var ik = Object.defineProperty;
var sk = (e, t, n) => t in e ? ik(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Gs = (e, t, n) => (sk(e, typeof t != "symbol" ? t + "" : t, n), n);
import * as De from "react";
import Pr, { Children as $f, isValidElement as tc, createContext as Uo, useContext as Zn, useRef as He, useEffect as ft, useCallback as te, useState as je, useId as Xo, useLayoutEffect as nc, useMemo as Et, useInsertionEffect as sy, forwardRef as nt, createElement as ly, cloneElement as Fa, memo as lk, useSyncExternalStore as uk, Fragment as F1, PureComponent as ck, Component as dk } from "react";
import { __unsafe_useEmotionCache as fk, Global as Zf, ThemeProvider as hk, ThemeContext as pk, keyframes as Q1, jsx as Ke, css as uy } from "@emotion/react";
import mk from "@emotion/styled";
import { createPortal as og } from "react-dom";
import { schAloftPriceJSON as Nn, AloftDate as Fr, AloftTime as fs, AloftArea as xt, AloftPrice as jt, AloftCount as gt, schAloftAreaJSON as ma, schAloftTimeJSON as gk } from "@aloft/shared-objects";
var ai = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function jf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var N5 = { exports: {} }, Hc = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var I6;
function vk() {
  if (I6)
    return Hc;
  I6 = 1;
  var e = Pr, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, d) {
    var f, h = {}, m = null, g = null;
    d !== void 0 && (m = "" + d), c.key !== void 0 && (m = "" + c.key), c.ref !== void 0 && (g = c.ref);
    for (f in c)
      r.call(c, f) && !a.hasOwnProperty(f) && (h[f] = c[f]);
    if (l && l.defaultProps)
      for (f in c = l.defaultProps, c)
        h[f] === void 0 && (h[f] = c[f]);
    return { $$typeof: t, type: l, key: m, ref: g, props: h, _owner: o.current };
  }
  return Hc.Fragment = n, Hc.jsx = s, Hc.jsxs = s, Hc;
}
var Gc = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var w6;
function Ck() {
  return w6 || (w6 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Pr, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), b = Symbol.iterator, C = "@@iterator";
    function y(B) {
      if (B === null || typeof B != "object")
        return null;
      var Ae = b && B[b] || B[C];
      return typeof Ae == "function" ? Ae : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(B) {
      {
        for (var Ae = arguments.length, ke = new Array(Ae > 1 ? Ae - 1 : 0), at = 1; at < Ae; at++)
          ke[at - 1] = arguments[at];
        I("error", B, ke);
      }
    }
    function I(B, Ae, ke) {
      {
        var at = _.ReactDebugCurrentFrame, St = at.getStackAddendum();
        St !== "" && (Ae += "%s", ke = ke.concat([St]));
        var Yt = ke.map(function(Dt) {
          return String(Dt);
        });
        Yt.unshift("Warning: " + Ae), Function.prototype.apply.call(console[B], console, Yt);
      }
    }
    var R = !1, E = !1, k = !1, N = !1, P = !1, F;
    F = Symbol.for("react.module.reference");
    function G(B) {
      return !!(typeof B == "string" || typeof B == "function" || B === r || B === a || P || B === o || B === d || B === f || N || B === g || R || E || k || typeof B == "object" && B !== null && (B.$$typeof === m || B.$$typeof === h || B.$$typeof === s || B.$$typeof === l || B.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      B.$$typeof === F || B.getModuleId !== void 0));
    }
    function j(B, Ae, ke) {
      var at = B.displayName;
      if (at)
        return at;
      var St = Ae.displayName || Ae.name || "";
      return St !== "" ? ke + "(" + St + ")" : ke;
    }
    function ae(B) {
      return B.displayName || "Context";
    }
    function ue(B) {
      if (B == null)
        return null;
      if (typeof B.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof B == "function")
        return B.displayName || B.name || null;
      if (typeof B == "string")
        return B;
      switch (B) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case d:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof B == "object")
        switch (B.$$typeof) {
          case l:
            var Ae = B;
            return ae(Ae) + ".Consumer";
          case s:
            var ke = B;
            return ae(ke._context) + ".Provider";
          case c:
            return j(B, B.render, "ForwardRef");
          case h:
            var at = B.displayName || null;
            return at !== null ? at : ue(B.type) || "Memo";
          case m: {
            var St = B, Yt = St._payload, Dt = St._init;
            try {
              return ue(Dt(Yt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var le = Object.assign, _e = 0, ve, z, K, Ce, q, J, ge;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function pe() {
      {
        if (_e === 0) {
          ve = console.log, z = console.info, K = console.warn, Ce = console.error, q = console.group, J = console.groupCollapsed, ge = console.groupEnd;
          var B = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: B,
            log: B,
            warn: B,
            error: B,
            group: B,
            groupCollapsed: B,
            groupEnd: B
          });
        }
        _e++;
      }
    }
    function fe() {
      {
        if (_e--, _e === 0) {
          var B = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: le({}, B, {
              value: ve
            }),
            info: le({}, B, {
              value: z
            }),
            warn: le({}, B, {
              value: K
            }),
            error: le({}, B, {
              value: Ce
            }),
            group: le({}, B, {
              value: q
            }),
            groupCollapsed: le({}, B, {
              value: J
            }),
            groupEnd: le({}, B, {
              value: ge
            })
          });
        }
        _e < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var de = _.ReactCurrentDispatcher, we;
    function Ie(B, Ae, ke) {
      {
        if (we === void 0)
          try {
            throw Error();
          } catch (St) {
            var at = St.stack.trim().match(/\n( *(at )?)/);
            we = at && at[1] || "";
          }
        return `
` + we + B;
      }
    }
    var Pe = !1, Se;
    {
      var Fe = typeof WeakMap == "function" ? WeakMap : Map;
      Se = new Fe();
    }
    function oe(B, Ae) {
      if (!B || Pe)
        return "";
      {
        var ke = Se.get(B);
        if (ke !== void 0)
          return ke;
      }
      var at;
      Pe = !0;
      var St = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Yt;
      Yt = de.current, de.current = null, pe();
      try {
        if (Ae) {
          var Dt = function() {
            throw Error();
          };
          if (Object.defineProperty(Dt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Dt, []);
            } catch (Xn) {
              at = Xn;
            }
            Reflect.construct(B, [], Dt);
          } else {
            try {
              Dt.call();
            } catch (Xn) {
              at = Xn;
            }
            B.call(Dt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Xn) {
            at = Xn;
          }
          B();
        }
      } catch (Xn) {
        if (Xn && at && typeof Xn.stack == "string") {
          for (var _t = Xn.stack.split(`
`), Qn = at.stack.split(`
`), yn = _t.length - 1, Mn = Qn.length - 1; yn >= 1 && Mn >= 0 && _t[yn] !== Qn[Mn]; )
            Mn--;
          for (; yn >= 1 && Mn >= 0; yn--, Mn--)
            if (_t[yn] !== Qn[Mn]) {
              if (yn !== 1 || Mn !== 1)
                do
                  if (yn--, Mn--, Mn < 0 || _t[yn] !== Qn[Mn]) {
                    var Hn = `
` + _t[yn].replace(" at new ", " at ");
                    return B.displayName && Hn.includes("<anonymous>") && (Hn = Hn.replace("<anonymous>", B.displayName)), typeof B == "function" && Se.set(B, Hn), Hn;
                  }
                while (yn >= 1 && Mn >= 0);
              break;
            }
        }
      } finally {
        Pe = !1, de.current = Yt, fe(), Error.prepareStackTrace = St;
      }
      var Sa = B ? B.displayName || B.name : "", dr = Sa ? Ie(Sa) : "";
      return typeof B == "function" && Se.set(B, dr), dr;
    }
    function pt(B, Ae, ke) {
      return oe(B, !1);
    }
    function Ee(B) {
      var Ae = B.prototype;
      return !!(Ae && Ae.isReactComponent);
    }
    function wt(B, Ae, ke) {
      if (B == null)
        return "";
      if (typeof B == "function")
        return oe(B, Ee(B));
      if (typeof B == "string")
        return Ie(B);
      switch (B) {
        case d:
          return Ie("Suspense");
        case f:
          return Ie("SuspenseList");
      }
      if (typeof B == "object")
        switch (B.$$typeof) {
          case c:
            return pt(B.render);
          case h:
            return wt(B.type, Ae, ke);
          case m: {
            var at = B, St = at._payload, Yt = at._init;
            try {
              return wt(Yt(St), Ae, ke);
            } catch {
            }
          }
        }
      return "";
    }
    var an = Object.prototype.hasOwnProperty, Ft = {}, Kn = _.ReactDebugCurrentFrame;
    function zn(B) {
      if (B) {
        var Ae = B._owner, ke = wt(B.type, B._source, Ae ? Ae.type : null);
        Kn.setExtraStackFrame(ke);
      } else
        Kn.setExtraStackFrame(null);
    }
    function Xt(B, Ae, ke, at, St) {
      {
        var Yt = Function.call.bind(an);
        for (var Dt in B)
          if (Yt(B, Dt)) {
            var _t = void 0;
            try {
              if (typeof B[Dt] != "function") {
                var Qn = Error((at || "React class") + ": " + ke + " type `" + Dt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof B[Dt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Qn.name = "Invariant Violation", Qn;
              }
              _t = B[Dt](Ae, Dt, at, ke, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (yn) {
              _t = yn;
            }
            _t && !(_t instanceof Error) && (zn(St), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", at || "React class", ke, Dt, typeof _t), zn(null)), _t instanceof Error && !(_t.message in Ft) && (Ft[_t.message] = !0, zn(St), x("Failed %s type: %s", ke, _t.message), zn(null));
          }
      }
    }
    var sn = Array.isArray;
    function Tn(B) {
      return sn(B);
    }
    function Pn(B) {
      {
        var Ae = typeof Symbol == "function" && Symbol.toStringTag, ke = Ae && B[Symbol.toStringTag] || B.constructor.name || "Object";
        return ke;
      }
    }
    function ro(B) {
      try {
        return vr(B), !1;
      } catch {
        return !0;
      }
    }
    function vr(B) {
      return "" + B;
    }
    function qo(B) {
      if (ro(B))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Pn(B)), vr(B);
    }
    var lr = _.ReactCurrentOwner, Le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Zt, wn, Un;
    Un = {};
    function Zr(B) {
      if (an.call(B, "ref")) {
        var Ae = Object.getOwnPropertyDescriptor(B, "ref").get;
        if (Ae && Ae.isReactWarning)
          return !1;
      }
      return B.ref !== void 0;
    }
    function Jo(B) {
      if (an.call(B, "key")) {
        var Ae = Object.getOwnPropertyDescriptor(B, "key").get;
        if (Ae && Ae.isReactWarning)
          return !1;
      }
      return B.key !== void 0;
    }
    function Is(B, Ae) {
      if (typeof B.ref == "string" && lr.current && Ae && lr.current.stateNode !== Ae) {
        var ke = ue(lr.current.type);
        Un[ke] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ue(lr.current.type), B.ref), Un[ke] = !0);
      }
    }
    function ws(B, Ae) {
      {
        var ke = function() {
          Zt || (Zt = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ae));
        };
        ke.isReactWarning = !0, Object.defineProperty(B, "key", {
          get: ke,
          configurable: !0
        });
      }
    }
    function oo(B, Ae) {
      {
        var ke = function() {
          wn || (wn = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ae));
        };
        ke.isReactWarning = !0, Object.defineProperty(B, "ref", {
          get: ke,
          configurable: !0
        });
      }
    }
    var ba = function(B, Ae, ke, at, St, Yt, Dt) {
      var _t = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: B,
        key: Ae,
        ref: ke,
        props: Dt,
        // Record the component responsible for creating this element.
        _owner: Yt
      };
      return _t._store = {}, Object.defineProperty(_t._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_t, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: at
      }), Object.defineProperty(_t, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: St
      }), Object.freeze && (Object.freeze(_t.props), Object.freeze(_t)), _t;
    };
    function fc(B, Ae, ke, at, St) {
      {
        var Yt, Dt = {}, _t = null, Qn = null;
        ke !== void 0 && (qo(ke), _t = "" + ke), Jo(Ae) && (qo(Ae.key), _t = "" + Ae.key), Zr(Ae) && (Qn = Ae.ref, Is(Ae, St));
        for (Yt in Ae)
          an.call(Ae, Yt) && !Le.hasOwnProperty(Yt) && (Dt[Yt] = Ae[Yt]);
        if (B && B.defaultProps) {
          var yn = B.defaultProps;
          for (Yt in yn)
            Dt[Yt] === void 0 && (Dt[Yt] = yn[Yt]);
        }
        if (_t || Qn) {
          var Mn = typeof B == "function" ? B.displayName || B.name || "Unknown" : B;
          _t && ws(Dt, Mn), Qn && oo(Dt, Mn);
        }
        return ba(B, _t, Qn, St, at, lr.current, Dt);
      }
    }
    var Ti = _.ReactCurrentOwner, Nl = _.ReactDebugCurrentFrame;
    function Ao(B) {
      if (B) {
        var Ae = B._owner, ke = wt(B.type, B._source, Ae ? Ae.type : null);
        Nl.setExtraStackFrame(ke);
      } else
        Nl.setExtraStackFrame(null);
    }
    var Mo;
    Mo = !1;
    function Ls(B) {
      return typeof B == "object" && B !== null && B.$$typeof === t;
    }
    function xo() {
      {
        if (Ti.current) {
          var B = ue(Ti.current.type);
          if (B)
            return `

Check the render method of \`` + B + "`.";
        }
        return "";
      }
    }
    function hc(B) {
      {
        if (B !== void 0) {
          var Ae = B.fileName.replace(/^.*[\\\/]/, ""), ke = B.lineNumber;
          return `

Check your code at ` + Ae + ":" + ke + ".";
        }
        return "";
      }
    }
    var Tl = {};
    function Pl(B) {
      {
        var Ae = xo();
        if (!Ae) {
          var ke = typeof B == "string" ? B : B.displayName || B.name;
          ke && (Ae = `

Check the top-level render call using <` + ke + ">.");
        }
        return Ae;
      }
    }
    function kl(B, Ae) {
      {
        if (!B._store || B._store.validated || B.key != null)
          return;
        B._store.validated = !0;
        var ke = Pl(Ae);
        if (Tl[ke])
          return;
        Tl[ke] = !0;
        var at = "";
        B && B._owner && B._owner !== Ti.current && (at = " It was passed a child from " + ue(B._owner.type) + "."), Ao(B), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ke, at), Ao(null);
      }
    }
    function Vl(B, Ae) {
      {
        if (typeof B != "object")
          return;
        if (Tn(B))
          for (var ke = 0; ke < B.length; ke++) {
            var at = B[ke];
            Ls(at) && kl(at, Ae);
          }
        else if (Ls(B))
          B._store && (B._store.validated = !0);
        else if (B) {
          var St = y(B);
          if (typeof St == "function" && St !== B.entries)
            for (var Yt = St.call(B), Dt; !(Dt = Yt.next()).done; )
              Ls(Dt.value) && kl(Dt.value, Ae);
        }
      }
    }
    function ao(B) {
      {
        var Ae = B.type;
        if (Ae == null || typeof Ae == "string")
          return;
        var ke;
        if (typeof Ae == "function")
          ke = Ae.propTypes;
        else if (typeof Ae == "object" && (Ae.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ae.$$typeof === h))
          ke = Ae.propTypes;
        else
          return;
        if (ke) {
          var at = ue(Ae);
          Xt(ke, B.props, "prop", at, B);
        } else if (Ae.PropTypes !== void 0 && !Mo) {
          Mo = !0;
          var St = ue(Ae);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", St || "Unknown");
        }
        typeof Ae.getDefaultProps == "function" && !Ae.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Rs(B) {
      {
        for (var Ae = Object.keys(B.props), ke = 0; ke < Ae.length; ke++) {
          var at = Ae[ke];
          if (at !== "children" && at !== "key") {
            Ao(B), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", at), Ao(null);
            break;
          }
        }
        B.ref !== null && (Ao(B), x("Invalid attribute `ref` supplied to `React.Fragment`."), Ao(null));
      }
    }
    var Ol = {};
    function Pi(B, Ae, ke, at, St, Yt) {
      {
        var Dt = G(B);
        if (!Dt) {
          var _t = "";
          (B === void 0 || typeof B == "object" && B !== null && Object.keys(B).length === 0) && (_t += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Qn = hc(St);
          Qn ? _t += Qn : _t += xo();
          var yn;
          B === null ? yn = "null" : Tn(B) ? yn = "array" : B !== void 0 && B.$$typeof === t ? (yn = "<" + (ue(B.type) || "Unknown") + " />", _t = " Did you accidentally export a JSX literal instead of a component?") : yn = typeof B, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", yn, _t);
        }
        var Mn = fc(B, Ae, ke, St, Yt);
        if (Mn == null)
          return Mn;
        if (Dt) {
          var Hn = Ae.children;
          if (Hn !== void 0)
            if (at)
              if (Tn(Hn)) {
                for (var Sa = 0; Sa < Hn.length; Sa++)
                  Vl(Hn[Sa], B);
                Object.freeze && Object.freeze(Hn);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Vl(Hn, B);
        }
        if (an.call(Ae, "key")) {
          var dr = ue(B), Xn = Object.keys(Ae).filter(function(Ds) {
            return Ds !== "key";
          }), Es = Xn.length > 0 ? "{key: someKey, " + Xn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ol[dr + Es]) {
            var ki = Xn.length > 0 ? "{" + Xn.join(": ..., ") + ": ...}" : "{}";
            x(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Es, dr, ki, dr), Ol[dr + Es] = !0;
          }
        }
        return B === r ? Rs(Mn) : ao(Mn), Mn;
      }
    }
    function pc(B, Ae, ke) {
      return Pi(B, Ae, ke, !0);
    }
    function mc(B, Ae, ke) {
      return Pi(B, Ae, ke, !1);
    }
    var ya = mc, gc = pc;
    Gc.Fragment = r, Gc.jsx = ya, Gc.jsxs = gc;
  }()), Gc;
}
process.env.NODE_ENV === "production" ? N5.exports = vk() : N5.exports = Ck();
var A = N5.exports;
function Wf(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
function bk() {
  return !!(globalThis != null && globalThis.document);
}
function cy(e) {
  return e.parentElement && cy(e.parentElement) ? !0 : e.hidden;
}
function yk(e) {
  const t = e.getAttribute("contenteditable");
  return t !== "false" && t != null;
}
function Sk(e) {
  return !!e.getAttribute("disabled") || !!e.getAttribute("aria-disabled");
}
function Ak(e) {
  var t;
  return ((t = dy(e)) == null ? void 0 : t.defaultView) ?? window;
}
function dy(e) {
  return Wf(e) ? e.ownerDocument : document;
}
function Mk(e) {
  return dy(e).activeElement;
}
function xk(e, ...t) {
  if (e == null)
    throw new TypeError("Cannot convert undefined or null to object");
  const n = { ...e };
  for (const r of t)
    if (r != null)
      for (const o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (o in n && delete n[o], n[o] = r[o]);
  return n;
}
const ot = (e) => e ? "" : void 0, di = (e) => e ? !0 : void 0;
function T5(e) {
  return Array.isArray(e);
}
function ar(e) {
  const t = typeof e;
  return e != null && (t === "object" || t === "function") && !T5(e);
}
function _k(e) {
  const t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function Ik(e) {
  const t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
  return { unitless: !n, value: t, unit: n };
}
function P5(e) {
  if (e == null)
    return e;
  const { unitless: t } = Ik(e);
  return t || typeof e == "number" ? `${e}px` : e;
}
const fy = (e, t) => parseInt(e[1], 10) > parseInt(t[1], 10) ? 1 : -1, ag = (e) => Object.fromEntries(Object.entries(e).sort(fy));
function L6(e) {
  const t = ag(e);
  return Object.assign(Object.values(t), t);
}
function wk(e) {
  const t = Object.keys(ag(e));
  return new Set(t);
}
function R6(e) {
  if (!e)
    return e;
  e = P5(e) ?? e;
  const t = -0.02;
  return typeof e == "number" ? `${e + t}` : e.replace(/(\d+\.?\d*)/u, (n) => `${parseFloat(n) + t}`);
}
function o1(e, t) {
  const n = ["@media screen"];
  return e && n.push("and", `(min-width: ${P5(e)})`), t && n.push("and", `(max-width: ${P5(t)})`), n.join(" ");
}
function Lk(e) {
  if (!e)
    return null;
  e.base = e.base ?? "0px";
  const t = L6(e), n = Object.entries(e).sort(fy).map(([a, s], l, c) => {
    let [, d] = c[l + 1] ?? [];
    return d = parseFloat(d) > 0 ? R6(d) : void 0, {
      _minW: R6(s),
      breakpoint: a,
      minW: s,
      maxW: d,
      maxWQuery: o1(null, d),
      minWQuery: o1(s),
      minMaxQuery: o1(s, d)
    };
  }), r = wk(e), o = Array.from(r.values());
  return {
    keys: r,
    normalized: t,
    isResponsive(a) {
      const s = Object.keys(a);
      return s.length > 0 && s.every((l) => r.has(l));
    },
    asObject: ag(e),
    asArray: L6(e),
    details: n,
    get(a) {
      return n.find((s) => s.breakpoint === a);
    },
    media: [
      null,
      ...t.map((a) => o1(a)).slice(1)
    ],
    /**
     * Converts the object responsive syntax to array syntax
     *
     * @example
     * toArrayValue({ base: 1, sm: 2, md: 3 }) // => [1, 2, 3]
     */
    toArrayValue(a) {
      if (!ar(a))
        throw new Error("toArrayValue: value must be an object");
      const s = o.map((l) => a[l] ?? null);
      for (; _k(s) === null; )
        s.pop();
      return s;
    },
    /**
     * Converts the array responsive syntax to object syntax
     *
     * @example
     * toObjectValue([1, 2, 3]) // => { base: 1, sm: 2, md: 3 }
     */
    toObjectValue(a) {
      if (!Array.isArray(a))
        throw new Error("toObjectValue: value must be an array");
      return a.reduce(
        (s, l, c) => {
          const d = o[c];
          return d != null && l != null && (s[d] = l), s;
        },
        {}
      );
    }
  };
}
function ig(...e) {
  return function(...n) {
    e.forEach((r) => r == null ? void 0 : r(...n));
  };
}
function lt(...e) {
  return function(n) {
    e.some((r) => (r == null || r(n), n == null ? void 0 : n.defaultPrevented));
  };
}
function hy(e) {
  return $f.toArray(e).filter(
    (t) => tc(t)
  );
}
function sg(e) {
  const t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function Rk(e, t) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${t}`;
}
function bn(e = {}) {
  const {
    name: t,
    strict: n = !0,
    hookName: r = "useContext",
    providerName: o = "Provider",
    errorMessage: a,
    defaultValue: s
  } = e, l = Uo(s);
  l.displayName = t;
  function c() {
    var f;
    const d = Zn(l);
    if (!d && n) {
      const h = new Error(
        a ?? Rk(r, o)
      );
      throw h.name = "ContextError", (f = Error.captureStackTrace) == null || f.call(Error, h, c), h;
    }
    return d;
  }
  return [l.Provider, c, l];
}
const Ye = (...e) => e.filter(Boolean).join(" "), py = (e) => e.hasAttribute("tabindex"), Ek = (e) => py(e) && e.tabIndex === -1;
function my(e) {
  if (!Wf(e) || cy(e) || Sk(e))
    return !1;
  const { localName: t } = e;
  if (["input", "select", "textarea", "button"].indexOf(t) >= 0)
    return !0;
  const r = {
    a: () => e.hasAttribute("href"),
    audio: () => e.hasAttribute("controls"),
    video: () => e.hasAttribute("controls")
  };
  return t in r ? r[t]() : yk(e) ? !0 : py(e);
}
function Dk(e) {
  return e ? Wf(e) && my(e) && !Ek(e) : !1;
}
const Nk = [
  "input:not(:disabled):not([disabled])",
  "select:not(:disabled):not([disabled])",
  "textarea:not(:disabled):not([disabled])",
  "embed",
  "iframe",
  "object",
  "a[href]",
  "area[href]",
  "button:not(:disabled):not([disabled])",
  "[tabindex]",
  "audio[controls]",
  "video[controls]",
  "*[tabindex]:not([aria-disabled])",
  "*[contenteditable]"
], Tk = Nk.join(), Pk = (e) => e.offsetWidth > 0 && e.offsetHeight > 0;
function kk(e) {
  const t = Array.from(
    e.querySelectorAll(Tk)
  );
  return t.unshift(e), t.filter((n) => my(n) && Pk(n));
}
function Vk(e, t, n, r) {
  const o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
const Ok = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, o, a, s) => {
    if (typeof r > "u")
      return e(r, o, a);
    t.has(r) || t.set(r, /* @__PURE__ */ new Map());
    const l = t.get(r);
    if (l.has(o))
      return l.get(o);
    const c = e(r, o, a, s);
    return l.set(o, c), c;
  };
}, gy = Ok(Vk), Fk = (e) => e.default || e;
function Bk(e) {
  const { wasSelected: t, enabled: n, isSelected: r, mode: o = "unmount" } = e;
  return !!(!n || r || o === "keepMounted" && t);
}
function Hk(e) {
  const t = parseFloat(e);
  return typeof t != "number" || Number.isNaN(t) ? 0 : t;
}
function vy(e, t) {
  let n = Hk(e);
  const r = 10 ** (t ?? 10);
  return n = Math.round(n * r) / r, t ? n.toFixed(t) : n.toString();
}
function E6(e) {
  if (!Number.isFinite(e))
    return 0;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n += 1;
  return n;
}
function Gk(e, t, n) {
  return e == null ? e : (n < t && console.warn("clamp: max cannot be less than min"), Math.min(Math.max(e, t), n));
}
function zf(e, t = []) {
  const n = Object.assign({}, e);
  for (const r of t)
    r in n && delete n[r];
  return n;
}
function Cy(e, t) {
  const n = {};
  for (const r of t)
    r in e && (n[r] = e[r]);
  return n;
}
function $k(e, t) {
  return Array.isArray(e) ? e.map((n) => n === null ? null : t(n)) : ar(e) ? Object.keys(e).reduce((n, r) => (n[r] = t(e[r]), n), {}) : e != null ? t(e) : null;
}
const Zk = (e) => typeof e == "function";
function da(e, ...t) {
  return Zk(e) ? e(...t) : e;
}
function jk(e) {
  const t = e.ownerDocument.defaultView || window, { overflow: n, overflowX: r, overflowY: o } = t.getComputedStyle(e);
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function Wk(e) {
  return e.localName === "html" ? e : e.assignedSlot || e.parentElement || e.ownerDocument.documentElement;
}
function by(e) {
  return ["html", "body", "#document"].includes(e.localName) ? e.ownerDocument.body : Wf(e) && jk(e) ? e : by(Wk(e));
}
function yy(e, t) {
  const n = {}, r = {};
  for (const [o, a] of Object.entries(e))
    t.includes(o) ? n[o] = a : r[o] = a;
  return [n, r];
}
function zk(e, ...t) {
  const n = Object.getOwnPropertyDescriptors(e), r = Object.keys(n), o = (s) => {
    const l = {};
    for (let c = 0; c < s.length; c++) {
      const d = s[c];
      n[d] && (Object.defineProperty(l, d, n[d]), delete n[d]);
    }
    return l;
  }, a = (s) => o(Array.isArray(s) ? s : r.filter(s));
  return t.map(a).concat(o(r));
}
function D6(e, t, n = {}) {
  const { stop: r, getKey: o } = n;
  function a(s, l = []) {
    if (ar(s) || Array.isArray(s)) {
      const c = {};
      for (const [d, f] of Object.entries(s)) {
        const h = (o == null ? void 0 : o(d)) ?? d, m = [...l, h];
        if (r != null && r(s, m))
          return t(s, l);
        c[h] = a(f, m);
      }
      return c;
    }
    return t(s, l);
  }
  return a(e);
}
const ed = (e) => {
  const { condition: t, message: n } = e;
  t && process.env.NODE_ENV !== "production" && console.warn(n);
};
var O2 = { exports: {} };
O2.exports;
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", o = 800, a = 16, s = 9007199254740991, l = "[object Arguments]", c = "[object Array]", d = "[object AsyncFunction]", f = "[object Boolean]", h = "[object Date]", m = "[object Error]", g = "[object Function]", b = "[object GeneratorFunction]", C = "[object Map]", y = "[object Number]", _ = "[object Null]", x = "[object Object]", I = "[object Proxy]", R = "[object RegExp]", E = "[object Set]", k = "[object String]", N = "[object Undefined]", P = "[object WeakMap]", F = "[object ArrayBuffer]", G = "[object DataView]", j = "[object Float32Array]", ae = "[object Float64Array]", ue = "[object Int8Array]", le = "[object Int16Array]", _e = "[object Int32Array]", ve = "[object Uint8Array]", z = "[object Uint8ClampedArray]", K = "[object Uint16Array]", Ce = "[object Uint32Array]", q = /[\\^$.*+?()[\]{}|]/g, J = /^\[object .+?Constructor\]$/, ge = /^(?:0|[1-9]\d*)$/, X = {};
  X[j] = X[ae] = X[ue] = X[le] = X[_e] = X[ve] = X[z] = X[K] = X[Ce] = !0, X[l] = X[c] = X[F] = X[f] = X[G] = X[h] = X[m] = X[g] = X[C] = X[y] = X[x] = X[R] = X[E] = X[k] = X[P] = !1;
  var pe = typeof ai == "object" && ai && ai.Object === Object && ai, fe = typeof self == "object" && self && self.Object === Object && self, de = pe || fe || Function("return this")(), we = t && !t.nodeType && t, Ie = we && !0 && e && !e.nodeType && e, Pe = Ie && Ie.exports === we, Se = Pe && pe.process, Fe = function() {
    try {
      var V = Ie && Ie.require && Ie.require("util").types;
      return V || Se && Se.binding && Se.binding("util");
    } catch {
    }
  }(), oe = Fe && Fe.isTypedArray;
  function pt(V, $, Q) {
    switch (Q.length) {
      case 0:
        return V.call($);
      case 1:
        return V.call($, Q[0]);
      case 2:
        return V.call($, Q[0], Q[1]);
      case 3:
        return V.call($, Q[0], Q[1], Q[2]);
    }
    return V.apply($, Q);
  }
  function Ee(V, $) {
    for (var Q = -1, Be = Array(V); ++Q < V; )
      Be[Q] = $(Q);
    return Be;
  }
  function wt(V) {
    return function($) {
      return V($);
    };
  }
  function an(V, $) {
    return V == null ? void 0 : V[$];
  }
  function Ft(V, $) {
    return function(Q) {
      return V($(Q));
    };
  }
  var Kn = Array.prototype, zn = Function.prototype, Xt = Object.prototype, sn = de["__core-js_shared__"], Tn = zn.toString, Pn = Xt.hasOwnProperty, ro = function() {
    var V = /[^.]+$/.exec(sn && sn.keys && sn.keys.IE_PROTO || "");
    return V ? "Symbol(src)_1." + V : "";
  }(), vr = Xt.toString, qo = Tn.call(Object), lr = RegExp(
    "^" + Tn.call(Pn).replace(q, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Le = Pe ? de.Buffer : void 0, Zt = de.Symbol, wn = de.Uint8Array, Un = Le ? Le.allocUnsafe : void 0, Zr = Ft(Object.getPrototypeOf, Object), Jo = Object.create, Is = Xt.propertyIsEnumerable, ws = Kn.splice, oo = Zt ? Zt.toStringTag : void 0, ba = function() {
    try {
      var V = Hl(Object, "defineProperty");
      return V({}, "", {}), V;
    } catch {
    }
  }(), fc = Le ? Le.isBuffer : void 0, Ti = Math.max, Nl = Date.now, Ao = Hl(de, "Map"), Mo = Hl(Object, "create"), Ls = function() {
    function V() {
    }
    return function($) {
      if (!Ko($))
        return {};
      if (Jo)
        return Jo($);
      V.prototype = $;
      var Q = new V();
      return V.prototype = void 0, Q;
    };
  }();
  function xo(V) {
    var $ = -1, Q = V == null ? 0 : V.length;
    for (this.clear(); ++$ < Q; ) {
      var Be = V[$];
      this.set(Be[0], Be[1]);
    }
  }
  function hc() {
    this.__data__ = Mo ? Mo(null) : {}, this.size = 0;
  }
  function Tl(V) {
    var $ = this.has(V) && delete this.__data__[V];
    return this.size -= $ ? 1 : 0, $;
  }
  function Pl(V) {
    var $ = this.__data__;
    if (Mo) {
      var Q = $[V];
      return Q === r ? void 0 : Q;
    }
    return Pn.call($, V) ? $[V] : void 0;
  }
  function kl(V) {
    var $ = this.__data__;
    return Mo ? $[V] !== void 0 : Pn.call($, V);
  }
  function Vl(V, $) {
    var Q = this.__data__;
    return this.size += this.has(V) ? 0 : 1, Q[V] = Mo && $ === void 0 ? r : $, this;
  }
  xo.prototype.clear = hc, xo.prototype.delete = Tl, xo.prototype.get = Pl, xo.prototype.has = kl, xo.prototype.set = Vl;
  function ao(V) {
    var $ = -1, Q = V == null ? 0 : V.length;
    for (this.clear(); ++$ < Q; ) {
      var Be = V[$];
      this.set(Be[0], Be[1]);
    }
  }
  function Rs() {
    this.__data__ = [], this.size = 0;
  }
  function Ol(V) {
    var $ = this.__data__, Q = dr($, V);
    if (Q < 0)
      return !1;
    var Be = $.length - 1;
    return Q == Be ? $.pop() : ws.call($, Q, 1), --this.size, !0;
  }
  function Pi(V) {
    var $ = this.__data__, Q = dr($, V);
    return Q < 0 ? void 0 : $[Q][1];
  }
  function pc(V) {
    return dr(this.__data__, V) > -1;
  }
  function mc(V, $) {
    var Q = this.__data__, Be = dr(Q, V);
    return Be < 0 ? (++this.size, Q.push([V, $])) : Q[Be][1] = $, this;
  }
  ao.prototype.clear = Rs, ao.prototype.delete = Ol, ao.prototype.get = Pi, ao.prototype.has = pc, ao.prototype.set = mc;
  function ya(V) {
    var $ = -1, Q = V == null ? 0 : V.length;
    for (this.clear(); ++$ < Q; ) {
      var Be = V[$];
      this.set(Be[0], Be[1]);
    }
  }
  function gc() {
    this.size = 0, this.__data__ = {
      hash: new xo(),
      map: new (Ao || ao)(),
      string: new xo()
    };
  }
  function B(V) {
    var $ = Bl(this, V).delete(V);
    return this.size -= $ ? 1 : 0, $;
  }
  function Ae(V) {
    return Bl(this, V).get(V);
  }
  function ke(V) {
    return Bl(this, V).has(V);
  }
  function at(V, $) {
    var Q = Bl(this, V), Be = Q.size;
    return Q.set(V, $), this.size += Q.size == Be ? 0 : 1, this;
  }
  ya.prototype.clear = gc, ya.prototype.delete = B, ya.prototype.get = Ae, ya.prototype.has = ke, ya.prototype.set = at;
  function St(V) {
    var $ = this.__data__ = new ao(V);
    this.size = $.size;
  }
  function Yt() {
    this.__data__ = new ao(), this.size = 0;
  }
  function Dt(V) {
    var $ = this.__data__, Q = $.delete(V);
    return this.size = $.size, Q;
  }
  function _t(V) {
    return this.__data__.get(V);
  }
  function Qn(V) {
    return this.__data__.has(V);
  }
  function yn(V, $) {
    var Q = this.__data__;
    if (Q instanceof ao) {
      var Be = Q.__data__;
      if (!Ao || Be.length < n - 1)
        return Be.push([V, $]), this.size = ++Q.size, this;
      Q = this.__data__ = new ya(Be);
    }
    return Q.set(V, $), this.size = Q.size, this;
  }
  St.prototype.clear = Yt, St.prototype.delete = Dt, St.prototype.get = _t, St.prototype.has = Qn, St.prototype.set = yn;
  function Mn(V, $) {
    var Q = Ac(V), Be = !Q && Sc(V), Nt = !Q && !Be && Zd(V), rn = !Q && !Be && !Nt && Wd(V), bt = Q || Be || Nt || rn, Lt = bt ? Ee(V.length, String) : [], Ut = Lt.length;
    for (var wr in V)
      ($ || Pn.call(V, wr)) && !(bt && // Safari 9 has enumerable `arguments.length` in strict mode.
      (wr == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      Nt && (wr == "offset" || wr == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      rn && (wr == "buffer" || wr == "byteLength" || wr == "byteOffset") || // Skip index properties.
      Vd(wr, Ut))) && Lt.push(wr);
    return Lt;
  }
  function Hn(V, $, Q) {
    (Q !== void 0 && !$l(V[$], Q) || Q === void 0 && !($ in V)) && Xn(V, $, Q);
  }
  function Sa(V, $, Q) {
    var Be = V[$];
    (!(Pn.call(V, $) && $l(Be, Q)) || Q === void 0 && !($ in V)) && Xn(V, $, Q);
  }
  function dr(V, $) {
    for (var Q = V.length; Q--; )
      if ($l(V[Q][0], $))
        return Q;
    return -1;
  }
  function Xn(V, $, Q) {
    $ == "__proto__" && ba ? ba(V, $, {
      configurable: !0,
      enumerable: !0,
      value: Q,
      writable: !0
    }) : V[$] = Q;
  }
  var Es = Pd();
  function ki(V) {
    return V == null ? V === void 0 ? N : _ : oo && oo in Object(V) ? kd(V) : Bd(V);
  }
  function Ds(V) {
    return Ns(V) && ki(V) == l;
  }
  function wd(V) {
    if (!Ko(V) || yc(V))
      return !1;
    var $ = Mc(V) ? lr : J;
    return $.test($d(V));
  }
  function Ld(V) {
    return Ns(V) && jd(V.length) && !!X[ki(V)];
  }
  function Xh(V) {
    if (!Ko(V))
      return Fd(V);
    var $ = ja(V), Q = [];
    for (var Be in V)
      Be == "constructor" && ($ || !Pn.call(V, Be)) || Q.push(Be);
    return Q;
  }
  function Rd(V, $, Q, Be, Nt) {
    V !== $ && Es($, function(rn, bt) {
      if (Nt || (Nt = new St()), Ko(rn))
        Yh(V, $, bt, Q, Rd, Be, Nt);
      else {
        var Lt = Be ? Be(Gl(V, bt), rn, bt + "", V, $, Nt) : void 0;
        Lt === void 0 && (Lt = rn), Hn(V, bt, Lt);
      }
    }, zd);
  }
  function Yh(V, $, Q, Be, Nt, rn, bt) {
    var Lt = Gl(V, Q), Ut = Gl($, Q), wr = bt.get(Ut);
    if (wr) {
      Hn(V, Q, wr);
      return;
    }
    var fr = rn ? rn(Lt, Ut, Q + "", V, $, bt) : void 0, ur = fr === void 0;
    if (ur) {
      var jl = Ac(Ut), Wl = !jl && Zd(Ut), xc = !jl && !Wl && Wd(Ut);
      fr = Ut, jl || Wl || xc ? Ac(Lt) ? fr = Lt : Qh(Lt) ? fr = Jh(Lt) : Wl ? (ur = !1, fr = Dd(Ut, !0)) : xc ? (ur = !1, fr = vc(Ut, !0)) : fr = [] : ep(Ut) || Sc(Ut) ? (fr = Lt, Sc(Lt) ? fr = tp(Lt) : (!Ko(Lt) || Mc(Lt)) && (fr = Cc(Ut))) : ur = !1;
    }
    ur && (bt.set(Ut, fr), Nt(fr, Ut, Be, rn, bt), bt.delete(Ut)), Hn(V, Q, fr);
  }
  function qh(V, $) {
    return Hd(Kh(V, $, Ud), V + "");
  }
  var Ed = ba ? function(V, $) {
    return ba(V, "toString", {
      configurable: !0,
      enumerable: !1,
      value: ln($),
      writable: !0
    });
  } : Ud;
  function Dd(V, $) {
    if ($)
      return V.slice();
    var Q = V.length, Be = Un ? Un(Q) : new V.constructor(Q);
    return V.copy(Be), Be;
  }
  function Nd(V) {
    var $ = new V.constructor(V.byteLength);
    return new wn($).set(new wn(V)), $;
  }
  function vc(V, $) {
    var Q = $ ? Nd(V.buffer) : V.buffer;
    return new V.constructor(Q, V.byteOffset, V.length);
  }
  function Jh(V, $) {
    var Q = -1, Be = V.length;
    for ($ || ($ = Array(Be)); ++Q < Be; )
      $[Q] = V[Q];
    return $;
  }
  function Td(V, $, Q, Be) {
    var Nt = !Q;
    Q || (Q = {});
    for (var rn = -1, bt = $.length; ++rn < bt; ) {
      var Lt = $[rn], Ut = Be ? Be(Q[Lt], V[Lt], Lt, Q, V) : void 0;
      Ut === void 0 && (Ut = V[Lt]), Nt ? Xn(Q, Lt, Ut) : Sa(Q, Lt, Ut);
    }
    return Q;
  }
  function Fl(V) {
    return qh(function($, Q) {
      var Be = -1, Nt = Q.length, rn = Nt > 1 ? Q[Nt - 1] : void 0, bt = Nt > 2 ? Q[2] : void 0;
      for (rn = V.length > 3 && typeof rn == "function" ? (Nt--, rn) : void 0, bt && Od(Q[0], Q[1], bt) && (rn = Nt < 3 ? void 0 : rn, Nt = 1), $ = Object($); ++Be < Nt; ) {
        var Lt = Q[Be];
        Lt && V($, Lt, Be, rn);
      }
      return $;
    });
  }
  function Pd(V) {
    return function($, Q, Be) {
      for (var Nt = -1, rn = Object($), bt = Be($), Lt = bt.length; Lt--; ) {
        var Ut = bt[V ? Lt : ++Nt];
        if (Q(rn[Ut], Ut, rn) === !1)
          break;
      }
      return $;
    };
  }
  function Bl(V, $) {
    var Q = V.__data__;
    return bc($) ? Q[typeof $ == "string" ? "string" : "hash"] : Q.map;
  }
  function Hl(V, $) {
    var Q = an(V, $);
    return wd(Q) ? Q : void 0;
  }
  function kd(V) {
    var $ = Pn.call(V, oo), Q = V[oo];
    try {
      V[oo] = void 0;
      var Be = !0;
    } catch {
    }
    var Nt = vr.call(V);
    return Be && ($ ? V[oo] = Q : delete V[oo]), Nt;
  }
  function Cc(V) {
    return typeof V.constructor == "function" && !ja(V) ? Ls(Zr(V)) : {};
  }
  function Vd(V, $) {
    var Q = typeof V;
    return $ = $ ?? s, !!$ && (Q == "number" || Q != "symbol" && ge.test(V)) && V > -1 && V % 1 == 0 && V < $;
  }
  function Od(V, $, Q) {
    if (!Ko(Q))
      return !1;
    var Be = typeof $;
    return (Be == "number" ? Zl(Q) && Vd($, Q.length) : Be == "string" && $ in Q) ? $l(Q[$], V) : !1;
  }
  function bc(V) {
    var $ = typeof V;
    return $ == "string" || $ == "number" || $ == "symbol" || $ == "boolean" ? V !== "__proto__" : V === null;
  }
  function yc(V) {
    return !!ro && ro in V;
  }
  function ja(V) {
    var $ = V && V.constructor, Q = typeof $ == "function" && $.prototype || Xt;
    return V === Q;
  }
  function Fd(V) {
    var $ = [];
    if (V != null)
      for (var Q in Object(V))
        $.push(Q);
    return $;
  }
  function Bd(V) {
    return vr.call(V);
  }
  function Kh(V, $, Q) {
    return $ = Ti($ === void 0 ? V.length - 1 : $, 0), function() {
      for (var Be = arguments, Nt = -1, rn = Ti(Be.length - $, 0), bt = Array(rn); ++Nt < rn; )
        bt[Nt] = Be[$ + Nt];
      Nt = -1;
      for (var Lt = Array($ + 1); ++Nt < $; )
        Lt[Nt] = Be[Nt];
      return Lt[$] = Q(bt), pt(V, this, Lt);
    };
  }
  function Gl(V, $) {
    if (!($ === "constructor" && typeof V[$] == "function") && $ != "__proto__")
      return V[$];
  }
  var Hd = Gd(Ed);
  function Gd(V) {
    var $ = 0, Q = 0;
    return function() {
      var Be = Nl(), Nt = a - (Be - Q);
      if (Q = Be, Nt > 0) {
        if (++$ >= o)
          return arguments[0];
      } else
        $ = 0;
      return V.apply(void 0, arguments);
    };
  }
  function $d(V) {
    if (V != null) {
      try {
        return Tn.call(V);
      } catch {
      }
      try {
        return V + "";
      } catch {
      }
    }
    return "";
  }
  function $l(V, $) {
    return V === $ || V !== V && $ !== $;
  }
  var Sc = Ds(function() {
    return arguments;
  }()) ? Ds : function(V) {
    return Ns(V) && Pn.call(V, "callee") && !Is.call(V, "callee");
  }, Ac = Array.isArray;
  function Zl(V) {
    return V != null && jd(V.length) && !Mc(V);
  }
  function Qh(V) {
    return Ns(V) && Zl(V);
  }
  var Zd = fc || np;
  function Mc(V) {
    if (!Ko(V))
      return !1;
    var $ = ki(V);
    return $ == g || $ == b || $ == d || $ == I;
  }
  function jd(V) {
    return typeof V == "number" && V > -1 && V % 1 == 0 && V <= s;
  }
  function Ko(V) {
    var $ = typeof V;
    return V != null && ($ == "object" || $ == "function");
  }
  function Ns(V) {
    return V != null && typeof V == "object";
  }
  function ep(V) {
    if (!Ns(V) || ki(V) != x)
      return !1;
    var $ = Zr(V);
    if ($ === null)
      return !0;
    var Q = Pn.call($, "constructor") && $.constructor;
    return typeof Q == "function" && Q instanceof Q && Tn.call(Q) == qo;
  }
  var Wd = oe ? wt(oe) : Ld;
  function tp(V) {
    return Td(V, zd(V));
  }
  function zd(V) {
    return Zl(V) ? Mn(V, !0) : Xh(V);
  }
  var cn = Fl(function(V, $, Q, Be) {
    Rd(V, $, Q, Be);
  });
  function ln(V) {
    return function() {
      return V;
    };
  }
  function Ud(V) {
    return V;
  }
  function np() {
    return !1;
  }
  e.exports = cn;
})(O2, O2.exports);
var Uk = O2.exports;
const Bo = /* @__PURE__ */ jf(Uk);
function or(e, t = []) {
  const n = He(e);
  return ft(() => {
    n.current = e;
  }), te((...r) => {
    var o;
    return (o = n.current) == null ? void 0 : o.call(n, ...r);
  }, t);
}
function v1(e, t, n, r) {
  const o = or(n);
  return ft(() => {
    const a = typeof e == "function" ? e() : e ?? document;
    if (!(!n || !a))
      return a.addEventListener(t, o, r), () => {
        a.removeEventListener(t, o, r);
      };
  }, [t, e, r, o, n]), () => {
    const a = typeof e == "function" ? e() : e ?? document;
    a == null || a.removeEventListener(t, o, r);
  };
}
function Xk(e) {
  const { isOpen: t, ref: n } = e, [r, o] = je(t), [a, s] = je(!1);
  return ft(() => {
    a || (o(t), s(!0));
  }, [t, a, r]), v1(
    () => n.current,
    "animationend",
    () => {
      o(t);
    }
  ), {
    present: !(t ? !1 : !r),
    onComplete() {
      var f;
      const c = Ak(n.current), d = new c.CustomEvent("animationend", { bubbles: !0 });
      (f = n.current) == null || f.dispatchEvent(d);
    }
  };
}
function Sy(e) {
  const {
    value: t,
    defaultValue: n,
    onChange: r,
    shouldUpdate: o = (m, g) => m !== g
  } = e, a = or(r), s = or(o), [l, c] = je(n), d = t !== void 0, f = d ? t : l, h = or(
    (m) => {
      const b = typeof m == "function" ? m(f) : m;
      s(f, b) && (d || c(b), a(b));
    },
    [d, a, f, s]
  );
  return [f, h];
}
function Yk(e = {}) {
  const {
    onChange: t,
    precision: n,
    defaultValue: r,
    value: o,
    step: a = 1,
    min: s = Number.MIN_SAFE_INTEGER,
    max: l = Number.MAX_SAFE_INTEGER,
    keepWithinRange: c = !0
  } = e, d = or(t), [f, h] = je(() => r == null ? "" : im(r, a, n) ?? ""), m = typeof o < "u", g = m ? o : f, b = Ay(qi(g), a), C = n ?? b, y = te(
    (G) => {
      G !== g && (m || h(G.toString()), d == null || d(G.toString(), qi(G)));
    },
    [d, m, g]
  ), _ = te(
    (G) => {
      let j = G;
      return c && (j = Gk(j, s, l)), vy(j, C);
    },
    [C, c, l, s]
  ), x = te(
    (G = a) => {
      let j;
      g === "" ? j = qi(G) : j = qi(g) + G, j = _(j), y(j);
    },
    [_, a, y, g]
  ), I = te(
    (G = a) => {
      let j;
      g === "" ? j = qi(-G) : j = qi(g) - G, j = _(j), y(j);
    },
    [_, a, y, g]
  ), R = te(() => {
    let G;
    r == null ? G = "" : G = im(r, a, n) ?? s, y(G);
  }, [r, n, a, y, s]), E = te(
    (G) => {
      const j = im(G, a, C) ?? s;
      y(j);
    },
    [C, a, y, s]
  ), k = qi(g);
  return {
    isOutOfRange: k > l || k < s,
    isAtMax: k === l,
    isAtMin: k === s,
    precision: C,
    value: g,
    valueAsNumber: k,
    update: y,
    reset: R,
    increment: x,
    decrement: I,
    clamp: _,
    cast: E,
    setValue: h
  };
}
function qi(e) {
  return parseFloat(e.toString().replace(/[^\w.-]+/g, ""));
}
function Ay(e, t) {
  return Math.max(E6(t), E6(e));
}
function im(e, t, n) {
  const r = qi(e);
  if (Number.isNaN(r))
    return;
  const o = Ay(r, t);
  return vy(r, n ?? o);
}
function My(e = {}) {
  const {
    onClose: t,
    onOpen: n,
    isOpen: r,
    id: o
  } = e, a = or(n), s = or(t), [l, c] = je(e.defaultIsOpen || !1), d = r !== void 0 ? r : l, f = r !== void 0, h = Xo(), m = o ?? `disclosure-${h}`, g = te(() => {
    f || c(!1), s == null || s();
  }, [f, s]), b = te(() => {
    f || c(!0), a == null || a();
  }, [f, a]), C = te(() => {
    d ? g() : b();
  }, [d, b, g]);
  function y(x = {}) {
    return {
      ...x,
      "aria-expanded": d,
      "aria-controls": m,
      onClick(I) {
        var R;
        (R = x.onClick) == null || R.call(x, I), C();
      }
    };
  }
  function _(x = {}) {
    return {
      ...x,
      hidden: !d,
      id: m
    };
  }
  return {
    isOpen: d,
    onOpen: b,
    onClose: g,
    onToggle: C,
    isControlled: f,
    getButtonProps: y,
    getDisclosureProps: _
  };
}
const ls = globalThis != null && globalThis.document ? nc : ft, ul = (e, t) => {
  const n = He(!1), r = He(!1);
  ft(() => {
    if (n.current && r.current)
      return e();
    r.current = !0;
  }, t), ft(() => (n.current = !0, () => {
    n.current = !1;
  }), []);
};
function qk(e) {
  const t = e.current;
  if (!t)
    return !1;
  const n = Mk(t);
  return !n || t.contains(n) ? !1 : !!Dk(n);
}
function Jk(e, t) {
  const { shouldFocus: n, visible: r, focusRef: o } = t, a = n && !r;
  ul(() => {
    if (!a || qk(e))
      return;
    const s = (o == null ? void 0 : o.current) || e.current;
    let l;
    if (s)
      return l = requestAnimationFrame(() => {
        s.focus({ preventScroll: !0 });
      }), () => {
        cancelAnimationFrame(l);
      };
  }, [a, e, o]);
}
function Kk(e, t) {
  const n = Xo();
  return Et(
    () => e || [t, n].filter(Boolean).join("-"),
    [e, t, n]
  );
}
function Qk(e, ...t) {
  const n = Kk(e);
  return Et(() => t.map((r) => `${r}-${n}`), [n, t]);
}
function eV(e, t) {
  const n = or(e);
  ft(() => {
    let r = null;
    const o = () => n();
    return t !== null && (r = window.setInterval(o, t)), () => {
      r && window.clearInterval(r);
    };
  }, [t, n]);
}
function tV(e, t) {
  if (e != null) {
    if (typeof e == "function") {
      e(t);
      return;
    }
    try {
      e.current = t;
    } catch {
      throw new Error(`Cannot assign value '${t}' to ref '${e}'`);
    }
  }
}
function ir(...e) {
  return (t) => {
    e.forEach((n) => {
      tV(n, t);
    });
  };
}
function nV(e) {
  const { ref: t, handler: n, enabled: r = !0 } = e, o = or(n), s = He({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }).current;
  ft(() => {
    if (!r)
      return;
    const l = (h) => {
      sm(h, t) && (s.isPointerDown = !0);
    }, c = (h) => {
      if (s.ignoreEmulatedMouseEvents) {
        s.ignoreEmulatedMouseEvents = !1;
        return;
      }
      s.isPointerDown && n && sm(h, t) && (s.isPointerDown = !1, o(h));
    }, d = (h) => {
      s.ignoreEmulatedMouseEvents = !0, n && s.isPointerDown && sm(h, t) && (s.isPointerDown = !1, o(h));
    }, f = xy(t.current);
    return f.addEventListener("mousedown", l, !0), f.addEventListener("mouseup", c, !0), f.addEventListener("touchstart", l, !0), f.addEventListener("touchend", d, !0), () => {
      f.removeEventListener("mousedown", l, !0), f.removeEventListener("mouseup", c, !0), f.removeEventListener("touchstart", l, !0), f.removeEventListener("touchend", d, !0);
    };
  }, [n, t, o, s, r]);
}
function sm(e, t) {
  var r, o;
  const n = ((r = e.composedPath) == null ? void 0 : r.call(e)[0]) ?? e.target;
  return n && !xy(n).contains(n) ? !1 : !((o = t.current) != null && o.contains(n));
}
function xy(e) {
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
function rV(e, t) {
  const n = or(e);
  ft(() => {
    if (t == null)
      return;
    let r = null;
    return r = window.setTimeout(() => {
      n();
    }, t), () => {
      r && window.clearTimeout(r);
    };
  }, [t, n]);
}
const nr = {
  open: (e, t) => `${e}[data-open], ${e}[open], ${e}[data-state=open] ${t}`,
  closed: (e, t) => `${e}[data-closed], ${e}[data-state=closed] ${t}`,
  hover: (e, t) => `${e}:hover ${t}, ${e}[data-hover] ${t}`,
  focus: (e, t) => `${e}:focus ${t}, ${e}[data-focus] ${t}`,
  focusVisible: (e, t) => `${e}:focus-visible ${t}`,
  focusWithin: (e, t) => `${e}:focus-within ${t}`,
  active: (e, t) => `${e}:active ${t}, ${e}[data-active] ${t}`,
  disabled: (e, t) => `${e}:disabled ${t}, ${e}[data-disabled] ${t}`,
  invalid: (e, t) => `${e}:invalid ${t}, ${e}[data-invalid] ${t}`,
  checked: (e, t) => `${e}:checked ${t}, ${e}[data-checked] ${t}`,
  indeterminate: (e, t) => `${e}:indeterminate ${t}, ${e}[aria-checked=mixed] ${t}, ${e}[data-indeterminate] ${t}`,
  readOnly: (e, t) => `${e}:read-only ${t}, ${e}[readonly] ${t}, ${e}[data-read-only] ${t}`,
  expanded: (e, t) => `${e}:read-only ${t}, ${e}[aria-expanded=true] ${t}, ${e}[data-expanded] ${t}`,
  placeholderShown: (e, t) => `${e}:placeholder-shown ${t}`
}, _a = (e) => _y((t) => e(t, "&"), "[role=group]", "[data-group]", ".group"), ei = (e) => _y((t) => e(t, "~ &"), "[data-peer]", ".peer"), _y = (e, ...t) => t.map(e).join(", "), Ru = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within, &[data-focus-within]",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty, &[data-empty]",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded], &[data-state=expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked], &[data-state=checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */
  _firstLetter: "&::first-letter",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate], &[data-state=indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is open
   */
  _groupOpen: _a(nr.open),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is closed
   */
  _groupClosed: _a(nr.closed),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: _a(nr.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: ei(nr.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: _a(nr.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: ei(nr.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: _a(nr.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: ei(nr.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: _a(nr.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: ei(nr.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: _a(nr.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: ei(nr.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: _a(nr.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: ei(nr.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: _a(nr.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: ei(nr.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: _a(nr.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: ei(nr.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: ei(nr.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder, &[data-placeholder]",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown, &[data-placeholder-shown]",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen, &[data-fullscreen]",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */
  _horizontal: "&[data-orientation=horizontal]",
  /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */
  _vertical: "&[data-orientation=vertical]",
  /**
   * Styles for the CSS Selector `&[data-open], &[open], &[data-state=open]`
   */
  _open: "&[data-open], &[open], &[data-state=open]",
  /**
   * Styles for the CSS Selector `&[data-closed], &[data-state=closed]`
   */
  _closed: "&[data-closed], &[data-state=closed]",
  /**
   * Styles for the CSS Selector `&[data-complete]`
   */
  _complete: "&[data-complete]",
  /**
   * Styles for the CSS Selector `&[data-incomplete]`
   */
  _incomplete: "&[data-incomplete]",
  /**
   * Styles for the CSS Selector `&[data-current]`
   */
  _current: "&[data-current]"
}, Iy = Object.keys(
  Ru
), oV = (e) => /!(important)?$/.test(e), N6 = (e) => typeof e == "string" ? e.replace(/!(important)?$/, "").trim() : e, aV = (e, t) => (n) => {
  const r = String(t), o = oV(r), a = N6(r), s = e ? `${e}.${a}` : a;
  let l = ar(n.__cssMap) && s in n.__cssMap ? n.__cssMap[s].varRef : t;
  return l = N6(l), o ? `${l} !important` : l;
};
function lg(e) {
  const { scale: t, transform: n, compose: r } = e;
  return (a, s) => {
    const l = aV(t, a)(s);
    let c = (n == null ? void 0 : n(l, s)) ?? l;
    return r && (c = r(c, s)), c;
  };
}
const T0 = (...e) => (t) => e.reduce((n, r) => r(n), t);
function No(e, t) {
  return (n) => {
    const r = { property: n, scale: e };
    return r.transform = lg({
      scale: e,
      transform: t
    }), r;
  };
}
const iV = ({ rtl: e, ltr: t }) => (n) => n.direction === "rtl" ? e : t;
function sV(e) {
  const { property: t, scale: n, transform: r } = e;
  return {
    scale: n,
    property: iV(t),
    transform: n ? lg({
      scale: n,
      compose: r
    }) : r
  };
}
const wy = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function lV() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...wy
  ].join(" ");
}
function uV() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...wy
  ].join(" ");
}
const cV = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
}, dV = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function fV(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: [
      "var(--chakra-ring-offset-shadow)",
      "var(--chakra-ring-shadow)",
      "var(--chakra-shadow, 0 0 #0000)"
    ].join(", ")
  };
}
const hV = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, k5 = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, pV = new Set(Object.values(k5)), V5 = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]), mV = (e) => e.trim();
function gV(e, t) {
  if (e == null || V5.has(e))
    return e;
  if (!(O5(e) || V5.has(e)))
    return `url('${e}')`;
  const o = /(^[a-z-A-Z]+)\((.*)\)/g.exec(e), a = o == null ? void 0 : o[1], s = o == null ? void 0 : o[2];
  if (!a || !s)
    return e;
  const l = a.includes("-gradient") ? a : `${a}-gradient`, [c, ...d] = s.split(",").map(mV).filter(Boolean);
  if ((d == null ? void 0 : d.length) === 0)
    return e;
  const f = c in k5 ? k5[c] : c;
  d.unshift(f);
  const h = d.map((m) => {
    if (pV.has(m))
      return m;
    const g = m.indexOf(" "), [b, C] = g !== -1 ? [m.substr(0, g), m.substr(g + 1)] : [m], y = O5(C) ? C : C && C.split(" "), _ = `colors.${b}`, x = _ in t.__cssMap ? t.__cssMap[_].varRef : b;
    return y ? [
      x,
      ...Array.isArray(y) ? y : [y]
    ].join(" ") : x;
  });
  return `${l}(${h.join(", ")})`;
}
const O5 = (e) => typeof e == "string" && e.includes("(") && e.includes(")"), vV = (e, t) => gV(e, t ?? {});
function CV(e) {
  return /^var\(--.+\)$/.test(e);
}
const bV = (e) => {
  const t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
  return { unitless: !n, value: t, unit: n };
}, Ia = (e) => (t) => `${e}(${t})`, Gt = {
  filter(e) {
    return e !== "auto" ? e : cV;
  },
  backdropFilter(e) {
    return e !== "auto" ? e : dV;
  },
  ring(e) {
    return fV(Gt.px(e));
  },
  bgClip(e) {
    return e === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: e };
  },
  transform(e) {
    return e === "auto" ? lV() : e === "auto-gpu" ? uV() : e;
  },
  vh(e) {
    return e === "$100vh" ? "var(--chakra-vh)" : e;
  },
  px(e) {
    if (e == null)
      return e;
    const { unitless: t } = bV(e);
    return t || typeof e == "number" ? `${e}px` : e;
  },
  fraction(e) {
    return typeof e != "number" || e > 1 ? e : `${e * 100}%`;
  },
  float(e, t) {
    const n = { left: "right", right: "left" };
    return t.direction === "rtl" ? n[e] : e;
  },
  degree(e) {
    if (CV(e) || e == null)
      return e;
    const t = typeof e == "string" && !e.endsWith("deg");
    return typeof e == "number" || t ? `${e}deg` : e;
  },
  gradient: vV,
  blur: Ia("blur"),
  opacity: Ia("opacity"),
  brightness: Ia("brightness"),
  contrast: Ia("contrast"),
  dropShadow: Ia("drop-shadow"),
  grayscale: Ia("grayscale"),
  hueRotate: (e) => Ia("hue-rotate")(Gt.degree(e)),
  invert: Ia("invert"),
  saturate: Ia("saturate"),
  sepia: Ia("sepia"),
  bgImage(e) {
    return e == null || O5(e) || V5.has(e) ? e : `url(${e})`;
  },
  outline(e) {
    const t = String(e) === "0" || String(e) === "none";
    return e !== null && t ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: e };
  },
  flexDirection(e) {
    const { space: t, divide: n } = hV[e] ?? {}, r = { flexDirection: e };
    return t && (r[t] = 1), n && (r[n] = 1), r;
  }
}, Z = {
  borderWidths: No("borderWidths"),
  borderStyles: No("borderStyles"),
  colors: No("colors"),
  borders: No("borders"),
  gradients: No("gradients", Gt.gradient),
  radii: No("radii", Gt.px),
  space: No("space", T0(Gt.vh, Gt.px)),
  spaceT: No("space", T0(Gt.vh, Gt.px)),
  degreeT(e) {
    return { property: e, transform: Gt.degree };
  },
  prop(e, t, n) {
    return {
      property: e,
      scale: t,
      ...t && {
        transform: lg({ scale: t, transform: n })
      }
    };
  },
  propT(e, t) {
    return { property: e, transform: t };
  },
  sizes: No("sizes", T0(Gt.vh, Gt.px)),
  sizesT: No("sizes", T0(Gt.vh, Gt.fraction)),
  shadows: No("shadows"),
  logical: sV,
  blur: No("blur", Gt.blur)
}, m2 = {
  background: Z.colors("background"),
  backgroundColor: Z.colors("backgroundColor"),
  backgroundImage: Z.gradients("backgroundImage"),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: { transform: Gt.bgClip },
  bgSize: Z.prop("backgroundSize"),
  bgPosition: Z.prop("backgroundPosition"),
  bg: Z.colors("background"),
  bgColor: Z.colors("backgroundColor"),
  bgPos: Z.prop("backgroundPosition"),
  bgRepeat: Z.prop("backgroundRepeat"),
  bgAttachment: Z.prop("backgroundAttachment"),
  bgGradient: Z.gradients("backgroundImage"),
  bgClip: { transform: Gt.bgClip }
};
Object.assign(m2, {
  bgImage: m2.backgroundImage,
  bgImg: m2.backgroundImage
});
const Jt = {
  border: Z.borders("border"),
  borderWidth: Z.borderWidths("borderWidth"),
  borderStyle: Z.borderStyles("borderStyle"),
  borderColor: Z.colors("borderColor"),
  borderRadius: Z.radii("borderRadius"),
  borderTop: Z.borders("borderTop"),
  borderBlockStart: Z.borders("borderBlockStart"),
  borderTopLeftRadius: Z.radii("borderTopLeftRadius"),
  borderStartStartRadius: Z.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: Z.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: Z.radii("borderTopRightRadius"),
  borderStartEndRadius: Z.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: Z.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: Z.borders("borderRight"),
  borderInlineEnd: Z.borders("borderInlineEnd"),
  borderBottom: Z.borders("borderBottom"),
  borderBlockEnd: Z.borders("borderBlockEnd"),
  borderBottomLeftRadius: Z.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: Z.radii("borderBottomRightRadius"),
  borderLeft: Z.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: Z.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: Z.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: Z.borders(["borderLeft", "borderRight"]),
  borderInline: Z.borders("borderInline"),
  borderY: Z.borders(["borderTop", "borderBottom"]),
  borderBlock: Z.borders("borderBlock"),
  borderTopWidth: Z.borderWidths("borderTopWidth"),
  borderBlockStartWidth: Z.borderWidths("borderBlockStartWidth"),
  borderTopColor: Z.colors("borderTopColor"),
  borderBlockStartColor: Z.colors("borderBlockStartColor"),
  borderTopStyle: Z.borderStyles("borderTopStyle"),
  borderBlockStartStyle: Z.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: Z.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: Z.borderWidths("borderBlockEndWidth"),
  borderBottomColor: Z.colors("borderBottomColor"),
  borderBlockEndColor: Z.colors("borderBlockEndColor"),
  borderBottomStyle: Z.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: Z.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: Z.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: Z.borderWidths("borderInlineStartWidth"),
  borderLeftColor: Z.colors("borderLeftColor"),
  borderInlineStartColor: Z.colors("borderInlineStartColor"),
  borderLeftStyle: Z.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: Z.borderStyles("borderInlineStartStyle"),
  borderRightWidth: Z.borderWidths("borderRightWidth"),
  borderInlineEndWidth: Z.borderWidths("borderInlineEndWidth"),
  borderRightColor: Z.colors("borderRightColor"),
  borderInlineEndColor: Z.colors("borderInlineEndColor"),
  borderRightStyle: Z.borderStyles("borderRightStyle"),
  borderInlineEndStyle: Z.borderStyles("borderInlineEndStyle"),
  borderTopRadius: Z.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: Z.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: Z.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: Z.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(Jt, {
  rounded: Jt.borderRadius,
  roundedTop: Jt.borderTopRadius,
  roundedTopLeft: Jt.borderTopLeftRadius,
  roundedTopRight: Jt.borderTopRightRadius,
  roundedTopStart: Jt.borderStartStartRadius,
  roundedTopEnd: Jt.borderStartEndRadius,
  roundedBottom: Jt.borderBottomRadius,
  roundedBottomLeft: Jt.borderBottomLeftRadius,
  roundedBottomRight: Jt.borderBottomRightRadius,
  roundedBottomStart: Jt.borderEndStartRadius,
  roundedBottomEnd: Jt.borderEndEndRadius,
  roundedLeft: Jt.borderLeftRadius,
  roundedRight: Jt.borderRightRadius,
  roundedStart: Jt.borderInlineStartRadius,
  roundedEnd: Jt.borderInlineEndRadius,
  borderStart: Jt.borderInlineStart,
  borderEnd: Jt.borderInlineEnd,
  borderTopStartRadius: Jt.borderStartStartRadius,
  borderTopEndRadius: Jt.borderStartEndRadius,
  borderBottomStartRadius: Jt.borderEndStartRadius,
  borderBottomEndRadius: Jt.borderEndEndRadius,
  borderStartRadius: Jt.borderInlineStartRadius,
  borderEndRadius: Jt.borderInlineEndRadius,
  borderStartWidth: Jt.borderInlineStartWidth,
  borderEndWidth: Jt.borderInlineEndWidth,
  borderStartColor: Jt.borderInlineStartColor,
  borderEndColor: Jt.borderInlineEndColor,
  borderStartStyle: Jt.borderInlineStartStyle,
  borderEndStyle: Jt.borderInlineEndStyle
});
const yV = {
  color: Z.colors("color"),
  textColor: Z.colors("color"),
  fill: Z.colors("fill"),
  stroke: Z.colors("stroke"),
  accentColor: Z.colors("accentColor"),
  textFillColor: Z.colors("textFillColor")
}, F2 = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: { transform: Gt.flexDirection },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: Z.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: Z.space("gap"),
  rowGap: Z.space("rowGap"),
  columnGap: Z.space("columnGap")
};
Object.assign(F2, {
  flexDir: F2.flexDirection
});
const Po = {
  width: Z.sizesT("width"),
  inlineSize: Z.sizesT("inlineSize"),
  height: Z.sizes("height"),
  blockSize: Z.sizes("blockSize"),
  boxSize: Z.sizes(["width", "height"]),
  minWidth: Z.sizes("minWidth"),
  minInlineSize: Z.sizes("minInlineSize"),
  minHeight: Z.sizes("minHeight"),
  minBlockSize: Z.sizes("minBlockSize"),
  maxWidth: Z.sizes("maxWidth"),
  maxInlineSize: Z.sizes("maxInlineSize"),
  maxHeight: Z.sizes("maxHeight"),
  maxBlockSize: Z.sizes("maxBlockSize"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  aspectRatio: !0,
  hideFrom: {
    scale: "breakpoints",
    transform: (e, t) => {
      var o, a;
      return { [`@media screen and (min-width: ${((a = (o = t.__breakpoints) == null ? void 0 : o.get(e)) == null ? void 0 : a.minW) ?? e})`]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (e, t) => {
      var o, a;
      return { [`@media screen and (max-width: ${((a = (o = t.__breakpoints) == null ? void 0 : o.get(e)) == null ? void 0 : a._minW) ?? e})`]: { display: "none" } };
    }
  },
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: Z.propT("float", Gt.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(Po, {
  w: Po.width,
  h: Po.height,
  minW: Po.minWidth,
  maxW: Po.maxWidth,
  minH: Po.minHeight,
  maxH: Po.maxHeight,
  overscroll: Po.overscrollBehavior,
  overscrollX: Po.overscrollBehaviorX,
  overscrollY: Po.overscrollBehaviorY
});
const SV = {
  filter: { transform: Gt.filter },
  blur: Z.blur("--chakra-blur"),
  brightness: Z.propT("--chakra-brightness", Gt.brightness),
  contrast: Z.propT("--chakra-contrast", Gt.contrast),
  hueRotate: Z.propT("--chakra-hue-rotate", Gt.hueRotate),
  invert: Z.propT("--chakra-invert", Gt.invert),
  saturate: Z.propT("--chakra-saturate", Gt.saturate),
  dropShadow: Z.propT("--chakra-drop-shadow", Gt.dropShadow),
  backdropFilter: { transform: Gt.backdropFilter },
  backdropBlur: Z.blur("--chakra-backdrop-blur"),
  backdropBrightness: Z.propT(
    "--chakra-backdrop-brightness",
    Gt.brightness
  ),
  backdropContrast: Z.propT("--chakra-backdrop-contrast", Gt.contrast),
  backdropHueRotate: Z.propT(
    "--chakra-backdrop-hue-rotate",
    Gt.hueRotate
  ),
  backdropInvert: Z.propT("--chakra-backdrop-invert", Gt.invert),
  backdropSaturate: Z.propT("--chakra-backdrop-saturate", Gt.saturate)
}, AV = {
  ring: { transform: Gt.ring },
  ringColor: Z.colors("--chakra-ring-color"),
  ringOffset: Z.prop("--chakra-ring-offset-width"),
  ringOffsetColor: Z.colors("--chakra-ring-offset-color"),
  ringInset: Z.prop("--chakra-ring-inset")
}, MV = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: { transform: Gt.outline },
  outlineOffset: !0,
  outlineColor: Z.colors("outlineColor")
}, Ly = {
  gridGap: Z.space("gridGap"),
  gridColumnGap: Z.space("gridColumnGap"),
  gridRowGap: Z.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
};
function xV(e, t, n, r) {
  const o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
const _V = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, o, a, s) => {
    if (typeof r > "u")
      return e(r, o, a);
    t.has(r) || t.set(r, /* @__PURE__ */ new Map());
    const l = t.get(r);
    if (l.has(o))
      return l.get(o);
    const c = e(r, o, a, s);
    return l.set(o, c), c;
  };
}, IV = _V(xV), wV = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, LV = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, lm = (e, t, n) => {
  const r = {}, o = IV(e, t, {});
  for (const a in o)
    a in n && n[a] != null || (r[a] = o[a]);
  return r;
}, RV = {
  srOnly: {
    transform(e) {
      return e === !0 ? wV : e === "focusable" ? LV : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: (e, t, n) => lm(t, `layerStyles.${e}`, n)
  },
  textStyle: {
    processResult: !0,
    transform: (e, t, n) => lm(t, `textStyles.${e}`, n)
  },
  apply: {
    processResult: !0,
    transform: (e, t, n) => lm(t, e, n)
  }
}, C1 = {
  position: !0,
  pos: Z.prop("position"),
  zIndex: Z.prop("zIndex", "zIndices"),
  inset: Z.spaceT("inset"),
  insetX: Z.spaceT(["left", "right"]),
  insetInline: Z.spaceT("insetInline"),
  insetY: Z.spaceT(["top", "bottom"]),
  insetBlock: Z.spaceT("insetBlock"),
  top: Z.spaceT("top"),
  insetBlockStart: Z.spaceT("insetBlockStart"),
  bottom: Z.spaceT("bottom"),
  insetBlockEnd: Z.spaceT("insetBlockEnd"),
  left: Z.spaceT("left"),
  insetInlineStart: Z.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: Z.spaceT("right"),
  insetInlineEnd: Z.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(C1, {
  insetStart: C1.insetInlineStart,
  insetEnd: C1.insetInlineEnd
});
const F5 = {
  boxShadow: Z.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: Z.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: Z.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(F5, {
  shadow: F5.boxShadow
});
const Sn = {
  margin: Z.spaceT("margin"),
  marginTop: Z.spaceT("marginTop"),
  marginBlockStart: Z.spaceT("marginBlockStart"),
  marginRight: Z.spaceT("marginRight"),
  marginInlineEnd: Z.spaceT("marginInlineEnd"),
  marginBottom: Z.spaceT("marginBottom"),
  marginBlockEnd: Z.spaceT("marginBlockEnd"),
  marginLeft: Z.spaceT("marginLeft"),
  marginInlineStart: Z.spaceT("marginInlineStart"),
  marginX: Z.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: Z.spaceT("marginInline"),
  marginY: Z.spaceT(["marginTop", "marginBottom"]),
  marginBlock: Z.spaceT("marginBlock"),
  padding: Z.space("padding"),
  paddingTop: Z.space("paddingTop"),
  paddingBlockStart: Z.space("paddingBlockStart"),
  paddingRight: Z.space("paddingRight"),
  paddingBottom: Z.space("paddingBottom"),
  paddingBlockEnd: Z.space("paddingBlockEnd"),
  paddingLeft: Z.space("paddingLeft"),
  paddingInlineStart: Z.space("paddingInlineStart"),
  paddingInlineEnd: Z.space("paddingInlineEnd"),
  paddingX: Z.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: Z.space("paddingInline"),
  paddingY: Z.space(["paddingTop", "paddingBottom"]),
  paddingBlock: Z.space("paddingBlock")
};
Object.assign(Sn, {
  m: Sn.margin,
  mt: Sn.marginTop,
  mr: Sn.marginRight,
  me: Sn.marginInlineEnd,
  marginEnd: Sn.marginInlineEnd,
  mb: Sn.marginBottom,
  ml: Sn.marginLeft,
  ms: Sn.marginInlineStart,
  marginStart: Sn.marginInlineStart,
  mx: Sn.marginX,
  my: Sn.marginY,
  p: Sn.padding,
  pt: Sn.paddingTop,
  py: Sn.paddingY,
  px: Sn.paddingX,
  pb: Sn.paddingBottom,
  pl: Sn.paddingLeft,
  ps: Sn.paddingInlineStart,
  paddingStart: Sn.paddingInlineStart,
  pr: Sn.paddingRight,
  pe: Sn.paddingInlineEnd,
  paddingEnd: Sn.paddingInlineEnd
});
const EV = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: Z.spaceT("scrollMargin"),
  scrollMarginTop: Z.spaceT("scrollMarginTop"),
  scrollMarginBottom: Z.spaceT("scrollMarginBottom"),
  scrollMarginLeft: Z.spaceT("scrollMarginLeft"),
  scrollMarginRight: Z.spaceT("scrollMarginRight"),
  scrollMarginX: Z.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: Z.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: Z.spaceT("scrollPadding"),
  scrollPaddingTop: Z.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: Z.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: Z.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: Z.spaceT("scrollPaddingRight"),
  scrollPaddingX: Z.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: Z.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
}, DV = {
  fontFamily: Z.prop("fontFamily", "fonts"),
  fontSize: Z.prop("fontSize", "fontSizes", Gt.px),
  fontWeight: Z.prop("fontWeight", "fontWeights"),
  lineHeight: Z.prop("lineHeight", "lineHeights"),
  letterSpacing: Z.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  textIndent: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  isTruncated: {
    transform(e) {
      if (e === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
}, NV = {
  textDecorationColor: Z.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: { property: "textDecoration" },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: Z.shadows("textShadow")
}, TV = {
  clipPath: !0,
  transform: Z.propT("transform", Gt.transform),
  transformOrigin: !0,
  translateX: Z.spaceT("--chakra-translate-x"),
  translateY: Z.spaceT("--chakra-translate-y"),
  skewX: Z.degreeT("--chakra-skew-x"),
  skewY: Z.degreeT("--chakra-skew-y"),
  scaleX: Z.prop("--chakra-scale-x"),
  scaleY: Z.prop("--chakra-scale-y"),
  scale: Z.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: Z.degreeT("--chakra-rotate")
}, PV = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: Z.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: Z.prop("listStyleImage")
}, kV = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: Z.prop("transitionDuration", "transition.duration"),
  transitionProperty: Z.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: Z.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
}, ug = Bo(
  {},
  m2,
  Jt,
  yV,
  F2,
  Po,
  SV,
  AV,
  MV,
  Ly,
  RV,
  C1,
  F5,
  Sn,
  EV,
  DV,
  NV,
  TV,
  PV,
  kV
), VV = Object.assign({}, Sn, Po, F2, Ly, C1), Ry = Object.keys(
  VV
), OV = [...Object.keys(ug), ...Iy], FV = { ...ug, ...Ru }, BV = (e) => e in FV, HV = (e) => (t) => {
  if (!t.__breakpoints)
    return e;
  const { isResponsive: n, toArrayValue: r, media: o } = t.__breakpoints, a = {};
  for (const s in e) {
    let l = da(e[s], t);
    if (l == null)
      continue;
    if (l = ar(l) && n(l) ? r(l) : l, !Array.isArray(l)) {
      a[s] = l;
      continue;
    }
    const c = l.slice(0, o.length).length;
    for (let d = 0; d < c; d += 1) {
      const f = o == null ? void 0 : o[d];
      if (!f) {
        a[s] = l[d];
        continue;
      }
      a[f] = a[f] || {}, l[d] != null && (a[f][s] = l[d]);
    }
  }
  return a;
};
function GV(e) {
  const t = [];
  let n = "", r = !1;
  for (let o = 0; o < e.length; o++) {
    const a = e[o];
    a === "(" ? (r = !0, n += a) : a === ")" ? (r = !1, n += a) : a === "," && !r ? (t.push(n), n = "") : n += a;
  }
  return n = n.trim(), n && t.push(n), t;
}
function $V(e) {
  return /^var\(--.+\)$/.test(e);
}
const ZV = (e, t) => e.startsWith("--") && typeof t == "string" && !$V(t), jV = (e, t) => {
  if (t == null)
    return t;
  const n = (s) => {
    var l, c;
    return (c = (l = e.__cssMap) == null ? void 0 : l[s]) == null ? void 0 : c.varRef;
  }, r = (s) => n(s) ?? s, [o, a] = GV(t);
  return t = n(o) ?? r(a) ?? r(t), t;
};
function WV(e) {
  const { configs: t = {}, pseudos: n = {}, theme: r } = e, o = (a, s = !1) => {
    var f;
    const l = da(a, r), c = HV(l)(r);
    let d = {};
    for (let h in c) {
      const m = c[h];
      let g = da(m, r);
      h in n && (h = n[h]), ZV(h, g) && (g = jV(r, g));
      let b = t[h];
      if (b === !0 && (b = { property: h }), ar(g)) {
        d[h] = d[h] ?? {}, d[h] = Bo(
          {},
          d[h],
          o(g, !0)
        );
        continue;
      }
      let C = ((f = b == null ? void 0 : b.transform) == null ? void 0 : f.call(b, g, r, l)) ?? g;
      C = b != null && b.processResult ? o(C, !0) : C;
      const y = da(b == null ? void 0 : b.property, r);
      if (!s && (b != null && b.static)) {
        const _ = da(b.static, r);
        d = Bo({}, d, _);
      }
      if (y && Array.isArray(y)) {
        for (const _ of y)
          d[_] = C;
        continue;
      }
      if (y) {
        y === "&" && ar(C) ? d = Bo({}, d, C) : d[y] = C;
        continue;
      }
      if (ar(C)) {
        d = Bo({}, d, C);
        continue;
      }
      d[h] = C;
    }
    return d;
  };
  return o;
}
const Ey = (e) => (t) => WV({
  theme: t,
  pseudos: Ru,
  configs: ug
})(e);
function un(e) {
  return {
    definePartsStyle(t) {
      return t;
    },
    defineMultiStyleConfig(t) {
      return { parts: e, ...t };
    }
  };
}
function zV(e, t, n) {
  var r, o;
  return ((o = (r = e.__cssMap) == null ? void 0 : r[`${t}.${n}`]) == null ? void 0 : o.varRef) ?? n;
}
function UV(e, t) {
  if (Array.isArray(e))
    return e;
  if (ar(e))
    return t(e);
  if (e != null)
    return [e];
}
function XV(e, t) {
  for (let n = t + 1; n < e.length; n++)
    if (e[n] != null)
      return n;
  return -1;
}
function YV(e) {
  const t = e.__breakpoints;
  return function(r, o, a, s) {
    var m, g;
    if (!t)
      return;
    const l = {}, c = UV(a, t.toArrayValue);
    if (!c)
      return l;
    const d = c.length, f = d === 1, h = !!r.parts;
    for (let b = 0; b < d; b++) {
      const C = t.details[b], y = t.details[XV(c, b)], _ = o1(C.minW, y == null ? void 0 : y._minW), x = da((m = r[o]) == null ? void 0 : m[c[b]], s);
      if (x) {
        if (h) {
          (g = r.parts) == null || g.forEach((I) => {
            Bo(l, {
              [I]: f ? x[I] : { [_]: x[I] }
            });
          });
          continue;
        }
        if (!h) {
          f ? Bo(l, x) : l[_] = x;
          continue;
        }
        l[_] = x;
      }
    }
    return l;
  };
}
function qV(e) {
  return (t) => {
    const { variant: n, size: r, theme: o } = t, a = YV(o);
    return Bo(
      {},
      da(e.baseStyle ?? {}, t),
      a(e, "sizes", r, t),
      a(e, "variants", n, t)
    );
  };
}
function Wn(e) {
  return zf(e, ["styleConfig", "size", "variant", "colorScheme"]);
}
function Dy(e) {
  return ar(e) && e.reference ? e.reference : String(e);
}
const Uf = (e, ...t) => t.map(Dy).join(` ${e} `).replace(/calc/g, ""), T6 = (...e) => `calc(${Uf("+", ...e)})`, P6 = (...e) => `calc(${Uf("-", ...e)})`, B5 = (...e) => `calc(${Uf("*", ...e)})`, k6 = (...e) => `calc(${Uf("/", ...e)})`, V6 = (e) => {
  const t = Dy(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : B5(t, -1);
}, ii = Object.assign(
  (e) => ({
    add: (...t) => ii(T6(e, ...t)),
    subtract: (...t) => ii(P6(e, ...t)),
    multiply: (...t) => ii(B5(e, ...t)),
    divide: (...t) => ii(k6(e, ...t)),
    negate: () => ii(V6(e)),
    toString: () => e.toString()
  }),
  {
    add: T6,
    subtract: P6,
    multiply: B5,
    divide: k6,
    negate: V6
  }
);
function JV(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function KV(e) {
  const t = JV(e.toString());
  return eO(QV(t));
}
function QV(e) {
  return e.includes("\\.") ? e : !Number.isInteger(parseFloat(e.toString())) ? e.replace(".", "\\.") : e;
}
function eO(e) {
  return e.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function tO(e, t = "") {
  return [t, e].filter(Boolean).join("-");
}
function nO(e, t) {
  return `var(${e}${t ? `, ${t}` : ""})`;
}
function rO(e, t = "") {
  return KV(`--${tO(e, t)}`);
}
function tt(e, t, n) {
  const r = rO(e, n);
  return {
    variable: r,
    reference: nO(r, t)
  };
}
function oO(e, t) {
  const n = {};
  for (const r of t) {
    if (Array.isArray(r)) {
      const [o, a] = r;
      n[o] = tt(`${e}-${o}`, a);
      continue;
    }
    n[r] = tt(`${e}-${r}`);
  }
  return n;
}
const aO = [
  "colors",
  "borders",
  "borderWidths",
  "borderStyles",
  "fonts",
  "fontSizes",
  "fontWeights",
  "gradients",
  "letterSpacings",
  "lineHeights",
  "radii",
  "space",
  "shadows",
  "sizes",
  "zIndices",
  "transition",
  "blur",
  "breakpoints"
];
function iO(e) {
  return Cy(e, aO);
}
function sO(e) {
  return e.semanticTokens;
}
function lO(e) {
  const { __cssMap: t, __cssVars: n, __breakpoints: r, ...o } = e;
  return o;
}
function uO(e) {
  const t = iO(e), n = sO(e), r = (a) => (
    // @ts-ignore
    Iy.includes(a) || a === "default"
  ), o = {};
  return D6(t, (a, s) => {
    a != null && (o[s.join(".")] = { isSemantic: !1, value: a });
  }), D6(
    n,
    (a, s) => {
      a != null && (o[s.join(".")] = { isSemantic: !0, value: a });
    },
    {
      stop: (a) => Object.keys(a).every(r)
    }
  ), o;
}
function O6(e, t) {
  return tt(String(e).replace(/\./g, "-"), void 0, t);
}
function cO(e) {
  var s;
  const t = uO(e), n = (s = e.config) == null ? void 0 : s.cssVarPrefix;
  let r = {};
  const o = {};
  function a(l, c) {
    const f = [String(l).split(".")[0], c].join(".");
    if (!t[f])
      return c;
    const { reference: m } = O6(f, n);
    return m;
  }
  for (const [l, c] of Object.entries(t)) {
    const { isSemantic: d, value: f } = c, { variable: h, reference: m } = O6(l, n);
    if (!d) {
      if (l.startsWith("space")) {
        const b = l.split("."), [C, ...y] = b, _ = `${C}.-${y.join(".")}`, x = ii.negate(f), I = ii.negate(m);
        o[_] = {
          value: x,
          var: h,
          varRef: I
        };
      }
      r[h] = f, o[l] = {
        value: f,
        var: h,
        varRef: m
      };
      continue;
    }
    const g = ar(f) ? f : { default: f };
    r = Bo(
      r,
      Object.entries(g).reduce(
        (b, [C, y]) => {
          if (!y)
            return b;
          const _ = a(l, `${y}`);
          if (C === "default")
            return b[h] = _, b;
          const x = (Ru == null ? void 0 : Ru[C]) ?? C;
          return b[x] = { [h]: _ }, b;
        },
        {}
      )
    ), o[l] = {
      value: m,
      var: h,
      varRef: m
    };
  }
  return {
    cssVars: r,
    cssMap: o
  };
}
function dO(e) {
  const t = lO(e), {
    /**
     * This is more like a dictionary of tokens users will type `green.500`,
     * and their equivalent css variable.
     */
    cssMap: n,
    /**
     * The extracted css variables will be stored here, and used in
     * the emotion's <Global/> component to attach variables to `:root`
     */
    cssVars: r
  } = cO(t);
  return Object.assign(t, {
    __cssVars: { ...{
      "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
      "--chakra-ring-offset-width": "0px",
      "--chakra-ring-offset-color": "#fff",
      "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
      "--chakra-ring-offset-shadow": "0 0 #0000",
      "--chakra-ring-shadow": "0 0 #0000",
      "--chakra-space-x-reverse": "0",
      "--chakra-space-y-reverse": "0"
    }, ...r },
    __cssMap: n,
    __breakpoints: Lk(t.breakpoints)
  }), t;
}
function Qt(e, t = {}) {
  let n = !1;
  function r() {
    if (!n) {
      n = !0;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function o(...f) {
    r();
    for (const h of f)
      t[h] = c(h);
    return Qt(e, t);
  }
  function a(...f) {
    for (const h of f)
      h in t || (t[h] = c(h));
    return Qt(e, t);
  }
  function s() {
    return Object.fromEntries(
      Object.entries(t).map(([h, m]) => [h, m.selector])
    );
  }
  function l() {
    return Object.fromEntries(
      Object.entries(t).map(([h, m]) => [h, m.className])
    );
  }
  function c(f) {
    const g = `chakra-${(["container", "root"].includes(f ?? "") ? [e] : [e, f]).filter(Boolean).join("__")}`;
    return {
      className: g,
      selector: `.${g}`,
      toString: () => f
    };
  }
  return {
    parts: o,
    toPart: c,
    extend: a,
    selectors: s,
    classnames: l,
    get keys() {
      return Object.keys(t);
    },
    __type: {}
  };
}
const fO = Qt("accordion").parts(
  "root",
  "container",
  "button",
  "panel",
  "icon"
), hO = Qt("alert").parts(
  "title",
  "description",
  "container",
  "icon",
  "spinner"
), pO = Qt("avatar").parts(
  "label",
  "badge",
  "container",
  "excessLabel",
  "group"
), mO = Qt("breadcrumb").parts(
  "link",
  "item",
  "container",
  "separator"
);
Qt("button").parts();
const gO = Qt("checkbox").parts(
  "control",
  "icon",
  "container",
  "label"
);
Qt("progress").parts(
  "track",
  "filledTrack",
  "label"
);
const vO = Qt("drawer").parts(
  "overlay",
  "dialogContainer",
  "dialog",
  "header",
  "closeButton",
  "body",
  "footer"
), CO = Qt("editable").parts(
  "preview",
  "input",
  "textarea"
), bO = Qt("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
), yO = Qt("formError").parts("text", "icon"), SO = Qt("input").parts(
  "addon",
  "field",
  "element",
  "group"
), AO = Qt("list").parts("container", "item", "icon"), MO = Qt("menu").parts(
  "button",
  "list",
  "item",
  "groupTitle",
  "icon",
  "command",
  "divider"
), xO = Qt("modal").parts(
  "overlay",
  "dialogContainer",
  "dialog",
  "header",
  "closeButton",
  "body",
  "footer"
), _O = Qt("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
Qt("pininput").parts("field");
const Ny = Qt("popover").parts(
  "content",
  "header",
  "body",
  "footer",
  "popper",
  "arrow",
  "closeButton"
), IO = Qt("progress").parts(
  "label",
  "filledTrack",
  "track"
), wO = Qt("radio").parts(
  "container",
  "control",
  "label"
), LO = Qt("select").parts("field", "icon"), RO = Qt("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
), EO = Qt("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
), DO = Qt("switch").parts(
  "container",
  "track",
  "thumb",
  "label"
), NO = Qt("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
), TO = Qt("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
), PO = Qt("tag").parts(
  "container",
  "label",
  "closeButton"
), kO = Qt("card").parts(
  "container",
  "header",
  "body",
  "footer"
);
Qt("stepper").parts(
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
);
const { definePartsStyle: VO, defineMultiStyleConfig: OO } = un(fO.keys), FO = {
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
}, BO = {
  transitionProperty: "common",
  transitionDuration: "normal",
  fontSize: "md",
  _focusVisible: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "blackAlpha.50"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: "4",
  py: "2"
}, HO = {
  pt: "2",
  px: "4",
  pb: "5"
}, GO = {
  fontSize: "1.25em"
}, $O = VO({
  container: FO,
  button: BO,
  panel: HO,
  icon: GO
}), ZO = OO({ baseStyle: $O });
function Ks(e, t, n) {
  return Math.min(Math.max(e, n), t);
}
class jO extends Error {
  constructor(t) {
    super(`Failed to parse color: "${t}"`);
  }
}
var a1 = jO;
function cg(e) {
  if (typeof e != "string")
    throw new a1(e);
  if (e.trim().toLowerCase() === "transparent")
    return [0, 0, 0, 0];
  let t = e.trim();
  t = KO.test(e) ? UO(e) : e;
  const n = XO.exec(t);
  if (n) {
    const s = Array.from(n).slice(1);
    return [...s.slice(0, 3).map((l) => parseInt(B1(l, 2), 16)), parseInt(B1(s[3] || "f", 2), 16) / 255];
  }
  const r = YO.exec(t);
  if (r) {
    const s = Array.from(r).slice(1);
    return [...s.slice(0, 3).map((l) => parseInt(l, 16)), parseInt(s[3] || "ff", 16) / 255];
  }
  const o = qO.exec(t);
  if (o) {
    const s = Array.from(o).slice(1);
    return [...s.slice(0, 3).map((l) => parseInt(l, 10)), parseFloat(s[3] || "1")];
  }
  const a = JO.exec(t);
  if (a) {
    const [s, l, c, d] = Array.from(a).slice(1).map(parseFloat);
    if (Ks(0, 100, l) !== l)
      throw new a1(e);
    if (Ks(0, 100, c) !== c)
      throw new a1(e);
    return [...QO(s, l, c), Number.isNaN(d) ? 1 : d];
  }
  throw new a1(e);
}
function WO(e) {
  let t = 5381, n = e.length;
  for (; n; )
    t = t * 33 ^ e.charCodeAt(--n);
  return (t >>> 0) % 2341;
}
const F6 = (e) => parseInt(e.replace(/_/g, ""), 36), zO = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((e, t) => {
  const n = F6(t.substring(0, 3)), r = F6(t.substring(3)).toString(16);
  let o = "";
  for (let a = 0; a < 6 - r.length; a++)
    o += "0";
  return e[n] = `${o}${r}`, e;
}, {});
function UO(e) {
  const t = e.toLowerCase().trim(), n = zO[WO(t)];
  if (!n)
    throw new a1(e);
  return `#${n}`;
}
const B1 = (e, t) => Array.from(Array(t)).map(() => e).join(""), XO = new RegExp(`^#${B1("([a-f0-9])", 3)}([a-f0-9])?$`, "i"), YO = new RegExp(`^#${B1("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i"), qO = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${B1(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i"), JO = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i, KO = /^[a-z]+$/i, B6 = (e) => Math.round(e * 255), QO = (e, t, n) => {
  let r = n / 100;
  if (t === 0)
    return [r, r, r].map(B6);
  const o = (e % 360 + 360) % 360 / 60, a = (1 - Math.abs(2 * r - 1)) * (t / 100), s = a * (1 - Math.abs(o % 2 - 1));
  let l = 0, c = 0, d = 0;
  o >= 0 && o < 1 ? (l = a, c = s) : o >= 1 && o < 2 ? (l = s, c = a) : o >= 2 && o < 3 ? (c = a, d = s) : o >= 3 && o < 4 ? (c = s, d = a) : o >= 4 && o < 5 ? (l = s, d = a) : o >= 5 && o < 6 && (l = a, d = s);
  const f = r - a / 2, h = l + f, m = c + f, g = d + f;
  return [h, m, g].map(B6);
};
function eF(e, t, n, r) {
  return `rgba(${Ks(0, 255, e).toFixed()}, ${Ks(0, 255, t).toFixed()}, ${Ks(0, 255, n).toFixed()}, ${parseFloat(Ks(0, 1, r).toFixed(3))})`;
}
function tF(e, t) {
  const [n, r, o, a] = cg(e);
  return eF(n, r, o, a - t);
}
function nF(e) {
  const [t, n, r, o] = cg(e);
  let a = (s) => {
    const l = Ks(0, 255, s).toString(16);
    return l.length === 1 ? `0${l}` : l;
  };
  return `#${a(t)}${a(n)}${a(r)}${o < 1 ? a(Math.round(o * 255)) : ""}`;
}
const rF = (e) => Object.keys(e).length === 0;
function oF(e, t, n, r, o) {
  for (t = t.split ? t.split(".") : t, r = 0; r < t.length; r++)
    e = e ? e[t[r]] : o;
  return e === o ? n : e;
}
const Vr = (e, t, n) => {
  const r = oF(e, `colors.${t}`, t);
  try {
    return nF(r), r;
  } catch {
    return n ?? "#000000";
  }
}, aF = (e) => {
  const [t, n, r] = cg(e);
  return (t * 299 + n * 587 + r * 114) / 1e3;
}, iF = (e) => (t) => {
  const n = Vr(t, e);
  return aF(n) < 128 ? "dark" : "light";
}, sF = (e) => (t) => iF(e)(t) === "dark", Fu = (e, t) => (n) => {
  const r = Vr(n, e);
  return tF(r, 1 - t);
};
function H6(e = "1rem", t = "rgba(255, 255, 255, 0.15)") {
  return {
    backgroundImage: `linear-gradient(
    45deg,
    ${t} 25%,
    transparent 25%,
    transparent 50%,
    ${t} 50%,
    ${t} 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: `${e} ${e}`
  };
}
const lF = () => `#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function uF(e) {
  const t = lF();
  return !e || rF(e) ? t : e.string && e.colors ? dF(e.string, e.colors) : e.string && !e.colors ? cF(e.string) : e.colors && !e.string ? fF(e.colors) : t;
}
function cF(e) {
  let t = 0;
  if (e.length === 0)
    return t.toString();
  for (let r = 0; r < e.length; r += 1)
    t = e.charCodeAt(r) + ((t << 5) - t), t = t & t;
  let n = "#";
  for (let r = 0; r < 3; r += 1) {
    const o = t >> r * 8 & 255;
    n += `00${o.toString(16)}`.substr(-2);
  }
  return n;
}
function dF(e, t) {
  let n = 0;
  if (e.length === 0)
    return t[0];
  for (let r = 0; r < e.length; r += 1)
    n = e.charCodeAt(r) + ((n << 5) - n), n = n & n;
  return n = (n % t.length + t.length) % t.length, t[n];
}
function fF(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function Qe(e, t) {
  return (n) => n.colorMode === "dark" ? t : e;
}
function dg(e) {
  const { orientation: t, vertical: n, horizontal: r } = e;
  return t ? t === "vertical" ? n : r : {};
}
function Ty(e) {
  return ar(e) && e.reference ? e.reference : String(e);
}
const Xf = (e, ...t) => t.map(Ty).join(` ${e} `).replace(/calc/g, ""), G6 = (...e) => `calc(${Xf("+", ...e)})`, $6 = (...e) => `calc(${Xf("-", ...e)})`, H5 = (...e) => `calc(${Xf("*", ...e)})`, Z6 = (...e) => `calc(${Xf("/", ...e)})`, j6 = (e) => {
  const t = Ty(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : H5(t, -1);
}, si = Object.assign(
  (e) => ({
    add: (...t) => si(G6(e, ...t)),
    subtract: (...t) => si($6(e, ...t)),
    multiply: (...t) => si(H5(e, ...t)),
    divide: (...t) => si(Z6(e, ...t)),
    negate: () => si(j6(e)),
    toString: () => e.toString()
  }),
  {
    add: G6,
    subtract: $6,
    multiply: H5,
    divide: Z6,
    negate: j6
  }
);
function hF(e) {
  return !Number.isInteger(parseFloat(e.toString()));
}
function pF(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function Py(e) {
  const t = pF(e.toString());
  return t.includes("\\.") ? e : hF(e) ? t.replace(".", "\\.") : e;
}
function mF(e, t = "") {
  return [t, Py(e)].filter(Boolean).join("-");
}
function gF(e, t) {
  return `var(${Py(e)}${t ? `, ${t}` : ""})`;
}
function vF(e, t = "") {
  return `--${mF(e, t)}`;
}
function sr(e, t) {
  const n = vF(e, t == null ? void 0 : t.prefix);
  return {
    variable: n,
    reference: gF(n, CF(t == null ? void 0 : t.fallback))
  };
}
function CF(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.reference;
}
const { definePartsStyle: td, defineMultiStyleConfig: bF } = un(hO.keys), Co = tt("alert-fg"), bi = tt("alert-bg"), yF = td({
  container: {
    bg: bi.reference,
    px: "4",
    py: "3"
  },
  title: {
    fontWeight: "bold",
    lineHeight: "6",
    marginEnd: "2"
  },
  description: {
    lineHeight: "6"
  },
  icon: {
    color: Co.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "6"
  },
  spinner: {
    color: Co.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "5"
  }
});
function fg(e) {
  const { theme: t, colorScheme: n } = e, r = Fu(`${n}.200`, 0.16)(t);
  return {
    light: `colors.${n}.100`,
    dark: r
  };
}
const SF = td((e) => {
  const { colorScheme: t } = e, n = fg(e);
  return {
    container: {
      [Co.variable]: `colors.${t}.600`,
      [bi.variable]: n.light,
      _dark: {
        [Co.variable]: `colors.${t}.200`,
        [bi.variable]: n.dark
      }
    }
  };
}), AF = td((e) => {
  const { colorScheme: t } = e, n = fg(e);
  return {
    container: {
      [Co.variable]: `colors.${t}.600`,
      [bi.variable]: n.light,
      _dark: {
        [Co.variable]: `colors.${t}.200`,
        [bi.variable]: n.dark
      },
      paddingStart: "3",
      borderStartWidth: "4px",
      borderStartColor: Co.reference
    }
  };
}), MF = td((e) => {
  const { colorScheme: t } = e, n = fg(e);
  return {
    container: {
      [Co.variable]: `colors.${t}.600`,
      [bi.variable]: n.light,
      _dark: {
        [Co.variable]: `colors.${t}.200`,
        [bi.variable]: n.dark
      },
      pt: "2",
      borderTopWidth: "4px",
      borderTopColor: Co.reference
    }
  };
}), xF = td((e) => {
  const { colorScheme: t } = e;
  return {
    container: {
      [Co.variable]: "colors.white",
      [bi.variable]: `colors.${t}.600`,
      _dark: {
        [Co.variable]: "colors.gray.900",
        [bi.variable]: `colors.${t}.200`
      },
      color: Co.reference
    }
  };
}), _F = {
  subtle: SF,
  "left-accent": AF,
  "top-accent": MF,
  solid: xF
}, IF = bF({
  baseStyle: yF,
  variants: _F,
  defaultProps: {
    variant: "subtle",
    colorScheme: "blue"
  }
}), ky = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
}, wF = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem",
  prose: "60ch"
}, LF = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, Vy = {
  ...ky,
  ...wF,
  container: LF
}, RF = (e) => typeof e == "function";
function Br(e, ...t) {
  return RF(e) ? e(...t) : e;
}
const { definePartsStyle: Oy, defineMultiStyleConfig: EF } = un(pO.keys), Eu = tt("avatar-border-color"), b1 = tt("avatar-bg"), H1 = tt("avatar-font-size"), Bu = tt("avatar-size"), DF = {
  borderRadius: "full",
  border: "0.2em solid",
  borderColor: Eu.reference,
  [Eu.variable]: "white",
  _dark: {
    [Eu.variable]: "colors.gray.800"
  }
}, NF = {
  bg: b1.reference,
  fontSize: H1.reference,
  width: Bu.reference,
  height: Bu.reference,
  lineHeight: "1",
  [b1.variable]: "colors.gray.200",
  _dark: {
    [b1.variable]: "colors.whiteAlpha.400"
  }
}, TF = (e) => {
  const { name: t, theme: n } = e, r = t ? uF({ string: t }) : "colors.gray.400", o = sF(r)(n);
  let a = "white";
  return o || (a = "gray.800"), {
    bg: b1.reference,
    fontSize: H1.reference,
    color: a,
    borderColor: Eu.reference,
    verticalAlign: "top",
    width: Bu.reference,
    height: Bu.reference,
    "&:not([data-loaded])": {
      [b1.variable]: r
    },
    [Eu.variable]: "colors.white",
    _dark: {
      [Eu.variable]: "colors.gray.800"
    }
  };
}, PF = {
  fontSize: H1.reference,
  lineHeight: "1"
}, kF = Oy((e) => ({
  badge: Br(DF, e),
  excessLabel: Br(NF, e),
  container: Br(TF, e),
  label: PF
}));
function Wi(e) {
  const t = e !== "100%" ? Vy[e] : void 0;
  return Oy({
    container: {
      [Bu.variable]: t ?? e,
      [H1.variable]: `calc(${t ?? e} / 2.5)`
    },
    excessLabel: {
      [Bu.variable]: t ?? e,
      [H1.variable]: `calc(${t ?? e} / 2.5)`
    }
  });
}
const VF = {
  "2xs": Wi(4),
  xs: Wi(6),
  sm: Wi(8),
  md: Wi(12),
  lg: Wi(16),
  xl: Wi(24),
  "2xl": Wi(32),
  full: Wi("100%")
}, OF = EF({
  baseStyle: kF,
  sizes: VF,
  defaultProps: {
    size: "md"
  }
}), jn = oO("badge", ["bg", "color", "shadow"]), FF = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold",
  bg: jn.bg.reference,
  color: jn.color.reference,
  boxShadow: jn.shadow.reference
}, BF = (e) => {
  const { colorScheme: t, theme: n } = e, r = Fu(`${t}.500`, 0.6)(n);
  return {
    [jn.bg.variable]: `colors.${t}.500`,
    [jn.color.variable]: "colors.white",
    _dark: {
      [jn.bg.variable]: r,
      [jn.color.variable]: "colors.whiteAlpha.800"
    }
  };
}, HF = (e) => {
  const { colorScheme: t, theme: n } = e, r = Fu(`${t}.200`, 0.16)(n);
  return {
    [jn.bg.variable]: `colors.${t}.100`,
    [jn.color.variable]: `colors.${t}.800`,
    _dark: {
      [jn.bg.variable]: r,
      [jn.color.variable]: `colors.${t}.200`
    }
  };
}, GF = (e) => {
  const { colorScheme: t, theme: n } = e, r = Fu(`${t}.200`, 0.8)(n);
  return {
    [jn.color.variable]: `colors.${t}.500`,
    _dark: {
      [jn.color.variable]: r
    },
    [jn.shadow.variable]: `inset 0 0 0px 1px ${jn.color.reference}`
  };
}, $F = {
  solid: BF,
  subtle: HF,
  outline: GF
}, y1 = {
  baseStyle: FF,
  variants: $F,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
}, { defineMultiStyleConfig: ZF, definePartsStyle: jF } = un(mO.keys), um = tt("breadcrumb-link-decor"), WF = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  outline: "none",
  color: "inherit",
  textDecoration: um.reference,
  [um.variable]: "none",
  "&:not([aria-current=page])": {
    cursor: "pointer",
    _hover: {
      [um.variable]: "underline"
    },
    _focusVisible: {
      boxShadow: "outline"
    }
  }
}, zF = jF({
  link: WF
}), UF = ZF({
  baseStyle: zF
}), XF = {
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
}, Fy = (e) => {
  const { colorScheme: t, theme: n } = e;
  if (t === "gray")
    return {
      color: Qe("gray.800", "whiteAlpha.900")(e),
      _hover: {
        bg: Qe("gray.100", "whiteAlpha.200")(e)
      },
      _active: { bg: Qe("gray.200", "whiteAlpha.300")(e) }
    };
  const r = Fu(`${t}.200`, 0.12)(n), o = Fu(`${t}.200`, 0.24)(n);
  return {
    color: Qe(`${t}.600`, `${t}.200`)(e),
    bg: "transparent",
    _hover: {
      bg: Qe(`${t}.50`, r)(e)
    },
    _active: {
      bg: Qe(`${t}.100`, o)(e)
    }
  };
}, YF = (e) => {
  const { colorScheme: t } = e, n = Qe("gray.200", "whiteAlpha.300")(e);
  return {
    border: "1px solid",
    borderColor: t === "gray" ? n : "currentColor",
    ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": { marginEnd: "-1px" },
    ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": { marginBottom: "-1px" },
    ...Br(Fy, e)
  };
}, qF = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
}, JF = (e) => {
  const { colorScheme: t } = e;
  if (t === "gray") {
    const l = Qe("gray.100", "whiteAlpha.200")(e);
    return {
      bg: l,
      color: Qe("gray.800", "whiteAlpha.900")(e),
      _hover: {
        bg: Qe("gray.200", "whiteAlpha.300")(e),
        _disabled: {
          bg: l
        }
      },
      _active: { bg: Qe("gray.300", "whiteAlpha.400")(e) }
    };
  }
  const {
    bg: n = `${t}.500`,
    color: r = "white",
    hoverBg: o = `${t}.600`,
    activeBg: a = `${t}.700`
  } = qF[t] ?? {}, s = Qe(n, `${t}.200`)(e);
  return {
    bg: s,
    color: Qe(r, "gray.800")(e),
    _hover: {
      bg: Qe(o, `${t}.300`)(e),
      _disabled: {
        bg: s
      }
    },
    _active: { bg: Qe(a, `${t}.400`)(e) }
  };
}, KF = (e) => {
  const { colorScheme: t } = e;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: Qe(`${t}.500`, `${t}.200`)(e),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: Qe(`${t}.700`, `${t}.500`)(e)
    }
  };
}, QF = {
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: "0",
  p: "0"
}, eB = {
  ghost: Fy,
  outline: YF,
  solid: JF,
  link: KF,
  unstyled: QF
}, tB = {
  lg: {
    h: "12",
    minW: "12",
    fontSize: "lg",
    px: "6"
  },
  md: {
    h: "10",
    minW: "10",
    fontSize: "md",
    px: "4"
  },
  sm: {
    h: "8",
    minW: "8",
    fontSize: "sm",
    px: "3"
  },
  xs: {
    h: "6",
    minW: "6",
    fontSize: "xs",
    px: "2"
  }
}, nB = {
  baseStyle: XF,
  variants: eB,
  sizes: tB,
  defaultProps: {
    variant: "solid",
    size: "md",
    colorScheme: "gray"
  }
}, { definePartsStyle: rl, defineMultiStyleConfig: rB } = un(kO.keys), B2 = tt("card-bg"), fi = tt("card-padding"), By = tt("card-shadow"), g2 = tt("card-radius"), Hy = tt("card-border-width", "0"), Gy = tt("card-border-color"), oB = rl({
  container: {
    [B2.variable]: "colors.chakra-body-bg",
    backgroundColor: B2.reference,
    boxShadow: By.reference,
    borderRadius: g2.reference,
    color: "chakra-body-text",
    borderWidth: Hy.reference,
    borderColor: Gy.reference
  },
  body: {
    padding: fi.reference,
    flex: "1 1 0%"
  },
  header: {
    padding: fi.reference
  },
  footer: {
    padding: fi.reference
  }
}), aB = {
  sm: rl({
    container: {
      [g2.variable]: "radii.base",
      [fi.variable]: "space.3"
    }
  }),
  md: rl({
    container: {
      [g2.variable]: "radii.md",
      [fi.variable]: "space.5"
    }
  }),
  lg: rl({
    container: {
      [g2.variable]: "radii.xl",
      [fi.variable]: "space.7"
    }
  })
}, iB = {
  elevated: rl({
    container: {
      [By.variable]: "shadows.base",
      _dark: {
        [B2.variable]: "colors.gray.700"
      }
    }
  }),
  outline: rl({
    container: {
      [Hy.variable]: "1px",
      [Gy.variable]: "colors.chakra-border-color"
    }
  }),
  filled: rl({
    container: {
      [B2.variable]: "colors.chakra-subtle-bg"
    }
  }),
  unstyled: {
    body: {
      [fi.variable]: 0
    },
    header: {
      [fi.variable]: 0
    },
    footer: {
      [fi.variable]: 0
    }
  }
}, sB = rB({
  baseStyle: oB,
  variants: iB,
  sizes: aB,
  defaultProps: {
    variant: "elevated",
    size: "md"
  }
}), { definePartsStyle: v2, defineMultiStyleConfig: lB } = un(gO.keys), S1 = tt("checkbox-size"), uB = (e) => {
  const { colorScheme: t } = e;
  return {
    w: S1.reference,
    h: S1.reference,
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "inherit",
    color: "white",
    _checked: {
      bg: Qe(`${t}.500`, `${t}.200`)(e),
      borderColor: Qe(`${t}.500`, `${t}.200`)(e),
      color: Qe("white", "gray.900")(e),
      _hover: {
        bg: Qe(`${t}.600`, `${t}.300`)(e),
        borderColor: Qe(`${t}.600`, `${t}.300`)(e)
      },
      _disabled: {
        borderColor: Qe("gray.200", "transparent")(e),
        bg: Qe("gray.200", "whiteAlpha.300")(e),
        color: Qe("gray.500", "whiteAlpha.500")(e)
      }
    },
    _indeterminate: {
      bg: Qe(`${t}.500`, `${t}.200`)(e),
      borderColor: Qe(`${t}.500`, `${t}.200`)(e),
      color: Qe("white", "gray.900")(e)
    },
    _disabled: {
      bg: Qe("gray.100", "whiteAlpha.100")(e),
      borderColor: Qe("gray.100", "transparent")(e)
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: Qe("red.500", "red.300")(e)
    }
  };
}, cB = {
  _disabled: { cursor: "not-allowed" }
}, dB = {
  userSelect: "none",
  _disabled: { opacity: 0.4 }
}, fB = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, hB = v2((e) => ({
  icon: fB,
  container: cB,
  control: Br(uB, e),
  label: dB
})), pB = {
  sm: v2({
    control: { [S1.variable]: "sizes.3" },
    label: { fontSize: "sm" },
    icon: { fontSize: "3xs" }
  }),
  md: v2({
    control: { [S1.variable]: "sizes.4" },
    label: { fontSize: "md" },
    icon: { fontSize: "2xs" }
  }),
  lg: v2({
    control: { [S1.variable]: "sizes.5" },
    label: { fontSize: "lg" },
    icon: { fontSize: "2xs" }
  })
}, Qi = lB({
  baseStyle: hB,
  sizes: pB,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), A1 = sr("close-button-size"), $c = sr("close-button-bg"), mB = {
  w: [A1.reference],
  h: [A1.reference],
  borderRadius: "md",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    [$c.variable]: "colors.blackAlpha.100",
    _dark: {
      [$c.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [$c.variable]: "colors.blackAlpha.200",
    _dark: {
      [$c.variable]: "colors.whiteAlpha.200"
    }
  },
  _focusVisible: {
    boxShadow: "outline"
  },
  bg: $c.reference
}, gB = {
  lg: {
    [A1.variable]: "sizes.10",
    fontSize: "md"
  },
  md: {
    [A1.variable]: "sizes.8",
    fontSize: "xs"
  },
  sm: {
    [A1.variable]: "sizes.6",
    fontSize: "2xs"
  }
}, vB = {
  baseStyle: mB,
  sizes: gB,
  defaultProps: {
    size: "md"
  }
}, { variants: CB, defaultProps: bB } = y1, yB = {
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm",
  bg: jn.bg.reference,
  color: jn.color.reference,
  boxShadow: jn.shadow.reference
}, SB = {
  baseStyle: yB,
  variants: CB,
  defaultProps: bB
}, AB = {
  w: "100%",
  mx: "auto",
  maxW: "prose",
  px: "4"
}, MB = {
  baseStyle: AB
}, xB = {
  opacity: 0.6,
  borderColor: "inherit"
}, _B = {
  borderStyle: "solid"
}, IB = {
  borderStyle: "dashed"
}, wB = {
  solid: _B,
  dashed: IB
}, LB = {
  baseStyle: xB,
  variants: wB,
  defaultProps: {
    variant: "solid"
  }
}, { definePartsStyle: G5, defineMultiStyleConfig: RB } = un(vO.keys), cm = tt("drawer-bg"), dm = tt("drawer-box-shadow");
function au(e) {
  return G5(e === "full" ? {
    dialog: { maxW: "100vw", h: "100vh" }
  } : {
    dialog: { maxW: e }
  });
}
const EB = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, DB = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
}, NB = (e) => {
  const { isFullHeight: t } = e;
  return {
    ...t && { height: "100vh" },
    zIndex: "modal",
    maxH: "100vh",
    color: "inherit",
    [cm.variable]: "colors.white",
    [dm.variable]: "shadows.lg",
    _dark: {
      [cm.variable]: "colors.gray.700",
      [dm.variable]: "shadows.dark-lg"
    },
    bg: cm.reference,
    boxShadow: dm.reference
  };
}, TB = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, PB = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, kB = {
  px: "6",
  py: "2",
  flex: "1",
  overflow: "auto"
}, VB = {
  px: "6",
  py: "4"
}, OB = G5((e) => ({
  overlay: EB,
  dialogContainer: DB,
  dialog: Br(NB, e),
  header: TB,
  closeButton: PB,
  body: kB,
  footer: VB
})), FB = {
  xs: au("xs"),
  sm: au("md"),
  md: au("lg"),
  lg: au("2xl"),
  xl: au("4xl"),
  full: au("full")
}, BB = RB({
  baseStyle: OB,
  sizes: FB,
  defaultProps: {
    size: "xs"
  }
}), { definePartsStyle: HB, defineMultiStyleConfig: GB } = un(CO.keys), $B = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal"
}, ZB = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, jB = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, WB = HB({
  preview: $B,
  input: ZB,
  textarea: jB
}), zB = GB({
  baseStyle: WB
}), { definePartsStyle: UB, defineMultiStyleConfig: XB } = un(bO.keys), Du = tt("form-control-color"), YB = {
  marginStart: "1",
  [Du.variable]: "colors.red.500",
  _dark: {
    [Du.variable]: "colors.red.300"
  },
  color: Du.reference
}, qB = {
  mt: "2",
  [Du.variable]: "colors.gray.600",
  _dark: {
    [Du.variable]: "colors.whiteAlpha.600"
  },
  color: Du.reference,
  lineHeight: "normal",
  fontSize: "sm"
}, JB = UB({
  container: {
    width: "100%",
    position: "relative"
  },
  requiredIndicator: YB,
  helperText: qB
}), KB = XB({
  baseStyle: JB
}), { definePartsStyle: QB, defineMultiStyleConfig: eH } = un(yO.keys), Nu = tt("form-error-color"), tH = {
  [Nu.variable]: "colors.red.500",
  _dark: {
    [Nu.variable]: "colors.red.300"
  },
  color: Nu.reference,
  mt: "2",
  fontSize: "sm",
  lineHeight: "normal"
}, nH = {
  marginEnd: "0.5em",
  [Nu.variable]: "colors.red.500",
  _dark: {
    [Nu.variable]: "colors.red.300"
  },
  color: Nu.reference
}, rH = QB({
  text: tH,
  icon: nH
}), oH = eH({
  baseStyle: rH
}), aH = {
  fontSize: "md",
  marginEnd: "3",
  mb: "2",
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
}, iH = {
  baseStyle: aH
}, sH = {
  fontFamily: "heading",
  fontWeight: "bold"
}, lH = {
  "4xl": {
    fontSize: ["6xl", null, "7xl"],
    lineHeight: 1
  },
  "3xl": {
    fontSize: ["5xl", null, "6xl"],
    lineHeight: 1
  },
  "2xl": {
    fontSize: ["4xl", null, "5xl"],
    lineHeight: [1.2, null, 1]
  },
  xl: {
    fontSize: ["3xl", null, "4xl"],
    lineHeight: [1.33, null, 1.2]
  },
  lg: {
    fontSize: ["2xl", null, "3xl"],
    lineHeight: [1.33, null, 1.2]
  },
  md: {
    fontSize: "xl",
    lineHeight: 1.2
  },
  sm: {
    fontSize: "md",
    lineHeight: 1.2
  },
  xs: {
    fontSize: "sm",
    lineHeight: 1.2
  }
}, uH = {
  baseStyle: sH,
  sizes: lH,
  defaultProps: {
    size: "xl"
  }
}, { definePartsStyle: ui, defineMultiStyleConfig: cH } = un(SO.keys), vu = tt("input-height"), Cu = tt("input-font-size"), bu = tt("input-padding"), yu = tt("input-border-radius"), dH = ui({
  addon: {
    height: vu.reference,
    fontSize: Cu.reference,
    px: bu.reference,
    borderRadius: yu.reference
  },
  field: {
    width: "100%",
    height: vu.reference,
    fontSize: Cu.reference,
    px: bu.reference,
    borderRadius: yu.reference,
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  }
}), zi = {
  lg: {
    [Cu.variable]: "fontSizes.lg",
    [bu.variable]: "space.4",
    [yu.variable]: "radii.md",
    [vu.variable]: "sizes.12"
  },
  md: {
    [Cu.variable]: "fontSizes.md",
    [bu.variable]: "space.4",
    [yu.variable]: "radii.md",
    [vu.variable]: "sizes.10"
  },
  sm: {
    [Cu.variable]: "fontSizes.sm",
    [bu.variable]: "space.3",
    [yu.variable]: "radii.sm",
    [vu.variable]: "sizes.8"
  },
  xs: {
    [Cu.variable]: "fontSizes.xs",
    [bu.variable]: "space.2",
    [yu.variable]: "radii.sm",
    [vu.variable]: "sizes.6"
  }
}, fH = {
  lg: ui({
    field: zi.lg,
    group: zi.lg
  }),
  md: ui({
    field: zi.md,
    group: zi.md
  }),
  sm: ui({
    field: zi.sm,
    group: zi.sm
  }),
  xs: ui({
    field: zi.xs,
    group: zi.xs
  })
};
function hg(e) {
  const { focusBorderColor: t, errorBorderColor: n } = e;
  return {
    focusBorderColor: t || Qe("blue.500", "blue.300")(e),
    errorBorderColor: n || Qe("red.500", "red.300")(e)
  };
}
const hH = ui((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = hg(e);
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: Qe("gray.300", "whiteAlpha.400")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Vr(t, r),
        boxShadow: `0 0 0 1px ${Vr(t, r)}`
      },
      _focusVisible: {
        zIndex: 1,
        borderColor: Vr(t, n),
        boxShadow: `0 0 0 1px ${Vr(t, n)}`
      }
    },
    addon: {
      border: "1px solid",
      borderColor: Qe("inherit", "whiteAlpha.50")(e),
      bg: Qe("gray.100", "whiteAlpha.300")(e)
    }
  };
}), pH = ui((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = hg(e);
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: Qe("gray.100", "whiteAlpha.50")(e),
      _hover: {
        bg: Qe("gray.200", "whiteAlpha.100")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Vr(t, r)
      },
      _focusVisible: {
        bg: "transparent",
        borderColor: Vr(t, n)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: Qe("gray.100", "whiteAlpha.50")(e)
    }
  };
}), mH = ui((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = hg(e);
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Vr(t, r),
        boxShadow: `0px 1px 0px 0px ${Vr(t, r)}`
      },
      _focusVisible: {
        borderColor: Vr(t, n),
        boxShadow: `0px 1px 0px 0px ${Vr(t, n)}`
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent"
    }
  };
}), gH = ui({
  field: {
    bg: "transparent",
    px: "0",
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: "0",
    height: "auto"
  }
}), vH = {
  outline: hH,
  filled: pH,
  flushed: mH,
  unstyled: gH
}, Kt = cH({
  baseStyle: dH,
  sizes: fH,
  variants: vH,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}), fm = tt("kbd-bg"), CH = {
  [fm.variable]: "colors.gray.100",
  _dark: {
    [fm.variable]: "colors.whiteAlpha.100"
  },
  bg: fm.reference,
  borderRadius: "md",
  borderWidth: "1px",
  borderBottomWidth: "3px",
  fontSize: "0.8em",
  fontWeight: "bold",
  lineHeight: "normal",
  px: "0.4em",
  whiteSpace: "nowrap"
}, bH = {
  baseStyle: CH
}, yH = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focusVisible: {
    boxShadow: "outline"
  }
}, SH = {
  baseStyle: yH
}, { defineMultiStyleConfig: AH, definePartsStyle: MH } = un(AO.keys), xH = {
  marginEnd: "2",
  display: "inline",
  verticalAlign: "text-bottom"
}, _H = MH({
  icon: xH
}), IH = AH({
  baseStyle: _H
}), { defineMultiStyleConfig: wH, definePartsStyle: LH } = un(MO.keys), wa = tt("menu-bg"), hm = tt("menu-shadow"), RH = {
  [wa.variable]: "#fff",
  [hm.variable]: "shadows.sm",
  _dark: {
    [wa.variable]: "colors.gray.700",
    [hm.variable]: "shadows.dark-lg"
  },
  color: "inherit",
  minW: "3xs",
  py: "2",
  zIndex: "dropdown",
  borderRadius: "md",
  borderWidth: "1px",
  bg: wa.reference,
  boxShadow: hm.reference
}, EH = {
  py: "1.5",
  px: "3",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  _focus: {
    [wa.variable]: "colors.gray.100",
    _dark: {
      [wa.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [wa.variable]: "colors.gray.200",
    _dark: {
      [wa.variable]: "colors.whiteAlpha.200"
    }
  },
  _expanded: {
    [wa.variable]: "colors.gray.100",
    _dark: {
      [wa.variable]: "colors.whiteAlpha.100"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  bg: wa.reference
}, DH = {
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
}, NH = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0
}, TH = {
  opacity: 0.6
}, PH = {
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "2",
  opacity: 0.6
}, kH = {
  transitionProperty: "common",
  transitionDuration: "normal"
}, VH = LH({
  button: kH,
  list: RH,
  item: EH,
  groupTitle: DH,
  icon: NH,
  command: TH,
  divider: PH
}), OH = wH({
  baseStyle: VH
}), { defineMultiStyleConfig: FH, definePartsStyle: $5 } = un(xO.keys), pm = tt("modal-bg"), mm = tt("modal-shadow"), BH = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, HH = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: t ? "center" : "flex-start",
    overflow: n === "inside" ? "hidden" : "auto",
    overscrollBehaviorY: "none"
  };
}, GH = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    borderRadius: "md",
    color: "inherit",
    my: t ? "auto" : "16",
    mx: t ? "auto" : void 0,
    zIndex: "modal",
    maxH: n === "inside" ? "calc(100% - 7.5rem)" : void 0,
    [pm.variable]: "colors.white",
    [mm.variable]: "shadows.lg",
    _dark: {
      [pm.variable]: "colors.gray.700",
      [mm.variable]: "shadows.dark-lg"
    },
    bg: pm.reference,
    boxShadow: mm.reference
  };
}, $H = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, ZH = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, jH = (e) => {
  const { scrollBehavior: t } = e;
  return {
    px: "6",
    py: "2",
    flex: "1",
    overflow: t === "inside" ? "auto" : void 0
  };
}, WH = {
  px: "6",
  py: "4"
}, zH = $5((e) => ({
  overlay: BH,
  dialogContainer: Br(HH, e),
  dialog: Br(GH, e),
  header: $H,
  closeButton: ZH,
  body: Br(jH, e),
  footer: WH
}));
function ra(e) {
  return $5(e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "$100vh",
      my: "0",
      borderRadius: "0"
    }
  } : {
    dialog: { maxW: e }
  });
}
const UH = {
  xs: ra("xs"),
  sm: ra("sm"),
  md: ra("md"),
  lg: ra("lg"),
  xl: ra("xl"),
  "2xl": ra("2xl"),
  "3xl": ra("3xl"),
  "4xl": ra("4xl"),
  "5xl": ra("5xl"),
  "6xl": ra("6xl"),
  full: ra("full")
}, XH = FH({
  baseStyle: zH,
  sizes: UH,
  defaultProps: { size: "md" }
}), $y = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    "3xs": "0.45rem",
    "2xs": "0.625rem",
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  }
}, { defineMultiStyleConfig: YH, definePartsStyle: Zy } = un(_O.keys), pg = sr("number-input-stepper-width"), jy = sr("number-input-input-padding"), qH = si(pg).add("0.5rem").toString(), gm = sr("number-input-bg"), vm = sr("number-input-color"), Cm = sr("number-input-border-color"), JH = {
  [pg.variable]: "sizes.6",
  [jy.variable]: qH
}, KH = (e) => {
  var t;
  return ((t = Br(Kt.baseStyle, e)) == null ? void 0 : t.field) ?? {};
}, QH = {
  width: pg.reference
}, eG = {
  borderStart: "1px solid",
  borderStartColor: Cm.reference,
  color: vm.reference,
  bg: gm.reference,
  [vm.variable]: "colors.chakra-body-text",
  [Cm.variable]: "colors.chakra-border-color",
  _dark: {
    [vm.variable]: "colors.whiteAlpha.800",
    [Cm.variable]: "colors.whiteAlpha.300"
  },
  _active: {
    [gm.variable]: "colors.gray.200",
    _dark: {
      [gm.variable]: "colors.whiteAlpha.300"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  }
}, tG = Zy((e) => ({
  root: JH,
  field: Br(KH, e) ?? {},
  stepperGroup: QH,
  stepper: eG
}));
function P0(e) {
  var a, s;
  const t = (a = Kt.sizes) == null ? void 0 : a[e], n = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  }, r = ((s = t.field) == null ? void 0 : s.fontSize) ?? "md", o = $y.fontSizes[r];
  return Zy({
    field: {
      ...t.field,
      paddingInlineEnd: jy.reference,
      verticalAlign: "top"
    },
    stepper: {
      fontSize: si(o).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: n[e]
      },
      _last: {
        borderBottomEndRadius: n[e],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  });
}
const nG = {
  xs: P0("xs"),
  sm: P0("sm"),
  md: P0("md"),
  lg: P0("lg")
}, rG = YH({
  baseStyle: tG,
  sizes: nG,
  variants: Kt.variants,
  defaultProps: Kt.defaultProps
});
var Eb;
const oG = {
  ...(Eb = Kt.baseStyle) == null ? void 0 : Eb.field,
  textAlign: "center"
}, aG = {
  lg: {
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  }
};
var Db;
const iG = {
  outline: (e) => {
    var t, n;
    return ((n = Br((t = Kt.variants) == null ? void 0 : t.outline, e)) == null ? void 0 : n.field) ?? {};
  },
  flushed: (e) => {
    var t, n;
    return ((n = Br((t = Kt.variants) == null ? void 0 : t.flushed, e)) == null ? void 0 : n.field) ?? {};
  },
  filled: (e) => {
    var t, n;
    return ((n = Br((t = Kt.variants) == null ? void 0 : t.filled, e)) == null ? void 0 : n.field) ?? {};
  },
  unstyled: ((Db = Kt.variants) == null ? void 0 : Db.unstyled.field) ?? {}
}, sG = {
  baseStyle: oG,
  sizes: aG,
  variants: iG,
  defaultProps: Kt.defaultProps
}, { defineMultiStyleConfig: lG, definePartsStyle: uG } = un(Ny.keys), k0 = sr("popper-bg"), cG = sr("popper-arrow-bg"), W6 = sr("popper-arrow-shadow-color"), dG = {
  zIndex: "popover"
}, fG = {
  [k0.variable]: "colors.white",
  bg: k0.reference,
  [cG.variable]: k0.reference,
  [W6.variable]: "colors.gray.200",
  _dark: {
    [k0.variable]: "colors.gray.700",
    [W6.variable]: "colors.whiteAlpha.300"
  },
  width: "xs",
  border: "1px solid",
  borderColor: "inherit",
  borderRadius: "md",
  boxShadow: "sm",
  zIndex: "inherit",
  _focusVisible: {
    outline: 0,
    boxShadow: "outline"
  }
}, hG = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
}, pG = {
  px: 3,
  py: 2
}, mG = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, gG = {
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
}, vG = uG({
  popper: dG,
  content: fG,
  header: hG,
  body: pG,
  footer: mG,
  closeButton: gG
}), CG = lG({
  baseStyle: vG
}), { defineMultiStyleConfig: bG, definePartsStyle: i1 } = un(IO.keys), yG = (e) => {
  const { colorScheme: t, theme: n, isIndeterminate: r, hasStripe: o } = e, a = Qe(
    H6(),
    H6("1rem", "rgba(0,0,0,0.1)")
  )(e), s = Qe(`${t}.500`, `${t}.200`)(e), l = `linear-gradient(
    to right,
    transparent 0%,
    ${Vr(n, s)} 50%,
    transparent 100%
  )`;
  return {
    ...!r && o && a,
    ...r ? { bgImage: l } : { bgColor: s }
  };
}, SG = {
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
}, AG = (e) => ({
  bg: Qe("gray.100", "whiteAlpha.300")(e)
}), MG = (e) => ({
  transitionProperty: "common",
  transitionDuration: "slow",
  ...yG(e)
}), xG = i1((e) => ({
  label: SG,
  filledTrack: MG(e),
  track: AG(e)
})), _G = {
  xs: i1({
    track: { h: "1" }
  }),
  sm: i1({
    track: { h: "2" }
  }),
  md: i1({
    track: { h: "3" }
  }),
  lg: i1({
    track: { h: "4" }
  })
}, IG = bG({
  sizes: _G,
  baseStyle: xG,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: wG, definePartsStyle: C2 } = un(wO.keys), LG = (e) => {
  var n;
  const t = (n = Br(Qi.baseStyle, e)) == null ? void 0 : n.control;
  return {
    ...t,
    borderRadius: "full",
    _checked: {
      ...t == null ? void 0 : t._checked,
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    }
  };
}, RG = C2((e) => {
  var t, n;
  return {
    label: (t = Qi.baseStyle) == null ? void 0 : t.call(Qi, e).label,
    container: (n = Qi.baseStyle) == null ? void 0 : n.call(Qi, e).container,
    control: LG(e)
  };
}), EG = {
  md: C2({
    control: { w: "4", h: "4" },
    label: { fontSize: "md" }
  }),
  lg: C2({
    control: { w: "5", h: "5" },
    label: { fontSize: "lg" }
  }),
  sm: C2({
    control: { width: "3", height: "3" },
    label: { fontSize: "sm" }
  })
}, DG = wG({
  baseStyle: RG,
  sizes: EG,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: NG, definePartsStyle: TG } = un(LO.keys), V0 = tt("select-bg");
var Nb;
const PG = {
  ...(Nb = Kt.baseStyle) == null ? void 0 : Nb.field,
  appearance: "none",
  paddingBottom: "1px",
  lineHeight: "normal",
  bg: V0.reference,
  [V0.variable]: "colors.white",
  _dark: {
    [V0.variable]: "colors.gray.700"
  },
  "> option, > optgroup": {
    bg: V0.reference
  }
}, kG = {
  width: "6",
  height: "100%",
  insetEnd: "2",
  position: "relative",
  color: "currentColor",
  fontSize: "xl",
  _disabled: {
    opacity: 0.5
  }
}, VG = TG({
  field: PG,
  icon: kG
}), O0 = {
  paddingInlineEnd: "8"
};
var Tb, Pb, kb, Vb, Ob, Fb, Bb, Hb;
const OG = {
  lg: {
    ...(Tb = Kt.sizes) == null ? void 0 : Tb.lg,
    field: {
      ...(Pb = Kt.sizes) == null ? void 0 : Pb.lg.field,
      ...O0
    }
  },
  md: {
    ...(kb = Kt.sizes) == null ? void 0 : kb.md,
    field: {
      ...(Vb = Kt.sizes) == null ? void 0 : Vb.md.field,
      ...O0
    }
  },
  sm: {
    ...(Ob = Kt.sizes) == null ? void 0 : Ob.sm,
    field: {
      ...(Fb = Kt.sizes) == null ? void 0 : Fb.sm.field,
      ...O0
    }
  },
  xs: {
    ...(Bb = Kt.sizes) == null ? void 0 : Bb.xs,
    field: {
      ...(Hb = Kt.sizes) == null ? void 0 : Hb.xs.field,
      ...O0
    },
    icon: {
      insetEnd: "1"
    }
  }
}, FG = NG({
  baseStyle: VG,
  sizes: OG,
  variants: Kt.variants,
  defaultProps: Kt.defaultProps
}), bm = tt("skeleton-start-color"), ym = tt("skeleton-end-color"), BG = {
  [bm.variable]: "colors.gray.100",
  [ym.variable]: "colors.gray.400",
  _dark: {
    [bm.variable]: "colors.gray.800",
    [ym.variable]: "colors.gray.600"
  },
  background: bm.reference,
  borderColor: ym.reference,
  opacity: 0.7,
  borderRadius: "sm"
}, HG = {
  baseStyle: BG
}, Sm = tt("skip-link-bg"), GG = {
  borderRadius: "md",
  fontWeight: "semibold",
  _focusVisible: {
    boxShadow: "outline",
    padding: "4",
    position: "fixed",
    top: "6",
    insetStart: "6",
    [Sm.variable]: "colors.white",
    _dark: {
      [Sm.variable]: "colors.gray.700"
    },
    bg: Sm.reference
  }
}, $G = {
  baseStyle: GG
}, { defineMultiStyleConfig: ZG, definePartsStyle: Yf } = un(RO.keys), cl = tt("slider-thumb-size"), G1 = tt("slider-track-size"), ns = tt("slider-bg"), jG = (e) => {
  const { orientation: t } = e;
  return {
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    },
    ...dg({
      orientation: t,
      vertical: {
        h: "100%",
        px: ii(cl.reference).divide(2).toString()
      },
      horizontal: {
        w: "100%",
        py: ii(cl.reference).divide(2).toString()
      }
    })
  };
}, WG = (e) => ({
  ...dg({
    orientation: e.orientation,
    horizontal: { h: G1.reference },
    vertical: { w: G1.reference }
  }),
  overflow: "hidden",
  borderRadius: "sm",
  [ns.variable]: "colors.gray.200",
  _dark: {
    [ns.variable]: "colors.whiteAlpha.200"
  },
  _disabled: {
    [ns.variable]: "colors.gray.300",
    _dark: {
      [ns.variable]: "colors.whiteAlpha.300"
    }
  },
  bg: ns.reference
}), zG = (e) => {
  const { orientation: t } = e;
  return {
    ...dg({
      orientation: t,
      vertical: { left: "50%" },
      horizontal: { top: "50%" }
    }),
    w: cl.reference,
    h: cl.reference,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focusVisible: {
      boxShadow: "outline"
    },
    _active: {
      "--slider-thumb-scale": "1.15"
    },
    _disabled: {
      bg: "gray.300"
    }
  };
}, UG = (e) => {
  const { colorScheme: t } = e;
  return {
    width: "inherit",
    height: "inherit",
    [ns.variable]: `colors.${t}.500`,
    _dark: {
      [ns.variable]: `colors.${t}.200`
    },
    bg: ns.reference
  };
}, XG = Yf((e) => ({
  container: jG(e),
  track: WG(e),
  thumb: zG(e),
  filledTrack: UG(e)
})), YG = Yf({
  container: {
    [cl.variable]: "sizes.4",
    [G1.variable]: "sizes.1"
  }
}), qG = Yf({
  container: {
    [cl.variable]: "sizes.3.5",
    [G1.variable]: "sizes.1"
  }
}), JG = Yf({
  container: {
    [cl.variable]: "sizes.2.5",
    [G1.variable]: "sizes.0.5"
  }
}), KG = {
  lg: YG,
  md: qG,
  sm: JG
}, QG = ZG({
  baseStyle: XG,
  sizes: KG,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), Ys = sr("spinner-size"), e$ = {
  width: [Ys.reference],
  height: [Ys.reference]
}, t$ = {
  xs: {
    [Ys.variable]: "sizes.3"
  },
  sm: {
    [Ys.variable]: "sizes.4"
  },
  md: {
    [Ys.variable]: "sizes.6"
  },
  lg: {
    [Ys.variable]: "sizes.8"
  },
  xl: {
    [Ys.variable]: "sizes.12"
  }
}, n$ = {
  baseStyle: e$,
  sizes: t$,
  defaultProps: {
    size: "md"
  }
}, { defineMultiStyleConfig: r$, definePartsStyle: Wy } = un(EO.keys), o$ = {
  fontWeight: "medium"
}, a$ = {
  opacity: 0.8,
  marginBottom: "2"
}, i$ = {
  verticalAlign: "baseline",
  fontWeight: "semibold"
}, s$ = {
  marginEnd: 1,
  w: "3.5",
  h: "3.5",
  verticalAlign: "middle"
}, l$ = Wy({
  container: {},
  label: o$,
  helpText: a$,
  number: i$,
  icon: s$
}), u$ = {
  md: Wy({
    label: { fontSize: "sm" },
    helpText: { fontSize: "sm" },
    number: { fontSize: "2xl" }
  })
}, c$ = r$({
  baseStyle: l$,
  sizes: u$,
  defaultProps: {
    size: "md"
  }
}), { defineMultiStyleConfig: d$, definePartsStyle: s1 } = un([
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
]), li = tt("stepper-indicator-size"), Su = tt("stepper-icon-size"), Au = tt("stepper-title-font-size"), l1 = tt("stepper-description-font-size"), Zc = tt("stepper-accent-color"), f$ = s1(({ colorScheme: e }) => ({
  stepper: {
    display: "flex",
    justifyContent: "space-between",
    gap: "4",
    "&[data-orientation=vertical]": {
      flexDirection: "column",
      alignItems: "flex-start"
    },
    "&[data-orientation=horizontal]": {
      flexDirection: "row",
      alignItems: "center"
    },
    [Zc.variable]: `colors.${e}.500`,
    _dark: {
      [Zc.variable]: `colors.${e}.200`
    }
  },
  title: {
    fontSize: Au.reference,
    fontWeight: "medium"
  },
  description: {
    fontSize: l1.reference,
    color: "chakra-subtle-text"
  },
  number: {
    fontSize: Au.reference
  },
  step: {
    flexShrink: 0,
    position: "relative",
    display: "flex",
    gap: "2",
    "&[data-orientation=horizontal]": {
      alignItems: "center"
    },
    flex: "1",
    "&:last-of-type:not([data-stretch])": {
      flex: "initial"
    }
  },
  icon: {
    flexShrink: 0,
    width: Su.reference,
    height: Su.reference
  },
  indicator: {
    flexShrink: 0,
    borderRadius: "full",
    width: li.reference,
    height: li.reference,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&[data-status=active]": {
      borderWidth: "2px",
      borderColor: Zc.reference
    },
    "&[data-status=complete]": {
      bg: Zc.reference,
      color: "chakra-inverse-text"
    },
    "&[data-status=incomplete]": {
      borderWidth: "2px"
    }
  },
  separator: {
    bg: "chakra-border-color",
    flex: "1",
    "&[data-status=complete]": {
      bg: Zc.reference
    },
    "&[data-orientation=horizontal]": {
      width: "100%",
      height: "2px",
      marginStart: "2"
    },
    "&[data-orientation=vertical]": {
      width: "2px",
      position: "absolute",
      height: "100%",
      maxHeight: `calc(100% - ${li.reference} - 8px)`,
      top: `calc(${li.reference} + 4px)`,
      insetStart: `calc(${li.reference} / 2 - 1px)`
    }
  }
})), h$ = d$({
  baseStyle: f$,
  sizes: {
    xs: s1({
      stepper: {
        [li.variable]: "sizes.4",
        [Su.variable]: "sizes.3",
        [Au.variable]: "fontSizes.xs",
        [l1.variable]: "fontSizes.xs"
      }
    }),
    sm: s1({
      stepper: {
        [li.variable]: "sizes.6",
        [Su.variable]: "sizes.4",
        [Au.variable]: "fontSizes.sm",
        [l1.variable]: "fontSizes.xs"
      }
    }),
    md: s1({
      stepper: {
        [li.variable]: "sizes.8",
        [Su.variable]: "sizes.5",
        [Au.variable]: "fontSizes.md",
        [l1.variable]: "fontSizes.sm"
      }
    }),
    lg: s1({
      stepper: {
        [li.variable]: "sizes.10",
        [Su.variable]: "sizes.6",
        [Au.variable]: "fontSizes.lg",
        [l1.variable]: "fontSizes.md"
      }
    })
  },
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: p$, definePartsStyle: b2 } = un(DO.keys), M1 = sr("switch-track-width"), ol = sr("switch-track-height"), Am = sr("switch-track-diff"), m$ = si.subtract(M1, ol), Z5 = sr("switch-thumb-x"), jc = sr("switch-bg"), g$ = (e) => {
  const { colorScheme: t } = e;
  return {
    borderRadius: "full",
    p: "0.5",
    width: [M1.reference],
    height: [ol.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    [jc.variable]: "colors.gray.300",
    _dark: {
      [jc.variable]: "colors.whiteAlpha.400"
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      [jc.variable]: `colors.${t}.500`,
      _dark: {
        [jc.variable]: `colors.${t}.200`
      }
    },
    bg: jc.reference
  };
}, v$ = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [ol.reference],
  height: [ol.reference],
  _checked: {
    transform: `translateX(${Z5.reference})`
  }
}, C$ = b2((e) => ({
  container: {
    [Am.variable]: m$,
    [Z5.variable]: Am.reference,
    _rtl: {
      [Z5.variable]: si(Am).negate().toString()
    }
  },
  track: g$(e),
  thumb: v$
})), b$ = {
  sm: b2({
    container: {
      [M1.variable]: "1.375rem",
      [ol.variable]: "sizes.3"
    }
  }),
  md: b2({
    container: {
      [M1.variable]: "1.875rem",
      [ol.variable]: "sizes.4"
    }
  }),
  lg: b2({
    container: {
      [M1.variable]: "2.875rem",
      [ol.variable]: "sizes.6"
    }
  })
}, y$ = p$({
  baseStyle: C$,
  sizes: b$,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: S$, definePartsStyle: Tu } = un(NO.keys), A$ = Tu({
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "wider",
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
}), H2 = {
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}, M$ = Tu((e) => {
  const { colorScheme: t } = e;
  return {
    th: {
      color: Qe("gray.600", "gray.400")(e),
      borderBottom: "1px",
      borderColor: Qe(`${t}.100`, `${t}.700`)(e),
      ...H2
    },
    td: {
      borderBottom: "1px",
      borderColor: Qe(`${t}.100`, `${t}.700`)(e),
      ...H2
    },
    caption: {
      color: Qe("gray.600", "gray.100")(e)
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), x$ = Tu((e) => {
  const { colorScheme: t } = e;
  return {
    th: {
      color: Qe("gray.600", "gray.400")(e),
      borderBottom: "1px",
      borderColor: Qe(`${t}.100`, `${t}.700`)(e),
      ...H2
    },
    td: {
      borderBottom: "1px",
      borderColor: Qe(`${t}.100`, `${t}.700`)(e),
      ...H2
    },
    caption: {
      color: Qe("gray.600", "gray.100")(e)
    },
    tbody: {
      tr: {
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "1px",
            borderColor: Qe(`${t}.100`, `${t}.700`)(e)
          },
          td: {
            background: Qe(`${t}.100`, `${t}.700`)(e)
          }
        }
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), _$ = {
  simple: M$,
  striped: x$,
  unstyled: {}
}, I$ = {
  sm: Tu({
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  }),
  md: Tu({
    th: {
      px: "6",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  }),
  lg: Tu({
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  })
}, w$ = S$({
  baseStyle: A$,
  variants: _$,
  sizes: I$,
  defaultProps: {
    variant: "simple",
    size: "md",
    colorScheme: "gray"
  }
}), Jr = tt("tabs-color"), ua = tt("tabs-bg"), F0 = tt("tabs-border-color"), { defineMultiStyleConfig: L$, definePartsStyle: Na } = un(TO.keys), R$ = (e) => {
  const { orientation: t } = e;
  return {
    display: t === "vertical" ? "flex" : "block"
  };
}, E$ = (e) => {
  const { isFitted: t } = e;
  return {
    flex: t ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
}, D$ = (e) => {
  const { align: t = "start", orientation: n } = e;
  return {
    justifyContent: {
      end: "flex-end",
      center: "center",
      start: "flex-start"
    }[t],
    flexDirection: n === "vertical" ? "column" : "row"
  };
}, N$ = {
  p: 4
}, T$ = Na((e) => ({
  root: R$(e),
  tab: E$(e),
  tablist: D$(e),
  tabpanel: N$
})), P$ = {
  sm: Na({
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  }),
  md: Na({
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  }),
  lg: Na({
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  })
}, k$ = Na((e) => {
  const { colorScheme: t, orientation: n } = e, r = n === "vertical", o = r ? "borderStart" : "borderBottom", a = r ? "marginStart" : "marginBottom";
  return {
    tablist: {
      [o]: "2px solid",
      borderColor: "inherit"
    },
    tab: {
      [o]: "2px solid",
      borderColor: "transparent",
      [a]: "-2px",
      _selected: {
        [Jr.variable]: `colors.${t}.600`,
        _dark: {
          [Jr.variable]: `colors.${t}.300`
        },
        borderColor: "currentColor"
      },
      _active: {
        [ua.variable]: "colors.gray.200",
        _dark: {
          [ua.variable]: "colors.whiteAlpha.300"
        }
      },
      _disabled: {
        _active: { bg: "none" }
      },
      color: Jr.reference,
      bg: ua.reference
    }
  };
}), V$ = Na((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px",
      [F0.variable]: "transparent",
      _selected: {
        [Jr.variable]: `colors.${t}.600`,
        [F0.variable]: "colors.white",
        _dark: {
          [Jr.variable]: `colors.${t}.300`,
          [F0.variable]: "colors.gray.800"
        },
        borderColor: "inherit",
        borderBottomColor: F0.reference
      },
      color: Jr.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), O$ = Na((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      border: "1px solid",
      borderColor: "inherit",
      [ua.variable]: "colors.gray.50",
      _dark: {
        [ua.variable]: "colors.whiteAlpha.50"
      },
      mb: "-1px",
      _notLast: {
        marginEnd: "-1px"
      },
      _selected: {
        [ua.variable]: "colors.white",
        [Jr.variable]: `colors.${t}.600`,
        _dark: {
          [ua.variable]: "colors.gray.800",
          [Jr.variable]: `colors.${t}.300`
        },
        borderColor: "inherit",
        borderTopColor: "currentColor",
        borderBottomColor: "transparent"
      },
      color: Jr.reference,
      bg: ua.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), F$ = Na((e) => {
  const { colorScheme: t, theme: n } = e;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: Vr(n, `${t}.700`),
        bg: Vr(n, `${t}.100`)
      }
    }
  };
}), B$ = Na((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      [Jr.variable]: "colors.gray.600",
      _dark: {
        [Jr.variable]: "inherit"
      },
      _selected: {
        [Jr.variable]: "colors.white",
        [ua.variable]: `colors.${t}.600`,
        _dark: {
          [Jr.variable]: "colors.gray.800",
          [ua.variable]: `colors.${t}.300`
        }
      },
      color: Jr.reference,
      bg: ua.reference
    }
  };
}), H$ = Na({}), G$ = {
  line: k$,
  enclosed: V$,
  "enclosed-colored": O$,
  "soft-rounded": F$,
  "solid-rounded": B$,
  unstyled: H$
}, $$ = L$({
  baseStyle: T$,
  sizes: P$,
  variants: G$,
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: Z$, definePartsStyle: al } = un(PO.keys), z6 = tt("tag-bg"), U6 = tt("tag-color"), Mm = tt("tag-shadow"), y2 = tt("tag-min-height"), S2 = tt("tag-min-width"), A2 = tt("tag-font-size"), M2 = tt("tag-padding-inline"), j$ = {
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0,
  [U6.variable]: jn.color.reference,
  [z6.variable]: jn.bg.reference,
  [Mm.variable]: jn.shadow.reference,
  color: U6.reference,
  bg: z6.reference,
  boxShadow: Mm.reference,
  borderRadius: "md",
  minH: y2.reference,
  minW: S2.reference,
  fontSize: A2.reference,
  px: M2.reference,
  _focusVisible: {
    [Mm.variable]: "shadows.outline"
  }
}, W$ = {
  lineHeight: 1.2,
  overflow: "visible"
}, z$ = {
  fontSize: "lg",
  w: "5",
  h: "5",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "1.5",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4
  },
  _focusVisible: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _hover: {
    opacity: 0.8
  },
  _active: {
    opacity: 1
  }
}, U$ = al({
  container: j$,
  label: W$,
  closeButton: z$
}), X$ = {
  sm: al({
    container: {
      [y2.variable]: "sizes.5",
      [S2.variable]: "sizes.5",
      [A2.variable]: "fontSizes.xs",
      [M2.variable]: "space.2"
    },
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  }),
  md: al({
    container: {
      [y2.variable]: "sizes.6",
      [S2.variable]: "sizes.6",
      [A2.variable]: "fontSizes.sm",
      [M2.variable]: "space.2"
    }
  }),
  lg: al({
    container: {
      [y2.variable]: "sizes.8",
      [S2.variable]: "sizes.8",
      [A2.variable]: "fontSizes.md",
      [M2.variable]: "space.3"
    }
  })
}, Y$ = {
  subtle: al((e) => {
    var t;
    return {
      container: (t = y1.variants) == null ? void 0 : t.subtle(e)
    };
  }),
  solid: al((e) => {
    var t;
    return {
      container: (t = y1.variants) == null ? void 0 : t.solid(e)
    };
  }),
  outline: al((e) => {
    var t;
    return {
      container: (t = y1.variants) == null ? void 0 : t.outline(e)
    };
  })
}, q$ = Z$({
  variants: Y$,
  baseStyle: U$,
  sizes: X$,
  defaultProps: {
    size: "md",
    variant: "subtle",
    colorScheme: "gray"
  }
});
var Gb;
const J$ = {
  ...(Gb = Kt.baseStyle) == null ? void 0 : Gb.field,
  paddingY: "2",
  minHeight: "20",
  lineHeight: "short",
  verticalAlign: "top"
};
var $b;
const K$ = {
  outline: (e) => {
    var t;
    return ((t = Kt.variants) == null ? void 0 : t.outline(e).field) ?? {};
  },
  flushed: (e) => {
    var t;
    return ((t = Kt.variants) == null ? void 0 : t.flushed(e).field) ?? {};
  },
  filled: (e) => {
    var t;
    return ((t = Kt.variants) == null ? void 0 : t.filled(e).field) ?? {};
  },
  unstyled: (($b = Kt.variants) == null ? void 0 : $b.unstyled.field) ?? {}
};
var Zb, jb, Wb, zb;
const Q$ = {
  xs: ((Zb = Kt.sizes) == null ? void 0 : Zb.xs.field) ?? {},
  sm: ((jb = Kt.sizes) == null ? void 0 : jb.sm.field) ?? {},
  md: ((Wb = Kt.sizes) == null ? void 0 : Wb.md.field) ?? {},
  lg: ((zb = Kt.sizes) == null ? void 0 : zb.lg.field) ?? {}
}, eZ = {
  baseStyle: J$,
  sizes: Q$,
  variants: K$,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}, B0 = sr("tooltip-bg"), xm = sr("tooltip-fg"), tZ = sr("popper-arrow-bg"), nZ = {
  bg: B0.reference,
  color: xm.reference,
  [B0.variable]: "colors.gray.700",
  [xm.variable]: "colors.whiteAlpha.900",
  _dark: {
    [B0.variable]: "colors.gray.300",
    [xm.variable]: "colors.gray.900"
  },
  [tZ.variable]: B0.reference,
  px: "2",
  py: "0.5",
  borderRadius: "sm",
  fontWeight: "medium",
  fontSize: "sm",
  boxShadow: "md",
  maxW: "xs",
  zIndex: "tooltip"
}, rZ = {
  baseStyle: nZ
}, oZ = {
  Accordion: ZO,
  Alert: IF,
  Avatar: OF,
  Badge: y1,
  Breadcrumb: UF,
  Button: nB,
  Checkbox: Qi,
  CloseButton: vB,
  Code: SB,
  Container: MB,
  Divider: LB,
  Drawer: BB,
  Editable: zB,
  Form: KB,
  FormError: oH,
  FormLabel: iH,
  Heading: uH,
  Input: Kt,
  Kbd: bH,
  Link: SH,
  List: IH,
  Menu: OH,
  Modal: XH,
  NumberInput: rG,
  PinInput: sG,
  Popover: CG,
  Progress: IG,
  Radio: DG,
  Select: FG,
  Skeleton: HG,
  SkipLink: $G,
  Slider: QG,
  Spinner: n$,
  Stat: c$,
  Switch: y$,
  Table: w$,
  Tabs: $$,
  Tag: q$,
  Textarea: eZ,
  Tooltip: rZ,
  Card: sB,
  Stepper: h$
}, aZ = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid"
}, iZ = {
  base: "0em",
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
}, sZ = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
    400: "#A0AEC0",
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    800: "#1A202C",
    900: "#171923"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#E53E3E",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBC8",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#FAF089",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#2F855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  teal: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044"
  },
  blue: {
    50: "#ebf8ff",
    100: "#bee3f8",
    200: "#90cdf4",
    300: "#63b3ed",
    400: "#4299e1",
    500: "#3182ce",
    600: "#2b6cb0",
    700: "#2c5282",
    800: "#2a4365",
    900: "#1A365D"
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666"
  },
  purple: {
    50: "#FAF5FF",
    100: "#E9D8FD",
    200: "#D6BCFA",
    300: "#B794F4",
    400: "#9F7AEA",
    500: "#805AD5",
    600: "#6B46C1",
    700: "#553C9A",
    800: "#44337A",
    900: "#322659"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  }
}, lZ = {
  none: "0",
  sm: "0.125rem",
  base: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
}, uZ = {
  xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  none: "none",
  "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
}, cZ = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
}, dZ = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, fZ = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
}, hZ = {
  property: cZ,
  easing: dZ,
  duration: fZ
}, pZ = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, mZ = {
  none: 0,
  sm: "4px",
  base: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "40px",
  "3xl": "64px"
}, gZ = {
  breakpoints: iZ,
  zIndices: pZ,
  radii: lZ,
  blur: mZ,
  colors: sZ,
  ...$y,
  sizes: Vy,
  shadows: uZ,
  space: ky,
  borders: aZ,
  transition: hZ
}, vZ = {
  colors: {
    "chakra-body-text": { _light: "gray.800", _dark: "whiteAlpha.900" },
    "chakra-body-bg": { _light: "white", _dark: "gray.800" },
    "chakra-border-color": { _light: "gray.200", _dark: "whiteAlpha.300" },
    "chakra-inverse-text": { _light: "white", _dark: "gray.800" },
    "chakra-subtle-bg": { _light: "gray.100", _dark: "gray.700" },
    "chakra-subtle-text": { _light: "gray.600", _dark: "gray.400" },
    "chakra-placeholder-color": { _light: "gray.500", _dark: "whiteAlpha.400" }
  }
}, CZ = {
  global: {
    body: {
      fontFamily: "body",
      color: "chakra-body-text",
      bg: "chakra-body-bg",
      transitionProperty: "background-color",
      transitionDuration: "normal",
      lineHeight: "base"
    },
    "*::placeholder": {
      color: "chakra-placeholder-color"
    },
    "*, *::before, &::after": {
      borderColor: "chakra-border-color"
    }
  }
}, bZ = [
  "borders",
  "breakpoints",
  "colors",
  "components",
  "config",
  "direction",
  "fonts",
  "fontSizes",
  "fontWeights",
  "letterSpacings",
  "lineHeights",
  "radii",
  "shadows",
  "sizes",
  "space",
  "styles",
  "transition",
  "zIndices"
];
function yZ(e) {
  return ar(e) ? bZ.every(
    (t) => Object.prototype.hasOwnProperty.call(e, t)
  ) : !1;
}
const SZ = "ltr", AZ = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
}, zy = {
  semanticTokens: vZ,
  direction: SZ,
  ...gZ,
  components: oZ,
  styles: CZ,
  config: AZ
}, mg = Uo({});
mg.displayName = "ColorModeContext";
function gg() {
  const e = Zn(mg);
  if (e === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return e;
}
const H0 = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};
function MZ(e = {}) {
  const { preventTransition: t = !0, nonce: n } = e, r = {
    setDataset: (o) => {
      const a = t ? r.preventTransition() : void 0;
      document.documentElement.dataset.theme = o, document.documentElement.style.colorScheme = o, a == null || a();
    },
    setClassName(o) {
      document.body.classList.add(o ? H0.dark : H0.light), document.body.classList.remove(o ? H0.light : H0.dark);
    },
    query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme(o) {
      return r.query().matches ?? o === "dark" ? "dark" : "light";
    },
    addListener(o) {
      const a = r.query(), s = (l) => {
        o(l.matches ? "dark" : "light");
      };
      return typeof a.addListener == "function" ? a.addListener(s) : a.addEventListener("change", s), () => {
        typeof a.removeListener == "function" ? a.removeListener(s) : a.removeEventListener("change", s);
      };
    },
    preventTransition() {
      const o = document.createElement("style");
      return o.appendChild(
        document.createTextNode(
          "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}"
        )
      ), n !== void 0 && (o.nonce = n), document.head.appendChild(o), () => {
        window.getComputedStyle(document.body), requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.head.removeChild(o);
          });
        });
      };
    }
  };
  return r;
}
const xZ = "chakra-ui-color-mode";
function _Z(e) {
  return {
    ssr: !1,
    type: "localStorage",
    get(t) {
      if (!(globalThis != null && globalThis.document))
        return t;
      let n;
      try {
        n = localStorage.getItem(e) || t;
      } catch {
      }
      return n || t;
    },
    set(t) {
      try {
        localStorage.setItem(e, t);
      } catch {
      }
    }
  };
}
const IZ = _Z(xZ), X6 = () => {
}, wZ = bk() ? nc : ft;
function Y6(e, t) {
  return e.type === "cookie" && e.ssr ? e.get(t) : t;
}
const Uy = function(t) {
  const {
    value: n,
    children: r,
    options: {
      useSystemColorMode: o,
      initialColorMode: a,
      disableTransitionOnChange: s
    } = {},
    colorModeManager: l = IZ
  } = t, c = fk(), d = a === "dark" ? "dark" : "light", [f, h] = je(
    () => Y6(l, d)
  ), [m, g] = je(
    () => Y6(l)
  ), { getSystemTheme: b, setClassName: C, setDataset: y, addListener: _ } = Et(
    () => MZ({
      preventTransition: s,
      nonce: c == null ? void 0 : c.nonce
    }),
    [s, c == null ? void 0 : c.nonce]
  ), x = a === "system" && !f ? m : f, I = te(
    (k) => {
      const N = k === "system" ? b() : k;
      h(N), C(N === "dark"), y(N), l.set(N);
    },
    [l, b, C, y]
  );
  wZ(() => {
    a === "system" && g(b());
  }, []), ft(() => {
    const k = l.get();
    if (k) {
      I(k);
      return;
    }
    if (a === "system") {
      I("system");
      return;
    }
    I(d);
  }, [l, d, a, I]);
  const R = te(() => {
    I(x === "dark" ? "light" : "dark");
  }, [x, I]);
  ft(() => {
    if (o)
      return _(I);
  }, [o, _, I]);
  const E = Et(
    () => ({
      colorMode: n ?? x,
      toggleColorMode: n ? X6 : R,
      setColorMode: n ? X6 : I,
      forced: n !== void 0
    }),
    [x, R, I, n]
  );
  return /* @__PURE__ */ A.jsx(mg.Provider, { value: E, children: r });
};
Uy.displayName = "ColorModeProvider";
const Xy = String.raw, Yy = Xy`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`, LZ = () => /* @__PURE__ */ A.jsx(Zf, { styles: Yy }), RZ = ({ scope: e = "" }) => /* @__PURE__ */ A.jsx(
  Zf,
  {
    styles: Xy`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${e} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${e} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${e} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${e} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${e} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${e} :where(b, strong) {
        font-weight: bold;
      }

      ${e} small {
        font-size: 80%;
      }

      ${e} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${e} sub {
        bottom: -0.25em;
      }

      ${e} sup {
        top: -0.5em;
      }

      ${e} img {
        border-style: none;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${e} :where(button, input) {
        overflow: visible;
      }

      ${e} :where(button, select) {
        text-transform: none;
      }

      ${e} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${e} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${e} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${e} progress {
        vertical-align: baseline;
      }

      ${e} textarea {
        overflow: auto;
      }

      ${e} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${e} input[type="number"]::-webkit-inner-spin-button,
      ${e} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${e} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${e} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${e} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${e} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${e} details {
        display: block;
      }

      ${e} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${e} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${e} button {
        background: transparent;
        padding: 0;
      }

      ${e} fieldset {
        margin: 0;
        padding: 0;
      }

      ${e} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${e} textarea {
        resize: vertical;
      }

      ${e} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${e} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${e} table {
        border-collapse: collapse;
      }

      ${e} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${e} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${e} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${e} select::-ms-expand {
        display: none;
      }

      ${Yy}
    `
  }
);
function EZ(e) {
  const { cssVarsRoot: t, theme: n, children: r } = e, o = Et(() => dO(n), [n]);
  return /* @__PURE__ */ A.jsxs(hk, { theme: o, children: [
    /* @__PURE__ */ A.jsx(DZ, { root: t }),
    r
  ] });
}
function DZ({ root: e = ":host, :root" }) {
  const t = [e, "[data-theme]"].join(",");
  return /* @__PURE__ */ A.jsx(Zf, { styles: (n) => ({ [t]: n.__cssVars }) });
}
bn({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function NZ(e) {
  return bn({
    name: `${e}StylesContext`,
    errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${e} />" `
  });
}
function TZ() {
  const { colorMode: e } = gg();
  return /* @__PURE__ */ A.jsx(
    Zf,
    {
      styles: (t) => {
        const n = gy(t, "styles.global"), r = da(n, { theme: t, colorMode: e });
        return r ? Ey(r)(t) : void 0;
      }
    }
  );
}
const [PZ, kZ] = bn({
  strict: !1,
  name: "PortalManagerContext"
});
function qy(e) {
  const { children: t, zIndex: n } = e;
  return /* @__PURE__ */ A.jsx(PZ, { value: { zIndex: n }, children: t });
}
qy.displayName = "PortalManager";
const Jy = Uo({
  getDocument() {
    return document;
  },
  getWindow() {
    return window;
  }
});
Jy.displayName = "EnvironmentContext";
function Ky(e) {
  const { children: t, environment: n, disabled: r } = e, o = He(null), a = Et(() => n || {
    getDocument: () => {
      var l;
      return ((l = o.current) == null ? void 0 : l.ownerDocument) ?? document;
    },
    getWindow: () => {
      var l;
      return ((l = o.current) == null ? void 0 : l.ownerDocument.defaultView) ?? window;
    }
  }, [n]), s = !r || !n;
  return /* @__PURE__ */ A.jsxs(Jy.Provider, { value: a, children: [
    t,
    s && /* @__PURE__ */ A.jsx("span", { id: "__chakra_env", hidden: !0, ref: o })
  ] });
}
Ky.displayName = "EnvironmentProvider";
const VZ = (e) => {
  const {
    children: t,
    colorModeManager: n,
    portalZIndex: r,
    resetScope: o,
    resetCSS: a = !0,
    theme: s = {},
    environment: l,
    cssVarsRoot: c,
    disableEnvironment: d,
    disableGlobalStyle: f
  } = e, h = /* @__PURE__ */ A.jsx(
    Ky,
    {
      environment: l,
      disabled: d,
      children: t
    }
  );
  return /* @__PURE__ */ A.jsx(EZ, { theme: s, cssVarsRoot: c, children: /* @__PURE__ */ A.jsxs(
    Uy,
    {
      colorModeManager: n,
      options: s.config,
      children: [
        a ? /* @__PURE__ */ A.jsx(RZ, { scope: o }) : /* @__PURE__ */ A.jsx(LZ, {}),
        !f && /* @__PURE__ */ A.jsx(TZ, {}),
        r ? /* @__PURE__ */ A.jsx(qy, { zIndex: r, children: h }) : h
      ]
    }
  ) });
}, Qy = Uo({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), qf = Uo({}), nd = Uo(null), Jf = typeof document < "u", vg = Jf ? nc : ft, eS = Uo({ strict: !1 }), Cg = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), OZ = "framerAppearId", tS = "data-" + Cg(OZ);
function FZ(e, t, n, r) {
  const { visualElement: o } = Zn(qf), a = Zn(eS), s = Zn(nd), l = Zn(Qy).reducedMotion, c = He();
  r = r || a.renderer, !c.current && r && (c.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceContext: s,
    blockInitialAnimation: s ? s.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const d = c.current;
  sy(() => {
    d && d.update(n, s);
  });
  const f = He(!!(n[tS] && !window.HandoffComplete));
  return vg(() => {
    d && (d.render(), f.current && d.animationState && d.animationState.animateChanges());
  }), ft(() => {
    d && (d.updateFeatures(), !f.current && d.animationState && d.animationState.animateChanges(), f.current && (f.current = !1, window.HandoffComplete = !0));
  }), d;
}
function Mu(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function BZ(e, t, n) {
  return te(
    (r) => {
      r && e.mount && e.mount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : Mu(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function $1(e) {
  return typeof e == "string" || Array.isArray(e);
}
function Kf(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const bg = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], yg = ["initial", ...bg];
function Qf(e) {
  return Kf(e.animate) || yg.some((t) => $1(e[t]));
}
function nS(e) {
  return !!(Qf(e) || e.variants);
}
function HZ(e, t) {
  if (Qf(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || $1(n) ? n : void 0,
      animate: $1(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function GZ(e) {
  const { initial: t, animate: n } = HZ(e, Zn(qf));
  return Et(() => ({ initial: t, animate: n }), [q6(t), q6(n)]);
}
function q6(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const J6 = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Z1 = {};
for (const e in J6)
  Z1[e] = {
    isEnabled: (t) => J6[e].some((n) => !!t[n])
  };
function $Z(e) {
  for (const t in e)
    Z1[t] = {
      ...Z1[t],
      ...e[t]
    };
}
const Sg = Uo({}), rS = Uo({}), ZZ = Symbol.for("motionComponentSymbol");
function jZ({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: o }) {
  e && $Z(e);
  function a(l, c) {
    let d;
    const f = {
      ...Zn(Qy),
      ...l,
      layoutId: WZ(l)
    }, { isStatic: h } = f, m = GZ(l), g = r(l, h);
    if (!h && Jf) {
      m.visualElement = FZ(o, g, f, t);
      const b = Zn(rS), C = Zn(eS).strict;
      m.visualElement && (d = m.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        f,
        C,
        e,
        b
      ));
    }
    return De.createElement(
      qf.Provider,
      { value: m },
      d && m.visualElement ? De.createElement(d, { visualElement: m.visualElement, ...f }) : null,
      n(o, l, BZ(g, m.visualElement, c), g, h, m.visualElement)
    );
  }
  const s = nt(a);
  return s[ZZ] = o, s;
}
function WZ({ layoutId: e }) {
  const t = Zn(Sg).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function zZ(e) {
  function t(r, o = {}) {
    return jZ(e(r, o));
  }
  if (typeof Proxy > "u")
    return t;
  const n = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, o) => (n.has(o) || n.set(o, t(o)), n.get(o))
  });
}
const UZ = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Ag(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(UZ.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
const G2 = {};
function XZ(e) {
  Object.assign(G2, e);
}
const rd = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Ml = new Set(rd);
function oS(e, { layout: t, layoutId: n }) {
  return Ml.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!G2[e] || e === "opacity");
}
const eo = (e) => !!(e && e.getVelocity), YZ = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, qZ = rd.length;
function JZ(e, { enableHardwareAcceleration: t = !0, allowTransformNone: n = !0 }, r, o) {
  let a = "";
  for (let s = 0; s < qZ; s++) {
    const l = rd[s];
    if (e[l] !== void 0) {
      const c = YZ[l] || l;
      a += `${c}(${e[l]}) `;
    }
  }
  return t && !e.z && (a += "translateZ(0)"), a = a.trim(), o ? a = o(e, r ? "" : a) : n && r && (a = "none"), a;
}
const aS = (e) => (t) => typeof t == "string" && t.startsWith(e), iS = aS("--"), j5 = aS("var(--"), KZ = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g, QZ = (e, t) => t && typeof e == "number" ? t.transform(e) : e, hs = (e, t, n) => Math.min(Math.max(n, e), t), xl = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, x1 = {
  ...xl,
  transform: (e) => hs(0, 1, e)
}, G0 = {
  ...xl,
  default: 1
}, _1 = (e) => Math.round(e * 1e5) / 1e5, eh = /(-)?([\d]*\.?[\d])+/g, sS = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, ej = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function od(e) {
  return typeof e == "string";
}
const ad = (e) => ({
  test: (t) => od(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), Ji = ad("deg"), Ta = ad("%"), ut = ad("px"), tj = ad("vh"), nj = ad("vw"), K6 = {
  ...Ta,
  parse: (e) => Ta.parse(e) / 100,
  transform: (e) => Ta.transform(e * 100)
}, Q6 = {
  ...xl,
  transform: Math.round
}, lS = {
  // Border props
  borderWidth: ut,
  borderTopWidth: ut,
  borderRightWidth: ut,
  borderBottomWidth: ut,
  borderLeftWidth: ut,
  borderRadius: ut,
  radius: ut,
  borderTopLeftRadius: ut,
  borderTopRightRadius: ut,
  borderBottomRightRadius: ut,
  borderBottomLeftRadius: ut,
  // Positioning props
  width: ut,
  maxWidth: ut,
  height: ut,
  maxHeight: ut,
  size: ut,
  top: ut,
  right: ut,
  bottom: ut,
  left: ut,
  // Spacing props
  padding: ut,
  paddingTop: ut,
  paddingRight: ut,
  paddingBottom: ut,
  paddingLeft: ut,
  margin: ut,
  marginTop: ut,
  marginRight: ut,
  marginBottom: ut,
  marginLeft: ut,
  // Transform props
  rotate: Ji,
  rotateX: Ji,
  rotateY: Ji,
  rotateZ: Ji,
  scale: G0,
  scaleX: G0,
  scaleY: G0,
  scaleZ: G0,
  skew: Ji,
  skewX: Ji,
  skewY: Ji,
  distance: ut,
  translateX: ut,
  translateY: ut,
  translateZ: ut,
  x: ut,
  y: ut,
  z: ut,
  perspective: ut,
  transformPerspective: ut,
  opacity: x1,
  originX: K6,
  originY: K6,
  originZ: ut,
  // Misc
  zIndex: Q6,
  // SVG
  fillOpacity: x1,
  strokeOpacity: x1,
  numOctaves: Q6
};
function Mg(e, t, n, r) {
  const { style: o, vars: a, transform: s, transformOrigin: l } = e;
  let c = !1, d = !1, f = !0;
  for (const h in t) {
    const m = t[h];
    if (iS(h)) {
      a[h] = m;
      continue;
    }
    const g = lS[h], b = QZ(m, g);
    if (Ml.has(h)) {
      if (c = !0, s[h] = b, !f)
        continue;
      m !== (g.default || 0) && (f = !1);
    } else
      h.startsWith("origin") ? (d = !0, l[h] = b) : o[h] = b;
  }
  if (t.transform || (c || r ? o.transform = JZ(e.transform, n, f, r) : o.transform && (o.transform = "none")), d) {
    const { originX: h = "50%", originY: m = "50%", originZ: g = 0 } = l;
    o.transformOrigin = `${h} ${m} ${g}`;
  }
}
const xg = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function uS(e, t, n) {
  for (const r in t)
    !eo(t[r]) && !oS(r, n) && (e[r] = t[r]);
}
function rj({ transformTemplate: e }, t, n) {
  return Et(() => {
    const r = xg();
    return Mg(r, t, { enableHardwareAcceleration: !n }, e), Object.assign({}, r.vars, r.style);
  }, [t]);
}
function oj(e, t, n) {
  const r = e.style || {}, o = {};
  return uS(o, r, e), Object.assign(o, rj(e, t, n)), e.transformValues ? e.transformValues(o) : o;
}
function aj(e, t, n) {
  const r = {}, o = oj(e, t, n);
  return e.drag && e.dragListener !== !1 && (r.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (r.tabIndex = 0), r.style = o, r;
}
const ij = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function $2(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || ij.has(e);
}
let cS = (e) => !$2(e);
function sj(e) {
  e && (cS = (t) => t.startsWith("on") ? !$2(t) : e(t));
}
try {
  sj(require("@emotion/is-prop-valid").default);
} catch {
}
function lj(e, t, n) {
  const r = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || (cS(o) || n === !0 && $2(o) || !t && !$2(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (r[o] = e[o]);
  return r;
}
function e8(e, t, n) {
  return typeof e == "string" ? e : ut.transform(t + n * e);
}
function uj(e, t, n) {
  const r = e8(t, e.x, e.width), o = e8(n, e.y, e.height);
  return `${r} ${o}`;
}
const cj = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, dj = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function fj(e, t, n = 1, r = 0, o = !0) {
  e.pathLength = 1;
  const a = o ? cj : dj;
  e[a.offset] = ut.transform(-r);
  const s = ut.transform(t), l = ut.transform(n);
  e[a.array] = `${s} ${l}`;
}
function _g(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: o,
  originY: a,
  pathLength: s,
  pathSpacing: l = 1,
  pathOffset: c = 0,
  // This is object creation, which we try to avoid per-frame.
  ...d
}, f, h, m) {
  if (Mg(e, d, f, m), h) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: g, style: b, dimensions: C } = e;
  g.transform && (C && (b.transform = g.transform), delete g.transform), C && (o !== void 0 || a !== void 0 || b.transform) && (b.transformOrigin = uj(C, o !== void 0 ? o : 0.5, a !== void 0 ? a : 0.5)), t !== void 0 && (g.x = t), n !== void 0 && (g.y = n), r !== void 0 && (g.scale = r), s !== void 0 && fj(g, s, l, c, !1);
}
const dS = () => ({
  ...xg(),
  attrs: {}
}), Ig = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function hj(e, t, n, r) {
  const o = Et(() => {
    const a = dS();
    return _g(a, t, { enableHardwareAcceleration: !1 }, Ig(r), e.transformTemplate), {
      ...a.attrs,
      style: { ...a.style }
    };
  }, [t]);
  if (e.style) {
    const a = {};
    uS(a, e.style, e), o.style = { ...a, ...o.style };
  }
  return o;
}
function pj(e = !1) {
  return (n, r, o, { latestValues: a }, s) => {
    const c = (Ag(n) ? hj : aj)(r, a, s, n), f = {
      ...lj(r, typeof n == "string", e),
      ...c,
      ref: o
    }, { children: h } = r, m = Et(() => eo(h) ? h.get() : h, [h]);
    return ly(n, {
      ...f,
      children: m
    });
  };
}
function fS(e, { style: t, vars: n }, r, o) {
  Object.assign(e.style, t, o && o.getProjectionStyles(r));
  for (const a in n)
    e.style.setProperty(a, n[a]);
}
const hS = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function pS(e, t, n, r) {
  fS(e, t, void 0, r);
  for (const o in t.attrs)
    e.setAttribute(hS.has(o) ? o : Cg(o), t.attrs[o]);
}
function wg(e, t) {
  const { style: n } = e, r = {};
  for (const o in n)
    (eo(n[o]) || t.style && eo(t.style[o]) || oS(o, e)) && (r[o] = n[o]);
  return r;
}
function mS(e, t) {
  const n = wg(e, t);
  for (const r in e)
    if (eo(e[r]) || eo(t[r])) {
      const o = rd.indexOf(r) !== -1 ? "attr" + r.charAt(0).toUpperCase() + r.substring(1) : r;
      n[o] = e[r];
    }
  return n;
}
function Lg(e, t, n, r = {}, o = {}) {
  return typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, r, o)), typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, r, o)), t;
}
function gS(e) {
  const t = He(null);
  return t.current === null && (t.current = e()), t.current;
}
const Z2 = (e) => Array.isArray(e), mj = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), gj = (e) => Z2(e) ? e[e.length - 1] || 0 : e;
function x2(e) {
  const t = eo(e) ? e.get() : e;
  return mj(t) ? t.toValue() : t;
}
function vj({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: n }, r, o, a) {
  const s = {
    latestValues: Cj(r, o, a, e),
    renderState: t()
  };
  return n && (s.mount = (l) => n(r, l, s)), s;
}
const vS = (e) => (t, n) => {
  const r = Zn(qf), o = Zn(nd), a = () => vj(e, t, r, o);
  return n ? a() : gS(a);
};
function Cj(e, t, n, r) {
  const o = {}, a = r(e, {});
  for (const m in a)
    o[m] = x2(a[m]);
  let { initial: s, animate: l } = e;
  const c = Qf(e), d = nS(e);
  t && d && !c && e.inherit !== !1 && (s === void 0 && (s = t.initial), l === void 0 && (l = t.animate));
  let f = n ? n.initial === !1 : !1;
  f = f || s === !1;
  const h = f ? l : s;
  return h && typeof h != "boolean" && !Kf(h) && (Array.isArray(h) ? h : [h]).forEach((g) => {
    const b = Lg(e, g);
    if (!b)
      return;
    const { transitionEnd: C, transition: y, ..._ } = b;
    for (const x in _) {
      let I = _[x];
      if (Array.isArray(I)) {
        const R = f ? I.length - 1 : 0;
        I = I[R];
      }
      I !== null && (o[x] = I);
    }
    for (const x in C)
      o[x] = C[x];
  }), o;
}
const Fn = (e) => e;
class t8 {
  constructor() {
    this.order = [], this.scheduled = /* @__PURE__ */ new Set();
  }
  add(t) {
    if (!this.scheduled.has(t))
      return this.scheduled.add(t), this.order.push(t), !0;
  }
  remove(t) {
    const n = this.order.indexOf(t);
    n !== -1 && (this.order.splice(n, 1), this.scheduled.delete(t));
  }
  clear() {
    this.order.length = 0, this.scheduled.clear();
  }
}
function bj(e) {
  let t = new t8(), n = new t8(), r = 0, o = !1, a = !1;
  const s = /* @__PURE__ */ new WeakSet(), l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, d = !1, f = !1) => {
      const h = f && o, m = h ? t : n;
      return d && s.add(c), m.add(c) && h && o && (r = t.order.length), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      n.remove(c), s.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (o) {
        a = !0;
        return;
      }
      if (o = !0, [t, n] = [n, t], n.clear(), r = t.order.length, r)
        for (let d = 0; d < r; d++) {
          const f = t.order[d];
          f(c), s.has(f) && (l.schedule(f), e());
        }
      o = !1, a && (a = !1, l.process(c));
    }
  };
  return l;
}
const $0 = [
  "prepare",
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], yj = 40;
function Sj(e, t) {
  let n = !1, r = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, a = $0.reduce((h, m) => (h[m] = bj(() => n = !0), h), {}), s = (h) => a[h].process(o), l = () => {
    const h = performance.now();
    n = !1, o.delta = r ? 1e3 / 60 : Math.max(Math.min(h - o.timestamp, yj), 1), o.timestamp = h, o.isProcessing = !0, $0.forEach(s), o.isProcessing = !1, n && t && (r = !1, e(l));
  }, c = () => {
    n = !0, r = !0, o.isProcessing || e(l);
  };
  return { schedule: $0.reduce((h, m) => {
    const g = a[m];
    return h[m] = (b, C = !1, y = !1) => (n || c(), g.schedule(b, C, y)), h;
  }, {}), cancel: (h) => $0.forEach((m) => a[m].cancel(h)), state: o, steps: a };
}
const { schedule: vn, cancel: yi, state: Mr, steps: _m } = Sj(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Fn, !0), Aj = {
  useVisualState: vS({
    scrapeMotionValuesFromProps: mS,
    createRenderState: dS,
    onMount: (e, t, { renderState: n, latestValues: r }) => {
      vn.read(() => {
        try {
          n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), vn.render(() => {
        _g(n, r, { enableHardwareAcceleration: !1 }, Ig(t.tagName), e.transformTemplate), pS(t, n);
      });
    }
  })
}, Mj = {
  useVisualState: vS({
    scrapeMotionValuesFromProps: wg,
    createRenderState: xg
  })
};
function xj(e, { forwardMotionProps: t = !1 }, n, r) {
  return {
    ...Ag(e) ? Aj : Mj,
    preloadedFeatures: n,
    useRender: pj(t),
    createVisualElement: r,
    Component: e
  };
}
function ci(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
const CS = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function th(e, t = "page") {
  return {
    point: {
      x: e[t + "X"],
      y: e[t + "Y"]
    }
  };
}
const _j = (e) => (t) => CS(t) && e(t, th(t));
function hi(e, t, n, r) {
  return ci(e, t, _j(n), r);
}
const Ij = (e, t) => (n) => t(e(n)), us = (...e) => e.reduce(Ij);
function bS(e) {
  let t = null;
  return () => {
    const n = () => {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
const n8 = bS("dragHorizontal"), r8 = bS("dragVertical");
function yS(e) {
  let t = !1;
  if (e === "y")
    t = r8();
  else if (e === "x")
    t = n8();
  else {
    const n = n8(), r = r8();
    n && r ? t = () => {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function SS() {
  const e = yS(!0);
  return e ? (e(), !1) : !0;
}
class ys {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function o8(e, t) {
  const n = "pointer" + (t ? "enter" : "leave"), r = "onHover" + (t ? "Start" : "End"), o = (a, s) => {
    if (a.pointerType === "touch" || SS())
      return;
    const l = e.getProps();
    e.animationState && l.whileHover && e.animationState.setActive("whileHover", t), l[r] && vn.update(() => l[r](a, s));
  };
  return hi(e.current, n, o, {
    passive: !e.getProps()[r]
  });
}
class wj extends ys {
  mount() {
    this.unmount = us(o8(this.node, !0), o8(this.node, !1));
  }
  unmount() {
  }
}
class Lj extends ys {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = us(ci(this.node.current, "focus", () => this.onFocus()), ci(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const AS = (e, t) => t ? e === t ? !0 : AS(e, t.parentElement) : !1;
function Im(e, t) {
  if (!t)
    return;
  const n = new PointerEvent("pointer" + e);
  t(n, th(n));
}
class Rj extends ys {
  constructor() {
    super(...arguments), this.removeStartListeners = Fn, this.removeEndListeners = Fn, this.removeAccessibleListeners = Fn, this.startPointerPress = (t, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const r = this.node.getProps(), a = hi(window, "pointerup", (l, c) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: d, onTapCancel: f, globalTapTarget: h } = this.node.getProps();
        vn.update(() => {
          !h && !AS(this.node.current, l.target) ? f && f(l, c) : d && d(l, c);
        });
      }, { passive: !(r.onTap || r.onPointerUp) }), s = hi(window, "pointercancel", (l, c) => this.cancelPress(l, c), { passive: !(r.onTapCancel || r.onPointerCancel) });
      this.removeEndListeners = us(a, s), this.startPress(t, n);
    }, this.startAccessiblePress = () => {
      const t = (a) => {
        if (a.key !== "Enter" || this.isPressing)
          return;
        const s = (l) => {
          l.key !== "Enter" || !this.checkPressEnd() || Im("up", (c, d) => {
            const { onTap: f } = this.node.getProps();
            f && vn.update(() => f(c, d));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = ci(this.node.current, "keyup", s), Im("down", (l, c) => {
          this.startPress(l, c);
        });
      }, n = ci(this.node.current, "keydown", t), r = () => {
        this.isPressing && Im("cancel", (a, s) => this.cancelPress(a, s));
      }, o = ci(this.node.current, "blur", r);
      this.removeAccessibleListeners = us(n, o);
    };
  }
  startPress(t, n) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: o } = this.node.getProps();
    o && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && vn.update(() => r(t, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !SS();
  }
  cancelPress(t, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && vn.update(() => r(t, n));
  }
  mount() {
    const t = this.node.getProps(), n = hi(t.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, { passive: !(t.onTapStart || t.onPointerStart) }), r = ci(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = us(n, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const W5 = /* @__PURE__ */ new WeakMap(), wm = /* @__PURE__ */ new WeakMap(), Ej = (e) => {
  const t = W5.get(e.target);
  t && t(e);
}, Dj = (e) => {
  e.forEach(Ej);
};
function Nj({ root: e, ...t }) {
  const n = e || document;
  wm.has(n) || wm.set(n, {});
  const r = wm.get(n), o = JSON.stringify(t);
  return r[o] || (r[o] = new IntersectionObserver(Dj, { root: e, ...t })), r[o];
}
function Tj(e, t, n) {
  const r = Nj(t);
  return W5.set(e, n), r.observe(e), () => {
    W5.delete(e), r.unobserve(e);
  };
}
const Pj = {
  some: 0,
  all: 1
};
class kj extends ys {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: o = "some", once: a } = t, s = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : Pj[o]
    }, l = (c) => {
      const { isIntersecting: d } = c;
      if (this.isInView === d || (this.isInView = d, a && !d && this.hasEnteredView))
        return;
      d && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", d);
      const { onViewportEnter: f, onViewportLeave: h } = this.node.getProps(), m = d ? f : h;
      m && m(c);
    };
    return Tj(this.node.current, s, l);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(Vj(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function Vj({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const Oj = {
  inView: {
    Feature: kj
  },
  tap: {
    Feature: Rj
  },
  focus: {
    Feature: Lj
  },
  hover: {
    Feature: wj
  }
};
function MS(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function Fj(e) {
  const t = {};
  return e.values.forEach((n, r) => t[r] = n.get()), t;
}
function Bj(e) {
  const t = {};
  return e.values.forEach((n, r) => t[r] = n.getVelocity()), t;
}
function nh(e, t, n) {
  const r = e.getProps();
  return Lg(r, t, n !== void 0 ? n : r.custom, Fj(e), Bj(e));
}
let id = Fn, $o = Fn;
process.env.NODE_ENV !== "production" && (id = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, $o = (e, t) => {
  if (!e)
    throw new Error(t);
});
const cs = (e) => e * 1e3, pi = (e) => e / 1e3, Hj = {
  current: !1
}, xS = (e) => Array.isArray(e) && typeof e[0] == "number";
function _S(e) {
  return !!(!e || typeof e == "string" && IS[e] || xS(e) || Array.isArray(e) && e.every(_S));
}
const u1 = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, IS = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: u1([0, 0.65, 0.55, 1]),
  circOut: u1([0.55, 0, 1, 0.45]),
  backIn: u1([0.31, 0.01, 0.66, -0.59]),
  backOut: u1([0.33, 1.53, 0.69, 0.99])
};
function wS(e) {
  if (e)
    return xS(e) ? u1(e) : Array.isArray(e) ? e.map(wS) : IS[e];
}
function Gj(e, t, n, { delay: r = 0, duration: o, repeat: a = 0, repeatType: s = "loop", ease: l, times: c } = {}) {
  const d = { [t]: n };
  c && (d.offset = c);
  const f = wS(l);
  return Array.isArray(f) && (d.easing = f), e.animate(d, {
    delay: r,
    duration: o,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: a + 1,
    direction: s === "reverse" ? "alternate" : "normal"
  });
}
function $j(e, { repeat: t, repeatType: n = "loop" }) {
  const r = t && n !== "loop" && t % 2 === 1 ? 0 : e.length - 1;
  return e[r];
}
const LS = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, Zj = 1e-7, jj = 12;
function Wj(e, t, n, r, o) {
  let a, s, l = 0;
  do
    s = t + (n - t) / 2, a = LS(s, r, o) - e, a > 0 ? n = s : t = s;
  while (Math.abs(a) > Zj && ++l < jj);
  return s;
}
function sd(e, t, n, r) {
  if (e === t && n === r)
    return Fn;
  const o = (a) => Wj(a, 0, 1, e, n);
  return (a) => a === 0 || a === 1 ? a : LS(o(a), t, r);
}
const zj = sd(0.42, 0, 1, 1), Uj = sd(0, 0, 0.58, 1), RS = sd(0.42, 0, 0.58, 1), Xj = (e) => Array.isArray(e) && typeof e[0] != "number", ES = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, DS = (e) => (t) => 1 - e(1 - t), Rg = (e) => 1 - Math.sin(Math.acos(e)), NS = DS(Rg), Yj = ES(Rg), TS = sd(0.33, 1.53, 0.69, 0.99), Eg = DS(TS), qj = ES(Eg), Jj = (e) => (e *= 2) < 1 ? 0.5 * Eg(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), a8 = {
  linear: Fn,
  easeIn: zj,
  easeInOut: RS,
  easeOut: Uj,
  circIn: Rg,
  circInOut: Yj,
  circOut: NS,
  backIn: Eg,
  backInOut: qj,
  backOut: TS,
  anticipate: Jj
}, i8 = (e) => {
  if (Array.isArray(e)) {
    $o(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, o] = e;
    return sd(t, n, r, o);
  } else if (typeof e == "string")
    return $o(a8[e] !== void 0, `Invalid easing type '${e}'`), a8[e];
  return e;
}, Dg = (e, t) => (n) => !!(od(n) && ej.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t)), PS = (e, t, n) => (r) => {
  if (!od(r))
    return r;
  const [o, a, s, l] = r.match(eh);
  return {
    [e]: parseFloat(o),
    [t]: parseFloat(a),
    [n]: parseFloat(s),
    alpha: l !== void 0 ? parseFloat(l) : 1
  };
}, Kj = (e) => hs(0, 255, e), Lm = {
  ...xl,
  transform: (e) => Math.round(Kj(e))
}, Qs = {
  test: Dg("rgb", "red"),
  parse: PS("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Lm.transform(e) + ", " + Lm.transform(t) + ", " + Lm.transform(n) + ", " + _1(x1.transform(r)) + ")"
};
function Qj(e) {
  let t = "", n = "", r = "", o = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), o = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), o = e.substring(4, 5), t += t, n += n, r += r, o += o), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const z5 = {
  test: Dg("#"),
  parse: Qj,
  transform: Qs.transform
}, xu = {
  test: Dg("hsl", "hue"),
  parse: PS("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Ta.transform(_1(t)) + ", " + Ta.transform(_1(n)) + ", " + _1(x1.transform(r)) + ")"
}, Tr = {
  test: (e) => Qs.test(e) || z5.test(e) || xu.test(e),
  parse: (e) => Qs.test(e) ? Qs.parse(e) : xu.test(e) ? xu.parse(e) : z5.parse(e),
  transform: (e) => od(e) ? e : e.hasOwnProperty("red") ? Qs.transform(e) : xu.transform(e)
}, Dn = (e, t, n) => -n * e + n * t + e;
function Rm(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function eW({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let o = 0, a = 0, s = 0;
  if (!t)
    o = a = s = n;
  else {
    const l = n < 0.5 ? n * (1 + t) : n + t - n * t, c = 2 * n - l;
    o = Rm(c, l, e + 1 / 3), a = Rm(c, l, e), s = Rm(c, l, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(a * 255),
    blue: Math.round(s * 255),
    alpha: r
  };
}
const Em = (e, t, n) => {
  const r = e * e;
  return Math.sqrt(Math.max(0, n * (t * t - r) + r));
}, tW = [z5, Qs, xu], nW = (e) => tW.find((t) => t.test(e));
function s8(e) {
  const t = nW(e);
  $o(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`);
  let n = t.parse(e);
  return t === xu && (n = eW(n)), n;
}
const kS = (e, t) => {
  const n = s8(e), r = s8(t), o = { ...n };
  return (a) => (o.red = Em(n.red, r.red, a), o.green = Em(n.green, r.green, a), o.blue = Em(n.blue, r.blue, a), o.alpha = Dn(n.alpha, r.alpha, a), Qs.transform(o));
};
function rW(e) {
  var t, n;
  return isNaN(e) && od(e) && (((t = e.match(eh)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(sS)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const VS = {
  regex: KZ,
  countKey: "Vars",
  token: "${v}",
  parse: Fn
}, OS = {
  regex: sS,
  countKey: "Colors",
  token: "${c}",
  parse: Tr.parse
}, FS = {
  regex: eh,
  countKey: "Numbers",
  token: "${n}",
  parse: xl.parse
};
function Dm(e, { regex: t, countKey: n, token: r, parse: o }) {
  const a = e.tokenised.match(t);
  a && (e["num" + n] = a.length, e.tokenised = e.tokenised.replace(t, r), e.values.push(...a.map(o)));
}
function j2(e) {
  const t = e.toString(), n = {
    value: t,
    tokenised: t,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  return n.value.includes("var(--") && Dm(n, VS), Dm(n, OS), Dm(n, FS), n;
}
function BS(e) {
  return j2(e).values;
}
function HS(e) {
  const { values: t, numColors: n, numVars: r, tokenised: o } = j2(e), a = t.length;
  return (s) => {
    let l = o;
    for (let c = 0; c < a; c++)
      c < r ? l = l.replace(VS.token, s[c]) : c < r + n ? l = l.replace(OS.token, Tr.transform(s[c])) : l = l.replace(FS.token, _1(s[c]));
    return l;
  };
}
const oW = (e) => typeof e == "number" ? 0 : e;
function aW(e) {
  const t = BS(e);
  return HS(e)(t.map(oW));
}
const ps = {
  test: rW,
  parse: BS,
  createTransformer: HS,
  getAnimatableNone: aW
}, GS = (e, t) => (n) => `${n > 0 ? t : e}`;
function $S(e, t) {
  return typeof e == "number" ? (n) => Dn(e, t, n) : Tr.test(e) ? kS(e, t) : e.startsWith("var(") ? GS(e, t) : jS(e, t);
}
const ZS = (e, t) => {
  const n = [...e], r = n.length, o = e.map((a, s) => $S(a, t[s]));
  return (a) => {
    for (let s = 0; s < r; s++)
      n[s] = o[s](a);
    return n;
  };
}, iW = (e, t) => {
  const n = { ...e, ...t }, r = {};
  for (const o in n)
    e[o] !== void 0 && t[o] !== void 0 && (r[o] = $S(e[o], t[o]));
  return (o) => {
    for (const a in r)
      n[a] = r[a](o);
    return n;
  };
}, jS = (e, t) => {
  const n = ps.createTransformer(t), r = j2(e), o = j2(t);
  return r.numVars === o.numVars && r.numColors === o.numColors && r.numNumbers >= o.numNumbers ? us(ZS(r.values, o.values), n) : (id(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), GS(e, t));
}, j1 = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, l8 = (e, t) => (n) => Dn(e, t, n);
function sW(e) {
  return typeof e == "number" ? l8 : typeof e == "string" ? Tr.test(e) ? kS : jS : Array.isArray(e) ? ZS : typeof e == "object" ? iW : l8;
}
function lW(e, t, n) {
  const r = [], o = n || sW(e[0]), a = e.length - 1;
  for (let s = 0; s < a; s++) {
    let l = o(e[s], e[s + 1]);
    if (t) {
      const c = Array.isArray(t) ? t[s] || Fn : t;
      l = us(c, l);
    }
    r.push(l);
  }
  return r;
}
function WS(e, t, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const a = e.length;
  if ($o(a === t.length, "Both input and output ranges must be the same length"), a === 1)
    return () => t[0];
  e[0] > e[a - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const s = lW(t, r, o), l = s.length, c = (d) => {
    let f = 0;
    if (l > 1)
      for (; f < e.length - 2 && !(d < e[f + 1]); f++)
        ;
    const h = j1(e[f], e[f + 1], d);
    return s[f](h);
  };
  return n ? (d) => c(hs(e[0], e[a - 1], d)) : c;
}
function uW(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const o = j1(0, t, r);
    e.push(Dn(n, 1, o));
  }
}
function cW(e) {
  const t = [0];
  return uW(t, e.length - 1), t;
}
function dW(e, t) {
  return e.map((n) => n * t);
}
function fW(e, t) {
  return e.map(() => t || RS).splice(0, e.length - 1);
}
function W2({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const o = Xj(r) ? r.map(i8) : i8(r), a = {
    done: !1,
    value: t[0]
  }, s = dW(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : cW(t),
    e
  ), l = WS(s, t, {
    ease: Array.isArray(o) ? o : fW(t, o)
  });
  return {
    calculatedDuration: e,
    next: (c) => (a.value = l(c), a.done = c >= e, a)
  };
}
function zS(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const hW = 5;
function US(e, t, n) {
  const r = Math.max(t - hW, 0);
  return zS(n - e(r), t - r);
}
const Nm = 1e-3, pW = 0.01, u8 = 10, mW = 0.05, gW = 1;
function vW({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let o, a;
  id(e <= cs(u8), "Spring duration must be 10 seconds or less");
  let s = 1 - t;
  s = hs(mW, gW, s), e = hs(pW, u8, pi(e)), s < 1 ? (o = (d) => {
    const f = d * s, h = f * e, m = f - n, g = U5(d, s), b = Math.exp(-h);
    return Nm - m / g * b;
  }, a = (d) => {
    const h = d * s * e, m = h * n + n, g = Math.pow(s, 2) * Math.pow(d, 2) * e, b = Math.exp(-h), C = U5(Math.pow(d, 2), s);
    return (-o(d) + Nm > 0 ? -1 : 1) * ((m - g) * b) / C;
  }) : (o = (d) => {
    const f = Math.exp(-d * e), h = (d - n) * e + 1;
    return -Nm + f * h;
  }, a = (d) => {
    const f = Math.exp(-d * e), h = (n - d) * (e * e);
    return f * h;
  });
  const l = 5 / e, c = bW(o, a, l);
  if (e = cs(e), isNaN(c))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const d = Math.pow(c, 2) * r;
    return {
      stiffness: d,
      damping: s * 2 * Math.sqrt(r * d),
      duration: e
    };
  }
}
const CW = 12;
function bW(e, t, n) {
  let r = n;
  for (let o = 1; o < CW; o++)
    r = r - e(r) / t(r);
  return r;
}
function U5(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const yW = ["duration", "bounce"], SW = ["stiffness", "damping", "mass"];
function c8(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function AW(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!c8(e, SW) && c8(e, yW)) {
    const n = vW(e);
    t = {
      ...t,
      ...n,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function XS({ keyframes: e, restDelta: t, restSpeed: n, ...r }) {
  const o = e[0], a = e[e.length - 1], s = { done: !1, value: o }, { stiffness: l, damping: c, mass: d, duration: f, velocity: h, isResolvedFromDuration: m } = AW({
    ...r,
    velocity: -pi(r.velocity || 0)
  }), g = h || 0, b = c / (2 * Math.sqrt(l * d)), C = a - o, y = pi(Math.sqrt(l / d)), _ = Math.abs(C) < 5;
  n || (n = _ ? 0.01 : 2), t || (t = _ ? 5e-3 : 0.5);
  let x;
  if (b < 1) {
    const I = U5(y, b);
    x = (R) => {
      const E = Math.exp(-b * y * R);
      return a - E * ((g + b * y * C) / I * Math.sin(I * R) + C * Math.cos(I * R));
    };
  } else if (b === 1)
    x = (I) => a - Math.exp(-y * I) * (C + (g + y * C) * I);
  else {
    const I = y * Math.sqrt(b * b - 1);
    x = (R) => {
      const E = Math.exp(-b * y * R), k = Math.min(I * R, 300);
      return a - E * ((g + b * y * C) * Math.sinh(k) + I * C * Math.cosh(k)) / I;
    };
  }
  return {
    calculatedDuration: m && f || null,
    next: (I) => {
      const R = x(I);
      if (m)
        s.done = I >= f;
      else {
        let E = g;
        I !== 0 && (b < 1 ? E = US(x, I, R) : E = 0);
        const k = Math.abs(E) <= n, N = Math.abs(a - R) <= t;
        s.done = k && N;
      }
      return s.value = s.done ? a : R, s;
    }
  };
}
function d8({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: a = 500, modifyTarget: s, min: l, max: c, restDelta: d = 0.5, restSpeed: f }) {
  const h = e[0], m = {
    done: !1,
    value: h
  }, g = (P) => l !== void 0 && P < l || c !== void 0 && P > c, b = (P) => l === void 0 ? c : c === void 0 || Math.abs(l - P) < Math.abs(c - P) ? l : c;
  let C = n * t;
  const y = h + C, _ = s === void 0 ? y : s(y);
  _ !== y && (C = _ - h);
  const x = (P) => -C * Math.exp(-P / r), I = (P) => _ + x(P), R = (P) => {
    const F = x(P), G = I(P);
    m.done = Math.abs(F) <= d, m.value = m.done ? _ : G;
  };
  let E, k;
  const N = (P) => {
    g(m.value) && (E = P, k = XS({
      keyframes: [m.value, b(m.value)],
      velocity: US(I, P, m.value),
      damping: o,
      stiffness: a,
      restDelta: d,
      restSpeed: f
    }));
  };
  return N(0), {
    calculatedDuration: null,
    next: (P) => {
      let F = !1;
      return !k && E === void 0 && (F = !0, R(P), N(P)), E !== void 0 && P > E ? k.next(P - E) : (!F && R(P), m);
    }
  };
}
const MW = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => vn.update(t, !0),
    stop: () => yi(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Mr.isProcessing ? Mr.timestamp : performance.now()
  };
}, f8 = 2e4;
function h8(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < f8; )
    t += n, r = e.next(t);
  return t >= f8 ? 1 / 0 : t;
}
const xW = {
  decay: d8,
  inertia: d8,
  tween: W2,
  keyframes: W2,
  spring: XS
};
function z2({ autoplay: e = !0, delay: t = 0, driver: n = MW, keyframes: r, type: o = "keyframes", repeat: a = 0, repeatDelay: s = 0, repeatType: l = "loop", onPlay: c, onStop: d, onComplete: f, onUpdate: h, ...m }) {
  let g = 1, b = !1, C, y;
  const _ = () => {
    y = new Promise((J) => {
      C = J;
    });
  };
  _();
  let x;
  const I = xW[o] || W2;
  let R;
  I !== W2 && typeof r[0] != "number" && (process.env.NODE_ENV !== "production" && $o(r.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${r}`), R = WS([0, 100], r, {
    clamp: !1
  }), r = [0, 100]);
  const E = I({ ...m, keyframes: r });
  let k;
  l === "mirror" && (k = I({
    ...m,
    keyframes: [...r].reverse(),
    velocity: -(m.velocity || 0)
  }));
  let N = "idle", P = null, F = null, G = null;
  E.calculatedDuration === null && a && (E.calculatedDuration = h8(E));
  const { calculatedDuration: j } = E;
  let ae = 1 / 0, ue = 1 / 0;
  j !== null && (ae = j + s, ue = ae * (a + 1) - s);
  let le = 0;
  const _e = (J) => {
    if (F === null)
      return;
    g > 0 && (F = Math.min(F, J)), g < 0 && (F = Math.min(J - ue / g, F)), P !== null ? le = P : le = Math.round(J - F) * g;
    const ge = le - t * (g >= 0 ? 1 : -1), X = g >= 0 ? ge < 0 : ge > ue;
    le = Math.max(ge, 0), N === "finished" && P === null && (le = ue);
    let pe = le, fe = E;
    if (a) {
      const Pe = Math.min(le, ue) / ae;
      let Se = Math.floor(Pe), Fe = Pe % 1;
      !Fe && Pe >= 1 && (Fe = 1), Fe === 1 && Se--, Se = Math.min(Se, a + 1), !!(Se % 2) && (l === "reverse" ? (Fe = 1 - Fe, s && (Fe -= s / ae)) : l === "mirror" && (fe = k)), pe = hs(0, 1, Fe) * ae;
    }
    const de = X ? { done: !1, value: r[0] } : fe.next(pe);
    R && (de.value = R(de.value));
    let { done: we } = de;
    !X && j !== null && (we = g >= 0 ? le >= ue : le <= 0);
    const Ie = P === null && (N === "finished" || N === "running" && we);
    return h && h(de.value), Ie && K(), de;
  }, ve = () => {
    x && x.stop(), x = void 0;
  }, z = () => {
    N = "idle", ve(), C(), _(), F = G = null;
  }, K = () => {
    N = "finished", f && f(), ve(), C();
  }, Ce = () => {
    if (b)
      return;
    x || (x = n(_e));
    const J = x.now();
    c && c(), P !== null ? F = J - P : (!F || N === "finished") && (F = J), N === "finished" && _(), G = F, P = null, N = "running", x.start();
  };
  e && Ce();
  const q = {
    then(J, ge) {
      return y.then(J, ge);
    },
    get time() {
      return pi(le);
    },
    set time(J) {
      J = cs(J), le = J, P !== null || !x || g === 0 ? P = J : F = x.now() - J / g;
    },
    get duration() {
      const J = E.calculatedDuration === null ? h8(E) : E.calculatedDuration;
      return pi(J);
    },
    get speed() {
      return g;
    },
    set speed(J) {
      J === g || !x || (g = J, q.time = pi(le));
    },
    get state() {
      return N;
    },
    play: Ce,
    pause: () => {
      N = "paused", P = le;
    },
    stop: () => {
      b = !0, N !== "idle" && (N = "idle", d && d(), z());
    },
    cancel: () => {
      G !== null && _e(G), z();
    },
    complete: () => {
      N = "finished";
    },
    sample: (J) => (F = 0, _e(J))
  };
  return q;
}
function _W(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const IW = _W(() => Object.hasOwnProperty.call(Element.prototype, "animate")), wW = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), Z0 = 10, LW = 2e4, RW = (e, t) => t.type === "spring" || e === "backgroundColor" || !_S(t.ease);
function EW(e, t, { onUpdate: n, onComplete: r, ...o }) {
  if (!(IW() && wW.has(t) && !o.repeatDelay && o.repeatType !== "mirror" && o.damping !== 0 && o.type !== "inertia"))
    return !1;
  let s = !1, l, c, d = !1;
  const f = () => {
    c = new Promise((I) => {
      l = I;
    });
  };
  f();
  let { keyframes: h, duration: m = 300, ease: g, times: b } = o;
  if (RW(t, o)) {
    const I = z2({
      ...o,
      repeat: 0,
      delay: 0
    });
    let R = { done: !1, value: h[0] };
    const E = [];
    let k = 0;
    for (; !R.done && k < LW; )
      R = I.sample(k), E.push(R.value), k += Z0;
    b = void 0, h = E, m = k - Z0, g = "linear";
  }
  const C = Gj(e.owner.current, t, h, {
    ...o,
    duration: m,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: g,
    times: b
  }), y = () => {
    d = !1, C.cancel();
  }, _ = () => {
    d = !0, vn.update(y), l(), f();
  };
  return C.onfinish = () => {
    d || (e.set($j(h, o)), r && r(), _());
  }, {
    then(I, R) {
      return c.then(I, R);
    },
    attachTimeline(I) {
      return C.timeline = I, C.onfinish = null, Fn;
    },
    get time() {
      return pi(C.currentTime || 0);
    },
    set time(I) {
      C.currentTime = cs(I);
    },
    get speed() {
      return C.playbackRate;
    },
    set speed(I) {
      C.playbackRate = I;
    },
    get duration() {
      return pi(m);
    },
    play: () => {
      s || (C.play(), yi(y));
    },
    pause: () => C.pause(),
    stop: () => {
      if (s = !0, C.playState === "idle")
        return;
      const { currentTime: I } = C;
      if (I) {
        const R = z2({
          ...o,
          autoplay: !1
        });
        e.setWithVelocity(R.sample(I - Z0).value, R.sample(I).value, Z0);
      }
      _();
    },
    complete: () => {
      d || C.finish();
    },
    cancel: _
  };
}
function DW({ keyframes: e, delay: t, onUpdate: n, onComplete: r }) {
  const o = () => (n && n(e[e.length - 1]), r && r(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: Fn,
    pause: Fn,
    stop: Fn,
    then: (a) => (a(), Promise.resolve()),
    cancel: Fn,
    complete: Fn
  });
  return t ? z2({
    keyframes: [0, 1],
    duration: 0,
    delay: t,
    onComplete: o
  }) : o();
}
const NW = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, TW = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), PW = {
  type: "keyframes",
  duration: 0.8
}, kW = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, VW = (e, { keyframes: t }) => t.length > 2 ? PW : Ml.has(e) ? e.startsWith("scale") ? TW(t[1]) : NW : kW, X5 = (e, t) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(ps.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url(")), OW = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function FW(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(eh) || [];
  if (!r)
    return e;
  const o = n.replace(r, "");
  let a = OW.has(t) ? 1 : 0;
  return r !== n && (a *= 100), t + "(" + a + o + ")";
}
const BW = /([a-z-]*)\(.*?\)/g, Y5 = {
  ...ps,
  getAnimatableNone: (e) => {
    const t = e.match(BW);
    return t ? t.map(FW).join(" ") : e;
  }
}, HW = {
  ...lS,
  // Color props
  color: Tr,
  backgroundColor: Tr,
  outlineColor: Tr,
  fill: Tr,
  stroke: Tr,
  // Border props
  borderColor: Tr,
  borderTopColor: Tr,
  borderRightColor: Tr,
  borderBottomColor: Tr,
  borderLeftColor: Tr,
  filter: Y5,
  WebkitFilter: Y5
}, Ng = (e) => HW[e];
function YS(e, t) {
  let n = Ng(e);
  return n !== Y5 && (n = ps), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const qS = (e) => /^0[^.\s]+$/.test(e);
function GW(e) {
  if (typeof e == "number")
    return e === 0;
  if (e !== null)
    return e === "none" || e === "0" || qS(e);
}
function $W(e, t, n, r) {
  const o = X5(t, n);
  let a;
  Array.isArray(n) ? a = [...n] : a = [null, n];
  const s = r.from !== void 0 ? r.from : e.get();
  let l;
  const c = [];
  for (let d = 0; d < a.length; d++)
    a[d] === null && (a[d] = d === 0 ? s : a[d - 1]), GW(a[d]) && c.push(d), typeof a[d] == "string" && a[d] !== "none" && a[d] !== "0" && (l = a[d]);
  if (o && c.length && l)
    for (let d = 0; d < c.length; d++) {
      const f = c[d];
      a[f] = YS(t, l);
    }
  return a;
}
function ZW({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: o, repeat: a, repeatType: s, repeatDelay: l, from: c, elapsed: d, ...f }) {
  return !!Object.keys(f).length;
}
function Tg(e, t) {
  return e[t] || e.default || e;
}
const jW = {
  skipAnimations: !1
}, Pg = (e, t, n, r = {}) => (o) => {
  const a = Tg(r, e) || {}, s = a.delay || r.delay || 0;
  let { elapsed: l = 0 } = r;
  l = l - cs(s);
  const c = $W(t, e, n, a), d = c[0], f = c[c.length - 1], h = X5(e, d), m = X5(e, f);
  id(h === m, `You are trying to animate ${e} from "${d}" to "${f}". ${d} is not an animatable value - to enable this animation set ${d} to a value animatable to ${f} via the \`style\` property.`);
  let g = {
    keyframes: c,
    velocity: t.getVelocity(),
    ease: "easeOut",
    ...a,
    delay: -l,
    onUpdate: (b) => {
      t.set(b), a.onUpdate && a.onUpdate(b);
    },
    onComplete: () => {
      o(), a.onComplete && a.onComplete();
    }
  };
  if (ZW(a) || (g = {
    ...g,
    ...VW(e, g)
  }), g.duration && (g.duration = cs(g.duration)), g.repeatDelay && (g.repeatDelay = cs(g.repeatDelay)), !h || !m || Hj.current || a.type === !1 || jW.skipAnimations)
    return DW(g);
  if (
    /**
     * If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    !r.isHandoff && t.owner && t.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !t.owner.getProps().onUpdate
  ) {
    const b = EW(t, e, g);
    if (b)
      return b;
  }
  return z2(g);
};
function U2(e) {
  return !!(eo(e) && e.add);
}
const JS = (e) => /^\-?\d*\.?\d+$/.test(e);
function kg(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Vg(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class Og {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return kg(this.subscriptions, t), () => Vg(this.subscriptions, t);
  }
  notify(t, n, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let a = 0; a < o; a++) {
          const s = this.subscriptions[a];
          s && s(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const p8 = /* @__PURE__ */ new Set();
function Fg(e, t, n) {
  e || p8.has(t) || (console.warn(t), n && console.warn(n), p8.add(t));
}
const WW = (e) => !isNaN(parseFloat(e));
class zW {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "10.18.0", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (r, o = !0) => {
      this.prev = this.current, this.current = r;
      const { delta: a, timestamp: s } = Mr;
      this.lastUpdated !== s && (this.timeDelta = a, this.lastUpdated = s, vn.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), o && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => vn.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: r }) => {
      r !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = WW(this.current), this.owner = n.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && Fg(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new Og());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), vn.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = t, this.timeDelta = r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t) {
    this.updateAndNotify(t), this.prev = t, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      zS(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Hu(e, t) {
  return new zW(e, t);
}
const KS = (e) => (t) => t.test(e), UW = {
  test: (e) => e === "auto",
  parse: (e) => e
}, QS = [xl, ut, Ta, Ji, nj, tj, UW], Wc = (e) => QS.find(KS(e)), XW = [...QS, Tr, ps], YW = (e) => XW.find(KS(e));
function qW(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Hu(n));
}
function JW(e, t) {
  const n = nh(e, t);
  let { transitionEnd: r = {}, transition: o = {}, ...a } = n ? e.makeTargetAnimatable(n, !1) : {};
  a = { ...a, ...r };
  for (const s in a) {
    const l = gj(a[s]);
    qW(e, s, l);
  }
}
function KW(e, t, n) {
  var r, o;
  const a = Object.keys(t).filter((l) => !e.hasValue(l)), s = a.length;
  if (s)
    for (let l = 0; l < s; l++) {
      const c = a[l], d = t[c];
      let f = null;
      Array.isArray(d) && (f = d[0]), f === null && (f = (o = (r = n[c]) !== null && r !== void 0 ? r : e.readValue(c)) !== null && o !== void 0 ? o : t[c]), f != null && (typeof f == "string" && (JS(f) || qS(f)) ? f = parseFloat(f) : !YW(f) && ps.test(d) && (f = YS(c, d)), e.addValue(c, Hu(f, { owner: e })), n[c] === void 0 && (n[c] = f), f !== null && e.setBaseTarget(c, f));
    }
}
function QW(e, t) {
  return t ? (t[e] || t.default || t).from : void 0;
}
function ez(e, t, n) {
  const r = {};
  for (const o in e) {
    const a = QW(o, t);
    if (a !== void 0)
      r[o] = a;
    else {
      const s = n.getValue(o);
      s && (r[o] = s.get());
    }
  }
  return r;
}
function tz({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function nz(e, t) {
  const n = e.get();
  if (Array.isArray(t)) {
    for (let r = 0; r < t.length; r++)
      if (t[r] !== n)
        return !0;
  } else
    return n !== t;
}
function eA(e, t, { delay: n = 0, transitionOverride: r, type: o } = {}) {
  let { transition: a = e.getDefaultTransition(), transitionEnd: s, ...l } = e.makeTargetAnimatable(t);
  const c = e.getValue("willChange");
  r && (a = r);
  const d = [], f = o && e.animationState && e.animationState.getState()[o];
  for (const h in l) {
    const m = e.getValue(h), g = l[h];
    if (!m || g === void 0 || f && tz(f, h))
      continue;
    const b = {
      delay: n,
      elapsed: 0,
      ...Tg(a || {}, h)
    };
    if (window.HandoffAppearAnimations) {
      const _ = e.getProps()[tS];
      if (_) {
        const x = window.HandoffAppearAnimations(_, h, m, vn);
        x !== null && (b.elapsed = x, b.isHandoff = !0);
      }
    }
    let C = !b.isHandoff && !nz(m, g);
    if (b.type === "spring" && (m.getVelocity() || b.velocity) && (C = !1), m.animation && (C = !1), C)
      continue;
    m.start(Pg(h, m, g, e.shouldReduceMotion && Ml.has(h) ? { type: !1 } : b));
    const y = m.animation;
    U2(c) && (c.add(h), y.then(() => c.remove(h))), d.push(y);
  }
  return s && Promise.all(d).then(() => {
    s && JW(e, s);
  }), d;
}
function q5(e, t, n = {}) {
  const r = nh(e, t, n.custom);
  let { transition: o = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (o = n.transitionOverride);
  const a = r ? () => Promise.all(eA(e, r, n)) : () => Promise.resolve(), s = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: d = 0, staggerChildren: f, staggerDirection: h } = o;
    return rz(e, t, d + c, f, h, n);
  } : () => Promise.resolve(), { when: l } = o;
  if (l) {
    const [c, d] = l === "beforeChildren" ? [a, s] : [s, a];
    return c().then(() => d());
  } else
    return Promise.all([a(), s(n.delay)]);
}
function rz(e, t, n = 0, r = 0, o = 1, a) {
  const s = [], l = (e.variantChildren.size - 1) * r, c = o === 1 ? (d = 0) => d * r : (d = 0) => l - d * r;
  return Array.from(e.variantChildren).sort(oz).forEach((d, f) => {
    d.notify("AnimationStart", t), s.push(q5(d, t, {
      ...a,
      delay: n + c(f)
    }).then(() => d.notify("AnimationComplete", t)));
  }), Promise.all(s);
}
function oz(e, t) {
  return e.sortNodePosition(t);
}
function az(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const o = t.map((a) => q5(e, a, n));
    r = Promise.all(o);
  } else if (typeof t == "string")
    r = q5(e, t, n);
  else {
    const o = typeof t == "function" ? nh(e, t, n.custom) : t;
    r = Promise.all(eA(e, o, n));
  }
  return r.then(() => e.notify("AnimationComplete", t));
}
const iz = [...bg].reverse(), sz = bg.length;
function lz(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => az(e, n, r)));
}
function uz(e) {
  let t = lz(e);
  const n = dz();
  let r = !0;
  const o = (c, d) => {
    const f = nh(e, d);
    if (f) {
      const { transition: h, transitionEnd: m, ...g } = f;
      c = { ...c, ...g, ...m };
    }
    return c;
  };
  function a(c) {
    t = c(e);
  }
  function s(c, d) {
    const f = e.getProps(), h = e.getVariantContext(!0) || {}, m = [], g = /* @__PURE__ */ new Set();
    let b = {}, C = 1 / 0;
    for (let _ = 0; _ < sz; _++) {
      const x = iz[_], I = n[x], R = f[x] !== void 0 ? f[x] : h[x], E = $1(R), k = x === d ? I.isActive : null;
      k === !1 && (C = _);
      let N = R === h[x] && R !== f[x] && E;
      if (N && r && e.manuallyAnimateOnMount && (N = !1), I.protectedKeys = { ...b }, // If it isn't active and hasn't *just* been set as inactive
      !I.isActive && k === null || // If we didn't and don't have any defined prop for this animation type
      !R && !I.prevProp || // Or if the prop doesn't define an animation
      Kf(R) || typeof R == "boolean")
        continue;
      let F = cz(I.prevProp, R) || // If we're making this variant active, we want to always make it active
      x === d && I.isActive && !N && E || // If we removed a higher-priority variant (i is in reverse order)
      _ > C && E, G = !1;
      const j = Array.isArray(R) ? R : [R];
      let ae = j.reduce(o, {});
      k === !1 && (ae = {});
      const { prevResolvedValues: ue = {} } = I, le = {
        ...ue,
        ...ae
      }, _e = (ve) => {
        F = !0, g.has(ve) && (G = !0, g.delete(ve)), I.needsAnimating[ve] = !0;
      };
      for (const ve in le) {
        const z = ae[ve], K = ue[ve];
        if (b.hasOwnProperty(ve))
          continue;
        let Ce = !1;
        Z2(z) && Z2(K) ? Ce = !MS(z, K) : Ce = z !== K, Ce ? z !== void 0 ? _e(ve) : g.add(ve) : z !== void 0 && g.has(ve) ? _e(ve) : I.protectedKeys[ve] = !0;
      }
      I.prevProp = R, I.prevResolvedValues = ae, I.isActive && (b = { ...b, ...ae }), r && e.blockInitialAnimation && (F = !1), F && (!N || G) && m.push(...j.map((ve) => ({
        animation: ve,
        options: { type: x, ...c }
      })));
    }
    if (g.size) {
      const _ = {};
      g.forEach((x) => {
        const I = e.getBaseTarget(x);
        I !== void 0 && (_[x] = I);
      }), m.push({ animation: _ });
    }
    let y = !!m.length;
    return r && (f.initial === !1 || f.initial === f.animate) && !e.manuallyAnimateOnMount && (y = !1), r = !1, y ? t(m) : Promise.resolve();
  }
  function l(c, d, f) {
    var h;
    if (n[c].isActive === d)
      return Promise.resolve();
    (h = e.variantChildren) === null || h === void 0 || h.forEach((g) => {
      var b;
      return (b = g.animationState) === null || b === void 0 ? void 0 : b.setActive(c, d);
    }), n[c].isActive = d;
    const m = s(f, c);
    for (const g in n)
      n[g].protectedKeys = {};
    return m;
  }
  return {
    animateChanges: s,
    setActive: l,
    setAnimateFunction: a,
    getState: () => n
  };
}
function cz(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !MS(t, e) : !1;
}
function $s(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function dz() {
  return {
    animate: $s(!0),
    whileInView: $s(),
    whileHover: $s(),
    whileTap: $s(),
    whileDrag: $s(),
    whileFocus: $s(),
    exit: $s()
  };
}
class fz extends ys {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = uz(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    this.unmount(), Kf(t) && (this.unmount = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let hz = 0;
class pz extends ys {
  constructor() {
    super(...arguments), this.id = hz++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n, custom: r } = this.node.presenceContext, { isPresent: o } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === o)
      return;
    const a = this.node.animationState.setActive("exit", !t, { custom: r ?? this.node.getProps().custom });
    n && !t && a.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const mz = {
  animation: {
    Feature: fz
  },
  exit: {
    Feature: pz
  }
}, m8 = (e, t) => Math.abs(e - t);
function gz(e, t) {
  const n = m8(e.x, t.x), r = m8(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class tA {
  constructor(t, n, { transformPagePoint: r, contextWindow: o, dragSnapToOrigin: a = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const h = Pm(this.lastMoveEventInfo, this.history), m = this.startEvent !== null, g = gz(h.offset, { x: 0, y: 0 }) >= 3;
      if (!m && !g)
        return;
      const { point: b } = h, { timestamp: C } = Mr;
      this.history.push({ ...b, timestamp: C });
      const { onStart: y, onMove: _ } = this.handlers;
      m || (y && y(this.lastMoveEvent, h), this.startEvent = this.lastMoveEvent), _ && _(this.lastMoveEvent, h);
    }, this.handlePointerMove = (h, m) => {
      this.lastMoveEvent = h, this.lastMoveEventInfo = Tm(m, this.transformPagePoint), vn.update(this.updatePoint, !0);
    }, this.handlePointerUp = (h, m) => {
      this.end();
      const { onEnd: g, onSessionEnd: b, resumeAnimation: C } = this.handlers;
      if (this.dragSnapToOrigin && C && C(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const y = Pm(h.type === "pointercancel" ? this.lastMoveEventInfo : Tm(m, this.transformPagePoint), this.history);
      this.startEvent && g && g(h, y), b && b(h, y);
    }, !CS(t))
      return;
    this.dragSnapToOrigin = a, this.handlers = n, this.transformPagePoint = r, this.contextWindow = o || window;
    const s = th(t), l = Tm(s, this.transformPagePoint), { point: c } = l, { timestamp: d } = Mr;
    this.history = [{ ...c, timestamp: d }];
    const { onSessionStart: f } = n;
    f && f(t, Pm(l, this.history)), this.removeListeners = us(hi(this.contextWindow, "pointermove", this.handlePointerMove), hi(this.contextWindow, "pointerup", this.handlePointerUp), hi(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), yi(this.updatePoint);
  }
}
function Tm(e, t) {
  return t ? { point: t(e.point) } : e;
}
function g8(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Pm({ point: e }, t) {
  return {
    point: e,
    delta: g8(e, nA(t)),
    offset: g8(e, vz(t)),
    velocity: Cz(t, 0.1)
  };
}
function vz(e) {
  return e[0];
}
function nA(e) {
  return e[e.length - 1];
}
function Cz(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const o = nA(e);
  for (; n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > cs(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const a = pi(o.timestamp - r.timestamp);
  if (a === 0)
    return { x: 0, y: 0 };
  const s = {
    x: (o.x - r.x) / a,
    y: (o.y - r.y) / a
  };
  return s.x === 1 / 0 && (s.x = 0), s.y === 1 / 0 && (s.y = 0), s;
}
function bo(e) {
  return e.max - e.min;
}
function J5(e, t = 0, n = 0.01) {
  return Math.abs(e - t) <= n;
}
function v8(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = Dn(t.min, t.max, e.origin), e.scale = bo(n) / bo(t), (J5(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = Dn(n.min, n.max, e.origin) - e.originPoint, (J5(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function I1(e, t, n, r) {
  v8(e.x, t.x, n.x, r ? r.originX : void 0), v8(e.y, t.y, n.y, r ? r.originY : void 0);
}
function C8(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + bo(t);
}
function bz(e, t, n) {
  C8(e.x, t.x, n.x), C8(e.y, t.y, n.y);
}
function b8(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + bo(t);
}
function w1(e, t, n) {
  b8(e.x, t.x, n.x), b8(e.y, t.y, n.y);
}
function yz(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? Dn(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? Dn(n, e, r.max) : Math.min(e, n)), e;
}
function y8(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function Sz(e, { top: t, left: n, bottom: r, right: o }) {
  return {
    x: y8(e.x, n, o),
    y: y8(e.y, t, r)
  };
}
function S8(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function Az(e, t) {
  return {
    x: S8(e.x, t.x),
    y: S8(e.y, t.y)
  };
}
function Mz(e, t) {
  let n = 0.5;
  const r = bo(e), o = bo(t);
  return o > r ? n = j1(t.min, t.max - r, e.min) : r > o && (n = j1(e.min, e.max - o, t.min)), hs(0, 1, n);
}
function xz(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const K5 = 0.35;
function _z(e = K5) {
  return e === !1 ? e = 0 : e === !0 && (e = K5), {
    x: A8(e, "left", "right"),
    y: A8(e, "top", "bottom")
  };
}
function A8(e, t, n) {
  return {
    min: M8(e, t),
    max: M8(e, n)
  };
}
function M8(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const x8 = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), _u = () => ({
  x: x8(),
  y: x8()
}), _8 = () => ({ min: 0, max: 0 }), Yn = () => ({
  x: _8(),
  y: _8()
});
function ko(e) {
  return [e("x"), e("y")];
}
function rA({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function Iz({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function wz(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function km(e) {
  return e === void 0 || e === 1;
}
function Q5({ scale: e, scaleX: t, scaleY: n }) {
  return !km(e) || !km(t) || !km(n);
}
function Ws(e) {
  return Q5(e) || oA(e) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function oA(e) {
  return I8(e.x) || I8(e.y);
}
function I8(e) {
  return e && e !== "0%";
}
function X2(e, t, n) {
  const r = e - n, o = t * r;
  return n + o;
}
function w8(e, t, n, r, o) {
  return o !== void 0 && (e = X2(e, o, r)), X2(e, n, r) + t;
}
function e3(e, t = 0, n = 1, r, o) {
  e.min = w8(e.min, t, n, r, o), e.max = w8(e.max, t, n, r, o);
}
function aA(e, { x: t, y: n }) {
  e3(e.x, t.translate, t.scale, t.originPoint), e3(e.y, n.translate, n.scale, n.originPoint);
}
function Lz(e, t, n, r = !1) {
  const o = n.length;
  if (!o)
    return;
  t.x = t.y = 1;
  let a, s;
  for (let l = 0; l < o; l++) {
    a = n[l], s = a.projectionDelta;
    const c = a.instance;
    c && c.style && c.style.display === "contents" || (r && a.options.layoutScroll && a.scroll && a !== a.root && Iu(e, {
      x: -a.scroll.offset.x,
      y: -a.scroll.offset.y
    }), s && (t.x *= s.x.scale, t.y *= s.y.scale, aA(e, s)), r && Ws(a.latestValues) && Iu(e, a.latestValues));
  }
  t.x = L8(t.x), t.y = L8(t.y);
}
function L8(e) {
  return Number.isInteger(e) || e > 1.0000000000001 || e < 0.999999999999 ? e : 1;
}
function es(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function R8(e, t, [n, r, o]) {
  const a = t[o] !== void 0 ? t[o] : 0.5, s = Dn(e.min, e.max, a);
  e3(e, t[n], t[r], s, t.scale);
}
const Rz = ["x", "scaleX", "originX"], Ez = ["y", "scaleY", "originY"];
function Iu(e, t) {
  R8(e.x, t, Rz), R8(e.y, t, Ez);
}
function iA(e, t) {
  return rA(wz(e.getBoundingClientRect(), t));
}
function Dz(e, t, n) {
  const r = iA(e, n), { scroll: o } = t;
  return o && (es(r.x, o.offset.x), es(r.y, o.offset.y)), r;
}
const sA = ({ current: e }) => e ? e.ownerDocument.defaultView : null, Nz = /* @__PURE__ */ new WeakMap();
class Tz {
  constructor(t) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Yn(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const o = (f) => {
      const { dragSnapToOrigin: h } = this.getProps();
      h ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(th(f, "page").point);
    }, a = (f, h) => {
      const { drag: m, dragPropagation: g, onDragStart: b } = this.getProps();
      if (m && !g && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = yS(m), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), ko((y) => {
        let _ = this.getAxisMotionValue(y).get() || 0;
        if (Ta.test(_)) {
          const { projection: x } = this.visualElement;
          if (x && x.layout) {
            const I = x.layout.layoutBox[y];
            I && (_ = bo(I) * (parseFloat(_) / 100));
          }
        }
        this.originPoint[y] = _;
      }), b && vn.update(() => b(f, h), !1, !0);
      const { animationState: C } = this.visualElement;
      C && C.setActive("whileDrag", !0);
    }, s = (f, h) => {
      const { dragPropagation: m, dragDirectionLock: g, onDirectionLock: b, onDrag: C } = this.getProps();
      if (!m && !this.openGlobalLock)
        return;
      const { offset: y } = h;
      if (g && this.currentDirection === null) {
        this.currentDirection = Pz(y), this.currentDirection !== null && b && b(this.currentDirection);
        return;
      }
      this.updateAxis("x", h.point, y), this.updateAxis("y", h.point, y), this.visualElement.render(), C && C(f, h);
    }, l = (f, h) => this.stop(f, h), c = () => ko((f) => {
      var h;
      return this.getAnimationState(f) === "paused" && ((h = this.getAxisMotionValue(f).animation) === null || h === void 0 ? void 0 : h.play());
    }), { dragSnapToOrigin: d } = this.getProps();
    this.panSession = new tA(t, {
      onSessionStart: o,
      onStart: a,
      onMove: s,
      onSessionEnd: l,
      resumeAnimation: c
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: d,
      contextWindow: sA(this.visualElement)
    });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: o } = n;
    this.startAnimation(o);
    const { onDragEnd: a } = this.getProps();
    a && vn.update(() => a(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: o } = this.getProps();
    if (!r || !j0(t, o, this.currentDirection))
      return;
    const a = this.getAxisMotionValue(t);
    let s = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (s = yz(s, this.constraints[t], this.elastic[t])), a.set(s);
  }
  resolveConstraints() {
    var t;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), o = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (t = this.visualElement.projection) === null || t === void 0 ? void 0 : t.layout, a = this.constraints;
    n && Mu(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && o ? this.constraints = Sz(o.layoutBox, n) : this.constraints = !1, this.elastic = _z(r), a !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && ko((s) => {
      this.getAxisMotionValue(s) && (this.constraints[s] = xz(o.layoutBox[s], this.constraints[s]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !Mu(t))
      return !1;
    const r = t.current;
    $o(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    const a = Dz(r, o.root, this.visualElement.getTransformPagePoint());
    let s = Az(o.layout.layoutBox, a);
    if (n) {
      const l = n(Iz(s));
      this.hasMutatedConstraints = !!l, l && (s = rA(l));
    }
    return s;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: o, dragTransition: a, dragSnapToOrigin: s, onDragTransitionEnd: l } = this.getProps(), c = this.constraints || {}, d = ko((f) => {
      if (!j0(f, n, this.currentDirection))
        return;
      let h = c && c[f] || {};
      s && (h = { min: 0, max: 0 });
      const m = o ? 200 : 1e6, g = o ? 40 : 1e7, b = {
        type: "inertia",
        velocity: r ? t[f] : 0,
        bounceStiffness: m,
        bounceDamping: g,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...a,
        ...h
      };
      return this.startAxisValueAnimation(f, b);
    });
    return Promise.all(d).then(l);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return r.start(Pg(t, r, 0, n));
  }
  stopAnimation() {
    ko((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    ko((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = "_drag" + t.toUpperCase(), r = this.visualElement.getProps(), o = r[n];
    return o || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    ko((n) => {
      const { drag: r } = this.getProps();
      if (!j0(n, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, a = this.getAxisMotionValue(n);
      if (o && o.layout) {
        const { min: s, max: l } = o.layout.layoutBox[n];
        a.set(t[n] - Dn(s, l, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!Mu(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    ko((s) => {
      const l = this.getAxisMotionValue(s);
      if (l) {
        const c = l.get();
        o[s] = Mz({ min: c, max: c }, this.constraints[s]);
      }
    });
    const { transformTemplate: a } = this.visualElement.getProps();
    this.visualElement.current.style.transform = a ? a({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), ko((s) => {
      if (!j0(s, t, null))
        return;
      const l = this.getAxisMotionValue(s), { min: c, max: d } = this.constraints[s];
      l.set(Dn(c, d, o[s]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    Nz.set(this.visualElement, this);
    const t = this.visualElement.current, n = hi(t, "pointerdown", (c) => {
      const { drag: d, dragListener: f = !0 } = this.getProps();
      d && f && this.start(c);
    }), r = () => {
      const { dragConstraints: c } = this.getProps();
      Mu(c) && (this.constraints = this.resolveRefConstraints());
    }, { projection: o } = this.visualElement, a = o.addEventListener("measure", r);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), r();
    const s = ci(window, "resize", () => this.scalePositionWithinConstraints()), l = o.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: d }) => {
      this.isDragging && d && (ko((f) => {
        const h = this.getAxisMotionValue(f);
        h && (this.originPoint[f] += c[f].translate, h.set(h.get() + c[f].translate));
      }), this.visualElement.render());
    });
    return () => {
      s(), n(), a(), l && l();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: a = !1, dragElastic: s = K5, dragMomentum: l = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: a,
      dragElastic: s,
      dragMomentum: l
    };
  }
}
function j0(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function Pz(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class kz extends ys {
  constructor(t) {
    super(t), this.removeGroupControls = Fn, this.removeListeners = Fn, this.controls = new Tz(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Fn;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const E8 = (e) => (t, n) => {
  e && vn.update(() => e(t, n));
};
class Vz extends ys {
  constructor() {
    super(...arguments), this.removePointerDownListener = Fn;
  }
  onPointerDown(t) {
    this.session = new tA(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: sA(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: E8(t),
      onStart: E8(n),
      onMove: r,
      onEnd: (a, s) => {
        delete this.session, o && vn.update(() => o(a, s));
      }
    };
  }
  mount() {
    this.removePointerDownListener = hi(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function lA() {
  const e = Zn(nd);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: n, register: r } = e, o = Xo();
  return ft(() => r(o), []), !t && n ? [!1, () => n && n(o)] : [!0];
}
function Oz() {
  return Fz(Zn(nd));
}
function Fz(e) {
  return e === null ? !0 : e.isPresent;
}
const _2 = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function D8(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const zc = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (ut.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = D8(e, t.target.x), r = D8(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, Bz = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, o = ps.parse(e);
    if (o.length > 5)
      return r;
    const a = ps.createTransformer(e), s = typeof o[0] != "number" ? 1 : 0, l = n.x.scale * t.x, c = n.y.scale * t.y;
    o[0 + s] /= l, o[1 + s] /= c;
    const d = Dn(l, c, 0.5);
    return typeof o[2 + s] == "number" && (o[2 + s] /= d), typeof o[3 + s] == "number" && (o[3 + s] /= d), a(o);
  }
};
class Hz extends Pr.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: o } = this.props, { projection: a } = t;
    XZ(Gz), a && (n.group && n.group.add(a), r && r.register && o && r.register(a), a.root.didUpdate(), a.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), a.setOptions({
      ...a.options,
      onExitComplete: () => this.safeToRemove()
    })), _2.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: o, isPresent: a } = this.props, s = r.projection;
    return s && (s.isPresent = a, o || t.layoutDependency !== n || n === void 0 ? s.willUpdate() : this.safeToRemove(), t.isPresent !== a && (a ? s.promote() : s.relegate() || vn.postRender(() => {
      const l = s.getStack();
      (!l || !l.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), queueMicrotask(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: o } = t;
    o && (o.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function uA(e) {
  const [t, n] = lA(), r = Zn(Sg);
  return Pr.createElement(Hz, { ...e, layoutGroup: r, switchLayoutGroup: Zn(rS), isPresent: t, safeToRemove: n });
}
const Gz = {
  borderRadius: {
    ...zc,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: zc,
  borderTopRightRadius: zc,
  borderBottomLeftRadius: zc,
  borderBottomRightRadius: zc,
  boxShadow: Bz
}, cA = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], $z = cA.length, N8 = (e) => typeof e == "string" ? parseFloat(e) : e, T8 = (e) => typeof e == "number" || ut.test(e);
function Zz(e, t, n, r, o, a) {
  o ? (e.opacity = Dn(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    jz(r)
  ), e.opacityExit = Dn(t.opacity !== void 0 ? t.opacity : 1, 0, Wz(r))) : a && (e.opacity = Dn(t.opacity !== void 0 ? t.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let s = 0; s < $z; s++) {
    const l = `border${cA[s]}Radius`;
    let c = P8(t, l), d = P8(n, l);
    if (c === void 0 && d === void 0)
      continue;
    c || (c = 0), d || (d = 0), c === 0 || d === 0 || T8(c) === T8(d) ? (e[l] = Math.max(Dn(N8(c), N8(d), r), 0), (Ta.test(d) || Ta.test(c)) && (e[l] += "%")) : e[l] = d;
  }
  (t.rotate || n.rotate) && (e.rotate = Dn(t.rotate || 0, n.rotate || 0, r));
}
function P8(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const jz = dA(0, 0.5, NS), Wz = dA(0.5, 0.95, Fn);
function dA(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(j1(e, t, r));
}
function k8(e, t) {
  e.min = t.min, e.max = t.max;
}
function To(e, t) {
  k8(e.x, t.x), k8(e.y, t.y);
}
function V8(e, t, n, r, o) {
  return e -= t, e = X2(e, 1 / n, r), o !== void 0 && (e = X2(e, 1 / o, r)), e;
}
function zz(e, t = 0, n = 1, r = 0.5, o, a = e, s = e) {
  if (Ta.test(t) && (t = parseFloat(t), t = Dn(s.min, s.max, t / 100) - s.min), typeof t != "number")
    return;
  let l = Dn(a.min, a.max, r);
  e === a && (l -= t), e.min = V8(e.min, t, n, l, o), e.max = V8(e.max, t, n, l, o);
}
function O8(e, t, [n, r, o], a, s) {
  zz(e, t[n], t[r], t[o], t.scale, a, s);
}
const Uz = ["x", "scaleX", "originX"], Xz = ["y", "scaleY", "originY"];
function F8(e, t, n, r) {
  O8(e.x, t, Uz, n ? n.x : void 0, r ? r.x : void 0), O8(e.y, t, Xz, n ? n.y : void 0, r ? r.y : void 0);
}
function B8(e) {
  return e.translate === 0 && e.scale === 1;
}
function fA(e) {
  return B8(e.x) && B8(e.y);
}
function Yz(e, t) {
  return e.x.min === t.x.min && e.x.max === t.x.max && e.y.min === t.y.min && e.y.max === t.y.max;
}
function hA(e, t) {
  return Math.round(e.x.min) === Math.round(t.x.min) && Math.round(e.x.max) === Math.round(t.x.max) && Math.round(e.y.min) === Math.round(t.y.min) && Math.round(e.y.max) === Math.round(t.y.max);
}
function H8(e) {
  return bo(e.x) / bo(e.y);
}
class qz {
  constructor() {
    this.members = [];
  }
  add(t) {
    kg(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (Vg(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((o) => t === o);
    if (n === 0)
      return !1;
    let r;
    for (let o = n; o >= 0; o--) {
      const a = this.members[o];
      if (a.isPresent !== !1) {
        r = a;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: o } = t.options;
      o === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function G8(e, t, n) {
  let r = "";
  const o = e.x.translate / t.x, a = e.y.translate / t.y;
  if ((o || a) && (r = `translate3d(${o}px, ${a}px, 0) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { rotate: c, rotateX: d, rotateY: f } = n;
    c && (r += `rotate(${c}deg) `), d && (r += `rotateX(${d}deg) `), f && (r += `rotateY(${f}deg) `);
  }
  const s = e.x.scale * t.x, l = e.y.scale * t.y;
  return (s !== 1 || l !== 1) && (r += `scale(${s}, ${l})`), r || "none";
}
const Jz = (e, t) => e.depth - t.depth;
class Kz {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    kg(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Vg(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(Jz), this.isDirty = !1, this.children.forEach(t);
  }
}
function Qz(e, t) {
  const n = performance.now(), r = ({ timestamp: o }) => {
    const a = o - n;
    a >= t && (yi(r), e(a - t));
  };
  return vn.read(r, !0), () => yi(r);
}
function eU(e) {
  window.MotionDebug && window.MotionDebug.record(e);
}
function tU(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function nU(e, t, n) {
  const r = eo(e) ? e : Hu(e);
  return r.start(Pg("", r, t, n)), r.animation;
}
const $8 = ["", "X", "Y", "Z"], rU = { visibility: "hidden" }, Z8 = 1e3;
let oU = 0;
const zs = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function pA({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(s = {}, l = t == null ? void 0 : t()) {
      this.id = oU++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, zs.totalNodes = zs.resolvedTargetDeltas = zs.recalculatedProjection = 0, this.nodes.forEach(sU), this.nodes.forEach(fU), this.nodes.forEach(hU), this.nodes.forEach(lU), eU(zs);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = s, this.root = l ? l.root || l : this, this.path = l ? [...l.path, l] : [], this.parent = l, this.depth = l ? l.depth + 1 : 0;
      for (let c = 0; c < this.path.length; c++)
        this.path[c].shouldResetTransform = !0;
      this.root === this && (this.nodes = new Kz());
    }
    addEventListener(s, l) {
      return this.eventHandlers.has(s) || this.eventHandlers.set(s, new Og()), this.eventHandlers.get(s).add(l);
    }
    notifyListeners(s, ...l) {
      const c = this.eventHandlers.get(s);
      c && c.notify(...l);
    }
    hasListeners(s) {
      return this.eventHandlers.has(s);
    }
    /**
     * Lifecycles
     */
    mount(s, l = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = tU(s), this.instance = s;
      const { layoutId: c, layout: d, visualElement: f } = this.options;
      if (f && !f.current && f.mount(s), this.root.nodes.add(this), this.parent && this.parent.children.add(this), l && (d || c) && (this.isLayoutDirty = !0), e) {
        let h;
        const m = () => this.root.updateBlockedByResize = !1;
        e(s, () => {
          this.root.updateBlockedByResize = !0, h && h(), h = Qz(m, 250), _2.hasAnimatedSinceResize && (_2.hasAnimatedSinceResize = !1, this.nodes.forEach(W8));
        });
      }
      c && this.root.registerSharedNode(c, this), this.options.animate !== !1 && f && (c || d) && this.addEventListener("didUpdate", ({ delta: h, hasLayoutChanged: m, hasRelativeTargetChanged: g, layout: b }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const C = this.options.transition || f.getDefaultTransition() || CU, { onLayoutAnimationStart: y, onLayoutAnimationComplete: _ } = f.getProps(), x = !this.targetLayout || !hA(this.targetLayout, b) || g, I = !m && g;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || I || m && (x || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(h, I);
          const R = {
            ...Tg(C, "layout"),
            onPlay: y,
            onComplete: _
          };
          (f.shouldReduceMotion || this.options.layoutRoot) && (R.delay = 0, R.type = !1), this.startAnimation(R);
        } else
          m || W8(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = b;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const s = this.getStack();
      s && s.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, yi(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(pU), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: s } = this.options;
      return s && s.getProps().transformTemplate;
    }
    willUpdate(s = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let f = 0; f < this.path.length; f++) {
        const h = this.path[f];
        h.shouldResetTransform = !0, h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: l, layout: c } = this.options;
      if (l === void 0 && !c)
        return;
      const d = this.getTransformTemplate();
      this.prevTransformTemplateValue = d ? d(this.latestValues, "") : void 0, this.updateSnapshot(), s && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(j8);
        return;
      }
      this.isUpdating || this.nodes.forEach(cU), this.isUpdating = !1, this.nodes.forEach(dU), this.nodes.forEach(aU), this.nodes.forEach(iU), this.clearAllSnapshots();
      const l = performance.now();
      Mr.delta = hs(0, 1e3 / 60, l - Mr.timestamp), Mr.timestamp = l, Mr.isProcessing = !0, _m.update.process(Mr), _m.preRender.process(Mr), _m.render.process(Mr), Mr.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, queueMicrotask(() => this.update()));
    }
    clearAllSnapshots() {
      this.nodes.forEach(uU), this.sharedNodes.forEach(mU);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, vn.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      vn.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let c = 0; c < this.path.length; c++)
          this.path[c].updateScroll();
      const s = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = Yn(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: l } = this.options;
      l && l.notify("LayoutMeasure", this.layout.layoutBox, s ? s.layoutBox : void 0);
    }
    updateScroll(s = "measure") {
      let l = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === s && (l = !1), l && (this.scroll = {
        animationId: this.root.animationId,
        phase: s,
        isRoot: r(this.instance),
        offset: n(this.instance)
      });
    }
    resetTransform() {
      if (!o)
        return;
      const s = this.isLayoutDirty || this.shouldResetTransform, l = this.projectionDelta && !fA(this.projectionDelta), c = this.getTransformTemplate(), d = c ? c(this.latestValues, "") : void 0, f = d !== this.prevTransformTemplateValue;
      s && (l || Ws(this.latestValues) || f) && (o(this.instance, d), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(s = !0) {
      const l = this.measurePageBox();
      let c = this.removeElementScroll(l);
      return s && (c = this.removeTransform(c)), bU(c), {
        animationId: this.root.animationId,
        measuredBox: l,
        layoutBox: c,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: s } = this.options;
      if (!s)
        return Yn();
      const l = s.measureViewportBox(), { scroll: c } = this.root;
      return c && (es(l.x, c.offset.x), es(l.y, c.offset.y)), l;
    }
    removeElementScroll(s) {
      const l = Yn();
      To(l, s);
      for (let c = 0; c < this.path.length; c++) {
        const d = this.path[c], { scroll: f, options: h } = d;
        if (d !== this.root && f && h.layoutScroll) {
          if (f.isRoot) {
            To(l, s);
            const { scroll: m } = this.root;
            m && (es(l.x, -m.offset.x), es(l.y, -m.offset.y));
          }
          es(l.x, f.offset.x), es(l.y, f.offset.y);
        }
      }
      return l;
    }
    applyTransform(s, l = !1) {
      const c = Yn();
      To(c, s);
      for (let d = 0; d < this.path.length; d++) {
        const f = this.path[d];
        !l && f.options.layoutScroll && f.scroll && f !== f.root && Iu(c, {
          x: -f.scroll.offset.x,
          y: -f.scroll.offset.y
        }), Ws(f.latestValues) && Iu(c, f.latestValues);
      }
      return Ws(this.latestValues) && Iu(c, this.latestValues), c;
    }
    removeTransform(s) {
      const l = Yn();
      To(l, s);
      for (let c = 0; c < this.path.length; c++) {
        const d = this.path[c];
        if (!d.instance || !Ws(d.latestValues))
          continue;
        Q5(d.latestValues) && d.updateSnapshot();
        const f = Yn(), h = d.measurePageBox();
        To(f, h), F8(l, d.latestValues, d.snapshot ? d.snapshot.layoutBox : void 0, f);
      }
      return Ws(this.latestValues) && F8(l, this.latestValues), l;
    }
    setTargetDelta(s) {
      this.targetDelta = s, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(s) {
      this.options = {
        ...this.options,
        ...s,
        crossfade: s.crossfade !== void 0 ? s.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Mr.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(s = !1) {
      var l;
      const c = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = c.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = c.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = c.isSharedProjectionDirty);
      const d = !!this.resumingFrom || this !== c;
      if (!(s || d && this.isSharedProjectionDirty || this.isProjectionDirty || !((l = this.parent) === null || l === void 0) && l.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: h, layoutId: m } = this.options;
      if (!(!this.layout || !(h || m))) {
        if (this.resolvedRelativeTargetAt = Mr.timestamp, !this.targetDelta && !this.relativeTarget) {
          const g = this.getClosestProjectingParent();
          g && g.layout && this.animationProgress !== 1 ? (this.relativeParent = g, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Yn(), this.relativeTargetOrigin = Yn(), w1(this.relativeTargetOrigin, this.layout.layoutBox, g.layout.layoutBox), To(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = Yn(), this.targetWithTransforms = Yn()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), bz(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : To(this.target, this.layout.layoutBox), aA(this.target, this.targetDelta)) : To(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const g = this.getClosestProjectingParent();
            g && !!g.resumingFrom == !!this.resumingFrom && !g.options.layoutScroll && g.target && this.animationProgress !== 1 ? (this.relativeParent = g, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Yn(), this.relativeTargetOrigin = Yn(), w1(this.relativeTargetOrigin, this.target, g.target), To(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          zs.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Q5(this.parent.latestValues) || oA(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var s;
      const l = this.getLead(), c = !!this.resumingFrom || this !== l;
      let d = !0;
      if ((this.isProjectionDirty || !((s = this.parent) === null || s === void 0) && s.isProjectionDirty) && (d = !1), c && (this.isSharedProjectionDirty || this.isTransformDirty) && (d = !1), this.resolvedRelativeTargetAt === Mr.timestamp && (d = !1), d)
        return;
      const { layout: f, layoutId: h } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(f || h))
        return;
      To(this.layoutCorrected, this.layout.layoutBox);
      const m = this.treeScale.x, g = this.treeScale.y;
      Lz(this.layoutCorrected, this.treeScale, this.path, c), l.layout && !l.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (l.target = l.layout.layoutBox);
      const { target: b } = l;
      if (!b) {
        this.projectionTransform && (this.projectionDelta = _u(), this.projectionTransform = "none", this.scheduleRender());
        return;
      }
      this.projectionDelta || (this.projectionDelta = _u(), this.projectionDeltaWithTransform = _u());
      const C = this.projectionTransform;
      I1(this.projectionDelta, this.layoutCorrected, b, this.latestValues), this.projectionTransform = G8(this.projectionDelta, this.treeScale), (this.projectionTransform !== C || this.treeScale.x !== m || this.treeScale.y !== g) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", b)), zs.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(s = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), s) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(s, l = !1) {
      const c = this.snapshot, d = c ? c.latestValues : {}, f = { ...this.latestValues }, h = _u();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !l;
      const m = Yn(), g = c ? c.source : void 0, b = this.layout ? this.layout.source : void 0, C = g !== b, y = this.getStack(), _ = !y || y.members.length <= 1, x = !!(C && !_ && this.options.crossfade === !0 && !this.path.some(vU));
      this.animationProgress = 0;
      let I;
      this.mixTargetDelta = (R) => {
        const E = R / 1e3;
        z8(h.x, s.x, E), z8(h.y, s.y, E), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (w1(m, this.layout.layoutBox, this.relativeParent.layout.layoutBox), gU(this.relativeTarget, this.relativeTargetOrigin, m, E), I && Yz(this.relativeTarget, I) && (this.isProjectionDirty = !1), I || (I = Yn()), To(I, this.relativeTarget)), C && (this.animationValues = f, Zz(f, d, this.latestValues, E, x, _)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = E;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(s) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (yi(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = vn.update(() => {
        _2.hasAnimatedSinceResize = !0, this.currentAnimation = nU(0, Z8, {
          ...s,
          onUpdate: (l) => {
            this.mixTargetDelta(l), s.onUpdate && s.onUpdate(l);
          },
          onComplete: () => {
            s.onComplete && s.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const s = this.getStack();
      s && s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Z8), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const s = this.getLead();
      let { targetWithTransforms: l, target: c, layout: d, latestValues: f } = s;
      if (!(!l || !c || !d)) {
        if (this !== s && this.layout && d && mA(this.options.animationType, this.layout.layoutBox, d.layoutBox)) {
          c = this.target || Yn();
          const h = bo(this.layout.layoutBox.x);
          c.x.min = s.target.x.min, c.x.max = c.x.min + h;
          const m = bo(this.layout.layoutBox.y);
          c.y.min = s.target.y.min, c.y.max = c.y.min + m;
        }
        To(l, c), Iu(l, f), I1(this.projectionDeltaWithTransform, this.layoutCorrected, l, f);
      }
    }
    registerSharedNode(s, l) {
      this.sharedNodes.has(s) || this.sharedNodes.set(s, new qz()), this.sharedNodes.get(s).add(l);
      const d = l.options.initialPromotionConfig;
      l.promote({
        transition: d ? d.transition : void 0,
        preserveFollowOpacity: d && d.shouldPreserveFollowOpacity ? d.shouldPreserveFollowOpacity(l) : void 0
      });
    }
    isLead() {
      const s = this.getStack();
      return s ? s.lead === this : !0;
    }
    getLead() {
      var s;
      const { layoutId: l } = this.options;
      return l ? ((s = this.getStack()) === null || s === void 0 ? void 0 : s.lead) || this : this;
    }
    getPrevLead() {
      var s;
      const { layoutId: l } = this.options;
      return l ? (s = this.getStack()) === null || s === void 0 ? void 0 : s.prevLead : void 0;
    }
    getStack() {
      const { layoutId: s } = this.options;
      if (s)
        return this.root.sharedNodes.get(s);
    }
    promote({ needsReset: s, transition: l, preserveFollowOpacity: c } = {}) {
      const d = this.getStack();
      d && d.promote(this, c), s && (this.projectionDelta = void 0, this.needsReset = !0), l && this.setOptions({ transition: l });
    }
    relegate() {
      const s = this.getStack();
      return s ? s.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement: s } = this.options;
      if (!s)
        return;
      let l = !1;
      const { latestValues: c } = s;
      if ((c.rotate || c.rotateX || c.rotateY || c.rotateZ) && (l = !0), !l)
        return;
      const d = {};
      for (let f = 0; f < $8.length; f++) {
        const h = "rotate" + $8[f];
        c[h] && (d[h] = c[h], s.setStaticValue(h, 0));
      }
      s.render();
      for (const f in d)
        s.setStaticValue(f, d[f]);
      s.scheduleRender();
    }
    getProjectionStyles(s) {
      var l, c;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return rU;
      const d = {
        visibility: ""
      }, f = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, d.opacity = "", d.pointerEvents = x2(s == null ? void 0 : s.pointerEvents) || "", d.transform = f ? f(this.latestValues, "") : "none", d;
      const h = this.getLead();
      if (!this.projectionDelta || !this.layout || !h.target) {
        const C = {};
        return this.options.layoutId && (C.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, C.pointerEvents = x2(s == null ? void 0 : s.pointerEvents) || ""), this.hasProjected && !Ws(this.latestValues) && (C.transform = f ? f({}, "") : "none", this.hasProjected = !1), C;
      }
      const m = h.animationValues || h.latestValues;
      this.applyTransformsToTarget(), d.transform = G8(this.projectionDeltaWithTransform, this.treeScale, m), f && (d.transform = f(m, d.transform));
      const { x: g, y: b } = this.projectionDelta;
      d.transformOrigin = `${g.origin * 100}% ${b.origin * 100}% 0`, h.animationValues ? d.opacity = h === this ? (c = (l = m.opacity) !== null && l !== void 0 ? l : this.latestValues.opacity) !== null && c !== void 0 ? c : 1 : this.preserveOpacity ? this.latestValues.opacity : m.opacityExit : d.opacity = h === this ? m.opacity !== void 0 ? m.opacity : "" : m.opacityExit !== void 0 ? m.opacityExit : 0;
      for (const C in G2) {
        if (m[C] === void 0)
          continue;
        const { correct: y, applyTo: _ } = G2[C], x = d.transform === "none" ? m[C] : y(m[C], h);
        if (_) {
          const I = _.length;
          for (let R = 0; R < I; R++)
            d[_[R]] = x;
        } else
          d[C] = x;
      }
      return this.options.layoutId && (d.pointerEvents = h === this ? x2(s == null ? void 0 : s.pointerEvents) || "" : "none"), d;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((s) => {
        var l;
        return (l = s.currentAnimation) === null || l === void 0 ? void 0 : l.stop();
      }), this.root.nodes.forEach(j8), this.root.sharedNodes.clear();
    }
  };
}
function aU(e) {
  e.updateLayout();
}
function iU(e) {
  var t;
  const n = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && n && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: o } = e.layout, { animationType: a } = e.options, s = n.source !== e.layout.source;
    a === "size" ? ko((h) => {
      const m = s ? n.measuredBox[h] : n.layoutBox[h], g = bo(m);
      m.min = r[h].min, m.max = m.min + g;
    }) : mA(a, n.layoutBox, r) && ko((h) => {
      const m = s ? n.measuredBox[h] : n.layoutBox[h], g = bo(r[h]);
      m.max = m.min + g, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[h].max = e.relativeTarget[h].min + g);
    });
    const l = _u();
    I1(l, r, n.layoutBox);
    const c = _u();
    s ? I1(c, e.applyTransform(o, !0), n.measuredBox) : I1(c, r, n.layoutBox);
    const d = !fA(l);
    let f = !1;
    if (!e.resumeFrom) {
      const h = e.getClosestProjectingParent();
      if (h && !h.resumeFrom) {
        const { snapshot: m, layout: g } = h;
        if (m && g) {
          const b = Yn();
          w1(b, n.layoutBox, m.layoutBox);
          const C = Yn();
          w1(C, r, g.layoutBox), hA(b, C) || (f = !0), h.options.layoutRoot && (e.relativeTarget = C, e.relativeTargetOrigin = b, e.relativeParent = h);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: c,
      layoutDelta: l,
      hasLayoutChanged: d,
      hasRelativeTargetChanged: f
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function sU(e) {
  zs.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function lU(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function uU(e) {
  e.clearSnapshot();
}
function j8(e) {
  e.clearMeasurements();
}
function cU(e) {
  e.isLayoutDirty = !1;
}
function dU(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function W8(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function fU(e) {
  e.resolveTargetDelta();
}
function hU(e) {
  e.calcProjection();
}
function pU(e) {
  e.resetRotation();
}
function mU(e) {
  e.removeLeadSnapshot();
}
function z8(e, t, n) {
  e.translate = Dn(t.translate, 0, n), e.scale = Dn(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function U8(e, t, n, r) {
  e.min = Dn(t.min, n.min, r), e.max = Dn(t.max, n.max, r);
}
function gU(e, t, n, r) {
  U8(e.x, t.x, n.x, r), U8(e.y, t.y, n.y, r);
}
function vU(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const CU = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, X8 = (e) => typeof navigator < "u" && navigator.userAgent.toLowerCase().includes(e), Y8 = X8("applewebkit/") && !X8("chrome/") ? Math.round : Fn;
function q8(e) {
  e.min = Y8(e.min), e.max = Y8(e.max);
}
function bU(e) {
  q8(e.x), q8(e.y);
}
function mA(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !J5(H8(t), H8(n), 0.2);
}
const yU = pA({
  attachResizeListener: (e, t) => ci(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), Vm = {
  current: void 0
}, gA = pA({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!Vm.current) {
      const e = new yU({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Vm.current = e;
    }
    return Vm.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), SU = {
  pan: {
    Feature: Vz
  },
  drag: {
    Feature: kz,
    ProjectionNode: gA,
    MeasureLayout: uA
  }
}, AU = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function MU(e) {
  const t = AU.exec(e);
  if (!t)
    return [,];
  const [, n, r] = t;
  return [n, r];
}
const xU = 4;
function t3(e, t, n = 1) {
  $o(n <= xU, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, o] = MU(e);
  if (!r)
    return;
  const a = window.getComputedStyle(t).getPropertyValue(r);
  if (a) {
    const s = a.trim();
    return JS(s) ? parseFloat(s) : s;
  } else
    return j5(o) ? t3(o, t, n + 1) : o;
}
function _U(e, { ...t }, n) {
  const r = e.current;
  if (!(r instanceof Element))
    return { target: t, transitionEnd: n };
  n && (n = { ...n }), e.values.forEach((o) => {
    const a = o.get();
    if (!j5(a))
      return;
    const s = t3(a, r);
    s && o.set(s);
  });
  for (const o in t) {
    const a = t[o];
    if (!j5(a))
      continue;
    const s = t3(a, r);
    s && (t[o] = s, n || (n = {}), n[o] === void 0 && (n[o] = a));
  }
  return { target: t, transitionEnd: n };
}
const IU = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), vA = (e) => IU.has(e), wU = (e) => Object.keys(e).some(vA), W0 = (e) => e === xl || e === ut, J8 = (e, t) => parseFloat(e.split(", ")[t]), K8 = (e, t) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const o = r.match(/^matrix3d\((.+)\)$/);
  if (o)
    return J8(o[1], t);
  {
    const a = r.match(/^matrix\((.+)\)$/);
    return a ? J8(a[1], e) : 0;
  }
}, LU = /* @__PURE__ */ new Set(["x", "y", "z"]), RU = rd.filter((e) => !LU.has(e));
function EU(e) {
  const t = [];
  return RU.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t.length && e.render(), t;
}
const Gu = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: K8(4, 13),
  y: K8(5, 14)
};
Gu.translateX = Gu.x;
Gu.translateY = Gu.y;
const DU = (e, t, n) => {
  const r = t.measureViewportBox(), o = t.current, a = getComputedStyle(o), { display: s } = a, l = {};
  s === "none" && t.setStaticValue("display", e.display || "block"), n.forEach((d) => {
    l[d] = Gu[d](r, a);
  }), t.render();
  const c = t.measureViewportBox();
  return n.forEach((d) => {
    const f = t.getValue(d);
    f && f.jump(l[d]), e[d] = Gu[d](c, a);
  }), e;
}, NU = (e, t, n = {}, r = {}) => {
  t = { ...t }, r = { ...r };
  const o = Object.keys(t).filter(vA);
  let a = [], s = !1;
  const l = [];
  if (o.forEach((c) => {
    const d = e.getValue(c);
    if (!e.hasValue(c))
      return;
    let f = n[c], h = Wc(f);
    const m = t[c];
    let g;
    if (Z2(m)) {
      const b = m.length, C = m[0] === null ? 1 : 0;
      f = m[C], h = Wc(f);
      for (let y = C; y < b && m[y] !== null; y++)
        g ? $o(Wc(m[y]) === g, "All keyframes must be of the same type") : (g = Wc(m[y]), $o(g === h || W0(h) && W0(g), "Keyframes must be of the same dimension as the current value"));
    } else
      g = Wc(m);
    if (h !== g)
      if (W0(h) && W0(g)) {
        const b = d.get();
        typeof b == "string" && d.set(parseFloat(b)), typeof m == "string" ? t[c] = parseFloat(m) : Array.isArray(m) && g === ut && (t[c] = m.map(parseFloat));
      } else
        h != null && h.transform && (g != null && g.transform) && (f === 0 || m === 0) ? f === 0 ? d.set(g.transform(f)) : t[c] = h.transform(m) : (s || (a = EU(e), s = !0), l.push(c), r[c] = r[c] !== void 0 ? r[c] : t[c], d.jump(m));
  }), l.length) {
    const c = l.indexOf("height") >= 0 ? window.pageYOffset : null, d = DU(t, e, l);
    return a.length && a.forEach(([f, h]) => {
      e.getValue(f).set(h);
    }), e.render(), Jf && c !== null && window.scrollTo({ top: c }), { target: d, transitionEnd: r };
  } else
    return { target: t, transitionEnd: r };
};
function TU(e, t, n, r) {
  return wU(t) ? NU(e, t, n, r) : { target: t, transitionEnd: r };
}
const PU = (e, t, n, r) => {
  const o = _U(e, t, r);
  return t = o.target, r = o.transitionEnd, TU(e, t, n, r);
}, n3 = { current: null }, CA = { current: !1 };
function kU() {
  if (CA.current = !0, !!Jf)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => n3.current = e.matches;
      e.addListener(t), t();
    } else
      n3.current = !1;
}
function VU(e, t, n) {
  const { willChange: r } = t;
  for (const o in t) {
    const a = t[o], s = n[o];
    if (eo(a))
      e.addValue(o, a), U2(r) && r.add(o), process.env.NODE_ENV === "development" && Fg(a.version === "10.18.0", `Attempting to mix Framer Motion versions ${a.version} with 10.18.0 may not work as expected.`);
    else if (eo(s))
      e.addValue(o, Hu(a, { owner: e })), U2(r) && r.remove(o);
    else if (s !== a)
      if (e.hasValue(o)) {
        const l = e.getValue(o);
        !l.hasAnimated && l.set(a);
      } else {
        const l = e.getStaticValue(o);
        e.addValue(o, Hu(l !== void 0 ? l : a, { owner: e }));
      }
  }
  for (const o in n)
    t[o] === void 0 && e.removeValue(o);
  return t;
}
const Q8 = /* @__PURE__ */ new WeakMap(), bA = Object.keys(Z1), OU = bA.length, ev = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], FU = yg.length;
class BU {
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: o, visualState: a }, s = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => vn.render(this.render, !1, !0);
    const { latestValues: l, renderState: c } = a;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = o, this.options = s, this.isControllingVariants = Qf(n), this.isVariantNode = nS(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: d, ...f } = this.scrapeMotionValuesFromProps(n, {});
    for (const h in f) {
      const m = f[h];
      l[h] !== void 0 && eo(m) && (m.set(l[h], !1), U2(d) && d.add(h));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n) {
    return {};
  }
  mount(t) {
    this.current = t, Q8.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), CA.current || kU(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : n3.current, process.env.NODE_ENV !== "production" && Fg(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    Q8.delete(this.current), this.projection && this.projection.unmount(), yi(this.notifyUpdate), yi(this.render), this.valueSubscriptions.forEach((t) => t()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features)
      this.features[t].unmount();
    this.current = null;
  }
  bindToMotionValue(t, n) {
    const r = Ml.has(t), o = n.on("change", (s) => {
      this.latestValues[t] = s, this.props.onUpdate && vn.update(this.notifyUpdate, !1, !0), r && this.projection && (this.projection.isTransformDirty = !0);
    }), a = n.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(t, () => {
      o(), a();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  loadFeatures({ children: t, ...n }, r, o, a) {
    let s, l;
    if (process.env.NODE_ENV !== "production" && o && r) {
      const c = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      n.ignoreStrict ? id(!1, c) : $o(!1, c);
    }
    for (let c = 0; c < OU; c++) {
      const d = bA[c], { isEnabled: f, Feature: h, ProjectionNode: m, MeasureLayout: g } = Z1[d];
      m && (s = m), f(n) && (!this.features[d] && h && (this.features[d] = new h(this)), g && (l = g));
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && s) {
      this.projection = new s(this.latestValues, this.parent && this.parent.projection);
      const { layoutId: c, layout: d, drag: f, dragConstraints: h, layoutScroll: m, layoutRoot: g } = n;
      this.projection.setOptions({
        layoutId: c,
        layout: d,
        alwaysMeasureLayout: !!f || h && Mu(h),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof d == "string" ? d : "both",
        initialPromotionConfig: a,
        layoutScroll: m,
        layoutRoot: g
      });
    }
    return l;
  }
  updateFeatures() {
    for (const t in this.features) {
      const n = this.features[t];
      n.isMounted ? n.update() : (n.mount(), n.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Yn();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(t, n = !0) {
    return this.makeTargetAnimatableFromInstance(t, this.props, n);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < ev.length; r++) {
      const o = ev[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const a = t["on" + o];
      a && (this.propEventSubscriptions[o] = this.on(o, a));
    }
    this.prevMotionValues = VU(this, this.scrapeMotionValuesFromProps(t, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(t = !1) {
    if (t)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const r = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (r.initial = this.props.initial), r;
    }
    const n = {};
    for (let r = 0; r < FU; r++) {
      const o = yg[r], a = this.props[o];
      ($1(a) || a === !1) && (n[o] = a);
    }
    return n;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    n !== this.values.get(t) && (this.removeValue(t), this.bindToMotionValue(t, n)), this.values.set(t, n), this.latestValues[t] = n.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Hu(n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t) {
    var n;
    return this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (n = this.getBaseTargetFromProps(this.props, t)) !== null && n !== void 0 ? n : this.readValueFromInstance(this.current, t, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: r } = this.props, o = typeof r == "string" || typeof r == "object" ? (n = Lg(this.props, r)) === null || n === void 0 ? void 0 : n[t] : void 0;
    if (r && o !== void 0)
      return o;
    const a = this.getBaseTargetFromProps(this.props, t);
    return a !== void 0 && !eo(a) ? a : this.initialValues[t] !== void 0 && o === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new Og()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class yA extends BU {
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  makeTargetAnimatableFromInstance({ transition: t, transitionEnd: n, ...r }, { transformValues: o }, a) {
    let s = ez(r, t || {}, this);
    if (o && (n && (n = o(n)), r && (r = o(r)), s && (s = o(s))), a) {
      KW(this, r, s);
      const l = PU(this, r, s, n);
      n = l.transitionEnd, r = l.target;
    }
    return {
      transition: t,
      transitionEnd: n,
      ...r
    };
  }
}
function HU(e) {
  return window.getComputedStyle(e);
}
class GU extends yA {
  constructor() {
    super(...arguments), this.type = "html";
  }
  readValueFromInstance(t, n) {
    if (Ml.has(n)) {
      const r = Ng(n);
      return r && r.default || 0;
    } else {
      const r = HU(t), o = (iS(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return iA(t, n);
  }
  build(t, n, r, o) {
    Mg(t, n, r, o.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n) {
    return wg(t, n);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    eo(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
  renderInstance(t, n, r, o) {
    fS(t, n, r, o);
  }
}
class $U extends yA {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Ml.has(n)) {
      const r = Ng(n);
      return r && r.default || 0;
    }
    return n = hS.has(n) ? n : Cg(n), t.getAttribute(n);
  }
  measureInstanceViewportBox() {
    return Yn();
  }
  scrapeMotionValuesFromProps(t, n) {
    return mS(t, n);
  }
  build(t, n, r, o) {
    _g(t, n, r, this.isSVGTag, o.transformTemplate);
  }
  renderInstance(t, n, r, o) {
    pS(t, n, r, o);
  }
  mount(t) {
    this.isSVGTag = Ig(t.tagName), super.mount(t);
  }
}
const ZU = (e, t) => Ag(e) ? new $U(t, { enableHardwareAcceleration: !1 }) : new GU(t, { enableHardwareAcceleration: !0 }), jU = {
  layout: {
    ProjectionNode: gA,
    MeasureLayout: uA
  }
}, WU = {
  ...mz,
  ...Oj,
  ...SU,
  ...jU
}, $a = /* @__PURE__ */ zZ((e, t) => xj(e, t, WU, ZU));
function SA() {
  const e = He(!1);
  return vg(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function zU() {
  const e = SA(), [t, n] = je(0), r = te(() => {
    e.current && n(t + 1);
  }, [t]);
  return [te(() => vn.postRender(r), [r]), t];
}
class UU extends De.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function XU({ children: e, isPresent: t }) {
  const n = Xo(), r = He(null), o = He({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return sy(() => {
    const { width: a, height: s, top: l, left: c } = o.current;
    if (t || !r.current || !a || !s)
      return;
    r.current.dataset.motionPopId = n;
    const d = document.createElement("style");
    return document.head.appendChild(d), d.sheet && d.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${a}px !important;
            height: ${s}px !important;
            top: ${l}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(d);
    };
  }, [t]), De.createElement(UU, { isPresent: t, childRef: r, sizeRef: o }, De.cloneElement(e, { ref: r }));
}
const Om = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: o, presenceAffectsLayout: a, mode: s }) => {
  const l = gS(YU), c = Xo(), d = Et(
    () => ({
      id: c,
      initial: t,
      isPresent: n,
      custom: o,
      onExitComplete: (f) => {
        l.set(f, !0);
        for (const h of l.values())
          if (!h)
            return;
        r && r();
      },
      register: (f) => (l.set(f, !1), () => l.delete(f))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    a ? void 0 : [n]
  );
  return Et(() => {
    l.forEach((f, h) => l.set(h, !1));
  }, [n]), De.useEffect(() => {
    !n && !l.size && r && r();
  }, [n]), s === "popLayout" && (e = De.createElement(XU, { isPresent: n }, e)), De.createElement(nd.Provider, { value: d }, e);
};
function YU() {
  return /* @__PURE__ */ new Map();
}
function qU(e) {
  return ft(() => () => e(), []);
}
const Us = (e) => e.key || "";
function JU(e, t) {
  e.forEach((n) => {
    const r = Us(n);
    t.set(r, n);
  });
}
function KU(e) {
  const t = [];
  return $f.forEach(e, (n) => {
    tc(n) && t.push(n);
  }), t;
}
const Ss = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, exitBeforeEnter: o, presenceAffectsLayout: a = !0, mode: s = "sync" }) => {
  $o(!o, "Replace exitBeforeEnter with mode='wait'");
  const l = Zn(Sg).forceRender || zU()[0], c = SA(), d = KU(e);
  let f = d;
  const h = He(/* @__PURE__ */ new Map()).current, m = He(f), g = He(/* @__PURE__ */ new Map()).current, b = He(!0);
  if (vg(() => {
    b.current = !1, JU(d, g), m.current = f;
  }), qU(() => {
    b.current = !0, g.clear(), h.clear();
  }), b.current)
    return De.createElement(De.Fragment, null, f.map((x) => De.createElement(Om, { key: Us(x), isPresent: !0, initial: n ? void 0 : !1, presenceAffectsLayout: a, mode: s }, x)));
  f = [...f];
  const C = m.current.map(Us), y = d.map(Us), _ = C.length;
  for (let x = 0; x < _; x++) {
    const I = C[x];
    y.indexOf(I) === -1 && !h.has(I) && h.set(I, void 0);
  }
  return s === "wait" && h.size && (f = []), h.forEach((x, I) => {
    if (y.indexOf(I) !== -1)
      return;
    const R = g.get(I);
    if (!R)
      return;
    const E = C.indexOf(I);
    let k = x;
    if (!k) {
      const N = () => {
        h.delete(I);
        const P = Array.from(g.keys()).filter((F) => !y.includes(F));
        if (P.forEach((F) => g.delete(F)), m.current = d.filter((F) => {
          const G = Us(F);
          return (
            // filter out the node exiting
            G === I || // filter out the leftover children
            P.includes(G)
          );
        }), !h.size) {
          if (c.current === !1)
            return;
          l(), r && r();
        }
      };
      k = De.createElement(Om, { key: Us(R), isPresent: !1, onExitComplete: N, custom: t, presenceAffectsLayout: a, mode: s }, R), h.set(I, k);
    }
    f.splice(E, 0, k);
  }), f = f.map((x) => {
    const I = x.key;
    return h.has(I) ? x : De.createElement(Om, { key: Us(x), isPresent: !0, presenceAffectsLayout: a, mode: s }, x);
  }), process.env.NODE_ENV !== "production" && s === "wait" && f.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), De.createElement(De.Fragment, null, h.size ? f : f.map((x) => Fa(x)));
}, QU = (e, t) => e.find((n) => n.id === t);
function tv(e, t) {
  const n = AA(e, t), r = n ? e[n].findIndex((o) => o.id === t) : -1;
  return {
    position: n,
    index: r
  };
}
function AA(e, t) {
  for (const [n, r] of Object.entries(e))
    if (QU(r, t))
      return n;
}
function eX(e) {
  const t = e.includes("right"), n = e.includes("left");
  let r = "center";
  return t && (r = "flex-end"), n && (r = "flex-start"), {
    display: "flex",
    flexDirection: "column",
    alignItems: r
  };
}
function tX(e) {
  const n = e === "top" || e === "bottom" ? "0 auto" : void 0, r = e.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0, o = e.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0, a = e.includes("left") ? void 0 : "env(safe-area-inset-right, 0px)", s = e.includes("right") ? void 0 : "env(safe-area-inset-left, 0px)";
  return {
    position: "fixed",
    zIndex: "var(--toast-z-index, 5500)",
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    margin: n,
    top: r,
    bottom: o,
    right: a,
    left: s
  };
}
const nX = /* @__PURE__ */ new Set([
  ...OV,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]), rX = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function oX(e) {
  return (rX.has(e) || !nX.has(e)) && e[0] !== "_";
}
const aX = Fk(mk), iX = ({ baseStyle: e }) => (t) => {
  const { theme: n, css: r, __css: o, sx: a, ...s } = t, [l] = zk(s, BV), c = da(e, t), d = xk(
    {},
    o,
    c,
    sg(l),
    a
  ), f = Ey(d)(t.theme);
  return r ? [f, r] : f;
};
function Fm(e, t) {
  const { baseStyle: n, ...r } = t ?? {};
  r.shouldForwardProp || (r.shouldForwardProp = oX);
  const o = iX({ baseStyle: n }), a = aX(
    e,
    r
  )(o);
  return nt(
    function(c, d) {
      const { children: f, ...h } = c, { colorMode: m, forced: g } = gg();
      return ly(
        a,
        { ref: d, "data-theme": g ? m : void 0, ...h },
        f
      );
    }
  );
}
function sX() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(Fm, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply(t, n, r) {
      return Fm(...r);
    },
    /**
     * @example
     * <chakra.div />
     */
    get(t, n) {
      return e.has(n) || e.set(n, Fm(n)), e.get(n);
    }
  });
}
const Ne = sX(), lX = {
  initial: (e) => {
    const { position: t } = e, n = ["top", "bottom"].includes(t) ? "y" : "x";
    let r = ["top-right", "bottom-right"].includes(t) ? 1 : -1;
    return t === "bottom" && (r = 1), {
      opacity: 0,
      [n]: r * 24
    };
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
}, MA = lk((e) => {
  const {
    id: t,
    message: n,
    onCloseComplete: r,
    onRequestRemove: o,
    requestClose: a = !1,
    position: s = "bottom",
    duration: l = 5e3,
    containerStyle: c,
    motionVariants: d = lX,
    toastSpacing: f = "0.5rem"
  } = e, [h, m] = je(l), g = Oz();
  ul(() => {
    g || r == null || r();
  }, [g]), ul(() => {
    m(l);
  }, [l]);
  const b = () => m(null), C = () => m(l), y = () => {
    g && o();
  };
  ft(() => {
    g && a && o();
  }, [g, a, o]), rV(y, h);
  const _ = Et(
    () => ({
      pointerEvents: "auto",
      maxWidth: 560,
      minWidth: 300,
      margin: f,
      ...c
    }),
    [c, f]
  ), x = Et(() => eX(s), [s]);
  return /* @__PURE__ */ A.jsx(
    $a.div,
    {
      layout: !0,
      className: "chakra-toast",
      variants: d,
      initial: "initial",
      animate: "animate",
      exit: "exit",
      onHoverStart: b,
      onHoverEnd: C,
      custom: { position: s },
      style: x,
      children: /* @__PURE__ */ A.jsx(
        Ne.div,
        {
          role: "status",
          "aria-atomic": "true",
          className: "chakra-toast__inner",
          __css: _,
          children: da(n, { id: t, onClose: y })
        }
      )
    }
  );
});
MA.displayName = "ToastComponent";
function Ze(e) {
  return nt(e);
}
var uX = typeof Element < "u", cX = typeof Map == "function", dX = typeof Set == "function", fX = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function I2(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, o;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!I2(e[r], t[r]))
          return !1;
      return !0;
    }
    var a;
    if (cX && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (a = e.entries(); !(r = a.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (a = e.entries(); !(r = a.next()).done; )
        if (!I2(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (dX && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (a = e.entries(); !(r = a.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (fX && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, o[r]))
        return !1;
    if (uX && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((o[r] === "_owner" || o[r] === "__v" || o[r] === "__o") && e.$$typeof) && !I2(e[o[r]], t[o[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var hX = function(t, n) {
  try {
    return I2(t, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const pX = /* @__PURE__ */ jf(hX);
function rh() {
  const e = Zn(
    pk
  );
  if (!e)
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  return e;
}
function mX() {
  const e = gg(), t = rh();
  return { ...e, theme: t };
}
function gX(e) {
  return Object.fromEntries(
    Object.entries(e).filter(([t, n]) => n !== void 0 && t !== "children" && !tc(n))
  );
}
function xA(e, t = {}) {
  const { styleConfig: n, ...r } = t, { theme: o, colorMode: a } = mX(), s = e ? gy(o, `components.${e}`) : void 0, l = n || s, c = Bo(
    { theme: o, colorMode: a },
    (l == null ? void 0 : l.defaultProps) ?? {},
    gX(r),
    (f, h) => f ? void 0 : h
  ), d = He({});
  if (l) {
    const h = qV(l)(c);
    pX(d.current, h) || (d.current = h);
  }
  return d.current;
}
function _l(e, t = {}) {
  return xA(e, t);
}
function Ir(e, t = {}) {
  return xA(e, t);
}
const nv = {
  path: /* @__PURE__ */ A.jsxs("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ A.jsx(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ A.jsx("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
}, Li = Ze((e, t) => {
  const {
    as: n,
    viewBox: r,
    color: o = "currentColor",
    focusable: a = !1,
    children: s,
    className: l,
    __css: c,
    ...d
  } = e, f = Ye("chakra-icon", l), h = _l("Icon", e), m = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: o,
    ...c,
    ...h
  }, g = {
    ref: t,
    focusable: a,
    className: f,
    __css: m
  }, b = r ?? nv.viewBox;
  if (n && typeof n != "string")
    return /* @__PURE__ */ A.jsx(Ne.svg, { as: n, ...g, ...d });
  const C = s ?? nv.path;
  return /* @__PURE__ */ A.jsx(Ne.svg, { verticalAlign: "middle", viewBox: b, ...g, ...d, children: C });
});
Li.displayName = "Icon";
function vX(e) {
  return /* @__PURE__ */ A.jsx(Li, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ A.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
    }
  ) });
}
function CX(e) {
  return /* @__PURE__ */ A.jsx(Li, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ A.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
    }
  ) });
}
function rv(e) {
  return /* @__PURE__ */ A.jsx(Li, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ A.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    }
  ) });
}
const bX = Q1({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), _A = Ze((e, t) => {
  const n = _l("Spinner", e), {
    label: r = "Loading...",
    thickness: o = "2px",
    speed: a = "0.45s",
    emptyColor: s = "transparent",
    className: l,
    ...c
  } = Wn(e), d = Ye("chakra-spinner", l), f = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: o,
    borderBottomColor: s,
    borderLeftColor: s,
    animation: `${bX} ${a} linear infinite`,
    ...n
  };
  return /* @__PURE__ */ A.jsx(
    Ne.div,
    {
      ref: t,
      __css: f,
      className: d,
      ...c,
      children: r && /* @__PURE__ */ A.jsx(Ne.span, { srOnly: !0, children: r })
    }
  );
});
_A.displayName = "Spinner";
const [yX, Bg] = bn({
  name: "AlertContext",
  hookName: "useAlertContext",
  providerName: "<Alert />"
}), [SX, Hg] = bn({
  name: "AlertStylesContext",
  hookName: "useAlertStyles",
  providerName: "<Alert />"
}), IA = {
  info: { icon: CX, colorScheme: "blue" },
  warning: { icon: rv, colorScheme: "orange" },
  success: { icon: vX, colorScheme: "green" },
  error: { icon: rv, colorScheme: "red" },
  loading: { icon: _A, colorScheme: "blue" }
};
function AX(e) {
  return IA[e].colorScheme;
}
function MX(e) {
  return IA[e].icon;
}
const Gg = Ze(function(t, n) {
  const { status: r = "info", addRole: o = !0, ...a } = Wn(t), s = t.colorScheme ?? AX(r), l = Ir("Alert", { ...t, colorScheme: s }), c = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    ...l.container
  };
  return /* @__PURE__ */ A.jsx(yX, { value: { status: r }, children: /* @__PURE__ */ A.jsx(SX, { value: l, children: /* @__PURE__ */ A.jsx(
    Ne.div,
    {
      "data-status": r,
      role: o ? "alert" : void 0,
      ref: n,
      ...a,
      className: Ye("chakra-alert", t.className),
      __css: c
    }
  ) }) });
});
Gg.displayName = "Alert";
function $g(e) {
  const { status: t } = Bg(), n = MX(t), r = Hg(), o = t === "loading" ? r.spinner : r.icon;
  return /* @__PURE__ */ A.jsx(
    Ne.span,
    {
      display: "inherit",
      "data-status": t,
      ...e,
      className: Ye("chakra-alert__icon", e.className),
      __css: o,
      children: e.children || /* @__PURE__ */ A.jsx(n, { h: "100%", w: "100%" })
    }
  );
}
$g.displayName = "AlertIcon";
const wA = Ze(
  function(t, n) {
    const r = Hg(), { status: o } = Bg();
    return /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ref: n,
        "data-status": o,
        ...t,
        className: Ye("chakra-alert__title", t.className),
        __css: r.title
      }
    );
  }
);
wA.displayName = "AlertTitle";
const LA = Ze(
  function(t, n) {
    const { status: r } = Bg(), o = Hg(), a = {
      display: "inline",
      ...o.description
    };
    return /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ref: n,
        "data-status": r,
        ...t,
        className: Ye("chakra-alert__desc", t.className),
        __css: a
      }
    );
  }
);
LA.displayName = "AlertDescription";
function xX(e) {
  return /* @__PURE__ */ A.jsx(Li, { focusable: "false", "aria-hidden": !0, ...e, children: /* @__PURE__ */ A.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
    }
  ) });
}
const oh = Ze(
  function(t, n) {
    const r = _l("CloseButton", t), { children: o, isDisabled: a, __css: s, ...l } = Wn(t), c = {
      outline: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0
    };
    return /* @__PURE__ */ A.jsx(
      Ne.button,
      {
        type: "button",
        "aria-label": "Close",
        ref: n,
        disabled: a,
        __css: {
          ...c,
          ...r,
          ...s
        },
        ...l,
        children: o || /* @__PURE__ */ A.jsx(xX, { width: "1em", height: "1em" })
      }
    );
  }
);
oh.displayName = "CloseButton";
const _X = (e) => {
  const {
    status: t,
    variant: n = "solid",
    id: r,
    title: o,
    isClosable: a,
    onClose: s,
    description: l,
    colorScheme: c,
    icon: d
  } = e, f = r ? {
    root: `toast-${r}`,
    title: `toast-${r}-title`,
    description: `toast-${r}-description`
  } : void 0;
  return /* @__PURE__ */ A.jsxs(
    Gg,
    {
      addRole: !1,
      status: t,
      variant: n,
      id: f == null ? void 0 : f.root,
      alignItems: "start",
      borderRadius: "md",
      boxShadow: "lg",
      paddingEnd: 8,
      textAlign: "start",
      width: "auto",
      colorScheme: c,
      children: [
        /* @__PURE__ */ A.jsx($g, { children: d }),
        /* @__PURE__ */ A.jsxs(Ne.div, { flex: "1", maxWidth: "100%", children: [
          o && /* @__PURE__ */ A.jsx(wA, { id: f == null ? void 0 : f.title, children: o }),
          l && /* @__PURE__ */ A.jsx(LA, { id: f == null ? void 0 : f.description, display: "block", children: l })
        ] }),
        a && /* @__PURE__ */ A.jsx(
          oh,
          {
            size: "sm",
            onClick: s,
            position: "absolute",
            insetEnd: 1,
            top: 1
          }
        )
      ]
    }
  );
};
function IX(e = {}) {
  const { render: t, toastComponent: n = _X } = e;
  return (o) => typeof t == "function" ? t({ ...o, ...e }) : /* @__PURE__ */ A.jsx(n, { ...o, ...e });
}
const wX = {
  top: [],
  "top-left": [],
  "top-right": [],
  "bottom-left": [],
  bottom: [],
  "bottom-right": []
}, L1 = LX(wX);
function LX(e) {
  let t = e;
  const n = /* @__PURE__ */ new Set(), r = (o) => {
    t = o(t), n.forEach((a) => a());
  };
  return {
    getState: () => t,
    subscribe: (o) => (n.add(o), () => {
      r(() => e), n.delete(o);
    }),
    /**
     * Delete a toast record at its position
     */
    removeToast: (o, a) => {
      r((s) => ({
        ...s,
        // id may be string or number
        // eslint-disable-next-line eqeqeq
        [a]: s[a].filter((l) => l.id != o)
      }));
    },
    notify: (o, a) => {
      const s = RX(o, a), { position: l, id: c } = s;
      return r((d) => {
        const h = l.includes("top") ? [s, ...d[l] ?? []] : [...d[l] ?? [], s];
        return {
          ...d,
          [l]: h
        };
      }), c;
    },
    update: (o, a) => {
      o && r((s) => {
        const l = { ...s }, { position: c, index: d } = tv(l, o);
        return c && d !== -1 && (l[c][d] = {
          ...l[c][d],
          ...a,
          message: IX(a)
        }), l;
      });
    },
    closeAll: ({ positions: o } = {}) => {
      r((a) => (o ?? [
        "bottom",
        "bottom-right",
        "bottom-left",
        "top",
        "top-left",
        "top-right"
      ]).reduce(
        (c, d) => (c[d] = a[d].map((f) => ({
          ...f,
          requestClose: !0
        })), c),
        { ...a }
      ));
    },
    close: (o) => {
      r((a) => {
        const s = AA(a, o);
        return s ? {
          ...a,
          [s]: a[s].map((l) => l.id == o ? {
            ...l,
            requestClose: !0
          } : l)
        } : a;
      });
    },
    isActive: (o) => !!tv(L1.getState(), o).position
  };
}
let ov = 0;
function RX(e, t = {}) {
  ov += 1;
  const n = t.id ?? ov, r = t.position ?? "bottom";
  return {
    id: n,
    message: e,
    position: r,
    duration: t.duration,
    onCloseComplete: t.onCloseComplete,
    onRequestRemove: () => L1.removeToast(String(n), r),
    status: t.status,
    requestClose: !1,
    containerStyle: t.containerStyle
  };
}
const [RA, EX] = bn({
  strict: !1,
  name: "PortalContext"
}), Zg = "chakra-portal", DX = ".chakra-portal", NX = (e) => /* @__PURE__ */ A.jsx(
  "div",
  {
    className: "chakra-portal-zIndex",
    style: {
      position: "absolute",
      zIndex: e.zIndex,
      top: 0,
      left: 0,
      right: 0
      // NB: Don't add `bottom: 0`, it makes the entire app unusable
      // @see https://github.com/chakra-ui/chakra-ui/issues/3201
    },
    children: e.children
  }
), TX = (e) => {
  const { appendToParentPortal: t, children: n } = e, [r, o] = je(null), a = He(null), [, s] = je({});
  ft(() => s({}), []);
  const l = EX(), c = kZ();
  ls(() => {
    if (!r)
      return;
    const f = r.ownerDocument, h = t ? l ?? f.body : f.body;
    if (!h)
      return;
    a.current = f.createElement("div"), a.current.className = Zg, h.appendChild(a.current), s({});
    const m = a.current;
    return () => {
      h.contains(m) && h.removeChild(m);
    };
  }, [r]);
  const d = c != null && c.zIndex ? /* @__PURE__ */ A.jsx(NX, { zIndex: c == null ? void 0 : c.zIndex, children: n }) : n;
  return a.current ? og(
    /* @__PURE__ */ A.jsx(RA, { value: a.current, children: d }),
    a.current
  ) : /* @__PURE__ */ A.jsx(
    "span",
    {
      ref: (f) => {
        f && o(f);
      }
    }
  );
}, PX = (e) => {
  const { children: t, containerRef: n, appendToParentPortal: r } = e, o = n.current, a = o ?? (typeof window < "u" ? document.body : void 0), s = Et(() => {
    const c = o == null ? void 0 : o.ownerDocument.createElement("div");
    return c && (c.className = Zg), c;
  }, [o]), [, l] = je({});
  return ls(() => l({}), []), ls(() => {
    if (!(!s || !a))
      return a.appendChild(s), () => {
        a.removeChild(s);
      };
  }, [s, a]), a && s ? og(
    /* @__PURE__ */ A.jsx(RA, { value: r ? s : null, children: t }),
    s
  ) : null;
};
function rc(e) {
  const t = {
    appendToParentPortal: !0,
    ...e
  }, { containerRef: n, ...r } = t;
  return n ? /* @__PURE__ */ A.jsx(PX, { containerRef: n, ...r }) : /* @__PURE__ */ A.jsx(TX, { ...r });
}
rc.className = Zg;
rc.selector = DX;
rc.displayName = "Portal";
const [kX, Ime] = bn({
  name: "ToastOptionsContext",
  strict: !1
}), VX = (e) => {
  const t = uk(
    L1.subscribe,
    L1.getState,
    L1.getState
  ), {
    motionVariants: n,
    component: r = MA,
    portalProps: o,
    animatePresenceProps: a
  } = e, l = Object.keys(t).map((c) => {
    const d = t[c];
    return /* @__PURE__ */ A.jsx(
      "div",
      {
        role: "region",
        "aria-live": "polite",
        "aria-label": `Notifications-${c}`,
        id: `chakra-toast-manager-${c}`,
        style: tX(c),
        children: /* @__PURE__ */ A.jsx(Ss, { ...a, initial: !1, children: d.map((f) => /* @__PURE__ */ A.jsx(
          r,
          {
            motionVariants: n,
            ...f
          },
          f.id
        )) })
      },
      c
    );
  });
  return /* @__PURE__ */ A.jsx(rc, { ...o, children: l });
}, OX = (e) => function({
  children: n,
  theme: r = e,
  toastOptions: o,
  ...a
}) {
  return /* @__PURE__ */ A.jsxs(VZ, { theme: r, ...a, children: [
    /* @__PURE__ */ A.jsx(kX, { value: o == null ? void 0 : o.defaultOptions, children: n }),
    /* @__PURE__ */ A.jsx(VX, { ...o })
  ] });
}, FX = OX(zy);
function av(e) {
  return e.sort((t, n) => {
    const r = t.compareDocumentPosition(n);
    if (r & Node.DOCUMENT_POSITION_FOLLOWING || r & Node.DOCUMENT_POSITION_CONTAINED_BY)
      return -1;
    if (r & Node.DOCUMENT_POSITION_PRECEDING || r & Node.DOCUMENT_POSITION_CONTAINS)
      return 1;
    if (r & Node.DOCUMENT_POSITION_DISCONNECTED || r & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC)
      throw Error("Cannot sort the given nodes.");
    return 0;
  });
}
const BX = (e) => typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
function iv(e, t, n) {
  let r = e + 1;
  return n && r >= t && (r = 0), r;
}
function sv(e, t, n) {
  let r = e - 1;
  return n && r < 0 && (r = t), r;
}
const Bm = typeof window < "u" ? nc : ft, lv = (e) => e;
var HX = Object.defineProperty, GX = (e, t, n) => t in e ? HX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Vn = (e, t, n) => (GX(e, typeof t != "symbol" ? t + "" : t, n), n);
class $X {
  constructor() {
    Vn(this, "descendants", /* @__PURE__ */ new Map()), Vn(this, "register", (t) => {
      if (t != null)
        return BX(t) ? this.registerNode(t) : (n) => {
          this.registerNode(n, t);
        };
    }), Vn(this, "unregister", (t) => {
      this.descendants.delete(t);
      const n = av(Array.from(this.descendants.keys()));
      this.assignIndex(n);
    }), Vn(this, "destroy", () => {
      this.descendants.clear();
    }), Vn(this, "assignIndex", (t) => {
      this.descendants.forEach((n) => {
        const r = t.indexOf(n.node);
        n.index = r, n.node.dataset.index = n.index.toString();
      });
    }), Vn(this, "count", () => this.descendants.size), Vn(this, "enabledCount", () => this.enabledValues().length), Vn(this, "values", () => Array.from(this.descendants.values()).sort((n, r) => n.index - r.index)), Vn(this, "enabledValues", () => this.values().filter((t) => !t.disabled)), Vn(this, "item", (t) => {
      if (this.count() !== 0)
        return this.values()[t];
    }), Vn(this, "enabledItem", (t) => {
      if (this.enabledCount() !== 0)
        return this.enabledValues()[t];
    }), Vn(this, "first", () => this.item(0)), Vn(this, "firstEnabled", () => this.enabledItem(0)), Vn(this, "last", () => this.item(this.descendants.size - 1)), Vn(this, "lastEnabled", () => {
      const t = this.enabledValues().length - 1;
      return this.enabledItem(t);
    }), Vn(this, "indexOf", (t) => {
      var n;
      return t ? ((n = this.descendants.get(t)) == null ? void 0 : n.index) ?? -1 : -1;
    }), Vn(this, "enabledIndexOf", (t) => t == null ? -1 : this.enabledValues().findIndex((n) => n.node.isSameNode(t))), Vn(this, "next", (t, n = !0) => {
      const r = iv(t, this.count(), n);
      return this.item(r);
    }), Vn(this, "nextEnabled", (t, n = !0) => {
      const r = this.item(t);
      if (!r)
        return;
      const o = this.enabledIndexOf(r.node), a = iv(
        o,
        this.enabledCount(),
        n
      );
      return this.enabledItem(a);
    }), Vn(this, "prev", (t, n = !0) => {
      const r = sv(t, this.count() - 1, n);
      return this.item(r);
    }), Vn(this, "prevEnabled", (t, n = !0) => {
      const r = this.item(t);
      if (!r)
        return;
      const o = this.enabledIndexOf(r.node), a = sv(
        o,
        this.enabledCount() - 1,
        n
      );
      return this.enabledItem(a);
    }), Vn(this, "registerNode", (t, n) => {
      if (!t || this.descendants.has(t))
        return;
      const r = Array.from(this.descendants.keys()).concat(t), o = av(r);
      n != null && n.disabled && (n.disabled = !!n.disabled);
      const a = { node: t, index: -1, ...n };
      this.descendants.set(t, a), this.assignIndex(o);
    });
  }
}
function EA() {
  const [e, t] = bn({
    name: "DescendantsProvider",
    errorMessage: "useDescendantsContext must be used within DescendantsProvider"
  });
  return [
    // context provider
    e,
    // call this when you need to read from context
    t,
    () => {
      const o = He(new $X());
      return Bm(() => () => o.current.destroy()), o.current;
    },
    (o) => {
      const a = t(), [s, l] = je(-1), c = He(null);
      Bm(() => () => {
        c.current && a.unregister(c.current);
      }, []), Bm(() => {
        if (!c.current)
          return;
        const f = Number(c.current.dataset.index);
        s != f && !Number.isNaN(f) && l(f);
      });
      const d = lv(o ? a.register(o) : a.register);
      return {
        descendants: a,
        index: s,
        enabledIndex: a.enabledIndexOf(c.current),
        register: ir(d, c)
      };
    }
  ];
}
const [ZX, ah] = bn({
  name: "AccordionStylesContext",
  hookName: "useAccordionStyles",
  providerName: "<Accordion />"
}), [jX, jg] = bn({
  name: "AccordionItemContext",
  hookName: "useAccordionItemContext",
  providerName: "<AccordionItem />"
}), [
  WX,
  wme,
  zX,
  UX
] = EA();
function XX(e) {
  const {
    onChange: t,
    defaultIndex: n,
    index: r,
    allowMultiple: o,
    allowToggle: a,
    ...s
  } = e;
  JX(e), KX(e);
  const l = zX(), [c, d] = je(-1);
  ft(() => () => {
    d(-1);
  }, []);
  const [f, h] = Sy({
    value: r,
    defaultValue() {
      return o ? n ?? [] : n ?? -1;
    },
    onChange: t
  });
  return {
    index: f,
    setIndex: h,
    htmlProps: s,
    getAccordionItemProps: (g) => {
      let b = !1;
      return g !== null && (b = Array.isArray(f) ? f.includes(g) : f === g), { isOpen: b, onChange: (y) => {
        if (g !== null)
          if (o && Array.isArray(f)) {
            const _ = y ? f.concat(g) : f.filter((x) => x !== g);
            h(_);
          } else
            y ? h(g) : a && h(-1);
      } };
    },
    focusedIndex: c,
    setFocusedIndex: d,
    descendants: l
  };
}
const [YX, Wg] = bn({
  name: "AccordionContext",
  hookName: "useAccordionContext",
  providerName: "Accordion"
});
function qX(e) {
  const { isDisabled: t, isFocusable: n, id: r, ...o } = e, { getAccordionItemProps: a, setFocusedIndex: s } = Wg(), l = He(null), c = Xo(), d = r ?? c, f = `accordion-button-${d}`, h = `accordion-panel-${d}`;
  QX(e);
  const { register: m, index: g, descendants: b } = UX({
    disabled: t && !n
  }), { isOpen: C, onChange: y } = a(
    g === -1 ? null : g
  );
  eY({ isOpen: C, isDisabled: t });
  const _ = () => {
    y == null || y(!0);
  }, x = () => {
    y == null || y(!1);
  }, I = te(() => {
    y == null || y(!C), s(g);
  }, [g, s, C, y]), R = te(
    (P) => {
      const G = {
        ArrowDown: () => {
          const j = b.nextEnabled(g);
          j == null || j.node.focus();
        },
        ArrowUp: () => {
          const j = b.prevEnabled(g);
          j == null || j.node.focus();
        },
        Home: () => {
          const j = b.firstEnabled();
          j == null || j.node.focus();
        },
        End: () => {
          const j = b.lastEnabled();
          j == null || j.node.focus();
        }
      }[P.key];
      G && (P.preventDefault(), G(P));
    },
    [b, g]
  ), E = te(() => {
    s(g);
  }, [s, g]), k = te(
    function(F = {}, G = null) {
      return {
        ...F,
        type: "button",
        ref: ir(m, l, G),
        id: f,
        disabled: !!t,
        "aria-expanded": !!C,
        "aria-controls": h,
        onClick: lt(F.onClick, I),
        onFocus: lt(F.onFocus, E),
        onKeyDown: lt(F.onKeyDown, R)
      };
    },
    [
      f,
      t,
      C,
      I,
      E,
      R,
      h,
      m
    ]
  ), N = te(
    function(F = {}, G = null) {
      return {
        ...F,
        ref: G,
        role: "region",
        id: h,
        "aria-labelledby": f,
        hidden: !C
      };
    },
    [f, C, h]
  );
  return {
    isOpen: C,
    isDisabled: t,
    isFocusable: n,
    onOpen: _,
    onClose: x,
    getButtonProps: k,
    getPanelProps: N,
    htmlProps: o
  };
}
function JX(e) {
  const t = e.index || e.defaultIndex, n = t != null && !Array.isArray(t) && e.allowMultiple;
  ed({
    condition: !!n,
    message: `If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: ${typeof t},`
  });
}
function KX(e) {
  ed({
    condition: !!(e.allowMultiple && e.allowToggle),
    message: "If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not"
  });
}
function QX(e) {
  ed({
    condition: !!(e.isFocusable && !e.isDisabled),
    message: `Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.
    `
  });
}
function eY(e) {
  ed({
    condition: e.isOpen && !!e.isDisabled,
    message: "Cannot open a disabled accordion item"
  });
}
const DA = Ze(function({ children: t, reduceMotion: n, ...r }, o) {
  const a = Ir("Accordion", r), s = Wn(r), { htmlProps: l, descendants: c, ...d } = XX(s), f = Et(
    () => ({ ...d, reduceMotion: !!n }),
    [d, n]
  );
  return /* @__PURE__ */ A.jsx(WX, { value: c, children: /* @__PURE__ */ A.jsx(YX, { value: f, children: /* @__PURE__ */ A.jsx(ZX, { value: a, children: /* @__PURE__ */ A.jsx(
    Ne.div,
    {
      ref: o,
      ...l,
      className: Ye("chakra-accordion", r.className),
      __css: a.root,
      children: t
    }
  ) }) }) });
});
DA.displayName = "Accordion";
const NA = Ze(
  function(t, n) {
    const { getButtonProps: r } = jg(), o = r(t, n), s = {
      display: "flex",
      alignItems: "center",
      width: "100%",
      outline: 0,
      ...ah().button
    };
    return /* @__PURE__ */ A.jsx(
      Ne.button,
      {
        ...o,
        className: Ye("chakra-accordion__button", t.className),
        __css: s
      }
    );
  }
);
NA.displayName = "AccordionButton";
function TA(e) {
  const { isOpen: t, isDisabled: n } = jg(), { reduceMotion: r } = Wg(), o = Ye("chakra-accordion__icon", e.className), a = ah(), s = {
    opacity: n ? 0.4 : 1,
    transform: t ? "rotate(-180deg)" : void 0,
    transition: r ? void 0 : "transform 0.2s",
    transformOrigin: "center",
    ...a.icon
  };
  return /* @__PURE__ */ A.jsx(
    Li,
    {
      viewBox: "0 0 24 24",
      "aria-hidden": !0,
      className: o,
      __css: s,
      ...e,
      children: /* @__PURE__ */ A.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
        }
      )
    }
  );
}
TA.displayName = "AccordionIcon";
const PA = Ze(
  function(t, n) {
    const { children: r, className: o } = t, { htmlProps: a, ...s } = qX(t), l = ah(), c = {
      ...l.container,
      overflowAnchor: "none"
    }, d = Et(() => s, [s]);
    return /* @__PURE__ */ A.jsx(jX, { value: d, children: /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ref: n,
        ...a,
        className: Ye("chakra-accordion__item", o),
        __css: c,
        children: typeof r == "function" ? r({
          isExpanded: !!s.isOpen,
          isDisabled: !!s.isDisabled
        }) : r
      }
    ) });
  }
);
PA.displayName = "AccordionItem";
const el = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
}, Uc = {
  scale: {
    enter: { scale: 1 },
    exit: { scale: 0.95 }
  },
  fade: {
    enter: { opacity: 1 },
    exit: { opacity: 0 }
  },
  pushLeft: {
    enter: { x: "100%" },
    exit: { x: "-30%" }
  },
  pushRight: {
    enter: { x: "-100%" },
    exit: { x: "30%" }
  },
  pushUp: {
    enter: { y: "100%" },
    exit: { y: "-30%" }
  },
  pushDown: {
    enter: { y: "-100%" },
    exit: { y: "30%" }
  },
  slideLeft: {
    position: { left: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "-100%", y: 0 }
  },
  slideRight: {
    position: { right: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "100%", y: 0 }
  },
  slideUp: {
    position: { top: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "-100%" }
  },
  slideDown: {
    position: { bottom: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "100%" }
  }
};
function r3(e) {
  switch ((e == null ? void 0 : e.direction) ?? "right") {
    case "right":
      return Uc.slideRight;
    case "left":
      return Uc.slideLeft;
    case "bottom":
      return Uc.slideDown;
    case "top":
      return Uc.slideUp;
    default:
      return Uc.slideRight;
  }
}
const il = {
  enter: {
    duration: 0.2,
    ease: el.easeOut
  },
  exit: {
    duration: 0.1,
    ease: el.easeIn
  }
}, fa = {
  enter: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t == null ? void 0 : t.enter
  }),
  exit: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t == null ? void 0 : t.exit
  })
}, tY = (e) => e != null && parseInt(e.toString(), 10) > 0, uv = {
  exit: {
    height: { duration: 0.2, ease: el.ease },
    opacity: { duration: 0.3, ease: el.ease }
  },
  enter: {
    height: { duration: 0.3, ease: el.ease },
    opacity: { duration: 0.4, ease: el.ease }
  }
}, nY = {
  exit: ({
    animateOpacity: e,
    startingHeight: t,
    transition: n,
    transitionEnd: r,
    delay: o
  }) => ({
    ...e && { opacity: tY(t) ? 1 : 0 },
    height: t,
    transitionEnd: r == null ? void 0 : r.exit,
    transition: (n == null ? void 0 : n.exit) ?? fa.exit(uv.exit, o)
  }),
  enter: ({
    animateOpacity: e,
    endingHeight: t,
    transition: n,
    transitionEnd: r,
    delay: o
  }) => ({
    ...e && { opacity: 1 },
    height: t,
    transitionEnd: r == null ? void 0 : r.enter,
    transition: (n == null ? void 0 : n.enter) ?? fa.enter(uv.enter, o)
  })
}, kA = nt(
  (e, t) => {
    const {
      in: n,
      unmountOnExit: r,
      animateOpacity: o = !0,
      startingHeight: a = 0,
      endingHeight: s = "auto",
      style: l,
      className: c,
      transition: d,
      transitionEnd: f,
      animatePresenceProps: h,
      ...m
    } = e, [g, b] = je(!1);
    ft(() => {
      const I = setTimeout(() => {
        b(!0);
      });
      return () => clearTimeout(I);
    }, []), ed({
      condition: Number(a) > 0 && !!r,
      message: "startingHeight and unmountOnExit are mutually exclusive. You can't use them together"
    });
    const C = parseFloat(a.toString()) > 0, y = {
      startingHeight: a,
      endingHeight: s,
      animateOpacity: o,
      transition: g ? d : { enter: { duration: 0 } },
      transitionEnd: {
        enter: f == null ? void 0 : f.enter,
        exit: r ? f == null ? void 0 : f.exit : {
          ...f == null ? void 0 : f.exit,
          display: C ? "block" : "none"
        }
      }
    }, _ = r ? n : !0, x = n || r ? "enter" : "exit";
    return /* @__PURE__ */ A.jsx(
      Ss,
      {
        ...h,
        initial: !1,
        custom: y,
        children: _ && /* @__PURE__ */ A.jsx(
          $a.div,
          {
            ref: t,
            ...m,
            className: Ye("chakra-collapse", c),
            style: {
              overflow: "hidden",
              display: "block",
              ...l
            },
            custom: y,
            variants: nY,
            initial: r ? "exit" : !1,
            animate: x,
            exit: "exit"
          }
        )
      }
    );
  }
);
kA.displayName = "Collapse";
const VA = Ze(
  function(t, n) {
    const { className: r, motionProps: o, ...a } = t, { reduceMotion: s } = Wg(), { getPanelProps: l, isOpen: c } = jg(), d = l(a, n), f = Ye("chakra-accordion__panel", r), h = ah();
    s || delete d.hidden;
    const m = /* @__PURE__ */ A.jsx(Ne.div, { ...d, __css: h.panel, className: f });
    return s ? m : /* @__PURE__ */ A.jsx(kA, { in: c, ...o, children: m });
  }
);
VA.displayName = "AccordionPanel";
const [rY, oY] = bn({
  name: "AvatarStylesContext",
  hookName: "useAvatarStyles",
  providerName: "<Avatar/>"
});
function aY(e) {
  const t = e.trim().split(" "), n = t[0] ?? "", r = t.length > 1 ? t[t.length - 1] : "";
  return n && r ? `${n.charAt(0)}${r.charAt(0)}` : n.charAt(0);
}
function OA(e) {
  const { name: t, getInitials: n, ...r } = e, o = oY();
  return /* @__PURE__ */ A.jsx(Ne.div, { role: "img", "aria-label": t, ...r, __css: o.label, children: t ? n == null ? void 0 : n(t) : null });
}
OA.displayName = "AvatarName";
const FA = (e) => /* @__PURE__ */ A.jsxs(
  Ne.svg,
  {
    viewBox: "0 0 128 128",
    color: "#fff",
    width: "100%",
    height: "100%",
    className: "chakra-avatar__svg",
    ...e,
    children: [
      /* @__PURE__ */ A.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
        }
      ),
      /* @__PURE__ */ A.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
        }
      )
    ]
  }
);
function iY(e) {
  const {
    loading: t,
    src: n,
    srcSet: r,
    onLoad: o,
    onError: a,
    crossOrigin: s,
    sizes: l,
    ignoreFallback: c
  } = e, [d, f] = je("pending");
  ft(() => {
    f(n ? "loading" : "pending");
  }, [n]);
  const h = He(null), m = te(() => {
    if (!n)
      return;
    g();
    const b = new Image();
    b.src = n, s && (b.crossOrigin = s), r && (b.srcset = r), l && (b.sizes = l), t && (b.loading = t), b.onload = (C) => {
      g(), f("loaded"), o == null || o(C);
    }, b.onerror = (C) => {
      g(), f("failed"), a == null || a(C);
    }, h.current = b;
  }, [n, s, r, l, o, a, t]), g = () => {
    h.current && (h.current.onload = null, h.current.onerror = null, h.current = null);
  };
  return ls(() => {
    if (!c)
      return d === "loading" && m(), () => {
        g();
      };
  }, [d, m, c]), c ? "loaded" : d;
}
function BA(e) {
  const {
    src: t,
    srcSet: n,
    onError: r,
    onLoad: o,
    getInitials: a,
    name: s,
    borderRadius: l,
    loading: c,
    iconLabel: d,
    icon: f = /* @__PURE__ */ A.jsx(FA, {}),
    ignoreFallback: h,
    referrerPolicy: m,
    crossOrigin: g
  } = e, C = iY({ src: t, onError: r, crossOrigin: g, ignoreFallback: h }) === "loaded";
  return !t || !C ? s ? /* @__PURE__ */ A.jsx(
    OA,
    {
      className: "chakra-avatar__initials",
      getInitials: a,
      name: s
    }
  ) : Fa(f, {
    role: "img",
    "aria-label": d
  }) : /* @__PURE__ */ A.jsx(
    Ne.img,
    {
      src: t,
      srcSet: n,
      alt: s ?? d,
      onLoad: o,
      referrerPolicy: m,
      crossOrigin: g ?? void 0,
      className: "chakra-avatar__img",
      loading: c,
      __css: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: l
      }
    }
  );
}
BA.displayName = "AvatarImage";
const sY = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  textTransform: "uppercase",
  fontWeight: "medium",
  position: "relative",
  flexShrink: 0
}, HA = Ze((e, t) => {
  const n = Ir("Avatar", e), [r, o] = je(!1), {
    src: a,
    srcSet: s,
    name: l,
    showBorder: c,
    borderRadius: d = "full",
    onError: f,
    onLoad: h,
    getInitials: m = aY,
    icon: g = /* @__PURE__ */ A.jsx(FA, {}),
    iconLabel: b = " avatar",
    loading: C,
    children: y,
    borderColor: _,
    ignoreFallback: x,
    crossOrigin: I,
    referrerPolicy: R,
    ...E
  } = Wn(e), k = {
    borderRadius: d,
    borderWidth: c ? "2px" : void 0,
    ...sY,
    ...n.container
  };
  return _ && (k.borderColor = _), /* @__PURE__ */ A.jsx(
    Ne.span,
    {
      ref: t,
      ...E,
      className: Ye("chakra-avatar", e.className),
      "data-loaded": ot(r),
      __css: k,
      children: /* @__PURE__ */ A.jsxs(rY, { value: n, children: [
        /* @__PURE__ */ A.jsx(
          BA,
          {
            src: a,
            srcSet: s,
            loading: C,
            onLoad: lt(h, () => {
              o(!0);
            }),
            onError: f,
            getInitials: m,
            name: l,
            borderRadius: d,
            icon: g,
            iconLabel: b,
            ignoreFallback: x,
            crossOrigin: I,
            referrerPolicy: R
          }
        ),
        y
      ] })
    }
  );
});
HA.displayName = "Avatar";
const Si = Ne("div");
Si.displayName = "Box";
const [lY, zg] = NZ("Card"), uY = Ze(function(t, n) {
  const {
    className: r,
    children: o,
    direction: a = "column",
    justify: s,
    align: l,
    ...c
  } = Wn(t), d = Ir("Card", t);
  return /* @__PURE__ */ A.jsx(
    Ne.div,
    {
      ref: n,
      className: Ye("chakra-card", r),
      __css: {
        display: "flex",
        flexDirection: a,
        justifyContent: s,
        alignItems: l,
        position: "relative",
        minWidth: 0,
        wordWrap: "break-word",
        ...d.container
      },
      ...c,
      children: /* @__PURE__ */ A.jsx(lY, { value: d, children: o })
    }
  );
}), cY = Ze(
  function(t, n) {
    const { className: r, ...o } = t, a = zg();
    return /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ref: n,
        className: Ye("chakra-card__body", r),
        __css: a.body,
        ...o
      }
    );
  }
), dY = Ze(
  function(t, n) {
    const { className: r, justify: o, ...a } = t, s = zg();
    return /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ref: n,
        className: Ye("chakra-card__footer", r),
        __css: {
          display: "flex",
          justifyContent: o,
          ...s.footer
        },
        ...a
      }
    );
  }
), fY = Ze(
  function(t, n) {
    const { className: r, ...o } = t, a = zg();
    return /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ref: n,
        className: Ye("chakra-card__header", r),
        __css: a.header,
        ...o
      }
    );
  }
), [hY, pY] = bn({
  name: "CheckboxGroupContext",
  strict: !1
});
function mY(e) {
  return /* @__PURE__ */ A.jsx(
    Ne.svg,
    {
      width: "1.2em",
      viewBox: "0 0 12 10",
      style: {
        fill: "none",
        strokeWidth: 2,
        stroke: "currentColor",
        strokeDasharray: 16
      },
      ...e,
      children: /* @__PURE__ */ A.jsx("polyline", { points: "1.5 6 4.5 9 10.5 1" })
    }
  );
}
function gY(e) {
  return /* @__PURE__ */ A.jsx(
    Ne.svg,
    {
      width: "1.2em",
      viewBox: "0 0 24 24",
      style: { stroke: "currentColor", strokeWidth: 4 },
      ...e,
      children: /* @__PURE__ */ A.jsx("line", { x1: "21", x2: "3", y1: "12", y2: "12" })
    }
  );
}
function vY(e) {
  const { isIndeterminate: t, isChecked: n, ...r } = e, o = t ? gY : mY;
  return n || t ? /* @__PURE__ */ A.jsx(
    Ne.div,
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
      },
      children: /* @__PURE__ */ A.jsx(o, { ...r })
    }
  ) : null;
}
var CY = () => typeof document < "u", cv = !1, ld = null, dl = !1, o3 = !1, a3 = /* @__PURE__ */ new Set();
function Ug(e, t) {
  a3.forEach((n) => n(e, t));
}
var bY = typeof window < "u" && window.navigator != null ? /^Mac/.test(window.navigator.platform) : !1;
function yY(e) {
  return !(e.metaKey || !bY && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function dv(e) {
  dl = !0, yY(e) && (ld = "keyboard", Ug("keyboard", e));
}
function iu(e) {
  if (ld = "pointer", e.type === "mousedown" || e.type === "pointerdown") {
    dl = !0;
    const t = e.composedPath ? e.composedPath()[0] : e.target;
    let n = !1;
    try {
      n = t.matches(":focus-visible");
    } catch {
    }
    if (n)
      return;
    Ug("pointer", e);
  }
}
function SY(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : e.detail === 0 && !e.pointerType;
}
function AY(e) {
  SY(e) && (dl = !0, ld = "virtual");
}
function MY(e) {
  e.target === window || e.target === document || e.target instanceof Element && e.target.hasAttribute("tabindex") || (!dl && !o3 && (ld = "virtual", Ug("virtual", e)), dl = !1, o3 = !1);
}
function xY() {
  dl = !1, o3 = !0;
}
function fv() {
  return ld !== "pointer";
}
function _Y() {
  if (!CY() || cv)
    return;
  const { focus: e } = HTMLElement.prototype;
  HTMLElement.prototype.focus = function(...n) {
    dl = !0, e.apply(this, n);
  }, document.addEventListener("keydown", dv, !0), document.addEventListener("keyup", dv, !0), document.addEventListener("click", AY, !0), window.addEventListener("focus", MY, !0), window.addEventListener("blur", xY, !1), typeof PointerEvent < "u" ? (document.addEventListener("pointerdown", iu, !0), document.addEventListener("pointermove", iu, !0), document.addEventListener("pointerup", iu, !0)) : (document.addEventListener("mousedown", iu, !0), document.addEventListener("mousemove", iu, !0), document.addEventListener("mouseup", iu, !0)), cv = !0;
}
function GA(e) {
  _Y(), e(fv());
  const t = () => e(fv());
  return a3.add(t), () => {
    a3.delete(t);
  };
}
const [IY, $A] = bn({
  name: "FormControlStylesContext",
  errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
}), [wY, Il] = bn({
  strict: !1,
  name: "FormControlContext"
});
function LY(e) {
  const {
    id: t,
    isRequired: n,
    isInvalid: r,
    isDisabled: o,
    isReadOnly: a,
    ...s
  } = e, l = Xo(), c = t || `field-${l}`, d = `${c}-label`, f = `${c}-feedback`, h = `${c}-helptext`, [m, g] = je(!1), [b, C] = je(!1), [y, _] = je(!1), x = te(
    (N = {}, P = null) => ({
      id: h,
      ...N,
      /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: ir(P, (F) => {
        F && C(!0);
      })
    }),
    [h]
  ), I = te(
    (N = {}, P = null) => ({
      ...N,
      ref: P,
      "data-focus": ot(y),
      "data-disabled": ot(o),
      "data-invalid": ot(r),
      "data-readonly": ot(a),
      id: N.id !== void 0 ? N.id : d,
      htmlFor: N.htmlFor !== void 0 ? N.htmlFor : c
    }),
    [c, o, y, r, a, d]
  ), R = te(
    (N = {}, P = null) => ({
      id: f,
      ...N,
      /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: ir(P, (F) => {
        F && g(!0);
      }),
      "aria-live": "polite"
    }),
    [f]
  ), E = te(
    (N = {}, P = null) => ({
      ...N,
      ...s,
      ref: P,
      role: "group",
      "data-focus": ot(y),
      "data-disabled": ot(o),
      "data-invalid": ot(r),
      "data-readonly": ot(a)
    }),
    [s, o, y, r, a]
  ), k = te(
    (N = {}, P = null) => ({
      ...N,
      ref: P,
      role: "presentation",
      "aria-hidden": !0,
      children: N.children || "*"
    }),
    []
  );
  return {
    isRequired: !!n,
    isInvalid: !!r,
    isReadOnly: !!a,
    isDisabled: !!o,
    isFocused: !!y,
    onFocus: () => _(!0),
    onBlur: () => _(!1),
    hasFeedbackText: m,
    setHasFeedbackText: g,
    hasHelpText: b,
    setHasHelpText: C,
    id: c,
    labelId: d,
    feedbackId: f,
    helpTextId: h,
    htmlProps: s,
    getHelpTextProps: x,
    getErrorMessageProps: R,
    getRootProps: E,
    getLabelProps: I,
    getRequiredIndicatorProps: k
  };
}
const ZA = Ze(
  function(t, n) {
    const r = Ir("Form", t), o = Wn(t), {
      getRootProps: a,
      htmlProps: s,
      ...l
    } = LY(o), c = Ye("chakra-form-control", t.className);
    return /* @__PURE__ */ A.jsx(wY, { value: l, children: /* @__PURE__ */ A.jsx(IY, { value: r, children: /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ...a({}, n),
        className: c,
        __css: r.container
      }
    ) }) });
  }
);
ZA.displayName = "FormControl";
const jA = Ze(
  function(t, n) {
    const r = Il(), o = $A(), a = Ye("chakra-form__helper-text", t.className);
    return /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ...r == null ? void 0 : r.getHelpTextProps(t, n),
        __css: o.helperText,
        className: a
      }
    );
  }
);
jA.displayName = "FormHelperText";
function Xg(e) {
  const { isDisabled: t, isInvalid: n, isReadOnly: r, isRequired: o, ...a } = Yg(e);
  return {
    ...a,
    disabled: t,
    readOnly: r,
    required: o,
    "aria-invalid": di(n),
    "aria-required": di(o),
    "aria-readonly": di(r)
  };
}
function Yg(e) {
  const t = Il(), {
    id: n,
    disabled: r,
    readOnly: o,
    required: a,
    isRequired: s,
    isInvalid: l,
    isReadOnly: c,
    isDisabled: d,
    onFocus: f,
    onBlur: h,
    ...m
  } = e, g = e["aria-describedby"] ? [e["aria-describedby"]] : [];
  return t != null && t.hasFeedbackText && (t != null && t.isInvalid) && g.push(t.feedbackId), t != null && t.hasHelpText && g.push(t.helpTextId), {
    ...m,
    "aria-describedby": g.join(" ") || void 0,
    id: n ?? (t == null ? void 0 : t.id),
    isDisabled: r ?? d ?? (t == null ? void 0 : t.isDisabled),
    isReadOnly: o ?? c ?? (t == null ? void 0 : t.isReadOnly),
    isRequired: a ?? s ?? (t == null ? void 0 : t.isRequired),
    isInvalid: l ?? (t == null ? void 0 : t.isInvalid),
    onFocus: lt(t == null ? void 0 : t.onFocus, f),
    onBlur: lt(t == null ? void 0 : t.onBlur, h)
  };
}
const WA = {
  border: "0",
  clip: "rect(0, 0, 0, 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
function zA(e = {}) {
  const t = Yg(e), {
    isDisabled: n,
    isReadOnly: r,
    isRequired: o,
    isInvalid: a,
    id: s,
    onBlur: l,
    onFocus: c,
    "aria-describedby": d
  } = t, {
    defaultChecked: f,
    isChecked: h,
    isFocusable: m,
    onChange: g,
    isIndeterminate: b,
    name: C,
    value: y,
    tabIndex: _ = void 0,
    "aria-label": x,
    "aria-labelledby": I,
    "aria-invalid": R,
    ...E
  } = e, k = zf(E, [
    "isDisabled",
    "isReadOnly",
    "isRequired",
    "isInvalid",
    "id",
    "onBlur",
    "onFocus",
    "aria-describedby"
  ]), N = or(g), P = or(l), F = or(c), [G, j] = je(!1), [ae, ue] = je(!1), [le, _e] = je(!1), ve = He(!1);
  ft(() => GA((Ee) => {
    ve.current = Ee;
  }), []);
  const z = He(null), [K, Ce] = je(!0), [q, J] = je(!!f), ge = h !== void 0, X = ge ? h : q, pe = te(
    (Ee) => {
      if (r || n) {
        Ee.preventDefault();
        return;
      }
      ge || J(X ? Ee.currentTarget.checked : b ? !0 : Ee.currentTarget.checked), N == null || N(Ee);
    },
    [
      r,
      n,
      X,
      ge,
      b,
      N
    ]
  );
  ls(() => {
    z.current && (z.current.indeterminate = !!b);
  }, [b]), ul(() => {
    n && j(!1);
  }, [n, j]), ls(() => {
    const Ee = z.current;
    if (!(Ee != null && Ee.form))
      return;
    const wt = () => {
      J(!!f);
    };
    return Ee.form.addEventListener("reset", wt), () => {
      var an;
      return (an = Ee.form) == null ? void 0 : an.removeEventListener("reset", wt);
    };
  }, []);
  const fe = n && !m, de = te(
    (Ee) => {
      Ee.key === " " && _e(!0);
    },
    [_e]
  ), we = te(
    (Ee) => {
      Ee.key === " " && _e(!1);
    },
    [_e]
  );
  ls(() => {
    if (!z.current)
      return;
    z.current.checked !== X && J(z.current.checked);
  }, [z.current]);
  const Ie = te(
    (Ee = {}, wt = null) => {
      const an = (Ft) => {
        G && Ft.preventDefault(), _e(!0);
      };
      return {
        ...Ee,
        ref: wt,
        "data-active": ot(le),
        "data-hover": ot(ae),
        "data-checked": ot(X),
        "data-focus": ot(G),
        "data-focus-visible": ot(G && ve.current),
        "data-indeterminate": ot(b),
        "data-disabled": ot(n),
        "data-invalid": ot(a),
        "data-readonly": ot(r),
        "aria-hidden": !0,
        onMouseDown: lt(Ee.onMouseDown, an),
        onMouseUp: lt(Ee.onMouseUp, () => _e(!1)),
        onMouseEnter: lt(
          Ee.onMouseEnter,
          () => ue(!0)
        ),
        onMouseLeave: lt(
          Ee.onMouseLeave,
          () => ue(!1)
        )
      };
    },
    [
      le,
      X,
      n,
      G,
      ae,
      b,
      a,
      r
    ]
  ), Pe = te(
    (Ee = {}, wt = null) => ({
      ...Ee,
      ref: wt,
      "data-active": ot(le),
      "data-hover": ot(ae),
      "data-checked": ot(X),
      "data-focus": ot(G),
      "data-focus-visible": ot(G && ve.current),
      "data-indeterminate": ot(b),
      "data-disabled": ot(n),
      "data-invalid": ot(a),
      "data-readonly": ot(r)
    }),
    [
      le,
      X,
      n,
      G,
      ae,
      b,
      a,
      r
    ]
  ), Se = te(
    (Ee = {}, wt = null) => ({
      ...k,
      ...Ee,
      ref: ir(wt, (an) => {
        an && Ce(an.tagName === "LABEL");
      }),
      onClick: lt(Ee.onClick, () => {
        var an;
        K || ((an = z.current) == null || an.click(), requestAnimationFrame(() => {
          var Ft;
          (Ft = z.current) == null || Ft.focus({ preventScroll: !0 });
        }));
      }),
      "data-disabled": ot(n),
      "data-checked": ot(X),
      "data-invalid": ot(a)
    }),
    [k, n, X, a, K]
  ), Fe = te(
    (Ee = {}, wt = null) => ({
      ...Ee,
      ref: ir(z, wt),
      type: "checkbox",
      name: C,
      value: y,
      id: s,
      tabIndex: _,
      onChange: lt(Ee.onChange, pe),
      onBlur: lt(
        Ee.onBlur,
        P,
        () => j(!1)
      ),
      onFocus: lt(
        Ee.onFocus,
        F,
        () => j(!0)
      ),
      onKeyDown: lt(Ee.onKeyDown, de),
      onKeyUp: lt(Ee.onKeyUp, we),
      required: o,
      checked: X,
      disabled: fe,
      readOnly: r,
      "aria-label": x,
      "aria-labelledby": I,
      "aria-invalid": R ? !!R : a,
      "aria-describedby": d,
      "aria-disabled": n,
      "aria-checked": b ? "mixed" : X,
      style: WA
    }),
    [
      C,
      y,
      s,
      _,
      pe,
      P,
      F,
      de,
      we,
      o,
      X,
      fe,
      r,
      x,
      I,
      R,
      a,
      d,
      n,
      b
    ]
  ), oe = te(
    (Ee = {}, wt = null) => ({
      ...Ee,
      ref: wt,
      onMouseDown: lt(Ee.onMouseDown, RY),
      "data-disabled": ot(n),
      "data-checked": ot(X),
      "data-invalid": ot(a)
    }),
    [X, n, a]
  );
  return {
    state: {
      isInvalid: a,
      isFocused: G,
      isChecked: X,
      isActive: le,
      isHovered: ae,
      isIndeterminate: b,
      isDisabled: n,
      isReadOnly: r,
      isRequired: o
    },
    getRootProps: Se,
    getCheckboxProps: Ie,
    getIndicatorProps: Pe,
    getInputProps: Fe,
    getLabelProps: oe,
    htmlProps: k
  };
}
function RY(e) {
  e.preventDefault(), e.stopPropagation();
}
function EY(e) {
  const [t, n] = je(e), [r, o] = je(!1);
  return e !== t && (o(!0), n(e)), r;
}
const DY = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "top",
  userSelect: "none",
  flexShrink: 0
}, NY = {
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  verticalAlign: "top",
  position: "relative"
}, TY = Q1({
  from: {
    opacity: 0,
    strokeDashoffset: 16,
    transform: "scale(0.95)"
  },
  to: {
    opacity: 1,
    strokeDashoffset: 0,
    transform: "scale(1)"
  }
}), PY = Q1({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
}), kY = Q1({
  from: {
    transform: "scaleX(0.65)"
  },
  to: {
    transform: "scaleX(1)"
  }
}), qg = Ze(
  function(t, n) {
    const r = pY(), o = { ...r, ...t }, a = Ir("Checkbox", o), s = Wn(t), {
      spacing: l = "0.5rem",
      className: c,
      children: d,
      iconColor: f,
      iconSize: h,
      icon: m = /* @__PURE__ */ A.jsx(vY, {}),
      isChecked: g,
      isDisabled: b = r == null ? void 0 : r.isDisabled,
      onChange: C,
      inputProps: y,
      ..._
    } = s;
    let x = g;
    r != null && r.value && s.value && (x = r.value.includes(s.value));
    let I = C;
    r != null && r.onChange && s.value && (I = ig(r.onChange, C));
    const {
      state: R,
      getInputProps: E,
      getCheckboxProps: k,
      getLabelProps: N,
      getRootProps: P
    } = zA({
      ..._,
      isDisabled: b,
      isChecked: x,
      onChange: I
    }), F = EY(R.isChecked), G = Et(
      () => ({
        animation: F ? R.isIndeterminate ? `${PY} 20ms linear, ${kY} 200ms linear` : `${TY} 200ms linear` : void 0,
        ...a.icon,
        ...sg({
          fontSize: h,
          color: f
        })
      }),
      [f, h, F, R.isIndeterminate, a.icon]
    ), j = Fa(m, {
      __css: G,
      isIndeterminate: R.isIndeterminate,
      isChecked: R.isChecked
    });
    return /* @__PURE__ */ A.jsxs(
      Ne.label,
      {
        __css: { ...NY, ...a.container },
        className: Ye("chakra-checkbox", c),
        ...P(),
        children: [
          /* @__PURE__ */ A.jsx(
            "input",
            {
              className: "chakra-checkbox__input",
              ...E(y, n)
            }
          ),
          /* @__PURE__ */ A.jsx(
            Ne.span,
            {
              __css: { ...DY, ...a.control },
              className: "chakra-checkbox__control",
              ...k(),
              children: j
            }
          ),
          d && /* @__PURE__ */ A.jsx(
            Ne.span,
            {
              className: "chakra-checkbox__label",
              ...N(),
              __css: {
                marginStart: l,
                ...a.label
              },
              children: d
            }
          )
        ]
      }
    );
  }
);
qg.displayName = "Checkbox";
function hv(e) {
  return e && ar(e) && ar(e.target);
}
function VY(e = {}) {
  const {
    defaultValue: t,
    value: n,
    onChange: r,
    isDisabled: o,
    isNative: a
  } = e, s = or(r), [l, c] = Sy({
    value: n,
    defaultValue: t || [],
    onChange: s
  }), d = te(
    (h) => {
      if (!l)
        return;
      const m = hv(h) ? h.target.checked : !l.includes(h), g = hv(h) ? h.target.value : h, b = m ? [...l, g] : l.filter((C) => String(C) !== String(g));
      c(b);
    },
    [c, l]
  ), f = te(
    (h = {}) => ({
      ...h,
      [a ? "checked" : "isChecked"]: l.some((g) => String(h.value) === String(g)),
      onChange: d
    }),
    [d, a, l]
  );
  return {
    value: l,
    isDisabled: o,
    onChange: d,
    setValue: c,
    getCheckboxProps: f
  };
}
function UA(e) {
  const { colorScheme: t, size: n, variant: r, children: o, isDisabled: a } = e, { value: s, onChange: l } = VY(e), c = Et(
    () => ({
      size: n,
      onChange: l,
      colorScheme: t,
      value: s,
      variant: r,
      isDisabled: a
    }),
    [n, l, t, s, r, a]
  );
  return /* @__PURE__ */ A.jsx(hY, { value: c, children: o });
}
UA.displayName = "CheckboxGroup";
function c1(e) {
  return typeof e == "function";
}
function OY(...e) {
  return (t) => e.reduce((n, r) => r(n), t);
}
const FY = (e) => function(...n) {
  let r = [...n], o = n[n.length - 1];
  return yZ(o) && // this ensures backward compatibility
  // previously only `extendTheme(override, activeTheme?)` was allowed
  r.length > 1 ? r = r.slice(0, r.length - 1) : o = e, OY(
    ...r.map(
      (a) => (s) => c1(a) ? a(s) : HY(s, a)
    )
  )(o);
}, BY = FY(zy);
function HY(...e) {
  return Bo({}, ...e, XA);
}
function XA(e, t, n, r) {
  if ((c1(e) || c1(t)) && Object.prototype.hasOwnProperty.call(r, n))
    return (...o) => {
      const a = c1(e) ? e(...o) : e, s = c1(t) ? t(...o) : t;
      return Bo({}, a, s, XA);
    };
  if (ar(e) && T5(t) || T5(e) && ar(t))
    return t;
}
const Y2 = Ze(function(t, n) {
  const { direction: r, align: o, justify: a, wrap: s, basis: l, grow: c, shrink: d, ...f } = t, h = {
    display: "flex",
    flexDirection: r,
    alignItems: o,
    justifyContent: a,
    flexWrap: s,
    flexBasis: l,
    flexGrow: c,
    flexShrink: d
  };
  return /* @__PURE__ */ A.jsx(Ne.div, { ref: n, __css: h, ...f });
});
Y2.displayName = "Flex";
function YA(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) !== -1)
        continue;
      n[r] = e[r];
    }
  return n;
}
function Je() {
  return Je = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Je.apply(null, arguments);
}
var i3 = { exports: {} }, z0 = { exports: {} }, tn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pv;
function GY() {
  if (pv)
    return tn;
  pv = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function I(E) {
    if (typeof E == "object" && E !== null) {
      var k = E.$$typeof;
      switch (k) {
        case t:
          switch (E = E.type, E) {
            case c:
            case d:
            case r:
            case a:
            case o:
            case h:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case l:
                case f:
                case b:
                case g:
                case s:
                  return E;
                default:
                  return k;
              }
          }
        case n:
          return k;
      }
    }
  }
  function R(E) {
    return I(E) === d;
  }
  return tn.AsyncMode = c, tn.ConcurrentMode = d, tn.ContextConsumer = l, tn.ContextProvider = s, tn.Element = t, tn.ForwardRef = f, tn.Fragment = r, tn.Lazy = b, tn.Memo = g, tn.Portal = n, tn.Profiler = a, tn.StrictMode = o, tn.Suspense = h, tn.isAsyncMode = function(E) {
    return R(E) || I(E) === c;
  }, tn.isConcurrentMode = R, tn.isContextConsumer = function(E) {
    return I(E) === l;
  }, tn.isContextProvider = function(E) {
    return I(E) === s;
  }, tn.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === t;
  }, tn.isForwardRef = function(E) {
    return I(E) === f;
  }, tn.isFragment = function(E) {
    return I(E) === r;
  }, tn.isLazy = function(E) {
    return I(E) === b;
  }, tn.isMemo = function(E) {
    return I(E) === g;
  }, tn.isPortal = function(E) {
    return I(E) === n;
  }, tn.isProfiler = function(E) {
    return I(E) === a;
  }, tn.isStrictMode = function(E) {
    return I(E) === o;
  }, tn.isSuspense = function(E) {
    return I(E) === h;
  }, tn.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === r || E === d || E === a || E === o || E === h || E === m || typeof E == "object" && E !== null && (E.$$typeof === b || E.$$typeof === g || E.$$typeof === s || E.$$typeof === l || E.$$typeof === f || E.$$typeof === y || E.$$typeof === _ || E.$$typeof === x || E.$$typeof === C);
  }, tn.typeOf = I, tn;
}
var nn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mv;
function $Y() {
  return mv || (mv = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function I(oe) {
      return typeof oe == "string" || typeof oe == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      oe === r || oe === d || oe === a || oe === o || oe === h || oe === m || typeof oe == "object" && oe !== null && (oe.$$typeof === b || oe.$$typeof === g || oe.$$typeof === s || oe.$$typeof === l || oe.$$typeof === f || oe.$$typeof === y || oe.$$typeof === _ || oe.$$typeof === x || oe.$$typeof === C);
    }
    function R(oe) {
      if (typeof oe == "object" && oe !== null) {
        var pt = oe.$$typeof;
        switch (pt) {
          case t:
            var Ee = oe.type;
            switch (Ee) {
              case c:
              case d:
              case r:
              case a:
              case o:
              case h:
                return Ee;
              default:
                var wt = Ee && Ee.$$typeof;
                switch (wt) {
                  case l:
                  case f:
                  case b:
                  case g:
                  case s:
                    return wt;
                  default:
                    return pt;
                }
            }
          case n:
            return pt;
        }
      }
    }
    var E = c, k = d, N = l, P = s, F = t, G = f, j = r, ae = b, ue = g, le = n, _e = a, ve = o, z = h, K = !1;
    function Ce(oe) {
      return K || (K = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), q(oe) || R(oe) === c;
    }
    function q(oe) {
      return R(oe) === d;
    }
    function J(oe) {
      return R(oe) === l;
    }
    function ge(oe) {
      return R(oe) === s;
    }
    function X(oe) {
      return typeof oe == "object" && oe !== null && oe.$$typeof === t;
    }
    function pe(oe) {
      return R(oe) === f;
    }
    function fe(oe) {
      return R(oe) === r;
    }
    function de(oe) {
      return R(oe) === b;
    }
    function we(oe) {
      return R(oe) === g;
    }
    function Ie(oe) {
      return R(oe) === n;
    }
    function Pe(oe) {
      return R(oe) === a;
    }
    function Se(oe) {
      return R(oe) === o;
    }
    function Fe(oe) {
      return R(oe) === h;
    }
    nn.AsyncMode = E, nn.ConcurrentMode = k, nn.ContextConsumer = N, nn.ContextProvider = P, nn.Element = F, nn.ForwardRef = G, nn.Fragment = j, nn.Lazy = ae, nn.Memo = ue, nn.Portal = le, nn.Profiler = _e, nn.StrictMode = ve, nn.Suspense = z, nn.isAsyncMode = Ce, nn.isConcurrentMode = q, nn.isContextConsumer = J, nn.isContextProvider = ge, nn.isElement = X, nn.isForwardRef = pe, nn.isFragment = fe, nn.isLazy = de, nn.isMemo = we, nn.isPortal = Ie, nn.isProfiler = Pe, nn.isStrictMode = Se, nn.isSuspense = Fe, nn.isValidElementType = I, nn.typeOf = R;
  }()), nn;
}
var gv;
function qA() {
  return gv || (gv = 1, process.env.NODE_ENV === "production" ? z0.exports = GY() : z0.exports = $Y()), z0.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Hm, vv;
function ZY() {
  if (vv)
    return Hm;
  vv = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var s = {}, l = 0; l < 10; l++)
        s["_" + String.fromCharCode(l)] = l;
      var c = Object.getOwnPropertyNames(s).map(function(f) {
        return s[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        d[f] = f;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Hm = o() ? Object.assign : function(a, s) {
    for (var l, c = r(a), d, f = 1; f < arguments.length; f++) {
      l = Object(arguments[f]);
      for (var h in l)
        t.call(l, h) && (c[h] = l[h]);
      if (e) {
        d = e(l);
        for (var m = 0; m < d.length; m++)
          n.call(l, d[m]) && (c[d[m]] = l[d[m]]);
      }
    }
    return c;
  }, Hm;
}
var Gm, Cv;
function Jg() {
  if (Cv)
    return Gm;
  Cv = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Gm = e, Gm;
}
var $m, bv;
function JA() {
  return bv || (bv = 1, $m = Function.call.bind(Object.prototype.hasOwnProperty)), $m;
}
var Zm, yv;
function jY() {
  if (yv)
    return Zm;
  yv = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Jg(), n = {}, r = JA();
    e = function(a) {
      var s = "Warning: " + a;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(a, s, l, c, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in a)
        if (r(a, f)) {
          var h;
          try {
            if (typeof a[f] != "function") {
              var m = Error(
                (c || "React class") + ": " + l + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            h = a[f](s, f, c, l, null, t);
          } catch (b) {
            h = b;
          }
          if (h && !(h instanceof Error) && e(
            (c || "React class") + ": type specification of " + l + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in n)) {
            n[h.message] = !0;
            var g = d ? d() : "";
            e(
              "Failed " + l + " type: " + h.message + (g ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Zm = o, Zm;
}
var jm, Sv;
function WY() {
  if (Sv)
    return jm;
  Sv = 1;
  var e = qA(), t = ZY(), n = Jg(), r = JA(), o = jY(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return jm = function(l, c) {
    var d = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function h(q) {
      var J = q && (d && q[d] || q[f]);
      if (typeof J == "function")
        return J;
    }
    var m = "<<anonymous>>", g = {
      array: _("array"),
      bigint: _("bigint"),
      bool: _("boolean"),
      func: _("function"),
      number: _("number"),
      object: _("object"),
      string: _("string"),
      symbol: _("symbol"),
      any: x(),
      arrayOf: I,
      element: R(),
      elementType: E(),
      instanceOf: k,
      node: G(),
      objectOf: P,
      oneOf: N,
      oneOfType: F,
      shape: ae,
      exact: ue
    };
    function b(q, J) {
      return q === J ? q !== 0 || 1 / q === 1 / J : q !== q && J !== J;
    }
    function C(q, J) {
      this.message = q, this.data = J && typeof J == "object" ? J : {}, this.stack = "";
    }
    C.prototype = Error.prototype;
    function y(q) {
      if (process.env.NODE_ENV !== "production")
        var J = {}, ge = 0;
      function X(fe, de, we, Ie, Pe, Se, Fe) {
        if (Ie = Ie || m, Se = Se || we, Fe !== n) {
          if (c) {
            var oe = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw oe.name = "Invariant Violation", oe;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var pt = Ie + ":" + we;
            !J[pt] && // Avoid spamming the console because they are often not actionable except for lib authors
            ge < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + Se + "` prop on `" + Ie + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), J[pt] = !0, ge++);
          }
        }
        return de[we] == null ? fe ? de[we] === null ? new C("The " + Pe + " `" + Se + "` is marked as required " + ("in `" + Ie + "`, but its value is `null`.")) : new C("The " + Pe + " `" + Se + "` is marked as required in " + ("`" + Ie + "`, but its value is `undefined`.")) : null : q(de, we, Ie, Pe, Se);
      }
      var pe = X.bind(null, !1);
      return pe.isRequired = X.bind(null, !0), pe;
    }
    function _(q) {
      function J(ge, X, pe, fe, de, we) {
        var Ie = ge[X], Pe = ve(Ie);
        if (Pe !== q) {
          var Se = z(Ie);
          return new C(
            "Invalid " + fe + " `" + de + "` of type " + ("`" + Se + "` supplied to `" + pe + "`, expected ") + ("`" + q + "`."),
            { expectedType: q }
          );
        }
        return null;
      }
      return y(J);
    }
    function x() {
      return y(s);
    }
    function I(q) {
      function J(ge, X, pe, fe, de) {
        if (typeof q != "function")
          return new C("Property `" + de + "` of component `" + pe + "` has invalid PropType notation inside arrayOf.");
        var we = ge[X];
        if (!Array.isArray(we)) {
          var Ie = ve(we);
          return new C("Invalid " + fe + " `" + de + "` of type " + ("`" + Ie + "` supplied to `" + pe + "`, expected an array."));
        }
        for (var Pe = 0; Pe < we.length; Pe++) {
          var Se = q(we, Pe, pe, fe, de + "[" + Pe + "]", n);
          if (Se instanceof Error)
            return Se;
        }
        return null;
      }
      return y(J);
    }
    function R() {
      function q(J, ge, X, pe, fe) {
        var de = J[ge];
        if (!l(de)) {
          var we = ve(de);
          return new C("Invalid " + pe + " `" + fe + "` of type " + ("`" + we + "` supplied to `" + X + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(q);
    }
    function E() {
      function q(J, ge, X, pe, fe) {
        var de = J[ge];
        if (!e.isValidElementType(de)) {
          var we = ve(de);
          return new C("Invalid " + pe + " `" + fe + "` of type " + ("`" + we + "` supplied to `" + X + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(q);
    }
    function k(q) {
      function J(ge, X, pe, fe, de) {
        if (!(ge[X] instanceof q)) {
          var we = q.name || m, Ie = Ce(ge[X]);
          return new C("Invalid " + fe + " `" + de + "` of type " + ("`" + Ie + "` supplied to `" + pe + "`, expected ") + ("instance of `" + we + "`."));
        }
        return null;
      }
      return y(J);
    }
    function N(q) {
      if (!Array.isArray(q))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), s;
      function J(ge, X, pe, fe, de) {
        for (var we = ge[X], Ie = 0; Ie < q.length; Ie++)
          if (b(we, q[Ie]))
            return null;
        var Pe = JSON.stringify(q, function(Fe, oe) {
          var pt = z(oe);
          return pt === "symbol" ? String(oe) : oe;
        });
        return new C("Invalid " + fe + " `" + de + "` of value `" + String(we) + "` " + ("supplied to `" + pe + "`, expected one of " + Pe + "."));
      }
      return y(J);
    }
    function P(q) {
      function J(ge, X, pe, fe, de) {
        if (typeof q != "function")
          return new C("Property `" + de + "` of component `" + pe + "` has invalid PropType notation inside objectOf.");
        var we = ge[X], Ie = ve(we);
        if (Ie !== "object")
          return new C("Invalid " + fe + " `" + de + "` of type " + ("`" + Ie + "` supplied to `" + pe + "`, expected an object."));
        for (var Pe in we)
          if (r(we, Pe)) {
            var Se = q(we, Pe, pe, fe, de + "." + Pe, n);
            if (Se instanceof Error)
              return Se;
          }
        return null;
      }
      return y(J);
    }
    function F(q) {
      if (!Array.isArray(q))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var J = 0; J < q.length; J++) {
        var ge = q[J];
        if (typeof ge != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + K(ge) + " at index " + J + "."
          ), s;
      }
      function X(pe, fe, de, we, Ie) {
        for (var Pe = [], Se = 0; Se < q.length; Se++) {
          var Fe = q[Se], oe = Fe(pe, fe, de, we, Ie, n);
          if (oe == null)
            return null;
          oe.data && r(oe.data, "expectedType") && Pe.push(oe.data.expectedType);
        }
        var pt = Pe.length > 0 ? ", expected one of type [" + Pe.join(", ") + "]" : "";
        return new C("Invalid " + we + " `" + Ie + "` supplied to " + ("`" + de + "`" + pt + "."));
      }
      return y(X);
    }
    function G() {
      function q(J, ge, X, pe, fe) {
        return le(J[ge]) ? null : new C("Invalid " + pe + " `" + fe + "` supplied to " + ("`" + X + "`, expected a ReactNode."));
      }
      return y(q);
    }
    function j(q, J, ge, X, pe) {
      return new C(
        (q || "React class") + ": " + J + " type `" + ge + "." + X + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + pe + "`."
      );
    }
    function ae(q) {
      function J(ge, X, pe, fe, de) {
        var we = ge[X], Ie = ve(we);
        if (Ie !== "object")
          return new C("Invalid " + fe + " `" + de + "` of type `" + Ie + "` " + ("supplied to `" + pe + "`, expected `object`."));
        for (var Pe in q) {
          var Se = q[Pe];
          if (typeof Se != "function")
            return j(pe, fe, de, Pe, z(Se));
          var Fe = Se(we, Pe, pe, fe, de + "." + Pe, n);
          if (Fe)
            return Fe;
        }
        return null;
      }
      return y(J);
    }
    function ue(q) {
      function J(ge, X, pe, fe, de) {
        var we = ge[X], Ie = ve(we);
        if (Ie !== "object")
          return new C("Invalid " + fe + " `" + de + "` of type `" + Ie + "` " + ("supplied to `" + pe + "`, expected `object`."));
        var Pe = t({}, ge[X], q);
        for (var Se in Pe) {
          var Fe = q[Se];
          if (r(q, Se) && typeof Fe != "function")
            return j(pe, fe, de, Se, z(Fe));
          if (!Fe)
            return new C(
              "Invalid " + fe + " `" + de + "` key `" + Se + "` supplied to `" + pe + "`.\nBad object: " + JSON.stringify(ge[X], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(q), null, "  ")
            );
          var oe = Fe(we, Se, pe, fe, de + "." + Se, n);
          if (oe)
            return oe;
        }
        return null;
      }
      return y(J);
    }
    function le(q) {
      switch (typeof q) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !q;
        case "object":
          if (Array.isArray(q))
            return q.every(le);
          if (q === null || l(q))
            return !0;
          var J = h(q);
          if (J) {
            var ge = J.call(q), X;
            if (J !== q.entries) {
              for (; !(X = ge.next()).done; )
                if (!le(X.value))
                  return !1;
            } else
              for (; !(X = ge.next()).done; ) {
                var pe = X.value;
                if (pe && !le(pe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function _e(q, J) {
      return q === "symbol" ? !0 : J ? J["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && J instanceof Symbol : !1;
    }
    function ve(q) {
      var J = typeof q;
      return Array.isArray(q) ? "array" : q instanceof RegExp ? "object" : _e(J, q) ? "symbol" : J;
    }
    function z(q) {
      if (typeof q > "u" || q === null)
        return "" + q;
      var J = ve(q);
      if (J === "object") {
        if (q instanceof Date)
          return "date";
        if (q instanceof RegExp)
          return "regexp";
      }
      return J;
    }
    function K(q) {
      var J = z(q);
      switch (J) {
        case "array":
        case "object":
          return "an " + J;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + J;
        default:
          return J;
      }
    }
    function Ce(q) {
      return !q.constructor || !q.constructor.name ? m : q.constructor.name;
    }
    return g.checkPropTypes = o, g.resetWarningCache = o.resetWarningCache, g.PropTypes = g, g;
  }, jm;
}
var Wm, Av;
function zY() {
  if (Av)
    return Wm;
  Av = 1;
  var e = Jg();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Wm = function() {
    function r(s, l, c, d, f, h) {
      if (h !== e) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Wm;
}
if (process.env.NODE_ENV !== "production") {
  var UY = qA(), XY = !0;
  i3.exports = WY()(UY.isElement, XY);
} else
  i3.exports = zY()();
var fn = i3.exports;
const KA = /* @__PURE__ */ jf(fn);
var s3 = "data-focus-lock", QA = "data-focus-lock-disabled", YY = "data-no-focus-lock", qY = "data-autofocus-inside", JY = "data-no-autofocus";
function zm(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function KY(e, t) {
  var n = je(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var QY = typeof window < "u" ? De.useLayoutEffect : De.useEffect, Mv = /* @__PURE__ */ new WeakMap();
function eM(e, t) {
  var n = KY(t || null, function(r) {
    return e.forEach(function(o) {
      return zm(o, r);
    });
  });
  return QY(function() {
    var r = Mv.get(n);
    if (r) {
      var o = new Set(r), a = new Set(e), s = n.current;
      o.forEach(function(l) {
        a.has(l) || zm(l, null);
      }), a.forEach(function(l) {
        o.has(l) || zm(l, s);
      });
    }
    Mv.set(n, e);
  }, [e]), n;
}
var Um = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && KA.node;
var Ra = function() {
  return Ra = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Ra.apply(this, arguments);
};
function tM(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function eq(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, a; r < o; r++)
      (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function nM(e) {
  return e;
}
function rM(e, t) {
  t === void 0 && (t = nM);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var s = t(a, r);
      return n.push(s), function() {
        n = n.filter(function(l) {
          return l !== s;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(a);
      }
      n = {
        push: function(l) {
          return a(l);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var s = [];
      if (n.length) {
        var l = n;
        n = [], l.forEach(a), s = n;
      }
      var c = function() {
        var f = s;
        s = [], f.forEach(a);
      }, d = function() {
        return Promise.resolve().then(c);
      };
      d(), n = {
        push: function(f) {
          s.push(f), d();
        },
        filter: function(f) {
          return s = s.filter(f), n;
        }
      };
    }
  };
  return o;
}
function Kg(e, t) {
  return t === void 0 && (t = nM), rM(e, t);
}
function oM(e) {
  e === void 0 && (e = {});
  var t = rM(null);
  return t.options = Ra({ async: !0, ssr: !1 }, e), t;
}
var aM = function(e) {
  var t = e.sideCar, n = tM(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return De.createElement(r, Ra({}, n));
};
aM.isSideCarExport = !0;
function tq(e, t) {
  return e.useMedium(t), aM;
}
var iM = Kg({}, function(e) {
  var t = e.target, n = e.currentTarget;
  return {
    target: t,
    currentTarget: n
  };
}), sM = Kg(), nq = Kg(), rq = oM({
  async: !0,
  ssr: typeof document < "u"
}), oq = /* @__PURE__ */ Uo(void 0), aq = [], lM = /* @__PURE__ */ nt(function(t, n) {
  var r, o = je(), a = o[0], s = o[1], l = He(), c = He(!1), d = He(null), f = je({}), h = f[1], m = t.children, g = t.disabled, b = g === void 0 ? !1 : g, C = t.noFocusGuards, y = C === void 0 ? !1 : C, _ = t.persistentFocus, x = _ === void 0 ? !1 : _, I = t.crossFrame, R = I === void 0 ? !0 : I, E = t.autoFocus, k = E === void 0 ? !0 : E, N = t.allowTextSelection, P = t.group, F = t.className, G = t.whiteList, j = t.hasPositiveIndices, ae = t.shards, ue = ae === void 0 ? aq : ae, le = t.as, _e = le === void 0 ? "div" : le, ve = t.lockProps, z = ve === void 0 ? {} : ve, K = t.sideCar, Ce = t.returnFocus, q = Ce === void 0 ? !1 : Ce, J = t.focusOptions, ge = t.onActivation, X = t.onDeactivation, pe = je({}), fe = pe[0], de = te(function(Ft) {
    var Kn = Ft.captureFocusRestore;
    if (!d.current) {
      var zn, Xt = (zn = document) == null ? void 0 : zn.activeElement;
      d.current = Xt, Xt !== document.body && (d.current = Kn(Xt));
    }
    l.current && ge && ge(l.current), c.current = !0, h();
  }, [ge]), we = te(function() {
    c.current = !1, X && X(l.current), h();
  }, [X]), Ie = te(function(Ft) {
    var Kn = d.current;
    if (Kn) {
      var zn = (typeof Kn == "function" ? Kn() : Kn) || document.body, Xt = typeof q == "function" ? q(zn) : q;
      if (Xt) {
        var sn = typeof Xt == "object" ? Xt : void 0;
        d.current = null, Ft ? Promise.resolve().then(function() {
          return zn.focus(sn);
        }) : zn.focus(sn);
      }
    }
  }, [q]), Pe = te(function(Ft) {
    c.current && iM.useMedium(Ft);
  }, []), Se = sM.useMedium, Fe = te(function(Ft) {
    l.current !== Ft && (l.current = Ft, s(Ft));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof N < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), ft(function() {
    !l.current && typeof _e != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var oe = Je((r = {}, r[QA] = b && "disabled", r[s3] = P, r), z), pt = y !== !0, Ee = pt && y !== "tail", wt = eM([n, Fe]), an = Et(function() {
    return {
      observed: l,
      shards: ue,
      enabled: !b,
      active: c.current
    };
  }, [b, c.current, ue, a]);
  return /* @__PURE__ */ Pr.createElement(F1, null, pt && [
    /* @__PURE__ */ Pr.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: b ? -1 : 0,
      style: Um
    }),
    j ? /* @__PURE__ */ Pr.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: b ? -1 : 1,
      style: Um
    }) : null
  ], !b && /* @__PURE__ */ Pr.createElement(K, {
    id: fe,
    sideCar: rq,
    observed: a,
    disabled: b,
    persistentFocus: x,
    crossFrame: R,
    autoFocus: k,
    whiteList: G,
    shards: ue,
    onActivation: de,
    onDeactivation: we,
    returnFocus: Ie,
    focusOptions: J,
    noFocusGuards: y
  }), /* @__PURE__ */ Pr.createElement(_e, Je({
    ref: wt
  }, oe, {
    className: F,
    onBlur: Se,
    onFocus: Pe
  }), /* @__PURE__ */ Pr.createElement(oq.Provider, {
    value: an
  }, m)), Ee && /* @__PURE__ */ Pr.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: b ? -1 : 0,
    style: Um
  }));
});
lM.propTypes = process.env.NODE_ENV !== "production" ? {
  children: fn.node,
  disabled: fn.bool,
  returnFocus: fn.oneOfType([fn.bool, fn.object, fn.func]),
  focusOptions: fn.object,
  noFocusGuards: fn.bool,
  hasPositiveIndices: fn.bool,
  allowTextSelection: fn.bool,
  autoFocus: fn.bool,
  persistentFocus: fn.bool,
  crossFrame: fn.bool,
  group: fn.string,
  className: fn.string,
  whiteList: fn.func,
  shards: fn.arrayOf(fn.any),
  as: fn.oneOfType([fn.string, fn.func, fn.object]),
  lockProps: fn.object,
  onActivation: fn.func,
  onDeactivation: fn.func,
  sideCar: fn.any.isRequired
} : {};
const uM = lM;
function q2(e, t) {
  return q2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, q2(e, t);
}
function iq(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, q2(e, t);
}
function fl(e) {
  "@babel/helpers - typeof";
  return fl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fl(e);
}
function sq(e, t) {
  if (fl(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (fl(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function cM(e) {
  var t = sq(e, "string");
  return fl(t) == "symbol" ? t : t + "";
}
function wu(e, t, n) {
  return (t = cM(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function lq(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof t != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function n(r) {
    return r.displayName || r.name || "Component";
  }
  return function(o) {
    if (process.env.NODE_ENV !== "production" && typeof o != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var a = [], s;
    function l() {
      s = e(a.map(function(d) {
        return d.props;
      })), t(s);
    }
    var c = /* @__PURE__ */ function(d) {
      iq(f, d);
      function f() {
        return d.apply(this, arguments) || this;
      }
      f.peek = function() {
        return s;
      };
      var h = f.prototype;
      return h.componentDidMount = function() {
        a.push(this), l();
      }, h.componentDidUpdate = function() {
        l();
      }, h.componentWillUnmount = function() {
        var g = a.indexOf(this);
        a.splice(g, 1), l();
      }, h.render = function() {
        return /* @__PURE__ */ Pr.createElement(o, this.props);
      }, f;
    }(ck);
    return wu(c, "displayName", "SideEffect(" + n(o) + ")"), c;
  };
}
var Za = function(e) {
  for (var t = Array(e.length), n = 0; n < e.length; ++n)
    t[n] = e[n];
  return t;
}, hl = function(e) {
  return Array.isArray(e) ? e : [e];
}, dM = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, uq = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var t = window.getComputedStyle(e, null);
  return !t || !t.getPropertyValue ? !1 : t.getPropertyValue("display") === "none" || t.getPropertyValue("visibility") === "hidden";
}, fM = function(e) {
  return e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e.parentNode.host
  ) : e.parentNode;
}, hM = function(e) {
  return e === document || e && e.nodeType === Node.DOCUMENT_NODE;
}, cq = function(e) {
  return e.hasAttribute("inert");
}, dq = function(e, t) {
  return !e || hM(e) || !uq(e) && !cq(e) && t(fM(e));
}, pM = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = dq(t, pM.bind(void 0, e));
  return e.set(t, r), r;
}, fq = function(e, t) {
  return e && !hM(e) ? mq(e) ? t(fM(e)) : !1 : !0;
}, mM = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = fq(t, mM.bind(void 0, e));
  return e.set(t, r), r;
}, gM = function(e) {
  return e.dataset;
}, hq = function(e) {
  return e.tagName === "BUTTON";
}, vM = function(e) {
  return e.tagName === "INPUT";
}, CM = function(e) {
  return vM(e) && e.type === "radio";
}, pq = function(e) {
  return !((vM(e) || hq(e)) && (e.type === "hidden" || e.disabled));
}, mq = function(e) {
  var t = e.getAttribute(JY);
  return ![!0, "true", ""].includes(t);
}, Qg = function(e) {
  var t;
  return !!(e && (!((t = gM(e)) === null || t === void 0) && t.focusGuard));
}, l3 = function(e) {
  return !Qg(e);
}, gq = function(e) {
  return !!e;
}, vq = function(e, t) {
  var n = Math.max(0, e.tabIndex), r = Math.max(0, t.tabIndex), o = n - r, a = e.index - t.index;
  if (o) {
    if (!n)
      return 1;
    if (!r)
      return -1;
  }
  return o || a;
}, Cq = function(e) {
  return e.tabIndex < 0 && !e.hasAttribute("tabindex") ? 0 : e.tabIndex;
}, e4 = function(e, t, n) {
  return Za(e).map(function(r, o) {
    var a = Cq(r);
    return {
      node: r,
      index: o,
      tabIndex: n && a === -1 ? (r.dataset || {}).focusGuard ? 0 : -1 : a
    };
  }).filter(function(r) {
    return !t || r.tabIndex >= 0;
  }).sort(vq);
}, bq = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], t4 = bq.join(","), yq = "".concat(t4, ", [data-focus-guard]"), bM = function(e, t) {
  return Za((e.shadowRoot || e).children).reduce(function(n, r) {
    return n.concat(r.matches(t ? yq : t4) ? [r] : [], bM(r));
  }, []);
}, Sq = function(e, t) {
  var n;
  return e instanceof HTMLIFrameElement && (!((n = e.contentDocument) === null || n === void 0) && n.body) ? $u([e.contentDocument.body], t) : [e];
}, $u = function(e, t) {
  return e.reduce(function(n, r) {
    var o, a = bM(r, t), s = (o = []).concat.apply(o, a.map(function(l) {
      return Sq(l, t);
    }));
    return n.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      s,
      // add if node is tabbable itself
      r.parentNode ? Za(r.parentNode.querySelectorAll(t4)).filter(function(l) {
        return l === r;
      }) : []
    );
  }, []);
}, Aq = function(e) {
  var t = e.querySelectorAll("[".concat(qY, "]"));
  return Za(t).map(function(n) {
    return $u([n]);
  }).reduce(function(n, r) {
    return n.concat(r);
  }, []);
}, n4 = function(e, t) {
  return Za(e).filter(function(n) {
    return pM(t, n);
  }).filter(function(n) {
    return pq(n);
  });
}, xv = function(e, t) {
  return t === void 0 && (t = /* @__PURE__ */ new Map()), Za(e).filter(function(n) {
    return mM(t, n);
  });
}, r4 = function(e, t, n) {
  return e4(n4($u(e, n), t), !0, n);
}, W1 = function(e, t) {
  return e4(n4($u(e), t), !1);
}, Mq = function(e, t) {
  return n4(Aq(e), t);
}, sl = function(e, t) {
  return e.shadowRoot ? sl(e.shadowRoot, t) : Object.getPrototypeOf(e).contains !== void 0 && Object.getPrototypeOf(e).contains.call(e, t) ? !0 : Za(e.children).some(function(n) {
    var r;
    if (n instanceof HTMLIFrameElement) {
      var o = (r = n.contentDocument) === null || r === void 0 ? void 0 : r.body;
      return o ? sl(o, t) : !1;
    }
    return sl(n, t);
  });
}, xq = function(e) {
  for (var t = /* @__PURE__ */ new Set(), n = e.length, r = 0; r < n; r += 1)
    for (var o = r + 1; o < n; o += 1) {
      var a = e[r].compareDocumentPosition(e[o]);
      (a & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && t.add(o), (a & Node.DOCUMENT_POSITION_CONTAINS) > 0 && t.add(r);
    }
  return e.filter(function(s, l) {
    return !t.has(l);
  });
}, yM = function(e) {
  return e.parentNode ? yM(e.parentNode) : e;
}, o4 = function(e) {
  var t = hl(e);
  return t.filter(Boolean).reduce(function(n, r) {
    var o = r.getAttribute(s3);
    return n.push.apply(n, o ? xq(Za(yM(r).querySelectorAll("[".concat(s3, '="').concat(o, '"]:not([').concat(QA, '="disabled"])')))) : [r]), n;
  }, []);
}, _q = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, z1 = function(e) {
  if (e === void 0 && (e = document), !(!e || !e.activeElement)) {
    var t = e.activeElement;
    return t.shadowRoot ? z1(t.shadowRoot) : t instanceof HTMLIFrameElement && _q(function() {
      return t.contentWindow.document;
    }) ? z1(t.contentWindow.document) : t;
  }
}, Iq = function(e, t) {
  return e === t;
}, wq = function(e, t) {
  return !!Za(e.querySelectorAll("iframe")).some(function(n) {
    return Iq(n, t);
  });
}, SM = function(e, t) {
  return t === void 0 && (t = z1(dM(e).ownerDocument)), !t || t.dataset && t.dataset.focusGuard ? !1 : o4(e).some(function(n) {
    return sl(n, t) || wq(n, t);
  });
}, Lq = function(e) {
  e === void 0 && (e = document);
  var t = z1(e);
  return t ? Za(e.querySelectorAll("[".concat(YY, "]"))).some(function(n) {
    return sl(n, t);
  }) : !1;
}, Rq = function(e, t) {
  return t.filter(CM).filter(function(n) {
    return n.name === e.name;
  }).filter(function(n) {
    return n.checked;
  })[0] || e;
}, a4 = function(e, t) {
  return CM(e) && e.name ? Rq(e, t) : e;
}, Eq = function(e) {
  var t = /* @__PURE__ */ new Set();
  return e.forEach(function(n) {
    return t.add(a4(n, e));
  }), e.filter(function(n) {
    return t.has(n);
  });
}, _v = function(e) {
  return e[0] && e.length > 1 ? a4(e[0], e) : e[0];
}, Iv = function(e, t) {
  return e.indexOf(a4(t, e));
}, u3 = "NEW_FOCUS", Dq = function(e, t, n, r, o) {
  var a = e.length, s = e[0], l = e[a - 1], c = Qg(r);
  if (!(r && e.indexOf(r) >= 0)) {
    var d = r !== void 0 ? n.indexOf(r) : -1, f = o ? n.indexOf(o) : d, h = o ? e.indexOf(o) : -1;
    if (d === -1)
      return h !== -1 ? h : u3;
    if (h === -1)
      return u3;
    var m = d - f, g = n.indexOf(s), b = n.indexOf(l), C = Eq(n), y = r !== void 0 ? C.indexOf(r) : -1, _ = o ? C.indexOf(o) : y, x = C.filter(function(P) {
      return P.tabIndex >= 0;
    }), I = r !== void 0 ? x.indexOf(r) : -1, R = o ? x.indexOf(o) : I, E = I >= 0 && R >= 0 ? (
      // old/new are tabbables, measure distance in tabbable space
      R - I
    ) : (
      // or else measure in focusable space
      _ - y
    );
    if (!m && h >= 0 || t.length === 0)
      return h;
    var k = Iv(e, t[0]), N = Iv(e, t[t.length - 1]);
    if (d <= g && c && Math.abs(m) > 1)
      return N;
    if (d >= b && c && Math.abs(m) > 1)
      return k;
    if (m && Math.abs(E) > 1)
      return h;
    if (d <= g)
      return N;
    if (d > b)
      return k;
    if (m)
      return Math.abs(m) > 1 ? h : (a + h + m) % a;
  }
}, Nq = function(e) {
  return function(t) {
    var n, r = (n = gM(t)) === null || n === void 0 ? void 0 : n.autofocus;
    return (
      // @ts-expect-error
      t.autofocus || //
      r !== void 0 && r !== "false" || //
      e.indexOf(t) >= 0
    );
  };
}, wv = function(e, t, n) {
  var r = e.map(function(a) {
    var s = a.node;
    return s;
  }), o = xv(r.filter(Nq(n)));
  return o && o.length ? _v(o) : _v(xv(t));
}, c3 = function(e, t) {
  return t === void 0 && (t = []), t.push(e), e.parentNode && c3(e.parentNode.host || e.parentNode, t), t;
}, Xm = function(e, t) {
  for (var n = c3(e), r = c3(t), o = 0; o < n.length; o += 1) {
    var a = n[o];
    if (r.indexOf(a) >= 0)
      return a;
  }
  return !1;
}, AM = function(e, t, n) {
  var r = hl(e), o = hl(t), a = r[0], s = !1;
  return o.filter(Boolean).forEach(function(l) {
    s = Xm(s || l, l) || s, n.filter(Boolean).forEach(function(c) {
      var d = Xm(a, c);
      d && (!s || sl(d, s) ? s = d : s = Xm(d, s));
    });
  }), s;
}, Lv = function(e, t) {
  return e.reduce(function(n, r) {
    return n.concat(Mq(r, t));
  }, []);
}, Tq = function(e, t) {
  var n = /* @__PURE__ */ new Map();
  return t.forEach(function(r) {
    return n.set(r.node, r);
  }), e.map(function(r) {
    return n.get(r);
  }).filter(gq);
}, Pq = function(e, t) {
  var n = z1(hl(e).length > 0 ? document : dM(e).ownerDocument), r = o4(e).filter(l3), o = AM(n || e, e, r), a = /* @__PURE__ */ new Map(), s = W1(r, a), l = s.filter(function(b) {
    var C = b.node;
    return l3(C);
  });
  if (l[0]) {
    var c = W1([o], a).map(function(b) {
      var C = b.node;
      return C;
    }), d = Tq(c, l), f = d.map(function(b) {
      var C = b.node;
      return C;
    }), h = d.filter(function(b) {
      var C = b.tabIndex;
      return C >= 0;
    }).map(function(b) {
      var C = b.node;
      return C;
    }), m = Dq(f, h, c, n, t);
    if (m === u3) {
      var g = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        wv(s, h, Lv(r, a)) || wv(s, f, Lv(r, a))
      );
      if (g)
        return { node: g };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return m === void 0 ? m : d[m];
  }
}, kq = function(e) {
  var t = o4(e).filter(l3), n = AM(e, e, t), r = e4($u([n], !0), !0, !0), o = $u(t, !1);
  return r.map(function(a) {
    var s = a.node, l = a.index;
    return {
      node: s,
      index: l,
      lockItem: o.indexOf(s) >= 0,
      guard: Qg(s)
    };
  });
}, i4 = function(e, t) {
  e && ("focus" in e && e.focus(t), "contentWindow" in e && e.contentWindow && e.contentWindow.focus());
}, Ym = 0, qm = !1, MM = function(e, t, n) {
  n === void 0 && (n = {});
  var r = Pq(e, t);
  if (!qm && r) {
    if (Ym > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), qm = !0, setTimeout(function() {
        qm = !1;
      }, 1);
      return;
    }
    Ym++, i4(r.node, n.focusOptions), Ym--;
  }
};
function Xc(e) {
  if (!e)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return e || null;
    };
  var t = e ? new WeakRef(e) : null;
  return function() {
    return (t == null ? void 0 : t.deref()) || null;
  };
}
var Vq = function(e) {
  if (!e)
    return null;
  for (var t = [], n = e; n && n !== document.body; )
    t.push({
      current: Xc(n),
      parent: Xc(n.parentElement),
      left: Xc(n.previousElementSibling),
      right: Xc(n.nextElementSibling)
    }), n = n.parentElement;
  return {
    element: Xc(e),
    stack: t,
    ownerDocument: e.ownerDocument
  };
}, Oq = function(e) {
  var t, n, r, o, a;
  if (e)
    for (var s = e.stack, l = e.ownerDocument, c = /* @__PURE__ */ new Map(), d = 0, f = s; d < f.length; d++) {
      var h = f[d], m = (t = h.parent) === null || t === void 0 ? void 0 : t.call(h);
      if (m && l.contains(m)) {
        for (var g = (n = h.left) === null || n === void 0 ? void 0 : n.call(h), b = h.current(), C = m.contains(b) ? b : void 0, y = (r = h.right) === null || r === void 0 ? void 0 : r.call(h), _ = r4([m], c), x = (
          // that is element itself
          (a = (o = C ?? // or something in it's place
          (g == null ? void 0 : g.nextElementSibling)) !== null && o !== void 0 ? o : (
            // or somebody to the right, still close enough
            y
          )) !== null && a !== void 0 ? a : (
            // or somebody to the left, something?
            g
          )
        ); x; ) {
          for (var I = 0, R = _; I < R.length; I++) {
            var E = R[I];
            if (x != null && x.contains(E.node))
              return E.node;
          }
          x = x.nextElementSibling;
        }
        if (_.length)
          return _[0].node;
      }
    }
}, xM = function(e) {
  var t = Vq(e);
  return function() {
    return Oq(t);
  };
}, Fq = function(e, t, n) {
  if (!e || !t)
    return console.error("no element or scope given"), {};
  var r = hl(t);
  if (r.every(function(s) {
    return !sl(s, e);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var o = n ? r4(r, /* @__PURE__ */ new Map()) : W1(r, /* @__PURE__ */ new Map()), a = o.findIndex(function(s) {
    var l = s.node;
    return l === e;
  });
  if (a !== -1)
    return {
      prev: o[a - 1],
      next: o[a + 1],
      first: o[0],
      last: o[o.length - 1]
    };
}, Bq = function(e, t) {
  var n = t ? r4(hl(e), /* @__PURE__ */ new Map()) : W1(hl(e), /* @__PURE__ */ new Map());
  return {
    first: n[0],
    last: n[n.length - 1]
  };
}, Hq = function(e) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, e);
}, _M = function(e, t, n) {
  t === void 0 && (t = {});
  var r = Hq(t), o = Fq(e, r.scope, r.onlyTabbable);
  if (o) {
    var a = n(o, r.cycle);
    a && i4(a.node, r.focusOptions);
  }
}, Gq = function(e, t) {
  t === void 0 && (t = {}), _M(e, t, function(n, r) {
    var o = n.next, a = n.first;
    return o || r && a;
  });
}, $q = function(e, t) {
  t === void 0 && (t = {}), _M(e, t, function(n, r) {
    var o = n.prev, a = n.last;
    return o || r && a;
  });
}, IM = function(e, t, n) {
  var r, o = Bq(e, (r = t.onlyTabbable) !== null && r !== void 0 ? r : !0), a = o[n];
  a && i4(a.node, t.focusOptions);
}, Zq = function(e, t) {
  t === void 0 && (t = {}), IM(e, t, "first");
}, jq = function(e, t) {
  t === void 0 && (t = {}), IM(e, t, "last");
};
function s4(e) {
  setTimeout(e, 1);
}
var Wq = function(t) {
  return t && "current" in t ? t.current : t;
}, wM = function() {
  return document && document.activeElement === document.body;
}, zq = function() {
  return wM() || Lq();
}, Pu = null, Yr = null, Rv = function() {
  return null;
}, ku = null, U1 = !1, l4 = !1, Uq = function() {
  return !0;
}, Xq = function(t) {
  return (Pu.whiteList || Uq)(t);
}, Yq = function(t, n) {
  ku = {
    observerNode: t,
    portaledElement: n
  };
}, qq = function(t) {
  return ku && ku.portaledElement === t;
};
function Ev(e, t, n, r) {
  var o = null, a = e;
  do {
    var s = r[a];
    if (s.guard)
      s.node.dataset.focusAutoGuard && (o = s);
    else if (s.lockItem) {
      if (a !== e)
        return;
      o = null;
    } else
      break;
  } while ((a += n) !== t);
  o && (o.node.tabIndex = 0);
}
var Jq = function(t) {
  return t ? !!U1 : U1 === "meanwhile";
}, Kq = function e(t, n, r) {
  return n && (n.host === t && (!n.activeElement || r.contains(n.activeElement)) || n.parentNode && e(t, n.parentNode, r));
}, Qq = function(t, n) {
  return n.some(function(r) {
    return Kq(t, r, r);
  });
}, LM = function(t) {
  return W1(t, /* @__PURE__ */ new Map());
}, eJ = function(t) {
  return !LM([t.parentNode]).some(function(n) {
    return n.node === t;
  });
}, J2 = function() {
  var t = !1;
  if (Pu) {
    var n = Pu, r = n.observed, o = n.persistentFocus, a = n.autoFocus, s = n.shards, l = n.crossFrame, c = n.focusOptions, d = n.noFocusGuards, f = r || ku && ku.portaledElement;
    if (wM() && Yr && Yr !== document.body && (!document.body.contains(Yr) || eJ(Yr))) {
      var h = Rv();
      h && h.focus();
    }
    var m = document && document.activeElement;
    if (f) {
      var g = [f].concat(s.map(Wq).filter(Boolean)), b = function() {
        if (!Jq(l) || !d || !Yr || l4)
          return !1;
        var I = LM(g), R = I.findIndex(function(E) {
          var k = E.node;
          return k === Yr;
        });
        return R === 0 || R === I.length - 1;
      };
      if ((!m || Xq(m)) && (o || b() || !zq() || !Yr && a) && (f && !(SM(g) || m && Qq(m, g) || qq(m)) && (document && !Yr && m && !a ? (m.blur && m.blur(), document.body.focus()) : (t = MM(g, Yr, {
        focusOptions: c
      }), ku = {})), Yr = document && document.activeElement, Yr !== document.body && (Rv = xM(Yr)), U1 = !1), document && m !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var C = document && document.activeElement, y = kq(g), _ = y.map(function(x) {
          var I = x.node;
          return I;
        }).indexOf(C);
        _ > -1 && (y.filter(function(x) {
          var I = x.guard, R = x.node;
          return I && R.dataset.focusAutoGuard;
        }).forEach(function(x) {
          var I = x.node;
          return I.removeAttribute("tabIndex");
        }), Ev(_, y.length, 1, y), Ev(_, -1, -1, y));
      }
    }
  }
  return t;
}, RM = function(t) {
  J2() && t && (t.stopPropagation(), t.preventDefault());
}, u4 = function() {
  return s4(J2);
}, tJ = function(t) {
  var n = t.target, r = t.currentTarget;
  r.contains(n) || Yq(r, n);
}, nJ = function() {
  return null;
};
process.env.NODE_ENV !== "production" && KA.node.isRequired;
var EM = function() {
  l4 = !0;
}, DM = function() {
  l4 = !1, U1 = "just", s4(function() {
    U1 = "meanwhile";
  });
}, rJ = function() {
  document.addEventListener("focusin", RM), document.addEventListener("focusout", u4), window.addEventListener("focus", EM), window.addEventListener("blur", DM);
}, oJ = function() {
  document.removeEventListener("focusin", RM), document.removeEventListener("focusout", u4), window.removeEventListener("focus", EM), window.removeEventListener("blur", DM);
};
function aJ(e) {
  return e.filter(function(t) {
    var n = t.disabled;
    return !n;
  });
}
var NM = {
  moveFocusInside: MM,
  focusInside: SM,
  focusNextElement: Gq,
  focusPrevElement: $q,
  focusFirstElement: Zq,
  focusLastElement: jq,
  captureFocusRestore: xM
};
function iJ(e) {
  var t = e.slice(-1)[0];
  t && !Pu && rJ();
  var n = Pu, r = n && t && t.id === n.id;
  Pu = t, n && !r && (n.onDeactivation(), e.filter(function(o) {
    var a = o.id;
    return a === n.id;
  }).length || n.returnFocus(!t)), t ? (Yr = null, (!r || n.observed !== t.observed) && t.onActivation(NM), J2(), s4(J2)) : (oJ(), Yr = null);
}
iM.assignSyncMedium(tJ);
sM.assignMedium(u4);
nq.assignMedium(function(e) {
  return e(NM);
});
const sJ = lq(aJ, iJ)(nJ);
var TM = /* @__PURE__ */ nt(function(t, n) {
  return /* @__PURE__ */ Pr.createElement(uM, Je({
    sideCar: sJ,
    ref: n
  }, t));
}), PM = uM.propTypes || {};
PM.sideCar;
var lJ = YA(PM, ["sideCar"]);
TM.propTypes = process.env.NODE_ENV !== "production" ? lJ : {};
const Dv = TM, uJ = Dv.default ?? Dv, kM = (e) => {
  const {
    initialFocusRef: t,
    finalFocusRef: n,
    contentRef: r,
    restoreFocus: o,
    children: a,
    isDisabled: s,
    autoFocus: l,
    persistentFocus: c,
    lockFocusAcrossFrames: d
  } = e, f = te(() => {
    t != null && t.current ? t.current.focus() : r != null && r.current && kk(r.current).length === 0 && requestAnimationFrame(() => {
      var b;
      (b = r.current) == null || b.focus();
    });
  }, [t, r]), h = te(() => {
    var g;
    (g = n == null ? void 0 : n.current) == null || g.focus();
  }, [n]), m = o && !n;
  return /* @__PURE__ */ A.jsx(
    uJ,
    {
      crossFrame: d,
      persistentFocus: c,
      autoFocus: l,
      disabled: s,
      onActivation: f,
      onDeactivation: h,
      returnFocus: m,
      children: a
    }
  );
};
kM.displayName = "FocusLock";
const [cJ, dJ] = bn({
  name: "FormErrorStylesContext",
  errorMessage: `useFormErrorStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormError />" `
}), VM = Ze(
  (e, t) => {
    const n = Ir("FormError", e), r = Wn(e), o = Il();
    return o != null && o.isInvalid ? /* @__PURE__ */ A.jsx(cJ, { value: n, children: /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ...o == null ? void 0 : o.getErrorMessageProps(r, t),
        className: Ye("chakra-form__error-message", e.className),
        __css: {
          display: "flex",
          alignItems: "center",
          ...n.text
        }
      }
    ) }) : null;
  }
);
VM.displayName = "FormErrorMessage";
const fJ = Ze((e, t) => {
  const n = dJ(), r = Il();
  if (!(r != null && r.isInvalid))
    return null;
  const o = Ye("chakra-form__error-icon", e.className);
  return /* @__PURE__ */ A.jsx(
    Li,
    {
      ref: t,
      "aria-hidden": !0,
      ...e,
      __css: n.icon,
      className: o,
      children: /* @__PURE__ */ A.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        }
      )
    }
  );
});
fJ.displayName = "FormErrorIcon";
const OM = Ze(
  function(t, n) {
    const r = _l("FormLabel", t), o = Wn(t), {
      className: a,
      children: s,
      requiredIndicator: l = /* @__PURE__ */ A.jsx(FM, {}),
      optionalIndicator: c = null,
      ...d
    } = o, f = Il(), h = (f == null ? void 0 : f.getLabelProps(d, n)) ?? { ref: n, ...d };
    return /* @__PURE__ */ A.jsxs(
      Ne.label,
      {
        ...h,
        className: Ye("chakra-form__label", o.className),
        __css: {
          display: "block",
          textAlign: "start",
          ...r
        },
        children: [
          s,
          f != null && f.isRequired ? l : c
        ]
      }
    );
  }
);
OM.displayName = "FormLabel";
const FM = Ze(
  function(t, n) {
    const r = Il(), o = $A();
    if (!(r != null && r.isRequired))
      return null;
    const a = Ye("chakra-form__required-indicator", t.className);
    return /* @__PURE__ */ A.jsx(
      Ne.span,
      {
        ...r == null ? void 0 : r.getRequiredIndicatorProps(t, n),
        __css: o.requiredIndicator,
        className: a
      }
    );
  }
);
FM.displayName = "RequiredIndicator";
const no = Ze(
  function(t, n) {
    const { htmlSize: r, ...o } = t, a = Ir("Input", o), s = Wn(o), l = Xg(s), c = Ye("chakra-input", t.className);
    return /* @__PURE__ */ A.jsx(
      Ne.input,
      {
        size: r,
        ...l,
        __css: a.field,
        ref: n,
        className: c
      }
    );
  }
);
no.displayName = "Input";
no.id = "Input";
const [hJ, BM] = bn({
  name: "InputGroupStylesContext",
  errorMessage: `useInputGroupStyles returned is 'undefined'. Seems you forgot to wrap the components in "<InputGroup />" `
}), c4 = Ze(
  function(t, n) {
    const r = Ir("Input", t), { children: o, className: a, ...s } = Wn(t), l = Ye("chakra-input__group", a), c = {}, d = hy(o), f = r.field;
    d.forEach((m) => {
      r && (f && m.type.id === "InputLeftElement" && (c.paddingStart = f.height ?? f.h), f && m.type.id === "InputRightElement" && (c.paddingEnd = f.height ?? f.h), m.type.id === "InputRightAddon" && (c.borderEndRadius = 0), m.type.id === "InputLeftAddon" && (c.borderStartRadius = 0));
    });
    const h = d.map((m) => {
      var b, C;
      const g = sg({
        size: ((b = m.props) == null ? void 0 : b.size) || t.size,
        variant: ((C = m.props) == null ? void 0 : C.variant) || t.variant
      });
      return m.type.id !== "Input" ? Fa(m, g) : Fa(m, Object.assign(g, c, m.props));
    });
    return /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        className: l,
        ref: n,
        __css: {
          width: "100%",
          display: "flex",
          position: "relative",
          // Parts of inputs override z-index to ensure that they stack correctly on each other
          // Create a new stacking context so that these overrides don't leak out and conflict with other z-indexes
          isolation: "isolate",
          ...r.group
        },
        "data-group": !0,
        ...s,
        children: /* @__PURE__ */ A.jsx(hJ, { value: r, children: h })
      }
    );
  }
);
c4.displayName = "InputGroup";
const pJ = {
  left: {
    marginEnd: "-1px",
    borderEndRadius: 0,
    borderEndColor: "transparent"
  },
  right: {
    marginStart: "-1px",
    borderStartRadius: 0,
    borderStartColor: "transparent"
  }
}, mJ = Ne("div", {
  baseStyle: {
    flex: "0 0 auto",
    width: "auto",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap"
  }
}), d4 = Ze(
  function(t, n) {
    const { placement: r = "left", ...o } = t, a = pJ[r] ?? {}, s = BM();
    return /* @__PURE__ */ A.jsx(
      mJ,
      {
        ref: n,
        ...o,
        __css: {
          ...s.addon,
          ...a
        }
      }
    );
  }
);
d4.displayName = "InputAddon";
const f4 = Ze(
  function(t, n) {
    return /* @__PURE__ */ A.jsx(
      d4,
      {
        ref: n,
        placement: "left",
        ...t,
        className: Ye("chakra-input__left-addon", t.className)
      }
    );
  }
);
f4.displayName = "InputLeftAddon";
f4.id = "InputLeftAddon";
const h4 = Ze(
  function(t, n) {
    return /* @__PURE__ */ A.jsx(
      d4,
      {
        ref: n,
        placement: "right",
        ...t,
        className: Ye("chakra-input__right-addon", t.className)
      }
    );
  }
);
h4.displayName = "InputRightAddon";
h4.id = "InputRightAddon";
const gJ = Ne("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    zIndex: 2
  }
}), ih = Ze(
  function(t, n) {
    const { placement: r = "left", ...o } = t, a = BM(), s = a.field, c = {
      [r === "left" ? "insetStart" : "insetEnd"]: "0",
      width: (s == null ? void 0 : s.height) ?? (s == null ? void 0 : s.h),
      height: (s == null ? void 0 : s.height) ?? (s == null ? void 0 : s.h),
      fontSize: s == null ? void 0 : s.fontSize,
      ...a.element
    };
    return /* @__PURE__ */ A.jsx(gJ, { ref: n, __css: c, ...o });
  }
);
ih.id = "InputElement";
ih.displayName = "InputElement";
const p4 = Ze(
  function(t, n) {
    const { className: r, ...o } = t, a = Ye("chakra-input__left-element", r);
    return /* @__PURE__ */ A.jsx(
      ih,
      {
        ref: n,
        placement: "left",
        className: a,
        ...o
      }
    );
  }
);
p4.id = "InputLeftElement";
p4.displayName = "InputLeftElement";
const m4 = Ze(
  function(t, n) {
    const { className: r, ...o } = t, a = Ye("chakra-input__right-element", r);
    return /* @__PURE__ */ A.jsx(
      ih,
      {
        ref: n,
        placement: "right",
        className: a,
        ...o
      }
    );
  }
);
m4.id = "InputRightElement";
m4.displayName = "InputRightElement";
const d3 = Ze(function(t, n) {
  const r = _l("Link", t), { className: o, isExternal: a, ...s } = Wn(t);
  return /* @__PURE__ */ A.jsx(
    Ne.a,
    {
      target: a ? "_blank" : void 0,
      rel: a ? "noopener" : void 0,
      ref: n,
      className: Ye("chakra-link", o),
      ...s,
      __css: r
    }
  );
});
d3.displayName = "Link";
function vJ(e, t, n, r) {
  if (t == null)
    return r;
  if (!r)
    return e.find(
      (s) => n(s).toLowerCase().startsWith(t.toLowerCase())
    );
  const o = e.filter(
    (a) => n(a).toLowerCase().startsWith(t.toLowerCase())
  );
  if (o.length > 0) {
    let a;
    return o.includes(r) ? (a = o.indexOf(r) + 1, a === o.length && (a = 0), o[a]) : (a = e.indexOf(o[0]), e[a]);
  }
  return r;
}
function CJ(e) {
  const { key: t } = e;
  return t.length === 1 || t.length > 1 && /[^a-zA-Z0-9]/.test(t);
}
function bJ(e = {}) {
  const { timeout: t = 300, preventDefault: n = () => !0 } = e, [r, o] = je([]), a = He(void 0), s = () => {
    a.current && (clearTimeout(a.current), a.current = null);
  }, l = () => {
    s(), a.current = setTimeout(() => {
      o([]), a.current = null;
    }, t);
  };
  ft(() => s, []);
  function c(d) {
    return (f) => {
      if (f.key === "Backspace") {
        const h = [...r];
        h.pop(), o(h);
        return;
      }
      if (CJ(f)) {
        const h = r.concat(f.key);
        n(f) && (f.preventDefault(), f.stopPropagation()), o(h), d(h.join("")), l();
      }
    };
  }
  return c;
}
var Kr = "top", Zo = "bottom", jo = "right", Qr = "left", g4 = "auto", ud = [Kr, Zo, jo, Qr], Zu = "start", X1 = "end", yJ = "clippingParents", HM = "viewport", Yc = "popper", SJ = "reference", Nv = /* @__PURE__ */ ud.reduce(function(e, t) {
  return e.concat([t + "-" + Zu, t + "-" + X1]);
}, []), GM = /* @__PURE__ */ [].concat(ud, [g4]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Zu, t + "-" + X1]);
}, []), AJ = "beforeRead", MJ = "read", xJ = "afterRead", _J = "beforeMain", IJ = "main", wJ = "afterMain", LJ = "beforeWrite", RJ = "write", EJ = "afterWrite", DJ = [AJ, MJ, xJ, _J, IJ, wJ, LJ, RJ, EJ];
function Ba(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function yo(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function pl(e) {
  var t = yo(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ho(e) {
  var t = yo(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function v4(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = yo(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function NJ(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, a = t.elements[n];
    !Ho(a) || !Ba(a) || (Object.assign(a.style, r), Object.keys(o).forEach(function(s) {
      var l = o[s];
      l === !1 ? a.removeAttribute(s) : a.setAttribute(s, l === !0 ? "" : l);
    }));
  });
}
function TJ(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], a = t.attributes[r] || {}, s = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), l = s.reduce(function(c, d) {
        return c[d] = "", c;
      }, {});
      !Ho(o) || !Ba(o) || (Object.assign(o.style, l), Object.keys(a).forEach(function(c) {
        o.removeAttribute(c);
      }));
    });
  };
}
const PJ = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: NJ,
  effect: TJ,
  requires: ["computeStyles"]
};
function Pa(e) {
  return e.split("-")[0];
}
var ll = Math.max, K2 = Math.min, ju = Math.round;
function f3() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function $M() {
  return !/^((?!chrome|android).)*safari/i.test(f3());
}
function Wu(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, a = 1;
  t && Ho(e) && (o = e.offsetWidth > 0 && ju(r.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && ju(r.height) / e.offsetHeight || 1);
  var s = pl(e) ? yo(e) : window, l = s.visualViewport, c = !$M() && n, d = (r.left + (c && l ? l.offsetLeft : 0)) / o, f = (r.top + (c && l ? l.offsetTop : 0)) / a, h = r.width / o, m = r.height / a;
  return {
    width: h,
    height: m,
    top: f,
    right: d + h,
    bottom: f + m,
    left: d,
    x: d,
    y: f
  };
}
function C4(e) {
  var t = Wu(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function ZM(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && v4(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Ai(e) {
  return yo(e).getComputedStyle(e);
}
function kJ(e) {
  return ["table", "td", "th"].indexOf(Ba(e)) >= 0;
}
function As(e) {
  return ((pl(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function sh(e) {
  return Ba(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (v4(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    As(e)
  );
}
function Tv(e) {
  return !Ho(e) || // https://github.com/popperjs/popper-core/issues/837
  Ai(e).position === "fixed" ? null : e.offsetParent;
}
function VJ(e) {
  var t = /firefox/i.test(f3()), n = /Trident/i.test(f3());
  if (n && Ho(e)) {
    var r = Ai(e);
    if (r.position === "fixed")
      return null;
  }
  var o = sh(e);
  for (v4(o) && (o = o.host); Ho(o) && ["html", "body"].indexOf(Ba(o)) < 0; ) {
    var a = Ai(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function cd(e) {
  for (var t = yo(e), n = Tv(e); n && kJ(n) && Ai(n).position === "static"; )
    n = Tv(n);
  return n && (Ba(n) === "html" || Ba(n) === "body" && Ai(n).position === "static") ? t : n || VJ(e) || t;
}
function b4(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function R1(e, t, n) {
  return ll(e, K2(t, n));
}
function OJ(e, t, n) {
  var r = R1(e, t, n);
  return r > n ? n : r;
}
function jM() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function WM(e) {
  return Object.assign({}, jM(), e);
}
function zM(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var FJ = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, WM(typeof t != "number" ? t : zM(t, ud));
};
function BJ(e) {
  var t, n = e.state, r = e.name, o = e.options, a = n.elements.arrow, s = n.modifiersData.popperOffsets, l = Pa(n.placement), c = b4(l), d = [Qr, jo].indexOf(l) >= 0, f = d ? "height" : "width";
  if (!(!a || !s)) {
    var h = FJ(o.padding, n), m = C4(a), g = c === "y" ? Kr : Qr, b = c === "y" ? Zo : jo, C = n.rects.reference[f] + n.rects.reference[c] - s[c] - n.rects.popper[f], y = s[c] - n.rects.reference[c], _ = cd(a), x = _ ? c === "y" ? _.clientHeight || 0 : _.clientWidth || 0 : 0, I = C / 2 - y / 2, R = h[g], E = x - m[f] - h[b], k = x / 2 - m[f] / 2 + I, N = R1(R, k, E), P = c;
    n.modifiersData[r] = (t = {}, t[P] = N, t.centerOffset = N - k, t);
  }
}
function HJ(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || ZM(t.elements.popper, o) && (t.elements.arrow = o));
}
const GJ = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: BJ,
  effect: HJ,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function zu(e) {
  return e.split("-")[1];
}
var $J = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function ZJ(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: ju(n * o) / o || 0,
    y: ju(r * o) / o || 0
  };
}
function Pv(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, a = e.variation, s = e.offsets, l = e.position, c = e.gpuAcceleration, d = e.adaptive, f = e.roundOffsets, h = e.isFixed, m = s.x, g = m === void 0 ? 0 : m, b = s.y, C = b === void 0 ? 0 : b, y = typeof f == "function" ? f({
    x: g,
    y: C
  }) : {
    x: g,
    y: C
  };
  g = y.x, C = y.y;
  var _ = s.hasOwnProperty("x"), x = s.hasOwnProperty("y"), I = Qr, R = Kr, E = window;
  if (d) {
    var k = cd(n), N = "clientHeight", P = "clientWidth";
    if (k === yo(n) && (k = As(n), Ai(k).position !== "static" && l === "absolute" && (N = "scrollHeight", P = "scrollWidth")), k = k, o === Kr || (o === Qr || o === jo) && a === X1) {
      R = Zo;
      var F = h && k === E && E.visualViewport ? E.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[N]
      );
      C -= F - r.height, C *= c ? 1 : -1;
    }
    if (o === Qr || (o === Kr || o === Zo) && a === X1) {
      I = jo;
      var G = h && k === E && E.visualViewport ? E.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[P]
      );
      g -= G - r.width, g *= c ? 1 : -1;
    }
  }
  var j = Object.assign({
    position: l
  }, d && $J), ae = f === !0 ? ZJ({
    x: g,
    y: C
  }, yo(n)) : {
    x: g,
    y: C
  };
  if (g = ae.x, C = ae.y, c) {
    var ue;
    return Object.assign({}, j, (ue = {}, ue[R] = x ? "0" : "", ue[I] = _ ? "0" : "", ue.transform = (E.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + C + "px)" : "translate3d(" + g + "px, " + C + "px, 0)", ue));
  }
  return Object.assign({}, j, (t = {}, t[R] = x ? C + "px" : "", t[I] = _ ? g + "px" : "", t.transform = "", t));
}
function jJ(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, a = n.adaptive, s = a === void 0 ? !0 : a, l = n.roundOffsets, c = l === void 0 ? !0 : l, d = {
    placement: Pa(t.placement),
    variation: zu(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Pv(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Pv(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const WJ = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: jJ,
  data: {}
};
var U0 = {
  passive: !0
};
function zJ(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, a = o === void 0 ? !0 : o, s = r.resize, l = s === void 0 ? !0 : s, c = yo(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && d.forEach(function(f) {
    f.addEventListener("scroll", n.update, U0);
  }), l && c.addEventListener("resize", n.update, U0), function() {
    a && d.forEach(function(f) {
      f.removeEventListener("scroll", n.update, U0);
    }), l && c.removeEventListener("resize", n.update, U0);
  };
}
const UJ = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: zJ,
  data: {}
};
var XJ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function w2(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return XJ[t];
  });
}
var YJ = {
  start: "end",
  end: "start"
};
function kv(e) {
  return e.replace(/start|end/g, function(t) {
    return YJ[t];
  });
}
function y4(e) {
  var t = yo(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function S4(e) {
  return Wu(As(e)).left + y4(e).scrollLeft;
}
function qJ(e, t) {
  var n = yo(e), r = As(e), o = n.visualViewport, a = r.clientWidth, s = r.clientHeight, l = 0, c = 0;
  if (o) {
    a = o.width, s = o.height;
    var d = $M();
    (d || !d && t === "fixed") && (l = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: a,
    height: s,
    x: l + S4(e),
    y: c
  };
}
function JJ(e) {
  var t, n = As(e), r = y4(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, a = ll(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), s = ll(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), l = -r.scrollLeft + S4(e), c = -r.scrollTop;
  return Ai(o || n).direction === "rtl" && (l += ll(n.clientWidth, o ? o.clientWidth : 0) - a), {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function A4(e) {
  var t = Ai(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function UM(e) {
  return ["html", "body", "#document"].indexOf(Ba(e)) >= 0 ? e.ownerDocument.body : Ho(e) && A4(e) ? e : UM(sh(e));
}
function E1(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = UM(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), a = yo(r), s = o ? [a].concat(a.visualViewport || [], A4(r) ? r : []) : r, l = t.concat(s);
  return o ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(E1(sh(s)))
  );
}
function h3(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function KJ(e, t) {
  var n = Wu(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Vv(e, t, n) {
  return t === HM ? h3(qJ(e, n)) : pl(t) ? KJ(t, n) : h3(JJ(As(e)));
}
function QJ(e) {
  var t = E1(sh(e)), n = ["absolute", "fixed"].indexOf(Ai(e).position) >= 0, r = n && Ho(e) ? cd(e) : e;
  return pl(r) ? t.filter(function(o) {
    return pl(o) && ZM(o, r) && Ba(o) !== "body";
  }) : [];
}
function eK(e, t, n, r) {
  var o = t === "clippingParents" ? QJ(e) : [].concat(t), a = [].concat(o, [n]), s = a[0], l = a.reduce(function(c, d) {
    var f = Vv(e, d, r);
    return c.top = ll(f.top, c.top), c.right = K2(f.right, c.right), c.bottom = K2(f.bottom, c.bottom), c.left = ll(f.left, c.left), c;
  }, Vv(e, s, r));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function XM(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? Pa(r) : null, a = r ? zu(r) : null, s = t.x + t.width / 2 - n.width / 2, l = t.y + t.height / 2 - n.height / 2, c;
  switch (o) {
    case Kr:
      c = {
        x: s,
        y: t.y - n.height
      };
      break;
    case Zo:
      c = {
        x: s,
        y: t.y + t.height
      };
      break;
    case jo:
      c = {
        x: t.x + t.width,
        y: l
      };
      break;
    case Qr:
      c = {
        x: t.x - n.width,
        y: l
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var d = o ? b4(o) : null;
  if (d != null) {
    var f = d === "y" ? "height" : "width";
    switch (a) {
      case Zu:
        c[d] = c[d] - (t[f] / 2 - n[f] / 2);
        break;
      case X1:
        c[d] = c[d] + (t[f] / 2 - n[f] / 2);
        break;
    }
  }
  return c;
}
function Y1(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, a = n.strategy, s = a === void 0 ? e.strategy : a, l = n.boundary, c = l === void 0 ? yJ : l, d = n.rootBoundary, f = d === void 0 ? HM : d, h = n.elementContext, m = h === void 0 ? Yc : h, g = n.altBoundary, b = g === void 0 ? !1 : g, C = n.padding, y = C === void 0 ? 0 : C, _ = WM(typeof y != "number" ? y : zM(y, ud)), x = m === Yc ? SJ : Yc, I = e.rects.popper, R = e.elements[b ? x : m], E = eK(pl(R) ? R : R.contextElement || As(e.elements.popper), c, f, s), k = Wu(e.elements.reference), N = XM({
    reference: k,
    element: I,
    strategy: "absolute",
    placement: o
  }), P = h3(Object.assign({}, I, N)), F = m === Yc ? P : k, G = {
    top: E.top - F.top + _.top,
    bottom: F.bottom - E.bottom + _.bottom,
    left: E.left - F.left + _.left,
    right: F.right - E.right + _.right
  }, j = e.modifiersData.offset;
  if (m === Yc && j) {
    var ae = j[o];
    Object.keys(G).forEach(function(ue) {
      var le = [jo, Zo].indexOf(ue) >= 0 ? 1 : -1, _e = [Kr, Zo].indexOf(ue) >= 0 ? "y" : "x";
      G[ue] += ae[_e] * le;
    });
  }
  return G;
}
function tK(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, a = n.rootBoundary, s = n.padding, l = n.flipVariations, c = n.allowedAutoPlacements, d = c === void 0 ? GM : c, f = zu(r), h = f ? l ? Nv : Nv.filter(function(b) {
    return zu(b) === f;
  }) : ud, m = h.filter(function(b) {
    return d.indexOf(b) >= 0;
  });
  m.length === 0 && (m = h);
  var g = m.reduce(function(b, C) {
    return b[C] = Y1(e, {
      placement: C,
      boundary: o,
      rootBoundary: a,
      padding: s
    })[Pa(C)], b;
  }, {});
  return Object.keys(g).sort(function(b, C) {
    return g[b] - g[C];
  });
}
function nK(e) {
  if (Pa(e) === g4)
    return [];
  var t = w2(e);
  return [kv(e), t, kv(t)];
}
function rK(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, a = o === void 0 ? !0 : o, s = n.altAxis, l = s === void 0 ? !0 : s, c = n.fallbackPlacements, d = n.padding, f = n.boundary, h = n.rootBoundary, m = n.altBoundary, g = n.flipVariations, b = g === void 0 ? !0 : g, C = n.allowedAutoPlacements, y = t.options.placement, _ = Pa(y), x = _ === y, I = c || (x || !b ? [w2(y)] : nK(y)), R = [y].concat(I).reduce(function(pe, fe) {
      return pe.concat(Pa(fe) === g4 ? tK(t, {
        placement: fe,
        boundary: f,
        rootBoundary: h,
        padding: d,
        flipVariations: b,
        allowedAutoPlacements: C
      }) : fe);
    }, []), E = t.rects.reference, k = t.rects.popper, N = /* @__PURE__ */ new Map(), P = !0, F = R[0], G = 0; G < R.length; G++) {
      var j = R[G], ae = Pa(j), ue = zu(j) === Zu, le = [Kr, Zo].indexOf(ae) >= 0, _e = le ? "width" : "height", ve = Y1(t, {
        placement: j,
        boundary: f,
        rootBoundary: h,
        altBoundary: m,
        padding: d
      }), z = le ? ue ? jo : Qr : ue ? Zo : Kr;
      E[_e] > k[_e] && (z = w2(z));
      var K = w2(z), Ce = [];
      if (a && Ce.push(ve[ae] <= 0), l && Ce.push(ve[z] <= 0, ve[K] <= 0), Ce.every(function(pe) {
        return pe;
      })) {
        F = j, P = !1;
        break;
      }
      N.set(j, Ce);
    }
    if (P)
      for (var q = b ? 3 : 1, J = function(fe) {
        var de = R.find(function(we) {
          var Ie = N.get(we);
          if (Ie)
            return Ie.slice(0, fe).every(function(Pe) {
              return Pe;
            });
        });
        if (de)
          return F = de, "break";
      }, ge = q; ge > 0; ge--) {
        var X = J(ge);
        if (X === "break")
          break;
      }
    t.placement !== F && (t.modifiersData[r]._skip = !0, t.placement = F, t.reset = !0);
  }
}
const oK = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: rK,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ov(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Fv(e) {
  return [Kr, jo, Zo, Qr].some(function(t) {
    return e[t] >= 0;
  });
}
function aK(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, a = t.modifiersData.preventOverflow, s = Y1(t, {
    elementContext: "reference"
  }), l = Y1(t, {
    altBoundary: !0
  }), c = Ov(s, r), d = Ov(l, o, a), f = Fv(c), h = Fv(d);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: d,
    isReferenceHidden: f,
    hasPopperEscaped: h
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": h
  });
}
const iK = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: aK
};
function sK(e, t, n) {
  var r = Pa(e), o = [Qr, Kr].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, s = a[0], l = a[1];
  return s = s || 0, l = (l || 0) * o, [Qr, jo].indexOf(r) >= 0 ? {
    x: l,
    y: s
  } : {
    x: s,
    y: l
  };
}
function lK(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, a = o === void 0 ? [0, 0] : o, s = GM.reduce(function(f, h) {
    return f[h] = sK(h, t.rects, a), f;
  }, {}), l = s[t.placement], c = l.x, d = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += d), t.modifiersData[r] = s;
}
const uK = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: lK
};
function cK(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = XM({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const dK = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: cK,
  data: {}
};
function fK(e) {
  return e === "x" ? "y" : "x";
}
function hK(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, a = o === void 0 ? !0 : o, s = n.altAxis, l = s === void 0 ? !1 : s, c = n.boundary, d = n.rootBoundary, f = n.altBoundary, h = n.padding, m = n.tether, g = m === void 0 ? !0 : m, b = n.tetherOffset, C = b === void 0 ? 0 : b, y = Y1(t, {
    boundary: c,
    rootBoundary: d,
    padding: h,
    altBoundary: f
  }), _ = Pa(t.placement), x = zu(t.placement), I = !x, R = b4(_), E = fK(R), k = t.modifiersData.popperOffsets, N = t.rects.reference, P = t.rects.popper, F = typeof C == "function" ? C(Object.assign({}, t.rects, {
    placement: t.placement
  })) : C, G = typeof F == "number" ? {
    mainAxis: F,
    altAxis: F
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, F), j = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, ae = {
    x: 0,
    y: 0
  };
  if (k) {
    if (a) {
      var ue, le = R === "y" ? Kr : Qr, _e = R === "y" ? Zo : jo, ve = R === "y" ? "height" : "width", z = k[R], K = z + y[le], Ce = z - y[_e], q = g ? -P[ve] / 2 : 0, J = x === Zu ? N[ve] : P[ve], ge = x === Zu ? -P[ve] : -N[ve], X = t.elements.arrow, pe = g && X ? C4(X) : {
        width: 0,
        height: 0
      }, fe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : jM(), de = fe[le], we = fe[_e], Ie = R1(0, N[ve], pe[ve]), Pe = I ? N[ve] / 2 - q - Ie - de - G.mainAxis : J - Ie - de - G.mainAxis, Se = I ? -N[ve] / 2 + q + Ie + we + G.mainAxis : ge + Ie + we + G.mainAxis, Fe = t.elements.arrow && cd(t.elements.arrow), oe = Fe ? R === "y" ? Fe.clientTop || 0 : Fe.clientLeft || 0 : 0, pt = (ue = j == null ? void 0 : j[R]) != null ? ue : 0, Ee = z + Pe - pt - oe, wt = z + Se - pt, an = R1(g ? K2(K, Ee) : K, z, g ? ll(Ce, wt) : Ce);
      k[R] = an, ae[R] = an - z;
    }
    if (l) {
      var Ft, Kn = R === "x" ? Kr : Qr, zn = R === "x" ? Zo : jo, Xt = k[E], sn = E === "y" ? "height" : "width", Tn = Xt + y[Kn], Pn = Xt - y[zn], ro = [Kr, Qr].indexOf(_) !== -1, vr = (Ft = j == null ? void 0 : j[E]) != null ? Ft : 0, qo = ro ? Tn : Xt - N[sn] - P[sn] - vr + G.altAxis, lr = ro ? Xt + N[sn] + P[sn] - vr - G.altAxis : Pn, Le = g && ro ? OJ(qo, Xt, lr) : R1(g ? qo : Tn, Xt, g ? lr : Pn);
      k[E] = Le, ae[E] = Le - Xt;
    }
    t.modifiersData[r] = ae;
  }
}
const pK = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: hK,
  requiresIfExists: ["offset"]
};
function mK(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function gK(e) {
  return e === yo(e) || !Ho(e) ? y4(e) : mK(e);
}
function vK(e) {
  var t = e.getBoundingClientRect(), n = ju(t.width) / e.offsetWidth || 1, r = ju(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function CK(e, t, n) {
  n === void 0 && (n = !1);
  var r = Ho(t), o = Ho(t) && vK(t), a = As(t), s = Wu(e, o, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Ba(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  A4(a)) && (l = gK(t)), Ho(t) ? (c = Wu(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : a && (c.x = S4(a))), {
    x: s.left + l.scrollLeft - c.x,
    y: s.top + l.scrollTop - c.y,
    width: s.width,
    height: s.height
  };
}
function bK(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function o(a) {
    n.add(a.name);
    var s = [].concat(a.requires || [], a.requiresIfExists || []);
    s.forEach(function(l) {
      if (!n.has(l)) {
        var c = t.get(l);
        c && o(c);
      }
    }), r.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || o(a);
  }), r;
}
function yK(e) {
  var t = bK(e);
  return DJ.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function SK(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function AK(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Bv = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Hv() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function MK(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, a = o === void 0 ? Bv : o;
  return function(l, c, d) {
    d === void 0 && (d = a);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Bv, a),
      modifiersData: {},
      elements: {
        reference: l,
        popper: c
      },
      attributes: {},
      styles: {}
    }, h = [], m = !1, g = {
      state: f,
      setOptions: function(_) {
        var x = typeof _ == "function" ? _(f.options) : _;
        C(), f.options = Object.assign({}, a, f.options, x), f.scrollParents = {
          reference: pl(l) ? E1(l) : l.contextElement ? E1(l.contextElement) : [],
          popper: E1(c)
        };
        var I = yK(AK([].concat(r, f.options.modifiers)));
        return f.orderedModifiers = I.filter(function(R) {
          return R.enabled;
        }), b(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!m) {
          var _ = f.elements, x = _.reference, I = _.popper;
          if (Hv(x, I)) {
            f.rects = {
              reference: CK(x, cd(I), f.options.strategy === "fixed"),
              popper: C4(I)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(G) {
              return f.modifiersData[G.name] = Object.assign({}, G.data);
            });
            for (var R = 0; R < f.orderedModifiers.length; R++) {
              if (f.reset === !0) {
                f.reset = !1, R = -1;
                continue;
              }
              var E = f.orderedModifiers[R], k = E.fn, N = E.options, P = N === void 0 ? {} : N, F = E.name;
              typeof k == "function" && (f = k({
                state: f,
                options: P,
                name: F,
                instance: g
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: SK(function() {
        return new Promise(function(y) {
          g.forceUpdate(), y(f);
        });
      }),
      destroy: function() {
        C(), m = !0;
      }
    };
    if (!Hv(l, c))
      return g;
    g.setOptions(d).then(function(y) {
      !m && d.onFirstUpdate && d.onFirstUpdate(y);
    });
    function b() {
      f.orderedModifiers.forEach(function(y) {
        var _ = y.name, x = y.options, I = x === void 0 ? {} : x, R = y.effect;
        if (typeof R == "function") {
          var E = R({
            state: f,
            name: _,
            instance: g,
            options: I
          }), k = function() {
          };
          h.push(E || k);
        }
      });
    }
    function C() {
      h.forEach(function(y) {
        return y();
      }), h = [];
    }
    return g;
  };
}
var xK = [UJ, dK, WJ, PJ, uK, oK, pK, GJ, iK], _K = /* @__PURE__ */ MK({
  defaultModifiers: xK
});
const su = (e, t) => ({
  var: e,
  varRef: t ? `var(${e}, ${t})` : `var(${e})`
}), pr = {
  arrowShadowColor: su("--popper-arrow-shadow-color"),
  arrowSize: su("--popper-arrow-size", "8px"),
  arrowSizeHalf: su("--popper-arrow-size-half"),
  arrowBg: su("--popper-arrow-bg"),
  transformOrigin: su("--popper-transform-origin"),
  arrowOffset: su("--popper-arrow-offset")
};
function IK(e) {
  if (e.includes("top"))
    return "1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("bottom"))
    return "-1px -1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("right"))
    return "-1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("left"))
    return "1px -1px 0px 0 var(--popper-arrow-shadow-color)";
}
const wK = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom"
}, LK = (e) => wK[e], Gv = {
  scroll: !0,
  resize: !0
};
function RK(e) {
  let t;
  return typeof e == "object" ? t = {
    enabled: !0,
    options: { ...Gv, ...e }
  } : t = {
    enabled: e,
    options: Gv
  }, t;
}
const EK = {
  name: "matchWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  },
  effect: ({ state: e }) => () => {
    const t = e.elements.reference;
    e.elements.popper.style.width = `${t.offsetWidth}px`;
  }
}, DK = {
  name: "transformOrigin",
  enabled: !0,
  phase: "write",
  fn: ({ state: e }) => {
    $v(e);
  },
  effect: ({ state: e }) => () => {
    $v(e);
  }
}, $v = (e) => {
  e.elements.popper.style.setProperty(
    pr.transformOrigin.var,
    LK(e.placement)
  );
}, NK = {
  name: "positionArrow",
  enabled: !0,
  phase: "afterWrite",
  fn: ({ state: e }) => {
    TK(e);
  }
}, TK = (e) => {
  var n;
  if (!e.placement)
    return;
  const t = PK(e.placement);
  if ((n = e.elements) != null && n.arrow && t) {
    Object.assign(e.elements.arrow.style, {
      [t.property]: t.value,
      width: pr.arrowSize.varRef,
      height: pr.arrowSize.varRef,
      zIndex: -1
    });
    const r = {
      [pr.arrowSizeHalf.var]: `calc(${pr.arrowSize.varRef} / 2 - 1px)`,
      [pr.arrowOffset.var]: `calc(${pr.arrowSizeHalf.varRef} * -1)`
    };
    for (const o in r)
      e.elements.arrow.style.setProperty(o, r[o]);
  }
}, PK = (e) => {
  if (e.startsWith("top"))
    return { property: "bottom", value: pr.arrowOffset.varRef };
  if (e.startsWith("bottom"))
    return { property: "top", value: pr.arrowOffset.varRef };
  if (e.startsWith("left"))
    return { property: "right", value: pr.arrowOffset.varRef };
  if (e.startsWith("right"))
    return { property: "left", value: pr.arrowOffset.varRef };
}, kK = {
  name: "innerArrow",
  enabled: !0,
  phase: "main",
  requires: ["arrow"],
  fn: ({ state: e }) => {
    Zv(e);
  },
  effect: ({ state: e }) => () => {
    Zv(e);
  }
}, Zv = (e) => {
  if (!e.elements.arrow)
    return;
  const t = e.elements.arrow.querySelector(
    "[data-popper-arrow-inner]"
  );
  if (!t)
    return;
  const n = IK(e.placement);
  n && t.style.setProperty("--popper-arrow-default-shadow", n), Object.assign(t.style, {
    transform: "rotate(45deg)",
    background: pr.arrowBg.varRef,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: "inherit",
    boxShadow: "var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))"
  });
}, VK = {
  "start-start": { ltr: "left-start", rtl: "right-start" },
  "start-end": { ltr: "left-end", rtl: "right-end" },
  "end-start": { ltr: "right-start", rtl: "left-start" },
  "end-end": { ltr: "right-end", rtl: "left-end" },
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
}, OK = {
  "auto-start": "auto-end",
  "auto-end": "auto-start",
  "top-start": "top-end",
  "top-end": "top-start",
  "bottom-start": "bottom-end",
  "bottom-end": "bottom-start"
};
function FK(e, t = "ltr") {
  var r;
  const n = ((r = VK[e]) == null ? void 0 : r[t]) || e;
  return t === "ltr" ? n : OK[e] ?? n;
}
function YM(e = {}) {
  const {
    enabled: t = !0,
    modifiers: n,
    placement: r = "bottom",
    strategy: o = "absolute",
    arrowPadding: a = 8,
    eventListeners: s = !0,
    offset: l,
    gutter: c = 8,
    flip: d = !0,
    boundary: f = "clippingParents",
    preventOverflow: h = !0,
    matchWidth: m,
    direction: g = "ltr"
  } = e, b = He(null), C = He(null), y = He(null), _ = FK(r, g), x = He(() => {
  }), I = te(() => {
    var G;
    !t || !b.current || !C.current || ((G = x.current) == null || G.call(x), y.current = _K(b.current, C.current, {
      placement: _,
      modifiers: [
        kK,
        NK,
        DK,
        {
          ...EK,
          enabled: !!m
        },
        {
          name: "eventListeners",
          ...RK(s)
        },
        {
          name: "arrow",
          options: { padding: a }
        },
        {
          name: "offset",
          options: {
            offset: l ?? [0, c]
          }
        },
        {
          name: "flip",
          enabled: !!d,
          options: { padding: 8 }
        },
        {
          name: "preventOverflow",
          enabled: !!h,
          options: { boundary: f }
        },
        // allow users override internal modifiers
        ...n ?? []
      ],
      strategy: o
    }), y.current.forceUpdate(), x.current = y.current.destroy);
  }, [
    _,
    t,
    n,
    m,
    s,
    a,
    l,
    c,
    d,
    h,
    f,
    o
  ]);
  ft(() => () => {
    var G;
    !b.current && !C.current && ((G = y.current) == null || G.destroy(), y.current = null);
  }, []);
  const R = te(
    (G) => {
      b.current = G, I();
    },
    [I]
  ), E = te(
    (G = {}, j = null) => ({
      ...G,
      ref: ir(R, j)
    }),
    [R]
  ), k = te(
    (G) => {
      C.current = G, I();
    },
    [I]
  ), N = te(
    (G = {}, j = null) => ({
      ...G,
      ref: ir(k, j),
      style: {
        ...G.style,
        position: o,
        minWidth: m ? void 0 : "max-content",
        inset: "0 auto auto 0"
      }
    }),
    [o, k, m]
  ), P = te((G = {}, j = null) => {
    const { size: ae, shadowColor: ue, bg: le, style: _e, ...ve } = G;
    return {
      ...ve,
      ref: j,
      "data-popper-arrow": "",
      style: BK(G)
    };
  }, []), F = te(
    (G = {}, j = null) => ({
      ...G,
      ref: j,
      "data-popper-arrow-inner": ""
    }),
    []
  );
  return {
    update() {
      var G;
      (G = y.current) == null || G.update();
    },
    forceUpdate() {
      var G;
      (G = y.current) == null || G.forceUpdate();
    },
    transformOrigin: pr.transformOrigin.varRef,
    referenceRef: R,
    popperRef: k,
    getPopperProps: N,
    getArrowProps: P,
    getArrowInnerProps: F,
    getReferenceProps: E
  };
}
function BK(e) {
  const { size: t, shadowColor: n, bg: r, style: o } = e, a = { ...o, position: "absolute" };
  return t && (a["--popper-arrow-size"] = t), n && (a["--popper-arrow-shadow-color"] = n), r && (a["--popper-arrow-bg"] = r), a;
}
function HK() {
  const e = He(/* @__PURE__ */ new Map()), t = e.current, n = te((o, a, s, l) => {
    e.current.set(s, { type: a, el: o, options: l }), o.addEventListener(a, s, l);
  }, []), r = te(
    (o, a, s, l) => {
      o.removeEventListener(a, s, l), e.current.delete(s);
    },
    []
  );
  return ft(
    () => () => {
      t.forEach((o, a) => {
        r(o.el, o.type, a, o.options);
      });
    },
    [r, t]
  ), { add: n, remove: r };
}
function Jm(e) {
  var o, a;
  const t = ((a = (o = e.composedPath) == null ? void 0 : o.call(e)) == null ? void 0 : a[0]) ?? e.target, { tagName: n, isContentEditable: r } = t;
  return n !== "INPUT" && n !== "TEXTAREA" && r !== !0;
}
function GK(e = {}) {
  const {
    ref: t,
    isDisabled: n,
    isFocusable: r,
    clickOnEnter: o = !0,
    clickOnSpace: a = !0,
    onMouseDown: s,
    onMouseUp: l,
    onClick: c,
    onKeyDown: d,
    onKeyUp: f,
    tabIndex: h,
    onMouseOver: m,
    onMouseLeave: g,
    ...b
  } = e, [C, y] = je(!0), [_, x] = je(!1), I = HK(), R = (z) => {
    z && z.tagName !== "BUTTON" && y(!1);
  }, E = C ? h : h || 0, k = n && !r, N = te(
    (z) => {
      if (n) {
        z.stopPropagation(), z.preventDefault();
        return;
      }
      z.currentTarget.focus(), c == null || c(z);
    },
    [n, c]
  ), P = te(
    (z) => {
      _ && Jm(z) && (z.preventDefault(), z.stopPropagation(), x(!1), I.remove(document, "keyup", P, !1));
    },
    [_, I]
  ), F = te(
    (z) => {
      if (d == null || d(z), n || z.defaultPrevented || z.metaKey || !Jm(z.nativeEvent) || C)
        return;
      const K = o && z.key === "Enter";
      a && z.key === " " && (z.preventDefault(), x(!0)), K && (z.preventDefault(), z.currentTarget.click()), I.add(document, "keyup", P, !1);
    },
    [
      n,
      C,
      d,
      o,
      a,
      I,
      P
    ]
  ), G = te(
    (z) => {
      if (f == null || f(z), n || z.defaultPrevented || z.metaKey || !Jm(z.nativeEvent) || C)
        return;
      a && z.key === " " && (z.preventDefault(), x(!1), z.currentTarget.click());
    },
    [a, C, n, f]
  ), j = te(
    (z) => {
      z.button === 0 && (x(!1), I.remove(document, "mouseup", j, !1));
    },
    [I]
  ), ae = te(
    (z) => {
      if (z.button !== 0)
        return;
      if (n) {
        z.stopPropagation(), z.preventDefault();
        return;
      }
      C || x(!0), z.currentTarget.focus({ preventScroll: !0 }), I.add(document, "mouseup", j, !1), s == null || s(z);
    },
    [n, C, s, I, j]
  ), ue = te(
    (z) => {
      z.button === 0 && (C || x(!1), l == null || l(z));
    },
    [l, C]
  ), le = te(
    (z) => {
      if (n) {
        z.preventDefault();
        return;
      }
      m == null || m(z);
    },
    [n, m]
  ), _e = te(
    (z) => {
      _ && (z.preventDefault(), x(!1)), g == null || g(z);
    },
    [_, g]
  ), ve = ir(t, R);
  return C ? {
    ...b,
    ref: ve,
    type: "button",
    "aria-disabled": k ? void 0 : n,
    disabled: k,
    onClick: N,
    onMouseDown: s,
    onMouseUp: l,
    onKeyUp: f,
    onKeyDown: d,
    onMouseOver: m,
    onMouseLeave: g
  } : {
    ...b,
    ref: ve,
    role: "button",
    "data-active": ot(_),
    "aria-disabled": n ? "true" : void 0,
    tabIndex: k ? void 0 : E,
    onClick: N,
    onMouseDown: ae,
    onMouseUp: ue,
    onKeyUp: G,
    onKeyDown: F,
    onMouseOver: le,
    onMouseLeave: _e
  };
}
const [
  $K,
  ZK,
  jK,
  WK
] = EA(), [zK, dd] = bn({
  strict: !1,
  name: "MenuContext"
});
function qM(e) {
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
function UK(e) {
  return qM(e).activeElement === e;
}
function XK(e = {}) {
  const {
    id: t,
    closeOnSelect: n = !0,
    closeOnBlur: r = !0,
    initialFocusRef: o,
    autoSelect: a = !0,
    isLazy: s,
    isOpen: l,
    defaultIsOpen: c,
    onClose: d,
    onOpen: f,
    placement: h = "bottom-start",
    lazyBehavior: m = "unmount",
    direction: g,
    computePositionOnMount: b = !1,
    ...C
  } = e, y = He(null), _ = He(null), x = He(!0), I = jK(), R = te(() => {
    requestAnimationFrame(() => {
      var X;
      (X = y.current) == null || X.focus({ preventScroll: !1 });
    });
  }, []), E = te(() => {
    const X = setTimeout(() => {
      var pe, fe;
      if (o)
        (pe = o.current) == null || pe.focus();
      else if (!I.count())
        (fe = y.current) == null || fe.focus({ preventScroll: !1 });
      else {
        const de = I.firstEnabled();
        de && le(de.index);
      }
    });
    Ce.current.add(X);
  }, [I, o]), k = te(() => {
    const X = setTimeout(() => {
      var pe;
      if (!I.count())
        (pe = y.current) == null || pe.focus({ preventScroll: !1 });
      else {
        const fe = I.lastEnabled();
        fe && le(fe.index);
      }
    });
    Ce.current.add(X);
  }, [I]), N = te(() => {
    f == null || f(), a ? E() : R();
  }, [a, E, R, f]), { isOpen: P, onOpen: F, onClose: G, onToggle: j } = My({
    isOpen: l,
    defaultIsOpen: c,
    onClose: d,
    onOpen: N
  });
  nV({
    enabled: P && r,
    ref: y,
    handler: (X) => {
      var fe, de, we;
      const pe = ((de = (fe = X.composedPath) == null ? void 0 : fe.call(X)) == null ? void 0 : de[0]) ?? X.target;
      (we = _.current) != null && we.contains(pe) || G();
    }
  });
  const ae = YM({
    ...C,
    enabled: P || b,
    placement: h,
    direction: g
  }), [ue, le] = je(-1);
  Jk(y, {
    focusRef: _,
    visible: P,
    shouldFocus: !0
  });
  const _e = Xk({ isOpen: P, ref: y }), [ve, z] = Qk(t, "menu-button", "menu-list"), K = te(() => {
    F(), R();
  }, [F, R]), Ce = He(/* @__PURE__ */ new Set([]));
  ft(() => {
    const X = Ce.current;
    return () => {
      X.forEach((pe) => clearTimeout(pe)), X.clear();
    };
  }, []), ul(() => {
    var X;
    P || (le(-1), (X = y.current) == null || X.scrollTo(0, 0));
  }, [P]), ul(() => {
    P && ue === -1 && R();
  }, [ue, P]), ft(() => {
    var pe;
    if (!P)
      return;
    const X = I.item(ue);
    (pe = X == null ? void 0 : X.node) == null || pe.focus({ preventScroll: !x.current });
  }, [I, ue, P]);
  const q = te(() => {
    F(), E();
  }, [E, F]), J = te(() => {
    x.current = !0, F(), k();
  }, [F, k]), ge = te(() => {
    var we, Ie;
    const X = qM(y.current), pe = (we = y.current) == null ? void 0 : we.contains(X.activeElement);
    if (!(P && !pe))
      return;
    const de = (Ie = I.item(ue)) == null ? void 0 : Ie.node;
    de == null || de.focus({ preventScroll: !x.current });
  }, [P, ue, I]);
  return {
    openAndFocusMenu: K,
    openAndFocusFirstItem: q,
    openAndFocusLastItem: J,
    onTransitionEnd: ge,
    unstable__animationState: _e,
    descendants: I,
    popper: ae,
    buttonId: ve,
    menuId: z,
    forceUpdate: ae.forceUpdate,
    orientation: "vertical",
    isOpen: P,
    onToggle: j,
    onOpen: F,
    onClose: G,
    menuRef: y,
    buttonRef: _,
    focusedIndex: ue,
    closeOnSelect: n,
    closeOnBlur: r,
    autoSelect: a,
    setFocusedIndex: le,
    isLazy: s,
    lazyBehavior: m,
    initialFocusRef: o,
    scrollIntoViewRef: x
  };
}
function YK(e = {}, t = null) {
  const n = dd(), {
    onToggle: r,
    popper: o,
    openAndFocusFirstItem: a,
    openAndFocusLastItem: s,
    scrollIntoViewRef: l
  } = n, c = te(
    (d) => {
      const f = d.key, m = {
        Enter: a,
        ArrowDown: a,
        ArrowUp: s
      }[f];
      m && (l.current = !0, d.preventDefault(), d.stopPropagation(), m(d));
    },
    [a, s, l]
  );
  return {
    ...e,
    ref: ir(n.buttonRef, t, o.referenceRef),
    id: n.buttonId,
    "data-active": ot(n.isOpen),
    "aria-expanded": n.isOpen,
    "aria-haspopup": "menu",
    "aria-controls": n.menuId,
    onClick: lt(e.onClick, r),
    onKeyDown: lt(e.onKeyDown, c)
  };
}
function p3(e) {
  var t;
  return QK(e) && !!((t = e == null ? void 0 : e.getAttribute("role")) != null && t.startsWith("menuitem"));
}
function qK(e = {}, t = null) {
  const n = dd();
  if (!n)
    throw new Error(
      "useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>"
    );
  const {
    focusedIndex: r,
    setFocusedIndex: o,
    menuRef: a,
    isOpen: s,
    onClose: l,
    menuId: c,
    isLazy: d,
    lazyBehavior: f,
    scrollIntoViewRef: h,
    unstable__animationState: m
  } = n, g = ZK(), b = bJ({
    preventDefault: (x) => x.key !== " " && p3(x.target)
  }), C = te(
    (x) => {
      if (!x.currentTarget.contains(x.target))
        return;
      const I = x.key, E = {
        Tab: (N) => N.preventDefault(),
        Escape: (N) => {
          N.stopPropagation(), l();
        },
        ArrowDown: () => {
          h.current = !0;
          const N = g.nextEnabled(r) ?? g.firstEnabled();
          N && o(N.index);
        },
        ArrowUp: () => {
          h.current = !0;
          const N = g.prevEnabled(r) ?? g.firstEnabled();
          N && o(N.index);
        }
      }[I];
      if (E) {
        x.preventDefault(), E(x);
        return;
      }
      const k = b((N) => {
        const P = vJ(
          g.values(),
          N,
          (F) => {
            var G;
            return ((G = F == null ? void 0 : F.node) == null ? void 0 : G.textContent) ?? "";
          },
          g.item(r)
        );
        if (P) {
          const F = g.indexOf(P.node);
          o(F);
        }
      });
      p3(x.target) && k(x);
    },
    [
      g,
      r,
      b,
      l,
      o,
      h
    ]
  ), y = He(!1);
  s && (y.current = !0);
  const _ = Bk({
    wasSelected: y.current,
    enabled: d,
    mode: f,
    isSelected: m.present
  });
  return {
    ...e,
    ref: ir(a, t),
    children: _ ? e.children : null,
    tabIndex: -1,
    role: "menu",
    id: c,
    style: {
      ...e.style,
      transformOrigin: "var(--popper-transform-origin)"
    },
    "aria-orientation": "vertical",
    onKeyDown: lt(e.onKeyDown, C)
  };
}
function JK(e = {}) {
  const { popper: t, isOpen: n } = dd();
  return t.getPopperProps({
    ...e,
    style: {
      visibility: n ? "visible" : "hidden",
      ...e.style
    }
  });
}
function KK(e = {}, t = null) {
  const {
    onMouseEnter: n,
    onMouseMove: r,
    onMouseLeave: o,
    onClick: a,
    onFocus: s,
    isDisabled: l,
    isFocusable: c,
    closeOnSelect: d,
    type: f,
    ...h
  } = e, m = dd(), {
    setFocusedIndex: g,
    focusedIndex: b,
    closeOnSelect: C,
    onClose: y,
    menuId: _,
    scrollIntoViewRef: x
  } = m, I = He(null), R = `${_}-menuitem-${Xo()}`, { index: E, register: k } = WK({
    disabled: l && !c
  }), N = te(
    (le) => {
      n == null || n(le), !l && (x.current = !1, g(E));
    },
    [g, E, l, n, x]
  ), P = te(
    (le) => {
      r == null || r(le), I.current && !UK(I.current) && N(le);
    },
    [N, r]
  ), F = te(
    (le) => {
      o == null || o(le), !l && g(-1);
    },
    [g, l, o]
  ), G = te(
    (le) => {
      a == null || a(le), p3(le.currentTarget) && (d ?? C) && y();
    },
    [y, a, C, d]
  ), j = te(
    (le) => {
      s == null || s(le), g(E);
    },
    [g, s, E]
  ), ae = E === b, ue = GK({
    onClick: G,
    onFocus: j,
    onMouseEnter: N,
    onMouseMove: P,
    onMouseLeave: F,
    ref: ir(k, I, t),
    isDisabled: l,
    isFocusable: c
  });
  return {
    ...h,
    ...ue,
    type: f ?? ue.type,
    id: R,
    role: "menuitem",
    tabIndex: ae ? 0 : -1
  };
}
function QK(e) {
  if (!eQ(e))
    return !1;
  const t = e.ownerDocument.defaultView ?? window;
  return e instanceof t.HTMLElement;
}
function eQ(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
const [tQ, fd] = bn({
  name: "MenuStylesContext",
  errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
}), JM = (e) => {
  const { children: t } = e, n = Ir("Menu", e), r = Wn(e), { direction: o } = rh(), { descendants: a, ...s } = XK({ ...r, direction: o }), l = Et(() => s, [s]), { isOpen: c, onClose: d, forceUpdate: f } = l;
  return /* @__PURE__ */ A.jsx($K, { value: a, children: /* @__PURE__ */ A.jsx(zK, { value: l, children: /* @__PURE__ */ A.jsx(tQ, { value: n, children: da(t, { isOpen: c, onClose: d, forceUpdate: f }) }) }) });
};
JM.displayName = "Menu";
const nQ = Ze((e, t) => {
  const n = fd();
  return /* @__PURE__ */ A.jsx(
    Ne.button,
    {
      ref: t,
      ...e,
      __css: {
        display: "inline-flex",
        appearance: "none",
        alignItems: "center",
        outline: 0,
        ...n.button
      }
    }
  );
}), KM = Ze(
  (e, t) => {
    const { children: n, as: r, ...o } = e, a = YK(o, t), s = r || nQ;
    return /* @__PURE__ */ A.jsx(
      s,
      {
        ...a,
        className: Ye("chakra-menu__menu-button", e.className),
        children: /* @__PURE__ */ A.jsx(
          Ne.span,
          {
            __css: { pointerEvents: "none", flex: "1 1 auto", minW: 0 },
            children: e.children
          }
        )
      }
    );
  }
);
KM.displayName = "MenuButton";
const QM = Ze(
  (e, t) => {
    const n = fd();
    return /* @__PURE__ */ A.jsx(
      Ne.span,
      {
        ref: t,
        ...e,
        __css: n.command,
        className: "chakra-menu__command"
      }
    );
  }
);
QM.displayName = "MenuCommand";
const ex = (e) => {
  const { className: t, children: n, ...r } = e, o = fd(), a = $f.only(n), s = tc(a) ? Fa(a, {
    focusable: "false",
    "aria-hidden": !0,
    className: Ye("chakra-menu__icon", a.props.className)
  }) : null, l = Ye("chakra-menu__icon-wrapper", t);
  return /* @__PURE__ */ A.jsx(Ne.span, { className: l, ...r, __css: o.icon, children: s });
};
ex.displayName = "MenuIcon";
const rQ = Ze(
  (e, t) => {
    const { type: n, ...r } = e, o = fd(), a = r.as || n ? n ?? void 0 : "button", s = Et(
      () => ({
        textDecoration: "none",
        color: "inherit",
        userSelect: "none",
        display: "flex",
        width: "100%",
        alignItems: "center",
        textAlign: "start",
        flex: "0 0 auto",
        outline: 0,
        ...o.item
      }),
      [o.item]
    );
    return /* @__PURE__ */ A.jsx(Ne.button, { ref: t, type: a, ...r, __css: s });
  }
), tx = Ze((e, t) => {
  const {
    icon: n,
    iconSpacing: r = "0.75rem",
    command: o,
    commandSpacing: a = "0.75rem",
    children: s,
    ...l
  } = e, c = KK(l, t), f = n || o ? /* @__PURE__ */ A.jsx("span", { style: { pointerEvents: "none", flex: 1 }, children: s }) : s;
  return /* @__PURE__ */ A.jsxs(
    rQ,
    {
      ...c,
      className: Ye("chakra-menu__menuitem", c.className),
      children: [
        n && /* @__PURE__ */ A.jsx(ex, { fontSize: "0.8em", marginEnd: r, children: n }),
        f,
        o && /* @__PURE__ */ A.jsx(QM, { marginStart: a, children: o })
      ]
    }
  );
});
tx.displayName = "MenuItem";
const oQ = {
  enter: {
    visibility: "visible",
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    transitionEnd: {
      visibility: "hidden"
    },
    opacity: 0,
    scale: 0.8,
    transition: {
      duration: 0.1,
      easings: "easeOut"
    }
  }
}, aQ = Ne($a.div), nx = Ze(
  function(t, n) {
    var m;
    const { rootProps: r, motionProps: o, ...a } = t, {
      isOpen: s,
      onTransitionEnd: l,
      unstable__animationState: c
    } = dd(), d = qK(a, n), f = JK(r), h = fd();
    return /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ...f,
        __css: { zIndex: t.zIndex ?? ((m = h.list) == null ? void 0 : m.zIndex) },
        children: /* @__PURE__ */ A.jsx(
          aQ,
          {
            variants: oQ,
            initial: !1,
            animate: s ? "enter" : "exit",
            __css: { outline: 0, ...h.list },
            ...o,
            ...d,
            className: Ye("chakra-menu__menu-list", d.className),
            onUpdate: l,
            onAnimationComplete: ig(
              c.onComplete,
              d.onAnimationComplete
            )
          }
        )
      }
    );
  }
);
nx.displayName = "MenuList";
var iQ = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, lu = /* @__PURE__ */ new WeakMap(), X0 = /* @__PURE__ */ new WeakMap(), Y0 = {}, Km = 0, rx = function(e) {
  return e && (e.host || rx(e.parentNode));
}, sQ = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = rx(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, lQ = function(e, t, n, r) {
  var o = sQ(t, Array.isArray(e) ? e : [e]);
  Y0[n] || (Y0[n] = /* @__PURE__ */ new WeakMap());
  var a = Y0[n], s = [], l = /* @__PURE__ */ new Set(), c = new Set(o), d = function(h) {
    !h || l.has(h) || (l.add(h), d(h.parentNode));
  };
  o.forEach(d);
  var f = function(h) {
    !h || c.has(h) || Array.prototype.forEach.call(h.children, function(m) {
      if (l.has(m))
        f(m);
      else
        try {
          var g = m.getAttribute(r), b = g !== null && g !== "false", C = (lu.get(m) || 0) + 1, y = (a.get(m) || 0) + 1;
          lu.set(m, C), a.set(m, y), s.push(m), C === 1 && b && X0.set(m, !0), y === 1 && m.setAttribute(n, "true"), b || m.setAttribute(r, "true");
        } catch (_) {
          console.error("aria-hidden: cannot operate on ", m, _);
        }
    });
  };
  return f(t), l.clear(), Km++, function() {
    s.forEach(function(h) {
      var m = lu.get(h) - 1, g = a.get(h) - 1;
      lu.set(h, m), a.set(h, g), m || (X0.has(h) || h.removeAttribute(r), X0.delete(h)), g || h.removeAttribute(n);
    }), Km--, Km || (lu = /* @__PURE__ */ new WeakMap(), lu = /* @__PURE__ */ new WeakMap(), X0 = /* @__PURE__ */ new WeakMap(), Y0 = {});
  };
}, uQ = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || iQ(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), lQ(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, cQ = Object.defineProperty, dQ = (e, t, n) => t in e ? cQ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, fQ = (e, t, n) => (dQ(e, typeof t != "symbol" ? t + "" : t, n), n);
class hQ {
  constructor() {
    fQ(this, "modals"), this.modals = /* @__PURE__ */ new Set();
  }
  add(t) {
    return this.modals.add(t), this.modals.size;
  }
  remove(t) {
    this.modals.delete(t);
  }
  isTopModal(t) {
    if (!t)
      return !1;
    const n = Array.from(this.modals)[this.modals.size - 1];
    return t === n;
  }
}
const m3 = new hQ();
function ox(e, t) {
  const [n, r] = je(0);
  return ft(() => {
    const o = e.current;
    if (o) {
      if (t) {
        const a = m3.add(o);
        r(a);
      }
      return () => {
        m3.remove(o), r(0);
      };
    }
  }, [t, e]), n;
}
function pQ(e) {
  const {
    isOpen: t,
    onClose: n,
    id: r,
    closeOnOverlayClick: o = !0,
    closeOnEsc: a = !0,
    useInert: s = !0,
    onOverlayClick: l,
    onEsc: c
  } = e, d = He(null), f = He(null), [h, m, g] = gQ(
    r,
    "chakra-modal",
    "chakra-modal--header",
    "chakra-modal--body"
  );
  mQ(d, t && s);
  const b = ox(d, t), C = He(null), y = te((F) => {
    C.current = F.target;
  }, []), _ = te(
    (F) => {
      F.key === "Escape" && (F.stopPropagation(), a && (n == null || n()), c == null || c());
    },
    [a, n, c]
  ), [x, I] = je(!1), [R, E] = je(!1), k = te(
    (F = {}, G = null) => ({
      role: "dialog",
      ...F,
      ref: ir(G, d),
      id: h,
      tabIndex: -1,
      "aria-modal": !0,
      "aria-labelledby": x ? m : void 0,
      "aria-describedby": R ? g : void 0,
      onClick: lt(
        F.onClick,
        (j) => j.stopPropagation()
      )
    }),
    [g, R, h, m, x]
  ), N = te(
    (F) => {
      F.stopPropagation(), C.current === F.target && m3.isTopModal(d.current) && (o && (n == null || n()), l == null || l());
    },
    [n, o, l]
  ), P = te(
    (F = {}, G = null) => ({
      ...F,
      ref: ir(G, f),
      onClick: lt(F.onClick, N),
      onKeyDown: lt(F.onKeyDown, _),
      onMouseDown: lt(F.onMouseDown, y)
    }),
    [_, y, N]
  );
  return {
    isOpen: t,
    onClose: n,
    headerId: m,
    bodyId: g,
    setBodyMounted: E,
    setHeaderMounted: I,
    dialogRef: d,
    overlayRef: f,
    getDialogProps: k,
    getDialogContainerProps: P,
    index: b
  };
}
function mQ(e, t) {
  const n = e.current;
  ft(() => {
    if (!(!e.current || !t))
      return uQ(e.current);
  }, [t, e, n]);
}
function gQ(e, ...t) {
  const n = Xo(), r = e || n;
  return Et(() => t.map((o) => `${o}-${r}`), [r, t]);
}
const [vQ, wl] = bn({
  name: "ModalStylesContext",
  errorMessage: `useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
}), [CQ, ms] = bn({
  strict: !0,
  name: "ModalContext",
  errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
}), M4 = (e) => {
  const t = {
    scrollBehavior: "outside",
    autoFocus: !0,
    trapFocus: !0,
    returnFocusOnClose: !0,
    blockScrollOnMount: !0,
    allowPinchZoom: !1,
    preserveScrollBarGap: !0,
    motionPreset: "scale",
    ...e,
    lockFocusAcrossFrames: e.lockFocusAcrossFrames ?? !0
  }, {
    portalProps: n,
    children: r,
    autoFocus: o,
    trapFocus: a,
    initialFocusRef: s,
    finalFocusRef: l,
    returnFocusOnClose: c,
    blockScrollOnMount: d,
    allowPinchZoom: f,
    preserveScrollBarGap: h,
    motionPreset: m,
    lockFocusAcrossFrames: g,
    animatePresenceProps: b,
    onCloseComplete: C
  } = t, y = Ir("Modal", t), x = {
    ...pQ(t),
    autoFocus: o,
    trapFocus: a,
    initialFocusRef: s,
    finalFocusRef: l,
    returnFocusOnClose: c,
    blockScrollOnMount: d,
    allowPinchZoom: f,
    preserveScrollBarGap: h,
    motionPreset: m,
    lockFocusAcrossFrames: g
  };
  return /* @__PURE__ */ A.jsx(CQ, { value: x, children: /* @__PURE__ */ A.jsx(vQ, { value: y, children: /* @__PURE__ */ A.jsx(
    Ss,
    {
      ...b,
      onExitComplete: C,
      children: x.isOpen && /* @__PURE__ */ A.jsx(rc, { ...n, children: r })
    }
  ) }) });
};
M4.displayName = "Modal";
var L2 = "right-scroll-bar-position", R2 = "width-before-scroll-bar", bQ = "with-scroll-bars-hidden", yQ = "--removed-body-scroll-bar-size", ax = oM(), Qm = function() {
}, lh = De.forwardRef(function(e, t) {
  var n = De.useRef(null), r = De.useState({
    onScrollCapture: Qm,
    onWheelCapture: Qm,
    onTouchMoveCapture: Qm
  }), o = r[0], a = r[1], s = e.forwardProps, l = e.children, c = e.className, d = e.removeScrollBar, f = e.enabled, h = e.shards, m = e.sideCar, g = e.noRelative, b = e.noIsolation, C = e.inert, y = e.allowPinchZoom, _ = e.as, x = _ === void 0 ? "div" : _, I = e.gapMode, R = tM(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = m, k = eM([n, t]), N = Ra(Ra({}, R), o);
  return De.createElement(
    De.Fragment,
    null,
    f && De.createElement(E, { sideCar: ax, removeScrollBar: d, shards: h, noRelative: g, noIsolation: b, inert: C, setCallbacks: a, allowPinchZoom: !!y, lockRef: n, gapMode: I }),
    s ? De.cloneElement(De.Children.only(l), Ra(Ra({}, N), { ref: k })) : De.createElement(x, Ra({}, N, { className: c, ref: k }), l)
  );
});
lh.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
lh.classNames = {
  fullWidth: R2,
  zeroRight: L2
};
var jv, SQ = function() {
  if (jv)
    return jv;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function AQ() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = SQ();
  return t && e.setAttribute("nonce", t), e;
}
function MQ(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function xQ(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var _Q = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = AQ()) && (MQ(t, n), xQ(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, IQ = function() {
  var e = _Q();
  return function(t, n) {
    De.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, ix = function() {
  var e = IQ(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, wQ = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, e5 = function(e) {
  return parseInt(e || "", 10) || 0;
}, LQ = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [e5(n), e5(r), e5(o)];
}, RQ = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return wQ;
  var t = LQ(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, EQ = ix(), Vu = "data-scroll-locked", DQ = function(e, t, n, r) {
  var o = e.left, a = e.top, s = e.right, l = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(bQ, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(l, "px ").concat(r, `;
  }
  body[`).concat(Vu, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(l, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(L2, ` {
    right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(R2, ` {
    margin-right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(L2, " .").concat(L2, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(R2, " .").concat(R2, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Vu, `] {
    `).concat(yQ, ": ").concat(l, `px;
  }
`);
}, Wv = function() {
  var e = parseInt(document.body.getAttribute(Vu) || "0", 10);
  return isFinite(e) ? e : 0;
}, NQ = function() {
  De.useEffect(function() {
    return document.body.setAttribute(Vu, (Wv() + 1).toString()), function() {
      var e = Wv() - 1;
      e <= 0 ? document.body.removeAttribute(Vu) : document.body.setAttribute(Vu, e.toString());
    };
  }, []);
}, TQ = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  NQ();
  var a = De.useMemo(function() {
    return RQ(o);
  }, [o]);
  return De.createElement(EQ, { styles: DQ(a, !t, o, n ? "" : "!important") });
}, g3 = !1;
if (typeof window < "u")
  try {
    var q0 = Object.defineProperty({}, "passive", {
      get: function() {
        return g3 = !0, !0;
      }
    });
    window.addEventListener("test", q0, q0), window.removeEventListener("test", q0, q0);
  } catch {
    g3 = !1;
  }
var uu = g3 ? { passive: !1 } : !1, PQ = function(e) {
  return e.tagName === "TEXTAREA";
}, sx = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !PQ(e) && n[t] === "visible")
  );
}, kQ = function(e) {
  return sx(e, "overflowY");
}, VQ = function(e) {
  return sx(e, "overflowX");
}, zv = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = lx(e, r);
    if (o) {
      var a = ux(e, r), s = a[1], l = a[2];
      if (s > l)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, OQ = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, FQ = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, lx = function(e, t) {
  return e === "v" ? kQ(t) : VQ(t);
}, ux = function(e, t) {
  return e === "v" ? OQ(t) : FQ(t);
}, BQ = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, HQ = function(e, t, n, r, o) {
  var a = BQ(e, window.getComputedStyle(t).direction), s = a * r, l = n.target, c = t.contains(l), d = !1, f = s > 0, h = 0, m = 0;
  do {
    if (!l)
      break;
    var g = ux(e, l), b = g[0], C = g[1], y = g[2], _ = C - y - a * b;
    (b || _) && lx(e, l) && (h += _, m += b);
    var x = l.parentNode;
    l = x && x.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? x.host : x;
  } while (
    // portaled content
    !c && l !== document.body || // self content
    c && (t.contains(l) || t === l)
  );
  return (f && (o && Math.abs(h) < 1 || !o && s > h) || !f && (o && Math.abs(m) < 1 || !o && -s > m)) && (d = !0), d;
}, J0 = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Uv = function(e) {
  return [e.deltaX, e.deltaY];
}, Xv = function(e) {
  return e && "current" in e ? e.current : e;
}, GQ = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, $Q = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, ZQ = 0, cu = [];
function jQ(e) {
  var t = De.useRef([]), n = De.useRef([0, 0]), r = De.useRef(), o = De.useState(ZQ++)[0], a = De.useState(ix)[0], s = De.useRef(e);
  De.useEffect(function() {
    s.current = e;
  }, [e]), De.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var C = eq([e.lockRef.current], (e.shards || []).map(Xv), !0).filter(Boolean);
      return C.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), C.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = De.useCallback(function(C, y) {
    if ("touches" in C && C.touches.length === 2 || C.type === "wheel" && C.ctrlKey)
      return !s.current.allowPinchZoom;
    var _ = J0(C), x = n.current, I = "deltaX" in C ? C.deltaX : x[0] - _[0], R = "deltaY" in C ? C.deltaY : x[1] - _[1], E, k = C.target, N = Math.abs(I) > Math.abs(R) ? "h" : "v";
    if ("touches" in C && N === "h" && k.type === "range")
      return !1;
    var P = zv(N, k);
    if (!P)
      return !0;
    if (P ? E = N : (E = N === "v" ? "h" : "v", P = zv(N, k)), !P)
      return !1;
    if (!r.current && "changedTouches" in C && (I || R) && (r.current = E), !E)
      return !0;
    var F = r.current || E;
    return HQ(F, y, C, F === "h" ? I : R, !0);
  }, []), c = De.useCallback(function(C) {
    var y = C;
    if (!(!cu.length || cu[cu.length - 1] !== a)) {
      var _ = "deltaY" in y ? Uv(y) : J0(y), x = t.current.filter(function(E) {
        return E.name === y.type && (E.target === y.target || y.target === E.shadowParent) && GQ(E.delta, _);
      })[0];
      if (x && x.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!x) {
        var I = (s.current.shards || []).map(Xv).filter(Boolean).filter(function(E) {
          return E.contains(y.target);
        }), R = I.length > 0 ? l(y, I[0]) : !s.current.noIsolation;
        R && y.cancelable && y.preventDefault();
      }
    }
  }, []), d = De.useCallback(function(C, y, _, x) {
    var I = { name: C, delta: y, target: _, should: x, shadowParent: WQ(_) };
    t.current.push(I), setTimeout(function() {
      t.current = t.current.filter(function(R) {
        return R !== I;
      });
    }, 1);
  }, []), f = De.useCallback(function(C) {
    n.current = J0(C), r.current = void 0;
  }, []), h = De.useCallback(function(C) {
    d(C.type, Uv(C), C.target, l(C, e.lockRef.current));
  }, []), m = De.useCallback(function(C) {
    d(C.type, J0(C), C.target, l(C, e.lockRef.current));
  }, []);
  De.useEffect(function() {
    return cu.push(a), e.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", c, uu), document.addEventListener("touchmove", c, uu), document.addEventListener("touchstart", f, uu), function() {
      cu = cu.filter(function(C) {
        return C !== a;
      }), document.removeEventListener("wheel", c, uu), document.removeEventListener("touchmove", c, uu), document.removeEventListener("touchstart", f, uu);
    };
  }, []);
  var g = e.removeScrollBar, b = e.inert;
  return De.createElement(
    De.Fragment,
    null,
    b ? De.createElement(a, { styles: $Q(o) }) : null,
    g ? De.createElement(TQ, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function WQ(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const zQ = tq(ax, jQ);
var cx = De.forwardRef(function(e, t) {
  return De.createElement(lh, Ra({}, e, { ref: t, sideCar: zQ }));
});
cx.classNames = lh.classNames;
const UQ = cx;
function dx(e) {
  const {
    autoFocus: t,
    trapFocus: n,
    dialogRef: r,
    initialFocusRef: o,
    blockScrollOnMount: a,
    allowPinchZoom: s,
    finalFocusRef: l,
    returnFocusOnClose: c,
    preserveScrollBarGap: d,
    lockFocusAcrossFrames: f,
    isOpen: h
  } = ms(), [m, g] = lA();
  ft(() => {
    !m && g && setTimeout(g);
  }, [m, g]);
  const b = ox(r, h);
  return /* @__PURE__ */ A.jsx(
    kM,
    {
      autoFocus: t,
      isDisabled: !n,
      initialFocusRef: o,
      finalFocusRef: l,
      restoreFocus: c,
      contentRef: r,
      lockFocusAcrossFrames: f,
      children: /* @__PURE__ */ A.jsx(
        UQ,
        {
          removeScrollBar: !d,
          allowPinchZoom: s,
          enabled: b === 1 && a,
          forwardProps: !0,
          children: e.children
        }
      )
    }
  );
}
const XQ = {
  initial: ({ offsetX: e, offsetY: t, transition: n, transitionEnd: r, delay: o }) => ({
    opacity: 0,
    x: e,
    y: t,
    transition: (n == null ? void 0 : n.exit) ?? fa.exit(il.exit, o),
    transitionEnd: r == null ? void 0 : r.exit
  }),
  enter: ({ transition: e, transitionEnd: t, delay: n }) => ({
    opacity: 1,
    x: 0,
    y: 0,
    transition: (e == null ? void 0 : e.enter) ?? fa.enter(il.enter, n),
    transitionEnd: t == null ? void 0 : t.enter
  }),
  exit: ({ offsetY: e, offsetX: t, transition: n, transitionEnd: r, reverse: o, delay: a }) => {
    const s = { x: t, y: e };
    return {
      opacity: 0,
      transition: (n == null ? void 0 : n.exit) ?? fa.exit(il.exit, a),
      ...o ? { ...s, transitionEnd: r == null ? void 0 : r.exit } : { transitionEnd: { ...s, ...r == null ? void 0 : r.exit } }
    };
  }
}, d1 = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: XQ
}, YQ = nt(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      reverse: a = !0,
      className: s,
      offsetX: l = 0,
      offsetY: c = 8,
      transition: d,
      transitionEnd: f,
      delay: h,
      animatePresenceProps: m,
      ...g
    } = t, b = r ? o && r : !0, C = o || r ? "enter" : "exit", y = {
      offsetX: l,
      offsetY: c,
      reverse: a,
      transition: d,
      transitionEnd: f,
      delay: h
    };
    return /* @__PURE__ */ A.jsx(Ss, { ...m, custom: y, children: b && /* @__PURE__ */ A.jsx(
      $a.div,
      {
        ref: n,
        className: Ye("chakra-offset-slide", s),
        custom: y,
        ...d1,
        animate: C,
        ...g
      }
    ) });
  }
);
YQ.displayName = "SlideFade";
const qQ = {
  exit: ({ reverse: e, initialScale: t, transition: n, transitionEnd: r, delay: o }) => ({
    opacity: 0,
    ...e ? { scale: t, transitionEnd: r == null ? void 0 : r.exit } : { transitionEnd: { scale: t, ...r == null ? void 0 : r.exit } },
    transition: (n == null ? void 0 : n.exit) ?? fa.exit(il.exit, o)
  }),
  enter: ({ transitionEnd: e, transition: t, delay: n }) => ({
    opacity: 1,
    scale: 1,
    transition: (t == null ? void 0 : t.enter) ?? fa.enter(il.enter, n),
    transitionEnd: e == null ? void 0 : e.enter
  })
}, fx = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: qQ
}, JQ = nt(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      reverse: a = !0,
      initialScale: s = 0.95,
      className: l,
      transition: c,
      transitionEnd: d,
      delay: f,
      animatePresenceProps: h,
      ...m
    } = t, g = r ? o && r : !0, b = o || r ? "enter" : "exit", C = { initialScale: s, reverse: a, transition: c, transitionEnd: d, delay: f };
    return /* @__PURE__ */ A.jsx(Ss, { ...h, custom: C, children: g && /* @__PURE__ */ A.jsx(
      $a.div,
      {
        ref: n,
        className: Ye("chakra-offset-slide", l),
        ...fx,
        animate: b,
        custom: C,
        ...m
      }
    ) });
  }
);
JQ.displayName = "ScaleFade";
const KQ = {
  slideInBottom: {
    ...d1,
    custom: { offsetY: 16, reverse: !0 }
  },
  slideInRight: {
    ...d1,
    custom: { offsetX: 16, reverse: !0 }
  },
  slideInTop: {
    ...d1,
    custom: { offsetY: -16, reverse: !0 }
  },
  slideInLeft: {
    ...d1,
    custom: { offsetX: -16, reverse: !0 }
  },
  scale: {
    ...fx,
    custom: { initialScale: 0.95, reverse: !0 }
  },
  none: {}
}, QQ = Ne($a.section), eee = (e) => KQ[e || "none"], hx = nt(
  (e, t) => {
    const { preset: n, motionProps: r = eee(n), ...o } = e;
    return /* @__PURE__ */ A.jsx(QQ, { ref: t, ...r, ...o });
  }
);
hx.displayName = "ModalTransition";
const px = Ze(
  (e, t) => {
    const {
      className: n,
      children: r,
      containerProps: o,
      motionProps: a,
      ...s
    } = e, { getDialogProps: l, getDialogContainerProps: c } = ms(), d = l(s, t), f = c(o), h = Ye("chakra-modal__content", n), m = wl(), g = {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      ...m.dialog
    }, b = {
      display: "flex",
      width: "100vw",
      height: "$100vh",
      position: "fixed",
      left: 0,
      top: 0,
      ...m.dialogContainer
    }, { motionPreset: C } = ms();
    return /* @__PURE__ */ A.jsx(dx, { children: /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ...f,
        className: "chakra-modal__content-container",
        tabIndex: -1,
        __css: b,
        children: /* @__PURE__ */ A.jsx(
          hx,
          {
            preset: C,
            motionProps: a,
            className: h,
            ...d,
            __css: g,
            children: r
          }
        )
      }
    ) });
  }
);
px.displayName = "ModalContent";
const x4 = Ze((e, t) => {
  const { className: n, ...r } = e, { bodyId: o, setBodyMounted: a } = ms();
  ft(() => (a(!0), () => a(!1)), [a]);
  const s = Ye("chakra-modal__body", n), l = wl();
  return /* @__PURE__ */ A.jsx(
    Ne.div,
    {
      ref: t,
      className: s,
      id: o,
      ...r,
      __css: l.body
    }
  );
});
x4.displayName = "ModalBody";
const mx = Ze(
  (e, t) => {
    const { onClick: n, className: r, ...o } = e, { onClose: a } = ms(), s = Ye("chakra-modal__close-btn", r), l = wl();
    return /* @__PURE__ */ A.jsx(
      oh,
      {
        ref: t,
        __css: l.closeButton,
        className: s,
        onClick: lt(n, (c) => {
          c.stopPropagation(), a();
        }),
        ...o
      }
    );
  }
);
mx.displayName = "ModalCloseButton";
const _4 = Ze(
  (e, t) => {
    const { className: n, ...r } = e, o = Ye("chakra-modal__footer", n), a = wl(), s = {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      ...a.footer
    };
    return /* @__PURE__ */ A.jsx(
      Ne.footer,
      {
        ref: t,
        ...r,
        __css: s,
        className: o
      }
    );
  }
);
_4.displayName = "ModalFooter";
const I4 = Ze(
  (e, t) => {
    const { className: n, ...r } = e, { headerId: o, setHeaderMounted: a } = ms();
    ft(() => (a(!0), () => a(!1)), [a]);
    const s = Ye("chakra-modal__header", n), l = wl(), c = {
      flex: 0,
      ...l.header
    };
    return /* @__PURE__ */ A.jsx(
      Ne.header,
      {
        ref: t,
        className: s,
        id: o,
        ...r,
        __css: c
      }
    );
  }
);
I4.displayName = "ModalHeader";
const tee = {
  enter: ({ transition: e, transitionEnd: t, delay: n } = {}) => ({
    opacity: 1,
    transition: (e == null ? void 0 : e.enter) ?? fa.enter(il.enter, n),
    transitionEnd: t == null ? void 0 : t.enter
  }),
  exit: ({ transition: e, transitionEnd: t, delay: n } = {}) => ({
    opacity: 0,
    transition: (e == null ? void 0 : e.exit) ?? fa.exit(il.exit, n),
    transitionEnd: t == null ? void 0 : t.exit
  })
}, gx = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: tee
}, nee = nt(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      className: a,
      transition: s,
      transitionEnd: l,
      delay: c,
      animatePresenceProps: d,
      ...f
    } = t, h = o || r ? "enter" : "exit", m = r ? o && r : !0, g = { transition: s, transitionEnd: l, delay: c };
    return /* @__PURE__ */ A.jsx(Ss, { ...d, custom: g, children: m && /* @__PURE__ */ A.jsx(
      $a.div,
      {
        ref: n,
        className: Ye("chakra-fade", a),
        custom: g,
        ...gx,
        animate: h,
        ...f
      }
    ) });
  }
);
nee.displayName = "Fade";
const ree = Ne($a.div), w4 = Ze(
  (e, t) => {
    const { className: n, transition: r, motionProps: o, ...a } = e, s = Ye("chakra-modal__overlay", n), c = {
      pos: "fixed",
      left: "0",
      top: "0",
      w: "100vw",
      h: "100vh",
      ...wl().overlay
    }, { motionPreset: d } = ms(), h = o || (d === "none" ? {} : gx);
    return /* @__PURE__ */ A.jsx(
      ree,
      {
        ...h,
        __css: c,
        ref: t,
        className: s,
        ...a
      }
    );
  }
);
w4.displayName = "ModalOverlay";
const [oee, aee] = bn(), iee = {
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
};
function see(e, t) {
  var n;
  if (e)
    return ((n = iee[e]) == null ? void 0 : n[t]) ?? e;
}
function lee(e) {
  var d;
  const {
    isOpen: t,
    onClose: n,
    placement: r = "right",
    children: o,
    ...a
  } = e, s = rh(), l = (d = s.components) == null ? void 0 : d.Drawer, c = see(r, s.direction);
  return /* @__PURE__ */ A.jsx(oee, { value: { placement: c }, children: /* @__PURE__ */ A.jsx(
    M4,
    {
      isOpen: t,
      onClose: n,
      styleConfig: l,
      ...a,
      children: o
    }
  ) });
}
const Yv = {
  exit: {
    duration: 0.15,
    ease: el.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
}, uee = {
  exit: ({ direction: e, transition: t, transitionEnd: n, delay: r }) => {
    const { exit: o } = r3({ direction: e });
    return {
      ...o,
      transition: (t == null ? void 0 : t.exit) ?? fa.exit(Yv.exit, r),
      transitionEnd: n == null ? void 0 : n.exit
    };
  },
  enter: ({ direction: e, transitionEnd: t, transition: n, delay: r }) => {
    const { enter: o } = r3({ direction: e });
    return {
      ...o,
      transition: (n == null ? void 0 : n.enter) ?? fa.enter(Yv.enter, r),
      transitionEnd: t == null ? void 0 : t.enter
    };
  }
}, vx = nt(
  function(t, n) {
    const {
      direction: r = "right",
      style: o,
      unmountOnExit: a,
      in: s,
      className: l,
      transition: c,
      transitionEnd: d,
      delay: f,
      motionProps: h,
      animatePresenceProps: m,
      ...g
    } = t, b = r3({ direction: r }), C = Object.assign(
      { position: "fixed" },
      b.position,
      o
    ), y = a ? s && a : !0, _ = s || a ? "enter" : "exit", x = { transitionEnd: d, transition: c, direction: r, delay: f };
    return /* @__PURE__ */ A.jsx(Ss, { ...m, custom: x, children: y && /* @__PURE__ */ A.jsx(
      $a.div,
      {
        ...g,
        ref: n,
        initial: "exit",
        className: Ye("chakra-slide", l),
        animate: _,
        exit: "exit",
        custom: x,
        variants: uee,
        style: C,
        ...h
      }
    ) });
  }
);
vx.displayName = "Slide";
const cee = Ne(vx), Cx = Ze(
  (e, t) => {
    const {
      className: n,
      children: r,
      motionProps: o,
      containerProps: a,
      ...s
    } = e, { getDialogProps: l, getDialogContainerProps: c, isOpen: d } = ms(), f = l(s, t), h = c(a), m = Ye("chakra-modal__content", n), g = wl(), b = {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      ...g.dialog
    }, C = {
      display: "flex",
      width: "100vw",
      height: "$100vh",
      position: "fixed",
      left: 0,
      top: 0,
      ...g.dialogContainer
    }, { placement: y } = aee();
    return /* @__PURE__ */ A.jsx(dx, { children: /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ...h,
        className: "chakra-modal__content-container",
        __css: C,
        children: /* @__PURE__ */ A.jsx(
          cee,
          {
            motionProps: o,
            direction: y,
            in: d,
            className: m,
            ...f,
            __css: b,
            children: r
          }
        )
      }
    ) });
  }
);
Cx.displayName = "DrawerContent";
const dee = (e) => /* @__PURE__ */ A.jsx(Li, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ A.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z"
  }
) }), fee = (e) => /* @__PURE__ */ A.jsx(Li, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ A.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z"
  }
) });
function qv(e, t, n, r) {
  ft(() => {
    if (!e.current || !r)
      return;
    const o = e.current.ownerDocument.defaultView ?? window, a = Array.isArray(t) ? t : [t], s = new o.MutationObserver((l) => {
      for (const c of l)
        c.type === "attributes" && c.attributeName && a.includes(c.attributeName) && n(c);
    });
    return s.observe(e.current, { attributes: !0, attributeFilter: a }), () => s.disconnect();
  });
}
const hee = 50, Jv = 300;
function pee(e, t) {
  const [n, r] = je(!1), [o, a] = je(null), [s, l] = je(!0), c = He(null), d = () => clearTimeout(c.current);
  eV(
    () => {
      o === "increment" && e(), o === "decrement" && t();
    },
    n ? hee : null
  );
  const f = te(() => {
    s && e(), c.current = setTimeout(() => {
      l(!1), r(!0), a("increment");
    }, Jv);
  }, [e, s]), h = te(() => {
    s && t(), c.current = setTimeout(() => {
      l(!1), r(!0), a("decrement");
    }, Jv);
  }, [t, s]), m = te(() => {
    l(!0), r(!1), d();
  }, []);
  return ft(() => () => d(), []), { up: f, down: h, stop: m, isSpinning: n };
}
const mee = /^[Ee0-9+\-.]$/;
function gee(e) {
  return mee.test(e);
}
function vee(e, t) {
  if (e.key == null)
    return !0;
  const n = e.ctrlKey || e.altKey || e.metaKey;
  return !(e.key.length === 1) || n ? !0 : t(e.key);
}
function Cee(e = {}) {
  const {
    focusInputOnChange: t = !0,
    clampValueOnBlur: n = !0,
    keepWithinRange: r = !0,
    min: o = Number.MIN_SAFE_INTEGER,
    max: a = Number.MAX_SAFE_INTEGER,
    step: s = 1,
    isReadOnly: l,
    isDisabled: c,
    isRequired: d,
    isInvalid: f,
    pattern: h = "[0-9]*(.[0-9]+)?",
    inputMode: m = "decimal",
    allowMouseWheel: g,
    id: b,
    onChange: C,
    precision: y,
    name: _,
    "aria-describedby": x,
    "aria-label": I,
    "aria-labelledby": R,
    onFocus: E,
    onBlur: k,
    onInvalid: N,
    getAriaValueText: P,
    isValidCharacter: F,
    format: G,
    parse: j,
    ...ae
  } = e, ue = or(E), le = or(k), _e = or(N), ve = or(
    F ?? gee
  ), z = or(P), K = Yk(e), {
    update: Ce,
    increment: q,
    decrement: J
  } = K, [ge, X] = je(!1), pe = !(l || c), fe = He(null), de = He(null), we = He(null), Ie = He(null), Pe = te(
    (Le) => Le.split("").filter(ve).join(""),
    [ve]
  ), Se = te(
    (Le) => (j == null ? void 0 : j(Le)) ?? Le,
    [j]
  ), Fe = te(
    (Le) => ((G == null ? void 0 : G(Le)) ?? Le).toString(),
    [G]
  );
  ul(() => {
    (K.valueAsNumber > a || K.valueAsNumber < o) && (_e == null || _e("rangeOverflow", Fe(K.value), K.valueAsNumber));
  }, [K.valueAsNumber, K.value, Fe, _e]), ls(() => {
    if (!fe.current)
      return;
    if (fe.current.value != K.value) {
      const Zt = Se(fe.current.value);
      K.setValue(Pe(Zt));
    }
  }, [Se, Pe]);
  const oe = te(
    (Le = s) => {
      pe && q(Le);
    },
    [q, pe, s]
  ), pt = te(
    (Le = s) => {
      pe && J(Le);
    },
    [J, pe, s]
  ), Ee = pee(oe, pt);
  qv(
    we,
    "disabled",
    Ee.stop,
    Ee.isSpinning
  ), qv(
    Ie,
    "disabled",
    Ee.stop,
    Ee.isSpinning
  );
  const wt = te(
    (Le) => {
      if (Le.nativeEvent.isComposing)
        return;
      const wn = Se(Le.currentTarget.value);
      Ce(Pe(wn)), de.current = {
        start: Le.currentTarget.selectionStart,
        end: Le.currentTarget.selectionEnd
      };
    },
    [Ce, Pe, Se]
  ), an = te(
    (Le) => {
      var Zt;
      ue == null || ue(Le), de.current && (Le.currentTarget.selectionStart = de.current.start ?? ((Zt = Le.currentTarget.value) == null ? void 0 : Zt.length), Le.currentTarget.selectionEnd = de.current.end ?? Le.currentTarget.selectionStart);
    },
    [ue]
  ), Ft = te(
    (Le) => {
      if (Le.nativeEvent.isComposing)
        return;
      vee(Le, ve) || Le.preventDefault();
      const Zt = Kn(Le) * s, wn = Le.key, Zr = {
        ArrowUp: () => oe(Zt),
        ArrowDown: () => pt(Zt),
        Home: () => Ce(o),
        End: () => Ce(a)
      }[wn];
      Zr && (Le.preventDefault(), Zr(Le));
    },
    [ve, s, oe, pt, Ce, o, a]
  ), Kn = (Le) => {
    let Zt = 1;
    return (Le.metaKey || Le.ctrlKey) && (Zt = 0.1), Le.shiftKey && (Zt = 10), Zt;
  }, zn = Et(() => {
    const Le = z == null ? void 0 : z(K.value);
    if (Le != null)
      return Le;
    const Zt = K.value.toString();
    return Zt || void 0;
  }, [K.value, z]), Xt = te(() => {
    let Le = K.value;
    if (K.value === "")
      return;
    /^[eE]/.test(K.value.toString()) ? K.setValue("") : (K.valueAsNumber < o && (Le = o), K.valueAsNumber > a && (Le = a), K.cast(Le));
  }, [K, a, o]), sn = te(() => {
    X(!1), n && Xt();
  }, [n, X, Xt]), Tn = te(() => {
    t && requestAnimationFrame(() => {
      var Le;
      (Le = fe.current) == null || Le.focus();
    });
  }, [t]), Pn = te(
    (Le) => {
      Le.preventDefault(), Ee.up(), Tn();
    },
    [Tn, Ee]
  ), ro = te(
    (Le) => {
      Le.preventDefault(), Ee.down(), Tn();
    },
    [Tn, Ee]
  );
  v1(
    () => fe.current,
    "wheel",
    (Le) => {
      var Jo;
      const wn = (((Jo = fe.current) == null ? void 0 : Jo.ownerDocument) ?? document).activeElement === fe.current;
      if (!g || !wn)
        return;
      Le.preventDefault();
      const Un = Kn(Le) * s, Zr = Math.sign(Le.deltaY);
      Zr === -1 ? oe(Un) : Zr === 1 && pt(Un);
    },
    { passive: !1 }
  );
  const vr = te(
    (Le = {}, Zt = null) => {
      const wn = c || r && K.isAtMax;
      return {
        ...Le,
        ref: ir(Zt, we),
        role: "button",
        tabIndex: -1,
        onPointerDown: lt(Le.onPointerDown, (Un) => {
          Un.button !== 0 || wn || Pn(Un);
        }),
        onPointerLeave: lt(Le.onPointerLeave, Ee.stop),
        onPointerUp: lt(Le.onPointerUp, Ee.stop),
        disabled: wn,
        "aria-disabled": di(wn)
      };
    },
    [K.isAtMax, r, Pn, Ee.stop, c]
  ), qo = te(
    (Le = {}, Zt = null) => {
      const wn = c || r && K.isAtMin;
      return {
        ...Le,
        ref: ir(Zt, Ie),
        role: "button",
        tabIndex: -1,
        onPointerDown: lt(Le.onPointerDown, (Un) => {
          Un.button !== 0 || wn || ro(Un);
        }),
        onPointerLeave: lt(Le.onPointerLeave, Ee.stop),
        onPointerUp: lt(Le.onPointerUp, Ee.stop),
        disabled: wn,
        "aria-disabled": di(wn)
      };
    },
    [K.isAtMin, r, ro, Ee.stop, c]
  ), lr = te(
    (Le = {}, Zt = null) => ({
      name: _,
      inputMode: m,
      type: "text",
      pattern: h,
      "aria-labelledby": R,
      "aria-label": I,
      "aria-describedby": x,
      id: b,
      disabled: c,
      role: "spinbutton",
      ...Le,
      readOnly: Le.readOnly ?? l,
      "aria-readonly": Le.readOnly ?? l,
      "aria-required": Le.required ?? d,
      required: Le.required ?? d,
      ref: ir(fe, Zt),
      value: Fe(K.value),
      "aria-valuemin": o,
      "aria-valuemax": a,
      "aria-valuenow": Number.isNaN(K.valueAsNumber) ? void 0 : K.valueAsNumber,
      "aria-invalid": di(f ?? K.isOutOfRange),
      "aria-valuetext": zn,
      autoComplete: "off",
      autoCorrect: "off",
      onChange: lt(Le.onChange, wt),
      onKeyDown: lt(Le.onKeyDown, Ft),
      onFocus: lt(
        Le.onFocus,
        an,
        () => X(!0)
      ),
      onBlur: lt(Le.onBlur, le, sn)
    }),
    [
      _,
      m,
      h,
      R,
      I,
      Fe,
      x,
      b,
      c,
      d,
      l,
      f,
      K.value,
      K.valueAsNumber,
      K.isOutOfRange,
      o,
      a,
      zn,
      wt,
      Ft,
      an,
      le,
      sn
    ]
  );
  return {
    value: Fe(K.value),
    valueAsNumber: K.valueAsNumber,
    isFocused: ge,
    isDisabled: c,
    isReadOnly: l,
    getIncrementButtonProps: vr,
    getDecrementButtonProps: qo,
    getInputProps: lr,
    htmlProps: ae
  };
}
const [bee, uh] = bn({
  name: "NumberInputStylesContext",
  errorMessage: `useNumberInputStyles returned is 'undefined'. Seems you forgot to wrap the components in "<NumberInput />" `
}), [yee, L4] = bn({
  name: "NumberInputContext",
  errorMessage: "useNumberInputContext: `context` is undefined. Seems you forgot to wrap number-input's components within <NumberInput />"
}), bx = Ze(
  function(t, n) {
    const r = Ir("NumberInput", t), o = Wn(t), a = Yg(o), { htmlProps: s, ...l } = Cee(a), c = Et(() => l, [l]);
    return /* @__PURE__ */ A.jsx(yee, { value: c, children: /* @__PURE__ */ A.jsx(bee, { value: r, children: /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ...s,
        ref: n,
        className: Ye("chakra-numberinput", t.className),
        __css: {
          position: "relative",
          zIndex: 0,
          ...r.root
        }
      }
    ) }) });
  }
);
bx.displayName = "NumberInput";
const yx = Ze(
  function(t, n) {
    const r = uh();
    return /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        "aria-hidden": !0,
        ref: n,
        ...t,
        __css: {
          display: "flex",
          flexDirection: "column",
          position: "absolute",
          top: "0",
          insetEnd: "0px",
          margin: "1px",
          height: "calc(100% - 2px)",
          zIndex: 1,
          ...r.stepperGroup
        }
      }
    );
  }
);
yx.displayName = "NumberInputStepper";
const Sx = Ze(
  function(t, n) {
    const { getInputProps: r } = L4(), o = r(t, n), a = uh();
    return /* @__PURE__ */ A.jsx(
      Ne.input,
      {
        ...o,
        className: Ye("chakra-numberinput__field", t.className),
        __css: {
          width: "100%",
          ...a.field
        }
      }
    );
  }
);
Sx.displayName = "NumberInputField";
const Ax = Ne("div", {
  baseStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    transitionProperty: "common",
    transitionDuration: "normal",
    userSelect: "none",
    cursor: "pointer",
    lineHeight: "normal"
  }
}), Mx = Ze(function(t, n) {
  const r = uh(), { getDecrementButtonProps: o } = L4(), a = o(t, n);
  return /* @__PURE__ */ A.jsx(Ax, { ...a, __css: r.stepper, children: t.children ?? /* @__PURE__ */ A.jsx(dee, {}) });
});
Mx.displayName = "NumberDecrementStepper";
const xx = Ze(function(t, n) {
  const { getIncrementButtonProps: r } = L4(), o = r(t, n), a = uh();
  return /* @__PURE__ */ A.jsx(Ax, { ...o, __css: a.stepper, children: t.children ?? /* @__PURE__ */ A.jsx(fee, {}) });
});
xx.displayName = "NumberIncrementStepper";
function See(e) {
  var n;
  const t = De.version;
  return typeof t != "string" || t.startsWith("18.") ? e == null ? void 0 : e.ref : (n = e == null ? void 0 : e.props) == null ? void 0 : n.ref;
}
function Aee(e) {
  return e && ar(e) && ar(e.target);
}
function _x(e = {}) {
  const {
    onChange: t,
    value: n,
    defaultValue: r,
    name: o,
    isDisabled: a,
    isFocusable: s,
    isNative: l,
    ...c
  } = e, [d, f] = je(r || ""), h = typeof n < "u", m = h ? n : d, g = He(null), b = te(() => {
    const E = g.current;
    if (!E)
      return;
    let k = "input:not(:disabled):checked";
    const N = E.querySelector(
      k
    );
    if (N) {
      N.focus();
      return;
    }
    k = "input:not(:disabled)";
    const P = E.querySelector(k);
    P == null || P.focus();
  }, []), y = `radio-${Xo()}`, _ = o || y, x = te(
    (E) => {
      const k = Aee(E) ? E.target.value : E;
      h || f(k), t == null || t(String(k));
    },
    [t, h]
  ), I = te(
    (E = {}, k = null) => ({
      ...E,
      ref: ir(k, g),
      role: "radiogroup"
    }),
    []
  ), R = te(
    (E = {}, k = null) => ({
      ...E,
      ref: k,
      name: _,
      [l ? "checked" : "isChecked"]: m != null ? E.value === m : void 0,
      onChange(P) {
        x(P);
      },
      "data-radiogroup": !0
    }),
    [l, _, x, m]
  );
  return {
    getRootProps: I,
    getRadioProps: R,
    name: _,
    ref: g,
    focus: b,
    setValue: f,
    value: m,
    onChange: x,
    isDisabled: a,
    isFocusable: s,
    htmlProps: c
  };
}
const [Mee, Ix] = bn({
  name: "RadioGroupContext",
  strict: !1
}), wx = Ze((e, t) => {
  const {
    colorScheme: n,
    size: r,
    variant: o,
    children: a,
    className: s,
    isDisabled: l,
    isFocusable: c,
    ...d
  } = e, { value: f, onChange: h, getRootProps: m, name: g, htmlProps: b } = _x(d), C = Et(
    () => ({
      name: g,
      size: r,
      onChange: h,
      colorScheme: n,
      value: f,
      variant: o,
      isDisabled: l,
      isFocusable: c
    }),
    [
      g,
      r,
      h,
      n,
      f,
      o,
      l,
      c
    ]
  );
  return /* @__PURE__ */ A.jsx(Mee, { value: C, children: /* @__PURE__ */ A.jsx(
    Ne.div,
    {
      ...m(b, t),
      className: Ye("chakra-radio-group", s),
      children: a
    }
  ) });
});
wx.displayName = "RadioGroup";
function Lx(e = {}) {
  const {
    defaultChecked: t,
    isChecked: n,
    isFocusable: r,
    isDisabled: o,
    isReadOnly: a,
    isRequired: s,
    onChange: l,
    isInvalid: c,
    name: d,
    value: f,
    id: h,
    "data-radiogroup": m,
    "aria-describedby": g,
    ...b
  } = e, C = `radio-${Xo()}`, y = Il(), x = !!Ix() || !!m;
  let R = !!y && !x ? y.id : C;
  R = h ?? R;
  const E = o ?? (y == null ? void 0 : y.isDisabled), k = a ?? (y == null ? void 0 : y.isReadOnly), N = s ?? (y == null ? void 0 : y.isRequired), P = c ?? (y == null ? void 0 : y.isInvalid), [F, G] = je(!1), [j, ae] = je(!1), [ue, le] = je(!1), [_e, ve] = je(!!t), z = typeof n < "u", K = z ? n : _e, Ce = He(!1);
  ft(() => GA((Se) => {
    Ce.current = Se;
  }), []);
  const q = te(
    (Se) => {
      if (k || E) {
        Se.preventDefault();
        return;
      }
      z || ve(Se.currentTarget.checked), l == null || l(Se);
    },
    [z, E, k, l]
  ), J = te(
    (Se) => {
      Se.key === " " && le(!0);
    },
    [le]
  ), ge = te(
    (Se) => {
      Se.key === " " && le(!1);
    },
    [le]
  ), X = te(
    (Se = {}, Fe = null) => ({
      ...Se,
      ref: Fe,
      "data-active": ot(ue),
      "data-hover": ot(j),
      "data-disabled": ot(E),
      "data-invalid": ot(P),
      "data-checked": ot(K),
      "data-focus": ot(F),
      "data-focus-visible": ot(F && Ce.current),
      "data-readonly": ot(k),
      "aria-hidden": !0,
      onMouseDown: lt(Se.onMouseDown, () => le(!0)),
      onMouseUp: lt(Se.onMouseUp, () => le(!1)),
      onMouseEnter: lt(
        Se.onMouseEnter,
        () => ae(!0)
      ),
      onMouseLeave: lt(
        Se.onMouseLeave,
        () => ae(!1)
      )
    }),
    [
      ue,
      j,
      E,
      P,
      K,
      F,
      k
    ]
  ), { onFocus: pe, onBlur: fe } = y ?? {}, de = te(
    (Se = {}, Fe = null) => {
      const oe = E && !r;
      return {
        ...Se,
        id: R,
        ref: Fe,
        type: "radio",
        name: d,
        value: f,
        onChange: lt(Se.onChange, q),
        onBlur: lt(
          fe,
          Se.onBlur,
          () => G(!1)
        ),
        onFocus: lt(
          pe,
          Se.onFocus,
          () => G(!0)
        ),
        onKeyDown: lt(Se.onKeyDown, J),
        onKeyUp: lt(Se.onKeyUp, ge),
        checked: K,
        disabled: oe,
        readOnly: k,
        required: N,
        "aria-invalid": di(P),
        "aria-disabled": di(oe),
        "aria-required": di(N),
        "data-readonly": ot(k),
        "aria-describedby": g,
        style: WA
      };
    },
    [
      E,
      r,
      R,
      d,
      f,
      q,
      fe,
      pe,
      J,
      ge,
      K,
      k,
      N,
      P,
      g
    ]
  );
  return {
    state: {
      isInvalid: P,
      isFocused: F,
      isChecked: K,
      isActive: ue,
      isHovered: j,
      isDisabled: E,
      isReadOnly: k,
      isRequired: N
    },
    getRadioProps: X,
    getInputProps: de,
    getLabelProps: (Se = {}, Fe = null) => ({
      ...Se,
      ref: Fe,
      onMouseDown: lt(Se.onMouseDown, xee),
      "data-disabled": ot(E),
      "data-checked": ot(K),
      "data-invalid": ot(P)
    }),
    getRootProps: (Se, Fe = null) => ({
      htmlFor: R,
      ...Se,
      ref: Fe,
      "data-disabled": ot(E),
      "data-checked": ot(K),
      "data-invalid": ot(P)
    }),
    htmlProps: b
  };
}
function xee(e) {
  e.preventDefault(), e.stopPropagation();
}
const Rx = Ze((e, t) => {
  const n = Ix(), { onChange: r, value: o } = e, a = Ir("Radio", { ...n, ...e }), s = Wn(e), {
    spacing: l = "0.5rem",
    children: c,
    isDisabled: d = n == null ? void 0 : n.isDisabled,
    isFocusable: f = n == null ? void 0 : n.isFocusable,
    inputProps: h,
    ...m
  } = s;
  let g = e.isChecked;
  (n == null ? void 0 : n.value) != null && o != null && (g = n.value === o);
  let b = r;
  n != null && n.onChange && o != null && (b = ig(n.onChange, r));
  const C = (e == null ? void 0 : e.name) ?? (n == null ? void 0 : n.name), {
    getInputProps: y,
    getRadioProps: _,
    getLabelProps: x,
    getRootProps: I,
    htmlProps: R
  } = Lx({
    ...m,
    isChecked: g,
    isFocusable: f,
    isDisabled: d,
    onChange: b,
    name: C
  }), [E, k] = yy(R, Ry), N = _(k), P = y(h, t), F = x(), G = Object.assign({}, E, I()), j = {
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "top",
    cursor: "pointer",
    position: "relative",
    ...a.container
  }, ae = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    ...a.control
  }, ue = {
    userSelect: "none",
    marginStart: l,
    ...a.label
  };
  return /* @__PURE__ */ A.jsxs(Ne.label, { className: "chakra-radio", ...G, __css: j, children: [
    /* @__PURE__ */ A.jsx("input", { className: "chakra-radio__input", ...P }),
    /* @__PURE__ */ A.jsx(
      Ne.span,
      {
        className: "chakra-radio__control",
        ...N,
        __css: ae
      }
    ),
    c && /* @__PURE__ */ A.jsx(
      Ne.span,
      {
        className: "chakra-radio__label",
        ...F,
        __css: ue,
        children: c
      }
    )
  ] });
});
Rx.displayName = "Radio";
const Ex = Ze(
  function(t, n) {
    const { children: r, placeholder: o, className: a, ...s } = t;
    return /* @__PURE__ */ A.jsxs(
      Ne.select,
      {
        ...s,
        ref: n,
        className: Ye("chakra-select", a),
        children: [
          o && /* @__PURE__ */ A.jsx("option", { value: "", children: o }),
          r
        ]
      }
    );
  }
);
Ex.displayName = "SelectField";
const Dx = Ze((e, t) => {
  var I;
  const n = Ir("Select", e), {
    rootProps: r,
    placeholder: o,
    icon: a,
    color: s,
    height: l,
    h: c,
    minH: d,
    minHeight: f,
    iconColor: h,
    iconSize: m,
    ...g
  } = Wn(e), [b, C] = yy(g, Ry), y = Xg(C), _ = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color: s
  }, x = {
    paddingEnd: "2rem",
    ...n.field,
    _focus: {
      zIndex: "unset",
      ...(I = n.field) == null ? void 0 : I._focus
    }
  };
  return /* @__PURE__ */ A.jsxs(
    Ne.div,
    {
      className: "chakra-select__wrapper",
      __css: _,
      ...b,
      ...r,
      children: [
        /* @__PURE__ */ A.jsx(
          Ex,
          {
            ref: t,
            height: c ?? l,
            minH: d ?? f,
            placeholder: o,
            ...y,
            __css: x,
            children: e.children
          }
        ),
        /* @__PURE__ */ A.jsx(
          Nx,
          {
            "data-disabled": ot(y.disabled),
            ...(h || s) && { color: h || s },
            __css: n.icon,
            ...m && { fontSize: m },
            children: a
          }
        )
      ]
    }
  );
});
Dx.displayName = "Select";
const _ee = (e) => /* @__PURE__ */ A.jsx("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ A.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  }
) }), Iee = Ne("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
}), Nx = (e) => {
  const { children: t = /* @__PURE__ */ A.jsx(_ee, {}), ...n } = e, r = Fa(t, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: !1,
    "aria-hidden": !0,
    // force icon to adhere to `IconWrapper` styles
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */ A.jsx(Iee, { ...n, className: "chakra-select__icon-wrapper", children: tc(t) ? r : null });
};
Nx.displayName = "SelectIcon";
const Tx = (e) => /* @__PURE__ */ A.jsx(
  Ne.div,
  {
    className: "chakra-stack__item",
    ...e,
    __css: {
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0,
      ...e.__css
    }
  }
);
Tx.displayName = "StackItem";
function wee(e) {
  const { spacing: t, direction: n } = e, r = {
    column: {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": $k(
      n,
      (o) => r[o]
    )
  };
}
const Px = Ze((e, t) => {
  const {
    isInline: n,
    direction: r,
    align: o,
    justify: a,
    spacing: s = "0.5rem",
    wrap: l,
    children: c,
    divider: d,
    className: f,
    shouldWrapChildren: h,
    ...m
  } = e, g = n ? "row" : r ?? "column", b = Et(
    () => wee({ spacing: s, direction: g }),
    [s, g]
  ), C = !!d, y = !h && !C, _ = Et(() => {
    const I = hy(c);
    return y ? I : I.map((R, E) => {
      const k = typeof R.key < "u" ? R.key : E, N = E + 1 === I.length, F = h ? /* @__PURE__ */ A.jsx(Tx, { children: R }, k) : R;
      if (!C)
        return F;
      const G = Fa(
        d,
        {
          __css: b
        }
      ), j = N ? null : G;
      return /* @__PURE__ */ A.jsxs(F1, { children: [
        F,
        j
      ] }, k);
    });
  }, [
    d,
    b,
    C,
    y,
    h,
    c
  ]), x = Ye("chakra-stack", f);
  return /* @__PURE__ */ A.jsx(
    Ne.div,
    {
      ref: t,
      display: "flex",
      alignItems: o,
      justifyContent: a,
      flexDirection: g,
      flexWrap: l,
      gap: C ? void 0 : s,
      className: x,
      ...m,
      children: _
    }
  );
});
Px.displayName = "Stack";
const v3 = Ze((e, t) => /* @__PURE__ */ A.jsx(Px, { align: "center", ...e, direction: "row", ref: t }));
v3.displayName = "HStack";
const kx = Ze(
  function(t, n) {
    const r = Ir("Switch", t), {
      spacing: o = "0.5rem",
      children: a,
      ...s
    } = Wn(t), {
      getIndicatorProps: l,
      getInputProps: c,
      getCheckboxProps: d,
      getRootProps: f,
      getLabelProps: h
    } = zA(s), m = Et(
      () => ({
        display: "inline-block",
        position: "relative",
        verticalAlign: "middle",
        lineHeight: 0,
        ...r.container
      }),
      [r.container]
    ), g = Et(
      () => ({
        display: "inline-flex",
        flexShrink: 0,
        justifyContent: "flex-start",
        boxSizing: "content-box",
        cursor: "pointer",
        ...r.track
      }),
      [r.track]
    ), b = Et(
      () => ({
        userSelect: "none",
        marginStart: o,
        ...r.label
      }),
      [o, r.label]
    );
    return /* @__PURE__ */ A.jsxs(
      Ne.label,
      {
        ...f(),
        className: Ye("chakra-switch", t.className),
        __css: m,
        children: [
          /* @__PURE__ */ A.jsx("input", { className: "chakra-switch__input", ...c({}, n) }),
          /* @__PURE__ */ A.jsx(
            Ne.span,
            {
              ...d(),
              className: "chakra-switch__track",
              __css: g,
              children: /* @__PURE__ */ A.jsx(
                Ne.span,
                {
                  __css: r.thumb,
                  className: "chakra-switch__thumb",
                  ...l()
                }
              )
            }
          ),
          a && /* @__PURE__ */ A.jsx(
            Ne.span,
            {
              className: "chakra-switch__label",
              ...h(),
              __css: b,
              children: a
            }
          )
        ]
      }
    );
  }
);
kx.displayName = "Switch";
const [Lee, hd] = bn({
  name: "TableStylesContext",
  errorMessage: `useTableStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Table />" `
}), Vx = Ze((e, t) => {
  const n = Ir("Table", e), { className: r, layout: o, ...a } = Wn(e);
  return /* @__PURE__ */ A.jsx(Lee, { value: n, children: /* @__PURE__ */ A.jsx(
    Ne.table,
    {
      ref: t,
      __css: { tableLayout: o, ...n.table },
      className: Ye("chakra-table", r),
      ...a
    }
  ) });
});
Vx.displayName = "Table";
const Ree = Ze((e, t) => {
  const n = hd();
  return /* @__PURE__ */ A.jsx(Ne.tbody, { ...e, ref: t, __css: n.tbody });
}), Eee = Ze(
  ({ isNumeric: e, ...t }, n) => {
    const r = hd();
    return /* @__PURE__ */ A.jsx(
      Ne.td,
      {
        ...t,
        ref: n,
        __css: r.td,
        "data-is-numeric": e
      }
    );
  }
), Dee = Ze(
  ({ isNumeric: e, ...t }, n) => {
    const r = hd();
    return /* @__PURE__ */ A.jsx(
      Ne.th,
      {
        ...t,
        ref: n,
        __css: r.th,
        "data-is-numeric": e
      }
    );
  }
), Nee = Ze((e, t) => {
  const n = hd();
  return /* @__PURE__ */ A.jsx(Ne.thead, { ...e, ref: t, __css: n.thead });
}), Kv = Ze((e, t) => {
  const n = hd();
  return /* @__PURE__ */ A.jsx(Ne.tr, { ...e, ref: t, __css: n.tr });
}), Tee = ["h", "minH", "height", "minHeight"], Ox = Ze((e, t) => {
  const n = _l("Textarea", e), { className: r, rows: o, ...a } = Wn(e), s = Xg(a), l = o ? zf(n, Tee) : n;
  return /* @__PURE__ */ A.jsx(
    Ne.textarea,
    {
      ref: t,
      rows: o,
      ...s,
      className: Ye("chakra-textarea", r),
      __css: l
    }
  );
});
Ox.displayName = "Textarea";
const Pee = {
  exit: {
    scale: 0.85,
    opacity: 0,
    transition: {
      opacity: { duration: 0.15, easings: "easeInOut" },
      scale: { duration: 0.2, easings: "easeInOut" }
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      opacity: { easings: "easeOut", duration: 0.2 },
      scale: { duration: 0.2, ease: [0.175, 0.885, 0.4, 1.1] }
    }
  }
}, C3 = (e) => {
  var t;
  return ((t = e.current) == null ? void 0 : t.ownerDocument) || document;
}, E2 = (e) => {
  var t, n;
  return ((n = (t = e.current) == null ? void 0 : t.ownerDocument) == null ? void 0 : n.defaultView) || window;
};
function kee(e = {}) {
  const {
    openDelay: t = 0,
    closeDelay: n = 0,
    closeOnClick: r = !0,
    closeOnMouseDown: o,
    closeOnScroll: a,
    closeOnPointerDown: s = o,
    closeOnEsc: l = !0,
    onOpen: c,
    onClose: d,
    placement: f,
    id: h,
    isOpen: m,
    defaultIsOpen: g,
    arrowSize: b = 10,
    arrowShadowColor: C,
    arrowPadding: y,
    modifiers: _,
    isDisabled: x,
    gutter: I,
    offset: R,
    direction: E,
    ...k
  } = e, { isOpen: N, onOpen: P, onClose: F } = My({
    isOpen: m,
    defaultIsOpen: g,
    onOpen: c,
    onClose: d
  }), { referenceRef: G, getPopperProps: j, getArrowInnerProps: ae, getArrowProps: ue } = YM({
    enabled: N,
    placement: f,
    arrowPadding: y,
    modifiers: _,
    gutter: I,
    offset: R,
    direction: E
  }), le = Xo(), ve = `tooltip-${h ?? le}`, z = He(null), K = He(void 0), Ce = te(() => {
    K.current && (clearTimeout(K.current), K.current = void 0);
  }, []), q = He(void 0), J = te(() => {
    q.current && (clearTimeout(q.current), q.current = void 0);
  }, []), ge = te(() => {
    J(), F();
  }, [F, J]), X = Vee(z, ge), pe = te(() => {
    if (!x && !K.current) {
      N && X();
      const oe = E2(z);
      K.current = oe.setTimeout(P, t);
    }
  }, [X, x, N, P, t]), fe = te(() => {
    Ce();
    const oe = E2(z);
    q.current = oe.setTimeout(ge, n);
  }, [n, ge, Ce]), de = te(() => {
    N && r && fe();
  }, [r, fe, N]), we = te(() => {
    N && s && fe();
  }, [s, fe, N]), Ie = te(
    (oe) => {
      N && oe.key === "Escape" && fe();
    },
    [N, fe]
  );
  v1(
    () => C3(z),
    "keydown",
    l ? Ie : void 0
  ), v1(
    () => {
      if (!a)
        return null;
      const oe = z.current;
      if (!oe)
        return null;
      const pt = by(oe);
      return pt.localName === "body" ? E2(z) : pt;
    },
    "scroll",
    () => {
      N && a && ge();
    },
    { passive: !0, capture: !0 }
  ), ft(() => {
    x && (Ce(), N && F());
  }, [x, N, F, Ce]), ft(() => () => {
    Ce(), J();
  }, [Ce, J]), v1(() => z.current, "pointerleave", fe);
  const Pe = te(
    (oe = {}, pt = null) => ({
      ...oe,
      ref: ir(z, pt, G),
      onPointerEnter: lt(oe.onPointerEnter, (wt) => {
        wt.pointerType !== "touch" && pe();
      }),
      onClick: lt(oe.onClick, de),
      onPointerDown: lt(oe.onPointerDown, we),
      onFocus: lt(oe.onFocus, pe),
      onBlur: lt(oe.onBlur, fe),
      "aria-describedby": N ? ve : void 0
    }),
    [
      pe,
      fe,
      we,
      N,
      ve,
      de,
      G
    ]
  ), Se = te(
    (oe = {}, pt = null) => j(
      {
        ...oe,
        style: {
          ...oe.style,
          [pr.arrowSize.var]: b ? `${b}px` : void 0,
          [pr.arrowShadowColor.var]: C
        }
      },
      pt
    ),
    [j, b, C]
  ), Fe = te(
    (oe = {}, pt = null) => {
      const Ee = {
        ...oe.style,
        position: "relative",
        transformOrigin: pr.transformOrigin.varRef
      };
      return {
        ref: pt,
        ...k,
        ...oe,
        id: ve,
        role: "tooltip",
        style: Ee
      };
    },
    [k, ve]
  );
  return {
    isOpen: N,
    show: pe,
    hide: fe,
    getTriggerProps: Pe,
    getTooltipProps: Fe,
    getTooltipPositionerProps: Se,
    getArrowProps: ue,
    getArrowInnerProps: ae
  };
}
const t5 = "chakra-ui:close-tooltip";
function Vee(e, t) {
  return ft(() => {
    const n = C3(e);
    return n.addEventListener(t5, t), () => n.removeEventListener(t5, t);
  }, [t, e]), () => {
    const n = C3(e), r = E2(e);
    n.dispatchEvent(new r.CustomEvent(t5));
  };
}
const Oee = Ne($a.div), R4 = Ze((e, t) => {
  const n = _l("Tooltip", e), r = Wn(e), o = rh(), {
    children: a,
    label: s,
    shouldWrapChildren: l,
    "aria-label": c,
    hasArrow: d,
    bg: f,
    portalProps: h,
    background: m,
    backgroundColor: g,
    bgColor: b,
    motionProps: C,
    animatePresenceProps: y,
    ..._
  } = r, x = m ?? g ?? f ?? b;
  if (x) {
    n.bg = x;
    const G = zV(o, "colors", x);
    n[pr.arrowBg.var] = G;
  }
  const I = kee({ ..._, direction: o.direction }), R = !tc(a) || l;
  let E;
  if (R)
    E = /* @__PURE__ */ A.jsx(
      Ne.span,
      {
        display: "inline-block",
        tabIndex: 0,
        ...I.getTriggerProps(),
        children: a
      }
    );
  else {
    const G = $f.only(a);
    E = Fa(
      G,
      I.getTriggerProps(G.props, See(G))
    );
  }
  const k = !!c, N = I.getTooltipProps({}, t), P = k ? zf(N, ["role", "id"]) : N, F = Cy(N, ["role", "id"]);
  return s ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    E,
    /* @__PURE__ */ A.jsx(Ss, { ...y, children: I.isOpen && /* @__PURE__ */ A.jsx(rc, { ...h, children: /* @__PURE__ */ A.jsx(
      Ne.div,
      {
        ...I.getTooltipPositionerProps(),
        __css: {
          zIndex: n.zIndex,
          pointerEvents: "none"
        },
        children: /* @__PURE__ */ A.jsxs(
          Oee,
          {
            variants: Pee,
            initial: "exit",
            animate: "enter",
            exit: "exit",
            ...C,
            ...P,
            __css: n,
            children: [
              s,
              k && /* @__PURE__ */ A.jsx(Ne.span, { srOnly: !0, ...F, children: c }),
              d && /* @__PURE__ */ A.jsx(
                Ne.div,
                {
                  "data-popper-arrow": !0,
                  className: "chakra-tooltip__arrow-wrapper",
                  children: /* @__PURE__ */ A.jsx(
                    Ne.div,
                    {
                      "data-popper-arrow-inner": !0,
                      className: "chakra-tooltip__arrow",
                      __css: { bg: n.bg }
                    }
                  )
                }
              )
            ]
          }
        )
      }
    ) }) })
  ] }) : /* @__PURE__ */ A.jsx(A.Fragment, { children: a });
});
R4.displayName = "Tooltip";
const Fee = "#E8F4FE", Bee = "#F8FBFE", Hee = "#40A7FF", Qv = "#E4E8EC", Gee = "#728291", $ee = "#394D60", Zee = $ee, jee = "#F23636", Wee = Fee, zee = Bee, Uee = {
  primary: Hee,
  primaryBackground: Wee,
  secondaryBackground: zee,
  disabled: Qv,
  textSecondary: Zee,
  inputLabelText: Gee,
  border: Qv,
  danger: jee
}, Re = {
  white: "#FFFFFF",
  black: "#000000",
  gray: "#9CA6AF",
  "gray.50": "#FAFAFA",
  "gray.100": "#F7F7F7",
  "gray.200": "#E7E7E7",
  "gray.300": "#CDD3D7",
  "gray.350": "#394D6015",
  "gray.400": "#E1E4E7",
  "gray.600": "#728291",
  "gray.650": "#657888",
  "gray.675": "#465C72",
  "gray.700": "#394D60",
  "gray.800": "#45525F",
  "gray.900": "#072138",
  "red.200": "#F4CCCD",
  "red.400": "#FA3C48",
  "red.700": "#CE161B",
  "orange.100": "#FBE7C3",
  "orange.500": "#EE9611",
  "orange.600": "#D55E00",
  "yellow.200": "#FFF6C7",
  "yellow.400": "#FFD600",
  lightYellow: "#FFFFE0",
  // maps to `lightyellow` named color
  "green.200": "#E0F4F0",
  "green.300": "#C7EBE3",
  "green.500": "#00A67F",
  "green.600": "#019E73",
  "green.700": "#087742",
  navy: "#3455DB",
  "navy.50": "#F4F7FF",
  "navy.100": "#EDF0FF",
  "navy.200": "#DAE1FE",
  "navy.250": "#D2E4F4",
  "navy.300": "#3455DB20",
  "navy.400": "#9CAFFF",
  "navy.450": "#5C76E2",
  "navy.600": "#2240B9",
  "navy.700": "#0072B2",
  "navy.800": "#00008B",
  "navy.900": "#1F364E",
  "pink.500": "#CC79A7",
  "purple.500": "#9552ee",
  "lavender.100": "#E6D7FC",
  "lavender.500": "#9552EE",
  "tiers.1": "#008B8B",
  "tiers.2": "#2A9570",
  "tiers.3": "#619B4E",
  "tiers.4": "#999933",
  "tiers.5": "#a17f2b",
  "tiers.6": "#b36d20",
  "tiers.7": "#d45a1d",
  "tiers.8": "#f04619",
  "tiers.9": "#f02c00",
  "tiers.10": "#FF0000"
}, Xee = {
  // Buttons
  buttonDefault: Re.navy,
  buttonHover: Re["navy.600"],
  buttonActive: Re["navy.800"],
  // Non-button interactive items
  selected1: Re["navy.100"],
  selected2: Re.navy,
  selected3: Re["navy.900"],
  selected4: Re["navy.200"],
  selected5: Re["lavender.100"],
  hover1: Re["navy.50"],
  hover2: Re["navy.400"],
  hoverTransparent: Re["navy.300"],
  hoverTransparentLight: Re["gray.350"],
  disabledFill: Re["gray.100"],
  // Strokes
  strokeDefault: Re["gray.300"],
  strokeLight: Re["gray.200"],
  strokeHover: Re.gray,
  strokeActive: Re["gray.600"],
  strokeInteractive: Re["gray.800"],
  // Surfaces
  surface1: Re.white,
  surface2: Re["gray.100"],
  surface3: Re["navy.50"],
  surface4: Re["gray.200"],
  surface5: Re["gray.700"],
  surface6: Re["gray.50"],
  surface7: Re["gray.400"],
  surface8: Re["green.200"],
  // Surface Accents
  surfaceAccent1: Re["navy.600"],
  surfaceAccent2: Re["navy.900"],
  surfaceAccent3: Re["navy.800"],
  surfaceAccent4: Re.navy,
  surfaceAccent5: Re["navy.400"],
  surfaceAccent6: Re["navy.450"],
  surfaceAccent7: Re["gray.700"],
  surfaceAccent8: Re["green.200"],
  surfaceAccent9: Re.black,
  surfaceAccent10: Re["lavender.500"],
  surfaceRequiredField: Re["yellow.200"],
  surfaceReadonly: Re["gray.400"],
  alertSuccess: Re["green.600"],
  alertError: Re["red.700"],
  alertWarning: Re["yellow.400"],
  alertSuccessLight: Re["green.300"],
  alertErrorLight: Re["red.200"],
  alertWarningLight: Re["orange.100"],
  alertInfoLight: Re["navy.250"],
  // Text
  textPrimary: Re["gray.900"],
  textSecondary: Re["gray.700"],
  textTertiary: Re["gray.650"],
  textOffset: Re.white,
  textDisabled: Re.gray,
  textError: Re["red.700"],
  textSuccess: Re["green.700"],
  textWarning: Re["orange.600"],
  textLight: Re["gray.675"],
  // Status
  statusOverdue: Re["red.400"],
  statusInProgress: Re["yellow.400"],
  statusComplete: Re["green.600"],
  statusWarning: Re["orange.500"],
  // Pins
  pinSold: Re["navy.700"],
  pinPending: Re["pink.500"],
  pinActive: Re["green.600"],
  pinRented: Re["orange.600"],
  pinOffMarket: Re["gray.650"],
  pinOther: Re["gray.900"],
  pinSubject: Re["orange.500"],
  // Graphs
  graphBackground: Re.white,
  graphAreaBackground: "#5C76E250",
  graphAreaBackgroundOpaque: "#5C76E2",
  graphChart: "#0072B2",
  graphChart2: "#B83280",
  graphChart3: "#CC79A7",
  graphChart4: "#FFA500",
  graphAdverse: "#D55E00",
  graphNeutral: "#657888",
  graphBeneficial: "#019E73",
  /** @deprecated - Use textError instead */
  error: Re["red.700"],
  // TODO: Replace with textError
  /** @deprecated - Use textSuccess instead */
  success: Re["green.700"],
  // TODO: Replace with textSuccess
  // Other
  aiv: Re["yellow.400"],
  aivLight: Re["yellow.200"],
  aivText: Re["gray.900"],
  arv: Re["green.500"],
  arvLight: Re["green.200"],
  arvText: Re.white,
  transparent: "#00000000",
  /** @deprecated - Use 'transparent' instead */
  none: "#00000000",
  // @ts-expect-error hacking our way to not overriding colors
  // eslint-disable-next-line object-shorthand
  undefined: void 0,
  // Quality tiers
  qualityTier1: Re["tiers.1"],
  qualityTier2: Re["tiers.2"],
  qualityTier3: Re["tiers.3"],
  qualityTier4: Re["tiers.4"],
  qualityTier5: Re["tiers.5"],
  qualityTier6: Re["tiers.6"],
  qualityTier7: Re["tiers.7"],
  qualityTier8: Re["tiers.8"],
  qualityTier9: Re["tiers.9"],
  qualityTier10: Re["tiers.10"]
}, Fo = {
  ...Uee,
  ...Xee,
  // all these are sorta hacky ways to use existing chakra components but hijacked with aloft colors
  // too tricky to figure out all the component style configs without TS help
  aloft: {
    100: Re["navy.50"]
  },
  green: {
    500: Re["green.600"]
  },
  red: {
    500: Re["red.400"]
  },
  orange: {
    500: Re["yellow.400"]
  },
  blue: {
    500: Re.navy
  }
}, Yee = {
  background: "#FFFFFF",
  backgroundAccent: "#1F364E",
  backgroundAccentDark: "#394D60",
  backgroundAccentLight: "#3C70A7",
  strokeLight: "#EBEDEF",
  surface: "#F0F0F0",
  text: "#072138",
  textLight: "#465C72",
  textAccent: "#73A9EF",
  border: "#E0E0E0",
  borderDark: "#E1E1E1",
  positive: "#008646",
  negative: "#CE161B",
  aivBackground: "#FFD600",
  arvBackground: "#00A67F"
}, eC = {
  Accordion: {
    parts: ["container"],
    baseStyle: {
      container: {
        borderStyle: "solid",
        borderColor: "gray.200"
      }
    }
  }
}, qee = {
  ...eC,
  Accordion: {
    ...eC.Accordion,
    variants: {
      default: {
        button: {
          backgroundColor: "surface2"
        }
      }
    }
  }
};
function mr(e, t) {
  Jee(e) && (e = "100%");
  var n = Kee(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function K0(e) {
  return Math.min(1, Math.max(0, e));
}
function Jee(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function Kee(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function Fx(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Q0(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function tl(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function Qee(e, t, n) {
  return {
    r: mr(e, 255) * 255,
    g: mr(t, 255) * 255,
    b: mr(n, 255) * 255
  };
}
function tC(e, t, n) {
  e = mr(e, 255), t = mr(t, 255), n = mr(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), a = 0, s = 0, l = (r + o) / 2;
  if (r === o)
    s = 0, a = 0;
  else {
    var c = r - o;
    switch (s = l > 0.5 ? c / (2 - r - o) : c / (r + o), r) {
      case e:
        a = (t - n) / c + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / c + 2;
        break;
      case n:
        a = (e - t) / c + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s, l };
}
function n5(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function ete(e, t, n) {
  var r, o, a;
  if (e = mr(e, 360), t = mr(t, 100), n = mr(n, 100), t === 0)
    o = n, a = n, r = n;
  else {
    var s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    r = n5(l, s, e + 1 / 3), o = n5(l, s, e), a = n5(l, s, e - 1 / 3);
  }
  return { r: r * 255, g: o * 255, b: a * 255 };
}
function nC(e, t, n) {
  e = mr(e, 255), t = mr(t, 255), n = mr(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), a = 0, s = r, l = r - o, c = r === 0 ? 0 : l / r;
  if (r === o)
    a = 0;
  else {
    switch (r) {
      case e:
        a = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / l + 2;
        break;
      case n:
        a = (e - t) / l + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: c, v: s };
}
function tte(e, t, n) {
  e = mr(e, 360) * 6, t = mr(t, 100), n = mr(n, 100);
  var r = Math.floor(e), o = e - r, a = n * (1 - t), s = n * (1 - o * t), l = n * (1 - (1 - o) * t), c = r % 6, d = [n, s, a, a, l, n][c], f = [l, n, n, s, a, a][c], h = [a, a, l, n, n, s][c];
  return { r: d * 255, g: f * 255, b: h * 255 };
}
function rC(e, t, n, r) {
  var o = [
    tl(Math.round(e).toString(16)),
    tl(Math.round(t).toString(16)),
    tl(Math.round(n).toString(16))
  ];
  return r && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) : o.join("");
}
function nte(e, t, n, r, o) {
  var a = [
    tl(Math.round(e).toString(16)),
    tl(Math.round(t).toString(16)),
    tl(Math.round(n).toString(16)),
    tl(rte(r))
  ];
  return o && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) && a[3].startsWith(a[3].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
}
function rte(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function oC(e) {
  return mo(e) / 255;
}
function mo(e) {
  return parseInt(e, 16);
}
function ote(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var b3 = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function ate(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, r = null, o = null, a = null, s = !1, l = !1;
  return typeof e == "string" && (e = lte(e)), typeof e == "object" && (ti(e.r) && ti(e.g) && ti(e.b) ? (t = Qee(e.r, e.g, e.b), s = !0, l = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : ti(e.h) && ti(e.s) && ti(e.v) ? (r = Q0(e.s), o = Q0(e.v), t = tte(e.h, r, o), s = !0, l = "hsv") : ti(e.h) && ti(e.s) && ti(e.l) && (r = Q0(e.s), a = Q0(e.l), t = ete(e.h, r, a), s = !0, l = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = Fx(n), {
    ok: s,
    format: e.format || l,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var ite = "[-\\+]?\\d+%?", ste = "[-\\+]?\\d*\\.\\d+%?", rs = "(?:".concat(ste, ")|(?:").concat(ite, ")"), r5 = "[\\s|\\(]+(".concat(rs, ")[,|\\s]+(").concat(rs, ")[,|\\s]+(").concat(rs, ")\\s*\\)?"), o5 = "[\\s|\\(]+(".concat(rs, ")[,|\\s]+(").concat(rs, ")[,|\\s]+(").concat(rs, ")[,|\\s]+(").concat(rs, ")\\s*\\)?"), ia = {
  CSS_UNIT: new RegExp(rs),
  rgb: new RegExp("rgb" + r5),
  rgba: new RegExp("rgba" + o5),
  hsl: new RegExp("hsl" + r5),
  hsla: new RegExp("hsla" + o5),
  hsv: new RegExp("hsv" + r5),
  hsva: new RegExp("hsva" + o5),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function lte(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (b3[e])
    e = b3[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = ia.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = ia.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = ia.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = ia.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = ia.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = ia.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = ia.hex8.exec(e), n ? {
    r: mo(n[1]),
    g: mo(n[2]),
    b: mo(n[3]),
    a: oC(n[4]),
    format: t ? "name" : "hex8"
  } : (n = ia.hex6.exec(e), n ? {
    r: mo(n[1]),
    g: mo(n[2]),
    b: mo(n[3]),
    format: t ? "name" : "hex"
  } : (n = ia.hex4.exec(e), n ? {
    r: mo(n[1] + n[1]),
    g: mo(n[2] + n[2]),
    b: mo(n[3] + n[3]),
    a: oC(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = ia.hex3.exec(e), n ? {
    r: mo(n[1] + n[1]),
    g: mo(n[2] + n[2]),
    b: mo(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function ti(e) {
  return !!ia.CSS_UNIT.exec(String(e));
}
var ch = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = ""), n === void 0 && (n = {});
      var r;
      if (t instanceof e)
        return t;
      typeof t == "number" && (t = ote(t)), this.originalInput = t;
      var o = ate(t);
      this.originalInput = t, this.r = o.r, this.g = o.g, this.b = o.b, this.a = o.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (r = n.format) !== null && r !== void 0 ? r : o.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = o.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var t = this.toRgb();
      return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var t = this.toRgb(), n, r, o, a = t.r / 255, s = t.g / 255, l = t.b / 255;
      return a <= 0.03928 ? n = a / 12.92 : n = Math.pow((a + 0.055) / 1.055, 2.4), s <= 0.03928 ? r = s / 12.92 : r = Math.pow((s + 0.055) / 1.055, 2.4), l <= 0.03928 ? o = l / 12.92 : o = Math.pow((l + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * r + 0.0722 * o;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(t) {
      return this.a = Fx(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var t = this.toHsl().s;
      return t === 0;
    }, e.prototype.toHsv = function() {
      var t = nC(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var t = nC(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.v * 100);
      return this.a === 1 ? "hsv(".concat(n, ", ").concat(r, "%, ").concat(o, "%)") : "hsva(".concat(n, ", ").concat(r, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var t = tC(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var t = tC(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.l * 100);
      return this.a === 1 ? "hsl(".concat(n, ", ").concat(r, "%, ").concat(o, "%)") : "hsla(".concat(n, ", ").concat(r, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
      return t === void 0 && (t = !1), rC(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
      return t === void 0 && (t = !1), nte(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
      return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var t = Math.round(this.r), n = Math.round(this.g), r = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(t, ", ").concat(n, ", ").concat(r, ")") : "rgba(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var t = function(n) {
        return "".concat(Math.round(mr(n, 255) * 100), "%");
      };
      return {
        r: t(this.r),
        g: t(this.g),
        b: t(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var t = function(n) {
        return Math.round(mr(n, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var t = "#" + rC(this.r, this.g, this.b, !1), n = 0, r = Object.entries(b3); n < r.length; n++) {
        var o = r[n], a = o[0], s = o[1];
        if (t === s)
          return a;
      }
      return !1;
    }, e.prototype.toString = function(t) {
      var n = !!t;
      t = t ?? this.format;
      var r = !1, o = this.a < 1 && this.a >= 0, a = !n && o && (t.startsWith("hex") || t === "name");
      return a ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l += t / 100, n.l = K0(n.l), new e(n);
    }, e.prototype.brighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toRgb();
      return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new e(n);
    }, e.prototype.darken = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l -= t / 100, n.l = K0(n.l), new e(n);
    }, e.prototype.tint = function(t) {
      return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
      return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s -= t / 100, n.s = K0(n.s), new e(n);
    }, e.prototype.saturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s += t / 100, n.s = K0(n.s), new e(n);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(t) {
      var n = this.toHsl(), r = (n.h + t) % 360;
      return n.h = r < 0 ? 360 + r : r, new e(n);
    }, e.prototype.mix = function(t, n) {
      n === void 0 && (n = 50);
      var r = this.toRgb(), o = new e(t).toRgb(), a = n / 100, s = {
        r: (o.r - r.r) * a + r.r,
        g: (o.g - r.g) * a + r.g,
        b: (o.b - r.b) * a + r.b,
        a: (o.a - r.a) * a + r.a
      };
      return new e(s);
    }, e.prototype.analogous = function(t, n) {
      t === void 0 && (t = 6), n === void 0 && (n = 30);
      var r = this.toHsl(), o = 360 / n, a = [this];
      for (r.h = (r.h - (o * t >> 1) + 720) % 360; --t; )
        r.h = (r.h + o) % 360, a.push(new e(r));
      return a;
    }, e.prototype.complement = function() {
      var t = this.toHsl();
      return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
      t === void 0 && (t = 6);
      for (var n = this.toHsv(), r = n.h, o = n.s, a = n.v, s = [], l = 1 / t; t--; )
        s.push(new e({ h: r, s: o, v: a })), a = (a + l) % 1;
      return s;
    }, e.prototype.splitcomplement = function() {
      var t = this.toHsl(), n = t.h;
      return [
        this,
        new e({ h: (n + 72) % 360, s: t.s, l: t.l }),
        new e({ h: (n + 216) % 360, s: t.s, l: t.l })
      ];
    }, e.prototype.onBackground = function(t) {
      var n = this.toRgb(), r = new e(t).toRgb(), o = n.a + r.a * (1 - n.a);
      return new e({
        r: (n.r * n.a + r.r * r.a * (1 - n.a)) / o,
        g: (n.g * n.a + r.g * r.a * (1 - n.a)) / o,
        b: (n.b * n.a + r.b * r.a * (1 - n.a)) / o,
        a: o
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(t) {
      for (var n = this.toHsl(), r = n.h, o = [this], a = 360 / t, s = 1; s < t; s++)
        o.push(new e({ h: (r + s * a) % 360, s: n.s, l: n.l }));
      return o;
    }, e.prototype.equals = function(t) {
      return this.toRgbString() === new e(t).toRgbString();
    }, e;
  }()
);
function ute(e) {
  return Array.isArray(e);
}
function cte(e) {
  var t = typeof e;
  return e != null && (t === "object" || t === "function") && !ute(e);
}
process.env.NODE_ENV;
process.env.NODE_ENV;
function dte(e, t, n, r) {
  var o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
var fte = function(t) {
  var n = /* @__PURE__ */ new WeakMap(), r = function(a, s, l, c) {
    if (typeof a > "u")
      return t(a, s, l);
    n.has(a) || n.set(a, /* @__PURE__ */ new Map());
    var d = n.get(a);
    if (d.has(s))
      return d.get(s);
    var f = t(a, s, l, c);
    return d.set(s, f), f;
  };
  return r;
}, hte = fte(dte), E4 = function(t, n, r) {
  var o = hte(t, "colors." + n, n), a = new ch(o), s = a.isValid;
  return s ? o : r;
}, pn = function(t, n) {
  return function(r) {
    var o = E4(r, t);
    return new ch(o).setAlpha(n).toRgbString();
  };
}, sa = function(t, n) {
  return function(r) {
    var o = E4(r, t);
    return new ch(o).darken(n).toHexString();
  };
}, a5 = function(t, n) {
  return function(r) {
    return new ch(E4(r, t)).lighten(n).toHexString();
  };
};
function Bx(e) {
  return cte(e) && e.reference ? e.reference : String(e);
}
var dh = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  return r.map(Bx).join(" " + t + " ").replace(/calc/g, "");
}, aC = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return "calc(" + dh.apply(void 0, ["+"].concat(n)) + ")";
}, iC = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return "calc(" + dh.apply(void 0, ["-"].concat(n)) + ")";
}, y3 = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return "calc(" + dh.apply(void 0, ["*"].concat(n)) + ")";
}, sC = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return "calc(" + dh.apply(void 0, ["/"].concat(n)) + ")";
}, lC = function(t) {
  var n = Bx(t);
  return n != null && !Number.isNaN(parseFloat(n)) ? String(n).startsWith("-") ? String(n).slice(1) : "-" + n : y3(n, -1);
}, qc = Object.assign(function(e) {
  return {
    add: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return qc(aC.apply(void 0, [e].concat(r)));
    },
    subtract: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return qc(iC.apply(void 0, [e].concat(r)));
    },
    multiply: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return qc(y3.apply(void 0, [e].concat(r)));
    },
    divide: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return qc(sC.apply(void 0, [e].concat(r)));
    },
    negate: function() {
      return qc(lC(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: aC,
  subtract: iC,
  multiply: y3,
  divide: sC,
  negate: lC
});
const Q2 = {
  Button: {
    // nope -- use SoundUI
    // baseStyle: {
    //     borderRadius: 'sm',
    //     _focus: {
    //         boxShadow: 'none',
    //     },
    // },
    variants: {
      filled: {
        color: "white",
        backgroundColor: "primary",
        _hover: {
          backgroundColor: sa("primary", 10),
          _disabled: {
            backgroundColor: "disabled"
          }
        },
        _focus: {
          backgroundColor: sa("primary", 10)
        },
        _active: {
          backgroundColor: sa("primary", 20)
        },
        _disabled: {
          backgroundColor: "disabled",
          color: sa("disabled", 50)
        }
      },
      outline: {
        color: "primary",
        backgroundColor: "transparent",
        borderColor: "border",
        borderWidth: "1px",
        borderStyle: "solid",
        _hover: {
          backgroundColor: a5("primary", 35)
        },
        _focus: {
          backgroundColor: a5("primary", 35)
        },
        _active: {
          backgroundColor: a5("primary", 30)
        },
        _disabled: {
          color: sa("disabled", 50)
        }
      },
      danger: {
        backgroundColor: "danger",
        color: "white",
        _hover: {
          backgroundColor: sa("danger", 10),
          _disabled: {
            backgroundColor: "danger"
          }
        },
        _focus: {
          backgroundColor: sa("danger", 10)
        },
        _active: {
          backgroundColor: sa("danger", 20)
        }
      }
    },
    defaultProps: {
      variant: "filled"
    }
  }
}, uC = {
  color: "buttonDefault",
  _hover: {
    color: "buttonHover",
    textDecoration: "underline"
  },
  _focus: {
    color: "buttonHover",
    textDecoration: "underline"
  },
  _active: {
    color: "buttonActive",
    textDecoration: "underline"
  }
}, _n = {
  Text: {
    variants: {
      link: uC,
      // headings
      h1: {
        fontSize: "1.5rem",
        fontWeight: "800",
        color: "textPrimary"
      },
      h2: {
        fontSize: "1.25rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      h3: {
        fontSize: "1rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      h4: {
        fontSize: "0.875rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      h5: {
        fontSize: "0.75rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      // bodies 🪦
      body1: {
        fontSize: "0.875rem",
        fontWeight: "400",
        color: "textPrimary",
        maxWidth: "40rem"
        // roughly 100 characters; no super wide lines please
      },
      body2: {
        fontSize: "0.75rem",
        fontWeight: "400",
        color: "textPrimary",
        maxWidth: "40rem"
        // roughly 110 characters; no super wide lines please
      },
      // placeholder
      placeholder: {
        fontSize: "0.875rem",
        fontWeight: "400",
        color: "textTertiary",
        fontStyle: "italic"
      },
      // subtitles
      subtitle1: {
        fontSize: "0.75rem",
        fontWeight: "600",
        color: "textSecondary",
        textTransform: "uppercase"
      },
      subtitle2: {
        fontSize: "0.625rem",
        fontWeight: "600",
        color: "textPrimary",
        textTransform: "uppercase"
      },
      subtitle3: {
        fontSize: "0.625rem",
        fontWeight: "600",
        color: "textSecondary"
      },
      // buttons and chips
      chip: {
        fontSize: "0.75rem",
        fontWeight: "600",
        color: "textPrimary"
      },
      buttonSmall: {
        fontSize: "0.75rem",
        fontWeight: "800",
        color: "typography.white"
      },
      buttonRegular: {
        fontSize: "0.875rem",
        fontWeight: "700",
        color: "typography.white"
      },
      // tables
      tableColumnTitle: {
        fontSize: "0.875rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      tableH1: {
        fontSize: "0.75rem",
        fontWeight: "700",
        color: "textSecondary"
      },
      tableH2: {
        fontSize: "0.75rem",
        fontWeight: "500",
        color: "typography.black"
      },
      tableH3: {
        fontSize: "0.625rem",
        fontWeight: "600",
        color: "textPrimary",
        textTransform: "uppercase"
      },
      tableTag: {
        fontSize: "0.375rem",
        fontWeight: "800",
        color: "textPrimary"
      },
      // displays
      displayLarge: {
        fontSize: "3.75rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      displayMedium: {
        fontSize: "2.75rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      displaySmall: {
        fontSize: "1.75rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      label: {
        fontSize: "1rem",
        fontWeight: "700",
        color: "textPrimary"
      }
    }
  },
  Link: {
    variants: {
      default: uC,
      unstyled: {}
    }
  }
}, pte = {
  color: "textOffset",
  backgroundColor: "buttonDefault",
  _hover: {
    color: "textOffset",
    backgroundColor: "buttonHover",
    _disabled: {
      backgroundColor: pn("buttonHover", 0.5)
    }
  },
  _focus: {
    color: "textOffset",
    backgroundColor: "buttonHover"
  },
  _active: {
    color: "textOffset",
    backgroundColor: "buttonActive"
  },
  _disabled: {
    color: "textOffset",
    backgroundColor: pn("buttonDefault", 0.5)
  }
}, mte = {
  backgroundColor: "surface1",
  border: "1px solid",
  color: "buttonDefault",
  borderColor: "buttonDefault",
  _hover: {
    color: "buttonHover",
    borderColor: "buttonHover",
    backgroundColor: "surface1",
    _disabled: {
      backgroundColor: pn("surface1", 0.5)
    }
  },
  _focus: {
    color: "buttonHover",
    borderColor: "buttonHover",
    backgroundColor: "surface1"
  },
  _active: {
    color: "buttonActive",
    borderColor: "buttonActive",
    backgroundColor: "surface1"
  },
  _disabled: {
    backgroundColor: pn("surface1", 0.5),
    color: pn("buttonDefault", 0.5),
    borderColor: pn("buttonDefault", 0.5)
  }
}, cC = {
  backgroundColor: "textTertiary",
  border: "1px solid",
  borderColor: "strokeDefault",
  color: "textOffset",
  _hover: {
    backgroundColor: "textSecondary",
    borderColor: "strokeHover",
    _disabled: {
      backgroundColor: pn("strokeHover", 0.5),
      color: pn("textPrimary", 0.5)
    }
  },
  _focus: {
    backgroundColor: "strokeHover",
    borderColor: "strokeHover"
  },
  _active: {
    backgroundColor: "strokeActive",
    borderColor: "strokeActive"
  },
  _disabled: {
    backgroundColor: pn("textTertiary", 0.5),
    borderColor: pn("strokeDefault", 0.5),
    color: pn("textOffset", 0.5)
  }
}, gte = {
  backgroundColor: "strokeDefault",
  border: "1px solid",
  borderColor: "strokeDefault",
  color: "textPrimary",
  _hover: {
    backgroundColor: "strokeHover",
    borderColor: "strokeHover",
    _disabled: {
      backgroundColor: pn("strokeHover", 0.5),
      color: pn("textPrimary", 0.5)
    }
  },
  _focus: {
    backgroundColor: "strokeHover",
    borderColor: "strokeHover"
  },
  _active: {
    backgroundColor: "strokeActive",
    borderColor: "strokeActive"
  },
  _disabled: {
    backgroundColor: pn("strokeDefault", 0.5),
    borderColor: pn("strokeDefault", 0.5),
    color: pn("textPrimary", 0.5)
  }
};
var Ub, Xb, Yb, qb, Jb, Kb;
const vte = {
  Button: {
    baseStyle: {
      borderRadius: "4px"
    },
    variants: {
      ...Q2.Button.variants,
      primary: pte,
      danger: {
        color: "textOffset",
        backgroundColor: "error",
        _hover: {
          backgroundColor: sa("error", 5),
          _disabled: {
            backgroundColor: pn("error", 0.6)
          }
        },
        _focus: {
          backgroundColor: sa("error", 10)
        },
        _active: {
          backgroundColor: sa("error", 15)
        },
        _disabled: {
          backgroundColor: pn("error", 0.5)
        }
      },
      secondary: mte,
      quaternary: cC,
      inline: {
        padding: "inlineButtonPadding",
        color: "buttonDefault",
        _hover: {
          color: "buttonHover",
          textDecoration: "underline",
          textUnderlineOffset: "2px",
          _disabled: {
            color: pn("buttonHover", 0.5)
          }
        },
        _focus: {
          color: "buttonHover"
        },
        _active: {
          color: "buttonActive"
        },
        _disabled: {
          color: pn("buttonDefault", 0.5)
        }
      },
      inlineSecondary: {
        padding: "inlineButtonPadding",
        color: "textPrimary",
        _hover: {
          color: "strokeHover",
          textUnderlineOffset: "2px",
          _disabled: {
            color: pn("strokeHover", 0.7)
          }
        },
        _focus: {
          color: "strokeHover"
        },
        _active: {
          color: "strokeHover"
        },
        _disabled: {
          color: pn("textPrimary", 0.7)
        }
      },
      nav: {
        backgroundColor: "transparent",
        padding: "navButtonPadding",
        color: "buttonDefault",
        _hover: {
          color: "buttonHover",
          backgroundColor: "transparent",
          _disabled: {
            backgroundColor: pn("navBackgroundHover", 0.5)
          }
        },
        _focus: {
          color: "buttonHover",
          backgroundColor: "transparent"
        },
        _active: {
          color: "buttonActive",
          backgroundColor: "transparent"
        },
        _disabled: {
          color: pn("buttonDefault", 0.5)
        }
      },
      tertiary: {
        color: "strokeDefault",
        _hover: {
          color: "strokeHover",
          backgroundColor: pn("strokeHover", 0.1),
          _disabled: {
            backgroundColor: pn("strokeHover", 0.5)
          }
        },
        _focus: {
          color: "strokeHover"
        },
        _active: {
          color: "strokeActive"
        },
        _disabled: {
          color: pn("strokeHover", 0.5)
        }
      },
      lowContrast: gte
    },
    sizes: {
      sm: {
        ...(Xb = (Ub = _n == null ? void 0 : _n.Text) == null ? void 0 : Ub.variants) == null ? void 0 : Xb.buttonSmall,
        px: "12px",
        py: "4px",
        height: "22px"
      },
      md: {
        ...(qb = (Yb = _n == null ? void 0 : _n.Text) == null ? void 0 : Yb.variants) == null ? void 0 : qb.buttonRegular,
        px: "40px",
        py: "10px"
      },
      lg: {
        ...(Kb = (Jb = _n == null ? void 0 : _n.Text) == null ? void 0 : Jb.variants) == null ? void 0 : Kb.buttonRegular,
        px: "40px",
        py: "10px"
      }
    },
    defaultProps: {
      ...Q2.Button.defaultProps
    }
  },
  IconButton: {
    sizes: {
      xs: {
        padding: "0rem"
      },
      sm: {
        padding: ".25rem"
      },
      md: {
        padding: ".5rem"
      },
      lg: {
        padding: ".75rem"
      }
    },
    variants: {
      quaternary: cC
    }
  }
};
var Qb, ey, ty, ny;
const Cte = {
  Checkbox: {
    baseStyle: {
      control: {
        borderColor: "strokeInteractive",
        _checked: {
          borderColor: "selected2",
          backgroundColor: "selected2",
          _before: {
            content: '""',
            display: "inline-block",
            pos: "relative",
            borderWidth: 0,
            bg: "selected2"
          },
          _hover: {
            background: "hover2"
          }
        },
        _hover: {
          background: "hover2"
        }
      }
    },
    variants: {
      boxed: {
        container: {
          marginBottom: ".5rem",
          borderWidth: "1px",
          borderColor: "strokeDefault",
          padding: ".5rem",
          width: "100%"
        }
      }
    },
    sizes: {
      sm: {
        control: {
          width: "12px",
          height: "12px",
          borderWidth: 1.5
        },
        label: {
          ...(ey = (Qb = _n == null ? void 0 : _n.Text) == null ? void 0 : Qb.variants) == null ? void 0 : ey.h4,
          marginInlineStart: "10px"
        },
        container: {
          marginBottom: "8px"
        }
      },
      lg: {
        control: {
          width: "18px",
          height: "18px",
          borderWidth: 2
        },
        label: {
          ...(ny = (ty = _n == null ? void 0 : _n.Text) == null ? void 0 : ty.variants) == null ? void 0 : ny.h4,
          marginInlineStart: "10px"
        },
        container: {
          marginBottom: "10px"
        }
      }
    }
  }
}, bte = {
  FormLabel: {
    baseStyle: {
      fontSize: "sm",
      color: "inputLabelText"
    }
  }
}, yte = {
  ...bte,
  FormLabel: {
    baseStyle: {
      color: "typography.tertiary",
      fontWeight: "bold",
      fontSize: "md"
    }
  },
  FormError: {
    parts: ["text"],
    baseStyle: {
      text: {
        ..._n.Text.variants.body2,
        color: "typography.danger"
      }
    }
  },
  Form: {
    parts: ["helperText"],
    baseStyle: {
      helperText: {
        ..._n.Text.variants.body1,
        color: "typography.tertiary"
      }
    }
  }
}, S3 = {
  outline: {
    borderRadius: "4px",
    borderColor: "strokeDefault",
    backgroundColor: "surface1",
    _hover: {
      borderColor: "strokeHover"
    },
    _invalid: {
      borderColor: "error"
    },
    _selected: {
      borderColor: "selected2"
    },
    _focusVisible: {
      borderColor: "selected2",
      boxShadow: "0 0 0 1px var(--chakra-colors-selected2)",
      // transparent outline doesn't show in any case except Windows with high-contrast theme enabled
      // in this case, boxShadow is _disabled_, and windows overrides 'transparent' with a new value
      outlineColor: "transparent",
      outlineWidth: "1px",
      outlineStyle: "dotted"
    }
  }
}, Ste = {
  Input: {
    variants: {
      outline: {
        field: {
          borderRadius: "sm",
          borderColor: "border",
          _focus: {
            borderColor: "primary",
            _invalid: {
              borderColor: "danger"
            }
          },
          _invalid: {
            borderColor: "danger"
          }
        }
      }
    }
  }
}, Ate = {
  Input: {
    variants: {
      ...Ste.Input.variants,
      outline: {
        field: S3.outline
      },
      ghost: {
        border: "none",
        backgroundColor: "surface3",
        _focus: {
          border: "none"
        },
        _disabled: {
          backgroundColor: "none"
        }
      }
    },
    defaultProps: {
      variant: "outline"
    },
    sizes: {
      xs: {
        field: {
          height: "1.5rem"
        }
      },
      sm: {
        field: {
          height: "2rem"
        }
      },
      md: {
        field: {
          height: "2.75rem"
        }
      },
      lg: {
        field: {
          height: "3rem"
        }
      }
    }
  },
  Textarea: {
    variants: {
      outline: S3.outline
    },
    defaultProps: {
      variant: "outline"
    }
  }
}, Hx = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 500,
  sticky: 600,
  banner: 700,
  overlay: 800,
  modal: 900,
  popover: 950,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, { definePartsStyle: Mte } = un(Ny.keys), xte = {
  Popover: {
    baseStyle: {
      popper: {
        zIndex: "popover"
      }
    },
    variants: {
      inline: Mte({
        popper: { zIndex: Hx.base + 1 }
      })
    }
  }
};
var ry, oy, ay, iy;
const _te = {
  RadioGroup: {
    baseStyle: {
      backgroundColor: "red"
    }
  },
  Radio: {
    parts: ["control"],
    baseStyle: {
      control: {
        borderColor: "strokeInteractive",
        _checked: {
          borderColor: "selected2",
          background: "none",
          _before: {
            content: '""',
            display: "inline-block",
            pos: "relative",
            borderWidth: 0,
            bg: "selected2"
          },
          _hover: {
            background: "hover2"
          }
        },
        _hover: {
          background: "hover2"
        },
        _disabled: {
          _checked: {
            _before: {
              bg: "selected1"
            }
          }
        }
      }
    },
    variants: {
      __dangerDoNotUseCheckmarks: {
        control: {
          position: "relative",
          borderColor: "none",
          background: "white",
          _before: {
            position: "absolute",
            top: "-2px",
            content: '""',
            transform: "rotate(45deg)",
            height: "1rem",
            width: ".5rem",
            borderRadius: "0px",
            borderBottomWidth: "3px",
            borderBottomStyle: "solid",
            borderBottomColor: "selected1",
            borderRightWidth: "3px",
            borderRightStyle: "solid",
            borderRightColor: "selected1"
          },
          _checked: {
            borderColor: "none",
            background: "white",
            _before: {
              content: '""',
              height: "1rem",
              width: ".5rem",
              borderRadius: "0px",
              borderBottomWidth: "3px",
              borderBottomStyle: "solid",
              borderBottomColor: "selected2",
              borderRightWidth: "3px",
              borderRightStyle: "solid",
              borderRightColor: "selected2",
              display: "inline-block",
              pos: "absolute",
              bg: "none"
            },
            _hover: {
              borderColor: "none",
              background: "white",
              _before: {
                content: '""',
                height: "1rem",
                width: ".5rem",
                borderRadius: "0px",
                borderBottomWidth: "3px",
                borderBottomStyle: "solid",
                borderBottomColor: "selected3",
                borderRightWidth: "3px",
                borderRightStyle: "solid",
                borderRightColor: "selected3",
                display: "inline-block",
                pos: "absolute",
                bg: "none"
              }
            }
          },
          _hover: {
            borderColor: "none",
            background: "white",
            _before: {
              content: '""',
              height: "1rem",
              width: ".5rem",
              borderRadius: "0px",
              borderBottomWidth: "3px",
              borderBottomStyle: "solid",
              borderBottomColor: "surfaceAccent5",
              borderRightWidth: "3px",
              borderRightStyle: "solid",
              borderRightColor: "surfaceAccent5",
              display: "inline-block",
              pos: "absolute",
              bg: "none"
            }
          }
        }
      }
    },
    sizes: {
      sm: {
        control: {
          width: "14px",
          height: "14px",
          borderWidth: 1.5,
          _checked: {
            _before: {
              w: "7px",
              h: "7px"
            }
          }
        },
        label: {
          ...(oy = (ry = _n == null ? void 0 : _n.Text) == null ? void 0 : ry.variants) == null ? void 0 : oy.h4,
          marginInlineStart: "10px"
        },
        container: {
          marginBottom: "8px",
          _last: {
            marginBottom: 0
          }
        }
      },
      lg: {
        control: {
          width: "20px",
          height: "20px",
          borderWidth: 2,
          _checked: {
            _before: {
              w: "10px",
              h: "10px"
            }
          }
        },
        label: {
          ...(iy = (ay = _n == null ? void 0 : _n.Text) == null ? void 0 : ay.variants) == null ? void 0 : iy.h4,
          marginInlineStart: "10px"
        },
        container: {
          marginBottom: "10px",
          _last: {
            marginBottom: 0
          }
        }
      }
    }
  }
}, Ite = {
  ReactTableUI: {
    parts: ["tbody"],
    baseStyle: {
      tbody: {
        tr: {
          "th, td": {
            borderBottomWidth: 0
          }
        }
      }
    }
  }
}, { defineMultiStyleConfig: wte } = un(["field"]), Lte = {
  Select: wte({
    defaultProps: {
      variant: "outline"
    },
    variants: {
      outline: {
        field: S3.outline
      }
    },
    sizes: {
      xs: {
        field: {
          height: "1.5rem"
        }
      },
      sm: {
        field: {
          height: "2rem"
        }
      },
      md: {
        field: {
          height: "2.75rem"
        }
      },
      lg: {
        field: {
          height: "3rem"
        }
      }
    }
  })
}, Rte = {
  Switch: {
    baseStyle: {
      track: {
        borderRadius: "4px",
        bg: "strokeDefault",
        _checked: {
          bg: "surfaceAccent4"
        }
      },
      thumb: {
        borderRadius: "2px"
      }
    }
  }
}, Ete = {
  ...qee,
  ...vte,
  ...Cte,
  ...yte,
  ...Ate,
  ..._te,
  ...xte,
  ...Rte,
  ..._n,
  ...Ite,
  ...Lte
}, Dte = {
  xxs: "8px",
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px",
  xl: "24px",
  "2xl": "28px"
}, Nte = {
  xs: "7px",
  sm: "8px",
  md: "10px",
  lg: "12px",
  xl: "16px",
  xxxl: "56px"
}, Gx = {
  heading: "'Lato', sans-serif",
  body: "'Lato', sans-serif",
  mono: "'Lato', sans-serif"
}, Tte = {
  styles: {
    global: () => {
      var e;
      return {
        a: {
          textDecoration: "underline"
        },
        svg: {
          display: "inline"
        },
        ".fc": {
          button: {
            ...Q2.Button.baseStyle,
            ...(e = Q2.Button.variants) == null ? void 0 : e.filled,
            border: "0px"
          },
          ".fc-daygrid-day.fc-day-sat, .fc-daygrid-day.fc-day-sun": {
            backgroundColor: "secondaryBackground"
          },
          ".fc-col-header-cell": {
            color: "black",
            backgroundColor: "initial"
          }
        }
      };
    }
  }
}, Pte = {}, kte = {
  primaryButtonPadding: "10px 40px",
  secondaryButtonPadding: "10px 40px",
  secondarySmallButtonPadding: "4px 12px",
  inlineButtonPadding: "0px 3px",
  navButtonPadding: "8px 20px"
}, Vte = {
  config: {
    initialColorMode: "light",
    useSystemColorMode: !1
  },
  ...Tte,
  colors: Fo,
  components: Ete,
  fonts: Gx,
  fontSizes: Dte,
  space: kte,
  sizes: Pte,
  zIndices: Hx
}, Lme = {
  config: {
    initialColorMode: "light",
    useSystemColorMode: !1
  },
  colors: Yee,
  fonts: Gx,
  fontSizes: Nte
};
const Rme = ({ children: e, themes: t }) => {
  const n = BY(Vte, ...t ?? []);
  return /* @__PURE__ */ A.jsx(FX, { theme: n, children: e });
}, Eme = (e) => /* @__PURE__ */ A.jsx(HA, { ...e });
function $x(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = $x(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function to() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = $x(e)) && (r && (r += " "), r += t);
  return r;
}
const Zx = ({ text: e, variant: t = "primary", size: n = "sm" }) => /* @__PURE__ */ A.jsx("span", { className: `badge ${t} ${n}`, children: e }), Ote = ["home-heart-filled", "baths", "location", "error-warning"], Fte = (e) => Ote.includes(e) ? "evenodd" : "nonzero", Bte = {
  add: {
    paths: [
      "M11 11V6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H11Z"
    ]
  },
  "arrow-left": {
    paths: [
      "M7.828 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H7.828L12.485 17.657C12.8755 18.0475 12.8755 18.6805 12.485 19.071C12.0945 19.4615 11.4615 19.4615 11.071 19.071L4 12L11.071 4.929C11.4615 4.53853 12.0945 4.53853 12.485 4.929C12.8755 5.31947 12.8755 5.95254 12.485 6.343L7.828 11Z"
    ]
  },
  "assignment-add": {
    paths: [
      "M180-120q-24.75 0-42.375-17.625T120-180v-600q0-24.75 17.625-42.375T180-840h205q5-35 32-57.5t63-22.5q36 0 63 22.5t32 57.5h205q24.75 0 42.375 17.625T840-780v329q-14-8-29.5-13t-30.5-8v-308H180v600h309q4 16 9.023 31.172Q503.045-133.655 510-120H180Zm0-107v47-600 308-4 249Zm100-53h211q4-16 9-31t13-29H280v60Zm0-170h344q14-7 27-11.5t29-8.5v-40H280v60Zm0-170h400v-60H280v60Zm200-177q14 0 24.5-10.5T515-832q0-14-10.5-24.5T480-867q-14 0-24.5 10.5T445-832q0 14 10.5 24.5T480-797ZM732.5-41Q655-41 600-96.5T545-228q0-78.435 54.99-133.717Q654.98-417 733-417q77 0 132.5 55.283Q921-306.435 921-228q0 76-55.5 131.5T732.5-41ZM718-101h33v-110h110v-33H751v-110h-33v110H608v33h110v110Z"
    ],
    viewBox: "0 -960 960 960"
  },
  bank: {
    paths: [
      "M11 1.57752L2.70577 6.3662C2.26904 6.61834 2 7.08433 2 7.58863C2 8.3682 2.63197 9.00017 3.41154 9.00017H20.5885C21.368 9.00017 22 8.3682 22 7.58863C22 7.08434 21.731 6.61835 21.2942 6.3662L13 1.57752C12.3812 1.22025 11.6188 1.22025 11 1.57752ZM12 3.88692L7.47372 6.50017H16.5263L12 3.88692Z",
      "M12 11.0002C12.6904 11.0002 13.25 11.5598 13.25 12.2502V16.5002C13.25 17.1905 12.6904 17.7502 12 17.7502C11.3096 17.7502 10.75 17.1905 10.75 16.5002V12.2502C10.75 11.5598 11.3096 11.0002 12 11.0002Z",
      "M20.75 22.0002C21.4404 22.0002 22 21.4405 22 20.7502C22 20.0598 21.4404 19.5002 20.75 19.5002H3.25C2.55964 19.5002 2 20.0598 2 20.7502C2 21.4405 2.55964 22.0002 3.25 22.0002H20.75Z",
      "M17.5 11.0002C18.1904 11.0002 18.75 11.5598 18.75 12.2502V16.5002C18.75 17.1905 18.1904 17.7502 17.5 17.7502C16.8096 17.7502 16.25 17.1905 16.25 16.5002V12.2502C16.25 11.5598 16.8096 11.0002 17.5 11.0002Z",
      "M6.5 11.0002C7.19036 11.0002 7.75 11.5598 7.75 12.2502V16.5002C7.75 17.1905 7.19036 17.7502 6.5 17.7502C5.80964 17.7502 5.25 17.1905 5.25 16.5002V12.2502C5.25 11.5598 5.80964 11.0002 6.5 11.0002Z"
    ]
  },
  cursor: {
    paths: [
      "M17.94 20.512L15.388 13.498H15.389L19.947 12.865L8.41004 1.633L6.79004 17.653L10.689 15.208L13.242 22.222L17.94 20.512Z"
    ]
  },
  "heart-3": {
    paths: [
      "M16.5 3C19.538 3 22 5.5 22 9C22 16 14.5 20 12 21.5C9.5 20 2 16 2 9C2 5.5 4.5 3 7.5 3C9.36 3 11 4 12 5C13 4 14.64 3 16.5 3ZM12.934 18.604C13.815 18.048 14.61 17.495 15.354 16.903C18.335 14.533 20 11.943 20 9C20 6.64 18.463 5 16.5 5C15.424 5 14.26 5.57 13.414 6.414L12 7.828L10.586 6.414C9.74 5.57 8.576 5 7.5 5C5.56 5 4 6.656 4 9C4 11.944 5.666 14.533 8.645 16.903C9.39 17.495 10.185 18.048 11.066 18.603C11.365 18.792 11.661 18.973 12 19.175C12.339 18.973 12.635 18.792 12.934 18.604V18.604Z"
    ]
  },
  lock: {
    paths: [
      "M19 10H20C20.2652 10 20.5196 10.1054 20.7071 10.2929C20.8946 10.4804 21 10.7348 21 11V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V11C3 10.7348 3.10536 10.4804 3.29289 10.2929C3.48043 10.1054 3.73478 10 4 10H5V9C5 8.08075 5.18106 7.1705 5.53284 6.32122C5.88463 5.47194 6.40024 4.70026 7.05025 4.05025C7.70026 3.40024 8.47194 2.88463 9.32122 2.53284C10.1705 2.18106 11.0807 2 12 2C12.9193 2 13.8295 2.18106 14.6788 2.53284C15.5281 2.88463 16.2997 3.40024 16.9497 4.05025C17.5998 4.70026 18.1154 5.47194 18.4672 6.32122C18.8189 7.1705 19 8.08075 19 9V10ZM5 12V20H19V12H5ZM11 14H13V18H11V14ZM17 10V9C17 7.67392 16.4732 6.40215 15.5355 5.46447C14.5979 4.52678 13.3261 4 12 4C10.6739 4 9.40215 4.52678 8.46447 5.46447C7.52678 6.40215 7 7.67392 7 9V10H17Z"
    ]
  },
  "indeterminate-circle": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM7 11H17V13H7V11Z"
    ]
  },
  "arrow-drop-down": {
    paths: [
      "M11.9998 15L8.46419 11.4643C8.07357 11.0737 8.07376 10.4403 8.46452 10.0498V10.0498C8.85514 9.65946 9.48829 9.65955 9.87869 10.0501L11.9998 12.172L14.121 10.0501C14.5114 9.65955 15.1445 9.65946 15.5351 10.0498V10.0498C15.9259 10.4403 15.9261 11.0737 15.5355 11.4643L11.9998 15Z"
    ]
  },
  subtract: {
    paths: [
      "M5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12V12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12V12Z"
    ]
  },
  "settings-3": {
    paths: [
      "M3.33933 17C2.9166 16.269 2.58799 15.4875 2.36133 14.674C2.85464 14.4231 3.26892 14.0406 3.55836 13.5689C3.84779 13.0972 4.00109 12.5546 4.0013 12.0011C4.00151 11.4477 3.84861 10.905 3.55953 10.433C3.27045 9.96106 2.85645 9.57828 2.36333 9.32701C2.81536 7.69249 3.67606 6.19996 4.86433 4.99001C5.32842 5.29173 5.86695 5.45917 6.42031 5.47379C6.97367 5.48841 7.52028 5.34964 7.99966 5.07284C8.47904 4.79604 8.87248 4.392 9.13646 3.90545C9.40043 3.41889 9.52463 2.86878 9.49533 2.31601C11.1374 1.89163 12.8606 1.89232 14.5023 2.31801C14.4733 2.87077 14.5977 3.4208 14.8619 3.90721C15.1261 4.39363 15.5197 4.79748 15.9992 5.07407C16.4786 5.35065 17.0253 5.48919 17.5786 5.47436C18.1319 5.45952 18.6704 5.29189 19.1343 4.99001C19.7133 5.58001 20.2273 6.25101 20.6593 7.00001C21.0923 7.74901 21.4163 8.53001 21.6373 9.32601C21.144 9.57691 20.7297 9.95938 20.4403 10.4311C20.1509 10.9028 19.9976 11.4454 19.9974 11.9989C19.9971 12.5523 20.15 13.0951 20.4391 13.567C20.7282 14.039 21.1422 14.4217 21.6353 14.673C21.1833 16.3075 20.3226 17.8001 19.1343 19.01C18.6702 18.7083 18.1317 18.5408 17.5784 18.5262C17.025 18.5116 16.4784 18.6504 15.999 18.9272C15.5196 19.204 15.1262 19.608 14.8622 20.0946C14.5982 20.5811 14.474 21.1312 14.5033 21.684C12.8612 22.1084 11.1381 22.1077 9.49633 21.682C9.52537 21.1292 9.40093 20.5792 9.13675 20.0928C8.87257 19.6064 8.47897 19.2025 7.9995 18.9259C7.52003 18.6494 6.97338 18.5108 6.42005 18.5257C5.86673 18.5405 5.32829 18.7081 4.86433 19.01C4.27332 18.407 3.76092 17.7316 3.33933 17V17ZM8.99933 17.196C10.065 17.8106 10.8662 18.797 11.2493 19.966C11.7483 20.013 12.2493 20.014 12.7483 19.967C13.1317 18.7979 13.9333 17.8114 14.9993 17.197C16.0645 16.5807 17.3199 16.3795 18.5243 16.632C18.8143 16.224 19.0643 15.789 19.2723 15.334C18.4518 14.4174 17.9984 13.2302 17.9993 12C17.9993 10.74 18.4693 9.56301 19.2723 8.66601C19.0629 8.21115 18.8118 7.77664 18.5223 7.36801C17.3186 7.62032 16.0641 7.41948 14.9993 6.80401C13.9337 6.18938 13.1325 5.20299 12.7493 4.03401C12.2503 3.98701 11.7493 3.98601 11.2503 4.03301C10.8669 5.20215 10.0653 6.18857 8.99933 6.80301C7.93411 7.41932 6.67881 7.62053 5.47433 7.36801C5.18489 7.77629 4.93446 8.21087 4.72633 8.66601C5.5469 9.58257 6.00021 10.7698 5.99933 12C5.99933 13.26 5.52933 14.437 4.72633 15.334C4.9358 15.7889 5.18687 16.2234 5.47633 16.632C6.68005 16.3797 7.93454 16.5805 8.99933 17.196ZM11.9993 15C11.2037 15 10.4406 14.6839 9.87801 14.1213C9.3154 13.5587 8.99933 12.7957 8.99933 12C8.99933 11.2044 9.3154 10.4413 9.87801 9.87869C10.4406 9.31608 11.2037 9.00001 11.9993 9.00001C12.795 9.00001 13.558 9.31608 14.1206 9.87869C14.6833 10.4413 14.9993 11.2044 14.9993 12C14.9993 12.7957 14.6833 13.5587 14.1206 14.1213C13.558 14.6839 12.795 15 11.9993 15ZM11.9993 13C12.2645 13 12.5189 12.8946 12.7064 12.7071C12.894 12.5196 12.9993 12.2652 12.9993 12C12.9993 11.7348 12.894 11.4804 12.7064 11.2929C12.5189 11.1054 12.2645 11 11.9993 11C11.7341 11 11.4798 11.1054 11.2922 11.2929C11.1047 11.4804 10.9993 11.7348 10.9993 12C10.9993 12.2652 11.1047 12.5196 11.2922 12.7071C11.4798 12.8946 11.7341 13 11.9993 13V13Z"
    ]
  },
  "apps-2": {
    paths: [
      "M6.5 11.5C5.90905 11.5 5.32389 11.3836 4.77792 11.1575C4.23196 10.9313 3.73588 10.5998 3.31802 10.182C2.90016 9.76412 2.56869 9.26804 2.34254 8.72208C2.1164 8.17611 2 7.59095 2 7C2 6.40905 2.1164 5.82389 2.34254 5.27792C2.56869 4.73196 2.90016 4.23588 3.31802 3.81802C3.73588 3.40016 4.23196 3.06869 4.77792 2.84254C5.32389 2.6164 5.90905 2.5 6.5 2.5C7.69347 2.5 8.83807 2.97411 9.68198 3.81802C10.5259 4.66193 11 5.80653 11 7C11 8.19347 10.5259 9.33807 9.68198 10.182C8.83807 11.0259 7.69347 11.5 6.5 11.5V11.5ZM7 21.5C5.80653 21.5 4.66193 21.0259 3.81802 20.182C2.97411 19.3381 2.5 18.1935 2.5 17C2.5 15.8065 2.97411 14.6619 3.81802 13.818C4.66193 12.9741 5.80653 12.5 7 12.5C8.19347 12.5 9.33807 12.9741 10.182 13.818C11.0259 14.6619 11.5 15.8065 11.5 17C11.5 18.1935 11.0259 19.3381 10.182 20.182C9.33807 21.0259 8.19347 21.5 7 21.5V21.5ZM17 11.5C16.4091 11.5 15.8239 11.3836 15.2779 11.1575C14.732 10.9313 14.2359 10.5998 13.818 10.182C13.4002 9.76412 13.0687 9.26804 12.8425 8.72208C12.6164 8.17611 12.5 7.59095 12.5 7C12.5 6.40905 12.6164 5.82389 12.8425 5.27792C13.0687 4.73196 13.4002 4.23588 13.818 3.81802C14.2359 3.40016 14.732 3.06869 15.2779 2.84254C15.8239 2.6164 16.4091 2.5 17 2.5C18.1935 2.5 19.3381 2.97411 20.182 3.81802C21.0259 4.66193 21.5 5.80653 21.5 7C21.5 8.19347 21.0259 9.33807 20.182 10.182C19.3381 11.0259 18.1935 11.5 17 11.5V11.5ZM17 21.5C15.8065 21.5 14.6619 21.0259 13.818 20.182C12.9741 19.3381 12.5 18.1935 12.5 17C12.5 15.8065 12.9741 14.6619 13.818 13.818C14.6619 12.9741 15.8065 12.5 17 12.5C18.1935 12.5 19.3381 12.9741 20.182 13.818C21.0259 14.6619 21.5 15.8065 21.5 17C21.5 18.1935 21.0259 19.3381 20.182 20.182C19.3381 21.0259 18.1935 21.5 17 21.5ZM6.5 9.5C7.16304 9.5 7.79893 9.23661 8.26777 8.76777C8.73661 8.29893 9 7.66304 9 7C9 6.33696 8.73661 5.70107 8.26777 5.23223C7.79893 4.76339 7.16304 4.5 6.5 4.5C5.83696 4.5 5.20107 4.76339 4.73223 5.23223C4.26339 5.70107 4 6.33696 4 7C4 7.66304 4.26339 8.29893 4.73223 8.76777C5.20107 9.23661 5.83696 9.5 6.5 9.5V9.5ZM7 19.5C7.66304 19.5 8.29893 19.2366 8.76777 18.7678C9.23661 18.2989 9.5 17.663 9.5 17C9.5 16.337 9.23661 15.7011 8.76777 15.2322C8.29893 14.7634 7.66304 14.5 7 14.5C6.33696 14.5 5.70107 14.7634 5.23223 15.2322C4.76339 15.7011 4.5 16.337 4.5 17C4.5 17.663 4.76339 18.2989 5.23223 18.7678C5.70107 19.2366 6.33696 19.5 7 19.5ZM17 9.5C17.663 9.5 18.2989 9.23661 18.7678 8.76777C19.2366 8.29893 19.5 7.66304 19.5 7C19.5 6.33696 19.2366 5.70107 18.7678 5.23223C18.2989 4.76339 17.663 4.5 17 4.5C16.337 4.5 15.7011 4.76339 15.2322 5.23223C14.7634 5.70107 14.5 6.33696 14.5 7C14.5 7.66304 14.7634 8.29893 15.2322 8.76777C15.7011 9.23661 16.337 9.5 17 9.5ZM17 19.5C17.663 19.5 18.2989 19.2366 18.7678 18.7678C19.2366 18.2989 19.5 17.663 19.5 17C19.5 16.337 19.2366 15.7011 18.7678 15.2322C18.2989 14.7634 17.663 14.5 17 14.5C16.337 14.5 15.7011 14.7634 15.2322 15.2322C14.7634 15.7011 14.5 16.337 14.5 17C14.5 17.663 14.7634 18.2989 15.2322 18.7678C15.7011 19.2366 16.337 19.5 17 19.5Z"
    ]
  },
  "arrow-drop-up": {
    paths: [
      "M11.9998 11.828L9.87869 13.9499C9.48829 14.3404 8.85514 14.3405 8.46452 13.9502V13.9502C8.07376 13.5597 8.07357 12.9263 8.46419 12.5356L11.9998 9L15.5355 12.5356C15.9261 12.9263 15.9259 13.5597 15.5351 13.9502V13.9502C15.1445 14.3405 14.5114 14.3404 14.121 13.9499L11.9998 11.828Z"
    ]
  },
  "thumb-down": {
    paths: [
      "M9.4 16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14V11.896C0.999731 11.6346 1.05069 11.3758 1.15 11.134L4.246 3.62C4.32128 3.43675 4.4493 3.28 4.6138 3.16961C4.77831 3.05923 4.97189 3.0002 5.17 3H22C22.2652 3 22.5196 3.10536 22.7071 3.29289C22.8946 3.48043 23 3.73478 23 4V14C23 14.2652 22.8946 14.5196 22.7071 14.7071C22.5196 14.8946 22.2652 15 22 15H18.518C18.3579 15 18.2001 15.0384 18.058 15.112C17.9158 15.1856 17.7934 15.2922 17.701 15.423L12.248 23.149C12.1791 23.2467 12.0774 23.3164 11.9615 23.3456C11.8455 23.3748 11.723 23.3614 11.616 23.308L9.802 22.4C9.2915 22.1448 8.88367 21.7227 8.64627 21.2037C8.40887 20.6847 8.3562 20.1001 8.497 19.547L9.4 16ZM17 13.412V5H5.84L3 11.896V14H9.4C9.7046 14 10.0052 14.0697 10.2788 14.2035C10.5524 14.3374 10.7918 14.532 10.9787 14.7725C11.1657 15.013 11.2952 15.293 11.3575 15.5912C11.4197 15.8893 11.4131 16.1978 11.338 16.493L10.435 20.041C10.4067 20.1517 10.4172 20.2687 10.4647 20.3726C10.5122 20.4765 10.5938 20.561 10.696 20.612L11.357 20.942L16.067 14.27C16.317 13.916 16.637 13.626 17 13.412V13.412ZM19 13H21V5H19V13Z"
    ]
  },
  "external-link": {
    paths: [
      "M10 6V8H5V19H16V14H18V20C18 20.2652 17.8946 20.5196 17.7071 20.7071C17.5196 20.8946 17.2652 21 17 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V7C3 6.73478 3.10536 6.48043 3.29289 6.29289C3.48043 6.10536 3.73478 6 4 6H10ZM21 3V11H19V6.413L11.207 14.207L9.793 12.793L17.585 5H13V3H21Z"
    ]
  },
  "delete-bin": {
    paths: [
      "M17 6H22V8H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V8H2V6H7V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H16C16.2652 2 16.5196 2.10536 16.7071 2.29289C16.8946 2.48043 17 2.73478 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"
    ]
  },
  remove: {
    viewBox: "0 0 16 16",
    paths: [
      "M7.99967 14.6666C4.31767 14.6666 1.33301 11.6819 1.33301 7.99992C1.33301 4.31792 4.31767 1.33325 7.99967 1.33325C11.6817 1.33325 14.6663 4.31792 14.6663 7.99992C14.6663 11.6819 11.6817 14.6666 7.99967 14.6666ZM7.99967 13.3333C9.41416 13.3333 10.7707 12.7713 11.7709 11.7712C12.7711 10.771 13.333 9.41441 13.333 7.99992C13.333 6.58543 12.7711 5.22888 11.7709 4.22868C10.7707 3.22849 9.41416 2.66659 7.99967 2.66659C6.58519 2.66659 5.22863 3.22849 4.22844 4.22868C3.22824 5.22888 2.66634 6.58543 2.66634 7.99992C2.66634 9.41441 3.22824 10.771 4.22844 11.7712C5.22863 12.7713 6.58519 13.3333 7.99967 13.3333ZM4.66634 7.33325H11.333V8.66659H4.66634V7.33325Z"
    ]
  },
  "arrow-left-down": {
    paths: [
      "M9 13.59L16.9 5.69C17.2905 5.29954 17.9235 5.29954 18.314 5.69V5.69C18.7045 6.08047 18.7045 6.71354 18.314 7.104L10.414 15.004H17C17.5523 15.004 18 15.4517 18 16.004V16.004C18 16.5563 17.5523 17.004 17 17.004H7V7.004C7 6.45172 7.44772 6.004 8 6.004V6.004C8.55228 6.004 9 6.45172 9 7.004V13.589V13.59Z"
    ]
  },
  "arrow-left-up": {
    paths: [
      "M10.41 9L18.31 16.9C18.7005 17.2905 18.7005 17.9235 18.31 18.314V18.314C17.9195 18.7045 17.2865 18.7045 16.896 18.314L8.996 10.414L8.996 17C8.996 17.5523 8.54828 18 7.996 18V18C7.44371 18 6.996 17.5523 6.996 17L6.996 7L16.996 7C17.5483 7 17.996 7.44772 17.996 8V8C17.996 8.55228 17.5483 9 16.996 9L10.411 9L10.41 9Z"
    ]
  },
  question: {
    paths: [
      "M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM9 13H11V15H9V13ZM11 11.355V12H9V10.5C9 10.2348 9.10536 9.98043 9.29289 9.79289C9.48043 9.60536 9.73478 9.5 10 9.5C10.2841 9.49998 10.5623 9.4193 10.8023 9.26733C11.0423 9.11536 11.2343 8.89837 11.3558 8.64158C11.4773 8.3848 11.5234 8.0988 11.4887 7.81684C11.454 7.53489 11.34 7.26858 11.1598 7.04891C10.9797 6.82924 10.7409 6.66523 10.4712 6.57597C10.2015 6.48671 9.91204 6.47587 9.63643 6.54471C9.36081 6.61354 9.11042 6.75923 8.91437 6.96482C8.71832 7.1704 8.58468 7.42743 8.529 7.706L6.567 7.313C6.68863 6.70508 6.96951 6.14037 7.38092 5.67659C7.79233 5.2128 8.31952 4.86658 8.90859 4.67332C9.49766 4.48006 10.1275 4.44669 10.7337 4.57661C11.3399 4.70654 11.9007 4.99511 12.3588 5.41282C12.8169 5.83054 13.1559 6.36241 13.3411 6.95406C13.5263 7.54572 13.5511 8.17594 13.4129 8.78031C13.2747 9.38467 12.9785 9.9415 12.5545 10.3939C12.1306 10.8462 11.5941 11.1779 11 11.355Z"
    ],
    viewBox: "0 0 20 20"
  },
  close: {
    paths: [
      "M12.0007 10.586L16.2437 6.34299C16.6342 5.95252 17.2673 5.95252 17.6577 6.34299V6.34299C18.0482 6.73345 18.0482 7.36652 17.6577 7.75699L13.4147 12L17.6577 16.243C18.0482 16.6335 18.0482 17.2665 17.6577 17.657V17.657C17.2673 18.0475 16.6342 18.0475 16.2437 17.657L12.0007 13.414L7.75772 17.657C7.36725 18.0475 6.73418 18.0475 6.34372 17.657V17.657C5.95325 17.2665 5.95325 16.6335 6.34372 16.243L10.5867 12L6.34372 7.75699C5.95325 7.36652 5.95325 6.73345 6.34372 6.34299V6.34299C6.73418 5.95252 7.36725 5.95252 7.75772 6.34299L12.0007 10.586Z"
    ]
  },
  "close-circle": {
    paths: [
      "M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18Z",
      "M10 8.88906L13.3336 5.55547C13.6404 5.24869 14.1378 5.24869 14.4445 5.55547C14.7513 5.86224 14.7513 6.35963 14.4445 6.6664L11.1109 10L14.4445 13.3336C14.7513 13.6404 14.7513 14.1378 14.4445 14.4445C14.1378 14.7513 13.6404 14.7513 13.3336 14.4445L10 11.1109L6.6664 14.4445C6.35963 14.7513 5.86224 14.7513 5.55547 14.4445C5.24869 14.1378 5.24869 13.6404 5.55547 13.3336L8.88906 10L5.55547 6.6664C5.24869 6.35963 5.24869 5.86224 5.55547 5.55547C5.86224 5.24869 6.35963 5.24869 6.6664 5.55547L10 8.88906Z"
    ]
  },
  "arrow-left-s": {
    paths: [
      "M10.828 12L15.071 16.243C15.4615 16.6335 15.4615 17.2665 15.071 17.657V17.657C14.6805 18.0475 14.0475 18.0475 13.657 17.657L8 12L13.657 6.343C14.0475 5.95253 14.6805 5.95253 15.071 6.343V6.343C15.4615 6.73347 15.4615 7.36653 15.071 7.757L10.828 12Z"
    ]
  },
  "lock-unlock": {
    paths: [
      "M10.828 12L15.071 16.243C15.4615 16.6335 15.4615 17.2665 15.071 17.657V17.657C14.6805 18.0475 14.0475 18.0475 13.657 17.657L8 12L13.657 6.343C14.0475 5.95253 14.6805 5.95253 15.071 6.343V6.343C15.4615 6.73347 15.4615 7.36653 15.071 7.757L10.828 12Z"
    ]
  },
  time: {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM13 12H17V14H11V7H13V12Z"
    ]
  },
  "zoom-out": {
    paths: [
      "M18.031 16.617L22.314 20.899L20.899 22.314L16.617 18.031C15.0237 19.3082 13.042 20.0029 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20.0029 13.042 19.3082 15.0237 18.031 16.617ZM16.025 15.875C17.2941 14.5699 18.0029 12.8204 18 11C18 7.132 14.867 4 11 4C7.132 4 4 7.132 4 11C4 14.867 7.132 18 11 18C12.8204 18.0029 14.5699 17.2941 15.875 16.025L16.025 15.875V15.875ZM7 10H15V12H7V10Z"
    ]
  },
  "more-2": {
    paths: [
      "M12 3C11.175 3 10.5 3.675 10.5 4.5C10.5 5.325 11.175 6 12 6C12.825 6 13.5 5.325 13.5 4.5C13.5 3.675 12.825 3 12 3ZM12 18C11.175 18 10.5 18.675 10.5 19.5C10.5 20.325 11.175 21 12 21C12.825 21 13.5 20.325 13.5 19.5C13.5 18.675 12.825 18 12 18ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
    ]
  },
  information: {
    viewBox: "0 0 20 20",
    paths: [
      "M10 18.3333C5.39751 18.3333 1.66667 14.6025 1.66667 9.99999C1.66667 5.39749 5.39751 1.66666 10 1.66666C14.6025 1.66666 18.3333 5.39749 18.3333 9.99999C18.3333 14.6025 14.6025 18.3333 10 18.3333ZM10 16.6667C11.7681 16.6667 13.4638 15.9643 14.7141 14.714C15.9643 13.4638 16.6667 11.7681 16.6667 9.99999C16.6667 8.23188 15.9643 6.53619 14.7141 5.28594C13.4638 4.0357 11.7681 3.33332 10 3.33332C8.2319 3.33332 6.5362 4.0357 5.28596 5.28594C4.03572 6.53619 3.33334 8.23188 3.33334 9.99999C3.33334 11.7681 4.03572 13.4638 5.28596 14.714C6.5362 15.9643 8.2319 16.6667 10 16.6667ZM9.16667 5.83332H10.8333V7.49999H9.16667V5.83332ZM9.16667 9.16666H10.8333V14.1667H9.16667V9.16666Z"
    ]
  },
  "information-inverse": {
    viewBox: "0 0 16 16",
    paths: [
      "M8.00049 1.33334C11.6822 1.33352 14.6665 4.31855 14.6665 8.00034C14.6663 11.682 11.6821 14.6662 8.00049 14.6664C4.3187 14.6664 1.33367 11.6821 1.3335 8.00034C1.3335 4.31844 4.31859 1.33334 8.00049 1.33334ZM7.44189 10.7601V11.8714H8.55322V10.7601H7.44189ZM7.44189 4.09409V9.09409H8.55322V4.09409H7.44189Z"
    ]
  },
  "arrow-right-up": {
    paths: [
      "M16.0044 9.414L8.10442 17.314C7.71394 17.7045 7.08085 17.7045 6.69038 17.314V17.314C6.29992 16.9235 6.2999 16.2905 6.69034 15.9L14.5894 8H8.0044C7.45211 8 7.0044 7.55228 7.0044 7V7C7.0044 6.44772 7.45211 6 8.0044 6H18.0044V16C18.0044 16.5523 17.5567 17 17.0044 17V17C16.4521 17 16.0044 16.5523 16.0044 16V9.414Z"
    ]
  },
  "arrow-right-down": {
    paths: [
      "M14.586 16.0044L6.68602 8.10442C6.29554 7.71394 6.29554 7.08085 6.68602 6.69038V6.69038C7.07648 6.29992 7.70954 6.2999 8.10002 6.69034L16 14.5894L16 8.0044C16 7.45211 16.4477 7.0044 17 7.0044V7.0044C17.5523 7.0044 18 7.45211 18 8.0044L18 18.0044L8 18.0044C7.44771 18.0044 7 17.5567 7 17.0044V17.0044C7 16.4521 7.44771 16.0044 8 16.0044L14.586 16.0044Z"
    ]
  },
  "alarm-warning": {
    paths: [
      "M4.00059 20V14C4.00059 11.8783 4.84345 9.84344 6.34374 8.34315C7.84403 6.84285 9.87886 6 12.0006 6C14.1223 6 16.1572 6.84285 17.6574 8.34315C19.1577 9.84344 20.0006 11.8783 20.0006 14V20H21.0006V22H3.00059V20H4.00059ZM6.00059 20H18.0006V14C18.0006 12.4087 17.3685 10.8826 16.2432 9.75736C15.118 8.63214 13.5919 8 12.0006 8C10.4093 8 8.88317 8.63214 7.75795 9.75736C6.63273 10.8826 6.00059 12.4087 6.00059 14V20ZM11.0006 2H13.0006V5H11.0006V2ZM19.7786 4.808L21.1926 6.222L19.0726 8.343L17.6576 6.929L19.7786 4.808ZM2.80859 6.222L4.22259 4.808L6.34359 6.928L4.93059 8.344L2.80859 6.222ZM7.00059 14C7.00059 12.6739 7.52738 11.4021 8.46506 10.4645C9.40274 9.52678 10.6745 9 12.0006 9V11C11.2049 11 10.4419 11.3161 9.87927 11.8787C9.31666 12.4413 9.00059 13.2044 9.00059 14H7.00059Z"
    ]
  },
  "arrow-up-down": {
    paths: [
      "M11.9498 7.95L10.5358 9.364L7.9998 6.828V20H5.9998V6.828L3.4648 9.364L2.0498 7.95L6.9998 3L11.9498 7.95ZM21.9498 16.05L16.9998 21L12.0498 16.05L13.4638 14.636L16.0008 17.172L15.9998 4H17.9998V17.172L20.5358 14.636L21.9498 16.05V16.05Z"
    ]
  },
  filter: {
    paths: [
      "M21 4V6H20L15 13.5V22H9V13.5L4 6H3V4H21ZM6.404 6L11 12.894V20H13V12.894L17.596 6H6.404Z"
    ]
  },
  "delete-bin-6": {
    paths: [
      "M7 4V2H17V4H22V6H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V6H2V4H7ZM6 6V20H18V6H6ZM9 9H11V17H9V9ZM13 9H15V17H13V9Z"
    ]
  },
  "delete-bin-7": {
    paths: [
      "M17 6H22V8H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V8H2V6H7V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H16C16.2652 2 16.5196 2.10536 16.7071 2.29289C16.8946 2.48043 17 2.73478 17 3V6ZM18 8H6V20H18V8ZM9 4V6H15V4H9Z"
    ]
  },
  "add-circle": {
    paths: [
      "M11 11V8C11 7.44772 11.4477 7 12 7V7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12V12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17V17C11.4477 17 11 16.5523 11 16V13H8C7.44772 13 7 12.5523 7 12V12C7 11.4477 7.44772 11 8 11H11ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20Z"
    ]
  },
  "settings-5": {
    paths: [
      "M2.21276 14.06C1.92517 12.7017 1.92517 11.2983 2.21276 9.94001C3.32276 10.07 4.29276 9.70301 4.60876 8.93901C4.92576 8.17401 4.50076 7.22901 3.62276 6.53601C4.3798 5.37233 5.37209 4.38005 6.53576 3.62301C7.22776 4.50001 8.17376 4.92601 8.93876 4.60901C9.70376 4.29201 10.0708 3.32301 9.93976 2.21301C11.298 1.92542 12.7015 1.92542 14.0598 2.21301C13.9298 3.32301 14.2968 4.29301 15.0608 4.60901C15.8258 4.92601 16.7708 4.50101 17.4638 3.62301C18.6274 4.38005 19.6197 5.37233 20.3768 6.53601C19.4998 7.22801 19.0738 8.17401 19.3908 8.93901C19.7078 9.70401 20.6768 10.071 21.7868 9.94001C22.0744 11.2983 22.0744 12.7017 21.7868 14.06C20.6768 13.93 19.7068 14.297 19.3908 15.061C19.0738 15.826 19.4988 16.771 20.3768 17.464C19.6197 18.6277 18.6274 19.62 17.4638 20.377C16.7718 19.5 15.8258 19.074 15.0608 19.391C14.2958 19.708 13.9288 20.677 14.0598 21.787C12.7015 22.0746 11.298 22.0746 9.93976 21.787C10.0698 20.677 9.70276 19.707 8.93876 19.391C8.17376 19.074 7.22876 19.499 6.53576 20.377C5.37209 19.62 4.3798 18.6277 3.62276 17.464C4.49976 16.772 4.92576 15.826 4.60876 15.061C4.29176 14.296 3.32276 13.929 2.21276 14.06V14.06ZM3.99976 12.21C5.09976 12.515 6.00676 13.212 6.45676 14.296C6.90576 15.381 6.75676 16.516 6.19476 17.508C6.29076 17.61 6.38976 17.709 6.49176 17.805C7.48476 17.243 8.61876 17.095 9.70376 17.543C10.7878 17.993 11.4848 18.9 11.7898 20C11.9298 20.004 12.0698 20.004 12.2098 20C12.5148 18.9 13.2118 17.993 14.2958 17.543C15.3808 17.094 16.5158 17.243 17.5078 17.805C17.6098 17.709 17.7088 17.61 17.8048 17.508C17.2428 16.515 17.0948 15.381 17.5428 14.296C17.9928 13.212 18.8998 12.515 19.9998 12.21C20.0038 12.07 20.0038 11.93 19.9998 11.79C18.8998 11.485 17.9928 10.788 17.5428 9.70401C17.0938 8.61901 17.2428 7.48401 17.8048 6.49201C17.7084 6.3904 17.6094 6.29137 17.5078 6.19501C16.5148 6.75701 15.3808 6.90501 14.2958 6.45701C13.2118 6.00701 12.5148 5.10001 12.2098 4.00001C12.0698 3.9963 11.9297 3.9963 11.7898 4.00001C11.4848 5.10001 10.7878 6.00701 9.70376 6.45701C8.61876 6.90601 7.48376 6.75701 6.49176 6.19501C6.38976 6.29101 6.29076 6.39001 6.19476 6.49201C6.75676 7.48501 6.90476 8.61901 6.45676 9.70401C6.00676 10.788 5.09976 11.485 3.99976 11.79C3.99576 11.93 3.99576 12.07 3.99976 12.21V12.21ZM11.9998 15C11.2041 15 10.4411 14.6839 9.87844 14.1213C9.31583 13.5587 8.99976 12.7957 8.99976 12C8.99976 11.2044 9.31583 10.4413 9.87844 9.87869C10.4411 9.31608 11.2041 9.00001 11.9998 9.00001C12.7954 9.00001 13.5585 9.31608 14.1211 9.87869C14.6837 10.4413 14.9998 11.2044 14.9998 12C14.9998 12.7957 14.6837 13.5587 14.1211 14.1213C13.5585 14.6839 12.7954 15 11.9998 15ZM11.9998 13C12.265 13 12.5193 12.8946 12.7069 12.7071C12.8944 12.5196 12.9998 12.2652 12.9998 12C12.9998 11.7348 12.8944 11.4804 12.7069 11.2929C12.5193 11.1054 12.265 11 11.9998 11C11.7345 11 11.4802 11.1054 11.2927 11.2929C11.1051 11.4804 10.9998 11.7348 10.9998 12C10.9998 12.2652 11.1051 12.5196 11.2927 12.7071C11.4802 12.8946 11.7345 13 11.9998 13V13Z"
    ]
  },
  "arrow-up-s": {
    paths: [
      "M12.0007 10.828L7.75772 15.071C7.36725 15.4615 6.73418 15.4615 6.34372 15.071V15.071C5.95325 14.6805 5.95325 14.0475 6.34372 13.657L12.0007 8L17.6577 13.657C18.0482 14.0475 18.0482 14.6805 17.6577 15.071V15.071C17.2673 15.4615 16.6342 15.4615 16.2437 15.071L12.0007 10.828Z"
    ]
  },
  "zoom-in": {
    paths: [
      "M18.031 16.617L22.314 20.899L20.899 22.314L16.617 18.031C15.0237 19.3082 13.042 20.0029 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20.0029 13.042 19.3082 15.0237 18.031 16.617ZM16.025 15.875C17.2941 14.5699 18.0029 12.8204 18 11C18 7.132 14.867 4 11 4C7.132 4 4 7.132 4 11C4 14.867 7.132 18 11 18C12.8204 18.0029 14.5699 17.2941 15.875 16.025L16.025 15.875V15.875ZM10 10V7H12V10H15V12H12V15H10V12H7V10H10Z"
    ]
  },
  "share-forward-fill": {
    paths: [
      "M13 14H11C9.3596 13.9994 7.75023 14.4471 6.34588 15.2949C4.94152 16.1427 3.7956 17.3582 3.032 18.81C3.01054 18.5405 2.99986 18.2703 3 18C3 12.477 7.477 8 13 8V3L23 11L13 19V14Z"
    ]
  },
  "upload-line": {
    paths: [
      "M3 19H21V21H3V19ZM13 5.828V17H11V5.828L4.929 11.9L3.515 10.486L12 2L20.485 10.485L19.071 11.899L13 5.83V5.828Z"
    ]
  },
  "error-warning": {
    paths: [
      "M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM9.16309 14.1406V15.8076H10.8291V14.1406H9.16309ZM9.16309 4.14062V11.6406H10.8291V4.14062H9.16309Z"
    ]
  },
  "arrow-up": {
    paths: [
      "M13.0007 7.828V19C13.0007 19.5523 12.5529 20 12.0007 20V20C11.4484 20 11.0007 19.5523 11.0007 19V7.828L6.34366 12.485C5.95319 12.8755 5.32012 12.8755 4.92966 12.485V12.485C4.53919 12.0945 4.53919 11.4615 4.92966 11.071L12.0007 4L19.0717 11.071C19.4621 11.4615 19.4621 12.0945 19.0717 12.485V12.485C18.6812 12.8755 18.0481 12.8755 17.6577 12.485L13.0007 7.828Z"
    ]
  },
  share: {
    paths: [
      "M13.1202 17.023L8.92121 14.733C8.373 15.3191 7.66119 15.7267 6.87828 15.9029C6.09537 16.0791 5.27756 16.0157 4.53113 15.7211C3.7847 15.4264 3.14417 14.914 2.69277 14.2505C2.24138 13.587 2 12.803 2 12.0005C2 11.198 2.24138 10.4141 2.69277 9.75058C3.14417 9.08707 3.7847 8.57467 4.53113 8.27998C5.27756 7.98529 6.09537 7.92193 6.87828 8.09813C7.66119 8.27434 8.373 8.68196 8.92121 9.26802L13.1212 6.97802C12.8828 6.03409 12.9968 5.03561 13.4418 4.16972C13.8869 3.30384 14.6325 2.63 15.5389 2.27452C16.4452 1.91904 17.4501 1.90633 18.3652 2.23875C19.2803 2.57118 20.0427 3.22594 20.5095 4.08028C20.9764 4.93463 21.1156 5.92991 20.9011 6.87957C20.6866 7.82922 20.1332 8.66806 19.3444 9.23883C18.5557 9.8096 17.5859 10.0731 16.6168 9.98001C15.6477 9.8869 14.7458 9.44353 14.0802 8.73302L9.88021 11.023C10.0414 11.6644 10.0414 12.3357 9.88021 12.977L14.0792 15.267C14.7448 14.5565 15.6467 14.1131 16.6158 14.02C17.5849 13.9269 18.5547 14.1904 19.3434 14.7612C20.1322 15.332 20.6856 16.1708 20.9001 17.1205C21.1146 18.0701 20.9754 19.0654 20.5085 19.9198C20.0417 20.7741 19.2793 21.4289 18.3642 21.7613C17.4491 22.0937 16.4442 22.081 15.5379 21.7255C14.6315 21.37 13.8859 20.6962 13.4408 19.8303C12.9958 18.9644 12.8818 17.9659 13.1202 17.022V17.023ZM6.00021 14C6.53064 14 7.03935 13.7893 7.41442 13.4142C7.78949 13.0392 8.00021 12.5305 8.00021 12C8.00021 11.4696 7.78949 10.9609 7.41442 10.5858C7.03935 10.2107 6.53064 10 6.00021 10C5.46977 10 4.96107 10.2107 4.58599 10.5858C4.21092 10.9609 4.00021 11.4696 4.00021 12C4.00021 12.5305 4.21092 13.0392 4.58599 13.4142C4.96107 13.7893 5.46977 14 6.00021 14V14ZM17.0002 8.00002C17.5306 8.00002 18.0393 7.78931 18.4144 7.41423C18.7895 7.03916 19.0002 6.53045 19.0002 6.00002C19.0002 5.46959 18.7895 4.96088 18.4144 4.58581C18.0393 4.21073 17.5306 4.00002 17.0002 4.00002C16.4698 4.00002 15.9611 4.21073 15.586 4.58581C15.2109 4.96088 15.0002 5.46959 15.0002 6.00002C15.0002 6.53045 15.2109 7.03916 15.586 7.41423C15.9611 7.78931 16.4698 8.00002 17.0002 8.00002V8.00002ZM17.0002 20C17.5306 20 18.0393 19.7893 18.4144 19.4142C18.7895 19.0392 19.0002 18.5305 19.0002 18C19.0002 17.4696 18.7895 16.9609 18.4144 16.5858C18.0393 16.2107 17.5306 16 17.0002 16C16.4698 16 15.9611 16.2107 15.586 16.5858C15.2109 16.9609 15.0002 17.4696 15.0002 18C15.0002 18.5305 15.2109 19.0392 15.586 19.4142C15.9611 19.7893 16.4698 20 17.0002 20V20Z"
    ]
  },
  "side-nav-expand": {
    paths: [
      "M14.2861 16.1429L4.00042 16.1429L4.00042 15L14.2861 15L14.2861 16.1429ZM14.2861 12.1429L4.00042 12.1429L4.00042 11L14.2861 11L14.2861 12.1429ZM14.2861 8.14288L4.00042 8.14288L4.00042 7.00002L14.2861 7.00003L14.2861 8.14288Z",
      "M18.384 11.5715L16.7674 9.95546L17.5754 9.14689L20 11.5715L17.5754 13.996L16.7674 13.1875L18.384 11.5715Z"
    ]
  },
  "side-nav-collapse": {
    paths: [
      "M9.71387 7H19.9996V8.14286H9.71387V7ZM9.71387 11H19.9996V12.1429H9.71387V11ZM9.71387 15H19.9996V16.1429H9.71387V15Z",
      "M5.616 11.5714L7.23257 13.1874L6.42457 13.996L4 11.5714L6.42457 9.14685L7.23257 9.95542L5.616 11.5714Z"
    ]
  },
  "arrow-drop-left": {
    paths: [
      "M11.828 12L13.9499 14.1211C14.3404 14.5115 14.3405 15.1447 13.9502 15.5353V15.5353C13.5597 15.9261 12.9263 15.9263 12.5356 15.5356L9 12L12.5356 8.46436C12.9263 8.07374 13.5597 8.07393 13.9502 8.46469V8.46469C14.3405 8.8553 14.3404 9.48845 13.9499 9.87886L11.828 12Z"
    ]
  },
  "arrow-down": {
    paths: [
      "M13.0007 16.172L17.6577 11.515C18.0481 11.1245 18.6812 11.1245 19.0717 11.515V11.515C19.4621 11.9055 19.4621 12.5385 19.0717 12.929L12.0007 20L4.92966 12.929C4.53919 12.5385 4.53919 11.9055 4.92966 11.515V11.515C5.32012 11.1245 5.95319 11.1245 6.34366 11.515L11.0007 16.172V5C11.0007 4.44772 11.4484 4 12.0007 4V4C12.5529 4 13.0007 4.44772 13.0007 5V16.172Z"
    ]
  },
  dashboard: {
    paths: [
      "M13 21V11H21V21H13ZM3 13V3H11V13H3ZM9 11V5H5V11H9ZM3 21V15H11V21H3ZM5 19H9V17H5V19ZM15 19H19V13H15V19ZM13 3H21V9H13V3ZM15 5V7H19V5H15Z"
    ]
  },
  "arrow-down-s": {
    paths: [
      "M12.0007 13.172L16.2437 8.92899C16.6342 8.53852 17.2673 8.53852 17.6577 8.92898V8.92898C18.0482 9.31945 18.0482 9.95252 17.6577 10.343L12.0007 16L6.34372 10.343C5.95325 9.95252 5.95325 9.31945 6.34372 8.92898V8.92898C6.73418 8.53852 7.36725 8.53852 7.75772 8.92898L12.0007 13.172Z"
    ]
  },
  "star-s": {
    paths: [
      "M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17ZM12.0002 14.656L14.8172 16.376L14.0512 13.166L16.5582 11.019L13.2682 10.755L12.0002 7.708L10.7322 10.755L7.44223 11.019L9.94923 13.166L9.18323 16.376L12.0002 14.657V14.656Z"
    ]
  },
  "lock-2": {
    paths: [
      "M6 8V7C6 5.4087 6.63214 3.88258 7.75736 2.75736C8.88258 1.63214 10.4087 1 12 1C13.5913 1 15.1174 1.63214 16.2426 2.75736C17.3679 3.88258 18 5.4087 18 7V8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H6ZM19 10H5V20H19V10ZM11 15.732C10.6187 15.5119 10.3207 15.1721 10.1522 14.7653C9.98376 14.3586 9.9542 13.9076 10.0681 13.4823C10.1821 13.057 10.4332 12.6813 10.7825 12.4132C11.1318 12.1452 11.5597 11.9999 12 11.9999C12.4403 11.9999 12.8682 12.1452 13.2175 12.4132C13.5668 12.6813 13.8179 13.057 13.9319 13.4823C14.0458 13.9076 14.0162 14.3586 13.8478 14.7653C13.6793 15.1721 13.3813 15.5119 13 15.732V18H11V15.732ZM8 8H16V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7V8Z"
    ]
  },
  "arrow-right": {
    paths: [
      "M16.172 11L11.515 6.343C11.1245 5.95253 11.1245 5.31947 11.515 4.929V4.929C11.9055 4.53853 12.5385 4.53853 12.929 4.929L20 12L12.929 19.071C12.5385 19.4615 11.9055 19.4615 11.515 19.071V19.071C11.1245 18.6805 11.1245 18.0475 11.515 17.657L16.172 13H5C4.44772 13 4 12.5523 4 12V12C4 11.4477 4.44772 11 5 11H16.172Z"
    ]
  },
  search: {
    paths: [
      "M18.031 16.617L21.6067 20.1919C21.9973 20.5824 21.9971 21.2159 21.6065 21.6065V21.6065C21.2159 21.9971 20.5824 21.9973 20.1919 21.6067L16.617 18.031C15.0237 19.3082 13.042 20.0029 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20.0029 13.042 19.3082 15.0237 18.031 16.617ZM16.025 15.875C17.2941 14.5699 18.0029 12.8204 18 11C18 7.132 14.867 4 11 4C7.132 4 4 7.132 4 11C4 14.867 7.132 18 11 18C12.8204 18.0029 14.5699 17.2941 15.875 16.025L16.025 15.875Z"
    ]
  },
  more: {
    paths: [
      "M4.5 10.5C3.675 10.5 3 11.175 3 12C3 12.825 3.675 13.5 4.5 13.5C5.325 13.5 6 12.825 6 12C6 11.175 5.325 10.5 4.5 10.5ZM19.5 10.5C18.675 10.5 18 11.175 18 12C18 12.825 18.675 13.5 19.5 13.5C20.325 13.5 21 12.825 21 12C21 11.175 20.325 10.5 19.5 10.5ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
    ]
  },
  "lock-password": {
    paths: [
      "M18 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H6V7C6 5.4087 6.63214 3.88258 7.75736 2.75736C8.88258 1.63214 10.4087 1 12 1C13.5913 1 15.1174 1.63214 16.2426 2.75736C17.3679 3.88258 18 5.4087 18 7V8ZM5 10V20H19V10H5ZM11 14H13V16H11V14ZM7 14H9V16H7V14ZM15 14H17V16H15V14ZM16 8V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7V8H16Z"
    ]
  },
  download: {
    paths: [
      "M3 19H21V21H3V19ZM13 13.172L19.071 7.1L20.485 8.514L12 17L3.515 8.515L4.929 7.1L11 13.17V2H13V13.172Z"
    ]
  },
  star: {
    paths: [
      "M11.9999 18.26L4.94691 22.208L6.52191 14.28L0.586914 8.792L8.61391 7.84L11.9999 0.5L15.3859 7.84L23.4129 8.792L17.4779 14.28L19.0529 22.208L11.9999 18.26ZM11.9999 15.968L16.2469 18.345L15.2979 13.572L18.8709 10.267L14.0379 9.694L11.9999 5.275L9.96191 9.695L5.12891 10.267L8.70191 13.572L7.75291 18.345L11.9999 15.968V15.968Z"
    ]
  },
  "arrow-go-forward": {
    paths: [
      "M18.172 7H11C9.4087 7 7.88258 7.63214 6.75736 8.75736C5.63214 9.88258 5 11.4087 5 13C5 14.5913 5.63214 16.1174 6.75736 17.2426C7.88258 18.3679 9.4087 19 11 19H19C19.5523 19 20 19.4477 20 20V20C20 20.5523 19.5523 21 19 21H11C8.87827 21 6.84344 20.1571 5.34315 18.6569C3.84285 17.1566 3 15.1217 3 13C3 10.8783 3.84285 8.84344 5.34315 7.34315C6.84344 5.84285 8.87827 5 11 5H18.172L16.343 3.171C15.9525 2.78053 15.9525 2.14746 16.343 1.757V1.757C16.7335 1.36653 17.3665 1.36653 17.757 1.757L22 6L17.757 10.243C17.3665 10.6335 16.7335 10.6335 16.343 10.243V10.243C15.9525 9.85253 15.9525 9.21946 16.343 8.829L18.172 7Z"
    ]
  },
  eye: {
    paths: [
      "M12.0006 3C17.3926 3 21.8786 6.88 22.8196 12C21.8796 17.12 17.3926 21 12.0006 21C6.60864 21 2.12264 17.12 1.18164 12C2.12164 6.88 6.60864 3 12.0006 3ZM12.0006 19C14.0401 18.9996 16.019 18.3068 17.6135 17.0352C19.208 15.7635 20.3235 13.9883 20.7776 12C20.3219 10.0133 19.2056 8.24 17.6113 6.97003C16.017 5.70005 14.0389 5.00853 12.0006 5.00853C9.96234 5.00853 7.98433 5.70005 6.39002 6.97003C4.7957 8.24 3.67941 10.0133 3.22364 12C3.67774 13.9883 4.79331 15.7635 6.38778 17.0352C7.98226 18.3068 9.96117 18.9996 12.0006 19V19ZM12.0006 16.5C10.8072 16.5 9.66257 16.0259 8.81866 15.182C7.97475 14.3381 7.50064 13.1935 7.50064 12C7.50064 10.8065 7.97475 9.66193 8.81866 8.81802C9.66257 7.97411 10.8072 7.5 12.0006 7.5C13.1941 7.5 14.3387 7.97411 15.1826 8.81802C16.0265 9.66193 16.5006 10.8065 16.5006 12C16.5006 13.1935 16.0265 14.3381 15.1826 15.182C14.3387 16.0259 13.1941 16.5 12.0006 16.5ZM12.0006 14.5C12.6637 14.5 13.2996 14.2366 13.7684 13.7678C14.2372 13.2989 14.5006 12.663 14.5006 12C14.5006 11.337 14.2372 10.7011 13.7684 10.2322C13.2996 9.76339 12.6637 9.5 12.0006 9.5C11.3376 9.5 10.7017 9.76339 10.2329 10.2322C9.76403 10.7011 9.50064 11.337 9.50064 12C9.50064 12.663 9.76403 13.2989 10.2329 13.7678C10.7017 14.2366 11.3376 14.5 12.0006 14.5Z"
    ]
  },
  "thumb-up": {
    paths: [
      "M14.6 8H21C21.5304 8 22.0391 8.21071 22.4142 8.58578C22.7893 8.96085 23 9.46956 23 10V12.104C23.0003 12.3654 22.9493 12.6242 22.85 12.866L19.755 20.381C19.6795 20.5642 19.5513 20.7209 19.3866 20.8311C19.2219 20.9413 19.0282 21.0001 18.83 21H2C1.73478 21 1.48043 20.8946 1.29289 20.7071C1.10536 20.5196 1 20.2652 1 20V10C1 9.73478 1.10536 9.48043 1.29289 9.29289C1.48043 9.10535 1.73478 9 2 9H5.482C5.6421 9.00004 5.79986 8.96164 5.94203 8.88803C6.0842 8.81442 6.20662 8.70775 6.299 8.57699L11.752 0.849995C11.8209 0.752308 11.9226 0.682556 12.0385 0.653386C12.1545 0.624215 12.277 0.637558 12.384 0.690995L14.198 1.598C14.7085 1.85316 15.1163 2.27531 15.3537 2.79431C15.5911 3.31331 15.6438 3.89792 15.503 4.451L14.6 8ZM7 10.588V19H18.16L21 12.104V10H14.6C14.2954 9.99995 13.9948 9.93033 13.7212 9.79645C13.4476 9.66257 13.2082 9.46797 13.0213 9.22748C12.8343 8.987 12.7048 8.70699 12.6425 8.40882C12.5803 8.11065 12.5869 7.8022 12.662 7.507L13.565 3.959C13.5933 3.84832 13.5828 3.73131 13.5353 3.62742C13.4878 3.52354 13.4062 3.43904 13.304 3.388L12.643 3.058L7.933 9.72999C7.683 10.084 7.363 10.374 7 10.588V10.588ZM5 11H3V19H5V11Z"
    ]
  },
  function: {
    paths: [
      "M3 3H11V11H3V3ZM3 13H11V21H3V13ZM13 3H21V11H13V3ZM13 13H21V21H13V13ZM15 5V9H19V5H15ZM15 15V19H19V15H15ZM5 5V9H9V5H5ZM5 15V19H9V15H5Z"
    ]
  },
  "arrow-drop-right": {
    paths: [
      "M12.1718 12L10.0499 9.87885C9.65934 9.48844 9.65925 8.85529 10.0496 8.46468V8.46468C10.4401 8.07392 11.0735 8.07372 11.4641 8.46435L14.9998 12L11.4641 15.5356C11.0735 15.9263 10.4401 15.9261 10.0496 15.5353V15.5353C9.65925 15.1447 9.65934 14.5115 10.0499 14.1211L12.1718 12Z"
    ]
  },
  "eye-off": {
    paths: [
      "M17.8826 19.297C16.1239 20.4126 14.0834 21.0033 12.0006 21C6.60864 21 2.12264 17.12 1.18164 12C1.61167 9.67072 2.78327 7.5429 4.52164 5.93401L1.39264 2.80801L2.80764 1.39301L22.6066 21.193L21.1916 22.607L17.8816 19.297H17.8826ZM5.93564 7.35001C4.57665 8.5856 3.62996 10.2088 3.22364 12C3.53593 13.3665 4.1629 14.6411 5.05464 15.7226C5.94638 16.804 7.07827 17.6624 8.36019 18.2293C9.64212 18.7962 11.0387 19.0561 12.4387 18.9881C13.8388 18.9202 15.2036 18.5264 16.4246 17.838L14.3966 15.81C13.5333 16.3538 12.5108 16.5881 11.4969 16.4744C10.4829 16.3608 9.53768 15.9059 8.81621 15.1844C8.09474 14.463 7.63987 13.5177 7.5262 12.5038C7.41254 11.4898 7.64682 10.4673 8.19064 9.60401L5.93564 7.35001ZM12.9146 14.328L9.67264 11.086C9.49471 11.5389 9.45283 12.034 9.55215 12.5104C9.65146 12.9867 9.88766 13.4238 10.2318 13.7679C10.5759 14.112 11.0129 14.3482 11.4893 14.4475C11.9657 14.5468 12.4607 14.5049 12.9136 14.327L12.9146 14.328ZM20.8076 16.592L19.3766 15.162C20.0451 14.2093 20.521 13.1352 20.7776 12C20.5059 10.8097 19.9949 9.68715 19.2758 8.7005C18.5567 7.71385 17.6444 6.88373 16.5945 6.26061C15.5446 5.63749 14.3789 5.23437 13.1684 5.07577C11.9578 4.91717 10.7276 5.00638 9.55264 5.33801L7.97464 3.76001C9.22164 3.27001 10.5806 3.00001 12.0006 3.00001C17.3926 3.00001 21.8786 6.88001 22.8196 12C22.5132 13.6657 21.8245 15.2376 20.8076 16.592V16.592ZM11.7236 7.50801C12.3602 7.46867 12.9978 7.56507 13.5942 7.79082C14.1906 8.01657 14.7323 8.36652 15.1832 8.81746C15.6341 9.2684 15.9841 9.81003 16.2098 10.4065C16.4356 11.0029 16.532 11.6405 16.4926 12.277L11.7226 7.50801H11.7236Z"
    ]
  },
  "arrow-right-s": {
    paths: [
      "M13.1727 12L8.92966 7.75699C8.53919 7.36652 8.53919 6.73345 8.92966 6.34299V6.34299C9.32012 5.95252 9.95319 5.95252 10.3437 6.34299L16.0007 12L10.3437 17.657C9.95319 18.0475 9.32012 18.0475 8.92966 17.657V17.657C8.53919 17.2665 8.53919 16.6335 8.92966 16.243L13.1727 12Z"
    ]
  },
  "arrow-go-back": {
    paths: [
      "M5.828 7L7.657 8.829C8.04747 9.21946 8.04747 9.85253 7.657 10.243V10.243C7.26653 10.6335 6.63347 10.6335 6.243 10.243L2 6L6.243 1.757C6.63346 1.36653 7.26653 1.36653 7.657 1.757V1.757C8.04747 2.14746 8.04747 2.78053 7.657 3.171L5.828 5H13C15.1217 5 17.1566 5.84285 18.6569 7.34315C20.1571 8.84344 21 10.8783 21 13C21 15.1217 20.1571 17.1566 18.6569 18.6569C17.1566 20.1571 15.1217 21 13 21H5C4.44772 21 4 20.5523 4 20V20C4 19.4477 4.44772 19 5 19H13C14.5913 19 16.1174 18.3679 17.2426 17.2426C18.3679 16.1174 19 14.5913 19 13C19 11.4087 18.3679 9.88258 17.2426 8.75736C16.1174 7.63214 14.5913 7 13 7H5.828Z"
    ]
  },
  check: {
    paths: [
      "M10.0007 15.172L18.4859 6.68594C18.8763 6.29547 19.5094 6.29547 19.9 6.68577V6.68577C20.2907 7.07626 20.291 7.70974 19.9004 8.10036L10.7078 17.2929C10.3173 17.6834 9.68414 17.6834 9.29361 17.2929L4.34372 12.343C3.95325 11.9525 3.95325 11.3195 4.34372 10.929V10.929C4.73418 10.5385 5.36725 10.5385 5.75772 10.929L10.0007 15.172Z"
    ]
  },
  "check-circle": {
    paths: [
      "M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18Z",
      "M7.66667 14.6167L4 10.95L5.28333 9.66667L7.66667 12.05L13.7167 6L15 7.28333L7.66667 14.6167Z"
    ]
  },
  "share-box": {
    paths: [
      "M10 3V5H5V19H19V14H21V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H10ZM17.586 5H13V3H21V11H19V6.414L12 13.414L10.586 12L17.586 5Z"
    ]
  },
  menu: {
    paths: ["M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"]
  },
  "notification-4": {
    paths: [
      "M18 10C18 8.4087 17.3679 6.88258 16.2426 5.75736C15.1174 4.63214 13.5913 4 12 4C10.4087 4 8.88258 4.63214 7.75736 5.75736C6.63214 6.88258 6 8.4087 6 10V18H18V10ZM20 18.667L20.4 19.2C20.4557 19.2743 20.4896 19.3626 20.498 19.4551C20.5063 19.5476 20.4887 19.6406 20.4472 19.7236C20.4057 19.8067 20.3419 19.8765 20.2629 19.9253C20.1839 19.9741 20.0929 20 20 20H4C3.90714 20 3.81612 19.9741 3.73713 19.9253C3.65815 19.8765 3.59431 19.8067 3.55279 19.7236C3.51126 19.6406 3.49368 19.5476 3.50202 19.4551C3.51036 19.3626 3.54429 19.2743 3.6 19.2L4 18.667V10C4 7.87827 4.84286 5.84344 6.34315 4.34315C7.84344 2.84285 9.87827 2 12 2C14.1217 2 16.1566 2.84285 17.6569 4.34315C19.1571 5.84344 20 7.87827 20 10V18.667ZM9.5 21H14.5C14.5 21.663 14.2366 22.2989 13.7678 22.7678C13.2989 23.2366 12.663 23.5 12 23.5C11.337 23.5 10.7011 23.2366 10.2322 22.7678C9.76339 22.2989 9.5 21.663 9.5 21V21Z"
    ]
  },
  "logo-google-drive": {
    paths: [
      "M29.5004 21L26.3296 26.5489C26.0476 27.0036 25.6517 27.3768 25.181 27.6313C24.7103 27.8859 24.1813 28.0129 23.6463 28H8.35454C7.81961 28.0129 7.29058 27.8859 6.8199 27.6313C6.34923 27.3768 5.95325 27.0036 5.67124 26.5489L4.36914 24.27L9.75824 21H29.5004Z",
      "M12.3828 4.13C11.6626 4.38843 11.0577 4.89441 10.6761 5.5576L2.95974 18.76C2.67862 19.2153 2.52139 19.7362 2.50364 20.271C2.48589 20.8058 2.60823 21.336 2.85854 21.8089L4.38854 24.2747L9.75854 21L16.0006 10.32L12.3828 4.13Z",
      "M9.75816 21H2.56836C2.62045 21.2836 2.7184 21.5568 2.85836 21.8089L4.38036 24.2632L4.36886 24.2702L5.67126 26.549C5.98317 27.0645 6.45165 27.4669 7.00836 27.6974L9.75816 21L9.75006 21.0049L9.75816 21Z",
      "M19.6062 4.13C20.3264 4.3884 20.9312 4.89439 21.3128 5.5576L29.0294 18.76C29.3105 19.2153 29.4678 19.7362 29.4855 20.271C29.5033 20.8058 29.381 21.336 29.1307 21.8089L27.6012 24.2747L22.2305 21L15.9883 10.32L19.6062 4.13Z",
      "M22.2305 21H29.4205C29.3684 21.2836 29.2704 21.5568 29.1305 21.8089L27.6081 24.2633L27.6197 24.2703L26.3175 26.549C26.0055 27.0645 25.5371 27.4669 24.9804 27.6974L22.2306 21L22.2387 21.0049L22.2305 21Z",
      "M19.6159 4.1342L19.6182 4.1302C19.5003 4.08935 19.3797 4.05651 19.2573 4.0319L16.0004 4L12.7435 4.0319C12.6211 4.05651 12.5006 4.08935 12.3826 4.1302C12.2567 4.17751 12.1341 4.23316 12.0156 4.2968L15.9893 10.32L19.9774 4.2993C19.8607 4.23642 19.7399 4.18126 19.6159 4.1342Z"
    ]
  },
  "emotion-happy": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM7 13H9C9 13.7956 9.31607 14.5587 9.87868 15.1213C10.4413 15.6839 11.2044 16 12 16C12.7956 16 13.5587 15.6839 14.1213 15.1213C14.6839 14.5587 15 13.7956 15 13H17C17 14.3261 16.4732 15.5979 15.5355 16.5355C14.5979 17.4732 13.3261 18 12 18C10.6739 18 9.40215 17.4732 8.46447 16.5355C7.52678 15.5979 7 14.3261 7 13V13ZM8 11C7.60218 11 7.22064 10.842 6.93934 10.5607C6.65804 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10218 6.65804 8.72064 6.93934 8.43934C7.22064 8.15804 7.60218 8 8 8C8.39782 8 8.77936 8.15804 9.06066 8.43934C9.34196 8.72064 9.5 9.10218 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77936 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10218 14.658 8.72064 14.9393 8.43934C15.2206 8.15804 15.6022 8 16 8C16.3978 8 16.7794 8.15804 17.0607 8.43934C17.342 8.72064 17.5 9.10218 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z"
    ]
  },
  "user-add": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 17V14H20V17H23V19H20V22H18V19H15V17H18Z"
    ]
  },
  "emotion-normal": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM8 14H16V16H8V14ZM8 11C7.60218 11 7.22064 10.842 6.93934 10.5607C6.65804 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10218 6.65804 8.72064 6.93934 8.43934C7.22064 8.15804 7.60218 8 8 8C8.39782 8 8.77936 8.15804 9.06066 8.43934C9.34196 8.72064 9.5 9.10218 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77936 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10218 14.658 8.72064 14.9393 8.43934C15.2206 8.15804 15.6022 8 16 8C16.3978 8 16.7794 8.15804 17.0607 8.43934C17.342 8.72064 17.5 9.10218 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z"
    ]
  },
  "user-search": {
    paths: [
      "M12 14V16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14V14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM21.446 20.032L22.95 21.536L21.536 22.95L20.032 21.446C19.1933 21.9405 18.2031 22.1121 17.247 21.9288C16.2908 21.7454 15.4343 21.2196 14.8381 20.4499C14.2419 19.6802 13.9469 18.7195 14.0083 17.7479C14.0698 16.7762 14.4835 15.8604 15.1719 15.1719C15.8604 14.4835 16.7762 14.0698 17.7479 14.0083C18.7195 13.9469 19.6802 14.2419 20.4499 14.8381C21.2196 15.4343 21.7454 16.2908 21.9288 17.247C22.1121 18.2031 21.9405 19.1933 21.446 20.032V20.032ZM18 20C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18C20 17.4696 19.7893 16.9609 19.4142 16.5858C19.0391 16.2107 18.5304 16 18 16C17.4696 16 16.9609 16.2107 16.5858 16.5858C16.2107 16.9609 16 17.4696 16 18C16 18.5304 16.2107 19.0391 16.5858 19.4142C16.9609 19.7893 17.4696 20 18 20V20Z"
    ]
  },
  "user-shared": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18.586 17L16.757 15.172L18.172 13.757L22.414 18L18.172 22.243L16.757 20.828L18.586 19H15V17H18.586Z"
    ]
  },
  user: {
    paths: [
      "M4 22C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14C14.1217 14 16.1566 14.8429 17.6569 16.3431C19.1571 17.8434 20 19.8783 20 22H18C18 20.4087 17.3679 18.8826 16.2426 17.7574C15.1174 16.6321 13.5913 16 12 16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"
    ]
  },
  parent: {
    paths: [
      "M7 9C7.66304 9 8.29893 8.73661 8.76777 8.26777C9.23661 7.79893 9.5 7.16304 9.5 6.5C9.5 5.83696 9.23661 5.20107 8.76777 4.73223C8.29893 4.26339 7.66304 4 7 4C6.33696 4 5.70107 4.26339 5.23223 4.73223C4.76339 5.20107 4.5 5.83696 4.5 6.5C4.5 7.16304 4.76339 7.79893 5.23223 8.26777C5.70107 8.73661 6.33696 9 7 9ZM7 11C6.40905 11 5.82389 10.8836 5.27792 10.6575C4.73196 10.4313 4.23588 10.0998 3.81802 9.68198C3.40016 9.26412 3.06869 8.76804 2.84254 8.22208C2.6164 7.67611 2.5 7.09095 2.5 6.5C2.5 5.90905 2.6164 5.32389 2.84254 4.77792C3.06869 4.23196 3.40016 3.73588 3.81802 3.31802C4.23588 2.90016 4.73196 2.56869 5.27792 2.34254C5.82389 2.1164 6.40905 2 7 2C8.19347 2 9.33807 2.47411 10.182 3.31802C11.0259 4.16193 11.5 5.30653 11.5 6.5C11.5 7.69347 11.0259 8.83807 10.182 9.68198C9.33807 10.5259 8.19347 11 7 11V11ZM17.5 13C18.0304 13 18.5391 12.7893 18.9142 12.4142C19.2893 12.0391 19.5 11.5304 19.5 11C19.5 10.4696 19.2893 9.96086 18.9142 9.58579C18.5391 9.21071 18.0304 9 17.5 9C16.9696 9 16.4609 9.21071 16.0858 9.58579C15.7107 9.96086 15.5 10.4696 15.5 11C15.5 11.5304 15.7107 12.0391 16.0858 12.4142C16.4609 12.7893 16.9696 13 17.5 13V13ZM17.5 15C16.4391 15 15.4217 14.5786 14.6716 13.8284C13.9214 13.0783 13.5 12.0609 13.5 11C13.5 9.93913 13.9214 8.92172 14.6716 8.17157C15.4217 7.42143 16.4391 7 17.5 7C18.5609 7 19.5783 7.42143 20.3284 8.17157C21.0786 8.92172 21.5 9.93913 21.5 11C21.5 12.0609 21.0786 13.0783 20.3284 13.8284C19.5783 14.5786 18.5609 15 17.5 15ZM20 21V20.5C20 19.837 19.7366 19.2011 19.2678 18.7322C18.7989 18.2634 18.163 18 17.5 18C16.837 18 16.2011 18.2634 15.7322 18.7322C15.2634 19.2011 15 19.837 15 20.5V21H13V20.5C13 19.9091 13.1164 19.3239 13.3425 18.7779C13.5687 18.232 13.9002 17.7359 14.318 17.318C14.7359 16.9002 15.232 16.5687 15.7779 16.3425C16.3239 16.1164 16.9091 16 17.5 16C18.0909 16 18.6761 16.1164 19.2221 16.3425C19.768 16.5687 20.2641 16.9002 20.682 17.318C21.0998 17.7359 21.4313 18.232 21.6575 18.7779C21.8836 19.3239 22 19.9091 22 20.5V21H20ZM10 21V17C10 16.2044 9.68393 15.4413 9.12132 14.8787C8.55871 14.3161 7.79565 14 7 14C6.20435 14 5.44129 14.3161 4.87868 14.8787C4.31607 15.4413 4 16.2044 4 17V21H2V17C2 15.6739 2.52678 14.4021 3.46447 13.4645C4.40215 12.5268 5.67392 12 7 12C8.32608 12 9.59785 12.5268 10.5355 13.4645C11.4732 14.4021 12 15.6739 12 17V21H10Z"
    ]
  },
  team: {
    paths: [
      "M12 11C13.3261 11 14.5979 11.5268 15.5355 12.4645C16.4732 13.4021 17 14.6739 17 16V22H15V16C15 15.2348 14.7077 14.4985 14.1827 13.9417C13.6578 13.385 12.9399 13.0499 12.176 13.005L12 13C11.2348 13 10.4985 13.2923 9.94174 13.8173C9.38499 14.3422 9.04989 15.0601 9.005 15.824L9 16V22H7V16C7 14.6739 7.52678 13.4021 8.46447 12.4645C9.40215 11.5268 10.6739 11 12 11ZM5.5 14C5.779 14 6.05 14.033 6.31 14.094C6.13902 14.603 6.03777 15.1328 6.009 15.669L6 16V16.086C5.88505 16.0449 5.76549 16.018 5.644 16.006L5.5 16C5.12712 16 4.76761 16.1389 4.49158 16.3896C4.21555 16.6403 4.0428 16.9848 4.007 17.356L4 17.5V22H2V17.5C2 16.5717 2.36875 15.6815 3.02513 15.0251C3.6815 14.3687 4.57174 14 5.5 14V14ZM18.5 14C19.4283 14 20.3185 14.3687 20.9749 15.0251C21.6313 15.6815 22 16.5717 22 17.5V22H20V17.5C20 17.1271 19.8611 16.7676 19.6104 16.4916C19.3597 16.2156 19.0152 16.0428 18.644 16.007L18.5 16C18.325 16 18.157 16.03 18 16.085V16C18 15.334 17.892 14.694 17.691 14.096C17.95 14.033 18.221 14 18.5 14ZM5.5 8C6.16304 8 6.79893 8.26339 7.26777 8.73223C7.73661 9.20107 8 9.83696 8 10.5C8 11.163 7.73661 11.7989 7.26777 12.2678C6.79893 12.7366 6.16304 13 5.5 13C4.83696 13 4.20107 12.7366 3.73223 12.2678C3.26339 11.7989 3 11.163 3 10.5C3 9.83696 3.26339 9.20107 3.73223 8.73223C4.20107 8.26339 4.83696 8 5.5 8V8ZM18.5 8C19.163 8 19.7989 8.26339 20.2678 8.73223C20.7366 9.20107 21 9.83696 21 10.5C21 11.163 20.7366 11.7989 20.2678 12.2678C19.7989 12.7366 19.163 13 18.5 13C17.837 13 17.2011 12.7366 16.7322 12.2678C16.2634 11.7989 16 11.163 16 10.5C16 9.83696 16.2634 9.20107 16.7322 8.73223C17.2011 8.26339 17.837 8 18.5 8V8ZM5.5 10C5.36739 10 5.24021 10.0527 5.14645 10.1464C5.05268 10.2402 5 10.3674 5 10.5C5 10.6326 5.05268 10.7598 5.14645 10.8536C5.24021 10.9473 5.36739 11 5.5 11C5.63261 11 5.75979 10.9473 5.85355 10.8536C5.94732 10.7598 6 10.6326 6 10.5C6 10.3674 5.94732 10.2402 5.85355 10.1464C5.75979 10.0527 5.63261 10 5.5 10ZM18.5 10C18.3674 10 18.2402 10.0527 18.1464 10.1464C18.0527 10.2402 18 10.3674 18 10.5C18 10.6326 18.0527 10.7598 18.1464 10.8536C18.2402 10.9473 18.3674 11 18.5 11C18.6326 11 18.7598 10.9473 18.8536 10.8536C18.9473 10.7598 19 10.6326 19 10.5C19 10.3674 18.9473 10.2402 18.8536 10.1464C18.7598 10.0527 18.6326 10 18.5 10ZM12 2C13.0609 2 14.0783 2.42143 14.8284 3.17157C15.5786 3.92172 16 4.93913 16 6C16 7.06087 15.5786 8.07828 14.8284 8.82843C14.0783 9.57857 13.0609 10 12 10C10.9391 10 9.92172 9.57857 9.17157 8.82843C8.42143 8.07828 8 7.06087 8 6C8 4.93913 8.42143 3.92172 9.17157 3.17157C9.92172 2.42143 10.9391 2 12 2V2ZM12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6C10 6.53043 10.2107 7.03914 10.5858 7.41421C10.9609 7.78929 11.4696 8 12 8C12.5304 8 13.0391 7.78929 13.4142 7.41421C13.7893 7.03914 14 6.53043 14 6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4V4Z"
    ]
  },
  "user-follow": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM17.793 19.914L21.328 16.379L22.743 17.793L17.793 22.743L14.257 19.207L15.672 17.793L17.792 19.914H17.793Z"
    ]
  },
  "user-received": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM19.418 17H23.004V19H19.418L21.247 20.828L19.833 22.243L15.59 18L19.833 13.757L21.247 15.172L19.418 17Z"
    ]
  },
  admin: {
    paths: [
      "M12 14V16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14V14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM21 17H22V22H14V17H15V16C15 15.2044 15.3161 14.4413 15.8787 13.8787C16.4413 13.3161 17.2044 13 18 13C18.7956 13 19.5587 13.3161 20.1213 13.8787C20.6839 14.4413 21 15.2044 21 16V17ZM19 17V16C19 15.7348 18.8946 15.4804 18.7071 15.2929C18.5196 15.1054 18.2652 15 18 15C17.7348 15 17.4804 15.1054 17.2929 15.2929C17.1054 15.4804 17 15.7348 17 16V17H19Z"
    ]
  },
  "user-heart": {
    paths: [
      "M17.841 15.659L18.017 15.836L18.195 15.659C18.4039 15.4501 18.652 15.2843 18.925 15.1713C19.1979 15.0582 19.4905 15 19.786 15C20.0815 15 20.3741 15.0582 20.647 15.1713C20.92 15.2843 21.1681 15.4501 21.377 15.659C21.5859 15.8679 21.7517 16.116 21.8647 16.389C21.9778 16.6619 22.036 16.9545 22.036 17.25C22.036 17.5455 21.9778 17.8381 21.8647 18.111C21.7517 18.384 21.5859 18.6321 21.377 18.841L18.017 22.2L14.659 18.841C14.237 18.419 14 17.8467 14 17.25C14 16.6533 14.237 16.081 14.659 15.659C15.081 15.237 15.6533 15 16.25 15C16.8467 15 17.419 15.237 17.841 15.659V15.659ZM12 14V16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4C4.00002 19.9216 4.80894 17.9247 6.25547 16.4323C7.702 14.9398 9.67259 14.069 11.75 14.004L12 14ZM12 1C15.315 1 18 3.685 18 7C18.0006 8.55253 17.3991 10.0448 16.3221 11.163C15.2451 12.2812 13.7765 12.9383 12.225 12.996L12 13C8.685 13 6 10.315 6 7C5.99944 5.44747 6.6009 3.95521 7.67791 2.83699C8.75491 1.71877 10.2235 1.06172 11.775 1.004L12 1ZM12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3Z"
    ]
  },
  "user-unfollow": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM19 17.586L21.121 15.464L22.536 16.879L20.414 19L22.536 21.121L21.121 22.536L19 20.414L16.879 22.536L15.464 21.121L17.586 19L15.464 16.879L16.879 15.464L19 17.586Z"
    ]
  },
  "emotion-unhappy": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM7 17C7 15.6739 7.52678 14.4021 8.46447 13.4645C9.40215 12.5268 10.6739 12 12 12C13.3261 12 14.5979 12.5268 15.5355 13.4645C16.4732 14.4021 17 15.6739 17 17H15C15 16.2044 14.6839 15.4413 14.1213 14.8787C13.5587 14.3161 12.7956 14 12 14C11.2044 14 10.4413 14.3161 9.87868 14.8787C9.31607 15.4413 9 16.2044 9 17H7ZM8 11C7.60218 11 7.22064 10.842 6.93934 10.5607C6.65804 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10218 6.65804 8.72064 6.93934 8.43934C7.22064 8.15804 7.60218 8 8 8C8.39782 8 8.77936 8.15804 9.06066 8.43934C9.34196 8.72064 9.5 9.10218 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77936 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10218 14.658 8.72064 14.9393 8.43934C15.2206 8.15804 15.6022 8 16 8C16.3978 8 16.7794 8.15804 17.0607 8.43934C17.342 8.72064 17.5 9.10218 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z"
    ]
  },
  "user-voice": {
    paths: [
      "M1 22C1 19.8783 1.84285 17.8434 3.34315 16.3431C4.84344 14.8429 6.87827 14 9 14C11.1217 14 13.1566 14.8429 14.6569 16.3431C16.1571 17.8434 17 19.8783 17 22H15C15 20.4087 14.3679 18.8826 13.2426 17.7574C12.1174 16.6321 10.5913 16 9 16C7.4087 16 5.88258 16.6321 4.75736 17.7574C3.63214 18.8826 3 20.4087 3 22H1ZM9 13C5.685 13 3 10.315 3 7C3 3.685 5.685 1 9 1C12.315 1 15 3.685 15 7C15 10.315 12.315 13 9 13ZM9 11C11.21 11 13 9.21 13 7C13 4.79 11.21 3 9 3C6.79 3 5 4.79 5 7C5 9.21 6.79 11 9 11ZM21.548 0.784C22.5062 2.71583 23.0032 4.84359 23 7C23 9.233 22.477 11.344 21.548 13.216L19.903 12.02C20.6282 10.446 21.0025 8.73307 21 7C21 5.208 20.607 3.507 19.903 1.98L21.548 0.784ZM18.246 3.184C18.7454 4.39416 19.0016 5.69083 19 7C19.0016 8.30917 18.7454 9.60584 18.246 10.816L16.569 9.596C16.8552 8.76044 17.0008 7.88321 17 7C17.0011 6.11685 16.8558 5.23962 16.57 4.404L18.246 3.184Z"
    ]
  },
  "camera-off": {
    paths: [
      "M19.5856 21H2.99958C2.73436 21 2.48001 20.8946 2.29247 20.7071C2.10493 20.5196 1.99958 20.2652 1.99958 20V6.00001C1.99958 5.73479 2.10493 5.48044 2.29247 5.2929C2.48001 5.10536 2.73436 5.00001 2.99958 5.00001H3.58558L1.39258 2.80801L2.80758 1.39301L22.6066 21.193L21.1916 22.607L19.5856 21ZM5.58558 7.00001H3.99958V19H17.5856L15.4056 16.82C14.3481 17.6569 13.0201 18.0762 11.6738 17.9981C10.3275 17.92 9.05677 17.35 8.10319 16.3964C7.14961 15.4428 6.57961 14.1721 6.50151 12.8258C6.42341 11.4795 6.84266 10.1515 7.67958 9.09401L5.58558 7.00001V7.00001ZM9.10958 10.525C8.64856 11.1988 8.43757 12.0125 8.5131 12.8253C8.58863 13.6382 8.94595 14.3991 9.52321 14.9764C10.1005 15.5536 10.8614 15.9109 11.6743 15.9865C12.4871 16.062 13.3008 15.851 13.9746 15.39L9.10958 10.525ZM21.9996 17.785L19.9996 15.785V7.00001H16.1716L14.1716 5.00001H9.82758L9.52058 5.30701L8.10658 3.89301L8.99958 3.00001H14.9996L16.9996 5.00001H20.9996C21.2648 5.00001 21.5191 5.10536 21.7067 5.2929C21.8942 5.48044 21.9996 5.73479 21.9996 6.00001V17.786V17.785ZM11.2626 7.05001C12.1019 6.9364 12.9562 7.01819 13.7587 7.28899C14.5613 7.55979 15.2904 8.0123 15.8894 8.61122C16.4883 9.21014 16.9408 9.9393 17.2116 10.7419C17.4824 11.5444 17.5642 12.3987 17.4506 13.238L15.1126 10.9C14.7778 10.2512 14.2494 9.72276 13.6006 9.388L11.2626 7.05001V7.05001Z"
    ]
  },
  "image-add": {
    paths: [
      "M21 15V18H24V20H21V23H19V20H16V18H19V15H21ZM21.008 3C21.556 3 22 3.445 22 3.993V13H20V5H4V18.999L14 9L17 12V14.829L14 11.829L6.827 19H14V21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448 20.5226 2 20.2702 2 20.007V3.993C2.00183 3.73038 2.1069 3.47902 2.29251 3.29322C2.47813 3.10742 2.72938 3.00209 2.992 3H21.008ZM8 7C8.53043 7 9.03914 7.21071 9.41421 7.58579C9.78929 7.96086 10 8.46957 10 9C10 9.53043 9.78929 10.0391 9.41421 10.4142C9.03914 10.7893 8.53043 11 8 11C7.46957 11 6.96086 10.7893 6.58579 10.4142C6.21071 10.0391 6 9.53043 6 9C6 8.46957 6.21071 7.96086 6.58579 7.58579C6.96086 7.21071 7.46957 7 8 7V7Z"
    ]
  },
  camera: {
    paths: [
      "M9.828 5L7.828 7H4V19H20V7H16.172L14.172 5H9.828ZM9 3H15L17 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V6C2 5.73478 2.10536 5.48043 2.29289 5.29289C2.48043 5.10536 2.73478 5 3 5H7L9 3ZM12 18C10.5413 18 9.14236 17.4205 8.11091 16.3891C7.07946 15.3576 6.5 13.9587 6.5 12.5C6.5 11.0413 7.07946 9.64236 8.11091 8.61091C9.14236 7.57946 10.5413 7 12 7C13.4587 7 14.8576 7.57946 15.8891 8.61091C16.9205 9.64236 17.5 11.0413 17.5 12.5C17.5 13.9587 16.9205 15.3576 15.8891 16.3891C14.8576 17.4205 13.4587 18 12 18ZM12 16C12.9283 16 13.8185 15.6313 14.4749 14.9749C15.1313 14.3185 15.5 13.4283 15.5 12.5C15.5 11.5717 15.1313 10.6815 14.4749 10.0251C13.8185 9.36875 12.9283 9 12 9C11.0717 9 10.1815 9.36875 9.52513 10.0251C8.86875 10.6815 8.5 11.5717 8.5 12.5C8.5 13.4283 8.86875 14.3185 9.52513 14.9749C10.1815 15.6313 11.0717 16 12 16V16Z"
    ]
  },
  image: {
    paths: [
      "M4.828 21L4.808 21.02L4.787 21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448 20.5226 2 20.2702 2 20.007V3.993C2.00183 3.73038 2.1069 3.47902 2.29251 3.29322C2.47813 3.10742 2.72938 3.00209 2.992 3H21.008C21.556 3 22 3.445 22 3.993V20.007C21.9982 20.2696 21.8931 20.521 21.7075 20.7068C21.5219 20.8926 21.2706 20.9979 21.008 21H4.828V21ZM20 15V5H4V19L14 9L20 15ZM20 17.828L14 11.828L6.828 19H20V17.828ZM8 11C7.46957 11 6.96086 10.7893 6.58579 10.4142C6.21071 10.0391 6 9.53043 6 9C6 8.46957 6.21071 7.96086 6.58579 7.58579C6.96086 7.21071 7.46957 7 8 7C8.53043 7 9.03914 7.21071 9.41421 7.58579C9.78929 7.96086 10 8.46957 10 9C10 9.53043 9.78929 10.0391 9.41421 10.4142C9.03914 10.7893 8.53043 11 8 11Z"
    ]
  },
  equalizer: {
    paths: [
      "M6.17 18C6.3766 17.4145 6.75974 16.9074 7.2666 16.5488C7.77346 16.1901 8.37909 15.9976 9 15.9976C9.62091 15.9976 10.2265 16.1901 10.7334 16.5488C11.2403 16.9074 11.6234 17.4145 11.83 18H22V20H11.83C11.6234 20.5855 11.2403 21.0926 10.7334 21.4512C10.2265 21.8099 9.62091 22.0025 9 22.0025C8.37909 22.0025 7.77346 21.8099 7.2666 21.4512C6.75974 21.0926 6.3766 20.5855 6.17 20H2V18H6.17ZM12.17 11C12.3766 10.4145 12.7597 9.90743 13.2666 9.54879C13.7735 9.19015 14.3791 8.99755 15 8.99755C15.6209 8.99755 16.2265 9.19015 16.7334 9.54879C17.2403 9.90743 17.6234 10.4145 17.83 11H22V13H17.83C17.6234 13.5855 17.2403 14.0926 16.7334 14.4512C16.2265 14.8099 15.6209 15.0025 15 15.0025C14.3791 15.0025 13.7735 14.8099 13.2666 14.4512C12.7597 14.0926 12.3766 13.5855 12.17 13H2V11H12.17ZM6.17 4C6.3766 3.41447 6.75974 2.90744 7.2666 2.54879C7.77346 2.19015 8.37909 1.99755 9 1.99755C9.62091 1.99755 10.2265 2.19015 10.7334 2.54879C11.2403 2.90744 11.6234 3.41447 11.83 4H22V6H11.83C11.6234 6.58553 11.2403 7.09257 10.7334 7.45121C10.2265 7.80986 9.62091 8.00245 9 8.00245C8.37909 8.00245 7.77346 7.80986 7.2666 7.45121C6.75974 7.09257 6.3766 6.58553 6.17 6H2V4H6.17ZM9 6C9.26522 6 9.51957 5.89464 9.70711 5.70711C9.89464 5.51957 10 5.26522 10 5C10 4.73478 9.89464 4.48043 9.70711 4.29289C9.51957 4.10536 9.26522 4 9 4C8.73478 4 8.48043 4.10536 8.29289 4.29289C8.10536 4.48043 8 4.73478 8 5C8 5.26522 8.10536 5.51957 8.29289 5.70711C8.48043 5.89464 8.73478 6 9 6V6ZM15 13C15.2652 13 15.5196 12.8946 15.7071 12.7071C15.8946 12.5196 16 12.2652 16 12C16 11.7348 15.8946 11.4804 15.7071 11.2929C15.5196 11.1054 15.2652 11 15 11C14.7348 11 14.4804 11.1054 14.2929 11.2929C14.1054 11.4804 14 11.7348 14 12C14 12.2652 14.1054 12.5196 14.2929 12.7071C14.4804 12.8946 14.7348 13 15 13V13ZM9 20C9.26522 20 9.51957 19.8946 9.70711 19.7071C9.89464 19.5196 10 19.2652 10 19C10 18.7348 9.89464 18.4804 9.70711 18.2929C9.51957 18.1054 9.26522 18 9 18C8.73478 18 8.48043 18.1054 8.29289 18.2929C8.10536 18.4804 8 18.7348 8 19C8 19.2652 8.10536 19.5196 8.29289 19.7071C8.48043 19.8946 8.73478 20 9 20V20Z"
    ]
  },
  "map-pin": {
    paths: [
      "M12 20.9L16.95 15.95C17.9289 14.971 18.5955 13.7237 18.8656 12.3659C19.1356 11.008 18.9969 9.6006 18.4671 8.32155C17.9373 7.04251 17.04 5.9493 15.8889 5.18017C14.7378 4.41103 13.3844 4.0005 12 4.0005C10.6156 4.0005 9.26222 4.41103 8.11109 5.18017C6.95996 5.9493 6.06275 7.04251 5.53292 8.32155C5.00308 9.6006 4.86442 11.008 5.13445 12.3659C5.40449 13.7237 6.07111 14.971 7.05 15.95L12 20.9ZM12 23.728L5.636 17.364C4.37734 16.1053 3.52019 14.5017 3.17293 12.7558C2.82567 11.01 3.00391 9.20043 3.6851 7.5559C4.36629 5.91137 5.51984 4.50577 6.99988 3.51684C8.47992 2.52791 10.22 2.00008 12 2.00008C13.78 2.00008 15.5201 2.52791 17.0001 3.51684C18.4802 4.50577 19.6337 5.91137 20.3149 7.5559C20.9961 9.20043 21.1743 11.01 20.8271 12.7558C20.4798 14.5017 19.6227 16.1053 18.364 17.364L12 23.728V23.728ZM12 13C12.5304 13 13.0391 12.7893 13.4142 12.4142C13.7893 12.0391 14 11.5304 14 11C14 10.4696 13.7893 9.96086 13.4142 9.58578C13.0391 9.21071 12.5304 9 12 9C11.4696 9 10.9609 9.21071 10.5858 9.58578C10.2107 9.96086 10 10.4696 10 11C10 11.5304 10.2107 12.0391 10.5858 12.4142C10.9609 12.7893 11.4696 13 12 13ZM12 15C10.9391 15 9.92172 14.5786 9.17158 13.8284C8.42143 13.0783 8 12.0609 8 11C8 9.93913 8.42143 8.92172 9.17158 8.17157C9.92172 7.42143 10.9391 7 12 7C13.0609 7 14.0783 7.42143 14.8284 8.17157C15.5786 8.92172 16 9.93913 16 11C16 12.0609 15.5786 13.0783 14.8284 13.8284C14.0783 14.5786 13.0609 15 12 15Z"
    ]
  },
  "map-pin-filled": {
    paths: [
      "M12 20.9L16.95 15.95C17.9289 14.971 18.5955 13.7237 18.8656 12.3659C19.1356 11.008 18.9969 9.6006 18.4671 8.32155C17.9373 7.04251 17.04 5.9493 15.8889 5.18017C14.7378 4.41103 13.3844 4.0005 12 4.0005C10.6156 4.0005 9.26222 4.41103 8.11109 5.18017C6.95996 5.9493 6.06275 7.04251 5.53292 8.32155C5.00308 9.6006 4.86442 11.008 5.13445 12.3659C5.40449 13.7237 6.07111 14.971 7.05 15.95L12 20.9Z"
    ],
    viewBox: "2 2 20 20"
  },
  "map-pin-add": {
    paths: [
      "M12 20.9L16.95 15.95C17.9289 14.971 18.5955 13.7237 18.8656 12.3659C19.1356 11.008 18.9969 9.6006 18.4671 8.32155C17.9373 7.04251 17.04 5.9493 15.8889 5.18017C14.7378 4.41103 13.3844 4.0005 12 4.0005C10.6156 4.0005 9.26222 4.41103 8.11109 5.18017C6.95996 5.9493 6.06275 7.04251 5.53292 8.32155C5.00308 9.6006 4.86442 11.008 5.13445 12.3659C5.40449 13.7237 6.07111 14.971 7.05 15.95L12 20.9ZM12 23.728L5.636 17.364C4.37734 16.1053 3.52019 14.5017 3.17293 12.7558C2.82567 11.01 3.00391 9.20043 3.6851 7.5559C4.36629 5.91137 5.51984 4.50577 6.99988 3.51684C8.47992 2.52791 10.22 2.00008 12 2.00008C13.78 2.00008 15.5201 2.52791 17.0001 3.51684C18.4802 4.50577 19.6337 5.91137 20.3149 7.5559C20.9961 9.20043 21.1743 11.01 20.8271 12.7558C20.4798 14.5017 19.6227 16.1053 18.364 17.364L12 23.728V23.728ZM11 10V7H13V10H16V12H13V15H11V12H8V10H11Z"
    ]
  },
  pushpin: {
    paths: [
      "M13.8277 1.686L22.3137 10.172L20.8987 11.586L20.1917 10.879L15.9497 15.121L15.2427 18.657L13.8277 20.071L9.58568 15.828L4.63568 20.778L3.22168 19.364L8.17168 14.414L3.92868 10.172L5.34268 8.757L8.87968 8.05L13.1217 3.808L12.4147 3.101L13.8287 1.686H13.8277ZM14.5357 5.222L9.86468 9.892L7.04268 10.457L13.5427 16.957L14.1067 14.135L18.7777 9.465L14.5357 5.222V5.222Z"
    ]
  },
  earth: {
    paths: [
      "M6.235 6.453C4.96004 7.77629 4.1795 9.49815 4.02457 11.3292C3.86964 13.1602 4.34977 14.9887 5.38426 16.5074C6.41874 18.0261 7.94451 19.1424 9.70511 19.6686C11.4657 20.1948 13.3538 20.0989 15.052 19.397C15.167 18.647 14.915 17.927 14.812 17.675C14.582 17.115 13.824 16.158 12.559 14.831C12.221 14.476 12.243 14.203 12.364 13.394L12.377 13.303C12.459 12.749 12.597 12.421 14.462 12.125C15.41 11.975 15.659 12.353 16.004 12.878L16.12 13.05C16.448 13.53 16.691 13.64 17.058 13.806C17.223 13.881 17.428 13.976 17.703 14.131C18.355 14.504 18.355 14.925 18.355 15.847V15.952C18.355 16.343 18.317 16.687 18.257 16.986C19.0244 16.0229 19.5591 14.8957 19.8196 13.6922C20.0801 12.4886 20.0593 11.2412 19.7588 10.047C19.4584 8.85284 18.8863 7.7441 18.0873 6.80714C17.2883 5.87017 16.2838 5.13026 15.152 4.645C14.599 5.018 13.84 5.547 13.575 5.91C13.44 6.095 13.248 7.042 12.625 7.12C12.463 7.14 12.244 7.126 12.012 7.111C11.39 7.071 10.54 7.016 10.268 7.755C10.095 8.223 10.065 9.495 10.624 10.155C10.714 10.26 10.731 10.455 10.67 10.674C10.59 10.961 10.429 11.136 10.378 11.172C10.282 11.116 10.09 10.893 9.959 10.742C9.646 10.377 9.254 9.922 8.748 9.782C8.564 9.731 8.362 9.689 8.165 9.647C7.616 9.532 6.995 9.401 6.85 9.093C6.744 8.867 6.745 8.556 6.745 8.228C6.745 7.811 6.745 7.34 6.541 6.883C6.47008 6.71991 6.36585 6.57344 6.235 6.453V6.453ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z"
    ]
  },
  "map-2": {
    paths: [
      "M2 5L9 2L15 5L21.303 2.299C21.3791 2.26638 21.4621 2.25317 21.5445 2.26054C21.627 2.26792 21.7063 2.29565 21.7754 2.34124C21.8445 2.38684 21.9012 2.44888 21.9404 2.5218C21.9796 2.59471 22.0001 2.67622 22 2.759V19L15 22L9 19L2.697 21.701C2.62091 21.7336 2.53792 21.7468 2.45547 21.7395C2.37301 21.7321 2.29368 21.7044 2.22459 21.6588C2.1555 21.6132 2.09881 21.5511 2.05961 21.4782C2.02041 21.4053 1.99993 21.3238 2 21.241V5ZM16 19.395L20 17.681V5.033L16 6.747V19.395ZM14 19.264V6.736L10 4.736V17.264L14 19.264ZM8 17.253V4.605L4 6.319V18.967L8 17.253Z"
    ]
  },
  "pushpin-2": {
    paths: [
      "M18 3V5H17V11L19 14V16H13V23H11V16H5V14L7 11V5H6V3H18ZM9 5V11.606L7.404 14H16.596L15 11.606V5H9Z"
    ]
  },
  "map-pin-2": {
    paths: [
      "M12 23.728L5.636 17.364C4.37734 16.1053 3.52019 14.5017 3.17293 12.7558C2.82567 11.01 3.00391 9.20043 3.6851 7.5559C4.36629 5.91137 5.51984 4.50577 6.99988 3.51684C8.47992 2.52791 10.22 2.00008 12 2.00008C13.78 2.00008 15.5201 2.52791 17.0001 3.51684C18.4802 4.50577 19.6337 5.91137 20.3149 7.5559C20.9961 9.20043 21.1743 11.01 20.8271 12.7558C20.4798 14.5017 19.6227 16.1053 18.364 17.364L12 23.728ZM16.95 15.95C17.9289 14.971 18.5955 13.7237 18.8656 12.3659C19.1356 11.008 18.9969 9.6006 18.4671 8.32155C17.9373 7.04251 17.04 5.9493 15.8889 5.18017C14.7378 4.41103 13.3844 4.0005 12 4.0005C10.6156 4.0005 9.26222 4.41103 8.11109 5.18017C6.95996 5.9493 6.06275 7.04251 5.53292 8.32155C5.00308 9.6006 4.86442 11.008 5.13445 12.3659C5.40449 13.7237 6.07111 14.971 7.05 15.95L12 20.9L16.95 15.95V15.95ZM12 13C11.4696 13 10.9609 12.7893 10.5858 12.4142C10.2107 12.0391 10 11.5304 10 11C10 10.4696 10.2107 9.96086 10.5858 9.58578C10.9609 9.21071 11.4696 9 12 9C12.5304 9 13.0391 9.21071 13.4142 9.58578C13.7893 9.96086 14 10.4696 14 11C14 11.5304 13.7893 12.0391 13.4142 12.4142C13.0391 12.7893 12.5304 13 12 13Z"
    ]
  },
  pencil: {
    paths: [
      "M15.728 9.686L14.314 8.272L5 17.586V19H6.414L15.728 9.686ZM17.142 8.272L18.556 6.858L17.142 5.444L15.728 6.858L17.142 8.272ZM7.242 21H3V16.757L16.435 3.322C16.6225 3.13453 16.8768 3.02921 17.142 3.02921C17.4072 3.02921 17.6615 3.13453 17.849 3.322L20.678 6.151C20.8655 6.33853 20.9708 6.59284 20.9708 6.858C20.9708 7.12316 20.8655 7.37747 20.678 7.565L7.243 21H7.242Z"
    ]
  },
  "layout-left-2": {
    paths: [
      "M21 3C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21ZM20 5H4V19H20V5ZM8 7V17H6V7H8Z"
    ]
  },
  "edit-2": {
    paths: [
      "M5 19H6.414L15.728 9.686L14.314 8.272L5 17.586V19ZM21 21H3V16.757L16.435 3.322C16.6225 3.13453 16.8768 3.02921 17.142 3.02921C17.4072 3.02921 17.6615 3.13453 17.849 3.322L20.678 6.151C20.8655 6.33853 20.9708 6.59284 20.9708 6.858C20.9708 7.12316 20.8655 7.37747 20.678 7.565L9.243 19H21V21ZM15.728 6.858L17.142 8.272L18.556 6.858L17.142 5.444L15.728 6.858V6.858Z"
    ]
  },
  "edit-box": {
    paths: [
      "M16.757 3L14.757 5H5V19H19V9.243L21 7.243V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H16.757V3ZM20.485 2.1L21.9 3.516L12.708 12.708L11.296 12.711L11.294 11.294L20.485 2.1V2.1Z"
    ]
  },
  edit: {
    paths: [
      "M6.414 16L16.556 5.858L15.142 4.444L5 14.586V16H6.414ZM7.243 18H3V13.757L14.435 2.322C14.6225 2.13453 14.8768 2.02921 15.142 2.02921C15.4072 2.02921 15.6615 2.13453 15.849 2.322L18.678 5.151C18.8655 5.33853 18.9708 5.59284 18.9708 5.858C18.9708 6.12316 18.8655 6.37747 18.678 6.565L7.243 18V18ZM3 20H21V22H3V20Z"
    ]
  },
  "layout-top-2": {
    paths: [
      "M21 3C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21ZM20 5H4V19H20V5ZM18 7V9H6V7H18Z"
    ]
  },
  "file-list-2": {
    paths: [
      "M20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V3C3 2.73478 3.10536 2.48043 3.29289 2.29289C3.48043 2.10536 3.73478 2 4 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22ZM19 20V4H5V20H19ZM8 7H16V9H8V7ZM8 11H16V13H8V11ZM8 15H13V17H8V15Z"
    ]
  },
  clipboard: {
    paths: [
      "M7 4V2H17V4H20.007C20.555 4 21 4.445 21 4.993V21.007C20.9997 21.2703 20.895 21.5227 20.7089 21.7089C20.5227 21.895 20.2703 21.9997 20.007 22H3.993C3.72972 21.9997 3.4773 21.895 3.29114 21.7089C3.10497 21.5227 3.00026 21.2703 3 21.007V4.993C3 4.445 3.445 4 3.993 4H7ZM7 6H5V20H19V6H17V8H7V6ZM9 4V6H15V4H9Z"
    ]
  },
  "contacts-book-2": {
    paths: [
      "M20 22H6C5.20435 22 4.44129 21.6839 3.87868 21.1213C3.31607 20.5587 3 19.7956 3 19V5C3 4.20435 3.31607 3.44129 3.87868 2.87868C4.44129 2.31607 5.20435 2 6 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22ZM19 20V18H6C5.73478 18 5.48043 18.1054 5.29289 18.2929C5.10536 18.4804 5 18.7348 5 19C5 19.2652 5.10536 19.5196 5.29289 19.7071C5.48043 19.8946 5.73478 20 6 20H19ZM5 16.17C5.313 16.06 5.65 16 6 16H19V4H6C5.73478 4 5.48043 4.10536 5.29289 4.29289C5.10536 4.48043 5 4.73478 5 5V16.17ZM12 10C11.4696 10 10.9609 9.78929 10.5858 9.41421C10.2107 9.03914 10 8.53043 10 8C10 7.46957 10.2107 6.96086 10.5858 6.58579C10.9609 6.21071 11.4696 6 12 6C12.5304 6 13.0391 6.21071 13.4142 6.58579C13.7893 6.96086 14 7.46957 14 8C14 8.53043 13.7893 9.03914 13.4142 9.41421C13.0391 9.78929 12.5304 10 12 10ZM9 14C9 13.2044 9.31607 12.4413 9.87868 11.8787C10.4413 11.3161 11.2044 11 12 11C12.7956 11 13.5587 11.3161 14.1213 11.8787C14.6839 12.4413 15 13.2044 15 14H9Z"
    ]
  },
  "file-3": {
    paths: [
      "M21 8V20.993C21.0009 21.1243 20.976 21.2545 20.9266 21.3762C20.8772 21.4979 20.8043 21.6087 20.7121 21.7022C20.6199 21.7957 20.5101 21.8701 20.3892 21.9212C20.2682 21.9723 20.1383 21.9991 20.007 22H3.993C3.72981 22 3.47739 21.8955 3.2912 21.7095C3.105 21.5235 3.00027 21.2712 3 21.008V2.992C3 2.455 3.449 2 4.002 2H14.997L21 8ZM19 9H14V4H5V20H19V9Z"
    ]
  },
  "file-lock": {
    paths: [
      "M15 4H5V20H19V8H15V4ZM3 2.992C3 2.444 3.447 2 3.999 2H16L21 7V20.993C21.0009 21.1243 20.976 21.2545 20.9266 21.3762C20.8772 21.4979 20.8043 21.6087 20.7121 21.7022C20.6199 21.7957 20.5101 21.8701 20.3892 21.9212C20.2682 21.9723 20.1383 21.9991 20.007 22H3.993C3.73038 21.9982 3.47902 21.8931 3.29322 21.7075C3.10742 21.5219 3.00209 21.2706 3 21.008V2.992ZM15 11H16V16H8V11H9V10C9 9.20435 9.31607 8.44129 9.87868 7.87868C10.4413 7.31607 11.2044 7 12 7C12.7956 7 13.5587 7.31607 14.1213 7.87868C14.6839 8.44129 15 9.20435 15 10V11ZM13 11V10C13 9.73478 12.8946 9.48043 12.7071 9.29289C12.5196 9.10536 12.2652 9 12 9C11.7348 9 11.4804 9.10536 11.2929 9.29289C11.1054 9.48043 11 9.73478 11 10V11H13Z"
    ]
  },
  "file-copy": {
    paths: [
      "M17 6V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2H4C3.73478 2 3.48043 2.10536 3.29289 2.29289C3.10536 2.48043 3 2.73478 3 3V17C3 17.2652 3.10536 17.5196 3.29289 17.7071C3.48043 17.8946 3.73478 18 4 18H7V21C7 21.552 7.45 22 8.007 22H19.993C20.1249 22.0008 20.2556 21.9755 20.3777 21.9256C20.4998 21.8757 20.6108 21.8022 20.7043 21.7093C20.7979 21.6164 20.8722 21.5059 20.9229 21.3841C20.9737 21.2624 20.9999 21.1319 21 21L20.997 7C20.997 6.448 20.547 6 19.99 6H17ZM18.997 8L19 20H9V8H18.997ZM15 6H7V16H5V4H15V6Z"
    ]
  },
  draft: {
    paths: [
      "M20 2C20.552 2 21 2.448 21 3V6.757L19 8.757V4H5V20H19V17.242L21 15.242V21C21 21.552 20.552 22 20 22H4C3.448 22 3 21.552 3 21V3C3 2.448 3.448 2 4 2H20ZM21.778 8.808L23.192 10.222L15.414 18L13.998 17.998L14 16.586L21.778 8.808V8.808ZM13 12V14H8V12H13ZM16 8V10H8V8H16Z"
    ]
  },
  "folder-3": {
    paths: [
      "M12.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H10.414L12.414 5ZM4 7V19H20V7H4Z"
    ]
  },
  folder: {
    paths: [
      "M4 5V19H20V7H11.586L9.586 5H4ZM12.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H10.414L12.414 5Z"
    ]
  },
  "folder-4": {
    paths: [
      "M12.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H10.414L12.414 5ZM8 19H20V11H8V19ZM6 19V10C6 9.73478 6.10536 9.48043 6.29289 9.29289C6.48043 9.10536 6.73478 9 7 9H20V7H11.586L9.586 5H4V19H6Z"
    ]
  },
  "folder-copy-2": {
    paths: [
      "M17 6V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2H4C3.73478 2 3.48043 2.10536 3.29289 2.29289C3.10536 2.48043 3 2.73478 3 3V17C3 17.2652 3.10536 17.5196 3.29289 17.7071C3.48043 17.8946 3.73478 18 4 18H7V21C7 21.552 7.45 22 8.007 22H19.993C20.1249 22.0008 20.2556 21.9755 20.3777 21.9256C20.4998 21.8757 20.6108 21.8022 20.7043 21.7093C20.7979 21.6164 20.8722 21.5059 20.9229 21.3841C20.9737 21.2624 20.9999 21.1319 21 21L20.997 7C20.997 6.448 20.547 6 19.991 6H17ZM18.998 8L19 20H9V8H18.998ZM15 6H7V16H5V4H15V6ZM17 11H11V13H17V11ZM17 15H11V17H17V15Z"
    ]
  },
  folders: {
    paths: [
      "M6 7V4C6 3.73478 6.10536 3.48043 6.29289 3.29289C6.48043 3.10536 6.73478 3 7 3H13.414L15.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V16C22 16.2652 21.8946 16.5196 21.7071 16.7071C21.5196 16.8946 21.2652 17 21 17H18V20C18 20.2652 17.8946 20.5196 17.7071 20.7071C17.5196 20.8946 17.2652 21 17 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V8C2 7.73478 2.10536 7.48043 2.29289 7.29289C2.48043 7.10536 2.73478 7 3 7H6ZM6 9H4V19H16V17H6V9ZM8 5V15H20V7H14.586L12.586 5H8Z"
    ]
  },
  task: {
    paths: [
      "M21 2.992V21.008C20.9979 21.2706 20.8926 21.5219 20.7068 21.7075C20.521 21.8931 20.2696 21.9982 20.007 22H3.993C3.72981 22 3.47739 21.8955 3.2912 21.7095C3.105 21.5235 3.00027 21.2712 3 21.008V2.992C3.00209 2.72938 3.10742 2.47813 3.29322 2.29251C3.47902 2.1069 3.73038 2.00183 3.993 2H20.007C20.555 2 21 2.444 21 2.992V2.992ZM19 4H5V20H19V4ZM11.293 13.121L15.536 8.879L16.95 10.293L11.293 15.95L7.403 12.06L8.818 10.646L11.293 13.121V13.121Z"
    ]
  },
  "vip-crown": {
    paths: [
      "M2 19H22V21H2V19ZM2 5L7 8.5L12 2L17 8.5L22 5V17H2V5ZM4 8.841V15H20V8.841L16.58 11.235L12 5.28L7.42 11.235L4 8.84V8.841Z"
    ]
  },
  vip: {
    paths: [
      "M2 19H22V21H2V19ZM11 8H13V16H11V8ZM7.965 8H10.09L7.104 15.964H5.104L2.118 8H4.243L6.104 13.113L7.965 8ZM17 14V16H15V8H19C19.7956 8 20.5587 8.31607 21.1213 8.87868C21.6839 9.44129 22 10.2044 22 11C22 11.7956 21.6839 12.5587 21.1213 13.1213C20.5587 13.6839 19.7956 14 19 14H17ZM17 10V12H19C19.2652 12 19.5196 11.8946 19.7071 11.7071C19.8946 11.5196 20 11.2652 20 11C20 10.7348 19.8946 10.4804 19.7071 10.2929C19.5196 10.1054 19.2652 10 19 10H17ZM2 3H22V5H2V3Z"
    ]
  },
  "vip-diamond": {
    paths: [
      "M4.87303 3H19.127C19.2848 2.99998 19.4404 3.0373 19.581 3.1089C19.7216 3.18051 19.8433 3.28437 19.936 3.412L23.759 8.668C23.827 8.76152 23.8605 8.8757 23.8537 8.99112C23.847 9.10653 23.8004 9.21603 23.722 9.301L12.367 21.602C12.2771 21.6992 12.1522 21.7568 12.0198 21.7621C11.8875 21.7673 11.7584 21.7198 11.661 21.63C11.654 21.624 7.86103 17.515 0.278033 9.301C0.199637 9.21603 0.153106 9.10653 0.14636 8.99112C0.139614 8.8757 0.17307 8.76152 0.241033 8.668L4.06403 3.412C4.15681 3.28437 4.27848 3.18051 4.41908 3.1089C4.55969 3.0373 4.71524 2.99998 4.87303 3ZM5.38303 5L2.58303 8.85L12 19.05L21.417 8.85L18.617 5H5.38303Z"
    ]
  },
  "money-dollar": {
    paths: [
      "M8.5 14H14C14.1326 14 14.2598 13.9473 14.3536 13.8536C14.4473 13.7598 14.5 13.6326 14.5 13.5C14.5 13.3674 14.4473 13.2402 14.3536 13.1464C14.2598 13.0527 14.1326 13 14 13H10C9.33696 13 8.70107 12.7366 8.23223 12.2678C7.76339 11.7989 7.5 11.163 7.5 10.5C7.5 9.83696 7.76339 9.20107 8.23223 8.73223C8.70107 8.26339 9.33696 8 10 8H11V6H13V8H15.5V10H10C9.86739 10 9.74021 10.0527 9.64645 10.1464C9.55268 10.2402 9.5 10.3674 9.5 10.5C9.5 10.6326 9.55268 10.7598 9.64645 10.8536C9.74021 10.9473 9.86739 11 10 11H14C14.663 11 15.2989 11.2634 15.7678 11.7322C16.2366 12.2011 16.5 12.837 16.5 13.5C16.5 14.163 16.2366 14.7989 15.7678 15.2678C15.2989 15.7366 14.663 16 14 16H13V18H11V16H8.5V14Z"
    ]
  },
  "money-dollar-circle": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM8.5 14H14C14.1326 14 14.2598 13.9473 14.3536 13.8536C14.4473 13.7598 14.5 13.6326 14.5 13.5C14.5 13.3674 14.4473 13.2402 14.3536 13.1464C14.2598 13.0527 14.1326 13 14 13H10C9.33696 13 8.70107 12.7366 8.23223 12.2678C7.76339 11.7989 7.5 11.163 7.5 10.5C7.5 9.83696 7.76339 9.20107 8.23223 8.73223C8.70107 8.26339 9.33696 8 10 8H11V6H13V8H15.5V10H10C9.86739 10 9.74021 10.0527 9.64645 10.1464C9.55268 10.2402 9.5 10.3674 9.5 10.5C9.5 10.6326 9.55268 10.7598 9.64645 10.8536C9.74021 10.9473 9.86739 11 10 11H14C14.663 11 15.2989 11.2634 15.7678 11.7322C16.2366 12.2011 16.5 12.837 16.5 13.5C16.5 14.163 16.2366 14.7989 15.7678 15.2678C15.2989 15.7366 14.663 16 14 16H13V18H11V16H8.5V14Z"
    ]
  },
  "bank-card": {
    paths: [
      "M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM20 11H4V19H20V11ZM20 9V5H4V9H20ZM14 15H18V17H14V15Z"
    ]
  },
  "gift-2": {
    paths: [
      "M14.5 2C15.0906 1.9998 15.6717 2.14908 16.1892 2.43393C16.7066 2.71879 17.1435 3.12995 17.4592 3.62914C17.7749 4.12832 17.9592 4.69929 17.9948 5.28886C18.0305 5.87843 17.9163 6.46743 17.663 7.001L21 7C21.2652 7 21.5196 7.10536 21.7071 7.2929C21.8946 7.48043 22 7.73479 22 8V12C22 12.2652 21.8946 12.5196 21.7071 12.7071C21.5196 12.8946 21.2652 13 21 13H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V13H3C2.73478 13 2.48043 12.8946 2.29289 12.7071C2.10536 12.5196 2 12.2652 2 12V8C2 7.73479 2.10536 7.48043 2.29289 7.2929C2.48043 7.10536 2.73478 7 3 7L6.337 7.001C5.98076 6.25268 5.90163 5.40221 6.1137 4.601C6.32577 3.7998 6.81529 3.09985 7.4951 2.62576C8.17491 2.15167 9.0009 1.9342 9.82603 2.01207C10.6512 2.08994 11.4219 2.4581 12.001 3.051C12.326 2.71753 12.7147 2.45268 13.1439 2.27215C13.5732 2.09162 14.0343 1.99908 14.5 2V2ZM18 13H6V20H18V13ZM20 9H4V11H20V9ZM9.5 4C9.11478 4.00019 8.74441 4.14858 8.46561 4.41441C8.18682 4.68025 8.02099 5.04315 8.00248 5.42792C7.98396 5.81269 8.11419 6.18984 8.36618 6.48121C8.61816 6.77258 8.97258 6.95583 9.356 6.993L9.5 7H11V5.5C11 5.12712 10.8611 4.76761 10.6104 4.49158C10.3597 4.21556 10.0152 4.0428 9.644 4.007L9.5 4ZM14.5 4L14.356 4.007C14.0094 4.04021 13.6851 4.19298 13.4388 4.43911C13.1925 4.68525 13.0395 5.0094 13.006 5.356L13 5.5V7H14.5L14.644 6.993C15.015 6.95703 15.3594 6.7842 15.6099 6.50819C15.8605 6.23218 15.9993 5.87277 15.9993 5.5C15.9993 5.12724 15.8605 4.76783 15.6099 4.49182C15.3594 4.21581 15.015 4.04297 14.644 4.007L14.5 4Z"
    ]
  },
  "vip-crown-2": {
    paths: [
      "M3.49189 8.06499L4.77789 19H19.2219L20.5079 8.06499L16.4979 10.738L11.9999 4.44099L7.50189 10.738L3.49189 8.06499ZM2.80089 5.19999L6.99989 7.99999L11.1859 2.13999C11.2784 2.01036 11.4005 1.9047 11.5421 1.83179C11.6837 1.75889 11.8406 1.72086 11.9999 1.72086C12.1591 1.72086 12.3161 1.75889 12.4577 1.83179C12.5993 1.9047 12.7214 2.01036 12.8139 2.13999L16.9999 7.99999L21.1999 5.19999C21.3588 5.09424 21.5447 5.0362 21.7356 5.03273C21.9265 5.02926 22.1144 5.0805 22.2771 5.18041C22.4398 5.28032 22.5705 5.42471 22.6537 5.59653C22.737 5.76834 22.7693 5.96039 22.7469 6.14999L21.1039 20.117C21.0752 20.3602 20.9583 20.5845 20.7753 20.7473C20.5922 20.91 20.3558 21 20.1109 21H3.88889C3.64395 21 3.40755 20.91 3.22451 20.7473C3.04148 20.5845 2.92454 20.3602 2.89589 20.117L1.25289 6.14899C1.23069 5.95947 1.26317 5.76756 1.34651 5.59591C1.42984 5.42425 1.56055 5.28003 1.7232 5.18025C1.88584 5.08048 2.07364 5.02932 2.26442 5.03281C2.45521 5.03631 2.641 5.09432 2.79989 5.19999H2.80089ZM11.9999 15C11.4695 15 10.9607 14.7893 10.5857 14.4142C10.2106 14.0391 9.99989 13.5304 9.99989 13C9.99989 12.4696 10.2106 11.9609 10.5857 11.5858C10.9607 11.2107 11.4695 11 11.9999 11C12.5303 11 13.039 11.2107 13.4141 11.5858C13.7892 11.9609 13.9999 12.4696 13.9999 13C13.9999 13.5304 13.7892 14.0391 13.4141 14.4142C13.039 14.7893 12.5303 15 11.9999 15Z"
    ]
  },
  "bank-card-2": {
    paths: [
      "M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM20 12H4V19H20V12ZM20 8V5H4V8H20Z"
    ]
  },
  "money-dollar-box": {
    paths: [
      "M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM4 5V19H20V5H4ZM8.5 14H14C14.1326 14 14.2598 13.9473 14.3536 13.8536C14.4473 13.7598 14.5 13.6326 14.5 13.5C14.5 13.3674 14.4473 13.2402 14.3536 13.1464C14.2598 13.0527 14.1326 13 14 13H10C9.33696 13 8.70107 12.7366 8.23223 12.2678C7.76339 11.7989 7.5 11.163 7.5 10.5C7.5 9.83696 7.76339 9.20107 8.23223 8.73223C8.70107 8.26339 9.33696 8 10 8H11V6H13V8H15.5V10H10C9.86739 10 9.74021 10.0527 9.64645 10.1464C9.55268 10.2402 9.5 10.3674 9.5 10.5C9.5 10.6326 9.55268 10.7598 9.64645 10.8536C9.74021 10.9473 9.86739 11 10 11H14C14.663 11 15.2989 11.2634 15.7678 11.7322C16.2366 12.2011 16.5 12.837 16.5 13.5C16.5 14.163 16.2366 14.7989 15.7678 15.2678C15.2989 15.7366 14.663 16 14 16H13V18H11V16H8.5V14Z"
    ]
  },
  gift: {
    paths: [
      "M15 2.00001C15.7023 1.99992 16.3922 2.18474 17.0004 2.53587C17.6086 2.887 18.1137 3.39207 18.4647 4.0003C18.8158 4.60853 19.0006 5.29847 19.0005 6.00075C19.0003 6.70304 18.8153 7.39291 18.464 8.00101L23 8.00001V10H21V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V10H1V8.00001L5.536 8.00101C5.03986 7.14189 4.88069 6.12906 5.08938 5.15918C5.29808 4.1893 5.85975 3.33157 6.66533 2.75256C7.47092 2.17354 8.46293 1.91456 9.44875 2.02588C10.4346 2.13721 11.3438 2.61091 12 3.35501C12.3746 2.92839 12.8361 2.58678 13.3535 2.35308C13.8709 2.11939 14.4323 1.99901 15 2.00001V2.00001ZM11 10H5V19H11V10ZM19 10H13V19H19V10ZM9 4.00001C8.48102 3.99768 7.98145 4.19719 7.60685 4.55639C7.23224 4.91558 7.01193 5.40632 6.99246 5.92495C6.97299 6.44357 7.15588 6.94945 7.50249 7.33572C7.84911 7.722 8.3323 7.9584 8.85 7.99501L9 8.00001H11V6.00001C11 5.52207 10.8289 5.05992 10.5176 4.69726C10.2063 4.33461 9.77542 4.09541 9.303 4.02301L9.149 4.00501L9 4.00001ZM15 4.00001C14.4954 3.99985 14.0094 4.19041 13.6395 4.5335C13.2695 4.87659 13.0428 5.34685 13.005 5.85001L13 6.00001V8.00001H15C15.5046 8.00017 15.9906 7.8096 16.3605 7.46651C16.7305 7.12342 16.9572 6.65316 16.995 6.15001L17 6.00001C17 5.46957 16.7893 4.96087 16.4142 4.58579C16.0391 4.21072 15.5304 4.00001 15 4.00001V4.00001Z"
    ]
  },
  "attachment-2": {
    paths: [
      "M14.8283 7.75701L9.17229 13.414C9.07678 13.5063 9.00059 13.6166 8.94819 13.7386C8.89578 13.8606 8.86819 13.9918 8.86704 14.1246C8.86588 14.2574 8.89118 14.3891 8.94147 14.512C8.99175 14.6349 9.066 14.7465 9.15989 14.8404C9.25378 14.9343 9.36544 15.0086 9.48833 15.0588C9.61123 15.1091 9.74291 15.1344 9.87569 15.1333C10.0085 15.1321 10.1397 15.1045 10.2617 15.0521C10.3837 14.9997 10.494 14.9235 10.5863 14.828L16.2433 9.17201C16.8059 8.60935 17.122 7.84623 17.122 7.05051C17.122 6.25479 16.8059 5.49167 16.2433 4.92901C15.6806 4.36635 14.9175 4.05026 14.1218 4.05026C13.3261 4.05026 12.5629 4.36635 12.0003 4.92901L6.34329 10.586C5.86936 11.0481 5.49192 11.5998 5.23284 12.2089C4.97377 12.818 4.83823 13.4726 4.83408 14.1345C4.82994 14.7964 4.95727 15.4526 5.20868 16.0649C5.4601 16.6773 5.83061 17.2336 6.2987 17.7016C6.7668 18.1696 7.32317 18.5401 7.93554 18.7914C8.54791 19.0427 9.20409 19.17 9.86602 19.1657C10.5279 19.1615 11.1824 19.0258 11.7915 18.7667C12.4006 18.5075 12.9522 18.13 13.4143 17.656L19.0713 12L20.4853 13.414L14.8283 19.071C14.1782 19.7211 13.4065 20.2367 12.5572 20.5885C11.7079 20.9403 10.7976 21.1214 9.87829 21.1214C8.95899 21.1214 8.04869 20.9403 7.19937 20.5885C6.35004 20.2367 5.57833 19.7211 4.92829 19.071C4.27824 18.421 3.7626 17.6493 3.4108 16.7999C3.059 15.9506 2.87793 15.0403 2.87793 14.121C2.87793 13.2017 3.059 12.2914 3.4108 11.4421C3.7626 10.5928 4.27824 9.82105 4.92829 9.17101L10.5863 3.51501C11.5293 2.60422 12.7923 2.10025 14.1033 2.11164C15.4143 2.12303 16.6683 2.64888 17.5954 3.57592C18.5224 4.50296 19.0483 5.75702 19.0597 7.068C19.071 8.37899 18.5671 9.642 17.6563 10.585L12.0003 16.244C11.7216 16.5226 11.3908 16.7436 11.0267 16.8943C10.6627 17.0451 10.2725 17.1227 9.87843 17.1226C9.48439 17.1226 9.09421 17.0449 8.73018 16.8941C8.36615 16.7432 8.03539 16.5222 7.75679 16.2435C7.47819 15.9648 7.2572 15.634 7.10645 15.27C6.9557 14.9059 6.87813 14.5157 6.87818 14.1217C6.87823 13.7276 6.95588 13.3374 7.10672 12.9734C7.25756 12.6094 7.47862 12.2786 7.75729 12L13.4143 6.34301L14.8283 7.75701Z"
    ]
  },
  asterisk: {
    paths: [
      "M13.0001 3V10.267L19.2941 6.634L20.2941 8.366L14.0011 11.999L20.2941 15.634L19.2941 17.366L13.0001 13.732V21H11.0001V13.732L4.70605 17.366L3.70605 15.634L9.99905 12L3.70605 8.366L4.70605 6.634L11.0001 10.267V3H13.0001Z"
    ]
  },
  autofill: {
    paths: [
      "M17 2V4H20.0068C20.5548 4 21 4.44516 21 4.99316V8H19V6H17V8H7V6H5V20H19V18H21V21.0068C20.9997 21.2701 20.8952 21.5228 20.709 21.709C20.5228 21.8952 20.2701 21.9997 20.0068 22H3.99316C3.72989 21.9997 3.47718 21.8952 3.29102 21.709C3.10485 21.5228 3.00026 21.2701 3 21.0068V4.99316C3 4.44516 3.44516 4 3.99316 4H7V2H17ZM9 4V6H15V4H9Z",
      "M17.4043 9.11073C17.7948 8.72042 18.4279 8.72033 18.8184 9.11073L22.707 12.9994L18.8184 16.889C18.428 17.2794 17.7948 17.2792 17.4043 16.889C17.0138 16.4985 17.0138 15.8655 17.4043 15.475L18.8789 13.9994H14.5C13.9477 13.9994 13.5 13.5517 13.5 12.9994C13.5002 12.4473 13.9478 11.9994 14.5 11.9994H18.8789L17.4043 10.5248C17.0138 10.1343 17.0138 9.50121 17.4043 9.11073Z"
    ],
    viewBox: "0 0 24 24"
  },
  phone: {
    paths: [
      "M9.366 10.682C10.3043 12.3305 11.6695 13.6957 13.318 14.634L14.202 13.396C14.3442 13.1969 14.5544 13.0569 14.7928 13.0023C15.0313 12.9478 15.2814 12.9825 15.496 13.1C16.9103 13.8729 18.4722 14.3378 20.079 14.464C20.3298 14.4839 20.5638 14.5975 20.7345 14.7823C20.9052 14.9671 21 15.2094 21 15.461V19.923C21.0001 20.1706 20.9083 20.4094 20.7424 20.5932C20.5765 20.777 20.3483 20.8927 20.102 20.918C19.572 20.973 19.038 21 18.5 21C9.94 21 3 14.06 3 5.5C3 4.962 3.027 4.428 3.082 3.898C3.10725 3.6517 3.22298 3.42352 3.40679 3.25763C3.5906 3.09175 3.82941 2.99995 4.077 3H8.539C8.79056 2.99997 9.0329 3.09475 9.21768 3.26545C9.40247 3.43615 9.51613 3.67022 9.536 3.921C9.66222 5.52779 10.1271 7.08968 10.9 8.504C11.0175 8.71856 11.0522 8.96874 10.9977 9.2072C10.9431 9.44565 10.8031 9.65584 10.604 9.798L9.366 10.682V10.682ZM6.844 10.025L8.744 8.668C8.20478 7.50409 7.83535 6.26884 7.647 5H5.01C5.004 5.166 5.001 5.333 5.001 5.5C5 12.956 11.044 19 18.5 19C18.667 19 18.834 18.997 19 18.99V16.353C17.7312 16.1646 16.4959 15.7952 15.332 15.256L13.975 17.156C13.4287 16.9437 12.898 16.6931 12.387 16.406L12.329 16.373C10.3676 15.2567 8.74328 13.6324 7.627 11.671L7.594 11.613C7.30691 11.102 7.05628 10.5713 6.844 10.025V10.025Z"
    ]
  },
  computer: {
    paths: [
      "M4.00004 16H20V5H4.00004V16ZM13 18V20H17V22H7.00004V20H11V18H2.99204C2.86073 17.9992 2.73086 17.9725 2.60988 17.9215C2.4889 17.8704 2.37919 17.7959 2.28703 17.7024C2.19488 17.6088 2.12209 17.498 2.07284 17.3763C2.02359 17.2546 1.99885 17.1243 2.00004 16.993V4.007C2.00004 3.451 2.45504 3 2.99204 3H21.008C21.556 3 22 3.449 22 4.007V16.993C22 17.549 21.545 18 21.008 18H13V18Z"
    ]
  },
  smartphone: {
    paths: [
      "M7 4V20H17V4H7ZM6 2H18C18.2652 2 18.5196 2.10536 18.7071 2.29289C18.8946 2.48043 19 2.73478 19 3V21C19 21.2652 18.8946 21.5196 18.7071 21.7071C18.5196 21.8946 18.2652 22 18 22H6C5.73478 22 5.48043 21.8946 5.29289 21.7071C5.10536 21.5196 5 21.2652 5 21V3C5 2.73478 5.10536 2.48043 5.29289 2.29289C5.48043 2.10536 5.73478 2 6 2ZM12 17C12.2652 17 12.5196 17.1054 12.7071 17.2929C12.8946 17.4804 13 17.7348 13 18C13 18.2652 12.8946 18.5196 12.7071 18.7071C12.5196 18.8946 12.2652 19 12 19C11.7348 19 11.4804 18.8946 11.2929 18.7071C11.1054 18.5196 11 18.2652 11 18C11 17.7348 11.1054 17.4804 11.2929 17.2929C11.4804 17.1054 11.7348 17 12 17V17Z"
    ]
  },
  macbook: {
    paths: [
      "M4 5V16H20V5H4ZM2 4.007C2 3.451 2.455 3 2.992 3H21.008C21.556 3 22 3.449 22 4.007V18H2V4.007ZM1 19H23V21H1V19Z"
    ]
  },
  "chat-new": {
    paths: [
      "M14 3V5H4V18.385L5.763 17H20V10H22V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H14ZM19 3V0H21V3H24V5H21V8H19V5H16V3H19Z"
    ]
  },
  "chat-4": {
    paths: [
      "M5.763 17H20V5H4V18.385L5.763 17ZM6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455Z"
    ]
  },
  "question-answer": {
    paths: [
      "M5.455 15L1 18.5V3C1 2.73478 1.10536 2.48043 1.29289 2.29289C1.48043 2.10536 1.73478 2 2 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V15H5.455ZM4.763 13H16V4H3V14.385L4.763 13ZM8 17H18.237L20 18.385V8H21C21.2652 8 21.5196 8.10536 21.7071 8.29289C21.8946 8.48043 22 8.73478 22 9V22.5L17.545 19H9C8.73478 19 8.48043 18.8946 8.29289 18.7071C8.10536 18.5196 8 18.2652 8 18V17Z"
    ]
  },
  "chat-3": {
    paths: [
      "M7.29101 20.824L2.00001 22L3.17601 16.709C2.40154 15.2604 1.99754 13.6426 2.00001 12C2.00001 6.477 6.47701 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C10.3574 22.0025 8.73963 21.5985 7.29101 20.824V20.824ZM7.58101 18.711L8.23401 19.061C9.39256 19.6801 10.6864 20.0027 12 20C13.5823 20 15.129 19.5308 16.4446 18.6518C17.7602 17.7727 18.7855 16.5233 19.391 15.0615C19.9965 13.5997 20.155 11.9911 19.8463 10.4393C19.5376 8.88743 18.7757 7.46197 17.6569 6.34315C16.538 5.22433 15.1126 4.4624 13.5607 4.15372C12.0089 3.84504 10.4004 4.00346 8.93854 4.60896C7.47674 5.21447 6.22731 6.23984 5.34825 7.55544C4.4692 8.87103 4.00001 10.4177 4.00001 12C4.00001 13.334 4.32501 14.618 4.94001 15.766L5.28901 16.419L4.63401 19.366L7.58101 18.711V18.711Z"
    ]
  },
  "chat-2": {
    paths: [
      "M14.45 19L12 22.5L9.55 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H14.45ZM13.409 17H20V5H4V17H10.591L12 19.012L13.409 17V17Z"
    ]
  },
  "chat-check": {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM5.763 17H20V5H4V18.385L5.763 17ZM11.293 12.121L15.536 7.879L16.95 9.293L11.293 14.95L7.403 11.06L8.818 9.646L11.293 12.121V12.121Z"
    ]
  },
  "message-2": {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM5.763 17H20V5H4V18.385L5.763 17ZM11 10H13V12H11V10ZM7 10H9V12H7V10ZM15 10H17V12H15V10Z"
    ]
  },
  feedback: {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM4 18.385L5.763 17H20V5H4V18.385V18.385ZM11 13H13V15H11V13ZM11 7H13V12H11V7Z"
    ]
  },
  "chat-heart": {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM4 18.385L5.763 17H20V5H4V18.385V18.385ZM12.018 14.7L8.659 11.34C8.23704 10.918 7.99999 10.3457 7.99999 9.749C7.99999 9.45352 8.05818 9.16094 8.17126 8.88796C8.28433 8.61497 8.45007 8.36693 8.659 8.158C8.86793 7.94907 9.11597 7.78333 9.38896 7.67026C9.66194 7.55718 9.95452 7.49899 10.25 7.49899C10.8467 7.49899 11.419 7.73604 11.841 8.158L12.018 8.335L12.195 8.158C12.4039 7.94907 12.652 7.78333 12.925 7.67026C13.1979 7.55718 13.4905 7.49899 13.786 7.49899C14.0815 7.49899 14.3741 7.55718 14.647 7.67026C14.92 7.78333 15.1681 7.94907 15.377 8.158C15.5859 8.36693 15.7517 8.61497 15.8647 8.88796C15.9778 9.16094 16.036 9.45352 16.036 9.749C16.036 10.0445 15.9778 10.3371 15.8647 10.61C15.7517 10.883 15.5859 11.1311 15.377 11.34L12.017 14.699L12.018 14.7Z"
    ]
  },
  "chat-delete": {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM4 18.385L5.763 17H20V5H4V18.385V18.385ZM13.414 11L15.889 13.475L14.475 14.889L12 12.414L9.525 14.89L8.111 13.476L10.586 11L8.11 8.525L9.524 7.111L12 9.586L14.475 7.111L15.889 8.525L13.414 11Z"
    ]
  },
  "chat-quote": {
    paths: [
      "M21 3C21.552 3 22 3.448 22 4V18C22 18.552 21.552 19 21 19H6.455L2 22.5V4C2 3.448 2.448 3 3 3H21ZM20 5H4V18.385L5.763 17H20V5ZM10.515 7.412L10.962 8.1C9.294 9.003 9.323 10.452 9.323 10.764C9.478 10.744 9.641 10.74 9.803 10.755C10.705 10.839 11.416 11.58 11.416 12.5C11.416 13.466 10.632 14.25 9.666 14.25C9.129 14.25 8.616 14.005 8.292 13.66C7.777 13.114 7.5 12.5 7.5 11.505C7.5 9.755 8.728 8.187 10.515 7.412V7.412ZM15.515 7.412L15.962 8.1C14.294 9.003 14.323 10.452 14.323 10.764C14.478 10.744 14.641 10.74 14.803 10.755C15.705 10.839 16.416 11.58 16.416 12.5C16.416 13.466 15.632 14.25 14.666 14.25C14.129 14.25 13.616 14.005 13.292 13.66C12.777 13.114 12.5 12.5 12.5 11.505C12.5 9.755 13.728 8.187 15.515 7.412V7.412Z"
    ]
  },
  numbers: {
    paths: [
      "M9 18H4V10H9V18ZM7 16V12H6V16H7ZM13 16V8H12V16H13ZM15 18H10V6H15V18ZM19 16V4H18V16H19ZM21 18H16V2H21V18ZM22 22H3V20H22V22Z"
    ]
  },
  "line-chart": {
    paths: [
      "M5 3V19H21V21H3V3H5ZM20.293 6.293L21.707 7.707L16 13.414L13 10.415L8.707 14.707L7.293 13.293L13 7.586L16 10.585L20.293 6.293V6.293Z"
    ]
  },
  cloud: {
    paths: [
      "M16.9999 21H6.99987C5.5831 21.0009 4.21172 20.5004 3.12856 19.5872C2.0454 18.6739 1.32035 17.4069 1.08178 16.0103C0.843215 14.6138 1.10653 13.1779 1.82511 11.9568C2.54368 10.7358 3.67115 9.80847 5.00787 9.33899C4.96259 8.39265 5.10989 7.44697 5.44083 6.55923C5.77178 5.67149 6.2795 4.86017 6.93322 4.17441C7.58694 3.48866 8.37307 2.94275 9.24398 2.56975C10.1149 2.19675 11.0525 2.00443 11.9999 2.00443C12.9473 2.00443 13.8849 2.19675 14.7558 2.56975C15.6267 2.94275 16.4128 3.48866 17.0665 4.17441C17.7203 4.86017 18.228 5.67149 18.5589 6.55923C18.8899 7.44697 19.0372 8.39265 18.9919 9.33899C20.3286 9.80847 21.4561 10.7358 22.1746 11.9568C22.8932 13.1779 23.1565 14.6138 22.918 16.0103C22.6794 17.4069 21.9543 18.6739 20.8712 19.5872C19.788 20.5004 18.4166 21.0009 16.9999 21ZM16.9999 8.99999C17.0001 8.333 16.8669 7.67269 16.6081 7.05796C16.3493 6.44323 15.9701 5.88649 15.4928 5.42053C15.0156 4.95457 14.4499 4.58881 13.8292 4.34478C13.2084 4.10075 12.5451 3.98339 11.8783 3.9996C11.2115 4.01582 10.5547 4.16528 9.94657 4.43919C9.33841 4.7131 8.7912 5.10592 8.33716 5.59452C7.88312 6.08312 7.53143 6.65763 7.3028 7.28421C7.07417 7.9108 6.97321 8.5768 7.00587 9.24299L7.07587 10.731L5.67187 11.225C4.78238 11.5396 4.03263 12.1583 3.55497 12.9719C3.07732 13.7856 2.90249 14.7418 3.06133 15.6718C3.22018 16.6018 3.7025 17.4458 4.42314 18.0548C5.14378 18.6637 6.0564 18.9985 6.99987 19H16.9999C17.7362 18.9998 18.4582 18.7963 19.0863 18.4119C19.7144 18.0276 20.2242 17.4774 20.5596 16.8219C20.895 16.1663 21.0429 15.431 20.9871 14.6967C20.9312 13.9625 20.6738 13.258 20.2432 12.6607C19.8126 12.0634 19.2254 11.5966 18.5464 11.3116C17.8675 11.0267 17.123 10.9347 16.3951 11.0458C15.6672 11.1569 14.9841 11.4667 14.421 11.9412C13.8579 12.4157 13.4367 13.0364 13.2039 13.735L11.3059 13.102C11.7047 11.9074 12.4692 10.8685 13.491 10.1323C14.5129 9.39613 15.7404 9 16.9999 8.99999Z"
    ]
  },
  "bar-chart-2": {
    paths: [
      "M2 13H8V21H2V13ZM16 8H22V21H16V8ZM9 3H15V21H9V3ZM4 15V19H6V15H4ZM11 5V19H13V5H11ZM18 10V19H20V10H18Z"
    ]
  },
  "chart-mixed": {
    paths: [
      "M564 153C577.8 142 580 121.8 569 108C558 94.2 537.8 92 524 103L383.4 215.5L275.2 134.4C263.5 125.6 247.4 125.9 236 135L76 263C62.2 274 60 294.2 71 308C82 321.8 102.2 324 116 313L256.6 200.5L364.8 281.6C376.5 290.4 392.6 290.1 404 281L564 153zM224 320L224 512C224 529.7 238.3 544 256 544C273.7 544 288 529.7 288 512L288 320C288 302.3 273.7 288 256 288C238.3 288 224 302.3 224 320zM96 416L96 512C96 529.7 110.3 544 128 544C145.7 544 160 529.7 160 512L160 416C160 398.3 145.7 384 128 384C110.3 384 96 398.3 96 416zM384 352C366.3 352 352 366.3 352 384L352 512C352 529.7 366.3 544 384 544C401.7 544 416 529.7 416 512L416 384C416 366.3 401.7 352 384 352zM480 320L480 512C480 529.7 494.3 544 512 544C529.7 544 544 529.7 544 512L544 320C544 302.3 529.7 288 512 288C494.3 288 480 302.3 480 320z"
    ],
    viewBox: "0 0 640 640"
  },
  "mail-close": {
    paths: [
      "M22 14H20V7.238L12.072 14.338L4 7.216V19H15V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V14ZM4.511 5L12.061 11.662L19.502 5H4.511ZM21.414 19L23.536 21.121L22.121 22.536L20 20.414L17.879 22.536L16.464 21.121L18.586 19L16.464 16.879L17.879 15.464L20 17.586L22.121 15.464L23.536 16.879L21.414 19V19Z"
    ]
  },
  "record-mail": {
    paths: [
      "M14.2566 15C13.4613 14.0359 13.018 12.8296 12.9999 11.5798C12.9817 10.3301 13.3898 9.11142 14.1569 8.12461C14.9239 7.13779 16.0042 6.44166 17.2198 6.1509C18.4354 5.86014 19.7138 5.99208 20.8443 6.52499C21.9749 7.0579 22.8903 7.96 23.4396 9.08269C23.9889 10.2054 24.1395 11.4817 23.8665 12.7014C23.5935 13.9211 22.9132 15.0114 21.9376 15.7928C20.9621 16.5741 19.7495 16.9999 18.4996 17H5.49965C4.24977 16.9999 3.0372 16.5741 2.06166 15.7928C1.08613 15.0114 0.40583 13.9211 0.132818 12.7014C-0.140194 11.4817 0.0103691 10.2054 0.559706 9.08269C1.10904 7.96 2.02439 7.0579 3.15496 6.52499C4.28553 5.99208 5.5639 5.86014 6.77949 6.1509C7.99507 6.44166 9.07537 7.13779 9.84243 8.12461C10.6095 9.11142 11.0176 10.3301 10.9994 11.5798C10.9813 12.8296 10.538 14.0359 9.74265 15H14.2566V15ZM5.49965 15C6.4279 15 7.31814 14.6313 7.97452 13.9749C8.6309 13.3185 8.99965 12.4283 8.99965 11.5C8.99965 10.5717 8.6309 9.68151 7.97452 9.02513C7.31814 8.36875 6.4279 8 5.49965 8C4.57139 8 3.68115 8.36875 3.02477 9.02513C2.3684 9.68151 1.99965 10.5717 1.99965 11.5C1.99965 12.4283 2.3684 13.3185 3.02477 13.9749C3.68115 14.6313 4.57139 15 5.49965 15V15ZM18.4996 15C19.4279 15 20.3181 14.6313 20.9745 13.9749C21.6309 13.3185 21.9996 12.4283 21.9996 11.5C21.9996 10.5717 21.6309 9.68151 20.9745 9.02513C20.3181 8.36875 19.4279 8 18.4996 8C17.5714 8 16.6811 8.36875 16.0248 9.02513C15.3684 9.68151 14.9996 10.5717 14.9996 11.5C14.9996 12.4283 15.3684 13.3185 16.0248 13.9749C16.6811 14.6313 17.5714 15 18.4996 15V15Z"
    ]
  },
  refresh: {
    paths: [
      "M12 20C9.76667 20 7.875 19.225 6.325 17.675C4.775 16.125 4 14.2333 4 12C4 9.76667 4.775 7.875 6.325 6.325C7.875 4.775 9.76667 4 12 4C13.15 4 14.25 4.2375 15.3 4.7125C16.35 5.1875 17.25 5.86667 18 6.75V4H20V11H13V9H17.2C16.6667 8.06667 15.9375 7.33333 15.0125 6.8C14.0875 6.26667 13.0833 6 12 6C10.3333 6 8.91667 6.58333 7.75 7.75C6.58333 8.91667 6 10.3333 6 12C6 13.6667 6.58333 15.0833 7.75 16.25C8.91667 17.4167 10.3333 18 12 18C13.2833 18 14.4417 17.6333 15.475 16.9C16.5083 16.1667 17.2333 15.2 17.65 14H19.75C19.2833 15.7667 18.3333 17.2083 16.9 18.325C15.4667 19.4417 13.8333 20 12 20Z"
    ]
  },
  mail: {
    paths: [
      "M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM20 7.238L12.072 14.338L4 7.216V19H20V7.238ZM4.511 5L12.061 11.662L19.502 5H4.511Z"
    ]
  },
  "calendar-2": {
    paths: [
      "M17 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H7V1H9V3H15V1H17V3ZM20 11H4V19H20V11ZM15 5H9V7H7V5H4V9H20V5H17V7H15V5ZM6 13H8V15H6V13ZM11 13H13V15H11V13ZM16 13H18V15H16V13Z"
    ]
  },
  "flag-2": {
    paths: [
      "M4 17V22H2V3H21.138C21.2256 2.99985 21.3118 3.02275 21.3878 3.06639C21.4638 3.11002 21.527 3.17288 21.5711 3.24864C21.6151 3.3244 21.6385 3.41042 21.6388 3.49806C21.6392 3.5857 21.6165 3.6719 21.573 3.748L18 10L21.573 16.252C21.6165 16.3281 21.6392 16.4143 21.6388 16.5019C21.6385 16.5896 21.6151 16.6756 21.5711 16.7514C21.527 16.8271 21.4638 16.89 21.3878 16.9336C21.3118 16.9773 21.2256 17.0001 21.138 17H4ZM4 5V15H18.554L15.696 10L18.554 5H4Z"
    ]
  },
  "send-plane": {
    paths: [
      "M1.92302 9.37001C1.41302 9.16501 1.41902 8.86001 1.95702 8.68101L21.043 2.31901C21.572 2.14301 21.875 2.43901 21.727 2.95701L16.273 22.043C16.123 22.572 15.798 22.596 15.556 22.113L11 13L1.92302 9.37001ZM6.81302 9.17001L12.449 11.425L15.489 17.507L19.035 5.09701L6.81202 9.17001H6.81302Z"
    ]
  },
  "send-plane-2": {
    paths: [
      "M3.741 1.40801L22.203 11.562C22.2814 11.6052 22.3468 11.6686 22.3923 11.7456C22.4378 11.8227 22.4618 11.9105 22.4618 12C22.4618 12.0895 22.4378 12.1774 22.3923 12.2544C22.3468 12.3314 22.2814 12.3949 22.203 12.438L3.741 22.592C3.66487 22.6339 3.57915 22.6552 3.49227 22.6539C3.4054 22.6525 3.32037 22.6286 3.24558 22.5844C3.17078 22.5401 3.1088 22.4772 3.06573 22.4017C3.02267 22.3263 3.00001 22.2409 3 22.154V1.84601C3.00001 1.75913 3.02267 1.67375 3.06573 1.59828C3.1088 1.52282 3.17078 1.45988 3.24558 1.41567C3.32037 1.37146 3.4054 1.3475 3.49227 1.34616C3.57915 1.34482 3.66487 1.36614 3.741 1.40801V1.40801ZM5 13V19.617L18.85 12L5 4.38301V11H10V13H5Z"
    ]
  },
  "mail-add": {
    paths: [
      "M22 13H20V7.238L12.072 14.338L4 7.216V19H14V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V13ZM4.511 5L12.061 11.662L19.502 5H4.511ZM21 18H24V20H21V23H19V20H16V18H19V15H21V18Z"
    ]
  },
  bookmark: {
    paths: [
      "M5 2H19C19.2652 2 19.5196 2.10536 19.7071 2.29289C19.8946 2.48043 20 2.73478 20 3V22.143C20.0001 22.2324 19.9763 22.3202 19.9309 22.3973C19.8855 22.4743 19.8204 22.5378 19.7421 22.5811C19.6639 22.6244 19.5755 22.6459 19.4861 22.6434C19.3968 22.641 19.3097 22.6146 19.234 22.567L12 18.03L4.766 22.566C4.69037 22.6135 4.60339 22.6399 4.5141 22.6424C4.42482 22.6449 4.33649 22.6235 4.2583 22.5803C4.1801 22.5371 4.11491 22.4738 4.06948 22.3969C4.02406 22.32 4.00007 22.2323 4 22.143V3C4 2.73478 4.10536 2.48043 4.29289 2.29289C4.48043 2.10536 4.73478 2 5 2ZM18 4H6V19.432L12 15.671L18 19.432V4Z"
    ]
  },
  "calendar-check": {
    paths: [
      "M9 1V3H15V1H17V3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H7V1H9ZM20 10H4V19H20V10ZM15.036 11.136L16.45 12.55L11.5 17.5L7.964 13.964L9.38 12.55L11.501 14.672L15.037 11.136H15.036ZM7 5H4V8H20V5H17V6H15V5H9V6H7V5Z"
    ]
  },
  "mail-check": {
    paths: [
      "M22 14H20V7.238L12.072 14.338L4 7.216V19H14V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V14ZM4.511 5L12.061 11.662L19.502 5H4.511ZM19 22L15.464 18.464L16.879 17.05L19 19.172L22.536 15.636L23.95 17.05L19 22Z"
    ]
  },
  "mail-send": {
    paths: [
      "M22 20.007C21.9982 20.2696 21.8931 20.521 21.7075 20.7068C21.5219 20.8926 21.2706 20.9979 21.008 21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448 20.5226 2 20.2702 2 20.007V19H20V7.3L12 14.5L2 5.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20.007ZM4.434 5L12 11.81L19.566 5H4.434ZM0 15H8V17H0V15ZM0 10H5V12H0V10Z"
    ]
  },
  "building-4": {
    paths: [
      "M21 20H23V22H1V20H3V3C3 2.73478 3.10536 2.48043 3.29289 2.29289C3.48043 2.10536 3.73478 2 4 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V20ZM19 20V4H5V20H19ZM8 11H11V13H8V11ZM8 7H11V9H8V7ZM8 15H11V17H8V15ZM13 15H16V17H13V15ZM13 11H16V13H13V11ZM13 7H16V9H13V7Z"
    ]
  },
  "home-2": {
    paths: [
      "M19 21H5C4.73478 21 4.48043 20.8947 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H1L11.327 1.61201C11.5111 1.44449 11.7511 1.35165 12 1.35165C12.2489 1.35165 12.4889 1.44449 12.673 1.61201L23 11H20V20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8947 19.2652 21 19 21ZM6 19H18V9.15701L12 3.70301L6 9.15701V19Z"
    ]
  },
  "home-2-filled": {
    paths: [
      "M19 21H5C4.73478 21 4.48043 20.8947 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H1L11.327 1.61201C11.5111 1.44449 11.7511 1.35165 12 1.35165C12.2489 1.35165 12.4889 1.44449 12.673 1.61201L23 11H20V20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8947 19.2652 21 19 21Z"
    ]
  },
  "home+building": {
    paths: [
      "M21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V12.487C1.99998 12.3441 2.03059 12.2029 2.08976 12.0728C2.14892 11.9428 2.23528 11.8269 2.343 11.733L6 8.544V4C6 3.73478 6.10536 3.48043 6.29289 3.29289C6.48043 3.10536 6.73478 3 7 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21ZM9 19H12V12.942L8 9.454L4 12.942V19H7V15H9V19ZM14 19H20V5H8V7.127C8.234 7.127 8.469 7.209 8.657 7.374L13.657 11.733C13.7647 11.8269 13.8511 11.9428 13.9102 12.0728C13.9694 12.2029 14 12.3441 14 12.487V19ZM16 11H18V13H16V11ZM16 15H18V17H16V15ZM16 7H18V9H16V7ZM12 7H14V9H12V7Z"
    ]
  },
  "home-heart": {
    paths: [
      "M20 20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8947 19.2652 21 19 21H5C4.73478 21 4.48043 20.8947 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H1L11.327 1.61201C11.5111 1.44449 11.7511 1.35165 12 1.35165C12.2489 1.35165 12.4889 1.44449 12.673 1.61201L23 11H20V20ZM18 19V9.15701L12 3.70301L6 9.15701V19H18ZM12 17L8.641 13.641C8.43207 13.4321 8.26633 13.184 8.15326 12.9111C8.04018 12.6381 7.98199 12.3455 7.98199 12.05C7.98199 11.7545 8.04018 11.462 8.15326 11.189C8.26633 10.916 8.43207 10.6679 8.641 10.459C8.84993 10.2501 9.09797 10.0843 9.37096 9.97127C9.64394 9.8582 9.93652 9.8 10.232 9.8C10.5275 9.8 10.8201 9.8582 11.093 9.97127C11.366 10.0843 11.6141 10.2501 11.823 10.459L12 10.636L12.177 10.459C12.3859 10.2501 12.634 10.0843 12.907 9.97127C13.1799 9.8582 13.4725 9.8 13.768 9.8C14.0635 9.8 14.3561 9.8582 14.629 9.97127C14.902 10.0843 15.1501 10.2501 15.359 10.459C15.5679 10.6679 15.7337 10.916 15.8467 11.189C15.9598 11.462 16.018 11.7545 16.018 12.05C16.018 12.3455 15.9598 12.6381 15.8467 12.9111C15.7337 13.184 15.5679 13.4321 15.359 13.641L12 17Z"
    ]
  },
  "home-heart-filled": {
    paths: [
      "M20 20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8947 19.2652 21 19 21H5C4.73478 21 4.48043 20.8947 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H1L11.327 1.61201C11.5111 1.44449 11.7511 1.35165 12 1.35165C12.2489 1.35165 12.4889 1.44449 12.673 1.61201L23 11H20V20ZM12 17L8.641 13.641C8.43207 13.4321 8.26633 13.184 8.15326 12.9111C8.04018 12.6381 7.98199 12.3455 7.98199 12.05C7.98199 11.7545 8.04018 11.462 8.15326 11.189C8.26633 10.916 8.43207 10.6679 8.641 10.459C8.84993 10.2501 9.09797 10.0843 9.37096 9.97127C9.64394 9.8582 9.93652 9.8 10.232 9.8C10.5275 9.8 10.8201 9.8582 11.093 9.97127C11.366 10.0843 11.6141 10.2501 11.823 10.459L12 10.636L12.177 10.459C12.3859 10.2501 12.634 10.0843 12.907 9.97127C13.1799 9.8582 13.4725 9.8 13.768 9.8C14.0635 9.8 14.3561 9.8582 14.629 9.97127C14.902 10.0843 15.1501 10.2501 15.359 10.459C15.5679 10.6679 15.7337 10.916 15.8467 11.189C15.9598 11.462 16.018 11.7545 16.018 12.05C16.018 12.3455 15.9598 12.6381 15.8467 12.9111C15.7337 13.184 15.5679 13.4321 15.359 13.641L12 17Z"
    ]
  },
  "arrow-out": {
    paths: [
      "M14.6667 4L16.7111 6.04444L14.1422 8.59556L15.4044 9.85778L17.9556 7.28889L20 9.33333V4L14.6667 4ZM4 9.33333L6.04444 7.28889L8.59556 9.85778L9.85778 8.59556L7.28889 6.04444L9.33333 4L4 4L4 9.33333ZM9.33333 20L7.28889 17.9556L9.85778 15.4044L8.59556 14.1422L6.04444 16.7111L4 14.6667L4 20H9.33333ZM20 14.6667L17.9556 16.7111L15.4044 14.1422L14.1422 15.4044L16.7111 17.9556L14.6667 20L20 20L20 14.6667Z"
    ]
  },
  "touch-point": {
    paths: [
      "M15.8464 13.1714L13.5982 12.0143C14.4933 11.3 15.0693 10.1857 15.0693 8.92857C15.0693 6.76429 13.3553 5 11.2528 5C9.15031 5 7.43637 6.76429 7.43637 8.92857C7.43637 10.45 8.28293 11.7714 9.51808 12.4214V14.75C8.02619 14.4214 8.1164 14.4357 7.94986 14.4357C7.58209 14.4357 7.23514 14.5857 6.97146 14.8571L6 15.8714L9.53195 19.5071C9.83033 19.8214 10.2467 20 10.6769 20H15.0485C15.7285 20 16.3044 19.5 16.4154 18.8071L16.9706 15.4429C17.1232 14.5143 16.6722 13.6 15.8464 13.1714ZM15.6036 15.2071L15.0485 18.5714H10.6769C10.6144 18.5714 10.5589 18.5429 10.5104 18.5L7.9568 15.8714L10.9059 16.5071V8.92857C10.9059 8.72857 11.0585 8.57143 11.2528 8.57143C11.4471 8.57143 11.5998 8.72857 11.5998 8.92857V13.2143H12.821L15.2219 14.45C15.4995 14.5929 15.6522 14.9 15.6036 15.2071ZM8.82417 8.92857C8.82417 7.55 9.9136 6.42857 11.2528 6.42857C12.5921 6.42857 13.6815 7.55 13.6815 8.92857C13.6815 9.60714 13.4178 10.2214 12.9876 10.6714V8.92857C12.9876 7.94286 12.2104 7.14286 11.2528 7.14286C10.2952 7.14286 9.51808 7.94286 9.51808 8.92857V10.6714C9.08786 10.2214 8.82417 9.60714 8.82417 8.92857Z"
    ]
  },
  tag: {
    paths: [
      "M8.6 8.8C9.26274 8.8 9.8 8.26274 9.8 7.6C9.8 6.93726 9.26274 6.4 8.6 6.4C7.93726 6.4 7.4 6.93726 7.4 7.6C7.4 8.26274 7.93726 8.8 8.6 8.8Z",
      "M20.528 11.664L13.328 4.464C13.04 4.176 12.64 4 12.2 4H6.6C5.72 4 5 4.72 5 5.6V11.2C5 11.64 5.176 12.04 5.472 12.336L12.672 19.536C12.96 19.824 13.36 20 13.8 20C14.24 20 14.64 19.824 14.928 19.528L20.528 13.928C20.824 13.64 21 13.24 21 12.8C21 12.36 20.816 11.952 20.528 11.664ZM13.8 18.408L6.6 11.2V5.6H12.2V5.592L19.4 12.792L13.8 18.408V18.408Z"
    ]
  },
  angle: {
    paths: [
      "M14.6,17.8c0.4,0.4,0.4,1,0,1.4l0,0c-0.4,0.4-1,0.4-1.4,0l-7.1-7.1L13.2,5c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4L9,12",
      "M12.8,18l-1.4-1.4c2.6-2.6,2.6-6.7,0-9.3L12.8,6C16.1,9.3,16.1,14.7,12.8,18z"
    ]
  },
  percent: {
    paths: [
      "M19 3.58587L3.58594 18.9999L5.00014 20.4141L20.4142 5.00006L19 3.58587Z",
      "M7 11C9.209 11 11 9.209 11 7C11 4.791 9.209 3 7 3C4.791 3 3 4.791 3 7C3 9.209 4.791 11 7 11ZM7 5C8.103 5 9 5.897 9 7C9 8.103 8.103 9 7 9C5.897 9 5 8.103 5 7C5 5.897 5.897 5 7 5Z",
      "M17 21C19.209 21 21 19.209 21 17C21 14.791 19.209 13 17 13C14.791 13 13 14.791 13 17C13 19.209 14.791 21 17 21ZM17 15C18.103 15 19 15.897 19 17C19 18.103 18.103 19 17 19C15.897 19 15 18.103 15 17C15 15.897 15.897 15 17 15Z"
    ]
  },
  bolt: {
    paths: [
      "M10.0568 1.36475L3.20312 9.83535H7.204L6.21909 15.25C6.21722 15.2606 6.2177 15.2715 6.2205 15.2819C6.22329 15.2923 6.22834 15.302 6.23529 15.3103C6.24223 15.3185 6.2509 15.3251 6.26069 15.3297C6.27047 15.3342 6.28113 15.3366 6.29192 15.3365V15.3365C6.3034 15.3365 6.31472 15.3338 6.32497 15.3287C6.33523 15.3235 6.34414 15.3161 6.351 15.3068L13.2053 6.83469H9.20443L10.194 1.41945C10.1954 1.40866 10.1944 1.39772 10.1911 1.38734C10.1879 1.37696 10.1825 1.36738 10.1753 1.35925C10.1681 1.35112 10.1592 1.34462 10.1493 1.34018C10.1394 1.33574 10.1286 1.33346 10.1178 1.3335V1.3335C10.1059 1.33354 10.0941 1.3364 10.0835 1.34183C10.0729 1.34726 10.0638 1.35512 10.0568 1.36475V1.36475Z"
    ],
    viewBox: "0 0 16 16"
  },
  "resize-handlebar": {
    paths: ["M20 9H4V11H20V9ZM4 15H20V13H4V15Z"],
    viewBox: "0 0 24 24"
  },
  "resize-vertical": {
    paths: [
      "M11.891 9.992a1 1 0 1 1 1.416 1.415l-4.3 4.3a1 1 0 0 1-1.414 0l-4.3-4.3A1 1 0 0 1 4.71 9.992l3.59 3.591 3.591-3.591zm0-3.984L8.3 2.417 4.709 6.008a1 1 0 0 1-1.416-1.415l4.3-4.3a1 1 0 0 1 1.414 0l4.3 4.3a1 1 0 1 1-1.416 1.415z"
    ],
    viewBox: "0 0 16 16"
  },
  "share-forward-fill-down": {
    paths: [
      "M5 10L5 8C5.00063 6.3596 4.55286 4.75023 3.7051 3.34588C2.85734 1.94152 1.64184 0.795601 0.190001 0.0320007C0.459466 0.0105373 0.729681 -0.00013795 1 6.76941e-07C6.523 9.18359e-07 11 4.477 11 10L16 10L8 20L-4.37114e-07 10L5 10Z"
    ],
    viewBox: "0 0 16 20"
  },
  "directions-car": {
    paths: [
      "M15.7667 5.00841C15.6 4.51675 15.1333 4.16675 14.5833 4.16675H5.41667C4.86667 4.16675 4.40833 4.51675 4.23333 5.00841L2.5 10.0001V16.6667C2.5 17.1251 2.875 17.5001 3.33333 17.5001H4.16667C4.625 17.5001 5 17.1251 5 16.6667V15.8334H15V16.6667C15 17.1251 15.375 17.5001 15.8333 17.5001H16.6667C17.125 17.5001 17.5 17.1251 17.5 16.6667V10.0001L15.7667 5.00841ZM5.70833 5.83341H14.2833L15.1833 8.42508H4.80833L5.70833 5.83341ZM15.8333 14.1667H4.16667V10.0001H15.8333V14.1667Z",
      "M6.25 13.3333C6.94036 13.3333 7.5 12.7736 7.5 12.0833C7.5 11.3929 6.94036 10.8333 6.25 10.8333C5.55964 10.8333 5 11.3929 5 12.0833C5 12.7736 5.55964 13.3333 6.25 13.3333Z",
      "M13.75 13.3333C14.4404 13.3333 15 12.7736 15 12.0833C15 11.3929 14.4404 10.8333 13.75 10.8333C13.0596 10.8333 12.5 11.3929 12.5 12.0833C12.5 12.7736 13.0596 13.3333 13.75 13.3333Z"
    ]
  },
  roofing: {
    paths: [
      "M10.8337 15H9.16699V13.3333H10.8337V15ZM12.5003 11.6667H7.50033V16.6667H12.5003V11.6667ZM15.8337 7.75V3.33333H13.3337V5.5L10.0003 2.5L1.66699 10H4.16699L10.0003 4.74167L15.8337 10H18.3337L15.8337 7.75Z"
    ]
  },
  hotel: {
    paths: [
      "M5.83301 11.6667C7.21634 11.6667 8.33301 10.5501 8.33301 9.16675C8.33301 7.78341 7.21634 6.66675 5.83301 6.66675C4.44967 6.66675 3.33301 7.78341 3.33301 9.16675C3.33301 10.5501 4.44967 11.6667 5.83301 11.6667ZM5.83301 8.33341C6.29134 8.33341 6.66634 8.70841 6.66634 9.16675C6.66634 9.62508 6.29134 10.0001 5.83301 10.0001C5.37467 10.0001 4.99967 9.62508 4.99967 9.16675C4.99967 8.70841 5.37467 8.33341 5.83301 8.33341ZM15.833 5.83341H9.16634V12.5001H2.49967V4.16675H0.833008V16.6667H2.49967V14.1667H17.4997V16.6667H19.1663V9.16675C19.1663 7.32508 17.6747 5.83341 15.833 5.83341ZM17.4997 12.5001H10.833V7.50008H15.833C16.7497 7.50008 17.4997 8.25008 17.4997 9.16675V12.5001Z"
    ]
  },
  hvac: {
    paths: [
      "M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 15.8333H4.16667V4.16667H15.8333V15.8333Z",
      "M10 15C12.7583 15 15 12.7583 15 10C15 7.24167 12.7583 5 10 5C7.24167 5 5 7.24167 5 10C5 12.7583 7.24167 15 10 15ZM12.8667 8.33333C13.0833 8.70833 13.2333 9.13333 13.2917 9.58333H6.70833C6.76667 9.13333 6.90833 8.70833 7.13333 8.33333H12.8667ZM13.2917 10.4167C13.2333 10.8667 13.0917 11.2917 12.8667 11.6667H7.13333C6.91667 11.2917 6.76667 10.8667 6.70833 10.4167H13.2917ZM7.81667 12.5H12.1833C11.6 13.0083 10.8417 13.3333 10 13.3333C9.15833 13.3333 8.40833 13.0083 7.81667 12.5ZM12.1833 7.5H7.81667C8.4 6.99167 9.15833 6.66667 10 6.66667C10.8417 6.66667 11.5917 6.99167 12.1833 7.5Z"
    ]
  },
  "rotate-right": {
    paths: [
      "M15.55 5.55L11 1V4.07C7.06 4.56 4 7.92 4 12C4 16.08 7.05 19.44 11 19.93V17.91C8.16 17.43 6 14.97 6 12C6 9.03 8.16 6.57 11 6.09V10L15.55 5.55ZM19.93 11C19.76 9.61 19.21 8.27 18.31 7.11L16.89 8.53C17.43 9.28 17.77 10.13 17.91 11H19.93ZM13 17.9V19.92C14.39 19.75 15.74 19.21 16.9 18.31L15.46 16.87C14.71 17.41 13.87 17.76 13 17.9ZM16.89 15.48L18.31 16.89C19.21 15.73 19.76 14.39 19.93 13H17.91C17.77 13.87 17.43 14.72 16.89 15.48V15.48Z"
    ]
  },
  "side-nav-collapse-2": {
    paths: [
      "M4.05579 18H17.479V16H4.05579V18ZM4.05579 13H14.3814V11H4.05579V13ZM4.05579 6V8H17.479V6H4.05579ZM22.6418 15.59L18.9453 12L22.6418 8.41L21.1859 7L16.0231 12L21.1859 17L22.6418 15.59Z"
    ],
    viewBox: "0 0 26 24"
  },
  "side-nav-expand-2": {
    paths: [
      "M21 6L8 6V8L21 8V6ZM21 11H11V13H21V11ZM21 18V16L8 16V18H21ZM3 8.41L6.58 12L3 15.59L4.41 17L9.41 12L4.41 7L3 8.41Z"
    ],
    viewBox: "0 0 24 24"
  },
  "cloud-upload": {
    paths: [
      "M22.4788 69.1667C17.2337 69.1667 12.7523 67.3511 9.03457 63.7198C5.31686 60.0886 3.45801 55.6504 3.45801 50.4052C3.45801 45.9094 4.81252 41.9035 7.52155 38.3875C10.2306 34.8716 13.7754 32.6237 18.1559 31.6438C19.5969 26.341 22.4788 22.0469 26.8018 18.7615C31.1247 15.4761 36.024 13.8334 41.4997 13.8334C48.2434 13.8334 53.9641 16.1822 58.6617 20.8797C63.3592 25.5773 65.708 31.298 65.708 38.0417C69.6851 38.5028 72.9849 40.2176 75.6075 43.186C78.2301 46.1544 79.5413 49.6271 79.5413 53.6042C79.5413 57.9271 78.0283 61.6016 75.0023 64.6276C71.9762 67.6537 68.3018 69.1667 63.9788 69.1667H44.958C43.0559 69.1667 41.4276 68.4895 40.0731 67.1349C38.7186 65.7804 38.0413 64.1521 38.0413 62.25V44.4396L32.508 49.8L27.6663 44.9584L41.4997 31.125L55.333 44.9584L50.4913 49.8L44.958 44.4396V62.25H63.9788C66.3997 62.25 68.4459 61.4143 70.1174 59.7427C71.7889 58.0712 72.6247 56.025 72.6247 53.6042C72.6247 51.1834 71.7889 49.1372 70.1174 47.4657C68.4459 45.7941 66.3997 44.9584 63.9788 44.9584H58.7913V38.0417C58.7913 33.2577 57.1054 29.1797 53.7335 25.8079C50.3617 22.436 46.2837 20.75 41.4997 20.75C36.7156 20.75 32.6377 22.436 29.2658 25.8079C25.8939 29.1797 24.208 33.2577 24.208 38.0417H22.4788C19.1358 38.0417 16.2827 39.2233 13.9195 41.5865C11.5563 43.9497 10.3747 46.8028 10.3747 50.1459C10.3747 53.4889 11.5563 56.3421 13.9195 58.7052C16.2827 61.0684 19.1358 62.25 22.4788 62.25H31.1247V69.1667H22.4788Z"
    ],
    viewBox: "0 0 83 83"
  },
  "mls-listing": {
    paths: [
      "M19 14V7.5L14 4L9 7.5V9H7V6.5L14 1.5L21 6.5V14H19ZM14.5 8H15.5V7H14.5V8ZM12.5 8H13.5V7H12.5V8ZM14.5 10H15.5V9H14.5V10ZM12.5 10H13.5V9H12.5V10ZM14 22.5L7 20.55V22H1V11H8.95L15.15 13.3C15.7 13.5 16.1458 13.85 16.4875 14.35C16.8292 14.85 17 15.4 17 16H19C19.8333 16 20.5417 16.275 21.125 16.825C21.7083 17.375 22 18.1 22 19V20L14 22.5ZM3 20H5V13H3V20ZM13.95 20.4L19.9 18.55C19.85 18.3667 19.7375 18.2292 19.5625 18.1375C19.3875 18.0458 19.2 18 19 18H14.2C13.6833 18 13.2167 17.9667 12.8 17.9C12.3833 17.8333 11.9333 17.7167 11.45 17.55L9.725 16.95L10.3 15.05L12.3 15.7C12.6 15.8 12.95 15.875 13.35 15.925C13.75 15.975 14.3 16 15 16C15 15.8167 14.9458 15.6417 14.8375 15.475C14.7292 15.3083 14.6 15.2 14.45 15.15L8.6 13H7V18.5L13.95 20.4Z"
    ]
  },
  "street-view": {
    paths: [
      "M7.875 18C6.59167 18 5.61667 17.525 4.95 16.575C4.28333 15.625 3.96667 14.5583 4 13.375L3.55 12.7C3.36667 12.4167 3.0625 11.775 2.6375 10.775C2.2125 9.775 2 8.51667 2 7C2 5.28333 2.425 3.85417 3.275 2.7125C4.125 1.57083 5.2 1 6.5 1C7.91667 1 9.02083 1.62917 9.8125 2.8875C10.6042 4.14583 11 5.51667 11 7C11 7.96667 10.8667 8.85833 10.6 9.675C10.3333 10.4917 10.1 11.15 9.9 11.65L10.1 11.975C10.2333 12.2083 10.4167 12.5792 10.65 13.0875C10.8833 13.5958 11 14.125 11 14.675C11 15.625 10.7042 16.4167 10.1125 17.05C9.52083 17.6833 8.775 18 7.875 18ZM5.25 11.6L8 11.05C8.21667 10.5167 8.4375 9.90833 8.6625 9.225C8.8875 8.54167 9 7.8 9 7C9 6 8.77083 5.08333 8.3125 4.25C7.85417 3.41667 7.25 3 6.5 3C5.75 3 5.14583 3.41667 4.6875 4.25C4.22917 5.08333 4 6 4 7C4 8.05 4.14583 8.97917 4.4375 9.7875C4.72917 10.5958 5 11.2 5.25 11.6ZM7.875 16C8.19167 16 8.45833 15.8833 8.675 15.65C8.89167 15.4167 9 15.0917 9 14.675C9 14.3917 8.93333 14.1 8.8 13.8C8.66667 13.5 8.53333 13.2333 8.4 13L6 13.5C6 14.1667 6.14583 14.75 6.4375 15.25C6.72917 15.75 7.20833 16 7.875 16ZM16.125 23C15.225 23 14.4792 22.6833 13.8875 22.05C13.2958 21.4167 13 20.625 13 19.675C13 19.125 13.1167 18.5958 13.35 18.0875C13.5833 17.5792 13.7667 17.2083 13.9 16.975L14.1 16.65C13.9 16.15 13.6667 15.4917 13.4 14.675C13.1333 13.8583 13 12.9667 13 12C13 10.5167 13.3958 9.14583 14.1875 7.8875C14.9792 6.62917 16.0833 6 17.5 6C18.8 6 19.875 6.57083 20.725 7.7125C21.575 8.85417 22 10.2833 22 12C22 13.5167 21.7875 14.7708 21.3625 15.7625C20.9375 16.7542 20.6333 17.3917 20.45 17.675L20 18.375C20.0167 19.5583 19.6958 20.625 19.0375 21.575C18.3792 22.525 17.4083 23 16.125 23ZM18.75 16.6C19 16.2 19.2708 15.6 19.5625 14.8C19.8542 14 20 13.0667 20 12C20 11 19.7708 10.0833 19.3125 9.25C18.8542 8.41667 18.25 8 17.5 8C16.75 8 16.1458 8.41667 15.6875 9.25C15.2292 10.0833 15 11 15 12C15 12.8 15.1125 13.5375 15.3375 14.2125C15.5625 14.8875 15.7833 15.5 16 16.05L18.75 16.6ZM16.125 21C16.7917 21 17.2708 20.75 17.5625 20.25C17.8542 19.75 18 19.1667 18 18.5L15.6 18C15.4667 18.2333 15.3333 18.5 15.2 18.8C15.0667 19.1 15 19.3917 15 19.675C15 20.0083 15.1042 20.3125 15.3125 20.5875C15.5208 20.8625 15.7917 21 16.125 21Z"
    ]
  },
  "play-button": {
    paths: [
      "M9.5 16.5L16.5 12L9.5 7.5V16.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
    ]
  },
  "arrow-left-right": {
    paths: ["M6.99 11 3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"]
  },
  warning: {
    paths: ["M10.5 17H13.5V20H10.5V17ZM10.5 4H13.5V14H10.5V4Z"]
  },
  attachment: {
    paths: [
      "M19 20.9999H5C4.73478 20.9999 4.48043 20.8946 4.29289 20.707C4.10536 20.5195 4 20.2651 4 19.9999V10.9999H1L11.327 1.61192C11.5111 1.4444 11.7511 1.35156 12 1.35156C12.2489 1.35156 12.4889 1.4444 12.673 1.61192L23 10.9999H20V19.9999C20 20.2651 19.8946 20.5195 19.7071 20.707C19.5196 20.8946 19.2652 20.9999 19 20.9999ZM6 18.9999H18V9.15692L12 3.70292L6 9.15692V18.9999Z"
    ]
  },
  bedrooms: {
    paths: [
      "M21.9875 13V18.9875H20.0125V17V16.9875H20H4H3.9875V17V18.9875H2.0125V13C2.0125 12.5517 2.1038 12.1454 2.28618 11.7806C2.46885 11.4152 2.70964 11.0914 3.00858 10.8091L3.0125 10.8132V10.8V8C3.0125 7.16994 3.30288 6.4648 3.88384 5.88384C4.4648 5.30288 5.16994 5.0125 6 5.0125H10C10.3818 5.0125 10.7384 5.08303 11.0701 5.224C11.4022 5.36512 11.7094 5.56022 11.9917 5.80937L12 5.81667L12.0083 5.80937C12.2906 5.56022 12.5978 5.36512 12.9299 5.224C13.2616 5.08303 13.6182 5.0125 14 5.0125H18C18.8301 5.0125 19.5352 5.30288 20.1162 5.88384C20.6971 6.4648 20.9875 7.16994 20.9875 8V10.8H20.9818L20.9914 10.8091C21.2904 11.0914 21.5311 11.4152 21.7138 11.7806C21.8962 12.1454 21.9875 12.5517 21.9875 13ZM12.9875 10V10.0125H13H19H19.0125V10V8C19.0125 7.71352 18.9155 7.47279 18.7213 7.27866C18.5272 7.08453 18.2865 6.9875 18 6.9875H14C13.7135 6.9875 13.4728 7.08453 13.2787 7.27866C13.0845 7.47279 12.9875 7.71352 12.9875 8V10ZM4.9875 10V10.0125H5H11H11.0125V10V8C11.0125 7.71352 10.9155 7.47279 10.7213 7.27866C10.5272 7.08453 10.2865 6.9875 10 6.9875H6C5.71352 6.9875 5.47279 7.08453 5.27866 7.27866C5.08453 7.47279 4.9875 7.71352 4.9875 8V10ZM3.9875 15V15.0125H4H20H20.0125V15V13C20.0125 12.7135 19.9155 12.4728 19.7213 12.2787C19.5272 12.0845 19.2865 11.9875 19 11.9875H5C4.71352 11.9875 4.47279 12.0845 4.27866 12.2787C4.08453 12.4728 3.9875 12.7135 3.9875 13V15Z"
    ]
  },
  "basement-sf": {
    paths: [
      "M10.425 14.6625H10.4125V14.675V17.9875H6.0125V16.0125H8.425H8.4375V16V12.6625H11H11.0125V12.65V9.3375H13.575H13.5875V9.325V6.0125H17.9875V7.9875H15.575H15.5625V8V11.3375H13H12.9875V11.35V14.6625H10.425ZM4.9875 19V19.0125H5H19H19.0125V19V5V4.9875H19H5H4.9875V5V19ZM5 20.9875C4.45334 20.9875 3.98568 20.793 3.59634 20.4037C3.207 20.0143 3.0125 19.5467 3.0125 19V5C3.0125 4.45334 3.207 3.98568 3.59634 3.59634C3.98568 3.207 4.45334 3.0125 5 3.0125H19C19.5467 3.0125 20.0143 3.207 20.4037 3.59634C20.793 3.98568 20.9875 4.45334 20.9875 5V19C20.9875 19.5467 20.793 20.0143 20.4037 20.4037C20.0143 20.793 19.5467 20.9875 19 20.9875H5Z"
    ]
  },
  baths: {
    paths: [
      "M12.1719 4.23869C12.1719 4.38228 12.2883 4.49869 12.4319 4.49869H17.5959C17.7395 4.49869 17.8559 4.38228 17.8559 4.23869V2.81469C17.8559 2.67109 17.7395 2.55469 17.5959 2.55469H12.4319C12.2883 2.55469 12.1719 2.67109 12.1719 2.81469V4.23869ZM19.7263 1.94402C19.8165 1.94492 19.9034 1.97627 19.9731 2.03236C19.9842 2.04133 19.9949 2.05094 20.0052 2.06116C20.0726 2.12865 20.1135 2.21778 20.121 2.31225C20.1216 2.31881 20.1219 2.32539 20.1221 2.332C20.1223 2.33599 20.1223 2.33999 20.1223 2.344V10.44H21.9983V2.332C22.0047 1.72796 21.774 1.14576 21.3562 0.710149C21.352 0.705792 21.3478 0.701451 21.3436 0.697124C20.9178 0.260125 20.3363 0.00948271 19.7263 0H16.3343C16.329 8.20692e-05 16.3236 0.00018281 16.3182 0.000302187C16.048 0.0063234 15.7833 0.0597554 15.5355 0.156C15.3848 0.214518 15.2404 0.288864 15.1047 0.378003C15.023 0.43162 14.9446 0.49059 14.8698 0.554688C14.8395 0.580701 14.8098 0.607559 14.7807 0.635246C14.5696 0.836301 14.4004 1.07367 14.2798 1.33356C14.1607 1.59017 14.0888 1.86874 14.0703 2.156H16.0063C16.03 2.10622 16.0644 2.0625 16.1069 2.02785C16.118 2.01874 16.1297 2.01025 16.1419 2.00245C16.1995 1.96569 16.2661 1.9455 16.3343 1.94406C16.3356 1.94403 16.337 1.94401 16.3383 1.944H19.7223C19.7236 1.944 19.725 1.94401 19.7263 1.94402ZM0 11V15C0 17.2091 1.79086 19 4 19H20C22.2091 19 24 17.2091 24 15V11H0ZM22 13H2V15C2 16.1046 2.89543 17 4 17H20C21.1046 17 22 16.1046 22 15V13Z"
    ]
  },
  cooling: {
    paths: [
      "M11.25 21.75V17.2538L7.74998 20.7038L6.69615 19.65L11.25 15.0961V12.75H8.90383L4.34998 17.3038L3.29615 16.25L6.74617 12.75H2.25V11.25H6.74617L3.29615 7.74998L4.34998 6.69615L8.90383 11.25H11.25V8.90383L6.69615 4.34998L7.74998 3.29615L11.25 6.74618V2.25H12.75V6.74618L16.25 3.29615L17.3038 4.34998L12.75 8.90383V11.25H15.0961L19.65 6.69615L20.7038 7.74998L17.2538 11.25H21.75V12.75H17.2538L20.7038 16.25L19.65 17.3038L15.0961 12.75H12.75V15.0961L17.3038 19.65L16.25 20.7038L12.75 17.2538V21.75L11.25 21.75Z"
    ]
  },
  "energy-efficiency": {
    paths: [
      "M11.077 23.0355V19.5088H12.923V23.0354L11.077 23.0355ZM0 11.9585V10.1124H3.52662V11.9585H0ZM20.4734 11.9585V10.1124H24V11.9585H20.4734ZM19.4083 20.3561L16.942 17.8899L18.2391 16.5929L20.7053 19.0591L19.4083 20.3561ZM4.5917 20.3561L3.29469 19.0591L5.76094 16.5929L7.05796 17.8899L4.5917 20.3561ZM12 16.5739C10.4631 16.5739 9.15584 16.035 8.07811 14.9573C7.00041 13.8796 6.46156 12.5723 6.46156 11.0354C6.46156 10.0982 6.68207 9.22953 7.1231 8.42953C7.56412 7.62952 8.16412 6.9676 8.9231 6.44374V1H15.0769V6.44374C15.8359 6.9676 16.4359 7.62952 16.8769 8.42953C17.3179 9.22953 17.5384 10.0982 17.5384 11.0354C17.5384 12.5723 16.9996 13.8796 15.9219 14.9573C14.8442 16.035 13.5369 16.5739 12 16.5739ZM10.7692 5.64377C10.9744 5.59484 11.1775 5.55815 11.3787 5.5337C11.5799 5.50923 11.787 5.497 12 5.497C12.213 5.497 12.4201 5.50923 12.6213 5.5337C12.8225 5.55815 13.0256 5.59484 13.2308 5.64377V2.8461H10.7692V5.64377ZM12 14.7278C13.0256 14.7278 13.8974 14.3688 14.6154 13.6508C15.3333 12.9329 15.6923 12.0611 15.6923 11.0354C15.6923 10.0098 15.3333 9.138 14.6154 8.42005C13.8974 7.7021 13.0256 7.34312 12 7.34312C10.9744 7.34312 10.1026 7.7021 9.38461 8.42005C8.66666 9.138 8.30768 10.0098 8.30768 11.0354C8.30768 12.0611 8.66666 12.9329 9.38461 13.6508C10.1026 14.3688 10.9744 14.7278 12 14.7278Z"
    ]
  },
  gla: {
    paths: [
      "M5.81519 20.2306C5.24341 20.2306 4.75944 20.0325 4.36329 19.6363C3.96713 19.2402 3.76904 18.7562 3.76904 18.1844V6.31147C3.76904 5.88584 3.96039 5.59001 4.34309 5.42397C4.72578 5.25796 5.06134 5.31918 5.34979 5.60765L7.21517 7.473L6.15364 8.5345L6.73824 9.11912L7.79977 8.0576L10.169 10.4268L9.10747 11.4883L9.69207 12.0729L10.7536 11.0114L13.1613 13.4191L12.0997 14.4806L12.6844 15.0652L13.7459 14.0037L16.1151 16.3729L15.0536 17.4344L15.6382 18.019L16.6997 16.9575L18.4112 18.669C18.6933 18.9511 18.7513 19.2819 18.5852 19.6613C18.4192 20.0408 18.1266 20.2306 17.7074 20.2306H5.81519ZM6.30749 17.9998H14.2998L5.99977 9.69985V17.6921C5.99977 17.7819 6.02862 17.8556 6.08632 17.9133C6.14402 17.971 6.21774 17.9998 6.30749 17.9998Z"
    ]
  },
  heating: {
    paths: [
      "M8.01665 18.5093L8.04463 18.5344L8.03726 18.4975C8.02071 18.4148 8.0125 18.3407 8.0125 18.275V18.05C8.0125 17.5183 8.11219 17.02 8.31149 16.5549C8.51081 16.0898 8.80151 15.6662 9.18376 15.2839C9.18379 15.2839 9.18381 15.2839 9.18384 15.2838L12 12.5175L14.8162 15.2838C14.8162 15.2839 14.8162 15.2839 14.8162 15.2839C15.1985 15.6662 15.4892 16.0898 15.6885 16.5549C15.8878 17.02 15.9875 17.5183 15.9875 18.05V18.275C15.9875 18.3407 15.9793 18.4148 15.9627 18.4975L15.9554 18.5344L15.9833 18.5093C16.6346 17.9248 17.1357 17.2443 17.4864 16.4676C17.8371 15.691 18.0125 14.8684 18.0125 14C18.0125 13.1651 17.858 12.3759 17.549 11.6327C17.2401 10.8895 16.7933 10.2256 16.2088 9.64116L16.2017 9.634L16.1932 9.63952C15.8608 9.85556 15.5119 10.0175 15.1465 10.1255C14.7809 10.2335 14.4071 10.2875 14.025 10.2875C12.9947 10.2875 12.1019 9.94695 11.3459 9.26571C10.5898 8.58438 10.1537 7.74549 10.0374 6.74855L10.0347 6.7254L10.0169 6.74046C9.36645 7.29086 8.79094 7.86218 8.29045 8.45443C7.79 9.04664 7.3687 9.64728 7.0266 10.2564C6.68447 10.8655 6.42574 11.4873 6.25045 12.1217C6.07517 12.756 5.9875 13.3821 5.9875 14C5.9875 14.8684 6.16286 15.691 6.51361 16.4676C6.86434 17.2443 7.36539 17.9248 8.01665 18.5093ZM12.0088 15.2911L12 15.2825L11.9912 15.2911L10.5662 16.6911L10.5662 16.6912C10.3817 16.8756 10.2392 17.0852 10.1385 17.3201C10.0379 17.5549 9.9875 17.7983 9.9875 18.05C9.9875 18.5868 10.1848 19.0483 10.5788 19.4339C10.9728 19.8196 11.4467 20.0125 12 20.0125C12.5533 20.0125 13.0272 19.8196 13.4212 19.4339C13.8152 19.0483 14.0125 18.5868 14.0125 18.05C14.0125 17.7817 13.9622 17.5342 13.8614 17.3074C13.7608 17.0809 13.6182 16.8755 13.4338 16.6912L13.4338 16.6911L12.0088 15.2911ZM14.8679 8.12375C15.1281 7.99786 15.3587 7.80911 15.5597 7.55784C15.5597 7.55783 15.5598 7.55782 15.5598 7.55781L16.003 7.01608C17.23 7.71458 18.2004 8.68622 18.9142 9.93122C19.6297 11.1793 19.9875 12.5355 19.9875 14C19.9875 16.2301 19.2138 18.1186 17.6662 19.6662C16.1186 21.2138 14.2301 21.9875 12 21.9875C9.76991 21.9875 7.88145 21.2138 6.33384 19.6662C4.78623 18.1186 4.0125 16.2301 4.0125 14C4.0125 11.853 4.73226 9.81392 6.17252 7.88247C7.60933 5.95566 9.54753 4.33509 11.9875 3.02092V6.3C11.9875 6.8699 12.1846 7.34816 12.5788 7.73393C12.9728 8.11964 13.4552 8.3125 14.025 8.3125C14.3268 8.3125 14.6078 8.24961 14.8679 8.12375Z"
    ]
  },
  "lot-size": {
    paths: [
      "M5 22V20H11V16H9C7.61667 16 6.4375 15.5125 5.4625 14.5375C4.4875 13.5625 4 12.3833 4 11C4 10 4.275 9.07917 4.825 8.2375C5.375 7.39583 6.11667 6.78333 7.05 6.4C7.2 5.15 7.74583 4.10417 8.6875 3.2625C9.62917 2.42083 10.7333 2 12 2C13.2667 2 14.3708 2.42083 15.3125 3.2625C16.2542 4.10417 16.8 5.15 16.95 6.4C17.8833 6.78333 18.625 7.39583 19.175 8.2375C19.725 9.07917 20 10 20 11C20 12.3833 19.5125 13.5625 18.5375 14.5375C17.5625 15.5125 16.3833 16 15 16H13V20H19V22H5ZM9 14H15C15.8333 14 16.5417 13.7083 17.125 13.125C17.7083 12.5417 18 11.8333 18 11C18 10.4 17.8292 9.85 17.4875 9.35C17.1458 8.85 16.7 8.48333 16.15 8.25L15.1 7.8L14.95 6.65C14.85 5.9 14.5208 5.27083 13.9625 4.7625C13.4042 4.25417 12.75 4 12 4C11.25 4 10.5958 4.25417 10.0375 4.7625C9.47917 5.27083 9.15 5.9 9.05 6.65L8.9 7.8L7.85 8.25C7.3 8.48333 6.85417 8.85 6.5125 9.35C6.17083 9.85 6 10.4 6 11C6 11.8333 6.29167 12.5417 6.875 13.125C7.45833 13.7083 8.16667 14 9 14Z"
    ]
  },
  "patio-porch": {
    paths: [
      "M12 2.01526L21.9603 8.9875H13H12.9875V9V21.9875H11.0125V9V8.9875H11H2.03965L12 2.01526ZM4.9 16.0125H8.9875V21.9875H7.0125V18V17.9875H7H5H4.9875V18V21.9875H3.0125V16.75H3.0127L3.0123 16.7478L2.21454 12.3601L4.14 12.0145L4.88771 16.0023L4.88963 16.0125H4.9ZM19.86 12.0145L21.7855 12.3601L20.9877 16.7478L20.9875 16.7477V16.75V21.9875H19.0125V18V17.9875H19H17H16.9875V18V21.9875H15.0125V16.0125H19.1H19.1104L19.1123 16.0023L19.86 12.0145ZM8.34284 6.98975L8.31028 7.0125H8.35H15.65H15.6897L15.6572 6.98975L12.0072 4.43975L12 4.43475L11.9928 4.43975L8.34284 6.98975Z"
    ]
  },
  pool: {
    paths: [
      "M2 20.3484V18.3984C2.48333 18.3984 2.89583 18.3234 3.2375 18.1734C3.57917 18.0234 3.925 17.8609 4.275 17.6859C4.625 17.5109 5.0125 17.3526 5.4375 17.2109C5.8625 17.0693 6.38333 16.9984 7 16.9984C7.63333 16.9984 8.15417 17.0693 8.5625 17.2109C8.97083 17.3526 9.35 17.5109 9.7 17.6859C10.05 17.8609 10.4 18.0234 10.75 18.1734C11.1 18.3234 11.5167 18.3984 12 18.3984C12.4833 18.3984 12.9 18.3234 13.25 18.1734C13.6 18.0234 13.95 17.8609 14.3 17.6859C14.65 17.5109 15.0333 17.3526 15.45 17.2109C15.8667 17.0693 16.3833 16.9984 17 16.9984C17.6333 16.9984 18.1583 17.0693 18.575 17.2109C18.9917 17.3526 19.375 17.5109 19.725 17.6859C20.075 17.8609 20.425 18.0234 20.775 18.1734C21.125 18.3234 21.5333 18.3984 22 18.3984V20.3484C21.3667 20.3484 20.8375 20.2734 20.4125 20.1234C19.9875 19.9734 19.6 19.8109 19.25 19.6359C18.9 19.4609 18.5583 19.3026 18.225 19.1609C17.8917 19.0193 17.4833 18.9484 17 18.9484C16.5333 18.9484 16.1292 19.0193 15.7875 19.1609C15.4458 19.3026 15.1042 19.4609 14.7625 19.6359C14.4208 19.8109 14.0375 19.9734 13.6125 20.1234C13.1875 20.2734 12.65 20.3484 12 20.3484C11.35 20.3484 10.8125 20.2734 10.3875 20.1234C9.9625 19.9734 9.57917 19.8109 9.2375 19.6359C8.89583 19.4609 8.55833 19.3026 8.225 19.1609C7.89167 19.0193 7.48333 18.9484 7 18.9484C6.53333 18.9484 6.12917 19.0193 5.7875 19.1609C5.44583 19.3026 5.1 19.4609 4.75 19.6359C4.4 19.8109 4.0125 19.9734 3.5875 20.1234C3.1625 20.2734 2.63333 20.3484 2 20.3484ZM2 15.8984V13.9484C2.48333 13.9484 2.89583 13.8734 3.2375 13.7234C3.57917 13.5734 3.925 13.4109 4.275 13.2359C4.625 13.0609 5.0125 12.9026 5.4375 12.7609C5.8625 12.6193 6.38333 12.5484 7 12.5484C7.63333 12.5484 8.15417 12.6193 8.5625 12.7609C8.97083 12.9026 9.35 13.0609 9.7 13.2359C10.05 13.4109 10.4 13.5734 10.75 13.7234C11.1 13.8734 11.5167 13.9484 12 13.9484C12.4833 13.9484 12.9 13.8734 13.25 13.7234C13.6 13.5734 13.95 13.4109 14.3 13.2359C14.65 13.0609 15.0333 12.9026 15.45 12.7609C15.8667 12.6193 16.3833 12.5484 17 12.5484C17.6333 12.5484 18.1583 12.6193 18.575 12.7609C18.9917 12.9026 19.375 13.0609 19.725 13.2359C20.075 13.4109 20.425 13.5734 20.775 13.7234C21.125 13.8734 21.5333 13.9484 22 13.9484V15.8984C21.3667 15.8984 20.8375 15.8234 20.4125 15.6734C19.9875 15.5234 19.6 15.3609 19.25 15.1859C18.9 15.0109 18.5583 14.8526 18.225 14.7109C17.8917 14.5693 17.4833 14.4984 17 14.4984C16.5167 14.4984 16.1042 14.5693 15.7625 14.7109C15.4208 14.8526 15.0792 15.0109 14.7375 15.1859C14.3958 15.3609 14.0167 15.5234 13.6 15.6734C13.1833 15.8234 12.65 15.8984 12 15.8984C11.35 15.8984 10.8125 15.8234 10.3875 15.6734C9.9625 15.5234 9.57917 15.3609 9.2375 15.1859C8.89583 15.0109 8.55833 14.8526 8.225 14.7109C7.89167 14.5693 7.48333 14.4984 7 14.4984C6.53333 14.4984 6.12917 14.5693 5.7875 14.7109C5.44583 14.8526 5.1 15.0109 4.75 15.1859C4.4 15.3609 4.0125 15.5234 3.5875 15.6734C3.1625 15.8234 2.63333 15.8984 2 15.8984ZM2 11.4484V9.49844C2.48333 9.49844 2.89583 9.42344 3.2375 9.27344C3.57917 9.12344 3.925 8.96094 4.275 8.78594C4.625 8.61094 5.0125 8.4526 5.4375 8.31094C5.8625 8.16927 6.38333 8.09844 7 8.09844C7.63333 8.09844 8.15417 8.16927 8.5625 8.31094C8.97083 8.4526 9.35 8.61094 9.7 8.78594C10.05 8.96094 10.4 9.12344 10.75 9.27344C11.1 9.42344 11.5167 9.49844 12 9.49844C12.4833 9.49844 12.9 9.42344 13.25 9.27344C13.6 9.12344 13.95 8.96094 14.3 8.78594C14.65 8.61094 15.0333 8.4526 15.45 8.31094C15.8667 8.16927 16.3833 8.09844 17 8.09844C17.6333 8.09844 18.1583 8.16927 18.575 8.31094C18.9917 8.4526 19.375 8.61094 19.725 8.78594C20.075 8.96094 20.425 9.12344 20.775 9.27344C21.125 9.42344 21.5333 9.49844 22 9.49844V11.4484C21.3667 11.4484 20.8375 11.3734 20.4125 11.2234C19.9875 11.0734 19.6 10.9109 19.25 10.7359C18.9 10.5609 18.5583 10.4026 18.225 10.2609C17.8917 10.1193 17.4833 10.0484 17 10.0484C16.5333 10.0484 16.1292 10.1193 15.7875 10.2609C15.4458 10.4026 15.1042 10.5609 14.7625 10.7359C14.4208 10.9109 14.0375 11.0734 13.6125 11.2234C13.1875 11.3734 12.65 11.4484 12 11.4484C11.35 11.4484 10.8125 11.3734 10.3875 11.2234C9.9625 11.0734 9.57917 10.9109 9.2375 10.7359C8.89583 10.5609 8.55833 10.4026 8.225 10.2609C7.89167 10.1193 7.48333 10.0484 7 10.0484C6.53333 10.0484 6.12917 10.1193 5.7875 10.2609C5.44583 10.4026 5.1 10.5609 4.75 10.7359C4.4 10.9109 4.0125 11.0734 3.5875 11.2234C3.1625 11.3734 2.63333 11.4484 2 11.4484ZM2 6.99844V5.04844C2.48333 5.04844 2.89583 4.97344 3.2375 4.82344C3.57917 4.67344 3.925 4.51094 4.275 4.33594C4.625 4.16094 5.0125 4.0026 5.4375 3.86094C5.8625 3.71927 6.38333 3.64844 7 3.64844C7.63333 3.64844 8.15417 3.71927 8.5625 3.86094C8.97083 4.0026 9.35 4.16094 9.7 4.33594C10.05 4.51094 10.4 4.67344 10.75 4.82344C11.1 4.97344 11.5167 5.04844 12 5.04844C12.4833 5.04844 12.9 4.97344 13.25 4.82344C13.6 4.67344 13.95 4.51094 14.3 4.33594C14.65 4.16094 15.0333 4.0026 15.45 3.86094C15.8667 3.71927 16.3833 3.64844 17 3.64844C17.6333 3.64844 18.1583 3.71927 18.575 3.86094C18.9917 4.0026 19.375 4.16094 19.725 4.33594C20.075 4.51094 20.425 4.67344 20.775 4.82344C21.125 4.97344 21.5333 5.04844 22 5.04844V6.99844C21.3667 6.99844 20.8375 6.92344 20.4125 6.77344C19.9875 6.62344 19.6 6.46094 19.25 6.28594C18.9 6.11094 18.5583 5.9526 18.225 5.81094C17.8917 5.66927 17.4833 5.59844 17 5.59844C16.5333 5.59844 16.1292 5.66927 15.7875 5.81094C15.4458 5.9526 15.1042 6.11094 14.7625 6.28594C14.4208 6.46094 14.0375 6.62344 13.6125 6.77344C13.1875 6.92344 12.65 6.99844 12 6.99844C11.35 6.99844 10.8125 6.92344 10.3875 6.77344C9.9625 6.62344 9.57917 6.46094 9.2375 6.28594C8.89583 6.11094 8.55833 5.9526 8.225 5.81094C7.89167 5.66927 7.48333 5.59844 7 5.59844C6.53333 5.59844 6.12917 5.66927 5.7875 5.81094C5.44583 5.9526 5.1 6.11094 4.75 6.28594C4.4 6.46094 4.0125 6.62344 3.5875 6.77344C3.1625 6.92344 2.63333 6.99844 2 6.99844Z"
    ]
  },
  parking: {
    paths: [
      "M4.3077 21.5C3.80257 21.5 3.375 21.325 3.025 20.975C2.675 20.625 2.5 20.1974 2.5 19.6923V4.3077C2.5 3.80257 2.675 3.375 3.025 3.025C3.375 2.675 3.80257 2.5 4.3077 2.5H19.6923C20.1974 2.5 20.625 2.675 20.975 3.025C21.325 3.375 21.5 3.80257 21.5 4.3077V19.6923C21.5 20.1974 21.325 20.625 20.975 20.975C20.625 21.325 20.1974 21.5 19.6923 21.5H4.3077ZM4.3077 20H19.6923C19.7692 20 19.8397 19.9679 19.9038 19.9038C19.9679 19.8397 20 19.7692 20 19.6923V4.3077C20 4.23077 19.9679 4.16024 19.9038 4.09613C19.8397 4.03203 19.7692 3.99998 19.6923 3.99998H4.3077C4.23077 3.99998 4.16024 4.03203 4.09613 4.09613C4.03202 4.16024 3.99998 4.23077 3.99998 4.3077V19.6923C3.99998 19.7692 4.03202 19.8397 4.09613 19.9038C4.16024 19.9679 4.23077 20 4.3077 20ZM8.80765 13.8846C8.56278 13.8846 8.35413 13.7984 8.1817 13.6259C8.00927 13.4535 7.92305 13.2448 7.92305 13C7.92305 12.7551 8.00927 12.5465 8.1817 12.374C8.35413 12.2016 8.56278 12.1154 8.80765 12.1154C9.05252 12.1154 9.26117 12.2016 9.4336 12.374C9.60603 12.5465 9.69225 12.7551 9.69225 13C9.69225 13.2448 9.60603 13.4535 9.4336 13.6259C9.26117 13.7984 9.05252 13.8846 8.80765 13.8846ZM15.1923 13.8846C14.9474 13.8846 14.7388 13.7984 14.5664 13.6259C14.3939 13.4535 14.3077 13.2448 14.3077 13C14.3077 12.7551 14.3939 12.5465 14.5664 12.374C14.7388 12.2016 14.9474 12.1154 15.1923 12.1154C15.4372 12.1154 15.6458 12.2016 15.8183 12.374C15.9907 12.5465 16.0769 12.7551 16.0769 13C16.0769 13.2448 15.9907 13.4535 15.8183 13.6259C15.6458 13.7984 15.4372 13.8846 15.1923 13.8846ZM5.5 11.1769V17.373C5.5 17.5551 5.55898 17.7051 5.67693 17.823C5.79488 17.941 5.94488 18 6.12693 18H6.37308C6.55511 18 6.7051 17.941 6.82305 17.823C6.941 17.7051 6.99998 17.5551 6.99998 17.373V16H17V17.373C17 17.5551 17.059 17.7051 17.1769 17.823C17.2949 17.941 17.4448 18 17.6269 18H17.873C18.0551 18 18.2051 17.941 18.323 17.823C18.441 17.7051 18.5 17.5551 18.5 17.373V11.1769L16.9269 6.62693C16.8628 6.43846 16.7541 6.28686 16.6009 6.17213C16.4477 6.05738 16.2769 6 16.0884 6H7.91153C7.72308 6 7.55225 6.05738 7.39905 6.17213C7.24583 6.28686 7.13718 6.43846 7.07308 6.62693L5.5 11.1769ZM7.47687 10L8.34998 7.49998H15.65L16.5231 10H7.47687ZM6.99998 14.5V11.5H17V14.5H6.99998Z"
    ]
  },
  view: {
    paths: [
      "M4.828 21L4.808 21.02L4.787 21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448 20.5226 2 20.2702 2 20.007V3.993C2.00183 3.73038 2.1069 3.47902 2.29251 3.29322C2.47813 3.10742 2.72938 3.00209 2.992 3H21.008C21.556 3 22 3.445 22 3.993V20.007C21.9982 20.2696 21.8931 20.521 21.7075 20.7068C21.5219 20.8926 21.2706 20.9979 21.008 21H4.828ZM20 15V5H4V19L14 9L20 15ZM20 17.828L14 11.828L6.828 19H20V17.828ZM8 11C7.46957 11 6.96086 10.7893 6.58579 10.4142C6.21071 10.0391 6 9.53043 6 9C6 8.46957 6.21071 7.96086 6.58579 7.58579C6.96086 7.21071 7.46957 7 8 7C8.53043 7 9.03914 7.21071 9.41421 7.58579C9.78929 7.96086 10 8.46957 10 9C10 9.53043 9.78929 10.0391 9.41421 10.4142C9.03914 10.7893 8.53043 11 8 11Z"
    ]
  },
  other: {
    paths: [
      "M19 20.9999H5C4.73478 20.9999 4.48043 20.8946 4.29289 20.707C4.10536 20.5195 4 20.2651 4 19.9999V10.9999H1L11.327 1.61192C11.5111 1.4444 11.7511 1.35156 12 1.35156C12.2489 1.35156 12.4889 1.4444 12.673 1.61192L23 10.9999H20V19.9999C20 20.2651 19.8946 20.5195 19.7071 20.707C19.5196 20.8946 19.2652 20.9999 19 20.9999ZM6 18.9999H18V9.15692L12 3.70292L6 9.15692V18.9999Z",
      "M9.3125 8.79462C9.47117 8.65462 9.64383 8.52162 9.8305 8.39562C10.0218 8.26962 10.2272 8.15996 10.4465 8.06662C10.6658 7.97329 10.9038 7.90096 11.1605 7.84962C11.4172 7.79362 11.6948 7.76562 11.9935 7.76562C12.3995 7.76562 12.7682 7.82162 13.0995 7.93362C13.4355 8.04562 13.7225 8.20662 13.9605 8.41662C14.1985 8.62196 14.3828 8.87162 14.5135 9.16562C14.6442 9.45962 14.7095 9.78862 14.7095 10.1526C14.7095 10.5073 14.6582 10.8153 14.5555 11.0766C14.4528 11.3333 14.3222 11.5573 14.1635 11.7486C14.0095 11.94 13.8415 12.1056 13.6595 12.2456C13.4775 12.3856 13.3048 12.5186 13.1415 12.6446C12.9782 12.766 12.8358 12.8873 12.7145 13.0086C12.5978 13.1253 12.5278 13.2583 12.5045 13.4076L12.3435 14.4296H11.1605L11.0415 13.2886C11.0368 13.2653 11.0345 13.2466 11.0345 13.2326C11.0345 13.214 11.0345 13.193 11.0345 13.1696C11.0345 12.9643 11.0858 12.787 11.1885 12.6376C11.2912 12.4836 11.4195 12.3413 11.5735 12.2106C11.7275 12.0753 11.8932 11.9446 12.0705 11.8186C12.2478 11.6926 12.4135 11.5573 12.5675 11.4126C12.7215 11.2633 12.8498 11.0953 12.9525 10.9086C13.0552 10.722 13.1065 10.5026 13.1065 10.2506C13.1065 10.0826 13.0738 9.93329 13.0085 9.80263C12.9478 9.66729 12.8615 9.55296 12.7495 9.45962C12.6375 9.36162 12.5022 9.28696 12.3435 9.23562C12.1895 9.18429 12.0215 9.15863 11.8395 9.15863C11.5735 9.15863 11.3472 9.18896 11.1605 9.24963C10.9785 9.30562 10.8222 9.37096 10.6915 9.44563C10.5655 9.51562 10.4582 9.58096 10.3695 9.64163C10.2808 9.69762 10.2015 9.72562 10.1315 9.72562C9.9635 9.72562 9.84217 9.65562 9.7675 9.51562L9.3125 8.79462ZM10.6355 17.0476C10.6355 16.903 10.6612 16.7653 10.7125 16.6346C10.7685 16.504 10.8432 16.392 10.9365 16.2986C11.0345 16.2053 11.1488 16.1306 11.2795 16.0746C11.4102 16.0186 11.5502 15.9906 11.6995 15.9906C11.8442 15.9906 11.9818 16.0186 12.1125 16.0746C12.2432 16.1306 12.3552 16.2053 12.4485 16.2986C12.5418 16.392 12.6165 16.504 12.6725 16.6346C12.7285 16.7653 12.7565 16.903 12.7565 17.0476C12.7565 17.197 12.7285 17.337 12.6725 17.4676C12.6165 17.5936 12.5418 17.7033 12.4485 17.7966C12.3552 17.89 12.2432 17.9623 12.1125 18.0136C11.9818 18.0696 11.8442 18.0976 11.6995 18.0976C11.5502 18.0976 11.4102 18.0696 11.2795 18.0136C11.1488 17.9623 11.0345 17.89 10.9365 17.7966C10.8432 17.7033 10.7685 17.5936 10.7125 17.4676C10.6612 17.337 10.6355 17.197 10.6355 17.0476Z"
    ]
  },
  location: {
    paths: [
      "M0.10612 9.37871C0.326299 10.6258 0.8891 11.9482 1.79452 13.3461C1.85721 13.4429 1.92153 13.54 1.9875 13.6375C3.08066 15.2532 4.63611 16.9795 6.65384 18.8164C7.08177 19.2059 7.53049 19.6005 8 20C8.46951 19.6005 8.91823 19.2059 9.34616 18.8164C11.3639 16.9795 12.9193 15.2532 14.0125 13.6375C14.0785 13.54 14.1428 13.4429 14.2055 13.3461C14.2514 13.2752 14.2964 13.2045 14.3406 13.134C15.4469 11.3676 16 9.72291 16 8.2C16 5.7 15.1958 3.70833 13.5875 2.225C13.5067 2.1505 13.4253 2.07788 13.3433 2.00713C11.7915 0.669042 10.0104 0 8 0C5.98962 0 4.20853 0.669051 2.65671 2.00715C2.57467 2.0779 2.49326 2.15051 2.4125 2.225C0.804167 3.70833 0 5.7 0 8.2C0 8.58512 0.0353734 8.97802 0.10612 9.37871ZM8.007 17.3436C9.92431 15.5827 11.3743 13.974 12.3569 12.5173C12.4145 12.4319 12.4706 12.3469 12.525 12.2625C12.5632 12.2033 12.6006 12.1444 12.6373 12.0857C13.263 11.085 13.6732 10.1591 13.8679 9.30809C13.956 8.92343 14 8.55407 14 8.2C14 8.16382 13.9998 8.12778 13.9993 8.09186C13.9989 8.06115 13.9984 8.03053 13.9976 8C13.9838 7.42121 13.9096 6.87674 13.775 6.3666C13.5081 5.35535 13.004 4.47898 12.2625 3.7375C12.1833 3.65828 12.1028 3.58177 12.0212 3.50797C10.9086 2.50266 9.56821 2 8 2C6.43178 2 5.09139 2.50266 3.97883 3.50798C3.89716 3.58178 3.81671 3.65829 3.7375 3.7375C2.99602 4.47898 2.49186 5.35535 2.22502 6.36659C2.09041 6.87674 2.01619 7.42121 2.00237 8C2.00164 8.03053 2.00108 8.06115 2.00069 8.09186C2.00023 8.12778 2 8.16382 2 8.2C2 8.55407 2.04402 8.92344 2.13206 9.30809C2.32694 10.1596 2.73752 11.086 3.3638 12.0874C3.40014 12.1455 3.43721 12.2039 3.475 12.2625C3.52943 12.3469 3.58547 12.4319 3.64312 12.5173C4.62573 13.974 6.07569 15.5827 7.993 17.3436C7.99533 17.3457 7.99767 17.3479 8 17.35C8.00233 17.3479 8.00467 17.3457 8.007 17.3436ZM11.999 8.08821C11.9521 10.2566 10.1797 12 8 12C5.82034 12 4.04787 10.2566 4.00095 8.08821C4.00032 8.05889 4 8.02948 4 8C4 7.62717 4.05101 7.26626 4.14642 6.92386C4.61638 5.2374 6.16369 4 8 4C9.83631 4 11.3836 5.2374 11.8536 6.92386C11.949 7.26626 12 7.62717 12 8C12 8.02948 11.9997 8.05889 11.999 8.08821ZM8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
    ]
  },
  "location-crosshairs": {
    viewBox: "0 0 16 16",
    paths: [
      "M8.83337 1.33325V2.16659V3.07023C10.9271 3.41919 12.5808 5.07284 12.9297 7.16659H13.8334H14.6667V8.83325H13.8334H12.9297C12.5808 10.927 10.9271 12.5806 8.83337 12.9296V13.8333V14.6666H7.16671V13.8333V12.9296C5.07296 12.5806 3.41931 10.927 3.07035 8.83325H2.16671H1.33337V7.16659H2.16671H3.07035C3.41931 5.07284 5.07296 3.41919 7.16671 3.07023V2.16659V1.33325H8.83337ZM4.66671 7.99992C4.66671 8.88397 5.0179 9.73182 5.64302 10.3569C6.26814 10.9821 7.11599 11.3333 8.00004 11.3333C8.8841 11.3333 9.73194 10.9821 10.3571 10.3569C10.9822 9.73182 11.3334 8.88397 11.3334 7.99992C11.3334 7.11586 10.9822 6.26802 10.3571 5.6429C9.73194 5.01777 8.8841 4.66659 8.00004 4.66659C7.11599 4.66659 6.26814 5.01777 5.64302 5.6429C5.0179 6.26802 4.66671 7.11586 4.66671 7.99992ZM8.00004 5.91659C8.55257 5.91659 9.08248 6.13608 9.47318 6.52678C9.86388 6.91748 10.0834 7.44738 10.0834 7.99992C10.0834 8.55245 9.86388 9.08236 9.47318 9.47306C9.08248 9.86376 8.55257 10.0833 8.00004 10.0833C7.44751 10.0833 6.9176 9.86376 6.5269 9.47306C6.1362 9.08236 5.91671 8.55245 5.91671 7.99992C5.91671 7.44738 6.1362 6.91748 6.5269 6.52678C6.9176 6.13608 7.44751 5.91659 8.00004 5.91659Z"
    ]
  },
  sparkle: {
    paths: [
      "M10.9789 6.43883C11.4321 6.28268 11.4321 6.0051 10.9789 5.83162L8.52121 4.89479C8.08545 4.73865 7.57997 4.23553 7.40567 3.78447L6.46443 1.33831C6.30755 0.88723 6.02867 0.88723 5.85436 1.33831L4.91312 3.78447C4.75625 4.21818 4.25077 4.7213 3.79758 4.89479L1.33989 5.83162C0.886702 5.98777 0.886702 6.26533 1.33989 6.43883L3.79758 7.37566C4.23334 7.5318 4.73882 8.0349 4.91312 8.48598L5.85436 10.9321C6.01124 11.3832 6.29012 11.3832 6.46443 10.9321L7.40567 8.48598C7.56254 8.05225 8.06802 7.54914 8.52121 7.37566L10.9789 6.43883ZM22.9541 15.0093C24.3486 14.6623 24.3486 14.0897 22.9541 13.7427L19.8691 12.9794C18.4746 12.6324 17.0453 11.2098 16.6967 9.82194L15.9298 6.75122C15.5811 5.36333 15.006 5.36333 14.6573 6.75122L13.8904 9.82194C13.5418 11.2098 12.1125 12.6324 10.7181 12.9794L7.63288 13.7427C6.23846 14.0897 6.23846 14.6623 7.63288 15.0093L10.7181 15.7725C12.1125 16.1195 13.5418 17.5421 13.8904 18.93L14.6573 22.0007C15.006 23.3886 15.5811 23.3886 15.9298 22.0007L16.6967 18.93C17.0453 17.5421 18.4746 16.1195 19.8691 15.7725L22.9541 15.0093Z"
    ]
  },
  school: {
    paths: [
      "M12 21L5 17.2V11.2L1 9L12 3L23 9V17H21V10.1L19 11.2V17.2L12 21ZM12 12.7L18.85 9L12 5.3L5.15 9L12 12.7ZM12 18.725L17 16.025V12.25L12 15L7 12.25V16.025L12 18.725Z"
    ]
  },
  database: {
    paths: [
      "M13.5655 3.46623V6.3536C13.1449 6.58797 12.5662 6.81584 11.8326 7.00138C10.7606 7.27482 9.43882 7.43758 8.00002 7.43758C6.56122 7.43758 5.23942 7.27482 4.16743 7.00138C3.4338 6.81584 2.85512 6.59123 2.43454 6.3536V3.46623L2.45352 3.44995C2.62111 3.30347 2.95631 3.10164 3.50337 2.89982C4.58168 2.50594 6.17227 2.22925 8.00002 2.22925C9.82777 2.22925 11.4184 2.50594 12.4967 2.89982C13.0437 3.10164 13.3758 3.30347 13.5465 3.44995L13.5655 3.46623ZM13.5655 8.07235V10.5203C13.1449 10.7546 12.5662 10.9825 11.8326 11.1681C10.7606 11.4415 9.43882 11.6042 8.00002 11.6042C6.56122 11.6042 5.23942 11.4415 4.16743 11.1681C3.4338 10.9825 2.85512 10.7579 2.43454 10.5203V8.07235C2.85512 8.24487 3.3168 8.39461 3.80378 8.51831C5.01174 8.8243 6.45687 9.00008 8.00002 9.00008C9.54318 9.00008 10.9883 8.8243 12.1963 8.51831C12.6832 8.39461 13.1449 8.24813 13.5655 8.07235ZM2.43454 14.5339V12.2423C2.85512 12.4148 3.3168 12.5645 3.80378 12.6882C5.01174 12.991 6.45687 13.1667 8.00002 13.1667C9.54318 13.1667 10.9883 12.991 12.1963 12.685C12.6832 12.5613 13.1449 12.4148 13.5655 12.239V14.5307L13.5465 14.547C13.3789 14.6934 13.0437 14.8953 12.4967 15.0971C11.4184 15.4942 9.82777 15.7709 8.00002 15.7709C6.17227 15.7709 4.58168 15.4942 3.50337 15.1003C2.95631 14.8985 2.62428 14.6967 2.45352 14.5502L2.43454 14.5339ZM13.6319 14.4656C13.6319 14.4656 13.6319 14.4688 13.6256 14.4721L13.6287 14.4656C13.6287 14.4656 13.6287 14.4656 13.6287 14.4623L13.6319 14.4656ZM2.3713 14.4656C2.3713 14.4656 2.3713 14.4688 2.37762 14.4721C2.37446 14.4688 2.37446 14.4656 2.3713 14.4656ZM13.6287 3.52808C13.6319 3.53133 13.6351 3.53459 13.6351 3.53459C13.6351 3.53459 13.6351 3.53133 13.6287 3.52808ZM15.0834 14.7292V3.27092C15.0834 1.83211 11.9117 0.666748 8.00002 0.666748C4.08838 0.666748 0.916687 1.83211 0.916687 3.27092V14.7292C0.916687 16.1681 4.08838 17.3334 8.00002 17.3334C11.9117 17.3334 15.0834 16.1681 15.0834 14.7292Z"
    ],
    viewBox: "0 0 16 18"
  },
  "database-filled": {
    paths: [
      "M15.5416 3.27092V4.83342C15.5416 6.27222 12.2767 7.43758 8.24998 7.43758C4.22329 7.43758 0.958313 6.27222 0.958313 4.83342V3.27092C0.958313 1.83211 4.22329 0.666748 8.24998 0.666748C12.2767 0.666748 15.5416 1.83211 15.5416 3.27092ZM13.7578 7.65568C14.4349 7.4148 15.0566 7.10555 15.5416 6.72469V10.0417C15.5416 11.4806 12.2767 12.6459 8.24998 12.6459C4.22329 12.6459 0.958313 11.4806 0.958313 10.0417V6.72469C1.44334 7.10881 2.06508 7.4148 2.74217 7.65568C4.20376 8.17651 6.15037 8.47925 8.24998 8.47925C10.3496 8.47925 12.2962 8.17651 13.7578 7.65568ZM0.958313 11.933C1.44334 12.3171 2.06508 12.6231 2.74217 12.864C4.20376 13.3848 6.15037 13.6876 8.24998 13.6876C10.3496 13.6876 12.2962 13.3848 13.7578 12.864C14.4349 12.6231 15.0566 12.3139 15.5416 11.933V14.7292C15.5416 16.1681 12.2767 17.3334 8.24998 17.3334C4.22329 17.3334 0.958313 16.1681 0.958313 14.7292V11.933Z"
    ],
    viewBox: "0 0 16 18"
  },
  "file-xml": {
    paths: [
      "M4.5 20.125H6.375V22H4.5C3.12109 22 2 20.8789 2 19.5V4.5C2 3.12109 3.12109 2 4.5 2H10.9648C11.6289 2 12.2656 2.26172 12.7344 2.73047L16.2695 6.26562C16.7383 6.73437 17 7.37109 17 8.03516V13.875H15.125V8.25H12C11.3086 8.25 10.75 7.69141 10.75 7V3.875H4.5C4.15625 3.875 3.875 4.15625 3.875 4.5V19.5C3.875 19.8438 4.15625 20.125 4.5 20.125ZM9.5 16.375C9.5 16.6602 9.58594 16.9375 9.74219 17.1719L10.125 17.7461L10.5078 17.1719C10.6641 16.9336 10.75 16.6562 10.75 16.375C10.75 16.0312 11.0312 15.75 11.375 15.75C11.7188 15.75 12 16.0312 12 16.375C12 16.9063 11.8437 17.4258 11.5469 17.8672L10.875 18.875L11.5469 19.8828C11.8437 20.3242 12 20.8437 12 21.375C12 21.7188 11.7188 22 11.375 22C11.0312 22 10.75 21.7188 10.75 21.375C10.75 21.0898 10.6641 20.8125 10.5078 20.5781L10.125 20L9.74219 20.5742C9.58594 20.8125 9.5 21.0898 9.5 21.3711C9.5 21.7148 9.21875 21.9961 8.875 21.9961C8.53125 21.9961 8.25 21.7148 8.25 21.3711C8.25 20.8398 8.40625 20.3203 8.70313 19.8789L9.375 18.875L8.70313 17.8672C8.40625 17.4258 8.25 16.9063 8.25 16.375C8.25 16.0312 8.53125 15.75 8.875 15.75C9.21875 15.75 9.5 16.0312 9.5 16.375ZM19.5 21.375V16.375C19.5 16.0312 19.7812 15.75 20.125 15.75C20.4688 15.75 20.75 16.0312 20.75 16.375V20.75H21.375C21.7188 20.75 22 21.0312 22 21.375C22 21.7188 21.7188 22 21.375 22H20.125C19.7812 22 19.5 21.7188 19.5 21.375ZM13.707 15.7734C13.9766 15.6992 14.2656 15.8125 14.4102 16.0547L15.75 18.2852L17.0898 16.0547C17.2344 15.8125 17.5234 15.6992 17.793 15.7734C18.0625 15.8477 18.25 16.0938 18.25 16.375V21.375C18.25 21.7188 17.9688 22 17.625 22C17.2812 22 17 21.7188 17 21.375V18.6328L16.2852 19.8242C16.1719 20.0117 15.9687 20.1289 15.75 20.1289C15.5313 20.1289 15.3281 20.0156 15.2148 19.8242L14.5 18.6328V21.375C14.5 21.7188 14.2188 22 13.875 22C13.5312 22 13.25 21.7188 13.25 21.375V16.375C13.25 16.0938 13.4375 15.8477 13.707 15.7734Z"
    ]
  },
  "property-inspection": {
    paths: [
      "M20 2C20.552 2 21 2.448 21 3V6.757L19 8.757V4H5V20H19V17.242L21 15.242V21C21 21.552 20.552 22 20 22H4C3.448 22 3 21.552 3 21V3C3 2.448 3.448 2 4 2H20ZM21.778 8.808L23.192 10.222L15.414 18L13.998 17.998L14 16.586L21.778 8.808V8.808ZM13 12V14H8V12H13ZM16 8V10H8V8H16Z"
    ]
  },
  "public-record": {
    paths: [
      "M6.5 10H4.5V17H6.5V10ZM12.5 10H10.5V17H12.5V10ZM21 19H2V21H21V19ZM18.5 10H16.5V17H18.5V10ZM11.5 3.26L16.71 6H6.29L11.5 3.26ZM11.5 1L2 6V8H21V6L11.5 1Z"
    ]
  },
  "user-input": {
    paths: [
      "M15 23L15.5 20.5L19.5734 16.4266L21.5734 18.4266L17.5 22.5L15 23ZM21.9266 18.0734L19.9266 16.0734L21 15L23 17L21.9266 18.0734Z",
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9467 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"
    ]
  },
  people: {
    paths: [
      "M12 11C13.3261 11 14.5979 11.5268 15.5355 12.4645C16.4732 13.4021 17 14.6739 17 16V22H15V16C15 15.2348 14.7077 14.4985 14.1827 13.9417C13.6578 13.385 12.9399 13.0499 12.176 13.005L12 13C11.2348 13 10.4985 13.2923 9.94174 13.8173C9.38499 14.3422 9.04989 15.0601 9.005 15.824L9 16V22H7V16C7 14.6739 7.52678 13.4021 8.46447 12.4645C9.40215 11.5268 10.6739 11 12 11ZM5.5 14C5.779 14 6.05 14.033 6.31 14.094C6.13902 14.603 6.03777 15.1328 6.009 15.669L6 16V16.086C5.88505 16.0449 5.76549 16.018 5.644 16.006L5.5 16C5.12712 16 4.76761 16.1389 4.49158 16.3896C4.21555 16.6403 4.0428 16.9848 4.007 17.356L4 17.5V22H2V17.5C2 16.5717 2.36875 15.6815 3.02513 15.0251C3.6815 14.3687 4.57174 14 5.5 14ZM18.5 14C19.4283 14 20.3185 14.3687 20.9749 15.0251C21.6313 15.6815 22 16.5717 22 17.5V22H20V17.5C20 17.1271 19.8611 16.7676 19.6104 16.4916C19.3597 16.2156 19.0152 16.0428 18.644 16.007L18.5 16C18.325 16 18.157 16.03 18 16.085V16C18 15.334 17.892 14.694 17.691 14.096C17.95 14.033 18.221 14 18.5 14ZM5.5 8C6.16304 8 6.79893 8.26339 7.26777 8.73223C7.73661 9.20107 8 9.83696 8 10.5C8 11.163 7.73661 11.7989 7.26777 12.2678C6.79893 12.7366 6.16304 13 5.5 13C4.83696 13 4.20107 12.7366 3.73223 12.2678C3.26339 11.7989 3 11.163 3 10.5C3 9.83696 3.26339 9.20107 3.73223 8.73223C4.20107 8.26339 4.83696 8 5.5 8ZM18.5 8C19.163 8 19.7989 8.26339 20.2678 8.73223C20.7366 9.20107 21 9.83696 21 10.5C21 11.163 20.7366 11.7989 20.2678 12.2678C19.7989 12.7366 19.163 13 18.5 13C17.837 13 17.2011 12.7366 16.7322 12.2678C16.2634 11.7989 16 11.163 16 10.5C16 9.83696 16.2634 9.20107 16.7322 8.73223C17.2011 8.26339 17.837 8 18.5 8ZM5.5 10C5.36739 10 5.24021 10.0527 5.14645 10.1464C5.05268 10.2402 5 10.3674 5 10.5C5 10.6326 5.05268 10.7598 5.14645 10.8536C5.24021 10.9473 5.36739 11 5.5 11C5.63261 11 5.75979 10.9473 5.85355 10.8536C5.94732 10.7598 6 10.6326 6 10.5C6 10.3674 5.94732 10.2402 5.85355 10.1464C5.75979 10.0527 5.63261 10 5.5 10ZM18.5 10C18.3674 10 18.2402 10.0527 18.1464 10.1464C18.0527 10.2402 18 10.3674 18 10.5C18 10.6326 18.0527 10.7598 18.1464 10.8536C18.2402 10.9473 18.3674 11 18.5 11C18.6326 11 18.7598 10.9473 18.8536 10.8536C18.9473 10.7598 19 10.6326 19 10.5C19 10.3674 18.9473 10.2402 18.8536 10.1464C18.7598 10.0527 18.6326 10 18.5 10ZM12 2C13.0609 2 14.0783 2.42143 14.8284 3.17157C15.5786 3.92172 16 4.93913 16 6C16 7.06087 15.5786 8.07828 14.8284 8.82843C14.0783 9.57857 13.0609 10 12 10C10.9391 10 9.92172 9.57857 9.17157 8.82843C8.42143 8.07828 8 7.06087 8 6C8 4.93913 8.42143 3.92172 9.17157 3.17157C9.92172 2.42143 10.9391 2 12 2ZM12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6C10 6.53043 10.2107 7.03914 10.5858 7.41421C10.9609 7.78929 11.4696 8 12 8C12.5304 8 13.0391 7.78929 13.4142 7.41421C13.7893 7.03914 14 6.53043 14 6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4Z"
    ]
  },
  signature: {
    viewBox: "0 0 16 16",
    paths: [
      "M3.33333 12.6667H4.276L10.4853 6.45739L9.54267 5.51472L3.33333 11.7241V12.6667ZM14 14.0001H2V11.1714L10.9567 2.21472C11.0817 2.08974 11.2512 2.01953 11.428 2.01953C11.6048 2.01953 11.7743 2.08974 11.8993 2.21472L13.7853 4.10072C13.9103 4.22574 13.9805 4.39528 13.9805 4.57206C13.9805 4.74883 13.9103 4.91837 13.7853 5.04339L6.162 12.6667H14V14.0001ZM10.4853 4.57206L11.428 5.51472L12.3707 4.57206L11.428 3.62939L10.4853 4.57206Z"
    ]
  },
  "signature-draw": {
    viewBox: "0 0 640 640",
    paths: [
      "M192 192C192 174.3 206.3 160 224 160C241.7 160 256 174.3 256 192L256 199.8C256 227.5 253.6 255.1 248.9 282.3L164.5 307.6C123.9 319.8 96.1 357.2 96.1 399.6L96.1 432L24.1 432C10.8 432 .1 442.7 .1 456C.1 469.3 10.8 480 24.1 480L96.6 480C100.8 516 131.4 544 168.6 544C194.6 544 218.6 530.1 231.5 507.5L245.4 483.2C272.2 436.2 291.9 385.5 303.8 332.7L398.2 304.4L385.7 341.9C382.4 351.7 384.1 362.4 390.1 370.7C396.1 379 405.7 384 416 384L544 384C561.7 384 576 369.7 576 352C576 334.3 561.7 320 544 320L460.4 320L478.4 266.1C482.2 254.8 479.3 242.3 471 233.7C462.7 225.1 450.3 221.9 438.8 225.3L316.4 262.1C318.8 241.4 320 220.7 320 199.8L320 192C320 139 277 96 224 96C171 96 128 139 128 192L128 224C128 241.7 142.3 256 160 256C177.7 256 192 241.7 192 224L192 192zM182.8 369L231.8 354.3C221.4 388.1 207.3 420.7 189.7 451.5L175.8 475.8C174.3 478.4 171.5 480.1 168.4 480.1C163.7 480.1 159.9 476.3 159.9 471.6L159.9 399.7C159.9 385.6 169.2 373.1 182.7 369zM616 480C629.3 480 640 469.3 640 456C640 442.7 629.3 432 616 432L323.1 432C316.6 448.3 309.4 464.3 301.5 480L616 480"
    ]
  },
  comment: {
    viewBox: "0 0 24 24",
    paths: [
      "M21 3C21.552 3 22 3.448 22 4V18C22 18.552 21.552 19 21 19H6.455L2 22.5V4C2 3.448 2.448 3 3 3H21ZM20 5H4V18.385L5.763 17H20V5ZM10.515 7.412L10.962 8.1C9.294 9.003 9.323 10.452 9.323 10.764C9.478 10.744 9.641 10.74 9.803 10.755C10.705 10.839 11.416 11.58 11.416 12.5C11.416 13.466 10.632 14.25 9.666 14.25C9.129 14.25 8.616 14.005 8.292 13.66C7.777 13.114 7.5 12.5 7.5 11.505C7.5 9.755 8.728 8.187 10.515 7.412ZM15.515 7.412L15.962 8.1C14.294 9.003 14.323 10.452 14.323 10.764C14.478 10.744 14.641 10.74 14.803 10.755C15.705 10.839 16.416 11.58 16.416 12.5C16.416 13.466 15.632 14.25 14.666 14.25C14.129 14.25 13.616 14.005 13.292 13.66C12.777 13.114 12.5 12.5 12.5 11.505C12.5 9.755 13.728 8.187 15.515 7.412Z"
    ]
  },
  pdf: {
    viewBox: "0 0 24 24",
    paths: [
      "M5.45801 19.375V19.5C5.45801 20.1148 5.99198 20.625 6.66699 20.625H17.333C18.0092 20.625 18.542 20.1149 18.542 19.5V19.375H20.125V19.5C20.125 20.9554 18.8652 22.125 17.333 22.125H6.66699C5.1327 22.125 3.875 20.9554 3.875 19.5V19.375H5.45801ZM7.66699 11.875C9.01566 11.8752 10.125 12.9041 10.125 14.1875C10.125 15.4709 9.01566 16.4998 7.66699 16.5H7.45801V17.625C7.45801 18.045 7.09671 18.3748 6.66699 18.375C6.23714 18.375 5.875 18.0451 5.875 17.625V12.625C5.875 12.2049 6.23714 11.875 6.66699 11.875H7.66699ZM12.333 11.875C13.4985 11.875 14.458 12.7633 14.458 13.875V16.375C14.458 17.4867 13.4985 18.375 12.333 18.375H11.333C10.9052 18.3748 10.542 18.0452 10.542 17.625V12.625C10.542 12.2048 10.9052 11.8752 11.333 11.875H12.333ZM18 11.875C18.428 11.875 18.792 12.2047 18.792 12.625C18.792 13.0453 18.428 13.375 18 13.375H16.792V14.375H18C18.428 14.375 18.792 14.7047 18.792 15.125C18.792 15.5453 18.428 15.875 18 15.875H16.792V17.625C16.792 18.0453 16.428 18.375 16 18.375C15.572 18.375 15.208 18.0453 15.208 17.625V12.625C15.208 12.2047 15.572 11.875 16 11.875H18ZM12.125 16.875H12.333C12.6384 16.875 12.875 16.6422 12.875 16.375V13.875C12.875 13.6078 12.6384 13.375 12.333 13.375H12.125V16.875ZM7.45801 15H7.66699C8.15969 14.9998 8.54199 14.6304 8.54199 14.1875C8.54199 13.7446 8.15969 13.3752 7.66699 13.375H7.45801V15ZM13.1709 1.875C13.7304 1.87502 14.2738 2.08378 14.6729 2.45801L19.498 6.9834C19.8971 7.35762 20.125 7.87042 20.125 8.40234V10.875H18.542V9.625H14C12.8345 9.625 11.875 8.73667 11.875 7.625V3.375H6.66699C5.99206 3.375 5.45801 3.88628 5.45801 4.5V10.875H3.875V4.5C3.875 3.04263 5.13276 1.875 6.66699 1.875H13.1709ZM13.458 7.625C13.458 7.89224 13.6946 8.125 14 8.125H18.4502C18.4318 8.09951 18.4115 8.07493 18.3877 8.05371L18.3857 8.05176L13.5566 3.52441L13.5547 3.52246C13.5264 3.49504 13.4935 3.47163 13.458 3.45117V7.625Z"
    ]
  },
  inspectifyReport: {
    viewBox: "0 0 24 24",
    paths: [
      "M20 2C20.552 2 21 2.448 21 3V6.757L19 8.757V4H5V20H19V17.242L21 15.242V21C21 21.552 20.552 22 20 22H4C3.448 22 3 21.552 3 21V3C3 2.448 3.448 2 4 2H20ZM21.778 8.808L23.192 10.222L15.414 18L13.998 17.998L14 16.586L21.778 8.808ZM13 12V14H8V12H13ZM16 8V10H8V8H16Z"
    ]
  },
  "quality-tiers": {
    viewBox: "0 0 16 16",
    paths: [
      "M9.57655 8.00783C10.2025 8.07293 10.6914 8.60414 10.6914 9.25253V10.5024H12.7609L12.8876 10.5076C13.5136 10.5727 14.0025 11.104 14.0025 11.7523V13.4189L13.9973 13.5465C13.9378 14.135 13.4722 14.6037 12.8902 14.661L12.7634 14.6662H3.24415C2.55866 14.6662 2.0025 14.1063 2.0025 13.4163V10.9165C2.0025 10.2264 2.55866 9.66656 3.24415 9.66656H5.72744V9.24992C5.72744 8.60153 6.21634 8.07032 6.84234 8.00522L6.96909 8.00002H9.45238L9.57914 8.00522L9.57655 8.00783ZM3.24156 13.4163H5.72486V10.9165H3.24156V13.4163ZM6.9665 13.4163H9.4498V9.24992H6.9665V13.4163ZM10.6914 13.4163H12.7609V11.7497H10.6914V13.4163ZM7.9443 1.4979C8.05553 1.27395 8.37112 1.28177 8.472 1.4979L9.08248 2.73999L10.4354 2.93789C10.6759 2.97435 10.7768 3.2738 10.6009 3.45348L9.62052 4.40914L9.85075 5.76581C9.88696 6.00798 9.63604 6.19546 9.41617 6.08349L8.21332 5.44812L7.00013 6.09391C6.77767 6.20588 6.52675 6.01839 6.56555 5.77622L6.79578 4.41955L5.81539 3.45608C5.63949 3.27901 5.74038 2.97956 5.98095 2.9405L7.33382 2.74259L7.9443 1.5005V1.4979Z"
    ]
  }
}, Hte = {
  sm: 10,
  md: 16,
  lg: 24,
  xl: 48,
  xxl: 64
};
const Go = nt(
  ({ color: e, icon: t, size: n = "md", variant: r = "default", __styleDoNotUse: o, __testId: a }, s) => {
    const { paths: l, viewBox: c = "0 0 24 24" } = Bte[t], d = Hte[n], h = {
      fill: e ? Fo[e] : "currentColor",
      ...o || {}
    }, m = l.map((g, b) => /* @__PURE__ */ A.jsx("path", { d: g }, b));
    return /* @__PURE__ */ A.jsx(
      "svg",
      {
        ref: s,
        className: to("icon", r === "outlined" && r),
        "data-testid": a || t,
        width: d,
        height: d,
        viewBox: c,
        xmlns: "http://www.w3.org/2000/svg",
        style: h,
        fillRule: Fte(t),
        children: m
      }
    );
  }
);
Go.displayName = "Icon";
const jx = ({ size: e = 20 }) => /* @__PURE__ */ A.jsxs(
  "div",
  {
    className: "small-roller",
    style: { height: e, width: e, transform: `scale(${e / 80})` },
    children: [
      /* @__PURE__ */ A.jsx("div", {}),
      /* @__PURE__ */ A.jsx("div", {}),
      /* @__PURE__ */ A.jsx("div", {}),
      /* @__PURE__ */ A.jsx("div", {}),
      /* @__PURE__ */ A.jsx("div", {}),
      /* @__PURE__ */ A.jsx("div", {})
    ]
  }
), Gte = (e, t) => e === "nav" ? "arrow-left" : t, A3 = nt(
  ({
    variant: e = "primary",
    icon: t,
    disabled: n,
    onClick: r,
    onMouseDown: o,
    size: a,
    __dangerDoNotUseSx: s,
    __testId: l,
    title: c,
    text: d,
    isLoading: f,
    "data-trace-name": h,
    fullWidth: m,
    rightIcon: g,
    type: b = "button",
    tabIndex: C,
    marginLeft: y,
    marginRight: _,
    id: x,
    badge: I
  }, R) => {
    const E = Gte(e, t);
    return (
      // eslint-disable-next-line aloft/prefer-sound-ui-button
      /* @__PURE__ */ A.jsxs(
        "button",
        {
          ref: R,
          id: x,
          "data-testid": l ?? x,
          "data-trace-name": h,
          className: to("button", e, a, (n || f) && "disabled"),
          style: {
            ...s,
            width: m ? "100%" : void 0,
            marginLeft: y,
            marginRight: _,
            position: f ? "relative" : s == null ? void 0 : s.position
          },
          title: c,
          onClick: r,
          onMouseDown: (k) => {
            k.preventDefault(), o == null || o(k);
          },
          disabled: n || f,
          type: b,
          tabIndex: C,
          children: [
            /* @__PURE__ */ A.jsxs("div", { className: to("contents", f && "loading"), children: [
              E && /* @__PURE__ */ A.jsx(Go, { icon: E, size: a }),
              d,
              g && /* @__PURE__ */ A.jsx(Go, { icon: g, size: a }),
              I && /* @__PURE__ */ A.jsx(Zx, { ...I })
            ] }),
            f && /* @__PURE__ */ A.jsx("div", { className: "loader", children: /* @__PURE__ */ A.jsx(
              jx,
              {
                size: a === "sm" || e === "inline" || e === "inlineSecondary" ? 20 : 30
              }
            ) })
          ]
        }
      )
    );
  }
), fh = nt(
  ({ children: e, ...t }, n) => /* @__PURE__ */ A.jsx(R4, { ref: n, ...t, children: /* @__PURE__ */ A.jsx(Si, { children: e }) })
);
const $te = ({
  variant: e,
  inline: t,
  children: n,
  ...r
}) => {
  if (t)
    return /* @__PURE__ */ A.jsx("span", { ...r, children: n });
  switch (e) {
    case "h1":
    case "displaySmall":
    case "displayMedium":
    case "displayLarge":
      return /* @__PURE__ */ A.jsx("h1", { ...r, children: n });
    case "h2":
      return /* @__PURE__ */ A.jsx("h2", { ...r, children: n });
    case "h3":
      return /* @__PURE__ */ A.jsx("h3", { ...r, children: n });
    case "h4":
      return /* @__PURE__ */ A.jsx("h4", { ...r, children: n });
    case "h5":
      return /* @__PURE__ */ A.jsx("h5", { ...r, children: n });
    default:
      return /* @__PURE__ */ A.jsx("p", { ...r, children: n });
  }
}, Wo = ({
  children: e,
  color: t,
  variant: n = "body1",
  __dangerDoNotUseSx: r,
  truncate: o = !1,
  casing: a,
  id: s,
  textAlign: l,
  inline: c,
  title: d,
  __testId: f
}) => /* @__PURE__ */ A.jsx(
  $te,
  {
    id: s,
    variant: n,
    inline: c,
    className: to("typography", n),
    title: d,
    "data-testid": f,
    style: {
      color: t ? Fo[t] : void 0,
      textAlign: l,
      textOverflow: o ? "ellipsis" : void 0,
      overflow: o ? "hidden" : void 0,
      textTransform: a,
      ...r
    },
    children: e
  }
), ef = nt(
  ({
    id: e,
    variant: t = "primary",
    ariaLabel: n,
    icon: r,
    disabled: o,
    onClick: a,
    onMouseDown: s,
    size: l = "md",
    __dangerDoNotUseSx: c,
    __testId: d,
    title: f,
    iconSize: h = "md",
    isLoading: m,
    iconColor: g,
    tabIndex: b,
    isRound: C,
    text: y,
    textColor: _
  }, x) => {
    let I = 30;
    return l === "xs" ? I = 16 : l === "sm" && (I = 20), // eslint-disable-next-line aloft/prefer-sound-ui-button
    /* @__PURE__ */ A.jsx(
      "button",
      {
        ref: x,
        className: to(
          "button",
          "icon-button",
          t,
          l,
          (o || m) && "disabled",
          C && "round",
          y && "text"
        ),
        id: e,
        tabIndex: b,
        "aria-label": n,
        "data-testid": d ?? e,
        title: f ?? n,
        onClick: a,
        onMouseDown: s,
        disabled: o,
        type: "button",
        style: c,
        children: m ? /* @__PURE__ */ A.jsx("div", { className: "loader", children: /* @__PURE__ */ A.jsx(jx, { size: I }) }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
          /* @__PURE__ */ A.jsx(Go, { icon: r, size: h, color: g }),
          y && /* @__PURE__ */ A.jsx(Wo, { variant: "buttonSmall", color: _, children: y })
        ] })
      }
    );
  }
);
ef.displayName = "IconButton";
const Zte = nt(
  ({ size: e = "xs", value: t }, n) => {
    if (!t)
      return null;
    const [r, o] = je("Copy to clipboard"), a = (s) => {
      s.stopPropagation(), s.preventDefault(), navigator.clipboard.writeText(t), o("Copied!"), setTimeout(() => {
        o("Copy to clipboard");
      }, 2e3);
    };
    return /* @__PURE__ */ A.jsx(fh, { openDelay: 500, label: r, children: /* @__PURE__ */ A.jsx(
      ef,
      {
        ref: n,
        ariaLabel: "Copy to clipboard",
        icon: "file-copy",
        size: e,
        variant: "tertiary",
        onClick: a
      }
    ) });
  }
);
Zte.displayName = "CopyButton";
const Wx = (e) => {
  throw new Error(`unexpected: ${e}`);
}, Dme = (e) => {
  switch (e) {
    case "xs":
    case "sm":
      return "sm";
    case "md":
      return "md";
    case "lg":
      return "lg";
    default:
      return Wx(e);
  }
}, jte = nt(
  ({ isChecked: e, onChange: t, isDisabled: n, isIndeterminate: r, children: o }, a) => /* @__PURE__ */ A.jsx(
    qg,
    {
      ref: a,
      isChecked: e,
      onChange: t,
      isDisabled: n,
      isIndeterminate: r,
      children: o
    }
  )
);
jte.displayName = "Checkbox";
function Wte(e = {}) {
  const {
    strict: t = !0,
    errorMessage: n = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",
    name: r
  } = e, o = Uo(void 0);
  o.displayName = r;
  function a() {
    var s;
    const l = Zn(o);
    if (!l && t) {
      const c = new Error(n);
      throw c.name = "ContextError", (s = Error.captureStackTrace) == null || s.call(Error, c, a), c;
    }
    return l;
  }
  return [
    o.Provider,
    a,
    o
  ];
}
var Wt;
(function(e) {
  e.assertEqual = (o) => {
  };
  function t(o) {
  }
  e.assertIs = t;
  function n(o) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = (o) => {
    const a = {};
    for (const s of o)
      a[s] = s;
    return a;
  }, e.getValidEnumValues = (o) => {
    const a = e.objectKeys(o).filter((l) => typeof o[o[l]] != "number"), s = {};
    for (const l of a)
      s[l] = o[l];
    return e.objectValues(s);
  }, e.objectValues = (o) => e.objectKeys(o).map(function(a) {
    return o[a];
  }), e.objectKeys = typeof Object.keys == "function" ? (o) => Object.keys(o) : (o) => {
    const a = [];
    for (const s in o)
      Object.prototype.hasOwnProperty.call(o, s) && a.push(s);
    return a;
  }, e.find = (o, a) => {
    for (const s of o)
      if (a(s))
        return s;
  }, e.isInteger = typeof Number.isInteger == "function" ? (o) => Number.isInteger(o) : (o) => typeof o == "number" && Number.isFinite(o) && Math.floor(o) === o;
  function r(o, a = " | ") {
    return o.map((s) => typeof s == "string" ? `'${s}'` : s).join(a);
  }
  e.joinValues = r, e.jsonStringifyReplacer = (o, a) => typeof a == "bigint" ? a.toString() : a;
})(Wt || (Wt = {}));
var dC;
(function(e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(dC || (dC = {}));
const $e = Wt.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), ts = (e) => {
  switch (typeof e) {
    case "undefined":
      return $e.undefined;
    case "string":
      return $e.string;
    case "number":
      return Number.isNaN(e) ? $e.nan : $e.number;
    case "boolean":
      return $e.boolean;
    case "function":
      return $e.function;
    case "bigint":
      return $e.bigint;
    case "symbol":
      return $e.symbol;
    case "object":
      return Array.isArray(e) ? $e.array : e === null ? $e.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? $e.promise : typeof Map < "u" && e instanceof Map ? $e.map : typeof Set < "u" && e instanceof Set ? $e.set : typeof Date < "u" && e instanceof Date ? $e.date : $e.object;
    default:
      return $e.unknown;
  }
}, Me = Wt.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class Mi extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const n = t || function(a) {
      return a.message;
    }, r = { _errors: [] }, o = (a) => {
      for (const s of a.issues)
        if (s.code === "invalid_union")
          s.unionErrors.map(o);
        else if (s.code === "invalid_return_type")
          o(s.returnTypeError);
        else if (s.code === "invalid_arguments")
          o(s.argumentsError);
        else if (s.path.length === 0)
          r._errors.push(n(s));
        else {
          let l = r, c = 0;
          for (; c < s.path.length; ) {
            const d = s.path[c];
            c === s.path.length - 1 ? (l[d] = l[d] || { _errors: [] }, l[d]._errors.push(n(s))) : l[d] = l[d] || { _errors: [] }, l = l[d], c++;
          }
        }
    };
    return o(this), r;
  }
  static assert(t) {
    if (!(t instanceof Mi))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Wt.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, r = [];
    for (const o of this.issues)
      o.path.length > 0 ? (n[o.path[0]] = n[o.path[0]] || [], n[o.path[0]].push(t(o))) : r.push(t(o));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Mi.create = (e) => new Mi(e);
const M3 = (e, t) => {
  let n;
  switch (e.code) {
    case Me.invalid_type:
      e.received === $e.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case Me.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, Wt.jsonStringifyReplacer)}`;
      break;
    case Me.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${Wt.joinValues(e.keys, ", ")}`;
      break;
    case Me.invalid_union:
      n = "Invalid input";
      break;
    case Me.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${Wt.joinValues(e.options)}`;
      break;
    case Me.invalid_enum_value:
      n = `Invalid enum value. Expected ${Wt.joinValues(e.options)}, received '${e.received}'`;
      break;
    case Me.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case Me.invalid_return_type:
      n = "Invalid function return type";
      break;
    case Me.invalid_date:
      n = "Invalid date";
      break;
    case Me.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : Wt.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case Me.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case Me.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case Me.custom:
      n = "Invalid input";
      break;
    case Me.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case Me.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case Me.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, Wt.assertNever(e);
  }
  return { message: n };
};
let zte = M3;
function Ute() {
  return zte;
}
const Xte = (e) => {
  const { data: t, path: n, errorMaps: r, issueData: o } = e, a = [...n, ...o.path || []], s = {
    ...o,
    path: a
  };
  if (o.message !== void 0)
    return {
      ...o,
      path: a,
      message: o.message
    };
  let l = "";
  const c = r.filter((d) => !!d).slice().reverse();
  for (const d of c)
    l = d(s, { data: t, defaultError: l }).message;
  return {
    ...o,
    path: a,
    message: l
  };
};
function Oe(e, t) {
  const n = Ute(), r = Xte({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      n,
      // then global override map
      n === M3 ? void 0 : M3
      // then global default map
    ].filter((o) => !!o)
  });
  e.common.issues.push(r);
}
class Gr {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const r = [];
    for (const o of n) {
      if (o.status === "aborted")
        return ht;
      o.status === "dirty" && t.dirty(), r.push(o.value);
    }
    return { status: t.value, value: r };
  }
  static async mergeObjectAsync(t, n) {
    const r = [];
    for (const o of n) {
      const a = await o.key, s = await o.value;
      r.push({
        key: a,
        value: s
      });
    }
    return Gr.mergeObjectSync(t, r);
  }
  static mergeObjectSync(t, n) {
    const r = {};
    for (const o of n) {
      const { key: a, value: s } = o;
      if (a.status === "aborted" || s.status === "aborted")
        return ht;
      a.status === "dirty" && t.dirty(), s.status === "dirty" && t.dirty(), a.value !== "__proto__" && (typeof s.value < "u" || o.alwaysSet) && (r[a.value] = s.value);
    }
    return { status: t.value, value: r };
  }
}
const ht = Object.freeze({
  status: "aborted"
}), f1 = (e) => ({ status: "dirty", value: e }), Yo = (e) => ({ status: "valid", value: e }), fC = (e) => e.status === "aborted", hC = (e) => e.status === "dirty", Uu = (e) => e.status === "valid", tf = (e) => typeof Promise < "u" && e instanceof Promise;
var Ue;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(Ue || (Ue = {}));
class Ha {
  constructor(t, n, r, o) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = r, this._key = o;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const pC = (e, t) => {
  if (Uu(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new Mi(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function Mt(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: n, required_error: r, description: o } = e;
  if (t && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: o } : { errorMap: (s, l) => {
    const { message: c } = e;
    return s.code === "invalid_enum_value" ? { message: c ?? l.defaultError } : typeof l.data > "u" ? { message: c ?? r ?? l.defaultError } : s.code !== "invalid_type" ? { message: l.defaultError } : { message: c ?? n ?? l.defaultError };
  }, description: o };
}
class Vt {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return ts(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: ts(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new Gr(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: ts(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (tf(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const r = this.safeParse(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(t, n) {
    const r = {
      common: {
        issues: [],
        async: (n == null ? void 0 : n.async) ?? !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ts(t)
    }, o = this._parseSync({ data: t, path: r.path, parent: r });
    return pC(r, o);
  }
  "~validate"(t) {
    var r, o;
    const n = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ts(t)
    };
    if (!this["~standard"].async)
      try {
        const a = this._parseSync({ data: t, path: [], parent: n });
        return Uu(a) ? {
          value: a.value
        } : {
          issues: n.common.issues
        };
      } catch (a) {
        (o = (r = a == null ? void 0 : a.message) == null ? void 0 : r.toLowerCase()) != null && o.includes("encountered") && (this["~standard"].async = !0), n.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: n }).then((a) => Uu(a) ? {
      value: a.value
    } : {
      issues: n.common.issues
    });
  }
  async parseAsync(t, n) {
    const r = await this.safeParseAsync(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(t, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ts(t)
    }, o = this._parse({ data: t, path: r.path, parent: r }), a = await (tf(o) ? o : Promise.resolve(o));
    return pC(r, a);
  }
  refine(t, n) {
    const r = (o) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(o) : n;
    return this._refinement((o, a) => {
      const s = t(o), l = () => a.addIssue({
        code: Me.custom,
        ...r(o)
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then((c) => c ? !0 : (l(), !1)) : s ? !0 : (l(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((r, o) => t(r) ? !0 : (o.addIssue(typeof n == "function" ? n(r, o) : n), !1));
  }
  _refinement(t) {
    return new xi({
      schema: this,
      typeName: mt.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (n) => this["~validate"](n)
    };
  }
  optional() {
    return mi.create(this, this._def);
  }
  nullable() {
    return bl.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ka.create(this);
  }
  promise() {
    return ff.create(this, this._def);
  }
  or(t) {
    return af.create([this, t], this._def);
  }
  and(t) {
    return sf.create(this, t, this._def);
  }
  transform(t) {
    return new xi({
      ...Mt(this._def),
      schema: this,
      typeName: mt.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new hf({
      ...Mt(this._def),
      innerType: this,
      defaultValue: n,
      typeName: mt.ZodDefault
    });
  }
  brand() {
    return new Yx({
      typeName: mt.ZodBranded,
      type: this,
      ...Mt(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new pf({
      ...Mt(this._def),
      innerType: this,
      catchValue: n,
      typeName: mt.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return N4.create(this, t);
  }
  readonly() {
    return mf.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Yte = /^c[^\s-]{8,}$/i, qte = /^[0-9a-z]+$/, Jte = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Kte = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Qte = /^[a-z0-9_-]{21}$/i, ene = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, tne = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, nne = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, rne = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let i5;
const one = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, ane = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, ine = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, sne = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, lne = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, une = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, zx = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", cne = new RegExp(`^${zx}$`);
function Ux(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const n = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${n}`;
}
function dne(e) {
  return new RegExp(`^${Ux(e)}$`);
}
function fne(e) {
  let t = `${zx}T${Ux(e)}`;
  const n = [];
  return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, new RegExp(`^${t}$`);
}
function hne(e, t) {
  return !!((t === "v4" || !t) && one.test(e) || (t === "v6" || !t) && ine.test(e));
}
function pne(e, t) {
  if (!ene.test(e))
    return !1;
  try {
    const [n] = e.split("."), r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), o = JSON.parse(atob(r));
    return !(typeof o != "object" || o === null || "typ" in o && (o == null ? void 0 : o.typ) !== "JWT" || !o.alg || t && o.alg !== t);
  } catch {
    return !1;
  }
}
function mne(e, t) {
  return !!((t === "v4" || !t) && ane.test(e) || (t === "v6" || !t) && sne.test(e));
}
class Da extends Vt {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== $e.string) {
      const a = this._getOrReturnCtx(t);
      return Oe(a, {
        code: Me.invalid_type,
        expected: $e.string,
        received: a.parsedType
      }), ht;
    }
    const r = new Gr();
    let o;
    for (const a of this._def.checks)
      if (a.kind === "min")
        t.data.length < a.value && (o = this._getOrReturnCtx(t, o), Oe(o, {
          code: Me.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "max")
        t.data.length > a.value && (o = this._getOrReturnCtx(t, o), Oe(o, {
          code: Me.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "length") {
        const s = t.data.length > a.value, l = t.data.length < a.value;
        (s || l) && (o = this._getOrReturnCtx(t, o), s ? Oe(o, {
          code: Me.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : l && Oe(o, {
          code: Me.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), r.dirty());
      } else if (a.kind === "email")
        nne.test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "email",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "emoji")
        i5 || (i5 = new RegExp(rne, "u")), i5.test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "emoji",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "uuid")
        Kte.test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "uuid",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "nanoid")
        Qte.test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "nanoid",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid")
        Yte.test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "cuid",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid2")
        qte.test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "cuid2",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "ulid")
        Jte.test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "ulid",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "url")
        try {
          new URL(t.data);
        } catch {
          o = this._getOrReturnCtx(t, o), Oe(o, {
            validation: "url",
            code: Me.invalid_string,
            message: a.message
          }), r.dirty();
        }
      else
        a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "regex",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty())) : a.kind === "trim" ? t.data = t.data.trim() : a.kind === "includes" ? t.data.includes(a.value, a.position) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          code: Me.invalid_string,
          validation: { includes: a.value, position: a.position },
          message: a.message
        }), r.dirty()) : a.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : a.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : a.kind === "startsWith" ? t.data.startsWith(a.value) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          code: Me.invalid_string,
          validation: { startsWith: a.value },
          message: a.message
        }), r.dirty()) : a.kind === "endsWith" ? t.data.endsWith(a.value) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          code: Me.invalid_string,
          validation: { endsWith: a.value },
          message: a.message
        }), r.dirty()) : a.kind === "datetime" ? fne(a).test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          code: Me.invalid_string,
          validation: "datetime",
          message: a.message
        }), r.dirty()) : a.kind === "date" ? cne.test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          code: Me.invalid_string,
          validation: "date",
          message: a.message
        }), r.dirty()) : a.kind === "time" ? dne(a).test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          code: Me.invalid_string,
          validation: "time",
          message: a.message
        }), r.dirty()) : a.kind === "duration" ? tne.test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "duration",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "ip" ? hne(t.data, a.version) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "ip",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "jwt" ? pne(t.data, a.alg) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "jwt",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "cidr" ? mne(t.data, a.version) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "cidr",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "base64" ? lne.test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "base64",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "base64url" ? une.test(t.data) || (o = this._getOrReturnCtx(t, o), Oe(o, {
          validation: "base64url",
          code: Me.invalid_string,
          message: a.message
        }), r.dirty()) : Wt.assertNever(a);
    return { status: r.value, value: t.data };
  }
  _regex(t, n, r) {
    return this.refinement((o) => t.test(o), {
      validation: n,
      code: Me.invalid_string,
      ...Ue.errToObj(r)
    });
  }
  _addCheck(t) {
    return new Da({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...Ue.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...Ue.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...Ue.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...Ue.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...Ue.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...Ue.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...Ue.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...Ue.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...Ue.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...Ue.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...Ue.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...Ue.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...Ue.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (t == null ? void 0 : t.offset) ?? !1,
      local: (t == null ? void 0 : t.local) ?? !1,
      ...Ue.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...Ue.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...Ue.errToObj(t) });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...Ue.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n == null ? void 0 : n.position,
      ...Ue.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...Ue.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...Ue.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...Ue.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...Ue.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...Ue.errToObj(n)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, Ue.errToObj(t));
  }
  trim() {
    return new Da({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Da({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Da({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Da.create = (e) => new Da({
  checks: [],
  typeName: mt.ZodString,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...Mt(e)
});
function gne(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, o = n > r ? n : r, a = Number.parseInt(e.toFixed(o).replace(".", "")), s = Number.parseInt(t.toFixed(o).replace(".", ""));
  return a % s / 10 ** o;
}
class ml extends Vt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== $e.number) {
      const a = this._getOrReturnCtx(t);
      return Oe(a, {
        code: Me.invalid_type,
        expected: $e.number,
        received: a.parsedType
      }), ht;
    }
    let r;
    const o = new Gr();
    for (const a of this._def.checks)
      a.kind === "int" ? Wt.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), Oe(r, {
        code: Me.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), o.dirty()) : a.kind === "min" ? (a.inclusive ? t.data < a.value : t.data <= a.value) && (r = this._getOrReturnCtx(t, r), Oe(r, {
        code: Me.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), o.dirty()) : a.kind === "max" ? (a.inclusive ? t.data > a.value : t.data >= a.value) && (r = this._getOrReturnCtx(t, r), Oe(r, {
        code: Me.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), o.dirty()) : a.kind === "multipleOf" ? gne(t.data, a.value) !== 0 && (r = this._getOrReturnCtx(t, r), Oe(r, {
        code: Me.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), o.dirty()) : a.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), Oe(r, {
        code: Me.not_finite,
        message: a.message
      }), o.dirty()) : Wt.assertNever(a);
    return { status: o.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, Ue.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, Ue.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, Ue.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, Ue.toString(n));
  }
  setLimit(t, n, r, o) {
    return new ml({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: Ue.toString(o)
        }
      ]
    });
  }
  _addCheck(t) {
    return new ml({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: Ue.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Ue.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Ue.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Ue.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Ue.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Ue.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: Ue.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Ue.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Ue.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && Wt.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
ml.create = (e) => new ml({
  checks: [],
  typeName: mt.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Mt(e)
});
class gl extends Vt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== $e.bigint)
      return this._getInvalidInput(t);
    let r;
    const o = new Gr();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? t.data < a.value : t.data <= a.value) && (r = this._getOrReturnCtx(t, r), Oe(r, {
        code: Me.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), o.dirty()) : a.kind === "max" ? (a.inclusive ? t.data > a.value : t.data >= a.value) && (r = this._getOrReturnCtx(t, r), Oe(r, {
        code: Me.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), o.dirty()) : a.kind === "multipleOf" ? t.data % a.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), Oe(r, {
        code: Me.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), o.dirty()) : Wt.assertNever(a);
    return { status: o.value, value: t.data };
  }
  _getInvalidInput(t) {
    const n = this._getOrReturnCtx(t);
    return Oe(n, {
      code: Me.invalid_type,
      expected: $e.bigint,
      received: n.parsedType
    }), ht;
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, Ue.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, Ue.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, Ue.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, Ue.toString(n));
  }
  setLimit(t, n, r, o) {
    return new gl({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: Ue.toString(o)
        }
      ]
    });
  }
  _addCheck(t) {
    return new gl({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Ue.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Ue.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Ue.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Ue.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Ue.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
gl.create = (e) => new gl({
  checks: [],
  typeName: mt.ZodBigInt,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...Mt(e)
});
class nf extends Vt {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== $e.boolean) {
      const r = this._getOrReturnCtx(t);
      return Oe(r, {
        code: Me.invalid_type,
        expected: $e.boolean,
        received: r.parsedType
      }), ht;
    }
    return Yo(t.data);
  }
}
nf.create = (e) => new nf({
  typeName: mt.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Mt(e)
});
class Xu extends Vt {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== $e.date) {
      const a = this._getOrReturnCtx(t);
      return Oe(a, {
        code: Me.invalid_type,
        expected: $e.date,
        received: a.parsedType
      }), ht;
    }
    if (Number.isNaN(t.data.getTime())) {
      const a = this._getOrReturnCtx(t);
      return Oe(a, {
        code: Me.invalid_date
      }), ht;
    }
    const r = new Gr();
    let o;
    for (const a of this._def.checks)
      a.kind === "min" ? t.data.getTime() < a.value && (o = this._getOrReturnCtx(t, o), Oe(o, {
        code: Me.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), r.dirty()) : a.kind === "max" ? t.data.getTime() > a.value && (o = this._getOrReturnCtx(t, o), Oe(o, {
        code: Me.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), r.dirty()) : Wt.assertNever(a);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Xu({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: Ue.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: Ue.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
Xu.create = (e) => new Xu({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: mt.ZodDate,
  ...Mt(e)
});
class x3 extends Vt {
  _parse(t) {
    if (this._getType(t) !== $e.symbol) {
      const r = this._getOrReturnCtx(t);
      return Oe(r, {
        code: Me.invalid_type,
        expected: $e.symbol,
        received: r.parsedType
      }), ht;
    }
    return Yo(t.data);
  }
}
x3.create = (e) => new x3({
  typeName: mt.ZodSymbol,
  ...Mt(e)
});
class rf extends Vt {
  _parse(t) {
    if (this._getType(t) !== $e.undefined) {
      const r = this._getOrReturnCtx(t);
      return Oe(r, {
        code: Me.invalid_type,
        expected: $e.undefined,
        received: r.parsedType
      }), ht;
    }
    return Yo(t.data);
  }
}
rf.create = (e) => new rf({
  typeName: mt.ZodUndefined,
  ...Mt(e)
});
class of extends Vt {
  _parse(t) {
    if (this._getType(t) !== $e.null) {
      const r = this._getOrReturnCtx(t);
      return Oe(r, {
        code: Me.invalid_type,
        expected: $e.null,
        received: r.parsedType
      }), ht;
    }
    return Yo(t.data);
  }
}
of.create = (e) => new of({
  typeName: mt.ZodNull,
  ...Mt(e)
});
class q1 extends Vt {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return Yo(t.data);
  }
}
q1.create = (e) => new q1({
  typeName: mt.ZodAny,
  ...Mt(e)
});
class _3 extends Vt {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return Yo(t.data);
  }
}
_3.create = (e) => new _3({
  typeName: mt.ZodUnknown,
  ...Mt(e)
});
class gs extends Vt {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return Oe(n, {
      code: Me.invalid_type,
      expected: $e.never,
      received: n.parsedType
    }), ht;
  }
}
gs.create = (e) => new gs({
  typeName: mt.ZodNever,
  ...Mt(e)
});
class I3 extends Vt {
  _parse(t) {
    if (this._getType(t) !== $e.undefined) {
      const r = this._getOrReturnCtx(t);
      return Oe(r, {
        code: Me.invalid_type,
        expected: $e.void,
        received: r.parsedType
      }), ht;
    }
    return Yo(t.data);
  }
}
I3.create = (e) => new I3({
  typeName: mt.ZodVoid,
  ...Mt(e)
});
class ka extends Vt {
  _parse(t) {
    const { ctx: n, status: r } = this._processInputParams(t), o = this._def;
    if (n.parsedType !== $e.array)
      return Oe(n, {
        code: Me.invalid_type,
        expected: $e.array,
        received: n.parsedType
      }), ht;
    if (o.exactLength !== null) {
      const s = n.data.length > o.exactLength.value, l = n.data.length < o.exactLength.value;
      (s || l) && (Oe(n, {
        code: s ? Me.too_big : Me.too_small,
        minimum: l ? o.exactLength.value : void 0,
        maximum: s ? o.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: o.exactLength.message
      }), r.dirty());
    }
    if (o.minLength !== null && n.data.length < o.minLength.value && (Oe(n, {
      code: Me.too_small,
      minimum: o.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.minLength.message
    }), r.dirty()), o.maxLength !== null && n.data.length > o.maxLength.value && (Oe(n, {
      code: Me.too_big,
      maximum: o.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((s, l) => o.type._parseAsync(new Ha(n, s, n.path, l)))).then((s) => Gr.mergeArray(r, s));
    const a = [...n.data].map((s, l) => o.type._parseSync(new Ha(n, s, n.path, l)));
    return Gr.mergeArray(r, a);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new ka({
      ...this._def,
      minLength: { value: t, message: Ue.toString(n) }
    });
  }
  max(t, n) {
    return new ka({
      ...this._def,
      maxLength: { value: t, message: Ue.toString(n) }
    });
  }
  length(t, n) {
    return new ka({
      ...this._def,
      exactLength: { value: t, message: Ue.toString(n) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
ka.create = (e, t) => new ka({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: mt.ZodArray,
  ...Mt(t)
});
function pu(e) {
  if (e instanceof On) {
    const t = {};
    for (const n in e.shape) {
      const r = e.shape[n];
      t[n] = mi.create(pu(r));
    }
    return new On({
      ...e._def,
      shape: () => t
    });
  } else
    return e instanceof ka ? new ka({
      ...e._def,
      type: pu(e.element)
    }) : e instanceof mi ? mi.create(pu(e.unwrap())) : e instanceof bl ? bl.create(pu(e.unwrap())) : e instanceof vl ? vl.create(e.items.map((t) => pu(t))) : e;
}
class On extends Vt {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), n = Wt.objectKeys(t);
    return this._cached = { shape: t, keys: n }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== $e.object) {
      const d = this._getOrReturnCtx(t);
      return Oe(d, {
        code: Me.invalid_type,
        expected: $e.object,
        received: d.parsedType
      }), ht;
    }
    const { status: r, ctx: o } = this._processInputParams(t), { shape: a, keys: s } = this._getCached(), l = [];
    if (!(this._def.catchall instanceof gs && this._def.unknownKeys === "strip"))
      for (const d in o.data)
        s.includes(d) || l.push(d);
    const c = [];
    for (const d of s) {
      const f = a[d], h = o.data[d];
      c.push({
        key: { status: "valid", value: d },
        value: f._parse(new Ha(o, h, o.path, d)),
        alwaysSet: d in o.data
      });
    }
    if (this._def.catchall instanceof gs) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const f of l)
          c.push({
            key: { status: "valid", value: f },
            value: { status: "valid", value: o.data[f] }
          });
      else if (d === "strict")
        l.length > 0 && (Oe(o, {
          code: Me.unrecognized_keys,
          keys: l
        }), r.dirty());
      else if (d !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const f of l) {
        const h = o.data[f];
        c.push({
          key: { status: "valid", value: f },
          value: d._parse(
            new Ha(o, h, o.path, f)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: f in o.data
        });
      }
    }
    return o.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const f of c) {
        const h = await f.key, m = await f.value;
        d.push({
          key: h,
          value: m,
          alwaysSet: f.alwaysSet
        });
      }
      return d;
    }).then((d) => Gr.mergeObjectSync(r, d)) : Gr.mergeObjectSync(r, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return Ue.errToObj, new On({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (n, r) => {
          var a, s;
          const o = ((s = (a = this._def).errorMap) == null ? void 0 : s.call(a, n, r).message) ?? r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: Ue.errToObj(t).message ?? o
          } : {
            message: o
          };
        }
      } : {}
    });
  }
  strip() {
    return new On({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new On({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new On({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new On({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: mt.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new On({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    for (const r of Wt.objectKeys(t))
      t[r] && this.shape[r] && (n[r] = this.shape[r]);
    return new On({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    for (const r of Wt.objectKeys(this.shape))
      t[r] || (n[r] = this.shape[r]);
    return new On({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return pu(this);
  }
  partial(t) {
    const n = {};
    for (const r of Wt.objectKeys(this.shape)) {
      const o = this.shape[r];
      t && !t[r] ? n[r] = o : n[r] = o.optional();
    }
    return new On({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    for (const r of Wt.objectKeys(this.shape))
      if (t && !t[r])
        n[r] = this.shape[r];
      else {
        let a = this.shape[r];
        for (; a instanceof mi; )
          a = a._def.innerType;
        n[r] = a;
      }
    return new On({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return Xx(Wt.objectKeys(this.shape));
  }
}
On.create = (e, t) => new On({
  shape: () => e,
  unknownKeys: "strip",
  catchall: gs.create(),
  typeName: mt.ZodObject,
  ...Mt(t)
});
On.strictCreate = (e, t) => new On({
  shape: () => e,
  unknownKeys: "strict",
  catchall: gs.create(),
  typeName: mt.ZodObject,
  ...Mt(t)
});
On.lazycreate = (e, t) => new On({
  shape: e,
  unknownKeys: "strip",
  catchall: gs.create(),
  typeName: mt.ZodObject,
  ...Mt(t)
});
class af extends Vt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = this._def.options;
    function o(a) {
      for (const l of a)
        if (l.result.status === "valid")
          return l.result;
      for (const l of a)
        if (l.result.status === "dirty")
          return n.common.issues.push(...l.ctx.common.issues), l.result;
      const s = a.map((l) => new Mi(l.ctx.common.issues));
      return Oe(n, {
        code: Me.invalid_union,
        unionErrors: s
      }), ht;
    }
    if (n.common.async)
      return Promise.all(r.map(async (a) => {
        const s = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: n.data,
            path: n.path,
            parent: s
          }),
          ctx: s
        };
      })).then(o);
    {
      let a;
      const s = [];
      for (const c of r) {
        const d = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, f = c._parseSync({
          data: n.data,
          path: n.path,
          parent: d
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !a && (a = { result: f, ctx: d }), d.common.issues.length && s.push(d.common.issues);
      }
      if (a)
        return n.common.issues.push(...a.ctx.common.issues), a.result;
      const l = s.map((c) => new Mi(c));
      return Oe(n, {
        code: Me.invalid_union,
        unionErrors: l
      }), ht;
    }
  }
  get options() {
    return this._def.options;
  }
}
af.create = (e, t) => new af({
  options: e,
  typeName: mt.ZodUnion,
  ...Mt(t)
});
const ni = (e) => e instanceof uf ? ni(e.schema) : e instanceof xi ? ni(e.innerType()) : e instanceof cf ? [e.value] : e instanceof Cl ? e.options : e instanceof df ? Wt.objectValues(e.enum) : e instanceof hf ? ni(e._def.innerType) : e instanceof rf ? [void 0] : e instanceof of ? [null] : e instanceof mi ? [void 0, ...ni(e.unwrap())] : e instanceof bl ? [null, ...ni(e.unwrap())] : e instanceof Yx || e instanceof mf ? ni(e.unwrap()) : e instanceof pf ? ni(e._def.innerType) : [];
class D4 extends Vt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== $e.object)
      return Oe(n, {
        code: Me.invalid_type,
        expected: $e.object,
        received: n.parsedType
      }), ht;
    const r = this.discriminator, o = n.data[r], a = this.optionsMap.get(o);
    return a ? n.common.async ? a._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : a._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (Oe(n, {
      code: Me.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), ht);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, n, r) {
    const o = /* @__PURE__ */ new Map();
    for (const a of n) {
      const s = ni(a.shape[t]);
      if (!s.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const l of s) {
        if (o.has(l))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(l)}`);
        o.set(l, a);
      }
    }
    return new D4({
      typeName: mt.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: o,
      ...Mt(r)
    });
  }
}
function w3(e, t) {
  const n = ts(e), r = ts(t);
  if (e === t)
    return { valid: !0, data: e };
  if (n === $e.object && r === $e.object) {
    const o = Wt.objectKeys(t), a = Wt.objectKeys(e).filter((l) => o.indexOf(l) !== -1), s = { ...e, ...t };
    for (const l of a) {
      const c = w3(e[l], t[l]);
      if (!c.valid)
        return { valid: !1 };
      s[l] = c.data;
    }
    return { valid: !0, data: s };
  } else if (n === $e.array && r === $e.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const o = [];
    for (let a = 0; a < e.length; a++) {
      const s = e[a], l = t[a], c = w3(s, l);
      if (!c.valid)
        return { valid: !1 };
      o.push(c.data);
    }
    return { valid: !0, data: o };
  } else
    return n === $e.date && r === $e.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class sf extends Vt {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), o = (a, s) => {
      if (fC(a) || fC(s))
        return ht;
      const l = w3(a.value, s.value);
      return l.valid ? ((hC(a) || hC(s)) && n.dirty(), { status: n.value, value: l.data }) : (Oe(r, {
        code: Me.invalid_intersection_types
      }), ht);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([a, s]) => o(a, s)) : o(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
sf.create = (e, t, n) => new sf({
  left: e,
  right: t,
  typeName: mt.ZodIntersection,
  ...Mt(n)
});
class vl extends Vt {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== $e.array)
      return Oe(r, {
        code: Me.invalid_type,
        expected: $e.array,
        received: r.parsedType
      }), ht;
    if (r.data.length < this._def.items.length)
      return Oe(r, {
        code: Me.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), ht;
    !this._def.rest && r.data.length > this._def.items.length && (Oe(r, {
      code: Me.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const a = [...r.data].map((s, l) => {
      const c = this._def.items[l] || this._def.rest;
      return c ? c._parse(new Ha(r, s, r.path, l)) : null;
    }).filter((s) => !!s);
    return r.common.async ? Promise.all(a).then((s) => Gr.mergeArray(n, s)) : Gr.mergeArray(n, a);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new vl({
      ...this._def,
      rest: t
    });
  }
}
vl.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new vl({
    items: e,
    typeName: mt.ZodTuple,
    rest: null,
    ...Mt(t)
  });
};
class lf extends Vt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== $e.object)
      return Oe(r, {
        code: Me.invalid_type,
        expected: $e.object,
        received: r.parsedType
      }), ht;
    const o = [], a = this._def.keyType, s = this._def.valueType;
    for (const l in r.data)
      o.push({
        key: a._parse(new Ha(r, l, r.path, l)),
        value: s._parse(new Ha(r, r.data[l], r.path, l)),
        alwaysSet: l in r.data
      });
    return r.common.async ? Gr.mergeObjectAsync(n, o) : Gr.mergeObjectSync(n, o);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, r) {
    return n instanceof Vt ? new lf({
      keyType: t,
      valueType: n,
      typeName: mt.ZodRecord,
      ...Mt(r)
    }) : new lf({
      keyType: Da.create(),
      valueType: t,
      typeName: mt.ZodRecord,
      ...Mt(n)
    });
  }
}
class L3 extends Vt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== $e.map)
      return Oe(r, {
        code: Me.invalid_type,
        expected: $e.map,
        received: r.parsedType
      }), ht;
    const o = this._def.keyType, a = this._def.valueType, s = [...r.data.entries()].map(([l, c], d) => ({
      key: o._parse(new Ha(r, l, r.path, [d, "key"])),
      value: a._parse(new Ha(r, c, r.path, [d, "value"]))
    }));
    if (r.common.async) {
      const l = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of s) {
          const d = await c.key, f = await c.value;
          if (d.status === "aborted" || f.status === "aborted")
            return ht;
          (d.status === "dirty" || f.status === "dirty") && n.dirty(), l.set(d.value, f.value);
        }
        return { status: n.value, value: l };
      });
    } else {
      const l = /* @__PURE__ */ new Map();
      for (const c of s) {
        const d = c.key, f = c.value;
        if (d.status === "aborted" || f.status === "aborted")
          return ht;
        (d.status === "dirty" || f.status === "dirty") && n.dirty(), l.set(d.value, f.value);
      }
      return { status: n.value, value: l };
    }
  }
}
L3.create = (e, t, n) => new L3({
  valueType: t,
  keyType: e,
  typeName: mt.ZodMap,
  ...Mt(n)
});
class Yu extends Vt {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== $e.set)
      return Oe(r, {
        code: Me.invalid_type,
        expected: $e.set,
        received: r.parsedType
      }), ht;
    const o = this._def;
    o.minSize !== null && r.data.size < o.minSize.value && (Oe(r, {
      code: Me.too_small,
      minimum: o.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.minSize.message
    }), n.dirty()), o.maxSize !== null && r.data.size > o.maxSize.value && (Oe(r, {
      code: Me.too_big,
      maximum: o.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.maxSize.message
    }), n.dirty());
    const a = this._def.valueType;
    function s(c) {
      const d = /* @__PURE__ */ new Set();
      for (const f of c) {
        if (f.status === "aborted")
          return ht;
        f.status === "dirty" && n.dirty(), d.add(f.value);
      }
      return { status: n.value, value: d };
    }
    const l = [...r.data.values()].map((c, d) => a._parse(new Ha(r, c, r.path, d)));
    return r.common.async ? Promise.all(l).then((c) => s(c)) : s(l);
  }
  min(t, n) {
    return new Yu({
      ...this._def,
      minSize: { value: t, message: Ue.toString(n) }
    });
  }
  max(t, n) {
    return new Yu({
      ...this._def,
      maxSize: { value: t, message: Ue.toString(n) }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Yu.create = (e, t) => new Yu({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: mt.ZodSet,
  ...Mt(t)
});
class uf extends Vt {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
uf.create = (e, t) => new uf({
  getter: e,
  typeName: mt.ZodLazy,
  ...Mt(t)
});
class cf extends Vt {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return Oe(n, {
        received: n.data,
        code: Me.invalid_literal,
        expected: this._def.value
      }), ht;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
cf.create = (e, t) => new cf({
  value: e,
  typeName: mt.ZodLiteral,
  ...Mt(t)
});
function Xx(e, t) {
  return new Cl({
    values: e,
    typeName: mt.ZodEnum,
    ...Mt(t)
  });
}
class Cl extends Vt {
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return Oe(n, {
        expected: Wt.joinValues(r),
        received: n.parsedType,
        code: Me.invalid_type
      }), ht;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(t.data)) {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return Oe(n, {
        received: n.data,
        code: Me.invalid_enum_value,
        options: r
      }), ht;
    }
    return Yo(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  extract(t, n = this._def) {
    return Cl.create(t, {
      ...this._def,
      ...n
    });
  }
  exclude(t, n = this._def) {
    return Cl.create(this.options.filter((r) => !t.includes(r)), {
      ...this._def,
      ...n
    });
  }
}
Cl.create = Xx;
class df extends Vt {
  _parse(t) {
    const n = Wt.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(t);
    if (r.parsedType !== $e.string && r.parsedType !== $e.number) {
      const o = Wt.objectValues(n);
      return Oe(r, {
        expected: Wt.joinValues(o),
        received: r.parsedType,
        code: Me.invalid_type
      }), ht;
    }
    if (this._cache || (this._cache = new Set(Wt.getValidEnumValues(this._def.values))), !this._cache.has(t.data)) {
      const o = Wt.objectValues(n);
      return Oe(r, {
        received: r.data,
        code: Me.invalid_enum_value,
        options: o
      }), ht;
    }
    return Yo(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
df.create = (e, t) => new df({
  values: e,
  typeName: mt.ZodNativeEnum,
  ...Mt(t)
});
class ff extends Vt {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== $e.promise && n.common.async === !1)
      return Oe(n, {
        code: Me.invalid_type,
        expected: $e.promise,
        received: n.parsedType
      }), ht;
    const r = n.parsedType === $e.promise ? n.data : Promise.resolve(n.data);
    return Yo(r.then((o) => this._def.type.parseAsync(o, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
ff.create = (e, t) => new ff({
  type: e,
  typeName: mt.ZodPromise,
  ...Mt(t)
});
class xi extends Vt {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === mt.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), o = this._def.effect || null, a = {
      addIssue: (s) => {
        Oe(r, s), s.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), o.type === "preprocess") {
      const s = o.transform(r.data, a);
      if (r.common.async)
        return Promise.resolve(s).then(async (l) => {
          if (n.value === "aborted")
            return ht;
          const c = await this._def.schema._parseAsync({
            data: l,
            path: r.path,
            parent: r
          });
          return c.status === "aborted" ? ht : c.status === "dirty" || n.value === "dirty" ? f1(c.value) : c;
        });
      {
        if (n.value === "aborted")
          return ht;
        const l = this._def.schema._parseSync({
          data: s,
          path: r.path,
          parent: r
        });
        return l.status === "aborted" ? ht : l.status === "dirty" || n.value === "dirty" ? f1(l.value) : l;
      }
    }
    if (o.type === "refinement") {
      const s = (l) => {
        const c = o.refinement(l, a);
        if (r.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return l;
      };
      if (r.common.async === !1) {
        const l = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return l.status === "aborted" ? ht : (l.status === "dirty" && n.dirty(), s(l.value), { status: n.value, value: l.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((l) => l.status === "aborted" ? ht : (l.status === "dirty" && n.dirty(), s(l.value).then(() => ({ status: n.value, value: l.value }))));
    }
    if (o.type === "transform")
      if (r.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!Uu(s))
          return ht;
        const l = o.transform(s.value, a);
        if (l instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: l };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((s) => Uu(s) ? Promise.resolve(o.transform(s.value, a)).then((l) => ({
          status: n.value,
          value: l
        })) : ht);
    Wt.assertNever(o);
  }
}
xi.create = (e, t, n) => new xi({
  schema: e,
  typeName: mt.ZodEffects,
  effect: t,
  ...Mt(n)
});
xi.createWithPreprocess = (e, t, n) => new xi({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: mt.ZodEffects,
  ...Mt(n)
});
class mi extends Vt {
  _parse(t) {
    return this._getType(t) === $e.undefined ? Yo(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
mi.create = (e, t) => new mi({
  innerType: e,
  typeName: mt.ZodOptional,
  ...Mt(t)
});
class bl extends Vt {
  _parse(t) {
    return this._getType(t) === $e.null ? Yo(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
bl.create = (e, t) => new bl({
  innerType: e,
  typeName: mt.ZodNullable,
  ...Mt(t)
});
class hf extends Vt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let r = n.data;
    return n.parsedType === $e.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
hf.create = (e, t) => new hf({
  innerType: e,
  typeName: mt.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...Mt(t)
});
class pf extends Vt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, o = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return tf(o) ? o.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Mi(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new Mi(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
pf.create = (e, t) => new pf({
  innerType: e,
  typeName: mt.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...Mt(t)
});
class R3 extends Vt {
  _parse(t) {
    if (this._getType(t) !== $e.nan) {
      const r = this._getOrReturnCtx(t);
      return Oe(r, {
        code: Me.invalid_type,
        expected: $e.nan,
        received: r.parsedType
      }), ht;
    }
    return { status: "valid", value: t.data };
  }
}
R3.create = (e) => new R3({
  typeName: mt.ZodNaN,
  ...Mt(e)
});
class Yx extends Vt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class N4 extends Vt {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? ht : a.status === "dirty" ? (n.dirty(), f1(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const o = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return o.status === "aborted" ? ht : o.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: o.value
      }) : this._def.out._parseSync({
        data: o.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(t, n) {
    return new N4({
      in: t,
      out: n,
      typeName: mt.ZodPipeline
    });
  }
}
class mf extends Vt {
  _parse(t) {
    const n = this._def.innerType._parse(t), r = (o) => (Uu(o) && (o.value = Object.freeze(o.value)), o);
    return tf(n) ? n.then((o) => r(o)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
mf.create = (e, t) => new mf({
  innerType: e,
  typeName: mt.ZodReadonly,
  ...Mt(t)
});
function mC(e, t) {
  const n = typeof e == "function" ? e(t) : typeof e == "string" ? { message: e } : e;
  return typeof n == "string" ? { message: n } : n;
}
function hh(e, t = {}, n) {
  return e ? q1.create().superRefine((r, o) => {
    const a = e(r);
    if (a instanceof Promise)
      return a.then((s) => {
        if (!s) {
          const l = mC(t, r), c = l.fatal ?? n ?? !0;
          o.addIssue({ code: "custom", ...l, fatal: c });
        }
      });
    if (!a) {
      const s = mC(t, r), l = s.fatal ?? n ?? !0;
      o.addIssue({ code: "custom", ...s, fatal: l });
    }
  }) : q1.create();
}
On.lazycreate;
var mt;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(mt || (mt = {}));
const v = Da.create, L = ml.create;
R3.create;
gl.create;
const Y = nf.create;
Xu.create;
x3.create;
const Ri = rf.create, Ou = of.create, gi = q1.create, gn = _3.create, gC = gs.create;
I3.create;
const ne = ka.create, M = On.create, Ot = On.strictCreate, zt = af.create, ga = D4.create, qx = sf.create, vne = vl.create, mn = lf.create;
L3.create;
Yu.create;
uf.create;
const ie = cf.create, be = Cl.create;
df.create;
ff.create;
xi.create;
mi.create;
const ze = bl.create;
xi.createWithPreprocess;
const Cne = {
  string: (e) => Da.create({ ...e, coerce: !0 }),
  number: (e) => ml.create({ ...e, coerce: !0 }),
  boolean: (e) => nf.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => gl.create({ ...e, coerce: !0 }),
  date: (e) => Xu.create({ ...e, coerce: !0 })
}, gf = ht;
var vf = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
vf.exports;
(function(e, t) {
  (function() {
    var n, r = "4.17.21", o = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s = "Expected a function", l = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", d = 500, f = "__lodash_placeholder__", h = 1, m = 2, g = 4, b = 1, C = 2, y = 1, _ = 2, x = 4, I = 8, R = 16, E = 32, k = 64, N = 128, P = 256, F = 512, G = 30, j = "...", ae = 800, ue = 16, le = 1, _e = 2, ve = 3, z = 1 / 0, K = 9007199254740991, Ce = 17976931348623157e292, q = 0 / 0, J = 4294967295, ge = J - 1, X = J >>> 1, pe = [
      ["ary", N],
      ["bind", y],
      ["bindKey", _],
      ["curry", I],
      ["curryRight", R],
      ["flip", F],
      ["partial", E],
      ["partialRight", k],
      ["rearg", P]
    ], fe = "[object Arguments]", de = "[object Array]", we = "[object AsyncFunction]", Ie = "[object Boolean]", Pe = "[object Date]", Se = "[object DOMException]", Fe = "[object Error]", oe = "[object Function]", pt = "[object GeneratorFunction]", Ee = "[object Map]", wt = "[object Number]", an = "[object Null]", Ft = "[object Object]", Kn = "[object Promise]", zn = "[object Proxy]", Xt = "[object RegExp]", sn = "[object Set]", Tn = "[object String]", Pn = "[object Symbol]", ro = "[object Undefined]", vr = "[object WeakMap]", qo = "[object WeakSet]", lr = "[object ArrayBuffer]", Le = "[object DataView]", Zt = "[object Float32Array]", wn = "[object Float64Array]", Un = "[object Int8Array]", Zr = "[object Int16Array]", Jo = "[object Int32Array]", Is = "[object Uint8Array]", ws = "[object Uint8ClampedArray]", oo = "[object Uint16Array]", ba = "[object Uint32Array]", fc = /\b__p \+= '';/g, Ti = /\b(__p \+=) '' \+/g, Nl = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Ao = /&(?:amp|lt|gt|quot|#39);/g, Mo = /[&<>"']/g, Ls = RegExp(Ao.source), xo = RegExp(Mo.source), hc = /<%-([\s\S]+?)%>/g, Tl = /<%([\s\S]+?)%>/g, Pl = /<%=([\s\S]+?)%>/g, kl = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Vl = /^\w*$/, ao = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Rs = /[\\^$.*+?()[\]{}|]/g, Ol = RegExp(Rs.source), Pi = /^\s+/, pc = /\s/, mc = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, ya = /\{\n\/\* \[wrapped with (.+)\] \*/, gc = /,? & /, B = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ae = /[()=,{}\[\]\/\s]/, ke = /\\(\\)?/g, at = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, St = /\w*$/, Yt = /^[-+]0x[0-9a-f]+$/i, Dt = /^0b[01]+$/i, _t = /^\[object .+?Constructor\]$/, Qn = /^0o[0-7]+$/i, yn = /^(?:0|[1-9]\d*)$/, Mn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Hn = /($^)/, Sa = /['\n\r\u2028\u2029\\]/g, dr = "\\ud800-\\udfff", Xn = "\\u0300-\\u036f", Es = "\\ufe20-\\ufe2f", ki = "\\u20d0-\\u20ff", Ds = Xn + Es + ki, wd = "\\u2700-\\u27bf", Ld = "a-z\\xdf-\\xf6\\xf8-\\xff", Xh = "\\xac\\xb1\\xd7\\xf7", Rd = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Yh = "\\u2000-\\u206f", qh = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Ed = "A-Z\\xc0-\\xd6\\xd8-\\xde", Dd = "\\ufe0e\\ufe0f", Nd = Xh + Rd + Yh + qh, vc = "['’]", Jh = "[" + dr + "]", Td = "[" + Nd + "]", Fl = "[" + Ds + "]", Pd = "\\d+", Bl = "[" + wd + "]", Hl = "[" + Ld + "]", kd = "[^" + dr + Nd + Pd + wd + Ld + Ed + "]", Cc = "\\ud83c[\\udffb-\\udfff]", Vd = "(?:" + Fl + "|" + Cc + ")", Od = "[^" + dr + "]", bc = "(?:\\ud83c[\\udde6-\\uddff]){2}", yc = "[\\ud800-\\udbff][\\udc00-\\udfff]", ja = "[" + Ed + "]", Fd = "\\u200d", Bd = "(?:" + Hl + "|" + kd + ")", Kh = "(?:" + ja + "|" + kd + ")", Gl = "(?:" + vc + "(?:d|ll|m|re|s|t|ve))?", Hd = "(?:" + vc + "(?:D|LL|M|RE|S|T|VE))?", Gd = Vd + "?", $d = "[" + Dd + "]?", $l = "(?:" + Fd + "(?:" + [Od, bc, yc].join("|") + ")" + $d + Gd + ")*", Sc = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ac = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Zl = $d + Gd + $l, Qh = "(?:" + [Bl, bc, yc].join("|") + ")" + Zl, Zd = "(?:" + [Od + Fl + "?", Fl, bc, yc, Jh].join("|") + ")", Mc = RegExp(vc, "g"), jd = RegExp(Fl, "g"), Ko = RegExp(Cc + "(?=" + Cc + ")|" + Zd + Zl, "g"), Ns = RegExp([
      ja + "?" + Hl + "+" + Gl + "(?=" + [Td, ja, "$"].join("|") + ")",
      Kh + "+" + Hd + "(?=" + [Td, ja + Bd, "$"].join("|") + ")",
      ja + "?" + Bd + "+" + Gl,
      ja + "+" + Hd,
      Ac,
      Sc,
      Pd,
      Qh
    ].join("|"), "g"), ep = RegExp("[" + Fd + dr + Ds + Dd + "]"), Wd = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, tp = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], zd = -1, cn = {};
    cn[Zt] = cn[wn] = cn[Un] = cn[Zr] = cn[Jo] = cn[Is] = cn[ws] = cn[oo] = cn[ba] = !0, cn[fe] = cn[de] = cn[lr] = cn[Ie] = cn[Le] = cn[Pe] = cn[Fe] = cn[oe] = cn[Ee] = cn[wt] = cn[Ft] = cn[Xt] = cn[sn] = cn[Tn] = cn[vr] = !1;
    var ln = {};
    ln[fe] = ln[de] = ln[lr] = ln[Le] = ln[Ie] = ln[Pe] = ln[Zt] = ln[wn] = ln[Un] = ln[Zr] = ln[Jo] = ln[Ee] = ln[wt] = ln[Ft] = ln[Xt] = ln[sn] = ln[Tn] = ln[Pn] = ln[Is] = ln[ws] = ln[oo] = ln[ba] = !0, ln[Fe] = ln[oe] = ln[vr] = !1;
    var Ud = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, np = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, V = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, $ = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Q = parseFloat, Be = parseInt, Nt = typeof ai == "object" && ai && ai.Object === Object && ai, rn = typeof self == "object" && self && self.Object === Object && self, bt = Nt || rn || Function("return this")(), Lt = t && !t.nodeType && t, Ut = Lt && !0 && e && !e.nodeType && e, wr = Ut && Ut.exports === Lt, fr = wr && Nt.process, ur = function() {
      try {
        var W = Ut && Ut.require && Ut.require("util").types;
        return W || fr && fr.binding && fr.binding("util");
      } catch {
      }
    }(), jl = ur && ur.isArrayBuffer, Wl = ur && ur.isDate, xc = ur && ur.isMap, x9 = ur && ur.isRegExp, _9 = ur && ur.isSet, I9 = ur && ur.isTypedArray;
    function io(W, se, ee) {
      switch (ee.length) {
        case 0:
          return W.call(se);
        case 1:
          return W.call(se, ee[0]);
        case 2:
          return W.call(se, ee[0], ee[1]);
        case 3:
          return W.call(se, ee[0], ee[1], ee[2]);
      }
      return W.apply(se, ee);
    }
    function RL(W, se, ee, Ge) {
      for (var vt = -1, qt = W == null ? 0 : W.length; ++vt < qt; ) {
        var er = W[vt];
        se(Ge, er, ee(er), W);
      }
      return Ge;
    }
    function _o(W, se) {
      for (var ee = -1, Ge = W == null ? 0 : W.length; ++ee < Ge && se(W[ee], ee, W) !== !1; )
        ;
      return W;
    }
    function EL(W, se) {
      for (var ee = W == null ? 0 : W.length; ee-- && se(W[ee], ee, W) !== !1; )
        ;
      return W;
    }
    function w9(W, se) {
      for (var ee = -1, Ge = W == null ? 0 : W.length; ++ee < Ge; )
        if (!se(W[ee], ee, W))
          return !1;
      return !0;
    }
    function Vi(W, se) {
      for (var ee = -1, Ge = W == null ? 0 : W.length, vt = 0, qt = []; ++ee < Ge; ) {
        var er = W[ee];
        se(er, ee, W) && (qt[vt++] = er);
      }
      return qt;
    }
    function Xd(W, se) {
      var ee = W == null ? 0 : W.length;
      return !!ee && zl(W, se, 0) > -1;
    }
    function rp(W, se, ee) {
      for (var Ge = -1, vt = W == null ? 0 : W.length; ++Ge < vt; )
        if (ee(se, W[Ge]))
          return !0;
      return !1;
    }
    function xn(W, se) {
      for (var ee = -1, Ge = W == null ? 0 : W.length, vt = Array(Ge); ++ee < Ge; )
        vt[ee] = se(W[ee], ee, W);
      return vt;
    }
    function Oi(W, se) {
      for (var ee = -1, Ge = se.length, vt = W.length; ++ee < Ge; )
        W[vt + ee] = se[ee];
      return W;
    }
    function op(W, se, ee, Ge) {
      var vt = -1, qt = W == null ? 0 : W.length;
      for (Ge && qt && (ee = W[++vt]); ++vt < qt; )
        ee = se(ee, W[vt], vt, W);
      return ee;
    }
    function DL(W, se, ee, Ge) {
      var vt = W == null ? 0 : W.length;
      for (Ge && vt && (ee = W[--vt]); vt--; )
        ee = se(ee, W[vt], vt, W);
      return ee;
    }
    function ap(W, se) {
      for (var ee = -1, Ge = W == null ? 0 : W.length; ++ee < Ge; )
        if (se(W[ee], ee, W))
          return !0;
      return !1;
    }
    var NL = ip("length");
    function TL(W) {
      return W.split("");
    }
    function PL(W) {
      return W.match(B) || [];
    }
    function L9(W, se, ee) {
      var Ge;
      return ee(W, function(vt, qt, er) {
        if (se(vt, qt, er))
          return Ge = qt, !1;
      }), Ge;
    }
    function Yd(W, se, ee, Ge) {
      for (var vt = W.length, qt = ee + (Ge ? 1 : -1); Ge ? qt-- : ++qt < vt; )
        if (se(W[qt], qt, W))
          return qt;
      return -1;
    }
    function zl(W, se, ee) {
      return se === se ? zL(W, se, ee) : Yd(W, R9, ee);
    }
    function kL(W, se, ee, Ge) {
      for (var vt = ee - 1, qt = W.length; ++vt < qt; )
        if (Ge(W[vt], se))
          return vt;
      return -1;
    }
    function R9(W) {
      return W !== W;
    }
    function E9(W, se) {
      var ee = W == null ? 0 : W.length;
      return ee ? lp(W, se) / ee : q;
    }
    function ip(W) {
      return function(se) {
        return se == null ? n : se[W];
      };
    }
    function sp(W) {
      return function(se) {
        return W == null ? n : W[se];
      };
    }
    function D9(W, se, ee, Ge, vt) {
      return vt(W, function(qt, er, dn) {
        ee = Ge ? (Ge = !1, qt) : se(ee, qt, er, dn);
      }), ee;
    }
    function VL(W, se) {
      var ee = W.length;
      for (W.sort(se); ee--; )
        W[ee] = W[ee].value;
      return W;
    }
    function lp(W, se) {
      for (var ee, Ge = -1, vt = W.length; ++Ge < vt; ) {
        var qt = se(W[Ge]);
        qt !== n && (ee = ee === n ? qt : ee + qt);
      }
      return ee;
    }
    function up(W, se) {
      for (var ee = -1, Ge = Array(W); ++ee < W; )
        Ge[ee] = se(ee);
      return Ge;
    }
    function OL(W, se) {
      return xn(se, function(ee) {
        return [ee, W[ee]];
      });
    }
    function N9(W) {
      return W && W.slice(0, V9(W) + 1).replace(Pi, "");
    }
    function so(W) {
      return function(se) {
        return W(se);
      };
    }
    function cp(W, se) {
      return xn(se, function(ee) {
        return W[ee];
      });
    }
    function _c(W, se) {
      return W.has(se);
    }
    function T9(W, se) {
      for (var ee = -1, Ge = W.length; ++ee < Ge && zl(se, W[ee], 0) > -1; )
        ;
      return ee;
    }
    function P9(W, se) {
      for (var ee = W.length; ee-- && zl(se, W[ee], 0) > -1; )
        ;
      return ee;
    }
    function FL(W, se) {
      for (var ee = W.length, Ge = 0; ee--; )
        W[ee] === se && ++Ge;
      return Ge;
    }
    var BL = sp(Ud), HL = sp(np);
    function GL(W) {
      return "\\" + $[W];
    }
    function $L(W, se) {
      return W == null ? n : W[se];
    }
    function Ul(W) {
      return ep.test(W);
    }
    function ZL(W) {
      return Wd.test(W);
    }
    function jL(W) {
      for (var se, ee = []; !(se = W.next()).done; )
        ee.push(se.value);
      return ee;
    }
    function dp(W) {
      var se = -1, ee = Array(W.size);
      return W.forEach(function(Ge, vt) {
        ee[++se] = [vt, Ge];
      }), ee;
    }
    function k9(W, se) {
      return function(ee) {
        return W(se(ee));
      };
    }
    function Fi(W, se) {
      for (var ee = -1, Ge = W.length, vt = 0, qt = []; ++ee < Ge; ) {
        var er = W[ee];
        (er === se || er === f) && (W[ee] = f, qt[vt++] = ee);
      }
      return qt;
    }
    function qd(W) {
      var se = -1, ee = Array(W.size);
      return W.forEach(function(Ge) {
        ee[++se] = Ge;
      }), ee;
    }
    function WL(W) {
      var se = -1, ee = Array(W.size);
      return W.forEach(function(Ge) {
        ee[++se] = [Ge, Ge];
      }), ee;
    }
    function zL(W, se, ee) {
      for (var Ge = ee - 1, vt = W.length; ++Ge < vt; )
        if (W[Ge] === se)
          return Ge;
      return -1;
    }
    function UL(W, se, ee) {
      for (var Ge = ee + 1; Ge--; )
        if (W[Ge] === se)
          return Ge;
      return Ge;
    }
    function Xl(W) {
      return Ul(W) ? YL(W) : NL(W);
    }
    function Qo(W) {
      return Ul(W) ? qL(W) : TL(W);
    }
    function V9(W) {
      for (var se = W.length; se-- && pc.test(W.charAt(se)); )
        ;
      return se;
    }
    var XL = sp(V);
    function YL(W) {
      for (var se = Ko.lastIndex = 0; Ko.test(W); )
        ++se;
      return se;
    }
    function qL(W) {
      return W.match(Ko) || [];
    }
    function JL(W) {
      return W.match(Ns) || [];
    }
    var KL = function W(se) {
      se = se == null ? bt : Yl.defaults(bt.Object(), se, Yl.pick(bt, tp));
      var ee = se.Array, Ge = se.Date, vt = se.Error, qt = se.Function, er = se.Math, dn = se.Object, fp = se.RegExp, QL = se.String, Io = se.TypeError, Jd = ee.prototype, eR = qt.prototype, ql = dn.prototype, Kd = se["__core-js_shared__"], Qd = eR.toString, on = ql.hasOwnProperty, tR = 0, O9 = function() {
        var i = /[^.]+$/.exec(Kd && Kd.keys && Kd.keys.IE_PROTO || "");
        return i ? "Symbol(src)_1." + i : "";
      }(), e0 = ql.toString, nR = Qd.call(dn), rR = bt._, oR = fp(
        "^" + Qd.call(on).replace(Rs, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), t0 = wr ? se.Buffer : n, Bi = se.Symbol, n0 = se.Uint8Array, F9 = t0 ? t0.allocUnsafe : n, r0 = k9(dn.getPrototypeOf, dn), B9 = dn.create, H9 = ql.propertyIsEnumerable, o0 = Jd.splice, G9 = Bi ? Bi.isConcatSpreadable : n, Ic = Bi ? Bi.iterator : n, Ts = Bi ? Bi.toStringTag : n, a0 = function() {
        try {
          var i = Fs(dn, "defineProperty");
          return i({}, "", {}), i;
        } catch {
        }
      }(), aR = se.clearTimeout !== bt.clearTimeout && se.clearTimeout, iR = Ge && Ge.now !== bt.Date.now && Ge.now, sR = se.setTimeout !== bt.setTimeout && se.setTimeout, i0 = er.ceil, s0 = er.floor, hp = dn.getOwnPropertySymbols, lR = t0 ? t0.isBuffer : n, $9 = se.isFinite, uR = Jd.join, cR = k9(dn.keys, dn), tr = er.max, Cr = er.min, dR = Ge.now, fR = se.parseInt, Z9 = er.random, hR = Jd.reverse, pp = Fs(se, "DataView"), wc = Fs(se, "Map"), mp = Fs(se, "Promise"), Jl = Fs(se, "Set"), Lc = Fs(se, "WeakMap"), Rc = Fs(dn, "create"), l0 = Lc && new Lc(), Kl = {}, pR = Bs(pp), mR = Bs(wc), gR = Bs(mp), vR = Bs(Jl), CR = Bs(Lc), u0 = Bi ? Bi.prototype : n, Ec = u0 ? u0.valueOf : n, j9 = u0 ? u0.toString : n;
      function D(i) {
        if (kn(i) && !Ct(i) && !(i instanceof kt)) {
          if (i instanceof wo)
            return i;
          if (on.call(i, "__wrapped__"))
            return W7(i);
        }
        return new wo(i);
      }
      var Ql = function() {
        function i() {
        }
        return function(u) {
          if (!Ln(u))
            return {};
          if (B9)
            return B9(u);
          i.prototype = u;
          var p = new i();
          return i.prototype = n, p;
        };
      }();
      function c0() {
      }
      function wo(i, u) {
        this.__wrapped__ = i, this.__actions__ = [], this.__chain__ = !!u, this.__index__ = 0, this.__values__ = n;
      }
      D.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: hc,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Tl,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Pl,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: D
        }
      }, D.prototype = c0.prototype, D.prototype.constructor = D, wo.prototype = Ql(c0.prototype), wo.prototype.constructor = wo;
      function kt(i) {
        this.__wrapped__ = i, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = J, this.__views__ = [];
      }
      function bR() {
        var i = new kt(this.__wrapped__);
        return i.__actions__ = jr(this.__actions__), i.__dir__ = this.__dir__, i.__filtered__ = this.__filtered__, i.__iteratees__ = jr(this.__iteratees__), i.__takeCount__ = this.__takeCount__, i.__views__ = jr(this.__views__), i;
      }
      function yR() {
        if (this.__filtered__) {
          var i = new kt(this);
          i.__dir__ = -1, i.__filtered__ = !0;
        } else
          i = this.clone(), i.__dir__ *= -1;
        return i;
      }
      function SR() {
        var i = this.__wrapped__.value(), u = this.__dir__, p = Ct(i), S = u < 0, w = p ? i.length : 0, T = TE(0, w, this.__views__), O = T.start, H = T.end, U = H - O, he = S ? H : O - 1, me = this.__iteratees__, ye = me.length, Ve = 0, We = Cr(U, this.__takeCount__);
        if (!p || !S && w == U && We == U)
          return p7(i, this.__actions__);
        var it = [];
        e:
          for (; U-- && Ve < We; ) {
            he += u;
            for (var It = -1, st = i[he]; ++It < ye; ) {
              var Tt = me[It], Bt = Tt.iteratee, co = Tt.type, Er = Bt(st);
              if (co == _e)
                st = Er;
              else if (!Er) {
                if (co == le)
                  continue e;
                break e;
              }
            }
            it[Ve++] = st;
          }
        return it;
      }
      kt.prototype = Ql(c0.prototype), kt.prototype.constructor = kt;
      function Ps(i) {
        var u = -1, p = i == null ? 0 : i.length;
        for (this.clear(); ++u < p; ) {
          var S = i[u];
          this.set(S[0], S[1]);
        }
      }
      function AR() {
        this.__data__ = Rc ? Rc(null) : {}, this.size = 0;
      }
      function MR(i) {
        var u = this.has(i) && delete this.__data__[i];
        return this.size -= u ? 1 : 0, u;
      }
      function xR(i) {
        var u = this.__data__;
        if (Rc) {
          var p = u[i];
          return p === c ? n : p;
        }
        return on.call(u, i) ? u[i] : n;
      }
      function _R(i) {
        var u = this.__data__;
        return Rc ? u[i] !== n : on.call(u, i);
      }
      function IR(i, u) {
        var p = this.__data__;
        return this.size += this.has(i) ? 0 : 1, p[i] = Rc && u === n ? c : u, this;
      }
      Ps.prototype.clear = AR, Ps.prototype.delete = MR, Ps.prototype.get = xR, Ps.prototype.has = _R, Ps.prototype.set = IR;
      function Wa(i) {
        var u = -1, p = i == null ? 0 : i.length;
        for (this.clear(); ++u < p; ) {
          var S = i[u];
          this.set(S[0], S[1]);
        }
      }
      function wR() {
        this.__data__ = [], this.size = 0;
      }
      function LR(i) {
        var u = this.__data__, p = d0(u, i);
        if (p < 0)
          return !1;
        var S = u.length - 1;
        return p == S ? u.pop() : o0.call(u, p, 1), --this.size, !0;
      }
      function RR(i) {
        var u = this.__data__, p = d0(u, i);
        return p < 0 ? n : u[p][1];
      }
      function ER(i) {
        return d0(this.__data__, i) > -1;
      }
      function DR(i, u) {
        var p = this.__data__, S = d0(p, i);
        return S < 0 ? (++this.size, p.push([i, u])) : p[S][1] = u, this;
      }
      Wa.prototype.clear = wR, Wa.prototype.delete = LR, Wa.prototype.get = RR, Wa.prototype.has = ER, Wa.prototype.set = DR;
      function za(i) {
        var u = -1, p = i == null ? 0 : i.length;
        for (this.clear(); ++u < p; ) {
          var S = i[u];
          this.set(S[0], S[1]);
        }
      }
      function NR() {
        this.size = 0, this.__data__ = {
          hash: new Ps(),
          map: new (wc || Wa)(),
          string: new Ps()
        };
      }
      function TR(i) {
        var u = M0(this, i).delete(i);
        return this.size -= u ? 1 : 0, u;
      }
      function PR(i) {
        return M0(this, i).get(i);
      }
      function kR(i) {
        return M0(this, i).has(i);
      }
      function VR(i, u) {
        var p = M0(this, i), S = p.size;
        return p.set(i, u), this.size += p.size == S ? 0 : 1, this;
      }
      za.prototype.clear = NR, za.prototype.delete = TR, za.prototype.get = PR, za.prototype.has = kR, za.prototype.set = VR;
      function ks(i) {
        var u = -1, p = i == null ? 0 : i.length;
        for (this.__data__ = new za(); ++u < p; )
          this.add(i[u]);
      }
      function OR(i) {
        return this.__data__.set(i, c), this;
      }
      function FR(i) {
        return this.__data__.has(i);
      }
      ks.prototype.add = ks.prototype.push = OR, ks.prototype.has = FR;
      function ea(i) {
        var u = this.__data__ = new Wa(i);
        this.size = u.size;
      }
      function BR() {
        this.__data__ = new Wa(), this.size = 0;
      }
      function HR(i) {
        var u = this.__data__, p = u.delete(i);
        return this.size = u.size, p;
      }
      function GR(i) {
        return this.__data__.get(i);
      }
      function $R(i) {
        return this.__data__.has(i);
      }
      function ZR(i, u) {
        var p = this.__data__;
        if (p instanceof Wa) {
          var S = p.__data__;
          if (!wc || S.length < o - 1)
            return S.push([i, u]), this.size = ++p.size, this;
          p = this.__data__ = new za(S);
        }
        return p.set(i, u), this.size = p.size, this;
      }
      ea.prototype.clear = BR, ea.prototype.delete = HR, ea.prototype.get = GR, ea.prototype.has = $R, ea.prototype.set = ZR;
      function W9(i, u) {
        var p = Ct(i), S = !p && Hs(i), w = !p && !S && ji(i), T = !p && !S && !w && ru(i), O = p || S || w || T, H = O ? up(i.length, QL) : [], U = H.length;
        for (var he in i)
          (u || on.call(i, he)) && !(O && // Safari 9 has enumerable `arguments.length` in strict mode.
          (he == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          w && (he == "offset" || he == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          T && (he == "buffer" || he == "byteLength" || he == "byteOffset") || // Skip index properties.
          qa(he, U))) && H.push(he);
        return H;
      }
      function z9(i) {
        var u = i.length;
        return u ? i[Ip(0, u - 1)] : n;
      }
      function jR(i, u) {
        return x0(jr(i), Vs(u, 0, i.length));
      }
      function WR(i) {
        return x0(jr(i));
      }
      function gp(i, u, p) {
        (p !== n && !ta(i[u], p) || p === n && !(u in i)) && Ua(i, u, p);
      }
      function Dc(i, u, p) {
        var S = i[u];
        (!(on.call(i, u) && ta(S, p)) || p === n && !(u in i)) && Ua(i, u, p);
      }
      function d0(i, u) {
        for (var p = i.length; p--; )
          if (ta(i[p][0], u))
            return p;
        return -1;
      }
      function zR(i, u, p, S) {
        return Hi(i, function(w, T, O) {
          u(S, w, p(w), O);
        }), S;
      }
      function U9(i, u) {
        return i && Ma(u, cr(u), i);
      }
      function UR(i, u) {
        return i && Ma(u, zr(u), i);
      }
      function Ua(i, u, p) {
        u == "__proto__" && a0 ? a0(i, u, {
          configurable: !0,
          enumerable: !0,
          value: p,
          writable: !0
        }) : i[u] = p;
      }
      function vp(i, u) {
        for (var p = -1, S = u.length, w = ee(S), T = i == null; ++p < S; )
          w[p] = T ? n : Jp(i, u[p]);
        return w;
      }
      function Vs(i, u, p) {
        return i === i && (p !== n && (i = i <= p ? i : p), u !== n && (i = i >= u ? i : u)), i;
      }
      function Lo(i, u, p, S, w, T) {
        var O, H = u & h, U = u & m, he = u & g;
        if (p && (O = w ? p(i, S, w, T) : p(i)), O !== n)
          return O;
        if (!Ln(i))
          return i;
        var me = Ct(i);
        if (me) {
          if (O = kE(i), !H)
            return jr(i, O);
        } else {
          var ye = br(i), Ve = ye == oe || ye == pt;
          if (ji(i))
            return v7(i, H);
          if (ye == Ft || ye == fe || Ve && !w) {
            if (O = U || Ve ? {} : V7(i), !H)
              return U ? xE(i, UR(O, i)) : ME(i, U9(O, i));
          } else {
            if (!ln[ye])
              return w ? i : {};
            O = VE(i, ye, H);
          }
        }
        T || (T = new ea());
        var We = T.get(i);
        if (We)
          return We;
        T.set(i, O), d6(i) ? i.forEach(function(st) {
          O.add(Lo(st, u, p, st, i, T));
        }) : u6(i) && i.forEach(function(st, Tt) {
          O.set(Tt, Lo(st, u, p, Tt, i, T));
        });
        var it = he ? U ? Op : Vp : U ? zr : cr, It = me ? n : it(i);
        return _o(It || i, function(st, Tt) {
          It && (Tt = st, st = i[Tt]), Dc(O, Tt, Lo(st, u, p, Tt, i, T));
        }), O;
      }
      function XR(i) {
        var u = cr(i);
        return function(p) {
          return X9(p, i, u);
        };
      }
      function X9(i, u, p) {
        var S = p.length;
        if (i == null)
          return !S;
        for (i = dn(i); S--; ) {
          var w = p[S], T = u[w], O = i[w];
          if (O === n && !(w in i) || !T(O))
            return !1;
        }
        return !0;
      }
      function Y9(i, u, p) {
        if (typeof i != "function")
          throw new Io(s);
        return Fc(function() {
          i.apply(n, p);
        }, u);
      }
      function Nc(i, u, p, S) {
        var w = -1, T = Xd, O = !0, H = i.length, U = [], he = u.length;
        if (!H)
          return U;
        p && (u = xn(u, so(p))), S ? (T = rp, O = !1) : u.length >= o && (T = _c, O = !1, u = new ks(u));
        e:
          for (; ++w < H; ) {
            var me = i[w], ye = p == null ? me : p(me);
            if (me = S || me !== 0 ? me : 0, O && ye === ye) {
              for (var Ve = he; Ve--; )
                if (u[Ve] === ye)
                  continue e;
              U.push(me);
            } else
              T(u, ye, S) || U.push(me);
          }
        return U;
      }
      var Hi = A7(Aa), q9 = A7(bp, !0);
      function YR(i, u) {
        var p = !0;
        return Hi(i, function(S, w, T) {
          return p = !!u(S, w, T), p;
        }), p;
      }
      function f0(i, u, p) {
        for (var S = -1, w = i.length; ++S < w; ) {
          var T = i[S], O = u(T);
          if (O != null && (H === n ? O === O && !uo(O) : p(O, H)))
            var H = O, U = T;
        }
        return U;
      }
      function qR(i, u, p, S) {
        var w = i.length;
        for (p = At(p), p < 0 && (p = -p > w ? 0 : w + p), S = S === n || S > w ? w : At(S), S < 0 && (S += w), S = p > S ? 0 : h6(S); p < S; )
          i[p++] = u;
        return i;
      }
      function J9(i, u) {
        var p = [];
        return Hi(i, function(S, w, T) {
          u(S, w, T) && p.push(S);
        }), p;
      }
      function hr(i, u, p, S, w) {
        var T = -1, O = i.length;
        for (p || (p = FE), w || (w = []); ++T < O; ) {
          var H = i[T];
          u > 0 && p(H) ? u > 1 ? hr(H, u - 1, p, S, w) : Oi(w, H) : S || (w[w.length] = H);
        }
        return w;
      }
      var Cp = M7(), K9 = M7(!0);
      function Aa(i, u) {
        return i && Cp(i, u, cr);
      }
      function bp(i, u) {
        return i && K9(i, u, cr);
      }
      function h0(i, u) {
        return Vi(u, function(p) {
          return Ja(i[p]);
        });
      }
      function Os(i, u) {
        u = $i(u, i);
        for (var p = 0, S = u.length; i != null && p < S; )
          i = i[xa(u[p++])];
        return p && p == S ? i : n;
      }
      function Q9(i, u, p) {
        var S = u(i);
        return Ct(i) ? S : Oi(S, p(i));
      }
      function Lr(i) {
        return i == null ? i === n ? ro : an : Ts && Ts in dn(i) ? NE(i) : WE(i);
      }
      function yp(i, u) {
        return i > u;
      }
      function JR(i, u) {
        return i != null && on.call(i, u);
      }
      function KR(i, u) {
        return i != null && u in dn(i);
      }
      function QR(i, u, p) {
        return i >= Cr(u, p) && i < tr(u, p);
      }
      function Sp(i, u, p) {
        for (var S = p ? rp : Xd, w = i[0].length, T = i.length, O = T, H = ee(T), U = 1 / 0, he = []; O--; ) {
          var me = i[O];
          O && u && (me = xn(me, so(u))), U = Cr(me.length, U), H[O] = !p && (u || w >= 120 && me.length >= 120) ? new ks(O && me) : n;
        }
        me = i[0];
        var ye = -1, Ve = H[0];
        e:
          for (; ++ye < w && he.length < U; ) {
            var We = me[ye], it = u ? u(We) : We;
            if (We = p || We !== 0 ? We : 0, !(Ve ? _c(Ve, it) : S(he, it, p))) {
              for (O = T; --O; ) {
                var It = H[O];
                if (!(It ? _c(It, it) : S(i[O], it, p)))
                  continue e;
              }
              Ve && Ve.push(it), he.push(We);
            }
          }
        return he;
      }
      function eE(i, u, p, S) {
        return Aa(i, function(w, T, O) {
          u(S, p(w), T, O);
        }), S;
      }
      function Tc(i, u, p) {
        u = $i(u, i), i = H7(i, u);
        var S = i == null ? i : i[xa(Eo(u))];
        return S == null ? n : io(S, i, p);
      }
      function e7(i) {
        return kn(i) && Lr(i) == fe;
      }
      function tE(i) {
        return kn(i) && Lr(i) == lr;
      }
      function nE(i) {
        return kn(i) && Lr(i) == Pe;
      }
      function Pc(i, u, p, S, w) {
        return i === u ? !0 : i == null || u == null || !kn(i) && !kn(u) ? i !== i && u !== u : rE(i, u, p, S, Pc, w);
      }
      function rE(i, u, p, S, w, T) {
        var O = Ct(i), H = Ct(u), U = O ? de : br(i), he = H ? de : br(u);
        U = U == fe ? Ft : U, he = he == fe ? Ft : he;
        var me = U == Ft, ye = he == Ft, Ve = U == he;
        if (Ve && ji(i)) {
          if (!ji(u))
            return !1;
          O = !0, me = !1;
        }
        if (Ve && !me)
          return T || (T = new ea()), O || ru(i) ? T7(i, u, p, S, w, T) : EE(i, u, U, p, S, w, T);
        if (!(p & b)) {
          var We = me && on.call(i, "__wrapped__"), it = ye && on.call(u, "__wrapped__");
          if (We || it) {
            var It = We ? i.value() : i, st = it ? u.value() : u;
            return T || (T = new ea()), w(It, st, p, S, T);
          }
        }
        return Ve ? (T || (T = new ea()), DE(i, u, p, S, w, T)) : !1;
      }
      function oE(i) {
        return kn(i) && br(i) == Ee;
      }
      function Ap(i, u, p, S) {
        var w = p.length, T = w, O = !S;
        if (i == null)
          return !T;
        for (i = dn(i); w--; ) {
          var H = p[w];
          if (O && H[2] ? H[1] !== i[H[0]] : !(H[0] in i))
            return !1;
        }
        for (; ++w < T; ) {
          H = p[w];
          var U = H[0], he = i[U], me = H[1];
          if (O && H[2]) {
            if (he === n && !(U in i))
              return !1;
          } else {
            var ye = new ea();
            if (S)
              var Ve = S(he, me, U, i, u, ye);
            if (!(Ve === n ? Pc(me, he, b | C, S, ye) : Ve))
              return !1;
          }
        }
        return !0;
      }
      function t7(i) {
        if (!Ln(i) || HE(i))
          return !1;
        var u = Ja(i) ? oR : _t;
        return u.test(Bs(i));
      }
      function aE(i) {
        return kn(i) && Lr(i) == Xt;
      }
      function iE(i) {
        return kn(i) && br(i) == sn;
      }
      function sE(i) {
        return kn(i) && E0(i.length) && !!cn[Lr(i)];
      }
      function n7(i) {
        return typeof i == "function" ? i : i == null ? Ur : typeof i == "object" ? Ct(i) ? a7(i[0], i[1]) : o7(i) : x6(i);
      }
      function Mp(i) {
        if (!Oc(i))
          return cR(i);
        var u = [];
        for (var p in dn(i))
          on.call(i, p) && p != "constructor" && u.push(p);
        return u;
      }
      function lE(i) {
        if (!Ln(i))
          return jE(i);
        var u = Oc(i), p = [];
        for (var S in i)
          S == "constructor" && (u || !on.call(i, S)) || p.push(S);
        return p;
      }
      function xp(i, u) {
        return i < u;
      }
      function r7(i, u) {
        var p = -1, S = Wr(i) ? ee(i.length) : [];
        return Hi(i, function(w, T, O) {
          S[++p] = u(w, T, O);
        }), S;
      }
      function o7(i) {
        var u = Bp(i);
        return u.length == 1 && u[0][2] ? F7(u[0][0], u[0][1]) : function(p) {
          return p === i || Ap(p, i, u);
        };
      }
      function a7(i, u) {
        return Gp(i) && O7(u) ? F7(xa(i), u) : function(p) {
          var S = Jp(p, i);
          return S === n && S === u ? Kp(p, i) : Pc(u, S, b | C);
        };
      }
      function p0(i, u, p, S, w) {
        i !== u && Cp(u, function(T, O) {
          if (w || (w = new ea()), Ln(T))
            uE(i, u, O, p, p0, S, w);
          else {
            var H = S ? S(Zp(i, O), T, O + "", i, u, w) : n;
            H === n && (H = T), gp(i, O, H);
          }
        }, zr);
      }
      function uE(i, u, p, S, w, T, O) {
        var H = Zp(i, p), U = Zp(u, p), he = O.get(U);
        if (he) {
          gp(i, p, he);
          return;
        }
        var me = T ? T(H, U, p + "", i, u, O) : n, ye = me === n;
        if (ye) {
          var Ve = Ct(U), We = !Ve && ji(U), it = !Ve && !We && ru(U);
          me = U, Ve || We || it ? Ct(H) ? me = H : Gn(H) ? me = jr(H) : We ? (ye = !1, me = v7(U, !0)) : it ? (ye = !1, me = C7(U, !0)) : me = [] : Bc(U) || Hs(U) ? (me = H, Hs(H) ? me = p6(H) : (!Ln(H) || Ja(H)) && (me = V7(U))) : ye = !1;
        }
        ye && (O.set(U, me), w(me, U, S, T, O), O.delete(U)), gp(i, p, me);
      }
      function i7(i, u) {
        var p = i.length;
        if (p)
          return u += u < 0 ? p : 0, qa(u, p) ? i[u] : n;
      }
      function s7(i, u, p) {
        u.length ? u = xn(u, function(T) {
          return Ct(T) ? function(O) {
            return Os(O, T.length === 1 ? T[0] : T);
          } : T;
        }) : u = [Ur];
        var S = -1;
        u = xn(u, so(rt()));
        var w = r7(i, function(T, O, H) {
          var U = xn(u, function(he) {
            return he(T);
          });
          return { criteria: U, index: ++S, value: T };
        });
        return VL(w, function(T, O) {
          return AE(T, O, p);
        });
      }
      function cE(i, u) {
        return l7(i, u, function(p, S) {
          return Kp(i, S);
        });
      }
      function l7(i, u, p) {
        for (var S = -1, w = u.length, T = {}; ++S < w; ) {
          var O = u[S], H = Os(i, O);
          p(H, O) && kc(T, $i(O, i), H);
        }
        return T;
      }
      function dE(i) {
        return function(u) {
          return Os(u, i);
        };
      }
      function _p(i, u, p, S) {
        var w = S ? kL : zl, T = -1, O = u.length, H = i;
        for (i === u && (u = jr(u)), p && (H = xn(i, so(p))); ++T < O; )
          for (var U = 0, he = u[T], me = p ? p(he) : he; (U = w(H, me, U, S)) > -1; )
            H !== i && o0.call(H, U, 1), o0.call(i, U, 1);
        return i;
      }
      function u7(i, u) {
        for (var p = i ? u.length : 0, S = p - 1; p--; ) {
          var w = u[p];
          if (p == S || w !== T) {
            var T = w;
            qa(w) ? o0.call(i, w, 1) : Rp(i, w);
          }
        }
        return i;
      }
      function Ip(i, u) {
        return i + s0(Z9() * (u - i + 1));
      }
      function fE(i, u, p, S) {
        for (var w = -1, T = tr(i0((u - i) / (p || 1)), 0), O = ee(T); T--; )
          O[S ? T : ++w] = i, i += p;
        return O;
      }
      function wp(i, u) {
        var p = "";
        if (!i || u < 1 || u > K)
          return p;
        do
          u % 2 && (p += i), u = s0(u / 2), u && (i += i);
        while (u);
        return p;
      }
      function Rt(i, u) {
        return jp(B7(i, u, Ur), i + "");
      }
      function hE(i) {
        return z9(ou(i));
      }
      function pE(i, u) {
        var p = ou(i);
        return x0(p, Vs(u, 0, p.length));
      }
      function kc(i, u, p, S) {
        if (!Ln(i))
          return i;
        u = $i(u, i);
        for (var w = -1, T = u.length, O = T - 1, H = i; H != null && ++w < T; ) {
          var U = xa(u[w]), he = p;
          if (U === "__proto__" || U === "constructor" || U === "prototype")
            return i;
          if (w != O) {
            var me = H[U];
            he = S ? S(me, U, H) : n, he === n && (he = Ln(me) ? me : qa(u[w + 1]) ? [] : {});
          }
          Dc(H, U, he), H = H[U];
        }
        return i;
      }
      var c7 = l0 ? function(i, u) {
        return l0.set(i, u), i;
      } : Ur, mE = a0 ? function(i, u) {
        return a0(i, "toString", {
          configurable: !0,
          enumerable: !1,
          value: em(u),
          writable: !0
        });
      } : Ur;
      function gE(i) {
        return x0(ou(i));
      }
      function Ro(i, u, p) {
        var S = -1, w = i.length;
        u < 0 && (u = -u > w ? 0 : w + u), p = p > w ? w : p, p < 0 && (p += w), w = u > p ? 0 : p - u >>> 0, u >>>= 0;
        for (var T = ee(w); ++S < w; )
          T[S] = i[S + u];
        return T;
      }
      function vE(i, u) {
        var p;
        return Hi(i, function(S, w, T) {
          return p = u(S, w, T), !p;
        }), !!p;
      }
      function m0(i, u, p) {
        var S = 0, w = i == null ? S : i.length;
        if (typeof u == "number" && u === u && w <= X) {
          for (; S < w; ) {
            var T = S + w >>> 1, O = i[T];
            O !== null && !uo(O) && (p ? O <= u : O < u) ? S = T + 1 : w = T;
          }
          return w;
        }
        return Lp(i, u, Ur, p);
      }
      function Lp(i, u, p, S) {
        var w = 0, T = i == null ? 0 : i.length;
        if (T === 0)
          return 0;
        u = p(u);
        for (var O = u !== u, H = u === null, U = uo(u), he = u === n; w < T; ) {
          var me = s0((w + T) / 2), ye = p(i[me]), Ve = ye !== n, We = ye === null, it = ye === ye, It = uo(ye);
          if (O)
            var st = S || it;
          else
            he ? st = it && (S || Ve) : H ? st = it && Ve && (S || !We) : U ? st = it && Ve && !We && (S || !It) : We || It ? st = !1 : st = S ? ye <= u : ye < u;
          st ? w = me + 1 : T = me;
        }
        return Cr(T, ge);
      }
      function d7(i, u) {
        for (var p = -1, S = i.length, w = 0, T = []; ++p < S; ) {
          var O = i[p], H = u ? u(O) : O;
          if (!p || !ta(H, U)) {
            var U = H;
            T[w++] = O === 0 ? 0 : O;
          }
        }
        return T;
      }
      function f7(i) {
        return typeof i == "number" ? i : uo(i) ? q : +i;
      }
      function lo(i) {
        if (typeof i == "string")
          return i;
        if (Ct(i))
          return xn(i, lo) + "";
        if (uo(i))
          return j9 ? j9.call(i) : "";
        var u = i + "";
        return u == "0" && 1 / i == -z ? "-0" : u;
      }
      function Gi(i, u, p) {
        var S = -1, w = Xd, T = i.length, O = !0, H = [], U = H;
        if (p)
          O = !1, w = rp;
        else if (T >= o) {
          var he = u ? null : LE(i);
          if (he)
            return qd(he);
          O = !1, w = _c, U = new ks();
        } else
          U = u ? [] : H;
        e:
          for (; ++S < T; ) {
            var me = i[S], ye = u ? u(me) : me;
            if (me = p || me !== 0 ? me : 0, O && ye === ye) {
              for (var Ve = U.length; Ve--; )
                if (U[Ve] === ye)
                  continue e;
              u && U.push(ye), H.push(me);
            } else
              w(U, ye, p) || (U !== H && U.push(ye), H.push(me));
          }
        return H;
      }
      function Rp(i, u) {
        return u = $i(u, i), i = H7(i, u), i == null || delete i[xa(Eo(u))];
      }
      function h7(i, u, p, S) {
        return kc(i, u, p(Os(i, u)), S);
      }
      function g0(i, u, p, S) {
        for (var w = i.length, T = S ? w : -1; (S ? T-- : ++T < w) && u(i[T], T, i); )
          ;
        return p ? Ro(i, S ? 0 : T, S ? T + 1 : w) : Ro(i, S ? T + 1 : 0, S ? w : T);
      }
      function p7(i, u) {
        var p = i;
        return p instanceof kt && (p = p.value()), op(u, function(S, w) {
          return w.func.apply(w.thisArg, Oi([S], w.args));
        }, p);
      }
      function Ep(i, u, p) {
        var S = i.length;
        if (S < 2)
          return S ? Gi(i[0]) : [];
        for (var w = -1, T = ee(S); ++w < S; )
          for (var O = i[w], H = -1; ++H < S; )
            H != w && (T[w] = Nc(T[w] || O, i[H], u, p));
        return Gi(hr(T, 1), u, p);
      }
      function m7(i, u, p) {
        for (var S = -1, w = i.length, T = u.length, O = {}; ++S < w; ) {
          var H = S < T ? u[S] : n;
          p(O, i[S], H);
        }
        return O;
      }
      function Dp(i) {
        return Gn(i) ? i : [];
      }
      function Np(i) {
        return typeof i == "function" ? i : Ur;
      }
      function $i(i, u) {
        return Ct(i) ? i : Gp(i, u) ? [i] : j7(en(i));
      }
      var CE = Rt;
      function Zi(i, u, p) {
        var S = i.length;
        return p = p === n ? S : p, !u && p >= S ? i : Ro(i, u, p);
      }
      var g7 = aR || function(i) {
        return bt.clearTimeout(i);
      };
      function v7(i, u) {
        if (u)
          return i.slice();
        var p = i.length, S = F9 ? F9(p) : new i.constructor(p);
        return i.copy(S), S;
      }
      function Tp(i) {
        var u = new i.constructor(i.byteLength);
        return new n0(u).set(new n0(i)), u;
      }
      function bE(i, u) {
        var p = u ? Tp(i.buffer) : i.buffer;
        return new i.constructor(p, i.byteOffset, i.byteLength);
      }
      function yE(i) {
        var u = new i.constructor(i.source, St.exec(i));
        return u.lastIndex = i.lastIndex, u;
      }
      function SE(i) {
        return Ec ? dn(Ec.call(i)) : {};
      }
      function C7(i, u) {
        var p = u ? Tp(i.buffer) : i.buffer;
        return new i.constructor(p, i.byteOffset, i.length);
      }
      function b7(i, u) {
        if (i !== u) {
          var p = i !== n, S = i === null, w = i === i, T = uo(i), O = u !== n, H = u === null, U = u === u, he = uo(u);
          if (!H && !he && !T && i > u || T && O && U && !H && !he || S && O && U || !p && U || !w)
            return 1;
          if (!S && !T && !he && i < u || he && p && w && !S && !T || H && p && w || !O && w || !U)
            return -1;
        }
        return 0;
      }
      function AE(i, u, p) {
        for (var S = -1, w = i.criteria, T = u.criteria, O = w.length, H = p.length; ++S < O; ) {
          var U = b7(w[S], T[S]);
          if (U) {
            if (S >= H)
              return U;
            var he = p[S];
            return U * (he == "desc" ? -1 : 1);
          }
        }
        return i.index - u.index;
      }
      function y7(i, u, p, S) {
        for (var w = -1, T = i.length, O = p.length, H = -1, U = u.length, he = tr(T - O, 0), me = ee(U + he), ye = !S; ++H < U; )
          me[H] = u[H];
        for (; ++w < O; )
          (ye || w < T) && (me[p[w]] = i[w]);
        for (; he--; )
          me[H++] = i[w++];
        return me;
      }
      function S7(i, u, p, S) {
        for (var w = -1, T = i.length, O = -1, H = p.length, U = -1, he = u.length, me = tr(T - H, 0), ye = ee(me + he), Ve = !S; ++w < me; )
          ye[w] = i[w];
        for (var We = w; ++U < he; )
          ye[We + U] = u[U];
        for (; ++O < H; )
          (Ve || w < T) && (ye[We + p[O]] = i[w++]);
        return ye;
      }
      function jr(i, u) {
        var p = -1, S = i.length;
        for (u || (u = ee(S)); ++p < S; )
          u[p] = i[p];
        return u;
      }
      function Ma(i, u, p, S) {
        var w = !p;
        p || (p = {});
        for (var T = -1, O = u.length; ++T < O; ) {
          var H = u[T], U = S ? S(p[H], i[H], H, p, i) : n;
          U === n && (U = i[H]), w ? Ua(p, H, U) : Dc(p, H, U);
        }
        return p;
      }
      function ME(i, u) {
        return Ma(i, Hp(i), u);
      }
      function xE(i, u) {
        return Ma(i, P7(i), u);
      }
      function v0(i, u) {
        return function(p, S) {
          var w = Ct(p) ? RL : zR, T = u ? u() : {};
          return w(p, i, rt(S, 2), T);
        };
      }
      function eu(i) {
        return Rt(function(u, p) {
          var S = -1, w = p.length, T = w > 1 ? p[w - 1] : n, O = w > 2 ? p[2] : n;
          for (T = i.length > 3 && typeof T == "function" ? (w--, T) : n, O && Rr(p[0], p[1], O) && (T = w < 3 ? n : T, w = 1), u = dn(u); ++S < w; ) {
            var H = p[S];
            H && i(u, H, S, T);
          }
          return u;
        });
      }
      function A7(i, u) {
        return function(p, S) {
          if (p == null)
            return p;
          if (!Wr(p))
            return i(p, S);
          for (var w = p.length, T = u ? w : -1, O = dn(p); (u ? T-- : ++T < w) && S(O[T], T, O) !== !1; )
            ;
          return p;
        };
      }
      function M7(i) {
        return function(u, p, S) {
          for (var w = -1, T = dn(u), O = S(u), H = O.length; H--; ) {
            var U = O[i ? H : ++w];
            if (p(T[U], U, T) === !1)
              break;
          }
          return u;
        };
      }
      function _E(i, u, p) {
        var S = u & y, w = Vc(i);
        function T() {
          var O = this && this !== bt && this instanceof T ? w : i;
          return O.apply(S ? p : this, arguments);
        }
        return T;
      }
      function x7(i) {
        return function(u) {
          u = en(u);
          var p = Ul(u) ? Qo(u) : n, S = p ? p[0] : u.charAt(0), w = p ? Zi(p, 1).join("") : u.slice(1);
          return S[i]() + w;
        };
      }
      function tu(i) {
        return function(u) {
          return op(A6(S6(u).replace(Mc, "")), i, "");
        };
      }
      function Vc(i) {
        return function() {
          var u = arguments;
          switch (u.length) {
            case 0:
              return new i();
            case 1:
              return new i(u[0]);
            case 2:
              return new i(u[0], u[1]);
            case 3:
              return new i(u[0], u[1], u[2]);
            case 4:
              return new i(u[0], u[1], u[2], u[3]);
            case 5:
              return new i(u[0], u[1], u[2], u[3], u[4]);
            case 6:
              return new i(u[0], u[1], u[2], u[3], u[4], u[5]);
            case 7:
              return new i(u[0], u[1], u[2], u[3], u[4], u[5], u[6]);
          }
          var p = Ql(i.prototype), S = i.apply(p, u);
          return Ln(S) ? S : p;
        };
      }
      function IE(i, u, p) {
        var S = Vc(i);
        function w() {
          for (var T = arguments.length, O = ee(T), H = T, U = nu(w); H--; )
            O[H] = arguments[H];
          var he = T < 3 && O[0] !== U && O[T - 1] !== U ? [] : Fi(O, U);
          if (T -= he.length, T < p)
            return R7(
              i,
              u,
              C0,
              w.placeholder,
              n,
              O,
              he,
              n,
              n,
              p - T
            );
          var me = this && this !== bt && this instanceof w ? S : i;
          return io(me, this, O);
        }
        return w;
      }
      function _7(i) {
        return function(u, p, S) {
          var w = dn(u);
          if (!Wr(u)) {
            var T = rt(p, 3);
            u = cr(u), p = function(H) {
              return T(w[H], H, w);
            };
          }
          var O = i(u, p, S);
          return O > -1 ? w[T ? u[O] : O] : n;
        };
      }
      function I7(i) {
        return Ya(function(u) {
          var p = u.length, S = p, w = wo.prototype.thru;
          for (i && u.reverse(); S--; ) {
            var T = u[S];
            if (typeof T != "function")
              throw new Io(s);
            if (w && !O && A0(T) == "wrapper")
              var O = new wo([], !0);
          }
          for (S = O ? S : p; ++S < p; ) {
            T = u[S];
            var H = A0(T), U = H == "wrapper" ? Fp(T) : n;
            U && $p(U[0]) && U[1] == (N | I | E | P) && !U[4].length && U[9] == 1 ? O = O[A0(U[0])].apply(O, U[3]) : O = T.length == 1 && $p(T) ? O[H]() : O.thru(T);
          }
          return function() {
            var he = arguments, me = he[0];
            if (O && he.length == 1 && Ct(me))
              return O.plant(me).value();
            for (var ye = 0, Ve = p ? u[ye].apply(this, he) : me; ++ye < p; )
              Ve = u[ye].call(this, Ve);
            return Ve;
          };
        });
      }
      function C0(i, u, p, S, w, T, O, H, U, he) {
        var me = u & N, ye = u & y, Ve = u & _, We = u & (I | R), it = u & F, It = Ve ? n : Vc(i);
        function st() {
          for (var Tt = arguments.length, Bt = ee(Tt), co = Tt; co--; )
            Bt[co] = arguments[co];
          if (We)
            var Er = nu(st), fo = FL(Bt, Er);
          if (S && (Bt = y7(Bt, S, w, We)), T && (Bt = S7(Bt, T, O, We)), Tt -= fo, We && Tt < he) {
            var $n = Fi(Bt, Er);
            return R7(
              i,
              u,
              C0,
              st.placeholder,
              p,
              Bt,
              $n,
              H,
              U,
              he - Tt
            );
          }
          var na = ye ? p : this, Qa = Ve ? na[i] : i;
          return Tt = Bt.length, H ? Bt = zE(Bt, H) : it && Tt > 1 && Bt.reverse(), me && U < Tt && (Bt.length = U), this && this !== bt && this instanceof st && (Qa = It || Vc(Qa)), Qa.apply(na, Bt);
        }
        return st;
      }
      function w7(i, u) {
        return function(p, S) {
          return eE(p, i, u(S), {});
        };
      }
      function b0(i, u) {
        return function(p, S) {
          var w;
          if (p === n && S === n)
            return u;
          if (p !== n && (w = p), S !== n) {
            if (w === n)
              return S;
            typeof p == "string" || typeof S == "string" ? (p = lo(p), S = lo(S)) : (p = f7(p), S = f7(S)), w = i(p, S);
          }
          return w;
        };
      }
      function Pp(i) {
        return Ya(function(u) {
          return u = xn(u, so(rt())), Rt(function(p) {
            var S = this;
            return i(u, function(w) {
              return io(w, S, p);
            });
          });
        });
      }
      function y0(i, u) {
        u = u === n ? " " : lo(u);
        var p = u.length;
        if (p < 2)
          return p ? wp(u, i) : u;
        var S = wp(u, i0(i / Xl(u)));
        return Ul(u) ? Zi(Qo(S), 0, i).join("") : S.slice(0, i);
      }
      function wE(i, u, p, S) {
        var w = u & y, T = Vc(i);
        function O() {
          for (var H = -1, U = arguments.length, he = -1, me = S.length, ye = ee(me + U), Ve = this && this !== bt && this instanceof O ? T : i; ++he < me; )
            ye[he] = S[he];
          for (; U--; )
            ye[he++] = arguments[++H];
          return io(Ve, w ? p : this, ye);
        }
        return O;
      }
      function L7(i) {
        return function(u, p, S) {
          return S && typeof S != "number" && Rr(u, p, S) && (p = S = n), u = Ka(u), p === n ? (p = u, u = 0) : p = Ka(p), S = S === n ? u < p ? 1 : -1 : Ka(S), fE(u, p, S, i);
        };
      }
      function S0(i) {
        return function(u, p) {
          return typeof u == "string" && typeof p == "string" || (u = Do(u), p = Do(p)), i(u, p);
        };
      }
      function R7(i, u, p, S, w, T, O, H, U, he) {
        var me = u & I, ye = me ? O : n, Ve = me ? n : O, We = me ? T : n, it = me ? n : T;
        u |= me ? E : k, u &= ~(me ? k : E), u & x || (u &= ~(y | _));
        var It = [
          i,
          u,
          w,
          We,
          ye,
          it,
          Ve,
          H,
          U,
          he
        ], st = p.apply(n, It);
        return $p(i) && G7(st, It), st.placeholder = S, $7(st, i, u);
      }
      function kp(i) {
        var u = er[i];
        return function(p, S) {
          if (p = Do(p), S = S == null ? 0 : Cr(At(S), 292), S && $9(p)) {
            var w = (en(p) + "e").split("e"), T = u(w[0] + "e" + (+w[1] + S));
            return w = (en(T) + "e").split("e"), +(w[0] + "e" + (+w[1] - S));
          }
          return u(p);
        };
      }
      var LE = Jl && 1 / qd(new Jl([, -0]))[1] == z ? function(i) {
        return new Jl(i);
      } : rm;
      function E7(i) {
        return function(u) {
          var p = br(u);
          return p == Ee ? dp(u) : p == sn ? WL(u) : OL(u, i(u));
        };
      }
      function Xa(i, u, p, S, w, T, O, H) {
        var U = u & _;
        if (!U && typeof i != "function")
          throw new Io(s);
        var he = S ? S.length : 0;
        if (he || (u &= ~(E | k), S = w = n), O = O === n ? O : tr(At(O), 0), H = H === n ? H : At(H), he -= w ? w.length : 0, u & k) {
          var me = S, ye = w;
          S = w = n;
        }
        var Ve = U ? n : Fp(i), We = [
          i,
          u,
          p,
          S,
          w,
          me,
          ye,
          T,
          O,
          H
        ];
        if (Ve && ZE(We, Ve), i = We[0], u = We[1], p = We[2], S = We[3], w = We[4], H = We[9] = We[9] === n ? U ? 0 : i.length : tr(We[9] - he, 0), !H && u & (I | R) && (u &= ~(I | R)), !u || u == y)
          var it = _E(i, u, p);
        else
          u == I || u == R ? it = IE(i, u, H) : (u == E || u == (y | E)) && !w.length ? it = wE(i, u, p, S) : it = C0.apply(n, We);
        var It = Ve ? c7 : G7;
        return $7(It(it, We), i, u);
      }
      function D7(i, u, p, S) {
        return i === n || ta(i, ql[p]) && !on.call(S, p) ? u : i;
      }
      function N7(i, u, p, S, w, T) {
        return Ln(i) && Ln(u) && (T.set(u, i), p0(i, u, n, N7, T), T.delete(u)), i;
      }
      function RE(i) {
        return Bc(i) ? n : i;
      }
      function T7(i, u, p, S, w, T) {
        var O = p & b, H = i.length, U = u.length;
        if (H != U && !(O && U > H))
          return !1;
        var he = T.get(i), me = T.get(u);
        if (he && me)
          return he == u && me == i;
        var ye = -1, Ve = !0, We = p & C ? new ks() : n;
        for (T.set(i, u), T.set(u, i); ++ye < H; ) {
          var it = i[ye], It = u[ye];
          if (S)
            var st = O ? S(It, it, ye, u, i, T) : S(it, It, ye, i, u, T);
          if (st !== n) {
            if (st)
              continue;
            Ve = !1;
            break;
          }
          if (We) {
            if (!ap(u, function(Tt, Bt) {
              if (!_c(We, Bt) && (it === Tt || w(it, Tt, p, S, T)))
                return We.push(Bt);
            })) {
              Ve = !1;
              break;
            }
          } else if (!(it === It || w(it, It, p, S, T))) {
            Ve = !1;
            break;
          }
        }
        return T.delete(i), T.delete(u), Ve;
      }
      function EE(i, u, p, S, w, T, O) {
        switch (p) {
          case Le:
            if (i.byteLength != u.byteLength || i.byteOffset != u.byteOffset)
              return !1;
            i = i.buffer, u = u.buffer;
          case lr:
            return !(i.byteLength != u.byteLength || !T(new n0(i), new n0(u)));
          case Ie:
          case Pe:
          case wt:
            return ta(+i, +u);
          case Fe:
            return i.name == u.name && i.message == u.message;
          case Xt:
          case Tn:
            return i == u + "";
          case Ee:
            var H = dp;
          case sn:
            var U = S & b;
            if (H || (H = qd), i.size != u.size && !U)
              return !1;
            var he = O.get(i);
            if (he)
              return he == u;
            S |= C, O.set(i, u);
            var me = T7(H(i), H(u), S, w, T, O);
            return O.delete(i), me;
          case Pn:
            if (Ec)
              return Ec.call(i) == Ec.call(u);
        }
        return !1;
      }
      function DE(i, u, p, S, w, T) {
        var O = p & b, H = Vp(i), U = H.length, he = Vp(u), me = he.length;
        if (U != me && !O)
          return !1;
        for (var ye = U; ye--; ) {
          var Ve = H[ye];
          if (!(O ? Ve in u : on.call(u, Ve)))
            return !1;
        }
        var We = T.get(i), it = T.get(u);
        if (We && it)
          return We == u && it == i;
        var It = !0;
        T.set(i, u), T.set(u, i);
        for (var st = O; ++ye < U; ) {
          Ve = H[ye];
          var Tt = i[Ve], Bt = u[Ve];
          if (S)
            var co = O ? S(Bt, Tt, Ve, u, i, T) : S(Tt, Bt, Ve, i, u, T);
          if (!(co === n ? Tt === Bt || w(Tt, Bt, p, S, T) : co)) {
            It = !1;
            break;
          }
          st || (st = Ve == "constructor");
        }
        if (It && !st) {
          var Er = i.constructor, fo = u.constructor;
          Er != fo && "constructor" in i && "constructor" in u && !(typeof Er == "function" && Er instanceof Er && typeof fo == "function" && fo instanceof fo) && (It = !1);
        }
        return T.delete(i), T.delete(u), It;
      }
      function Ya(i) {
        return jp(B7(i, n, X7), i + "");
      }
      function Vp(i) {
        return Q9(i, cr, Hp);
      }
      function Op(i) {
        return Q9(i, zr, P7);
      }
      var Fp = l0 ? function(i) {
        return l0.get(i);
      } : rm;
      function A0(i) {
        for (var u = i.name + "", p = Kl[u], S = on.call(Kl, u) ? p.length : 0; S--; ) {
          var w = p[S], T = w.func;
          if (T == null || T == i)
            return w.name;
        }
        return u;
      }
      function nu(i) {
        var u = on.call(D, "placeholder") ? D : i;
        return u.placeholder;
      }
      function rt() {
        var i = D.iteratee || tm;
        return i = i === tm ? n7 : i, arguments.length ? i(arguments[0], arguments[1]) : i;
      }
      function M0(i, u) {
        var p = i.__data__;
        return BE(u) ? p[typeof u == "string" ? "string" : "hash"] : p.map;
      }
      function Bp(i) {
        for (var u = cr(i), p = u.length; p--; ) {
          var S = u[p], w = i[S];
          u[p] = [S, w, O7(w)];
        }
        return u;
      }
      function Fs(i, u) {
        var p = $L(i, u);
        return t7(p) ? p : n;
      }
      function NE(i) {
        var u = on.call(i, Ts), p = i[Ts];
        try {
          i[Ts] = n;
          var S = !0;
        } catch {
        }
        var w = e0.call(i);
        return S && (u ? i[Ts] = p : delete i[Ts]), w;
      }
      var Hp = hp ? function(i) {
        return i == null ? [] : (i = dn(i), Vi(hp(i), function(u) {
          return H9.call(i, u);
        }));
      } : om, P7 = hp ? function(i) {
        for (var u = []; i; )
          Oi(u, Hp(i)), i = r0(i);
        return u;
      } : om, br = Lr;
      (pp && br(new pp(new ArrayBuffer(1))) != Le || wc && br(new wc()) != Ee || mp && br(mp.resolve()) != Kn || Jl && br(new Jl()) != sn || Lc && br(new Lc()) != vr) && (br = function(i) {
        var u = Lr(i), p = u == Ft ? i.constructor : n, S = p ? Bs(p) : "";
        if (S)
          switch (S) {
            case pR:
              return Le;
            case mR:
              return Ee;
            case gR:
              return Kn;
            case vR:
              return sn;
            case CR:
              return vr;
          }
        return u;
      });
      function TE(i, u, p) {
        for (var S = -1, w = p.length; ++S < w; ) {
          var T = p[S], O = T.size;
          switch (T.type) {
            case "drop":
              i += O;
              break;
            case "dropRight":
              u -= O;
              break;
            case "take":
              u = Cr(u, i + O);
              break;
            case "takeRight":
              i = tr(i, u - O);
              break;
          }
        }
        return { start: i, end: u };
      }
      function PE(i) {
        var u = i.match(ya);
        return u ? u[1].split(gc) : [];
      }
      function k7(i, u, p) {
        u = $i(u, i);
        for (var S = -1, w = u.length, T = !1; ++S < w; ) {
          var O = xa(u[S]);
          if (!(T = i != null && p(i, O)))
            break;
          i = i[O];
        }
        return T || ++S != w ? T : (w = i == null ? 0 : i.length, !!w && E0(w) && qa(O, w) && (Ct(i) || Hs(i)));
      }
      function kE(i) {
        var u = i.length, p = new i.constructor(u);
        return u && typeof i[0] == "string" && on.call(i, "index") && (p.index = i.index, p.input = i.input), p;
      }
      function V7(i) {
        return typeof i.constructor == "function" && !Oc(i) ? Ql(r0(i)) : {};
      }
      function VE(i, u, p) {
        var S = i.constructor;
        switch (u) {
          case lr:
            return Tp(i);
          case Ie:
          case Pe:
            return new S(+i);
          case Le:
            return bE(i, p);
          case Zt:
          case wn:
          case Un:
          case Zr:
          case Jo:
          case Is:
          case ws:
          case oo:
          case ba:
            return C7(i, p);
          case Ee:
            return new S();
          case wt:
          case Tn:
            return new S(i);
          case Xt:
            return yE(i);
          case sn:
            return new S();
          case Pn:
            return SE(i);
        }
      }
      function OE(i, u) {
        var p = u.length;
        if (!p)
          return i;
        var S = p - 1;
        return u[S] = (p > 1 ? "& " : "") + u[S], u = u.join(p > 2 ? ", " : " "), i.replace(mc, `{
/* [wrapped with ` + u + `] */
`);
      }
      function FE(i) {
        return Ct(i) || Hs(i) || !!(G9 && i && i[G9]);
      }
      function qa(i, u) {
        var p = typeof i;
        return u = u ?? K, !!u && (p == "number" || p != "symbol" && yn.test(i)) && i > -1 && i % 1 == 0 && i < u;
      }
      function Rr(i, u, p) {
        if (!Ln(p))
          return !1;
        var S = typeof u;
        return (S == "number" ? Wr(p) && qa(u, p.length) : S == "string" && u in p) ? ta(p[u], i) : !1;
      }
      function Gp(i, u) {
        if (Ct(i))
          return !1;
        var p = typeof i;
        return p == "number" || p == "symbol" || p == "boolean" || i == null || uo(i) ? !0 : Vl.test(i) || !kl.test(i) || u != null && i in dn(u);
      }
      function BE(i) {
        var u = typeof i;
        return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? i !== "__proto__" : i === null;
      }
      function $p(i) {
        var u = A0(i), p = D[u];
        if (typeof p != "function" || !(u in kt.prototype))
          return !1;
        if (i === p)
          return !0;
        var S = Fp(p);
        return !!S && i === S[0];
      }
      function HE(i) {
        return !!O9 && O9 in i;
      }
      var GE = Kd ? Ja : am;
      function Oc(i) {
        var u = i && i.constructor, p = typeof u == "function" && u.prototype || ql;
        return i === p;
      }
      function O7(i) {
        return i === i && !Ln(i);
      }
      function F7(i, u) {
        return function(p) {
          return p == null ? !1 : p[i] === u && (u !== n || i in dn(p));
        };
      }
      function $E(i) {
        var u = L0(i, function(S) {
          return p.size === d && p.clear(), S;
        }), p = u.cache;
        return u;
      }
      function ZE(i, u) {
        var p = i[1], S = u[1], w = p | S, T = w < (y | _ | N), O = S == N && p == I || S == N && p == P && i[7].length <= u[8] || S == (N | P) && u[7].length <= u[8] && p == I;
        if (!(T || O))
          return i;
        S & y && (i[2] = u[2], w |= p & y ? 0 : x);
        var H = u[3];
        if (H) {
          var U = i[3];
          i[3] = U ? y7(U, H, u[4]) : H, i[4] = U ? Fi(i[3], f) : u[4];
        }
        return H = u[5], H && (U = i[5], i[5] = U ? S7(U, H, u[6]) : H, i[6] = U ? Fi(i[5], f) : u[6]), H = u[7], H && (i[7] = H), S & N && (i[8] = i[8] == null ? u[8] : Cr(i[8], u[8])), i[9] == null && (i[9] = u[9]), i[0] = u[0], i[1] = w, i;
      }
      function jE(i) {
        var u = [];
        if (i != null)
          for (var p in dn(i))
            u.push(p);
        return u;
      }
      function WE(i) {
        return e0.call(i);
      }
      function B7(i, u, p) {
        return u = tr(u === n ? i.length - 1 : u, 0), function() {
          for (var S = arguments, w = -1, T = tr(S.length - u, 0), O = ee(T); ++w < T; )
            O[w] = S[u + w];
          w = -1;
          for (var H = ee(u + 1); ++w < u; )
            H[w] = S[w];
          return H[u] = p(O), io(i, this, H);
        };
      }
      function H7(i, u) {
        return u.length < 2 ? i : Os(i, Ro(u, 0, -1));
      }
      function zE(i, u) {
        for (var p = i.length, S = Cr(u.length, p), w = jr(i); S--; ) {
          var T = u[S];
          i[S] = qa(T, p) ? w[T] : n;
        }
        return i;
      }
      function Zp(i, u) {
        if (!(u === "constructor" && typeof i[u] == "function") && u != "__proto__")
          return i[u];
      }
      var G7 = Z7(c7), Fc = sR || function(i, u) {
        return bt.setTimeout(i, u);
      }, jp = Z7(mE);
      function $7(i, u, p) {
        var S = u + "";
        return jp(i, OE(S, UE(PE(S), p)));
      }
      function Z7(i) {
        var u = 0, p = 0;
        return function() {
          var S = dR(), w = ue - (S - p);
          if (p = S, w > 0) {
            if (++u >= ae)
              return arguments[0];
          } else
            u = 0;
          return i.apply(n, arguments);
        };
      }
      function x0(i, u) {
        var p = -1, S = i.length, w = S - 1;
        for (u = u === n ? S : u; ++p < u; ) {
          var T = Ip(p, w), O = i[T];
          i[T] = i[p], i[p] = O;
        }
        return i.length = u, i;
      }
      var j7 = $E(function(i) {
        var u = [];
        return i.charCodeAt(0) === 46 && u.push(""), i.replace(ao, function(p, S, w, T) {
          u.push(w ? T.replace(ke, "$1") : S || p);
        }), u;
      });
      function xa(i) {
        if (typeof i == "string" || uo(i))
          return i;
        var u = i + "";
        return u == "0" && 1 / i == -z ? "-0" : u;
      }
      function Bs(i) {
        if (i != null) {
          try {
            return Qd.call(i);
          } catch {
          }
          try {
            return i + "";
          } catch {
          }
        }
        return "";
      }
      function UE(i, u) {
        return _o(pe, function(p) {
          var S = "_." + p[0];
          u & p[1] && !Xd(i, S) && i.push(S);
        }), i.sort();
      }
      function W7(i) {
        if (i instanceof kt)
          return i.clone();
        var u = new wo(i.__wrapped__, i.__chain__);
        return u.__actions__ = jr(i.__actions__), u.__index__ = i.__index__, u.__values__ = i.__values__, u;
      }
      function XE(i, u, p) {
        (p ? Rr(i, u, p) : u === n) ? u = 1 : u = tr(At(u), 0);
        var S = i == null ? 0 : i.length;
        if (!S || u < 1)
          return [];
        for (var w = 0, T = 0, O = ee(i0(S / u)); w < S; )
          O[T++] = Ro(i, w, w += u);
        return O;
      }
      function YE(i) {
        for (var u = -1, p = i == null ? 0 : i.length, S = 0, w = []; ++u < p; ) {
          var T = i[u];
          T && (w[S++] = T);
        }
        return w;
      }
      function qE() {
        var i = arguments.length;
        if (!i)
          return [];
        for (var u = ee(i - 1), p = arguments[0], S = i; S--; )
          u[S - 1] = arguments[S];
        return Oi(Ct(p) ? jr(p) : [p], hr(u, 1));
      }
      var JE = Rt(function(i, u) {
        return Gn(i) ? Nc(i, hr(u, 1, Gn, !0)) : [];
      }), KE = Rt(function(i, u) {
        var p = Eo(u);
        return Gn(p) && (p = n), Gn(i) ? Nc(i, hr(u, 1, Gn, !0), rt(p, 2)) : [];
      }), QE = Rt(function(i, u) {
        var p = Eo(u);
        return Gn(p) && (p = n), Gn(i) ? Nc(i, hr(u, 1, Gn, !0), n, p) : [];
      });
      function eD(i, u, p) {
        var S = i == null ? 0 : i.length;
        return S ? (u = p || u === n ? 1 : At(u), Ro(i, u < 0 ? 0 : u, S)) : [];
      }
      function tD(i, u, p) {
        var S = i == null ? 0 : i.length;
        return S ? (u = p || u === n ? 1 : At(u), u = S - u, Ro(i, 0, u < 0 ? 0 : u)) : [];
      }
      function nD(i, u) {
        return i && i.length ? g0(i, rt(u, 3), !0, !0) : [];
      }
      function rD(i, u) {
        return i && i.length ? g0(i, rt(u, 3), !0) : [];
      }
      function oD(i, u, p, S) {
        var w = i == null ? 0 : i.length;
        return w ? (p && typeof p != "number" && Rr(i, u, p) && (p = 0, S = w), qR(i, u, p, S)) : [];
      }
      function z7(i, u, p) {
        var S = i == null ? 0 : i.length;
        if (!S)
          return -1;
        var w = p == null ? 0 : At(p);
        return w < 0 && (w = tr(S + w, 0)), Yd(i, rt(u, 3), w);
      }
      function U7(i, u, p) {
        var S = i == null ? 0 : i.length;
        if (!S)
          return -1;
        var w = S - 1;
        return p !== n && (w = At(p), w = p < 0 ? tr(S + w, 0) : Cr(w, S - 1)), Yd(i, rt(u, 3), w, !0);
      }
      function X7(i) {
        var u = i == null ? 0 : i.length;
        return u ? hr(i, 1) : [];
      }
      function aD(i) {
        var u = i == null ? 0 : i.length;
        return u ? hr(i, z) : [];
      }
      function iD(i, u) {
        var p = i == null ? 0 : i.length;
        return p ? (u = u === n ? 1 : At(u), hr(i, u)) : [];
      }
      function sD(i) {
        for (var u = -1, p = i == null ? 0 : i.length, S = {}; ++u < p; ) {
          var w = i[u];
          S[w[0]] = w[1];
        }
        return S;
      }
      function Y7(i) {
        return i && i.length ? i[0] : n;
      }
      function lD(i, u, p) {
        var S = i == null ? 0 : i.length;
        if (!S)
          return -1;
        var w = p == null ? 0 : At(p);
        return w < 0 && (w = tr(S + w, 0)), zl(i, u, w);
      }
      function uD(i) {
        var u = i == null ? 0 : i.length;
        return u ? Ro(i, 0, -1) : [];
      }
      var cD = Rt(function(i) {
        var u = xn(i, Dp);
        return u.length && u[0] === i[0] ? Sp(u) : [];
      }), dD = Rt(function(i) {
        var u = Eo(i), p = xn(i, Dp);
        return u === Eo(p) ? u = n : p.pop(), p.length && p[0] === i[0] ? Sp(p, rt(u, 2)) : [];
      }), fD = Rt(function(i) {
        var u = Eo(i), p = xn(i, Dp);
        return u = typeof u == "function" ? u : n, u && p.pop(), p.length && p[0] === i[0] ? Sp(p, n, u) : [];
      });
      function hD(i, u) {
        return i == null ? "" : uR.call(i, u);
      }
      function Eo(i) {
        var u = i == null ? 0 : i.length;
        return u ? i[u - 1] : n;
      }
      function pD(i, u, p) {
        var S = i == null ? 0 : i.length;
        if (!S)
          return -1;
        var w = S;
        return p !== n && (w = At(p), w = w < 0 ? tr(S + w, 0) : Cr(w, S - 1)), u === u ? UL(i, u, w) : Yd(i, R9, w, !0);
      }
      function mD(i, u) {
        return i && i.length ? i7(i, At(u)) : n;
      }
      var gD = Rt(q7);
      function q7(i, u) {
        return i && i.length && u && u.length ? _p(i, u) : i;
      }
      function vD(i, u, p) {
        return i && i.length && u && u.length ? _p(i, u, rt(p, 2)) : i;
      }
      function CD(i, u, p) {
        return i && i.length && u && u.length ? _p(i, u, n, p) : i;
      }
      var bD = Ya(function(i, u) {
        var p = i == null ? 0 : i.length, S = vp(i, u);
        return u7(i, xn(u, function(w) {
          return qa(w, p) ? +w : w;
        }).sort(b7)), S;
      });
      function yD(i, u) {
        var p = [];
        if (!(i && i.length))
          return p;
        var S = -1, w = [], T = i.length;
        for (u = rt(u, 3); ++S < T; ) {
          var O = i[S];
          u(O, S, i) && (p.push(O), w.push(S));
        }
        return u7(i, w), p;
      }
      function Wp(i) {
        return i == null ? i : hR.call(i);
      }
      function SD(i, u, p) {
        var S = i == null ? 0 : i.length;
        return S ? (p && typeof p != "number" && Rr(i, u, p) ? (u = 0, p = S) : (u = u == null ? 0 : At(u), p = p === n ? S : At(p)), Ro(i, u, p)) : [];
      }
      function AD(i, u) {
        return m0(i, u);
      }
      function MD(i, u, p) {
        return Lp(i, u, rt(p, 2));
      }
      function xD(i, u) {
        var p = i == null ? 0 : i.length;
        if (p) {
          var S = m0(i, u);
          if (S < p && ta(i[S], u))
            return S;
        }
        return -1;
      }
      function _D(i, u) {
        return m0(i, u, !0);
      }
      function ID(i, u, p) {
        return Lp(i, u, rt(p, 2), !0);
      }
      function wD(i, u) {
        var p = i == null ? 0 : i.length;
        if (p) {
          var S = m0(i, u, !0) - 1;
          if (ta(i[S], u))
            return S;
        }
        return -1;
      }
      function LD(i) {
        return i && i.length ? d7(i) : [];
      }
      function RD(i, u) {
        return i && i.length ? d7(i, rt(u, 2)) : [];
      }
      function ED(i) {
        var u = i == null ? 0 : i.length;
        return u ? Ro(i, 1, u) : [];
      }
      function DD(i, u, p) {
        return i && i.length ? (u = p || u === n ? 1 : At(u), Ro(i, 0, u < 0 ? 0 : u)) : [];
      }
      function ND(i, u, p) {
        var S = i == null ? 0 : i.length;
        return S ? (u = p || u === n ? 1 : At(u), u = S - u, Ro(i, u < 0 ? 0 : u, S)) : [];
      }
      function TD(i, u) {
        return i && i.length ? g0(i, rt(u, 3), !1, !0) : [];
      }
      function PD(i, u) {
        return i && i.length ? g0(i, rt(u, 3)) : [];
      }
      var kD = Rt(function(i) {
        return Gi(hr(i, 1, Gn, !0));
      }), VD = Rt(function(i) {
        var u = Eo(i);
        return Gn(u) && (u = n), Gi(hr(i, 1, Gn, !0), rt(u, 2));
      }), OD = Rt(function(i) {
        var u = Eo(i);
        return u = typeof u == "function" ? u : n, Gi(hr(i, 1, Gn, !0), n, u);
      });
      function FD(i) {
        return i && i.length ? Gi(i) : [];
      }
      function BD(i, u) {
        return i && i.length ? Gi(i, rt(u, 2)) : [];
      }
      function HD(i, u) {
        return u = typeof u == "function" ? u : n, i && i.length ? Gi(i, n, u) : [];
      }
      function zp(i) {
        if (!(i && i.length))
          return [];
        var u = 0;
        return i = Vi(i, function(p) {
          if (Gn(p))
            return u = tr(p.length, u), !0;
        }), up(u, function(p) {
          return xn(i, ip(p));
        });
      }
      function J7(i, u) {
        if (!(i && i.length))
          return [];
        var p = zp(i);
        return u == null ? p : xn(p, function(S) {
          return io(u, n, S);
        });
      }
      var GD = Rt(function(i, u) {
        return Gn(i) ? Nc(i, u) : [];
      }), $D = Rt(function(i) {
        return Ep(Vi(i, Gn));
      }), ZD = Rt(function(i) {
        var u = Eo(i);
        return Gn(u) && (u = n), Ep(Vi(i, Gn), rt(u, 2));
      }), jD = Rt(function(i) {
        var u = Eo(i);
        return u = typeof u == "function" ? u : n, Ep(Vi(i, Gn), n, u);
      }), WD = Rt(zp);
      function zD(i, u) {
        return m7(i || [], u || [], Dc);
      }
      function UD(i, u) {
        return m7(i || [], u || [], kc);
      }
      var XD = Rt(function(i) {
        var u = i.length, p = u > 1 ? i[u - 1] : n;
        return p = typeof p == "function" ? (i.pop(), p) : n, J7(i, p);
      });
      function K7(i) {
        var u = D(i);
        return u.__chain__ = !0, u;
      }
      function YD(i, u) {
        return u(i), i;
      }
      function _0(i, u) {
        return u(i);
      }
      var qD = Ya(function(i) {
        var u = i.length, p = u ? i[0] : 0, S = this.__wrapped__, w = function(T) {
          return vp(T, i);
        };
        return u > 1 || this.__actions__.length || !(S instanceof kt) || !qa(p) ? this.thru(w) : (S = S.slice(p, +p + (u ? 1 : 0)), S.__actions__.push({
          func: _0,
          args: [w],
          thisArg: n
        }), new wo(S, this.__chain__).thru(function(T) {
          return u && !T.length && T.push(n), T;
        }));
      });
      function JD() {
        return K7(this);
      }
      function KD() {
        return new wo(this.value(), this.__chain__);
      }
      function QD() {
        this.__values__ === n && (this.__values__ = f6(this.value()));
        var i = this.__index__ >= this.__values__.length, u = i ? n : this.__values__[this.__index__++];
        return { done: i, value: u };
      }
      function eN() {
        return this;
      }
      function tN(i) {
        for (var u, p = this; p instanceof c0; ) {
          var S = W7(p);
          S.__index__ = 0, S.__values__ = n, u ? w.__wrapped__ = S : u = S;
          var w = S;
          p = p.__wrapped__;
        }
        return w.__wrapped__ = i, u;
      }
      function nN() {
        var i = this.__wrapped__;
        if (i instanceof kt) {
          var u = i;
          return this.__actions__.length && (u = new kt(this)), u = u.reverse(), u.__actions__.push({
            func: _0,
            args: [Wp],
            thisArg: n
          }), new wo(u, this.__chain__);
        }
        return this.thru(Wp);
      }
      function rN() {
        return p7(this.__wrapped__, this.__actions__);
      }
      var oN = v0(function(i, u, p) {
        on.call(i, p) ? ++i[p] : Ua(i, p, 1);
      });
      function aN(i, u, p) {
        var S = Ct(i) ? w9 : YR;
        return p && Rr(i, u, p) && (u = n), S(i, rt(u, 3));
      }
      function iN(i, u) {
        var p = Ct(i) ? Vi : J9;
        return p(i, rt(u, 3));
      }
      var sN = _7(z7), lN = _7(U7);
      function uN(i, u) {
        return hr(I0(i, u), 1);
      }
      function cN(i, u) {
        return hr(I0(i, u), z);
      }
      function dN(i, u, p) {
        return p = p === n ? 1 : At(p), hr(I0(i, u), p);
      }
      function Q7(i, u) {
        var p = Ct(i) ? _o : Hi;
        return p(i, rt(u, 3));
      }
      function e6(i, u) {
        var p = Ct(i) ? EL : q9;
        return p(i, rt(u, 3));
      }
      var fN = v0(function(i, u, p) {
        on.call(i, p) ? i[p].push(u) : Ua(i, p, [u]);
      });
      function hN(i, u, p, S) {
        i = Wr(i) ? i : ou(i), p = p && !S ? At(p) : 0;
        var w = i.length;
        return p < 0 && (p = tr(w + p, 0)), D0(i) ? p <= w && i.indexOf(u, p) > -1 : !!w && zl(i, u, p) > -1;
      }
      var pN = Rt(function(i, u, p) {
        var S = -1, w = typeof u == "function", T = Wr(i) ? ee(i.length) : [];
        return Hi(i, function(O) {
          T[++S] = w ? io(u, O, p) : Tc(O, u, p);
        }), T;
      }), mN = v0(function(i, u, p) {
        Ua(i, p, u);
      });
      function I0(i, u) {
        var p = Ct(i) ? xn : r7;
        return p(i, rt(u, 3));
      }
      function gN(i, u, p, S) {
        return i == null ? [] : (Ct(u) || (u = u == null ? [] : [u]), p = S ? n : p, Ct(p) || (p = p == null ? [] : [p]), s7(i, u, p));
      }
      var vN = v0(function(i, u, p) {
        i[p ? 0 : 1].push(u);
      }, function() {
        return [[], []];
      });
      function CN(i, u, p) {
        var S = Ct(i) ? op : D9, w = arguments.length < 3;
        return S(i, rt(u, 4), p, w, Hi);
      }
      function bN(i, u, p) {
        var S = Ct(i) ? DL : D9, w = arguments.length < 3;
        return S(i, rt(u, 4), p, w, q9);
      }
      function yN(i, u) {
        var p = Ct(i) ? Vi : J9;
        return p(i, R0(rt(u, 3)));
      }
      function SN(i) {
        var u = Ct(i) ? z9 : hE;
        return u(i);
      }
      function AN(i, u, p) {
        (p ? Rr(i, u, p) : u === n) ? u = 1 : u = At(u);
        var S = Ct(i) ? jR : pE;
        return S(i, u);
      }
      function MN(i) {
        var u = Ct(i) ? WR : gE;
        return u(i);
      }
      function xN(i) {
        if (i == null)
          return 0;
        if (Wr(i))
          return D0(i) ? Xl(i) : i.length;
        var u = br(i);
        return u == Ee || u == sn ? i.size : Mp(i).length;
      }
      function _N(i, u, p) {
        var S = Ct(i) ? ap : vE;
        return p && Rr(i, u, p) && (u = n), S(i, rt(u, 3));
      }
      var IN = Rt(function(i, u) {
        if (i == null)
          return [];
        var p = u.length;
        return p > 1 && Rr(i, u[0], u[1]) ? u = [] : p > 2 && Rr(u[0], u[1], u[2]) && (u = [u[0]]), s7(i, hr(u, 1), []);
      }), w0 = iR || function() {
        return bt.Date.now();
      };
      function wN(i, u) {
        if (typeof u != "function")
          throw new Io(s);
        return i = At(i), function() {
          if (--i < 1)
            return u.apply(this, arguments);
        };
      }
      function t6(i, u, p) {
        return u = p ? n : u, u = i && u == null ? i.length : u, Xa(i, N, n, n, n, n, u);
      }
      function n6(i, u) {
        var p;
        if (typeof u != "function")
          throw new Io(s);
        return i = At(i), function() {
          return --i > 0 && (p = u.apply(this, arguments)), i <= 1 && (u = n), p;
        };
      }
      var Up = Rt(function(i, u, p) {
        var S = y;
        if (p.length) {
          var w = Fi(p, nu(Up));
          S |= E;
        }
        return Xa(i, S, u, p, w);
      }), r6 = Rt(function(i, u, p) {
        var S = y | _;
        if (p.length) {
          var w = Fi(p, nu(r6));
          S |= E;
        }
        return Xa(u, S, i, p, w);
      });
      function o6(i, u, p) {
        u = p ? n : u;
        var S = Xa(i, I, n, n, n, n, n, u);
        return S.placeholder = o6.placeholder, S;
      }
      function a6(i, u, p) {
        u = p ? n : u;
        var S = Xa(i, R, n, n, n, n, n, u);
        return S.placeholder = a6.placeholder, S;
      }
      function i6(i, u, p) {
        var S, w, T, O, H, U, he = 0, me = !1, ye = !1, Ve = !0;
        if (typeof i != "function")
          throw new Io(s);
        u = Do(u) || 0, Ln(p) && (me = !!p.leading, ye = "maxWait" in p, T = ye ? tr(Do(p.maxWait) || 0, u) : T, Ve = "trailing" in p ? !!p.trailing : Ve);
        function We($n) {
          var na = S, Qa = w;
          return S = w = n, he = $n, O = i.apply(Qa, na), O;
        }
        function it($n) {
          return he = $n, H = Fc(Tt, u), me ? We($n) : O;
        }
        function It($n) {
          var na = $n - U, Qa = $n - he, _6 = u - na;
          return ye ? Cr(_6, T - Qa) : _6;
        }
        function st($n) {
          var na = $n - U, Qa = $n - he;
          return U === n || na >= u || na < 0 || ye && Qa >= T;
        }
        function Tt() {
          var $n = w0();
          if (st($n))
            return Bt($n);
          H = Fc(Tt, It($n));
        }
        function Bt($n) {
          return H = n, Ve && S ? We($n) : (S = w = n, O);
        }
        function co() {
          H !== n && g7(H), he = 0, S = U = w = H = n;
        }
        function Er() {
          return H === n ? O : Bt(w0());
        }
        function fo() {
          var $n = w0(), na = st($n);
          if (S = arguments, w = this, U = $n, na) {
            if (H === n)
              return it(U);
            if (ye)
              return g7(H), H = Fc(Tt, u), We(U);
          }
          return H === n && (H = Fc(Tt, u)), O;
        }
        return fo.cancel = co, fo.flush = Er, fo;
      }
      var LN = Rt(function(i, u) {
        return Y9(i, 1, u);
      }), RN = Rt(function(i, u, p) {
        return Y9(i, Do(u) || 0, p);
      });
      function EN(i) {
        return Xa(i, F);
      }
      function L0(i, u) {
        if (typeof i != "function" || u != null && typeof u != "function")
          throw new Io(s);
        var p = function() {
          var S = arguments, w = u ? u.apply(this, S) : S[0], T = p.cache;
          if (T.has(w))
            return T.get(w);
          var O = i.apply(this, S);
          return p.cache = T.set(w, O) || T, O;
        };
        return p.cache = new (L0.Cache || za)(), p;
      }
      L0.Cache = za;
      function R0(i) {
        if (typeof i != "function")
          throw new Io(s);
        return function() {
          var u = arguments;
          switch (u.length) {
            case 0:
              return !i.call(this);
            case 1:
              return !i.call(this, u[0]);
            case 2:
              return !i.call(this, u[0], u[1]);
            case 3:
              return !i.call(this, u[0], u[1], u[2]);
          }
          return !i.apply(this, u);
        };
      }
      function DN(i) {
        return n6(2, i);
      }
      var NN = CE(function(i, u) {
        u = u.length == 1 && Ct(u[0]) ? xn(u[0], so(rt())) : xn(hr(u, 1), so(rt()));
        var p = u.length;
        return Rt(function(S) {
          for (var w = -1, T = Cr(S.length, p); ++w < T; )
            S[w] = u[w].call(this, S[w]);
          return io(i, this, S);
        });
      }), Xp = Rt(function(i, u) {
        var p = Fi(u, nu(Xp));
        return Xa(i, E, n, u, p);
      }), s6 = Rt(function(i, u) {
        var p = Fi(u, nu(s6));
        return Xa(i, k, n, u, p);
      }), TN = Ya(function(i, u) {
        return Xa(i, P, n, n, n, u);
      });
      function PN(i, u) {
        if (typeof i != "function")
          throw new Io(s);
        return u = u === n ? u : At(u), Rt(i, u);
      }
      function kN(i, u) {
        if (typeof i != "function")
          throw new Io(s);
        return u = u == null ? 0 : tr(At(u), 0), Rt(function(p) {
          var S = p[u], w = Zi(p, 0, u);
          return S && Oi(w, S), io(i, this, w);
        });
      }
      function VN(i, u, p) {
        var S = !0, w = !0;
        if (typeof i != "function")
          throw new Io(s);
        return Ln(p) && (S = "leading" in p ? !!p.leading : S, w = "trailing" in p ? !!p.trailing : w), i6(i, u, {
          leading: S,
          maxWait: u,
          trailing: w
        });
      }
      function ON(i) {
        return t6(i, 1);
      }
      function FN(i, u) {
        return Xp(Np(u), i);
      }
      function BN() {
        if (!arguments.length)
          return [];
        var i = arguments[0];
        return Ct(i) ? i : [i];
      }
      function HN(i) {
        return Lo(i, g);
      }
      function GN(i, u) {
        return u = typeof u == "function" ? u : n, Lo(i, g, u);
      }
      function $N(i) {
        return Lo(i, h | g);
      }
      function ZN(i, u) {
        return u = typeof u == "function" ? u : n, Lo(i, h | g, u);
      }
      function jN(i, u) {
        return u == null || X9(i, u, cr(u));
      }
      function ta(i, u) {
        return i === u || i !== i && u !== u;
      }
      var WN = S0(yp), zN = S0(function(i, u) {
        return i >= u;
      }), Hs = e7(function() {
        return arguments;
      }()) ? e7 : function(i) {
        return kn(i) && on.call(i, "callee") && !H9.call(i, "callee");
      }, Ct = ee.isArray, UN = jl ? so(jl) : tE;
      function Wr(i) {
        return i != null && E0(i.length) && !Ja(i);
      }
      function Gn(i) {
        return kn(i) && Wr(i);
      }
      function XN(i) {
        return i === !0 || i === !1 || kn(i) && Lr(i) == Ie;
      }
      var ji = lR || am, YN = Wl ? so(Wl) : nE;
      function qN(i) {
        return kn(i) && i.nodeType === 1 && !Bc(i);
      }
      function JN(i) {
        if (i == null)
          return !0;
        if (Wr(i) && (Ct(i) || typeof i == "string" || typeof i.splice == "function" || ji(i) || ru(i) || Hs(i)))
          return !i.length;
        var u = br(i);
        if (u == Ee || u == sn)
          return !i.size;
        if (Oc(i))
          return !Mp(i).length;
        for (var p in i)
          if (on.call(i, p))
            return !1;
        return !0;
      }
      function KN(i, u) {
        return Pc(i, u);
      }
      function QN(i, u, p) {
        p = typeof p == "function" ? p : n;
        var S = p ? p(i, u) : n;
        return S === n ? Pc(i, u, n, p) : !!S;
      }
      function Yp(i) {
        if (!kn(i))
          return !1;
        var u = Lr(i);
        return u == Fe || u == Se || typeof i.message == "string" && typeof i.name == "string" && !Bc(i);
      }
      function eT(i) {
        return typeof i == "number" && $9(i);
      }
      function Ja(i) {
        if (!Ln(i))
          return !1;
        var u = Lr(i);
        return u == oe || u == pt || u == we || u == zn;
      }
      function l6(i) {
        return typeof i == "number" && i == At(i);
      }
      function E0(i) {
        return typeof i == "number" && i > -1 && i % 1 == 0 && i <= K;
      }
      function Ln(i) {
        var u = typeof i;
        return i != null && (u == "object" || u == "function");
      }
      function kn(i) {
        return i != null && typeof i == "object";
      }
      var u6 = xc ? so(xc) : oE;
      function tT(i, u) {
        return i === u || Ap(i, u, Bp(u));
      }
      function nT(i, u, p) {
        return p = typeof p == "function" ? p : n, Ap(i, u, Bp(u), p);
      }
      function rT(i) {
        return c6(i) && i != +i;
      }
      function oT(i) {
        if (GE(i))
          throw new vt(a);
        return t7(i);
      }
      function aT(i) {
        return i === null;
      }
      function iT(i) {
        return i == null;
      }
      function c6(i) {
        return typeof i == "number" || kn(i) && Lr(i) == wt;
      }
      function Bc(i) {
        if (!kn(i) || Lr(i) != Ft)
          return !1;
        var u = r0(i);
        if (u === null)
          return !0;
        var p = on.call(u, "constructor") && u.constructor;
        return typeof p == "function" && p instanceof p && Qd.call(p) == nR;
      }
      var qp = x9 ? so(x9) : aE;
      function sT(i) {
        return l6(i) && i >= -K && i <= K;
      }
      var d6 = _9 ? so(_9) : iE;
      function D0(i) {
        return typeof i == "string" || !Ct(i) && kn(i) && Lr(i) == Tn;
      }
      function uo(i) {
        return typeof i == "symbol" || kn(i) && Lr(i) == Pn;
      }
      var ru = I9 ? so(I9) : sE;
      function lT(i) {
        return i === n;
      }
      function uT(i) {
        return kn(i) && br(i) == vr;
      }
      function cT(i) {
        return kn(i) && Lr(i) == qo;
      }
      var dT = S0(xp), fT = S0(function(i, u) {
        return i <= u;
      });
      function f6(i) {
        if (!i)
          return [];
        if (Wr(i))
          return D0(i) ? Qo(i) : jr(i);
        if (Ic && i[Ic])
          return jL(i[Ic]());
        var u = br(i), p = u == Ee ? dp : u == sn ? qd : ou;
        return p(i);
      }
      function Ka(i) {
        if (!i)
          return i === 0 ? i : 0;
        if (i = Do(i), i === z || i === -z) {
          var u = i < 0 ? -1 : 1;
          return u * Ce;
        }
        return i === i ? i : 0;
      }
      function At(i) {
        var u = Ka(i), p = u % 1;
        return u === u ? p ? u - p : u : 0;
      }
      function h6(i) {
        return i ? Vs(At(i), 0, J) : 0;
      }
      function Do(i) {
        if (typeof i == "number")
          return i;
        if (uo(i))
          return q;
        if (Ln(i)) {
          var u = typeof i.valueOf == "function" ? i.valueOf() : i;
          i = Ln(u) ? u + "" : u;
        }
        if (typeof i != "string")
          return i === 0 ? i : +i;
        i = N9(i);
        var p = Dt.test(i);
        return p || Qn.test(i) ? Be(i.slice(2), p ? 2 : 8) : Yt.test(i) ? q : +i;
      }
      function p6(i) {
        return Ma(i, zr(i));
      }
      function hT(i) {
        return i ? Vs(At(i), -K, K) : i === 0 ? i : 0;
      }
      function en(i) {
        return i == null ? "" : lo(i);
      }
      var pT = eu(function(i, u) {
        if (Oc(u) || Wr(u)) {
          Ma(u, cr(u), i);
          return;
        }
        for (var p in u)
          on.call(u, p) && Dc(i, p, u[p]);
      }), m6 = eu(function(i, u) {
        Ma(u, zr(u), i);
      }), N0 = eu(function(i, u, p, S) {
        Ma(u, zr(u), i, S);
      }), mT = eu(function(i, u, p, S) {
        Ma(u, cr(u), i, S);
      }), gT = Ya(vp);
      function vT(i, u) {
        var p = Ql(i);
        return u == null ? p : U9(p, u);
      }
      var CT = Rt(function(i, u) {
        i = dn(i);
        var p = -1, S = u.length, w = S > 2 ? u[2] : n;
        for (w && Rr(u[0], u[1], w) && (S = 1); ++p < S; )
          for (var T = u[p], O = zr(T), H = -1, U = O.length; ++H < U; ) {
            var he = O[H], me = i[he];
            (me === n || ta(me, ql[he]) && !on.call(i, he)) && (i[he] = T[he]);
          }
        return i;
      }), bT = Rt(function(i) {
        return i.push(n, N7), io(g6, n, i);
      });
      function yT(i, u) {
        return L9(i, rt(u, 3), Aa);
      }
      function ST(i, u) {
        return L9(i, rt(u, 3), bp);
      }
      function AT(i, u) {
        return i == null ? i : Cp(i, rt(u, 3), zr);
      }
      function MT(i, u) {
        return i == null ? i : K9(i, rt(u, 3), zr);
      }
      function xT(i, u) {
        return i && Aa(i, rt(u, 3));
      }
      function _T(i, u) {
        return i && bp(i, rt(u, 3));
      }
      function IT(i) {
        return i == null ? [] : h0(i, cr(i));
      }
      function wT(i) {
        return i == null ? [] : h0(i, zr(i));
      }
      function Jp(i, u, p) {
        var S = i == null ? n : Os(i, u);
        return S === n ? p : S;
      }
      function LT(i, u) {
        return i != null && k7(i, u, JR);
      }
      function Kp(i, u) {
        return i != null && k7(i, u, KR);
      }
      var RT = w7(function(i, u, p) {
        u != null && typeof u.toString != "function" && (u = e0.call(u)), i[u] = p;
      }, em(Ur)), ET = w7(function(i, u, p) {
        u != null && typeof u.toString != "function" && (u = e0.call(u)), on.call(i, u) ? i[u].push(p) : i[u] = [p];
      }, rt), DT = Rt(Tc);
      function cr(i) {
        return Wr(i) ? W9(i) : Mp(i);
      }
      function zr(i) {
        return Wr(i) ? W9(i, !0) : lE(i);
      }
      function NT(i, u) {
        var p = {};
        return u = rt(u, 3), Aa(i, function(S, w, T) {
          Ua(p, u(S, w, T), S);
        }), p;
      }
      function TT(i, u) {
        var p = {};
        return u = rt(u, 3), Aa(i, function(S, w, T) {
          Ua(p, w, u(S, w, T));
        }), p;
      }
      var PT = eu(function(i, u, p) {
        p0(i, u, p);
      }), g6 = eu(function(i, u, p, S) {
        p0(i, u, p, S);
      }), kT = Ya(function(i, u) {
        var p = {};
        if (i == null)
          return p;
        var S = !1;
        u = xn(u, function(T) {
          return T = $i(T, i), S || (S = T.length > 1), T;
        }), Ma(i, Op(i), p), S && (p = Lo(p, h | m | g, RE));
        for (var w = u.length; w--; )
          Rp(p, u[w]);
        return p;
      });
      function VT(i, u) {
        return v6(i, R0(rt(u)));
      }
      var OT = Ya(function(i, u) {
        return i == null ? {} : cE(i, u);
      });
      function v6(i, u) {
        if (i == null)
          return {};
        var p = xn(Op(i), function(S) {
          return [S];
        });
        return u = rt(u), l7(i, p, function(S, w) {
          return u(S, w[0]);
        });
      }
      function FT(i, u, p) {
        u = $i(u, i);
        var S = -1, w = u.length;
        for (w || (w = 1, i = n); ++S < w; ) {
          var T = i == null ? n : i[xa(u[S])];
          T === n && (S = w, T = p), i = Ja(T) ? T.call(i) : T;
        }
        return i;
      }
      function BT(i, u, p) {
        return i == null ? i : kc(i, u, p);
      }
      function HT(i, u, p, S) {
        return S = typeof S == "function" ? S : n, i == null ? i : kc(i, u, p, S);
      }
      var C6 = E7(cr), b6 = E7(zr);
      function GT(i, u, p) {
        var S = Ct(i), w = S || ji(i) || ru(i);
        if (u = rt(u, 4), p == null) {
          var T = i && i.constructor;
          w ? p = S ? new T() : [] : Ln(i) ? p = Ja(T) ? Ql(r0(i)) : {} : p = {};
        }
        return (w ? _o : Aa)(i, function(O, H, U) {
          return u(p, O, H, U);
        }), p;
      }
      function $T(i, u) {
        return i == null ? !0 : Rp(i, u);
      }
      function ZT(i, u, p) {
        return i == null ? i : h7(i, u, Np(p));
      }
      function jT(i, u, p, S) {
        return S = typeof S == "function" ? S : n, i == null ? i : h7(i, u, Np(p), S);
      }
      function ou(i) {
        return i == null ? [] : cp(i, cr(i));
      }
      function WT(i) {
        return i == null ? [] : cp(i, zr(i));
      }
      function zT(i, u, p) {
        return p === n && (p = u, u = n), p !== n && (p = Do(p), p = p === p ? p : 0), u !== n && (u = Do(u), u = u === u ? u : 0), Vs(Do(i), u, p);
      }
      function UT(i, u, p) {
        return u = Ka(u), p === n ? (p = u, u = 0) : p = Ka(p), i = Do(i), QR(i, u, p);
      }
      function XT(i, u, p) {
        if (p && typeof p != "boolean" && Rr(i, u, p) && (u = p = n), p === n && (typeof u == "boolean" ? (p = u, u = n) : typeof i == "boolean" && (p = i, i = n)), i === n && u === n ? (i = 0, u = 1) : (i = Ka(i), u === n ? (u = i, i = 0) : u = Ka(u)), i > u) {
          var S = i;
          i = u, u = S;
        }
        if (p || i % 1 || u % 1) {
          var w = Z9();
          return Cr(i + w * (u - i + Q("1e-" + ((w + "").length - 1))), u);
        }
        return Ip(i, u);
      }
      var YT = tu(function(i, u, p) {
        return u = u.toLowerCase(), i + (p ? y6(u) : u);
      });
      function y6(i) {
        return Qp(en(i).toLowerCase());
      }
      function S6(i) {
        return i = en(i), i && i.replace(Mn, BL).replace(jd, "");
      }
      function qT(i, u, p) {
        i = en(i), u = lo(u);
        var S = i.length;
        p = p === n ? S : Vs(At(p), 0, S);
        var w = p;
        return p -= u.length, p >= 0 && i.slice(p, w) == u;
      }
      function JT(i) {
        return i = en(i), i && xo.test(i) ? i.replace(Mo, HL) : i;
      }
      function KT(i) {
        return i = en(i), i && Ol.test(i) ? i.replace(Rs, "\\$&") : i;
      }
      var QT = tu(function(i, u, p) {
        return i + (p ? "-" : "") + u.toLowerCase();
      }), eP = tu(function(i, u, p) {
        return i + (p ? " " : "") + u.toLowerCase();
      }), tP = x7("toLowerCase");
      function nP(i, u, p) {
        i = en(i), u = At(u);
        var S = u ? Xl(i) : 0;
        if (!u || S >= u)
          return i;
        var w = (u - S) / 2;
        return y0(s0(w), p) + i + y0(i0(w), p);
      }
      function rP(i, u, p) {
        i = en(i), u = At(u);
        var S = u ? Xl(i) : 0;
        return u && S < u ? i + y0(u - S, p) : i;
      }
      function oP(i, u, p) {
        i = en(i), u = At(u);
        var S = u ? Xl(i) : 0;
        return u && S < u ? y0(u - S, p) + i : i;
      }
      function aP(i, u, p) {
        return p || u == null ? u = 0 : u && (u = +u), fR(en(i).replace(Pi, ""), u || 0);
      }
      function iP(i, u, p) {
        return (p ? Rr(i, u, p) : u === n) ? u = 1 : u = At(u), wp(en(i), u);
      }
      function sP() {
        var i = arguments, u = en(i[0]);
        return i.length < 3 ? u : u.replace(i[1], i[2]);
      }
      var lP = tu(function(i, u, p) {
        return i + (p ? "_" : "") + u.toLowerCase();
      });
      function uP(i, u, p) {
        return p && typeof p != "number" && Rr(i, u, p) && (u = p = n), p = p === n ? J : p >>> 0, p ? (i = en(i), i && (typeof u == "string" || u != null && !qp(u)) && (u = lo(u), !u && Ul(i)) ? Zi(Qo(i), 0, p) : i.split(u, p)) : [];
      }
      var cP = tu(function(i, u, p) {
        return i + (p ? " " : "") + Qp(u);
      });
      function dP(i, u, p) {
        return i = en(i), p = p == null ? 0 : Vs(At(p), 0, i.length), u = lo(u), i.slice(p, p + u.length) == u;
      }
      function fP(i, u, p) {
        var S = D.templateSettings;
        p && Rr(i, u, p) && (u = n), i = en(i), u = N0({}, u, S, D7);
        var w = N0({}, u.imports, S.imports, D7), T = cr(w), O = cp(w, T), H, U, he = 0, me = u.interpolate || Hn, ye = "__p += '", Ve = fp(
          (u.escape || Hn).source + "|" + me.source + "|" + (me === Pl ? at : Hn).source + "|" + (u.evaluate || Hn).source + "|$",
          "g"
        ), We = "//# sourceURL=" + (on.call(u, "sourceURL") ? (u.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++zd + "]") + `
`;
        i.replace(Ve, function(st, Tt, Bt, co, Er, fo) {
          return Bt || (Bt = co), ye += i.slice(he, fo).replace(Sa, GL), Tt && (H = !0, ye += `' +
__e(` + Tt + `) +
'`), Er && (U = !0, ye += `';
` + Er + `;
__p += '`), Bt && (ye += `' +
((__t = (` + Bt + `)) == null ? '' : __t) +
'`), he = fo + st.length, st;
        }), ye += `';
`;
        var it = on.call(u, "variable") && u.variable;
        if (!it)
          ye = `with (obj) {
` + ye + `
}
`;
        else if (Ae.test(it))
          throw new vt(l);
        ye = (U ? ye.replace(fc, "") : ye).replace(Ti, "$1").replace(Nl, "$1;"), ye = "function(" + (it || "obj") + `) {
` + (it ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (H ? ", __e = _.escape" : "") + (U ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ye + `return __p
}`;
        var It = M6(function() {
          return qt(T, We + "return " + ye).apply(n, O);
        });
        if (It.source = ye, Yp(It))
          throw It;
        return It;
      }
      function hP(i) {
        return en(i).toLowerCase();
      }
      function pP(i) {
        return en(i).toUpperCase();
      }
      function mP(i, u, p) {
        if (i = en(i), i && (p || u === n))
          return N9(i);
        if (!i || !(u = lo(u)))
          return i;
        var S = Qo(i), w = Qo(u), T = T9(S, w), O = P9(S, w) + 1;
        return Zi(S, T, O).join("");
      }
      function gP(i, u, p) {
        if (i = en(i), i && (p || u === n))
          return i.slice(0, V9(i) + 1);
        if (!i || !(u = lo(u)))
          return i;
        var S = Qo(i), w = P9(S, Qo(u)) + 1;
        return Zi(S, 0, w).join("");
      }
      function vP(i, u, p) {
        if (i = en(i), i && (p || u === n))
          return i.replace(Pi, "");
        if (!i || !(u = lo(u)))
          return i;
        var S = Qo(i), w = T9(S, Qo(u));
        return Zi(S, w).join("");
      }
      function CP(i, u) {
        var p = G, S = j;
        if (Ln(u)) {
          var w = "separator" in u ? u.separator : w;
          p = "length" in u ? At(u.length) : p, S = "omission" in u ? lo(u.omission) : S;
        }
        i = en(i);
        var T = i.length;
        if (Ul(i)) {
          var O = Qo(i);
          T = O.length;
        }
        if (p >= T)
          return i;
        var H = p - Xl(S);
        if (H < 1)
          return S;
        var U = O ? Zi(O, 0, H).join("") : i.slice(0, H);
        if (w === n)
          return U + S;
        if (O && (H += U.length - H), qp(w)) {
          if (i.slice(H).search(w)) {
            var he, me = U;
            for (w.global || (w = fp(w.source, en(St.exec(w)) + "g")), w.lastIndex = 0; he = w.exec(me); )
              var ye = he.index;
            U = U.slice(0, ye === n ? H : ye);
          }
        } else if (i.indexOf(lo(w), H) != H) {
          var Ve = U.lastIndexOf(w);
          Ve > -1 && (U = U.slice(0, Ve));
        }
        return U + S;
      }
      function bP(i) {
        return i = en(i), i && Ls.test(i) ? i.replace(Ao, XL) : i;
      }
      var yP = tu(function(i, u, p) {
        return i + (p ? " " : "") + u.toUpperCase();
      }), Qp = x7("toUpperCase");
      function A6(i, u, p) {
        return i = en(i), u = p ? n : u, u === n ? ZL(i) ? JL(i) : PL(i) : i.match(u) || [];
      }
      var M6 = Rt(function(i, u) {
        try {
          return io(i, n, u);
        } catch (p) {
          return Yp(p) ? p : new vt(p);
        }
      }), SP = Ya(function(i, u) {
        return _o(u, function(p) {
          p = xa(p), Ua(i, p, Up(i[p], i));
        }), i;
      });
      function AP(i) {
        var u = i == null ? 0 : i.length, p = rt();
        return i = u ? xn(i, function(S) {
          if (typeof S[1] != "function")
            throw new Io(s);
          return [p(S[0]), S[1]];
        }) : [], Rt(function(S) {
          for (var w = -1; ++w < u; ) {
            var T = i[w];
            if (io(T[0], this, S))
              return io(T[1], this, S);
          }
        });
      }
      function MP(i) {
        return XR(Lo(i, h));
      }
      function em(i) {
        return function() {
          return i;
        };
      }
      function xP(i, u) {
        return i == null || i !== i ? u : i;
      }
      var _P = I7(), IP = I7(!0);
      function Ur(i) {
        return i;
      }
      function tm(i) {
        return n7(typeof i == "function" ? i : Lo(i, h));
      }
      function wP(i) {
        return o7(Lo(i, h));
      }
      function LP(i, u) {
        return a7(i, Lo(u, h));
      }
      var RP = Rt(function(i, u) {
        return function(p) {
          return Tc(p, i, u);
        };
      }), EP = Rt(function(i, u) {
        return function(p) {
          return Tc(i, p, u);
        };
      });
      function nm(i, u, p) {
        var S = cr(u), w = h0(u, S);
        p == null && !(Ln(u) && (w.length || !S.length)) && (p = u, u = i, i = this, w = h0(u, cr(u)));
        var T = !(Ln(p) && "chain" in p) || !!p.chain, O = Ja(i);
        return _o(w, function(H) {
          var U = u[H];
          i[H] = U, O && (i.prototype[H] = function() {
            var he = this.__chain__;
            if (T || he) {
              var me = i(this.__wrapped__), ye = me.__actions__ = jr(this.__actions__);
              return ye.push({ func: U, args: arguments, thisArg: i }), me.__chain__ = he, me;
            }
            return U.apply(i, Oi([this.value()], arguments));
          });
        }), i;
      }
      function DP() {
        return bt._ === this && (bt._ = rR), this;
      }
      function rm() {
      }
      function NP(i) {
        return i = At(i), Rt(function(u) {
          return i7(u, i);
        });
      }
      var TP = Pp(xn), PP = Pp(w9), kP = Pp(ap);
      function x6(i) {
        return Gp(i) ? ip(xa(i)) : dE(i);
      }
      function VP(i) {
        return function(u) {
          return i == null ? n : Os(i, u);
        };
      }
      var OP = L7(), FP = L7(!0);
      function om() {
        return [];
      }
      function am() {
        return !1;
      }
      function BP() {
        return {};
      }
      function HP() {
        return "";
      }
      function GP() {
        return !0;
      }
      function $P(i, u) {
        if (i = At(i), i < 1 || i > K)
          return [];
        var p = J, S = Cr(i, J);
        u = rt(u), i -= J;
        for (var w = up(S, u); ++p < i; )
          u(p);
        return w;
      }
      function ZP(i) {
        return Ct(i) ? xn(i, xa) : uo(i) ? [i] : jr(j7(en(i)));
      }
      function jP(i) {
        var u = ++tR;
        return en(i) + u;
      }
      var WP = b0(function(i, u) {
        return i + u;
      }, 0), zP = kp("ceil"), UP = b0(function(i, u) {
        return i / u;
      }, 1), XP = kp("floor");
      function YP(i) {
        return i && i.length ? f0(i, Ur, yp) : n;
      }
      function qP(i, u) {
        return i && i.length ? f0(i, rt(u, 2), yp) : n;
      }
      function JP(i) {
        return E9(i, Ur);
      }
      function KP(i, u) {
        return E9(i, rt(u, 2));
      }
      function QP(i) {
        return i && i.length ? f0(i, Ur, xp) : n;
      }
      function ek(i, u) {
        return i && i.length ? f0(i, rt(u, 2), xp) : n;
      }
      var tk = b0(function(i, u) {
        return i * u;
      }, 1), nk = kp("round"), rk = b0(function(i, u) {
        return i - u;
      }, 0);
      function ok(i) {
        return i && i.length ? lp(i, Ur) : 0;
      }
      function ak(i, u) {
        return i && i.length ? lp(i, rt(u, 2)) : 0;
      }
      return D.after = wN, D.ary = t6, D.assign = pT, D.assignIn = m6, D.assignInWith = N0, D.assignWith = mT, D.at = gT, D.before = n6, D.bind = Up, D.bindAll = SP, D.bindKey = r6, D.castArray = BN, D.chain = K7, D.chunk = XE, D.compact = YE, D.concat = qE, D.cond = AP, D.conforms = MP, D.constant = em, D.countBy = oN, D.create = vT, D.curry = o6, D.curryRight = a6, D.debounce = i6, D.defaults = CT, D.defaultsDeep = bT, D.defer = LN, D.delay = RN, D.difference = JE, D.differenceBy = KE, D.differenceWith = QE, D.drop = eD, D.dropRight = tD, D.dropRightWhile = nD, D.dropWhile = rD, D.fill = oD, D.filter = iN, D.flatMap = uN, D.flatMapDeep = cN, D.flatMapDepth = dN, D.flatten = X7, D.flattenDeep = aD, D.flattenDepth = iD, D.flip = EN, D.flow = _P, D.flowRight = IP, D.fromPairs = sD, D.functions = IT, D.functionsIn = wT, D.groupBy = fN, D.initial = uD, D.intersection = cD, D.intersectionBy = dD, D.intersectionWith = fD, D.invert = RT, D.invertBy = ET, D.invokeMap = pN, D.iteratee = tm, D.keyBy = mN, D.keys = cr, D.keysIn = zr, D.map = I0, D.mapKeys = NT, D.mapValues = TT, D.matches = wP, D.matchesProperty = LP, D.memoize = L0, D.merge = PT, D.mergeWith = g6, D.method = RP, D.methodOf = EP, D.mixin = nm, D.negate = R0, D.nthArg = NP, D.omit = kT, D.omitBy = VT, D.once = DN, D.orderBy = gN, D.over = TP, D.overArgs = NN, D.overEvery = PP, D.overSome = kP, D.partial = Xp, D.partialRight = s6, D.partition = vN, D.pick = OT, D.pickBy = v6, D.property = x6, D.propertyOf = VP, D.pull = gD, D.pullAll = q7, D.pullAllBy = vD, D.pullAllWith = CD, D.pullAt = bD, D.range = OP, D.rangeRight = FP, D.rearg = TN, D.reject = yN, D.remove = yD, D.rest = PN, D.reverse = Wp, D.sampleSize = AN, D.set = BT, D.setWith = HT, D.shuffle = MN, D.slice = SD, D.sortBy = IN, D.sortedUniq = LD, D.sortedUniqBy = RD, D.split = uP, D.spread = kN, D.tail = ED, D.take = DD, D.takeRight = ND, D.takeRightWhile = TD, D.takeWhile = PD, D.tap = YD, D.throttle = VN, D.thru = _0, D.toArray = f6, D.toPairs = C6, D.toPairsIn = b6, D.toPath = ZP, D.toPlainObject = p6, D.transform = GT, D.unary = ON, D.union = kD, D.unionBy = VD, D.unionWith = OD, D.uniq = FD, D.uniqBy = BD, D.uniqWith = HD, D.unset = $T, D.unzip = zp, D.unzipWith = J7, D.update = ZT, D.updateWith = jT, D.values = ou, D.valuesIn = WT, D.without = GD, D.words = A6, D.wrap = FN, D.xor = $D, D.xorBy = ZD, D.xorWith = jD, D.zip = WD, D.zipObject = zD, D.zipObjectDeep = UD, D.zipWith = XD, D.entries = C6, D.entriesIn = b6, D.extend = m6, D.extendWith = N0, nm(D, D), D.add = WP, D.attempt = M6, D.camelCase = YT, D.capitalize = y6, D.ceil = zP, D.clamp = zT, D.clone = HN, D.cloneDeep = $N, D.cloneDeepWith = ZN, D.cloneWith = GN, D.conformsTo = jN, D.deburr = S6, D.defaultTo = xP, D.divide = UP, D.endsWith = qT, D.eq = ta, D.escape = JT, D.escapeRegExp = KT, D.every = aN, D.find = sN, D.findIndex = z7, D.findKey = yT, D.findLast = lN, D.findLastIndex = U7, D.findLastKey = ST, D.floor = XP, D.forEach = Q7, D.forEachRight = e6, D.forIn = AT, D.forInRight = MT, D.forOwn = xT, D.forOwnRight = _T, D.get = Jp, D.gt = WN, D.gte = zN, D.has = LT, D.hasIn = Kp, D.head = Y7, D.identity = Ur, D.includes = hN, D.indexOf = lD, D.inRange = UT, D.invoke = DT, D.isArguments = Hs, D.isArray = Ct, D.isArrayBuffer = UN, D.isArrayLike = Wr, D.isArrayLikeObject = Gn, D.isBoolean = XN, D.isBuffer = ji, D.isDate = YN, D.isElement = qN, D.isEmpty = JN, D.isEqual = KN, D.isEqualWith = QN, D.isError = Yp, D.isFinite = eT, D.isFunction = Ja, D.isInteger = l6, D.isLength = E0, D.isMap = u6, D.isMatch = tT, D.isMatchWith = nT, D.isNaN = rT, D.isNative = oT, D.isNil = iT, D.isNull = aT, D.isNumber = c6, D.isObject = Ln, D.isObjectLike = kn, D.isPlainObject = Bc, D.isRegExp = qp, D.isSafeInteger = sT, D.isSet = d6, D.isString = D0, D.isSymbol = uo, D.isTypedArray = ru, D.isUndefined = lT, D.isWeakMap = uT, D.isWeakSet = cT, D.join = hD, D.kebabCase = QT, D.last = Eo, D.lastIndexOf = pD, D.lowerCase = eP, D.lowerFirst = tP, D.lt = dT, D.lte = fT, D.max = YP, D.maxBy = qP, D.mean = JP, D.meanBy = KP, D.min = QP, D.minBy = ek, D.stubArray = om, D.stubFalse = am, D.stubObject = BP, D.stubString = HP, D.stubTrue = GP, D.multiply = tk, D.nth = mD, D.noConflict = DP, D.noop = rm, D.now = w0, D.pad = nP, D.padEnd = rP, D.padStart = oP, D.parseInt = aP, D.random = XT, D.reduce = CN, D.reduceRight = bN, D.repeat = iP, D.replace = sP, D.result = FT, D.round = nk, D.runInContext = W, D.sample = SN, D.size = xN, D.snakeCase = lP, D.some = _N, D.sortedIndex = AD, D.sortedIndexBy = MD, D.sortedIndexOf = xD, D.sortedLastIndex = _D, D.sortedLastIndexBy = ID, D.sortedLastIndexOf = wD, D.startCase = cP, D.startsWith = dP, D.subtract = rk, D.sum = ok, D.sumBy = ak, D.template = fP, D.times = $P, D.toFinite = Ka, D.toInteger = At, D.toLength = h6, D.toLower = hP, D.toNumber = Do, D.toSafeInteger = hT, D.toString = en, D.toUpper = pP, D.trim = mP, D.trimEnd = gP, D.trimStart = vP, D.truncate = CP, D.unescape = bP, D.uniqueId = jP, D.upperCase = yP, D.upperFirst = Qp, D.each = Q7, D.eachRight = e6, D.first = Y7, nm(D, function() {
        var i = {};
        return Aa(D, function(u, p) {
          on.call(D.prototype, p) || (i[p] = u);
        }), i;
      }(), { chain: !1 }), D.VERSION = r, _o(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(i) {
        D[i].placeholder = D;
      }), _o(["drop", "take"], function(i, u) {
        kt.prototype[i] = function(p) {
          p = p === n ? 1 : tr(At(p), 0);
          var S = this.__filtered__ && !u ? new kt(this) : this.clone();
          return S.__filtered__ ? S.__takeCount__ = Cr(p, S.__takeCount__) : S.__views__.push({
            size: Cr(p, J),
            type: i + (S.__dir__ < 0 ? "Right" : "")
          }), S;
        }, kt.prototype[i + "Right"] = function(p) {
          return this.reverse()[i](p).reverse();
        };
      }), _o(["filter", "map", "takeWhile"], function(i, u) {
        var p = u + 1, S = p == le || p == ve;
        kt.prototype[i] = function(w) {
          var T = this.clone();
          return T.__iteratees__.push({
            iteratee: rt(w, 3),
            type: p
          }), T.__filtered__ = T.__filtered__ || S, T;
        };
      }), _o(["head", "last"], function(i, u) {
        var p = "take" + (u ? "Right" : "");
        kt.prototype[i] = function() {
          return this[p](1).value()[0];
        };
      }), _o(["initial", "tail"], function(i, u) {
        var p = "drop" + (u ? "" : "Right");
        kt.prototype[i] = function() {
          return this.__filtered__ ? new kt(this) : this[p](1);
        };
      }), kt.prototype.compact = function() {
        return this.filter(Ur);
      }, kt.prototype.find = function(i) {
        return this.filter(i).head();
      }, kt.prototype.findLast = function(i) {
        return this.reverse().find(i);
      }, kt.prototype.invokeMap = Rt(function(i, u) {
        return typeof i == "function" ? new kt(this) : this.map(function(p) {
          return Tc(p, i, u);
        });
      }), kt.prototype.reject = function(i) {
        return this.filter(R0(rt(i)));
      }, kt.prototype.slice = function(i, u) {
        i = At(i);
        var p = this;
        return p.__filtered__ && (i > 0 || u < 0) ? new kt(p) : (i < 0 ? p = p.takeRight(-i) : i && (p = p.drop(i)), u !== n && (u = At(u), p = u < 0 ? p.dropRight(-u) : p.take(u - i)), p);
      }, kt.prototype.takeRightWhile = function(i) {
        return this.reverse().takeWhile(i).reverse();
      }, kt.prototype.toArray = function() {
        return this.take(J);
      }, Aa(kt.prototype, function(i, u) {
        var p = /^(?:filter|find|map|reject)|While$/.test(u), S = /^(?:head|last)$/.test(u), w = D[S ? "take" + (u == "last" ? "Right" : "") : u], T = S || /^find/.test(u);
        w && (D.prototype[u] = function() {
          var O = this.__wrapped__, H = S ? [1] : arguments, U = O instanceof kt, he = H[0], me = U || Ct(O), ye = function(Tt) {
            var Bt = w.apply(D, Oi([Tt], H));
            return S && Ve ? Bt[0] : Bt;
          };
          me && p && typeof he == "function" && he.length != 1 && (U = me = !1);
          var Ve = this.__chain__, We = !!this.__actions__.length, it = T && !Ve, It = U && !We;
          if (!T && me) {
            O = It ? O : new kt(this);
            var st = i.apply(O, H);
            return st.__actions__.push({ func: _0, args: [ye], thisArg: n }), new wo(st, Ve);
          }
          return it && It ? i.apply(this, H) : (st = this.thru(ye), it ? S ? st.value()[0] : st.value() : st);
        });
      }), _o(["pop", "push", "shift", "sort", "splice", "unshift"], function(i) {
        var u = Jd[i], p = /^(?:push|sort|unshift)$/.test(i) ? "tap" : "thru", S = /^(?:pop|shift)$/.test(i);
        D.prototype[i] = function() {
          var w = arguments;
          if (S && !this.__chain__) {
            var T = this.value();
            return u.apply(Ct(T) ? T : [], w);
          }
          return this[p](function(O) {
            return u.apply(Ct(O) ? O : [], w);
          });
        };
      }), Aa(kt.prototype, function(i, u) {
        var p = D[u];
        if (p) {
          var S = p.name + "";
          on.call(Kl, S) || (Kl[S] = []), Kl[S].push({ name: u, func: p });
        }
      }), Kl[C0(n, _).name] = [{
        name: "wrapper",
        func: n
      }], kt.prototype.clone = bR, kt.prototype.reverse = yR, kt.prototype.value = SR, D.prototype.at = qD, D.prototype.chain = JD, D.prototype.commit = KD, D.prototype.next = QD, D.prototype.plant = tN, D.prototype.reverse = nN, D.prototype.toJSON = D.prototype.valueOf = D.prototype.value = rN, D.prototype.first = D.prototype.head, Ic && (D.prototype[Ic] = eN), D;
    }, Yl = KL();
    Ut ? ((Ut.exports = Yl)._ = Yl, Lt._ = Yl) : bt._ = Yl;
  }).call(ai);
})(vf, vf.exports);
var ph = vf.exports;
const h1 = /* @__PURE__ */ jf(ph);
function bne(e, t) {
  var n = Mne(t);
  return n.formatToParts ? Sne(n, e) : Ane(n, e);
}
var yne = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function Sne(e, t) {
  try {
    for (var n = e.formatToParts(t), r = [], o = 0; o < n.length; o++) {
      var a = yne[n[o].type];
      a >= 0 && (r[a] = parseInt(n[o].value, 10));
    }
    return r;
  } catch (s) {
    if (s instanceof RangeError)
      return [NaN];
    throw s;
  }
}
function Ane(e, t) {
  var n = e.format(t), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var s5 = {};
function Mne(e) {
  if (!s5[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    s5[e] = n ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return s5[e];
}
function Jx(e, t, n, r, o, a, s) {
  var l = /* @__PURE__ */ new Date(0);
  return l.setUTCFullYear(e, t, n), l.setUTCHours(r, o, a, s), l;
}
var vC = 36e5, xne = 6e4, l5 = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function _ne(e, t, n) {
  var r, o;
  if (!e || (r = l5.timezoneZ.exec(e), r))
    return 0;
  var a;
  if (r = l5.timezoneHH.exec(e), r)
    return a = parseInt(r[1], 10), CC(a) ? -(a * vC) : NaN;
  if (r = l5.timezoneHHMM.exec(e), r) {
    a = parseInt(r[2], 10);
    var s = parseInt(r[3], 10);
    return CC(a, s) ? (o = Math.abs(a) * vC + s * xne, r[1] === "+" ? -o : o) : NaN;
  }
  if (Lne(e)) {
    t = new Date(t || Date.now());
    var l = n ? t : Ine(t), c = E3(l, e), d = n ? c : wne(t, c, e);
    return -d;
  }
  return NaN;
}
function Ine(e) {
  return Jx(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function E3(e, t) {
  var n = bne(e, t), r = Jx(
    n[0],
    n[1] - 1,
    n[2],
    n[3] % 24,
    n[4],
    n[5],
    0
  ).getTime(), o = e.getTime(), a = o % 1e3;
  return o -= a >= 0 ? a : 1e3 + a, r - o;
}
function wne(e, t, n) {
  var r = e.getTime(), o = r - t, a = E3(new Date(o), n);
  if (t === a)
    return t;
  o -= a - t;
  var s = E3(new Date(o), n);
  return a === s ? a : Math.max(a, s);
}
function CC(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var bC = {};
function Lne(e) {
  if (bC[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), bC[e] = !0, !0;
  } catch {
    return !1;
  }
}
function yC(e, t) {
  return -_ne(e, t);
}
var Rne = Object.create, T4 = Object.defineProperty, Ene = Object.getOwnPropertyDescriptor, Kx = Object.getOwnPropertyNames, Dne = Object.getPrototypeOf, Nne = Object.prototype.hasOwnProperty, Tne = /* @__PURE__ */ ((e) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(e, {
  get: (t, n) => (typeof require < "u" ? require : t)[n]
}) : e)(function(e) {
  if (typeof require < "u")
    return require.apply(this, arguments);
  throw Error('Dynamic require of "' + e + '" is not supported');
}), va = (e, t) => function() {
  return t || (0, e[Kx(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, pd = (e, t) => {
  for (var n in t)
    T4(e, n, { get: t[n], enumerable: !0 });
}, Pne = (e, t, n, r) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let o of Kx(t))
      !Nne.call(e, o) && o !== n && T4(e, o, { get: () => t[o], enumerable: !(r = Ene(t, o)) || r.enumerable });
  return e;
}, re = (e, t, n) => (n = e != null ? Rne(Dne(e)) : {}, Pne(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? T4(n, "default", { value: e, enumerable: !0 }) : n,
  e
)), kne = va({
  "../shared-utils/lib/distinct.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
  }
}), yl = va({
  "../shared-utils/lib/is.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.isNull = e.isUndefined = e.isSymbol = e.isFunction = e.isObject = e.isString = e.isNumber = e.isBoolean = e.getPrimitiveType = void 0;
    var t = "Object", n = (h) => Object.prototype.toString.call(h).slice(8, -1);
    e.getPrimitiveType = n;
    var r = (h) => (m) => (0, e.getPrimitiveType)(m) === h, o = (h) => typeof h == "boolean";
    e.isBoolean = o;
    var a = (h) => typeof h == "number" && !isNaN(h);
    e.isNumber = a;
    var s = (h) => typeof h == "string";
    e.isString = s, e.isObject = r(t);
    var l = (h) => typeof h == "function";
    e.isFunction = l;
    var c = (h) => typeof h == "symbol";
    e.isSymbol = c;
    var d = (h) => h === void 0;
    e.isUndefined = d;
    var f = (h) => h === null;
    e.isNull = f;
  }
}), Vne = va({
  "../shared-utils/lib/checkLength.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.checkLength = t;
    function t(n, r, o = "Incorrect array size") {
      if (r.length !== n)
        throw new Error(`${o} (expected ${n}, got ${r.length})`);
      return r;
    }
  }
}), One = va({
  "../shared-utils/lib/checkMinLength.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.checkMinLength = t;
    function t(n, r, o = "Array size too small") {
      if (r.length < n)
        throw new Error(`${o} (expected ${n}, got ${r.length})`);
      return r;
    }
  }
}), Fne = va({
  "../shared-utils/lib/enumerate.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.enumerate = t;
    function* t(n) {
      let r = 0;
      for (const o of n)
        yield [r, o], r += 1;
    }
  }
}), Bne = va({
  "../shared-utils/lib/hasDefinedValues.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.hasDefinedValues = n;
    var t = yl();
    function n(r) {
      return Object.values(r).some((o) => !(0, t.isUndefined)(o));
    }
  }
}), Hne = va({
  "../shared-utils/lib/toTitleCase.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.toTitleCase = t;
    function t(n) {
      return n.replace(/\w\S*/g, (r) => r.charAt(0).toUpperCase() + r.substr(1).toLowerCase());
    }
  }
}), ce = va({
  "../shared-utils/lib/index.js"(e) {
    var t = e && e.__createBinding || (Object.create ? function(N, P, F, G) {
      G === void 0 && (G = F);
      var j = Object.getOwnPropertyDescriptor(P, F);
      (!j || ("get" in j ? !P.__esModule : j.writable || j.configurable)) && (j = { enumerable: !0, get: function() {
        return P[F];
      } }), Object.defineProperty(N, G, j);
    } : function(N, P, F, G) {
      G === void 0 && (G = F), N[G] = P[F];
    }), n = e && e.__exportStar || function(N, P) {
      for (var F in N)
        F !== "default" && !Object.prototype.hasOwnProperty.call(P, F) && t(P, N, F);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.noop = e.memoize = e.toPunctuatedPhoneFormat = e.GDRIVE_REGEX = e.URL_REGEX = e.PHONE_REGEX = e.EMAIL_REGEX = e.unreachable = e.toTitleCase = e.isUndefined = void 0, e.linJitter = s, e.clamp = l, e.populated = d, e.isObject = f, e.difference = h, e.isDefined = m, e.expected = g, e.orNull = C, e.orUndefined = y, e.applyIfNonEmptyString = _, e.isNonEmptyString = x, e.makeLookup = E, kne();
    var r = yl();
    n(Vne(), e), n(One(), e), n(Fne(), e), n(Bne(), e);
    var o = yl();
    Object.defineProperty(e, "isUndefined", { enumerable: !0, get: function() {
      return o.isUndefined;
    } });
    var a = Hne();
    Object.defineProperty(e, "toTitleCase", { enumerable: !0, get: function() {
      return a.toTitleCase;
    } });
    function s(N, P) {
      return N + Math.random() * (P - N);
    }
    function l(N, P, F) {
      return Math.min(F ?? 1 / 0, Math.max(N, P ?? -1 / 0));
    }
    var c = (N) => {
      throw console.warn(N), new Error(`unexpected: ${N}`);
    };
    e.unreachable = c;
    function d(N) {
      if (N !== null && typeof N == "object") {
        for (const P in N)
          if (N[P] !== void 0)
            return !0;
      }
      return !1;
    }
    function f(N) {
      return typeof N == "object" && N !== null && !Array.isArray(N);
    }
    function h(N, P) {
      const F = new Set(N);
      for (const G of P)
        F.delete(G);
      return F;
    }
    function m(N) {
      return N !== void 0;
    }
    function g(N, P = "expected a defined value") {
      if (N == null)
        throw new Error(`${P} (got ${N})`);
      return N;
    }
    e.EMAIL_REGEX = /^[^@]*@.*\..*$/, e.PHONE_REGEX = /^\+1[1-9]\d{1,14}$/, e.URL_REGEX = /^https:\/\/.*$/, e.GDRIVE_REGEX = /https:\/\/drive.google.com\/drive\/.+/;
    var b = (N) => {
      const P = N == null ? void 0 : N.match(/([0-9]{3})([0-9]{3})([0-9]{4})$/);
      return P ? `(${P[1]}) ${P[2]}-${P[3]}` : N;
    };
    e.toPunctuatedPhoneFormat = b;
    function C(N) {
      return (P) => P !== null ? N(P) : null;
    }
    function y(N) {
      return (P) => P !== void 0 ? N(P) : void 0;
    }
    function _(N) {
      return y((P) => P.trim() === "" ? void 0 : N(P));
    }
    function x(N) {
      return N != null && N.trim() !== "";
    }
    var I = {}, R = (N, P, F) => {
      if (P.every((ae, ue) => {
        var le;
        return ae === ((le = I[F]) === null || le === void 0 ? void 0 : le.deps[ue]);
      }, !0))
        return I[F].value;
      const j = N();
      return I[F] = {
        deps: P,
        value: j
      }, j;
    };
    e.memoize = R;
    function E({ cases: N, default: P, errorMsg: F }) {
      const G = N.flatMap((ae) => {
        const [ue, le] = ae;
        return Array.isArray(ue) ? ue.map((_e) => [_e, le]) : [ae];
      }), j = Object.fromEntries(G);
      return (ae) => {
        const ue = j[ae];
        if (m(ue))
          return ue;
        if (m(P))
          return P;
        if ((0, r.isString)(F))
          throw new Error(F);
        const le = Object.keys(j), _e = String(ae);
        if ((0, r.isFunction)(F))
          throw new Error(F(_e, le));
        const ve = new Intl.ListFormat("en", { type: "disjunction" }).format(le);
        throw new Error(`Invalid case: ${_e}.
Expected one of: ${ve}`);
      };
    }
    var k = () => {
    };
    e.noop = k;
  }
}), P4 = va({
  "../shared-utils/lib/lens.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Iso = e.Lens = void 0, e.identityLens = r, e.propertyLens = o, e.arrayLens = a, e.arrayFindLens = s, e.arrayFindDeleteLens = l;
    var t = class D3 {
      /**
       * Constructs a new FullLens from the given getter and setter pair.
       */
      constructor(f, h) {
        this.get = f, this.set = h;
      }
      /**
       * Lenses can be concatenated/pipelined/composed/etc, whatever your
       * preferred terminology is. We "zoom in" with the first lens, and then
       * "zoom in" with the second lens. For example, suppose we have a
       * Map<string, Request>. We can concatenate a lens that zooms in on a
       * specific key of this map to a lens that zooms in on a property of Request
       * to get a lens that zooms in on that property within the whole map.
       *
       * This is probably the trickiest code in this whole file. If you understand
       * it, you understand lenses. If you really want to make sure you understand
       * it, delete the code below and see if you can implement it yourself. If
       * working with FullLens is too hard, try using the simpler Lens type first.
       *
       * This is defined as a class method to make it easier to concatenate
       * multiple lenses in a row.
       */
      concat(f) {
        return new D3((h) => f.get(this.get(h)), (h, m) => this.set(h, f.set(this.get(h), m)));
      }
      /**
       * Converts a lens from a container S to an item A into a lens from arrays
       * of containers S to arrays of items A. When setting, the new array MUST be
       * the same length as the old one.
       */
      overArray() {
        return new D3((f) => f.map(this.get), (f, h) => {
          if (f.length !== h.length) {
            const m = `got ${h.length}, need ${f.length}`;
            throw new Error(`FullLens.mapped() input wrong length (${m})`);
          }
          return f.map((m, g) => this.set(m, h[g]));
        });
      }
      /**
       * Applies a function to transform the value the lens points at.
       */
      map(f, h) {
        return this.set(f, h(this.get(f)));
      }
      /**
       * Adapt this lens to a simplified version of the React useState-style API.
       * Returns a new value and setter callback.
       *
       *     const [house, setHouse] = useState(initHouse);
       *     const [addr, setAddr] = houseAddressLens.adaptReact(house, setHouse);
       */
      adaptReact(f, h) {
        return [this.get(f), (m) => h(this.set(f, m))];
      }
    }, n = class extends t {
    };
    e.Lens = n;
    function r() {
      return new n((d) => d, (d, f) => f);
    }
    function o(d) {
      return new n((f) => f[d], (f, h) => Object.assign(Object.assign({}, f), { [d]: h }));
    }
    function a(...d) {
      return new t((f) => d.map((h) => h.get(f)), (f, h) => {
        if (h.length != d.length) {
          const m = `got ${h.length}, need ${d.length}`;
          throw new Error(`arrayLens().set() input wrong length (${m})`);
        }
        return h.reduce((m, g, b) => d[b].set(m, g), f);
      });
    }
    function s(d) {
      return new t((f) => f.find(d), (f, h) => {
        const m = f.findIndex(d);
        return m === -1 ? [...f, h] : [...f.slice(0, m), h, ...f.slice(m + 1)];
      });
    }
    function l(d) {
      return new n((f) => f.find(d), (f, h) => {
        if (h === void 0)
          return f.filter((g) => !d(g));
        const m = f.findIndex(d);
        return m === -1 ? [...f, h] : [...f.slice(0, m), h, ...f.slice(m + 1)];
      });
    }
    var c = class {
      constructor(d, f) {
        this.fwd = d, this.inv = f;
      }
      /**
       * Converts this isomorphism into a lens, which is useful for inserting an
       * isomorphism into Lens.concat()
       */
      toLens() {
        return new n(this.fwd, (d, f) => this.inv(f));
      }
    };
    e.Iso = c;
  }
}), mh = va({
  "../shared-utils/lib/enum.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.AloftEnum = t;
    function t() {
      return (n) => {
        const r = Object.keys(n);
        if (r.length === 0)
          throw new Error("AloftEnum requires at least one enum variant");
        return Object.assign(Object.assign({}, n), { _keys: r, _values: Object.values(n), _isKey: (o) => o in n, _index: (o) => Object.keys(n).findIndex((a) => o === a) });
      };
    }
  }
}), Gne = va({
  "../../node_modules/pluralize/pluralize.js"(e, t) {
    (function(n, r) {
      typeof Tne == "function" && typeof e == "object" && typeof t == "object" ? t.exports = r() : typeof define == "function" && define.amd ? define(function() {
        return r();
      }) : n.pluralize = r();
    })(e, function() {
      var n = [], r = [], o = {}, a = {}, s = {};
      function l(C) {
        return typeof C == "string" ? new RegExp("^" + C + "$", "i") : C;
      }
      function c(C, y) {
        return C === y ? y : C === C.toLowerCase() ? y.toLowerCase() : C === C.toUpperCase() ? y.toUpperCase() : C[0] === C[0].toUpperCase() ? y.charAt(0).toUpperCase() + y.substr(1).toLowerCase() : y.toLowerCase();
      }
      function d(C, y) {
        return C.replace(/\$(\d{1,2})/g, function(_, x) {
          return y[x] || "";
        });
      }
      function f(C, y) {
        return C.replace(y[0], function(_, x) {
          var I = d(y[1], arguments);
          return c(_ === "" ? C[x - 1] : _, I);
        });
      }
      function h(C, y, _) {
        if (!C.length || o.hasOwnProperty(C))
          return y;
        for (var x = _.length; x--; ) {
          var I = _[x];
          if (I[0].test(y))
            return f(y, I);
        }
        return y;
      }
      function m(C, y, _) {
        return function(x) {
          var I = x.toLowerCase();
          return y.hasOwnProperty(I) ? c(x, I) : C.hasOwnProperty(I) ? c(x, C[I]) : h(I, x, _);
        };
      }
      function g(C, y, _, x) {
        return function(I) {
          var R = I.toLowerCase();
          return y.hasOwnProperty(R) ? !0 : C.hasOwnProperty(R) ? !1 : h(R, R, _) === R;
        };
      }
      function b(C, y, _) {
        var x = y === 1 ? b.singular(C) : b.plural(C);
        return (_ ? y + " " : "") + x;
      }
      return b.plural = m(
        s,
        a,
        n
      ), b.isPlural = g(
        s,
        a,
        n
      ), b.singular = m(
        a,
        s,
        r
      ), b.isSingular = g(
        a,
        s,
        r
      ), b.addPluralRule = function(C, y) {
        n.push([l(C), y]);
      }, b.addSingularRule = function(C, y) {
        r.push([l(C), y]);
      }, b.addUncountableRule = function(C) {
        if (typeof C == "string") {
          o[C.toLowerCase()] = !0;
          return;
        }
        b.addPluralRule(C, "$0"), b.addSingularRule(C, "$0");
      }, b.addIrregularRule = function(C, y) {
        y = y.toLowerCase(), C = C.toLowerCase(), s[C] = y, a[y] = C;
      }, [
        // Pronouns.
        ["I", "we"],
        ["me", "us"],
        ["he", "they"],
        ["she", "they"],
        ["them", "them"],
        ["myself", "ourselves"],
        ["yourself", "yourselves"],
        ["itself", "themselves"],
        ["herself", "themselves"],
        ["himself", "themselves"],
        ["themself", "themselves"],
        ["is", "are"],
        ["was", "were"],
        ["has", "have"],
        ["this", "these"],
        ["that", "those"],
        // Words ending in with a consonant and `o`.
        ["echo", "echoes"],
        ["dingo", "dingoes"],
        ["volcano", "volcanoes"],
        ["tornado", "tornadoes"],
        ["torpedo", "torpedoes"],
        // Ends with `us`.
        ["genus", "genera"],
        ["viscus", "viscera"],
        // Ends with `ma`.
        ["stigma", "stigmata"],
        ["stoma", "stomata"],
        ["dogma", "dogmata"],
        ["lemma", "lemmata"],
        ["schema", "schemata"],
        ["anathema", "anathemata"],
        // Other irregular rules.
        ["ox", "oxen"],
        ["axe", "axes"],
        ["die", "dice"],
        ["yes", "yeses"],
        ["foot", "feet"],
        ["eave", "eaves"],
        ["goose", "geese"],
        ["tooth", "teeth"],
        ["quiz", "quizzes"],
        ["human", "humans"],
        ["proof", "proofs"],
        ["carve", "carves"],
        ["valve", "valves"],
        ["looey", "looies"],
        ["thief", "thieves"],
        ["groove", "grooves"],
        ["pickaxe", "pickaxes"],
        ["passerby", "passersby"]
      ].forEach(function(C) {
        return b.addIrregularRule(C[0], C[1]);
      }), [
        [/s?$/i, "s"],
        [/[^\u0000-\u007F]$/i, "$0"],
        [/([^aeiou]ese)$/i, "$1"],
        [/(ax|test)is$/i, "$1es"],
        [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"],
        [/(e[mn]u)s?$/i, "$1s"],
        [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"],
        [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1i"],
        [/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"],
        [/(seraph|cherub)(?:im)?$/i, "$1im"],
        [/(her|at|gr)o$/i, "$1oes"],
        [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, "$1a"],
        [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, "$1a"],
        [/sis$/i, "ses"],
        [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"],
        [/([^aeiouy]|qu)y$/i, "$1ies"],
        [/([^ch][ieo][ln])ey$/i, "$1ies"],
        [/(x|ch|ss|sh|zz)$/i, "$1es"],
        [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"],
        [/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"],
        [/(pe)(?:rson|ople)$/i, "$1ople"],
        [/(child)(?:ren)?$/i, "$1ren"],
        [/eaux$/i, "$0"],
        [/m[ae]n$/i, "men"],
        ["thou", "you"]
      ].forEach(function(C) {
        return b.addPluralRule(C[0], C[1]);
      }), [
        [/s$/i, ""],
        [/(ss)$/i, "$1"],
        [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"],
        [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"],
        [/ies$/i, "y"],
        [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, "$1ie"],
        [/\b(mon|smil)ies$/i, "$1ey"],
        [/\b((?:tit)?m|l)ice$/i, "$1ouse"],
        [/(seraph|cherub)im$/i, "$1"],
        [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, "$1"],
        [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, "$1sis"],
        [/(movie|twelve|abuse|e[mn]u)s$/i, "$1"],
        [/(test)(?:is|es)$/i, "$1is"],
        [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1us"],
        [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, "$1um"],
        [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, "$1on"],
        [/(alumn|alg|vertebr)ae$/i, "$1a"],
        [/(cod|mur|sil|vert|ind)ices$/i, "$1ex"],
        [/(matr|append)ices$/i, "$1ix"],
        [/(pe)(rson|ople)$/i, "$1rson"],
        [/(child)ren$/i, "$1"],
        [/(eau)x?$/i, "$1"],
        [/men$/i, "man"]
      ].forEach(function(C) {
        return b.addSingularRule(C[0], C[1]);
      }), [
        // Singular words with no plurals.
        "adulthood",
        "advice",
        "agenda",
        "aid",
        "aircraft",
        "alcohol",
        "ammo",
        "analytics",
        "anime",
        "athletics",
        "audio",
        "bison",
        "blood",
        "bream",
        "buffalo",
        "butter",
        "carp",
        "cash",
        "chassis",
        "chess",
        "clothing",
        "cod",
        "commerce",
        "cooperation",
        "corps",
        "debris",
        "diabetes",
        "digestion",
        "elk",
        "energy",
        "equipment",
        "excretion",
        "expertise",
        "firmware",
        "flounder",
        "fun",
        "gallows",
        "garbage",
        "graffiti",
        "hardware",
        "headquarters",
        "health",
        "herpes",
        "highjinks",
        "homework",
        "housework",
        "information",
        "jeans",
        "justice",
        "kudos",
        "labour",
        "literature",
        "machinery",
        "mackerel",
        "mail",
        "media",
        "mews",
        "moose",
        "music",
        "mud",
        "manga",
        "news",
        "only",
        "personnel",
        "pike",
        "plankton",
        "pliers",
        "police",
        "pollution",
        "premises",
        "rain",
        "research",
        "rice",
        "salmon",
        "scissors",
        "series",
        "sewage",
        "shambles",
        "shrimp",
        "software",
        "species",
        "staff",
        "swine",
        "tennis",
        "traffic",
        "transportation",
        "trout",
        "tuna",
        "wealth",
        "welfare",
        "whiting",
        "wildebeest",
        "wildlife",
        "you",
        /pok[eé]mon$/i,
        // Regexes.
        /[^aeiou]ese$/i,
        // "chinese", "japanese"
        /deer$/i,
        // "deer", "reindeer"
        /fish$/i,
        // "fish", "blowfish", "angelfish"
        /measles$/i,
        /o[iu]s$/i,
        // "carnivorous"
        /pox$/i,
        // "chickpox", "smallpox"
        /sheep$/i
      ].forEach(b.addUncountableRule), b;
    });
  }
}), gr = re(ce(), 1), Ms = re(yl(), 1);
re(P4(), 1);
var $ne = {};
pd($ne, {
  BLOB_ID_REGEX: () => Qx,
  equals: () => Wne,
  fromMetadata: () => jne,
  getExtension: () => zne
});
var Zne = re(ce(), 1), Qx = /b-[0-9a-f]{40}/;
function jne(e, t) {
  return {
    $type: "AloftToolkitBlob",
    id: e,
    type: t.type,
    name: t.name,
    size: t.size,
    createdAt: t.createdAt,
    createdBy: t.createdBy,
    annotation: t.annotation
  };
}
function Wne(e, t) {
  return e.id === t.id;
}
function zne(e) {
  var n;
  const t = ((n = e.name) == null ? void 0 : n.split(".")) ?? [];
  return t.length >= 2 ? (0, Zne.expected)(t[t.length - 1]).toLowerCase() : void 0;
}
var k4 = v().regex(Qx).brand("BlobID"), os = M({
  blobID: k4,
  filename: v()
}), Une = {};
pd(Une, {
  equals: () => qne,
  fromToolkitAccountID: () => Jne,
  schAloftToolkitAccount: () => Yne,
  toToolkitAccountID: () => Kne
});
var oc = v(), In = v(), _i = v();
v();
var e_ = M({
  self: v().optional(),
  next: v().optional(),
  limit: L().optional(),
  totalCount: L().optional(),
  numResults: L().optional()
}), Xne = M({
  id: oc
}), Yne = Ot({
  $type: ie("AloftToolkitAccount")
}).and(Xne), qne = h1.isEqual, Jne = (e) => ({
  $type: "AloftToolkitAccount",
  id: e
}), Kne = (e) => e.id, V4 = re(mh(), 1), Ll = Ot({
  AddressLineText: v(),
  CityName: v(),
  PostalCode: v(),
  StateCode: v(),
  unitNumber: v().optional(),
  CountyName: v().optional()
}), t_ = M({
  latitude: L(),
  longitude: L()
}), n_ = be([
  "Weekly",
  "Bi-Monthly",
  "Monthly",
  "Quarterly",
  "Semi-Annually",
  "Annually"
]), r_ = be(["Legal", "Illegal", "Legal Nonconforming", "No Zoning"]), Qne = be(["Fee Simple", "Leased Fee", "Leasehold", "Other"]), ere = be(["Urban", "Suburban", "Rural"]), tre = M({
  address: Ll,
  coordinates: t_.optional(),
  zoning: v().optional(),
  zoningCompliance: r_.optional(),
  legalDescription: v().optional(),
  hoa: v().optional(),
  hoaFeeAmount: Nn.optional(),
  hoaFeeFrequency: n_.optional(),
  parcelNumber: v().optional(),
  newConstruction: Y().optional(),
  pud: Y().optional(),
  userUploadedPhotoBlobId: v().optional(),
  locationType: ere.optional(),
  propertyInterest: Qne.optional(),
  propertyInterestOther: v().optional()
}), md = Ll.partial(), e2 = (e) => v().default("").transform((t) => t.trim()).pipe(v().min(1, { message: `${e} is required.` })), O4 = M({
  AddressLineText: e2("Address"),
  CityName: e2("City"),
  PostalCode: e2("Zip"),
  StateCode: e2("State"),
  unitNumber: v().optional()
});
function nre(e) {
  const t = e != null && e.unitNumber ? ` ${e.unitNumber}` : "", n = (e == null ? void 0 : e.AddressLineText) ?? "Unknown Street Number and Name", r = `${(e == null ? void 0 : e.CityName) ?? "Unknown City Name"}, ${(e == null ? void 0 : e.StateCode) ?? "Unknown State"} ${(e == null ? void 0 : e.PostalCode) ?? "Unknown Zip Code"}`;
  return [n + t, r];
}
var rre = (e) => nre(e).join(" "), Cf = re(ce(), 1);
function ore(e) {
  var t;
  try {
    const n = e.split(",").map((r) => r.trim()).filter((r) => r);
    switch (n.length) {
      case 3:
        return are(n);
      case 4:
        return ((t = n[n.length - 1]) == null ? void 0 : t.split(" ").length) !== 1 ? SC(n, !0) : SC(n);
      case 5:
        return ire(n);
      default:
        throw new Error("Unexpected address format");
    }
  } catch (n) {
    throw new Error(`could not translate string address to Address: ${e}, ${n}`);
  }
}
var are = (e) => {
  const [t, n, r] = (0, Cf.checkMinLength)(3, e), [o, a] = r.split(" ");
  if (o.length > 2)
    throw new Error("Unexpected address format");
  return {
    AddressLineText: t,
    CityName: n,
    StateCode: o,
    PostalCode: a
  };
}, SC = (e, t = !1) => {
  const [n, r, o, a] = (0, Cf.checkMinLength)(4, e);
  if (t) {
    const [s, l] = (0, Cf.checkLength)(2, a.split(" "));
    return {
      AddressLineText: `${n} ${r}`,
      CityName: o,
      StateCode: s,
      PostalCode: l
    };
  }
  if (o.length > 2)
    throw new Error("Unexpected address format");
  return {
    AddressLineText: n,
    CityName: r,
    StateCode: o,
    PostalCode: a
  };
}, ire = (e) => {
  const [t, n, r, o, a] = (0, Cf.checkMinLength)(
    5,
    e
  );
  if (o.length > 2)
    throw new Error("Unexpected address format");
  return {
    AddressLineText: `${t} ${n}`.trim(),
    CityName: r,
    StateCode: o,
    PostalCode: a
  };
}, qn = Fr.schema, An = fs.schema, yt = xt.schema, Te = jt.schema, Ht = gt.schema, sre = v().transform((e, t) => {
  const n = +e.replace(/,/g, "").replace(/—|−/g, "-");
  return Number.isNaN(n) ? (t.addIssue({
    code: Me.custom,
    message: "Not a number"
  }), gf) : n;
}), lre = zt([L(), sre]);
ie("");
var ure = /^\(\d{3}\) \d{3}-\d{4}$/;
v().regex(ure, "Invalid US phone number");
v().refine(
  (e) => (
    // US zip codes are 5 digits or 9 digits with a hyphen in the middle
    /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(e)
  ),
  {
    message: "Invalid US zip code"
  }
);
var xe = lre.refine((e) => e % 1 === 0, "Not a whole number").refine((e) => e >= 0, "Not a positive number").brand("PositiveInt"), hn = v(), ac = (e) => gi().transform((t, n) => {
  const r = e.safeParse(t);
  if (r.success)
    return r.data;
  for (const o of r.error.issues)
    n.addIssue(o);
  return gf;
}), cre = ga("t", [
  M({ t: ie("string"), v: v() }),
  M({ t: ie("boolean"), v: Y() }),
  M({ t: ie("number"), v: L() }),
  M({ t: ie("enum"), v: hn }),
  M({ t: ie("price"), v: Te }),
  M({ t: ie("date"), v: qn }),
  M({ t: ie("count"), v: Ht }),
  M({ t: ie("area"), v: yt })
]), dre = v().brand("ToolkitListingID"), fre = re(mh(), 1), Xe;
((e) => {
  ((t) => {
    t.US_PACIFIC = "America/Los_Angeles", t.US_EASTERN = "America/New_York", t.US_CENTRAL = "America/Chicago", t.US_MOUNTAIN = "America/Denver", t.US_PHOENIX = "America/Phoenix", t.UTC = "Etc/UTC";
  })(e.TimeZones || (e.TimeZones = {})), e.differenceInMinutes = (t, n, r = /* @__PURE__ */ new Date()) => (yC(t, r) - yC(n, r)) / 6e4;
})(Xe || (Xe = {}));
var zo = (0, fre.AloftEnum)()({
  northwestmls: {
    resoID: "M00000650",
    constellation1ID: "NorthwestMLS",
    shortName: "NWMLS",
    longName: "Northwest Multiple Listing Service",
    isActive: !0,
    timeZone: Xe.TimeZones.US_PACIFIC,
    abodeMLSName: "Northwest MLS"
  },
  mlspin: {
    resoID: "M00000306",
    constellation1ID: "MLSPIN",
    shortName: "MLS PIN",
    longName: "Massachusetts MLS Property Information Network",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "MLS Property Information Network"
  },
  armls: {
    resoID: "M00000048",
    constellation1ID: "ArizonaRegional",
    shortName: "ARMLS",
    longName: "Arizona Regional Multiple Listing Service (ARMLS)",
    isActive: !0,
    timeZone: Xe.TimeZones.US_MOUNTAIN,
    abodeMLSName: "Arizona Regional MLS"
  },
  houston: {
    resoID: "M00000599",
    constellation1ID: "Houston",
    shortName: "HAR",
    longName: "Houston Association of Realtors",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "Houston Association of Realtors MLS"
  },
  lasvegas: {
    resoID: "M00000466",
    constellation1ID: "LasVegas",
    shortName: "LVR",
    longName: "Las Vegas Realtors",
    isActive: !0,
    timeZone: Xe.TimeZones.US_PACIFIC,
    abodeMLSName: "Greater Las Vegas Association of Realtors"
  },
  sef: {
    resoID: "M00000151",
    constellation1ID: "SEF",
    shortName: "Miami Realtors MLS",
    longName: "Miami Realtors MLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Miami Association of Realtors"
  },
  hivemls: {
    isActive: !0,
    resoID: "M00000722",
    constellation1ID: void 0,
    longName: "Hive",
    shortName: "Hive",
    abodeMLSName: "hivemls"
  },
  mlsnow: {
    resoID: "M00000830",
    constellation1ID: "MLSNow",
    shortName: "MLS Now",
    longName: "MLS Now",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "MLS Now (YES MLS)"
  },
  onekey: {
    resoID: "M00000489",
    constellation1ID: "OneKey",
    shortName: "OneKey",
    longName: "OneKey MLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "One Key MLS"
  },
  stellarmls: {
    resoID: "M00000146",
    constellation1ID: "StellarMLS",
    shortName: "Stellar MLS",
    longName: "Stellar MLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Stellar MLS"
  },
  crmls: {
    resoID: "M00000093",
    constellation1ID: "CRMLS",
    shortName: "CRMLS",
    longName: "California Regional Multiple Listing Service (CRMLS)",
    isActive: !0,
    timeZone: Xe.TimeZones.US_PACIFIC,
    abodeMLSName: "California Regional Multiple Listing Service"
  },
  trianglemls: {
    resoID: "M00000389",
    constellation1ID: "TriangleMLS",
    shortName: "Triangle MLS",
    longName: "Triangle MLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Triangle MLS"
  },
  canopymls: {
    resoID: "M00000391",
    constellation1ID: "CanopyMLS",
    shortName: "Canopy MLS",
    longName: "Canopy MLS (Canopy Realtor Association)",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Canopy MLS"
  },
  recolorado: {
    resoID: "M00000116",
    constellation1ID: "REColorado",
    shortName: "REcolorado",
    longName: "REcolorado",
    isActive: !0,
    timeZone: Xe.TimeZones.US_MOUNTAIN,
    abodeMLSName: "REcolorado"
  },
  sanantonio: {
    resoID: "M00000616",
    constellation1ID: "SanAntonio",
    shortName: "SanAntonio",
    longName: "San Antonio Board of REALTORS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "San Antonio Board of Realtors"
  },
  mlsok: {
    resoID: "M00000519",
    constellation1ID: "MLSOK",
    shortName: "MLSOK",
    longName: "MLSOK",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "MLS of Oklahoma"
  },
  centraltexas: {
    resoID: "M00000610",
    constellation1ID: "CentralTexas",
    shortName: "CTXMLS",
    longName: "Central Texas MLS (CTXMLS)",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "Central Texas MLS (Four River AOR)"
  },
  georgiamls: {
    resoID: "M00000188",
    constellation1ID: "GeorgiaMLS",
    shortName: "Georgia MLS",
    longName: "Georgia MLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Georgia MLS"
  },
  nabor: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "NABOR",
    longName: "Naples Area Board of REALTORS",
    isActive: !1
  },
  swmric: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "SWMRIC",
    longName: "Southwestern Michigan Association of REALTORS",
    isActive: !1
  },
  rebny: {
    resoID: "T00000046",
    constellation1ID: "REBNY",
    shortName: "REBNY",
    longName: "Real Estate Board of New York (REBNY)",
    isActive: !1,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Real Estate Board of NEW York 620A"
  },
  realtracs: {
    resoID: "M00000574",
    constellation1ID: "Realtracs",
    shortName: "Realtracs",
    longName: "Realtracs",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "Middle Tennessee MLS - REALTRACS"
  },
  gsrein: {
    resoID: "M00000065",
    constellation1ID: "GSREIN",
    shortName: "GSREIN",
    longName: "Gulf South Real Estate Information Network",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "Gulf South Real Estate Information Network (NEW Orleans)"
  },
  realmls: {
    resoID: "M00000141",
    constellation1ID: "RealMLS",
    shortName: "RealMLS",
    longName: "realMLS (Northeast Florida Multiple Listing Service)",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Northeast Florida/Jacksonville"
  },
  irmls: {
    resoID: "M00000256",
    constellation1ID: "IRMLS",
    shortName: "IRMLS",
    longName: "Indiana Regional MLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Indiana Regional MLS"
  },
  mlstechnology: {
    resoID: "M00000521",
    constellation1ID: "MLSTechnology",
    shortName: "MLS Technology",
    longName: "MLS Technology",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "MLS Technology (Tulsa MLS)"
  },
  knoxville: {
    resoID: "M00000582",
    constellation1ID: "Knoxville",
    shortName: "Knoxville",
    longName: "Knoxville Area Association of REALTORS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Knoxville Area Association of Realtors"
  },
  mred: {
    resoID: "M00000243",
    constellation1ID: "MRED",
    shortName: "MRED",
    longName: "Midwest Real Estate Data (MRED)",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "Midwest Real Estate Data"
  },
  brightmls: {
    resoID: "M00000309",
    constellation1ID: "BrightMLS",
    shortName: "Bright MLS",
    longName: "Bright MLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Bright MLS"
  },
  northcarolinaregional: {
    resoID: "M00000722",
    constellation1ID: "NorthCarolinaRegional",
    shortName: "NorthCarolinaRegional",
    longName: "North Carolina Regional MLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "North Carolina Regional MLS"
  },
  austin: {
    resoID: "M00000589",
    constellation1ID: "Austin",
    shortName: "ACTRIS",
    longName: "Austin Central Texas Realty Information Service (ACTRIS)",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "Austin Board of Realtors"
  },
  metrolist: {
    resoID: "M00000091",
    constellation1ID: "Metrolist",
    shortName: "MetroList",
    longName: "MetroList",
    isActive: !0,
    timeZone: Xe.TimeZones.US_PACIFIC,
    abodeMLSName: "MetroList - Sacramento"
  },
  mlsunited: {
    resoID: "M00000070",
    constellation1ID: "MLSUnited",
    shortName: "MLS United",
    longName: "MLS United",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "MLS United"
  },
  fmls: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "FMLS",
    longName: "First Multiple Listing Service",
    isActive: !1
  },
  heartlandmls: {
    resoID: "M00000270",
    constellation1ID: "HeartlandMLS",
    shortName: "Heartland MLS",
    longName: "Heartland MLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "Heartland MLS"
  },
  gardenstatemls: {
    resoID: "M00000449",
    constellation1ID: "GardenStateMLS",
    shortName: "Garden State MLS",
    longName: "Garden State MLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Garden State MLS"
  },
  ntreis: {
    resoID: "M00000594",
    constellation1ID: "NTREIS",
    shortName: "NTREIS",
    longName: "North Texas Real Estate Information Systems (NTREIS)",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "North Texas Real Estate Information System"
  },
  mibor: {
    resoID: "M00000255",
    constellation1ID: "MIBOR",
    shortName: "MIBOR",
    longName: "MIBOR Broker Listing Cooperative",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Metropolitan Indiana Board of Realtors"
  },
  palmbeachfl: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "PalmBeachFL",
    longName: "Palm Beach Board of REALTORS",
    isActive: !1
  },
  portlandor: {
    resoID: "M00000531",
    constellation1ID: "PortlandOR",
    shortName: "RMLS",
    longName: "Regional Multiple Listing Service (RMLS)",
    isActive: !0,
    timeZone: Xe.TimeZones.US_PACIFIC,
    abodeMLSName: "Regional MLS of Oregon"
  },
  maris: {
    resoID: "M00000360",
    constellation1ID: "MARIS",
    shortName: "MARIS MLS",
    longName: "MARIS MLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "Mid America Regional Information System"
  },
  northstarmls: {
    resoID: "M00000345",
    constellation1ID: "NorthStarMLS",
    shortName: "NorthstarMLS",
    longName: "NorthstarMLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "Northstar MLS"
  },
  westpenn: {
    resoID: "M00000549",
    constellation1ID: "WestPenn",
    shortName: "West Penn MultiList",
    longName: "West Penn MultiList",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "West Penn Multi List"
  },
  smartmls: {
    resoID: "M00000127",
    constellation1ID: "SmartMLS",
    shortName: "SmartMLS",
    longName: "SmartMLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "SMART MLS"
  },
  claw: {
    resoID: "M00000071",
    constellation1ID: "CLAW",
    shortName: "The MLS",
    longName: "The MLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_PACIFIC,
    abodeMLSName: "Combined L.A./Westside MLS, Inc."
  },
  beachesmls: {
    resoID: "M00000170",
    constellation1ID: "Beaches",
    shortName: "BeachesMLS",
    longName: "BeachesMLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Beaches MLS- FLEX MLS"
  },
  wasatch_front_regional_mls_utahrealestatecom: {
    resoID: "M00000628",
    constellation1ID: "UtahRealEstate",
    shortName: "UtahRealEstatecom",
    longName: "UtahRealEstatecom",
    isActive: !0,
    timeZone: Xe.TimeZones.US_MOUNTAIN,
    abodeMLSName: "Wasatch Front Regional MLS (UtahRealEstate.com)"
  },
  utahrealestate: {
    resoID: "M00000628",
    constellation1ID: "UtahRealEstate",
    shortName: "UtahRealEstatecom",
    longName: "UtahRealEstatecom",
    isActive: !0,
    timeZone: Xe.TimeZones.US_MOUNTAIN,
    abodeMLSName: "Wasatch Front Regional MLS (UtahRealEstate.com)"
  },
  realcomp: {
    resoID: "M00000316",
    constellation1ID: "Realcomp",
    shortName: "Realcom",
    longName: "Realcomp",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Realcomp MLS"
  },
  bridgemls: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "bridgeMLS",
    longName: "bridgeMLS",
    isActive: !1
  },
  neren: {
    resoID: "M00000445",
    constellation1ID: "NEREN",
    shortName: "PrimeMLS",
    longName: "PrimeMLS",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "New England Real Estate Network"
  },
  brevard_county_mls: {
    resoID: "M00000150",
    constellation1ID: "BrevardMLS",
    longName: "Brevard County MLS (Melborne/Space Coast)",
    shortName: "Brevard County MLS (Melborne/Space Coast)",
    isActive: !0,
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Space Coast Association of Realtors MLS"
  },
  rmlsa: {
    resoID: "M00000852",
    constellation1ID: "RMLSA",
    longName: "RMLS Alliance (IL)",
    shortName: "RMLSA",
    isActive: !0,
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "RMLS Alliance (Peoria Area Association of Reatlors)"
  },
  wyoming_mls: {
    isActive: !0,
    resoID: "M00000679",
    constellation1ID: "WyomingMLS",
    longName: "Wyoming MLS",
    shortName: "Wyoming MLS",
    timeZone: Xe.TimeZones.US_MOUNTAIN,
    abodeMLSName: "Wyoming MLS"
  },
  florida_gulf_coast_mls: {
    isActive: !0,
    resoID: "M00000130",
    constellation1ID: "FGCMLS",
    longName: "Florida Gulf Coast MLS",
    shortName: "Florida Gulf Coast MLS",
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "SWFL MLS/Florida Gulf Coast MLS (Royal Palm Coast AOR)"
  },
  des_moines: {
    isActive: !0,
    resoID: "M00000204",
    constellation1ID: "DesMoines",
    longName: "Des Moines Area Association of REALTORS",
    shortName: "Des Moines",
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "Des Moines Area Association of Reatlors MLS"
  },
  centralpanhandle: {
    isActive: !0,
    resoID: "M00000159",
    constellation1ID: "CentralPanhandle",
    longName: "Central Panhandle Association of REALTORS",
    shortName: "Central Panhandle",
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Central Panhandle AOR"
  },
  oklahoma_city_metropolitan_board_of_realtors_mlsok: {
    isActive: !0,
    resoID: "M00000519",
    constellation1ID: "MLSOK",
    longName: "Oklahoma City Metropolitan Board of Realtors / MLSOK",
    shortName: "Oklahoma City Metropolitan Board of Realtors / MLSOK",
    timeZone: Xe.TimeZones.US_CENTRAL,
    abodeMLSName: "MLS of Oklahoma"
  },
  emerald_coast_association_of_realtors: {
    isActive: !0,
    resoID: "M00000138",
    constellation1ID: "EmeraldCoast",
    longName: "Emerald Coast Association of Realtors",
    shortName: "Emerald Coast Association of Realtors",
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Emerald Coast"
  },
  lexington_bluegrass_association_of_realtors: {
    isActive: !0,
    resoID: "M00000288",
    constellation1ID: "LexingtonKY",
    longName: "Lexington Bluegrass Association of Realtors",
    shortName: "Lexington Bluegrass Association of Realtors",
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Lexington-Bluegrass Association of Realtors"
  },
  triad_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000400",
    constellation1ID: "TriadMLS",
    longName: "Triad Multiple Listing Service",
    shortName: "Triad Multiple Listing Service",
    timeZone: Xe.TimeZones.US_EASTERN,
    abodeMLSName: "Triad MLS"
  },
  tucson_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tucson Association of Realtors",
    shortName: "Tucson Association of Realtors"
  },
  tulare_county_association_of_realtors: {
    isActive: !0,
    resoID: "M00000104",
    constellation1ID: void 0,
    longName: "Tulare County Association of Realtors",
    shortName: "Tulare County Association of Realtors",
    abodeMLSName: "Tulare County Association of Realtors MLS"
  },
  tuolumne_county_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tuolumne County Association of Realtors",
    shortName: "Tuolumne County Association of Realtors"
  },
  tuscaloosa: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tuscaloosa",
    shortName: "Tuscaloosa"
  },
  ulster_county_board_of_realtors: {
    isActive: !0,
    resoID: "M00000479",
    constellation1ID: void 0,
    longName: "Ulster County Board of Realtors",
    shortName: "Ulster County Board of Realtors",
    abodeMLSName: "Hudson Valley Catskill Region MLS (Ulster County Board of Realtors)"
  },
  upper_peninsula_association_of_realtors: {
    isActive: !0,
    resoID: "M00000324",
    constellation1ID: void 0,
    longName: "Upper Peninsula Association of REALTORS",
    shortName: "Upper Peninsula Association of REALTORS",
    abodeMLSName: "Upper Peninsula Association of Realtors"
  },
  upstate_new_york_real_estate_information_services: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Upstate New York Real Estate Information Services (UNYREIS)",
    shortName: "Upstate New York Real Estate Information Services (UNYREIS)"
  },
  vail_board_of_realtors: {
    isActive: !0,
    resoID: "M00000114",
    constellation1ID: void 0,
    longName: "Vail Board of Realtors",
    shortName: "Vail Board of Realtors",
    abodeMLSName: "Vail Multi-List Services"
  },
  ventura_county_regional_data_share: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Ventura County Regional Data Share",
    shortName: "Ventura County Regional Data Share"
  },
  waco_association_of_realtors: {
    isActive: !0,
    resoID: "M00000594",
    constellation1ID: void 0,
    longName: "Waco Association of Realtors",
    shortName: "Waco Association of Realtors",
    abodeMLSName: "Waco Association of Realtors"
  },
  walker_co: {
    isActive: !0,
    resoID: "M00000711",
    constellation1ID: void 0,
    longName: "Walker Co",
    shortName: "Walker Co",
    abodeMLSName: "Walker County Board of Realtors"
  },
  warren_county_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Warren County Board of REALTORS",
    shortName: "Warren County Board of REALTORS"
  },
  washington_county_board_of_realtors: {
    isActive: !0,
    resoID: "M00000629",
    constellation1ID: void 0,
    longName: "Washington County Board of Realtors",
    shortName: "Washington County Board of Realtors",
    abodeMLSName: "Washington County Board of Realtors"
  },
  water_wonderland_mls: {
    isActive: !0,
    resoID: "M00000317",
    constellation1ID: void 0,
    longName: "Water Wonderland MLS",
    shortName: "Water Wonderland MLS",
    abodeMLSName: "Water Wonderland Board of Realtors"
  },
  waterloo_cedar_falls_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Waterloo Cedar Falls Board of Realtors",
    shortName: "Waterloo Cedar Falls Board of Realtors"
  },
  west_branch_valley_association_of_realtors: {
    isActive: !0,
    resoID: "M00000799",
    constellation1ID: void 0,
    longName: "West Branch Valley Association of Realtors",
    shortName: "West Branch Valley Association of Realtors",
    abodeMLSName: "West Branch Valley AOR"
  },
  west_central_association_of_realtors_sedaliawarsaw_mls: {
    isActive: !0,
    resoID: "M00000735",
    constellation1ID: void 0,
    longName: "West Central Association of REALTORS (MO) - Sedalia/Warsaw MLS",
    shortName: "West Central Association of REALTORS (MO) - Sedalia/Warsaw MLS",
    abodeMLSName: "West Central Association of Realtors"
  },
  west_metro_board_of_realtors_ga: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "West Metro Board of Realtors, GA",
    shortName: "West Metro Board of Realtors, GA"
  },
  western_regional_information_systems_technology: {
    isActive: !0,
    resoID: "M00000506",
    constellation1ID: void 0,
    longName: "Western Regional Information Systems & Technology",
    shortName: "Western Regional Information Systems & Technology",
    abodeMLSName: "Western Regional Information System & Technology"
  },
  western_upstate_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000556",
    constellation1ID: void 0,
    longName: "Western Upstate Multiple Listing Service",
    shortName: "Western Upstate Multiple Listing Service",
    abodeMLSName: "Western Upstate MLS"
  },
  white_mountain_assoc_of_realtors: {
    isActive: !0,
    resoID: "M00000042",
    constellation1ID: void 0,
    longName: "White Mountain Assoc. of Realtors",
    shortName: "White Mountain Assoc. of Realtors",
    abodeMLSName: "White Mountain Association of Realtors MLS"
  },
  wichita_falls_association_of_realtors: {
    isActive: !0,
    resoID: "M00000625",
    constellation1ID: void 0,
    longName: "Wichita Falls Association of REALTORS",
    shortName: "Wichita Falls Association of REALTORS",
    abodeMLSName: "Wichita Falls AOR"
  },
  willamette_valley_mls: {
    isActive: !0,
    resoID: "M00000532",
    constellation1ID: void 0,
    longName: "Willamette Valley MLS",
    shortName: "Willamette Valley MLS",
    abodeMLSName: "Willamette Valley MLS"
  },
  williamsburg_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000858",
    constellation1ID: void 0,
    longName: "Williamsburg Area Association of Realtors",
    shortName: "Williamsburg Area Association of Realtors",
    abodeMLSName: "Williamsburg Board of Realtors"
  },
  yakima_association_of_realtors: {
    isActive: !0,
    resoID: "M00000656",
    constellation1ID: void 0,
    longName: "Yakima Association of Realtors",
    shortName: "Yakima Association of Realtors",
    abodeMLSName: "Yakima Association of Realtors MLS"
  },
  yuma_mls: {
    isActive: !0,
    resoID: "M00000050",
    constellation1ID: void 0,
    longName: "Yuma MLS",
    shortName: "Yuma MLS",
    abodeMLSName: "Yuma Association of Realtors MLS"
  },
  ack_association_of_realtors_northern_mi_mls: {
    isActive: !0,
    resoID: "M00000315",
    constellation1ID: void 0,
    longName: "ACK Association of Realtors/Northern MI MLS",
    shortName: "ACK Association of Realtors/Northern MI MLS",
    abodeMLSName: "ACK Association of Realtors/Northern MI MLS"
  },
  adirondack_champlain_valley_mls: {
    isActive: !0,
    resoID: "M00000483",
    constellation1ID: void 0,
    longName: "Adirondack-Champlain Valley MLS",
    shortName: "Adirondack-Champlain Valley MLS",
    abodeMLSName: "Adirondack-Champlain Valley MLS"
  },
  aiken_board_of_realtors: {
    isActive: !0,
    resoID: "M00000555",
    constellation1ID: void 0,
    longName: "Aiken Board of Realtors",
    shortName: "Aiken Board of Realtors",
    abodeMLSName: "Aiken Board of Realtors"
  },
  alaska_mls: {
    isActive: !0,
    resoID: "M00000001",
    constellation1ID: void 0,
    longName: "Alaska MLS",
    shortName: "Alaska MLS",
    abodeMLSName: "Alaska MLS"
  },
  albany_bor_southwest_ga_mls: {
    isActive: !0,
    resoID: "M00000172",
    constellation1ID: void 0,
    longName: "Albany BOR/Southwest GA MLS",
    shortName: "Albany BOR/Southwest GA MLS",
    abodeMLSName: "Albany BOR/Southwest GA MLS"
  },
  allegheny_valley_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Allegheny Valley Board of REALTORS",
    shortName: "Allegheny Valley Board of REALTORS",
    abodeMLSName: void 0
  },
  amarillo_association_of_realtors: {
    isActive: !0,
    resoID: "M00000588",
    constellation1ID: void 0,
    longName: "Amarillo Association of Realtors",
    shortName: "Amarillo Association of Realtors",
    abodeMLSName: "Amarillo Association of Realtors"
  },
  amelia_island_nassau_county_assoc_of_realtors: {
    isActive: !0,
    resoID: "M00000136",
    constellation1ID: void 0,
    longName: "Amelia Island",
    shortName: "Amelia Island",
    abodeMLSName: "Amelia Island"
  },
  ann_arbor_area_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Ann Arbor Area Board of Realtors",
    shortName: "Ann Arbor Area Board of Realtors",
    abodeMLSName: void 0
  },
  ashland_board_of_realtors_oh: {
    isActive: !0,
    resoID: "M00000278",
    constellation1ID: void 0,
    longName: "Ashland Area AOR",
    shortName: "Ashland Area AOR",
    abodeMLSName: "Ashland Area AOR"
  },
  aspen_glenwood_springs_mls_co: {
    isActive: !0,
    resoID: "M00000109",
    constellation1ID: void 0,
    longName: "Aspen/Glenwood Springs MLS",
    shortName: "Aspen/Glenwood Springs MLS",
    abodeMLSName: "Aspen/Glenwood Springs MLS"
  },
  athens_area_association_or_realtors_: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Athens Area Association or Realtors *",
    shortName: "Athens Area Association or Realtors *",
    abodeMLSName: void 0
  },
  athens_board_of_realtors_oh: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Athens Board of REALTORS, OH",
    shortName: "Athens Board of REALTORS, OH",
    abodeMLSName: void 0
  },
  badlands_board_of_realtors: {
    isActive: !0,
    resoID: "M00000427",
    constellation1ID: void 0,
    longName: "Badlands Board of Realtors",
    shortName: "Badlands Board of Realtors",
    abodeMLSName: "Badlands Board of Realtors"
  },
  bagnell_dam_association_of_realtors: {
    isActive: !0,
    resoID: "M00000355",
    constellation1ID: void 0,
    longName: "Bagnell Dam Association of Realtors",
    shortName: "Bagnell Dam Association of Realtors",
    abodeMLSName: "Bagnell Dam Association of Realtors"
  },
  bakersfield_association_of_realtors: {
    isActive: !0,
    resoID: "M00000053",
    constellation1ID: void 0,
    longName: "Bakersfield Association of Realtors/Golden Empire MLS",
    shortName: "Bakersfield Association of Realtors/Golden Empire MLS",
    abodeMLSName: "Bakersfield Association of Realtors/Golden Empire MLS"
  },
  baldwin_county_association: {
    isActive: !0,
    resoID: "M00000022",
    constellation1ID: void 0,
    longName: "Baldwin Realtors MLS",
    shortName: "Baldwin Realtors MLS",
    abodeMLSName: "Baldwin Realtors MLS"
  },
  bay_area_real_estate_information: {
    isActive: !0,
    resoID: "M00000097",
    constellation1ID: void 0,
    longName: "Bay Area Real Estate Information Services",
    shortName: "Bay Area Real Estate Information Services",
    abodeMLSName: "Bay Area Real Estate Information Services"
  },
  bay_county: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Bay County (Panama City MLS)",
    shortName: "Bay County (Panama City MLS)",
    abodeMLSName: void 0
  },
  bay_east_aor_contra_costa_aor: {
    isActive: !0,
    resoID: "M00000105",
    constellation1ID: void 0,
    longName: "Bay East AOR/Contra Costa AOR",
    shortName: "Bay East AOR/Contra Costa AOR",
    abodeMLSName: "Bay East AOR/Contra Costa AOR"
  },
  beaches_mls_matrix_mls: {
    isActive: !0,
    resoID: "M00000170",
    constellation1ID: void 0,
    longName: "Beaches MLS- MATRIX MLS",
    shortName: "Beaches MLS- MATRIX MLS",
    abodeMLSName: "Beaches MLS- MATRIX MLS"
  },
  beaumont_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Beaumont Board of REALTORS",
    shortName: "Beaumont Board of REALTORS",
    abodeMLSName: void 0
  },
  berkshire_county_ma: {
    isActive: !0,
    resoID: "M00000305",
    constellation1ID: void 0,
    longName: "Berkshire Realtors",
    shortName: "Berkshire Realtors",
    abodeMLSName: "Berkshire Realtors"
  },
  big_bear_mls_ca: {
    isActive: !0,
    resoID: "M00000055",
    constellation1ID: void 0,
    longName: "Big Bear AOR",
    shortName: "Big Bear AOR",
    abodeMLSName: "Big Bear AOR"
  },
  billings_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000378",
    constellation1ID: void 0,
    longName: "Billings Association of Realtors",
    shortName: "Billings Association of Realtors",
    abodeMLSName: "Billings Association of Realtors"
  },
  birmingham: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Birmingham",
    shortName: "Birmingham",
    abodeMLSName: void 0
  },
  black_hills_association_of_realtors: {
    isActive: !0,
    resoID: "M00000571",
    constellation1ID: void 0,
    longName: "Black Hills Association of Realtors",
    shortName: "Black Hills Association of Realtors",
    abodeMLSName: "Black Hills Association of Realtors"
  },
  bonita_springs_estero_association_of_realtors: {
    isActive: !0,
    resoID: "M00000821",
    constellation1ID: void 0,
    longName: "Bonita Springs Association of Realtors MLS",
    shortName: "Bonita Springs Association of Realtors MLS",
    abodeMLSName: "Bonita Springs Association of Realtors MLS"
  },
  brooklyn_bor: {
    isActive: !0,
    resoID: "M00000471",
    constellation1ID: void 0,
    longName: "Brooklyn BOR",
    shortName: "Brooklyn BOR",
    abodeMLSName: "Brooklyn BOR"
  },
  bryan_college_station_regional_aor_bryancollege_station_regional_mls: {
    isActive: !0,
    resoID: "M00000592",
    constellation1ID: void 0,
    longName: "Bryan College Station Association of Realtors",
    shortName: "Bryan College Station Association of Realtors",
    abodeMLSName: "Bryan College Station Association of Realtors"
  },
  buffalo_niagara_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Buffalo Niagara Association of Realtors",
    shortName: "Buffalo Niagara Association of Realtors",
    abodeMLSName: void 0
  },
  burlingtonalamance_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Burlington/Alamance MLS",
    shortName: "Burlington/Alamance MLS",
    abodeMLSName: void 0
  },
  calaveras_county_association_of_realtors: {
    isActive: !0,
    resoID: "M00000052",
    constellation1ID: void 0,
    longName: "Calaveras County Association of Realtors MLS",
    shortName: "Calaveras County Association of Realtors MLS",
    abodeMLSName: "Calaveras County Association of Realtors MLS"
  },
  california_desert_association_of_realtors: {
    isActive: !0,
    resoID: "M00000093",
    constellation1ID: void 0,
    longName: "California Data Share",
    shortName: "California Data Share",
    abodeMLSName: "California Data Share"
  },
  campbell_county_board_of_realtors_northeast_wyoming_realtor_alliance: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Campbell County Board of Realtors / Northeast Wyoming REALTOR Alliance",
    shortName: "Campbell County Board of Realtors / Northeast Wyoming REALTOR Alliance",
    abodeMLSName: void 0
  },
  cape_cod_islands_association_of_realtors: {
    isActive: !0,
    resoID: "M00000307",
    constellation1ID: void 0,
    longName: "Cape Cod and the Islands Association of Realtors",
    shortName: "Cape Cod and the Islands Association of Realtors",
    abodeMLSName: "Cape Cod and the Islands Association of Realtors"
  },
  cape_fear_realtors_multiple_listing_service: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Cape Fear REALTORS Multiple Listing Service (North Carolina Regional MLS)",
    shortName: "Cape Fear REALTORS Multiple Listing Service (North Carolina Regional MLS)",
    abodeMLSName: void 0
  },
  cape_may_county_association_of_realtors: {
    isActive: !0,
    resoID: "M00000447",
    constellation1ID: void 0,
    longName: "Cape May County MLS",
    shortName: "Cape May County MLS",
    abodeMLSName: "Cape May County MLS"
  },
  carolina_smokies_aor: {
    isActive: !0,
    resoID: "M00000395",
    constellation1ID: void 0,
    longName: "Carolina Smokies AOR",
    shortName: "Carolina Smokies AOR",
    abodeMLSName: "Carolina Smokies AOR"
  },
  carpet_capital_aor: {
    isActive: !0,
    resoID: "M00000752",
    constellation1ID: void 0,
    longName: "Carpet Capital AOR",
    shortName: "Carpet Capital AOR",
    abodeMLSName: "Carpet Capital AOR"
  },
  cedar_rapids: {
    isActive: !0,
    resoID: "M00000200",
    constellation1ID: void 0,
    longName: "Cedar Rapids AOR",
    shortName: "Cedar Rapids AOR",
    abodeMLSName: "Cedar Rapids AOR"
  },
  central_arizona_board_of_realtors: {
    isActive: !0,
    resoID: "M00000043",
    constellation1ID: void 0,
    longName: "Central Arizona Association of Realtors MLS",
    shortName: "Central Arizona Association of Realtors MLS",
    abodeMLSName: "Central Arizona Association of Realtors MLS"
  },
  central_iowa_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Central Iowa Board of Realtors",
    shortName: "Central Iowa Board of Realtors",
    abodeMLSName: void 0
  },
  central_ga_bor_mls: {
    isActive: !0,
    resoID: "M00000190",
    constellation1ID: void 0,
    longName: "Central GA BOR MLS",
    shortName: "Central GA BOR MLS",
    abodeMLSName: "Central GA BOR MLS"
  },
  central_hill_country_association_of_realtors: {
    isActive: !0,
    resoID: "M00000596",
    constellation1ID: void 0,
    longName: "Central Hill Country Association of Realtors",
    shortName: "Central Hill Country Association of Realtors",
    abodeMLSName: "Central Hill Country Association of Realtors"
  },
  central_jersey_mls: {
    isActive: !0,
    resoID: "M00000450",
    constellation1ID: void 0,
    longName: "Central Jersey MLS",
    shortName: "Central Jersey MLS",
    abodeMLSName: "Central Jersey MLS"
  },
  central_new_york_information_services: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Central New York Information Services (Jefferson Lewis Board of Realtors MLS)",
    shortName: "Central New York Information Services (Jefferson Lewis Board of Realtors MLS)",
    abodeMLSName: void 0
  },
  central_oregon_association_of_realtors: {
    isActive: !0,
    resoID: "M00000525",
    constellation1ID: void 0,
    longName: "Central Oregon Association of Realtors",
    shortName: "Central Oregon Association of Realtors",
    abodeMLSName: "Central Oregon Association of Realtors"
  },
  central_susquehanna_valley_board_of_realtors: {
    isActive: !0,
    resoID: "M00000538",
    constellation1ID: void 0,
    longName: "Central Susquehanna Valley BOR",
    shortName: "Central Susquehanna Valley BOR",
    abodeMLSName: "Central Susquehanna Valley BOR"
  },
  central_tennessee_west_aor: {
    isActive: !0,
    resoID: "M00000581",
    constellation1ID: void 0,
    longName: "Central Tennessee West AOR",
    shortName: "Central Tennessee West AOR",
    abodeMLSName: "Central Tennessee West AOR"
  },
  central_virginia_regional_mls: {
    isActive: !0,
    resoID: "M00000643",
    constellation1ID: void 0,
    longName: "Central Virginia Regional MLS",
    shortName: "Central Virginia Regional MLS",
    abodeMLSName: "Central Virginia Regional MLS"
  },
  central_wisconsin_multiple_listing_service: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Central Wisconsin Multiple Listing Service",
    shortName: "Central Wisconsin Multiple Listing Service",
    abodeMLSName: void 0
  },
  centre_county_association_of_realtors_pa: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Centre County Association of Realtors, PA",
    shortName: "Centre County Association of Realtors, PA",
    abodeMLSName: void 0
  },
  centris: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Centris",
    shortName: "Centris",
    abodeMLSName: void 0
  },
  charleston_trident_mls_chs_regional: {
    isActive: !0,
    resoID: "M00000558",
    constellation1ID: void 0,
    longName: "Charleston-Trident Association of Realtors",
    shortName: "Charleston-Trident Association of Realtors",
    abodeMLSName: "Charleston-Trident Association of Realtors"
  },
  charlottesville_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000633",
    constellation1ID: void 0,
    longName: "Charlottesville Association of Realtors",
    shortName: "Charlottesville Association of Realtors",
    abodeMLSName: "Charlottesville Association of Realtors"
  },
  chattanooga_association_of_realtors_tn: {
    isActive: !0,
    resoID: "M00000575",
    constellation1ID: void 0,
    longName: "Chattanooga Association of Realtors, TN",
    shortName: "Chattanooga Association of Realtors, TN",
    abodeMLSName: "Greater Chattanooga AOR"
  },
  cheyenne_board_of_realtors: {
    isActive: !0,
    resoID: "M00000675",
    constellation1ID: void 0,
    longName: "Cheyenne Board of Realtors",
    shortName: "Cheyenne Board of Realtors",
    abodeMLSName: "Cheyenne Board of Realtors"
  },
  classic_athens: {
    isActive: !0,
    resoID: "M00000177",
    constellation1ID: void 0,
    longName: "Classic / Athens",
    shortName: "Classic / Athens",
    abodeMLSName: "Classic / Athens"
  },
  clatsop_mls_or_clatsop_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Clatsop MLS, OR / Clatsop Association of REALTORS",
    shortName: "Clatsop MLS, OR / Clatsop Association of REALTORS",
    abodeMLSName: void 0
  },
  coastal_carolinas_association_of_realtors_sc: {
    isActive: !0,
    resoID: "M00000565",
    constellation1ID: void 0,
    longName: "Coastal Carolina AOR",
    shortName: "Coastal Carolina AOR",
    abodeMLSName: "Coastal Carolina AOR"
  },
  coeur_d_alene_association_of_realtors: {
    isActive: !0,
    resoID: "M00000227",
    constellation1ID: void 0,
    longName: "Coeur d'Alene Association of Realtors",
    shortName: "Coeur d'Alene Association of Realtors",
    abodeMLSName: "Coeur d'Alene Association of Realtors"
  },
  colorado_real_estate_network: {
    isActive: !0,
    resoID: "M00000684",
    constellation1ID: void 0,
    longName: "Colorado Real Estate Network",
    shortName: "Colorado Real Estate Network",
    abodeMLSName: "Colorado Real Estate Network"
  },
  columbia_board_of_realtors: {
    isActive: !0,
    resoID: "M00000349",
    constellation1ID: void 0,
    longName: "Columbia Board of REALTORS",
    shortName: "Columbia Board of REALTORS",
    abodeMLSName: "Columbia Board of REALTORS"
  },
  columbia_county_northern_dutchess_mls: {
    isActive: !0,
    resoID: "M00000476",
    constellation1ID: void 0,
    longName: "Columbia Greene North Dutchess MLS",
    shortName: "Columbia Greene North Dutchess MLS",
    abodeMLSName: "Columbia Greene North Dutchess MLS"
  },
  columbus_and_central_ohio_regional_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Columbus and Central Ohio Regional MLS",
    shortName: "Columbus and Central Ohio Regional MLS",
    abodeMLSName: void 0
  },
  columbus_board_of_realtors_ga: {
    isActive: !0,
    resoID: "M00000753",
    constellation1ID: void 0,
    longName: "Columbus BOR",
    shortName: "Columbus BOR",
    abodeMLSName: "Columbus BOR"
  },
  columbus_ne_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Columbus NE Board of Realtors",
    shortName: "Columbus NE Board of Realtors",
    abodeMLSName: void 0
  },
  commercial_and_industrial_real_estate_brokers: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Commercial and Industrial Real Estate Brokers",
    shortName: "Commercial and Industrial Real Estate Brokers",
    abodeMLSName: void 0
  },
  consolidated_mls: {
    isActive: !0,
    resoID: "M00000559",
    constellation1ID: void 0,
    longName: "Consolidated MLS",
    shortName: "Consolidated MLS",
    abodeMLSName: "Consolidated MLS"
  },
  cooperative_arkansas_realtors_mls: {
    isActive: !0,
    resoID: "M00000031",
    constellation1ID: void 0,
    longName: "Cooperative Arkansas Realtors MLS",
    shortName: "Cooperative Arkansas Realtors MLS",
    abodeMLSName: "Cooperative Arkansas Realtors MLS"
  },
  corpus_christi_association_of_realtors_south_texas_mls: {
    isActive: !0,
    resoID: "M00000593",
    constellation1ID: void 0,
    longName: "Corpus Christi Board of Realtors (South Texas MLS)",
    shortName: "Corpus Christi Board of Realtors (South Texas MLS)",
    abodeMLSName: "Corpus Christi Board of Realtors (South Texas MLS)"
  },
  darien_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Darien MLS",
    shortName: "Darien MLS",
    abodeMLSName: void 0
  },
  dayton_realtors: {
    isActive: !0,
    resoID: "M00000496",
    constellation1ID: void 0,
    longName: "Dayton Area Board of Realtors",
    shortName: "Dayton Area Board of Realtors",
    abodeMLSName: "Dayton Area Board of Realtors"
  },
  daytona_beach_area_association: {
    isActive: !0,
    resoID: "M00000140",
    constellation1ID: void 0,
    longName: "Daytona Beach Area Association of REALTORS",
    shortName: "Daytona Beach Area Association of REALTORS",
    abodeMLSName: "Daytona Beach Area Association of REALTORS"
  },
  desert_area_mls: {
    isActive: !0,
    resoID: "M00000082",
    constellation1ID: void 0,
    longName: "Desert Area MLS",
    shortName: "Desert Area MLS",
    abodeMLSName: "Desert Area MLS"
  },
  door_county_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Door County Board of REALTORS",
    shortName: "Door County Board of REALTORS",
    abodeMLSName: void 0
  },
  dothan_mls: {
    isActive: !0,
    resoID: "M00000013",
    constellation1ID: void 0,
    longName: "Dothan MLS",
    shortName: "Dothan MLS",
    abodeMLSName: "Southeast Alabama AOR/MLS (Dothan)"
  },
  east_alabama_board_of_realtors_al: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "East Alabama Board of REALTORS, AL",
    shortName: "East Alabama Board of REALTORS, AL",
    abodeMLSName: void 0
  },
  east_central_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "East Central Association of Realtors",
    shortName: "East Central Association of Realtors",
    abodeMLSName: void 0
  },
  east_central_iowa: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "East Central Iowa",
    shortName: "East Central Iowa",
    abodeMLSName: void 0
  },
  eastern_shore_aor: {
    isActive: !0,
    resoID: "M00000631",
    constellation1ID: void 0,
    longName: "Eastern Shore AOR",
    shortName: "Eastern Shore AOR",
    abodeMLSName: "Eastern Shore AOR"
  },
  fargo_moorhead_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000428",
    constellation1ID: void 0,
    longName: "Fargo Morehead Area Association of Realtors",
    shortName: "Fargo Morehead Area Association of Realtors",
    abodeMLSName: "Fargo Morehead Area Association of Realtors"
  },
  fayetteville_association_of_realtors: {
    isActive: !0,
    resoID: "M00000394",
    constellation1ID: void 0,
    longName: "Longleaf Pine REALTORS (Fayetteville)",
    shortName: "Longleaf Pine REALTORS (Fayetteville)",
    abodeMLSName: "Fayetteville Association of Realtors (Longleaf Pine REALTORS)"
  },
  firelands_association_of_realtors: {
    isActive: !0,
    resoID: "M00000504",
    constellation1ID: void 0,
    longName: "Firelands Association of Realtors",
    shortName: "Firelands Association of Realtors",
    abodeMLSName: "Firelands Association of Realtors"
  },
  flint_hills_mls: {
    isActive: !0,
    resoID: "M00000271",
    constellation1ID: void 0,
    longName: "Flint Hills AOR (aka Manhattan Area AOR)",
    shortName: "Flint Hills AOR (aka Manhattan Area AOR)",
    abodeMLSName: "Flint Hills AOR (aka Manhattan Area AOR)"
  },
  florida_keys_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000168",
    constellation1ID: void 0,
    longName: "Florida Keys MLS",
    shortName: "Florida Keys MLS",
    abodeMLSName: "Florida Keys MLS"
  },
  fort_smith_bor_dba_western_river_valley_bor: {
    isActive: !0,
    resoID: "M00000853",
    constellation1ID: void 0,
    longName: "Fort Smith BOR dba Western River Valley BOR",
    shortName: "Fort Smith BOR dba Western River Valley BOR",
    abodeMLSName: "Fort Smith BOR dba Western River Valley BOR"
  },
  franklin_and_gulf_counties: {
    isActive: !0,
    resoID: "M00000129",
    constellation1ID: void 0,
    longName: "Franklin and Gulf Counties",
    shortName: "Franklin and Gulf Counties",
    abodeMLSName: "Franklin and Gulf Counties"
  },
  freeport_galena: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Freeport Galena (Realtor Association of Northwestern Illinois)",
    shortName: "Freeport Galena (Realtor Association of Northwestern Illinois)",
    abodeMLSName: void 0
  },
  fresno_association_of_realtors: {
    isActive: !0,
    resoID: "M00000060",
    constellation1ID: void 0,
    longName: "Fresno Association of REALTORS",
    shortName: "Fresno Association of REALTORS",
    abodeMLSName: "Fresno Association of REALTORS"
  },
  gallatin_association_of_realtors_big_sky_country_mls: {
    isActive: !0,
    resoID: "M00000379",
    constellation1ID: void 0,
    longName: "Gallatin Association of Realtors (Big Sky Country MLS)",
    shortName: "Gallatin Association of Realtors (Big Sky Country MLS)",
    abodeMLSName: "Gallatin Association of Realtors (Big Sky Country MLS)"
  },
  galveston_association_of_realtors: {
    isActive: !0,
    resoID: "M00000597",
    constellation1ID: void 0,
    longName: "Galveston Board of Realtors",
    shortName: "Galveston Board of Realtors",
    abodeMLSName: "Galveston Board of Realtors"
  },
  golden_isles_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Golden Isles Association of Realtors",
    shortName: "Golden Isles Association of Realtors",
    abodeMLSName: void 0
  },
  global_mls: {
    isActive: !0,
    resoID: "M00000468",
    constellation1ID: void 0,
    longName: "Global MLS",
    shortName: "Global MLS",
    abodeMLSName: "Global MLS"
  },
  grand_forks_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000429",
    constellation1ID: void 0,
    longName: "Grand Forks Area Association of Realtors",
    shortName: "Grand Forks Area Association of Realtors",
    abodeMLSName: "Grand Forks Area Association of Realtors"
  },
  grand_island_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Grand Island Board of Realtors",
    shortName: "Grand Island Board of Realtors",
    abodeMLSName: void 0
  },
  grand_junction_area_realtor_association: {
    isActive: !0,
    resoID: "M00000729",
    constellation1ID: void 0,
    longName: "Grand Junction Area Realtor Association",
    shortName: "Grand Junction Area Realtor Association",
    abodeMLSName: "Grand Junction Association of Realtors MLS"
  },
  great_north_mls: {
    isActive: !0,
    resoID: "M00000107",
    constellation1ID: void 0,
    longName: "Great North MLS",
    shortName: "Great North MLS",
    abodeMLSName: "Great North MLS"
  },
  great_plains_mls_omaha: {
    isActive: !0,
    resoID: "M00000441",
    constellation1ID: void 0,
    longName: "Great Plains Regional MLS",
    shortName: "Great Plains Regional MLS",
    abodeMLSName: "Great Plains Regional MLS"
  },
  greater_alabama_mls: {
    isActive: !0,
    resoID: "M00000010",
    constellation1ID: void 0,
    longName: "Greater Alabama MLS",
    shortName: "Greater Alabama MLS",
    abodeMLSName: "Greater Alabama MLS"
  },
  greater_antelope_valley_association_of_realtors: {
    isActive: !0,
    resoID: "M00000084",
    constellation1ID: void 0,
    longName: "Greater Antelope Valley Association of Realtors",
    shortName: "Greater Antelope Valley Association of Realtors",
    abodeMLSName: "Greater Antelope Valley Association of Realtors"
  },
  greater_augusta_association_of_realtors: {
    isActive: !0,
    resoID: "M00000176",
    constellation1ID: void 0,
    longName: "Greater Augusta Board of Realtors MLS",
    shortName: "Greater Augusta Board of Realtors MLS",
    abodeMLSName: "Greater Augusta Board of Realtors MLS"
  },
  greater_baton_rouge_aor: {
    isActive: !0,
    resoID: "M00000298",
    constellation1ID: void 0,
    longName: "Greater Baton Rouge Association of Realtors",
    shortName: "Greater Baton Rouge Association of Realtors",
    abodeMLSName: "Greater Baton Rouge Association of Realtors"
  },
  greater_binghamton_aor: {
    isActive: !0,
    resoID: "M00000470",
    constellation1ID: void 0,
    longName: "Greater Binghamton AOR",
    shortName: "Greater Binghamton AOR",
    abodeMLSName: "Greater Binghamton AOR"
  },
  greater_capital_region_multiple_listing_service: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Greater Capital Region Multiple Listing Service",
    shortName: "Greater Capital Region Multiple Listing Service"
  },
  greater_el_paso_association_of_realtors: {
    isActive: !0,
    resoID: "M00000595",
    constellation1ID: void 0,
    longName: "Greater El Paso Association of Realtors",
    shortName: "Greater El Paso Association of Realtors",
    abodeMLSName: "Greater El Paso Association of Realtors"
  },
  greater_erie_board_of_realtors_oh: {
    isActive: !0,
    resoID: "M00000540",
    constellation1ID: void 0,
    longName: "Greater Erie BOR",
    shortName: "Greater Erie BOR",
    abodeMLSName: "Greater Erie BOR"
  },
  greater_fairbanks_board_of_realtors_mls: {
    isActive: !0,
    resoID: "M00000002",
    constellation1ID: void 0,
    longName: "Greater Fairbanks Board of Realtors MLS",
    shortName: "Greater Fairbanks Board of Realtors MLS",
    abodeMLSName: "Greater Fairbanks Board of Realtors MLS"
  },
  greater_greenville_association_mls: {
    isActive: !0,
    resoID: "M00000365",
    constellation1ID: void 0,
    longName: "Greater Greenville Association of Realtors",
    shortName: "Greater Greenville Association of Realtors",
    abodeMLSName: "Greater Greenville Association of Realtors"
  },
  greater_lansing_association_of_realtors: {
    isActive: !0,
    resoID: "M00000322",
    constellation1ID: void 0,
    longName: "Greater Lansing Association of Realtors",
    shortName: "Greater Lansing Association of Realtors",
    abodeMLSName: "Greater Lansing Association of Realtors"
  },
  greater_las_vegas_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Greater Las Vegas Association of Realtors",
    shortName: "Greater Las Vegas Association of Realtors",
    abodeMLSName: void 0
  },
  greater_lehigh_association_of_realtors: {
    isActive: !0,
    resoID: "M00000534",
    constellation1ID: void 0,
    longName: "Greater Lehigh Valley MLS",
    shortName: "Greater Lehigh Valley MLS",
    abodeMLSName: "Greater Lehigh Valley MLS"
  },
  greater_louisville_association_of_realtors: {
    isActive: !0,
    resoID: "M00000290",
    constellation1ID: void 0,
    longName: "Greater Louisville Association of Realtors",
    shortName: "Greater Louisville Association of Realtors",
    abodeMLSName: "Greater Louisville Association of Realtors"
  },
  greater_mcallen_association_of_realtors: {
    isActive: !0,
    resoID: "M00000608",
    constellation1ID: void 0,
    longName: "Greater McAllen Association of Realtors",
    shortName: "Greater McAllen Association of Realtors",
    abodeMLSName: "Greater McAllen Association of Realtors"
  },
  greater_northwest_indiana_association_of_realtors: {
    isActive: !0,
    resoID: "M00000259",
    constellation1ID: void 0,
    longName: "Greater Northwest Indiana Association of Realtors",
    shortName: "Greater Northwest Indiana Association of Realtors",
    abodeMLSName: "Greater Northwest Indiana Association of Realtors"
  },
  greater_pocatello_association_on_realtors: {
    isActive: !0,
    resoID: "M00000233",
    constellation1ID: void 0,
    longName: "Greater Pocatello Association on Realtors",
    shortName: "Greater Pocatello Association on Realtors",
    abodeMLSName: "Pocatello Board of Realtors"
  },
  greater_scranton_board_of_realtors: {
    isActive: !0,
    resoID: "M00000536",
    constellation1ID: void 0,
    longName: "Greater Scranton Board of Realtors",
    shortName: "Greater Scranton Board of Realtors",
    abodeMLSName: "Greater Scranton Board of Realtors"
  },
  greater_southern_mls: {
    isActive: !0,
    resoID: "M00000083",
    constellation1ID: void 0,
    longName: "Greater Southern MLS (Lake Charles)/Southwest Louisiana Association of Realtors",
    shortName: "Greater Southern MLS (Lake Charles)/Southwest Louisiana Association of Realtors",
    abodeMLSName: "Greater Southern MLS (Lake Charles)/Southwest Louisiana Association of Realtors"
  },
  greater_tyler_association_of_realtors: {
    isActive: !0,
    resoID: "M00000621",
    constellation1ID: void 0,
    longName: "Greater Tyler Association of Realtors",
    shortName: "Greater Tyler Association of Realtors",
    abodeMLSName: "Greater Tyler Association of Realtors"
  },
  greenbrier_valley_board_of_realtors: {
    isActive: !0,
    resoID: "M00000669",
    constellation1ID: void 0,
    longName: "Greenbrier Valley Board of Realtors",
    shortName: "Greenbrier Valley Board of Realtors",
    abodeMLSName: "Greenbrier Valley Board of Realtors"
  },
  greenwich_association_of_realtors: {
    isActive: !0,
    resoID: "M00000125",
    constellation1ID: void 0,
    longName: "Greenwich Board of Realtors MLS",
    shortName: "Greenwich Board of Realtors MLS",
    abodeMLSName: "Greenwich Board of Realtors MLS"
  },
  greenwood_association: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Greenwood Association",
    shortName: "Greenwood Association",
    abodeMLSName: void 0
  },
  harlingen_board_of_realtors_mls_rio_grande_valley_multiple_listing_service: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Harlingen Board of Realtors MLS / Rio Grande Valley Multiple Listing Service",
    shortName: "Harlingen Board of Realtors MLS / Rio Grande Valley Multiple Listing Service",
    abodeMLSName: void 0
  },
  hastings_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Hastings Board of Realtors",
    shortName: "Hastings Board of Realtors",
    abodeMLSName: void 0
  },
  gulf_coast_mls: {
    isActive: !0,
    resoID: "M00000018",
    constellation1ID: void 0,
    longName: "Gulf Coast MLS",
    shortName: "Gulf Coast MLS",
    abodeMLSName: "Gulf Coast MLS"
  },
  hattiesburg_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000367",
    constellation1ID: void 0,
    longName: "Hattiesburg Area Association of Realtors",
    shortName: "Hattiesburg Area Association of Realtors",
    abodeMLSName: "Hattiesburg Area Association of Realtors"
  },
  hawaii_information_service_mls: {
    isActive: !0,
    resoID: "M00000193",
    constellation1ID: void 0,
    longName: "Hawaii Information System",
    shortName: "Hawaii Information System",
    abodeMLSName: "Hawaii Information System"
  },
  heart_of_missouri_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Heart of Missouri Board of REALTORS",
    shortName: "Heart of Missouri Board of REALTORS",
    abodeMLSName: void 0
  },
  heart_of_iowa_association_of_realtors: {
    isActive: !0,
    resoID: "M00000205",
    constellation1ID: void 0,
    longName: "Heart of Iowa Association of Realtors",
    shortName: "Heart of Iowa Association of Realtors",
    abodeMLSName: "Heart of Iowa Association of Realtors"
  },
  henderson_county_board_of_realtors: {
    isActive: !0,
    resoID: "M00000740",
    constellation1ID: void 0,
    longName: "Henderson County BOR",
    shortName: "Henderson County BOR",
    abodeMLSName: "Henderson County BOR"
  },
  hernando_county_association_of_realtors: {
    isActive: !0,
    resoID: "M00000131",
    constellation1ID: void 0,
    longName: "Hernando County Association of REALTORS/MLS",
    shortName: "Hernando County Association of REALTORS/MLS",
    abodeMLSName: "Hernando County Association of REALTORS/MLS"
  },
  hi_central_mls: {
    isActive: !0,
    resoID: "M00000194",
    constellation1ID: void 0,
    longName: "Hi-Central MLS",
    shortName: "Hi-Central MLS",
    abodeMLSName: "Hi-Central MLS"
  },
  high_country_association_of_realtors: {
    isActive: !0,
    resoID: "M00000387",
    constellation1ID: void 0,
    longName: "High Country AOR",
    shortName: "High Country AOR",
    abodeMLSName: "High Country AOR"
  },
  highland_lakes_association_of_realtors: {
    isActive: !0,
    resoID: "M00000606",
    constellation1ID: void 0,
    longName: "Highland Lakes BOR",
    shortName: "Highland Lakes BOR",
    abodeMLSName: "Highland Lakes BOR"
  },
  highlands_cashiers_board_of_realtors: {
    isActive: !0,
    resoID: "M00000390",
    constellation1ID: void 0,
    longName: "Highlands Cashiers Board of Realtors MLS",
    shortName: "Highlands Cashiers Board of Realtors MLS",
    abodeMLSName: "Highlands Cashiers Board of Realtors MLS"
  },
  hilton_head_mls_resides: {
    isActive: !0,
    resoID: "M00000564",
    constellation1ID: void 0,
    longName: "Hilton Head Area Association of Realtors",
    shortName: "Hilton Head Area Association of Realtors",
    abodeMLSName: "Hilton Head Area Association of Realtors"
  },
  honolulu_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Honolulu Board of Realtors",
    shortName: "Honolulu Board of Realtors",
    abodeMLSName: void 0
  },
  hot_springs_mls: {
    isActive: !0,
    resoID: "M00000029",
    constellation1ID: void 0,
    longName: "Hot Springs MLS",
    shortName: "Hot Springs MLS",
    abodeMLSName: "Hot Springs MLS"
  },
  hudson_county_mls: {
    isActive: !0,
    resoID: "M00000784",
    constellation1ID: void 0,
    longName: "Hudson MLS",
    shortName: "Hudson MLS",
    abodeMLSName: "Hudson MLS"
  },
  humboldt_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Humboldt Association of Realtors",
    shortName: "Humboldt Association of Realtors",
    abodeMLSName: void 0
  },
  huntington_board_of_realtors: {
    isActive: !0,
    resoID: "M00000668",
    constellation1ID: void 0,
    longName: "Huntington Board of Realtors",
    shortName: "Huntington Board of Realtors",
    abodeMLSName: "Huntington Board of Realtors"
  },
  idyllwild: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Idyllwild",
    shortName: "Idyllwild",
    abodeMLSName: void 0
  },
  imperial_county_aor: {
    isActive: !0,
    resoID: "M00000058",
    constellation1ID: void 0,
    longName: "Imperial County AOR",
    shortName: "Imperial County AOR",
    abodeMLSName: "Imperial County AOR"
  },
  incline_village_board_of_realtors: {
    isActive: !0,
    resoID: "M00000465",
    constellation1ID: void 0,
    longName: "Incline Village Board of Realtors",
    shortName: "Incline Village Board of Realtors",
    abodeMLSName: "Incline Village Board of Realtors"
  },
  indian_river_association_of_realtors_mls: {
    isActive: !0,
    resoID: "M00000169",
    constellation1ID: void 0,
    longName: "Indian River Association of Realtors MLS",
    shortName: "Indian River Association of Realtors MLS",
    abodeMLSName: "Indian River Association of Realtors MLS"
  },
  intermountain_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000225",
    constellation1ID: void 0,
    longName: "Intermountain MLS",
    shortName: "Intermountain MLS",
    abodeMLSName: "Intermountain MLS"
  },
  iowa_city_area: {
    isActive: !0,
    resoID: "M00000206",
    constellation1ID: void 0,
    longName: "Iowa City Area Association of Realtors",
    shortName: "Iowa City Area Association of Realtors",
    abodeMLSName: "Iowa City Area Association of Realtors"
  },
  iowa_great_lakes: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Iowa Great Lakes",
    shortName: "Iowa Great Lakes",
    abodeMLSName: void 0
  },
  ires_regional_mls_of_northern_colorado: {
    isActive: !0,
    resoID: "M00000118",
    constellation1ID: void 0,
    longName: "IRES",
    shortName: "IRES",
    abodeMLSName: "IRES"
  },
  ithaca_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Ithaca Board of Realtors",
    shortName: "Ithaca Board of Realtors",
    abodeMLSName: void 0
  },
  jasper_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Jasper Association of REALTORS",
    shortName: "Jasper Association of REALTORS",
    abodeMLSName: void 0
  },
  jefferson_city_area_board_of_realtors: {
    isActive: !0,
    resoID: "M00000353",
    constellation1ID: void 0,
    longName: "Jefferson City Area Board of Realtors",
    shortName: "Jefferson City Area Board of Realtors",
    abodeMLSName: "Jefferson City Area Board of Realtors"
  },
  jonesboro_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Jonesboro Board of Realtors",
    shortName: "Jonesboro Board of Realtors",
    abodeMLSName: void 0
  },
  kanab_listing_service: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Kanab Listing Service",
    shortName: "Kanab Listing Service",
    abodeMLSName: void 0
  },
  kanawha_valley_board_of_realtors: {
    isActive: !0,
    resoID: "M00000667",
    constellation1ID: void 0,
    longName: "Kanawha Valley Board of Realtors",
    shortName: "Kanawha Valley Board of Realtors",
    abodeMLSName: "Kanawha Valley Board of Realtors"
  },
  kerrville_bor: {
    isActive: !0,
    resoID: "M00000600",
    constellation1ID: void 0,
    longName: "Kerrville BOR",
    shortName: "Kerrville BOR",
    abodeMLSName: "Kerrville BOR"
  },
  key_west_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Key West Association of Realtors",
    shortName: "Key West Association of Realtors",
    abodeMLSName: void 0
  },
  kings_county_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Kings County Board of Realtors",
    shortName: "Kings County Board of Realtors",
    abodeMLSName: void 0
  },
  lake_country_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Lake Country Board of Realtors",
    shortName: "Lake Country Board of Realtors",
    abodeMLSName: void 0
  },
  lake_havasu_mls: {
    isActive: !0,
    resoID: "M00000832",
    constellation1ID: void 0,
    longName: "Lake Havasu AOR",
    shortName: "Lake Havasu AOR",
    abodeMLSName: "Lake Havasu AOR"
  },
  lake_martin: {
    isActive: !0,
    resoID: "M00000004",
    constellation1ID: void 0,
    longName: "Lake Martin Area AOR",
    shortName: "Lake Martin Area AOR",
    abodeMLSName: "Lake Martin Area AOR"
  },
  lakeway_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000584",
    constellation1ID: void 0,
    longName: "Lakeway Area Association of Realtors",
    shortName: "Lakeway Area Association of Realtors",
    abodeMLSName: "Lakeway Area Association of Realtors"
  },
  laredo_bor: {
    isActive: !0,
    resoID: "M00000603",
    constellation1ID: void 0,
    longName: "Laredo BOR",
    shortName: "Laredo BOR",
    abodeMLSName: "Laredo BOR"
  },
  lawrence_mls: {
    isActive: !0,
    resoID: "M00000269",
    constellation1ID: void 0,
    longName: "Lawrence BOR",
    shortName: "Lawrence BOR",
    abodeMLSName: "Lawrence BOR"
  },
  lee_county_association: {
    isActive: !0,
    resoID: "M00000008",
    constellation1ID: void 0,
    longName: "Lee County AOR MLS",
    shortName: "Lee County AOR MLS",
    abodeMLSName: "Lee County AOR MLS"
  },
  link_nantucket: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Link Nantucket",
    shortName: "Link Nantucket",
    abodeMLSName: void 0
  },
  lmperial_county: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "lmperial County",
    shortName: "lmperial County",
    abodeMLSName: void 0
  },
  longleaf_pine_realtors: {
    isActive: !0,
    resoID: "M00000394",
    constellation1ID: void 0,
    longName: "Longleaf Pine REALTORS (Fayetteville)",
    shortName: "Longleaf Pine REALTORS (Fayetteville)",
    abodeMLSName: "Longleaf Pine REALTORS (Fayetteville)"
  },
  longview_association: {
    isActive: !0,
    resoID: "M00000604",
    constellation1ID: void 0,
    longName: "Longview Association of Realtors",
    shortName: "Longview Association of Realtors",
    abodeMLSName: "Longview Association of Realtors"
  },
  low_country_mls: {
    isActive: !0,
    resoID: "M00000557",
    constellation1ID: void 0,
    longName: "Low Country Regional MLS (Beaufort County Association of Realtors)",
    shortName: "Low Country Regional MLS (Beaufort County Association of Realtors)",
    abodeMLSName: "Low Country Regional MLS (Beaufort County Association of Realtors)"
  },
  lubbock_association_of_realtors: {
    isActive: !0,
    resoID: "M00000811",
    constellation1ID: void 0,
    longName: "Lubbock Association of Realtors",
    shortName: "Lubbock Association of Realtors",
    abodeMLSName: "Lubbock Association of Realtors"
  },
  luzerne_county_association_of_realtors_greater_wilkes_barre_association_of_realtors: {
    isActive: !0,
    resoID: "M00000545",
    constellation1ID: void 0,
    longName: "Luzerne County Association of REALTORS (was Greater Wilkes-Barre Association of Realtors)",
    shortName: "Luzerne County Association of REALTORS (was Greater Wilkes-Barre Association of Realtors)",
    abodeMLSName: "Luzerne County Association of REALTORS (was Greater Wilkes-Barre Association of Realtors)"
  },
  lynchburg_association_of_realtors: {
    isActive: !0,
    resoID: "M00000641",
    constellation1ID: void 0,
    longName: "Lynchburg Board of Realtors",
    shortName: "Lynchburg Board of Realtors",
    abodeMLSName: "Lynchburg Board of Realtors"
  },
  maine_real_estate_information_system: {
    isActive: !0,
    resoID: "M00000311",
    constellation1ID: void 0,
    longName: "Maine Listings",
    shortName: "Maine Listings",
    abodeMLSName: "Maine Listings"
  },
  mansfield_board_of_realtors_oh: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mansfield Board of Realtors , OH",
    shortName: "Mansfield Board of Realtors , OH",
    abodeMLSName: void 0
  },
  mammoth_lakes_board_of_realtors: {
    isActive: !0,
    resoID: "M00000073",
    constellation1ID: void 0,
    longName: "Mammoth Lakes Board of Realtors",
    shortName: "Mammoth Lakes Board of Realtors",
    abodeMLSName: "Mammoth Lakes Board of Realtors"
  },
  marco_multi_list_mls: {
    isActive: !0,
    resoID: "M00000148",
    constellation1ID: void 0,
    longName: "Marco Multi List",
    shortName: "Marco Multi List",
    abodeMLSName: "Marco Multi List, Inc."
  },
  mason_city_greater: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mason City, Greater",
    shortName: "Mason City, Greater",
    abodeMLSName: void 0
  },
  max_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Max MLS (bridge MLS)",
    shortName: "Max MLS (bridge MLS)",
    abodeMLSName: void 0
  },
  maui_board_of_reatlors: {
    isActive: !0,
    resoID: "M00000195",
    constellation1ID: void 0,
    longName: "Maui Board of Reatlors",
    shortName: "Maui Board of Reatlors",
    abodeMLSName: "Maui Board of Reatlors"
  },
  memphis_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000583",
    constellation1ID: void 0,
    longName: "Memphis Area Association of Realtors",
    shortName: "Memphis Area Association of Realtors",
    abodeMLSName: "Memphis Area Association of Realtors"
  },
  mercer_tazewell_county_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mercer - Tazewell County Board of REALTORS",
    shortName: "Mercer - Tazewell County Board of REALTORS",
    abodeMLSName: void 0
  },
  metro_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Metro MLS",
    shortName: "Metro MLS",
    abodeMLSName: void 0
  },
  metropolitan_indianapolis_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Metropolitan Indianapolis Board of Realtors",
    shortName: "Metropolitan Indianapolis Board of Realtors",
    abodeMLSName: void 0
  },
  mi_realsource: {
    isActive: !0,
    resoID: "M00000331",
    constellation1ID: void 0,
    longName: "MI RealSource",
    shortName: "MI RealSource",
    abodeMLSName: "MI RealSource"
  },
  michigan_regional_information_center: {
    isActive: !0,
    resoID: "T00000006",
    constellation1ID: void 0,
    longName: "Michigan Regional Information Center",
    shortName: "Michigan Regional Information Center",
    abodeMLSName: "Michigan Regional Information Center"
  },
  mid_georgia_multiple_listing_service_ga: {
    isActive: !0,
    resoID: "M00000184",
    constellation1ID: void 0,
    longName: "Middle Georgia MLS",
    shortName: "Middle Georgia MLS",
    abodeMLSName: "Middle Georgia MLS"
  },
  mid_ks_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mid KS MLS",
    shortName: "Mid KS MLS",
    abodeMLSName: void 0
  },
  midamerica_regional_information_systems: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "MidAmerica Regional Information Systems",
    shortName: "MidAmerica Regional Information Systems",
    abodeMLSName: void 0
  },
  middle_tennessee_regional_mls_realtracs: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Middle Tennessee Regional MLS / Realtracs",
    shortName: "Middle Tennessee Regional MLS / Realtracs",
    abodeMLSName: void 0
  },
  middlesex_county_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Middlesex County MLS (Central Jersey MLS)",
    shortName: "Middlesex County MLS (Central Jersey MLS)",
    abodeMLSName: void 0
  },
  midhudson_multiple_listing_service: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "MidHudson Multiple Listing Service",
    shortName: "MidHudson Multiple Listing Service",
    abodeMLSName: void 0
  },
  midwest_minnesota_regional_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Midwest Minnesota Regional MLS",
    shortName: "Midwest Minnesota Regional MLS",
    abodeMLSName: void 0
  },
  minot_board_of_realtors: {
    isActive: !0,
    resoID: "M00000431",
    constellation1ID: void 0,
    longName: "Minot Board of Realtors",
    shortName: "Minot Board of Realtors",
    abodeMLSName: "Minot Board of Realtors"
  },
  mls_listings: {
    isActive: !0,
    resoID: "M00000101",
    constellation1ID: void 0,
    longName: "MLS Listings",
    shortName: "MLS Listings",
    abodeMLSName: "MLS Listings"
  },
  mls_of_columbus_realtors: {
    isActive: !0,
    resoID: "M00000495",
    constellation1ID: void 0,
    longName: "MLS of Columbus Realtors",
    shortName: "MLS of Columbus Realtors",
    abodeMLSName: "MLS of Columbus Realtors"
  },
  mls_of_greater_cincinnati: {
    isActive: !0,
    resoID: "M00000494",
    constellation1ID: void 0,
    longName: "MLS of Greater Cincinnati",
    shortName: "MLS of Greater Cincinnati",
    abodeMLSName: "MLS of Greater Cincinnati"
  },
  mls_of_southern_arizona: {
    isActive: !0,
    resoID: "M00000049",
    constellation1ID: void 0,
    longName: "MLS of Southern Arizona (MLSSAZ-aka Tucson AOR)",
    shortName: "MLS of Southern Arizona (MLSSAZ-aka Tucson AOR)",
    abodeMLSName: "MLS of Southern Arizona (MLSSAZ-aka Tucson AOR)"
  },
  mobile_area_asociation_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mobile Area Asociation of Realtors",
    shortName: "Mobile Area Asociation of Realtors",
    abodeMLSName: void 0
  },
  monmouthocean_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000452",
    constellation1ID: void 0,
    longName: "Monmouth County Board of Realtors",
    shortName: "Monmouth County Board of Realtors",
    abodeMLSName: "Monmouth County Board of Realtors"
  },
  montana_regional_mls: {
    isActive: !0,
    resoID: "M00000383",
    constellation1ID: void 0,
    longName: "Montana Regional MLS",
    shortName: "Montana Regional MLS",
    abodeMLSName: "Montana Regional MLS"
  },
  montgomery_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000020",
    constellation1ID: void 0,
    longName: "Montgomery AreaAOR/MLS",
    shortName: "Montgomery AreaAOR/MLS",
    abodeMLSName: "Montgomery AreaAOR/MLS"
  },
  mount_rushmore_mls: {
    isActive: !0,
    resoID: "M00000573",
    constellation1ID: void 0,
    longName: "Mount Rushmore AOR MLS",
    shortName: "Mount Rushmore AOR MLS",
    abodeMLSName: "Mount Rushmore AOR MLS"
  },
  mountain_central_association_of_realtors: {
    isActive: !0,
    resoID: "M00000231",
    constellation1ID: void 0,
    longName: "Mountain Central AOR",
    shortName: "Mountain Central AOR",
    abodeMLSName: "Mountain Central AOR"
  },
  mountain_home_mls_north_central_bor: {
    isActive: !0,
    resoID: "M00000033",
    constellation1ID: void 0,
    longName: "Mountain Home MLS/North Central BOR",
    shortName: "Mountain Home MLS/North Central BOR",
    abodeMLSName: "Mountain Home MLS/North Central BOR"
  },
  navarre_area_bor: {
    isActive: !0,
    resoID: "M00000153",
    constellation1ID: void 0,
    longName: "Navarre Area BOR",
    shortName: "Navarre Area BOR",
    abodeMLSName: "Navarre Area BOR"
  },
  muscatine_county: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Muscatine County",
    shortName: "Muscatine County",
    abodeMLSName: void 0
  },
  new_canaan_board_of_realtors: {
    isActive: !0,
    resoID: "M00000127",
    constellation1ID: void 0,
    longName: "NEW Canaan Association of Realtors MLS",
    shortName: "NEW Canaan Association of Realtors MLS",
    abodeMLSName: "NEW Canaan Association of Realtors MLS"
  },
  new_england_real_estate_network: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "New England Real Estate Network (NEREN)",
    shortName: "New England Real Estate Network (NEREN)",
    abodeMLSName: void 0
  },
  new_jersey_mls: {
    isActive: !0,
    resoID: "M00000448",
    constellation1ID: void 0,
    longName: "New Jersey MLS",
    shortName: "New Jersey MLS",
    abodeMLSName: "New Jersey MLS"
  },
  new_mexico_mls: {
    isActive: !0,
    resoID: "M00000462",
    constellation1ID: void 0,
    longName: "New Mexico MLS",
    shortName: "New Mexico MLS",
    abodeMLSName: "New Mexico MLS"
  },
  new_river_valley_association_of_realtors_va: {
    isActive: !0,
    resoID: "M00000634",
    constellation1ID: void 0,
    longName: "New River Valley Association of Realtors",
    shortName: "New River Valley Association of Realtors",
    abodeMLSName: "New River Valley Association of Realtors"
  },
  new_york_state_alliance_of_mls: {
    isActive: !0,
    resoID: "T00000077",
    constellation1ID: void 0,
    longName: "New York State Alliance of MLSs (NYSAMLS/GENRIS/CNYIS/WNYREIS)",
    shortName: "New York State Alliance of MLSs (NYSAMLS/GENRIS/CNYIS/WNYREIS)",
    abodeMLSName: "New York State Alliance of MLSs (NYSAMLS/GENRIS/CNYIS/WNYREIS)"
  },
  norfolk_ne_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Norfolk NE Board of Realtors",
    shortName: "Norfolk NE Board of Realtors",
    abodeMLSName: void 0
  },
  north_alabama_real_estate_information_services_al: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "North Alabama Real Estate Information Services, AL",
    shortName: "North Alabama Real Estate Information Services, AL",
    abodeMLSName: void 0
  },
  north_central_iowa_regional: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "North Central Iowa Regional",
    shortName: "North Central Iowa Regional",
    abodeMLSName: void 0
  },
  north_central_washington_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "North Central Washington Association of Realtors",
    shortName: "North Central Washington Association of Realtors",
    abodeMLSName: void 0
  },
  north_central_west_virginia: {
    isActive: !0,
    resoID: "M00000666",
    constellation1ID: void 0,
    longName: "North Central West Virginia Real Estate",
    shortName: "North Central West Virginia Real Estate",
    abodeMLSName: "North Central West Virginia Real Estate"
  },
  northeast_ar_aor: {
    isActive: !0,
    resoID: "M00000030",
    constellation1ID: void 0,
    longName: "Northeast AR AOR",
    shortName: "Northeast AR AOR",
    abodeMLSName: "Northeast AR AOR"
  },
  northeast_central_aor_mls: {
    isActive: !0,
    resoID: "M00000771",
    constellation1ID: void 0,
    longName: "NorthEast Central AOR MLS",
    shortName: "NorthEast Central AOR MLS",
    abodeMLSName: "NorthEast Central AOR MLS"
  },
  northeast_florida_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northeast Florida MLS",
    shortName: "Northeast Florida MLS",
    abodeMLSName: void 0
  },
  northeast_georgia_board_of_realtors: {
    isActive: !0,
    resoID: "M00000848",
    constellation1ID: void 0,
    longName: "Northeast Georgia BOR (NEGBOR)",
    shortName: "Northeast Georgia BOR (NEGBOR)",
    abodeMLSName: "Northeast Georgia BOR (NEGBOR)"
  },
  northeast_ia_regional_mls: {
    isActive: !0,
    resoID: "M00000221",
    constellation1ID: void 0,
    longName: "Northeast IA Regional MLS",
    shortName: "Northeast IA Regional MLS",
    abodeMLSName: "Northeast IA Regional MLS"
  },
  northeast_louisiana_board_of_realtors: {
    isActive: !0,
    resoID: "M00000303",
    constellation1ID: void 0,
    longName: "Northeast Louisiana Association of Realtors",
    shortName: "Northeast Louisiana Association of Realtors",
    abodeMLSName: "Northeast Louisiana Association of Realtors"
  },
  northeast_mississippi_board_of_realtors: {
    isActive: !0,
    resoID: "M00000376",
    constellation1ID: void 0,
    longName: "Northeast Mississippi Board of Realtors",
    shortName: "Northeast Mississippi Board of Realtors",
    abodeMLSName: "Northeast Mississippi Board of Realtors"
  },
  northeast_oklahoma_aor: {
    isActive: !0,
    resoID: "M00000515",
    constellation1ID: void 0,
    longName: "Northeast Oklahoma AOR",
    shortName: "Northeast Oklahoma AOR",
    abodeMLSName: "Northeast Oklahoma AOR"
  },
  northeast_wisconsin_association_of_realtors: {
    isActive: !0,
    resoID: "M00000657",
    constellation1ID: void 0,
    longName: "Northeast Wisconsin Association of Realtors",
    shortName: "Northeast Wisconsin Association of Realtors",
    abodeMLSName: "Northeast Wisconsin Association of Realtors"
  },
  northern_arizona_assoc_of_realtors: {
    isActive: !0,
    resoID: "M00000040",
    constellation1ID: void 0,
    longName: "Northern Arizona Assocation of Realtors MLS",
    shortName: "Northern Arizona Assocation of Realtors MLS",
    abodeMLSName: "Northern Arizona Assocation of Realtors MLS"
  },
  northern_great_lakes_mls: {
    isActive: !0,
    resoID: "M00000330",
    constellation1ID: void 0,
    longName: "Northern Great Lakes Realtors MLS",
    shortName: "Northern Great Lakes Realtors MLS",
    abodeMLSName: "Northern Great Lakes Realtors MLS"
  },
  northern_jackson_county_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northern Jackson County MLS",
    shortName: "Northern Jackson County MLS",
    abodeMLSName: void 0
  },
  northern_kentucky_association_of_realtors: {
    isActive: !0,
    resoID: "M00000284",
    constellation1ID: void 0,
    longName: "Northern Kentucky Association of Realtors",
    shortName: "Northern Kentucky Association of Realtors",
    abodeMLSName: "Northern Kentucky Association of Realtors"
  },
  northern_michigan_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northern Michigan MLS",
    shortName: "Northern Michigan MLS",
    abodeMLSName: void 0
  },
  northern_nevada_regional_mls: {
    isActive: !0,
    resoID: "M00000467",
    constellation1ID: void 0,
    longName: "Northern Nevada Regional MLS",
    shortName: "Northern Nevada Regional MLS",
    abodeMLSName: "Northern Nevada Regional MLS"
  },
  northern_santa_barbara_county_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northern Santa Barbara County MLS",
    shortName: "Northern Santa Barbara County MLS",
    abodeMLSName: void 0
  },
  northwest_arkansas_board_of_realtors_mls: {
    isActive: !0,
    resoID: "M00000035",
    constellation1ID: void 0,
    longName: "Northwest Arkansas Associaton of Realtors MLS",
    shortName: "Northwest Arkansas Associaton of Realtors MLS",
    abodeMLSName: "Northwest Arkansas Associaton of Realtors MLS"
  },
  northwest_association_ms: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northwest Association, MS (MLS United)",
    shortName: "Northwest Association, MS (MLS United)",
    abodeMLSName: void 0
  },
  northwest_illinois_alliance_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "NorthWest Illinois Alliance of REALTORS (formerly Rockford Area REALTORS )",
    shortName: "NorthWest Illinois Alliance of REALTORS (formerly Rockford Area REALTORS )",
    abodeMLSName: void 0
  },
  northwest_iowa_regional: {
    isActive: !0,
    resoID: "M00000224",
    constellation1ID: void 0,
    longName: "Northwest IA Regionial BOR",
    shortName: "Northwest IA Regionial BOR",
    abodeMLSName: "Northwest IA Regionial BOR"
  },
  northwest_ohio_real_estate_information_systems: {
    isActive: !0,
    resoID: "M00000505",
    constellation1ID: void 0,
    longName: "Northwest Ohio Real Estate Information System",
    shortName: "Northwest Ohio Real Estate Information System",
    abodeMLSName: "Northwest Ohio Real Estate Information System"
  },
  northwest_oklahoma_associaton_of_realtors: {
    isActive: !0,
    resoID: "M00000514",
    constellation1ID: void 0,
    longName: "Northwest Oklahoma Associaton of Realtors",
    shortName: "Northwest Oklahoma Associaton of Realtors",
    abodeMLSName: "Northwest Oklahoma Associaton of Realtors"
  },
  northwest_wyoming_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northwest Wyoming Board of Realtors",
    shortName: "Northwest Wyoming Board of Realtors",
    abodeMLSName: void 0
  },
  northwoods_association_of_realtors: {
    isActive: !0,
    resoID: "M00000663",
    constellation1ID: void 0,
    longName: "Northwoods Association of Realtors",
    shortName: "Northwoods Association of Realtors",
    abodeMLSName: "Northwoods Association of Realtors"
  },
  odessa_bor: {
    isActive: !0,
    resoID: "M00000736",
    constellation1ID: void 0,
    longName: "Odessa BOR",
    shortName: "Odessa BOR",
    abodeMLSName: "Odessa BOR"
  },
  oregon_data_share: {
    isActive: !0,
    resoID: "T00000038",
    constellation1ID: void 0,
    longName: "Oregon Data Share",
    shortName: "Oregon Data Share",
    abodeMLSName: "Oregon Data Share"
  },
  outer_banks_association_of_realtors: {
    isActive: !0,
    resoID: "M00000409",
    constellation1ID: void 0,
    longName: "Outer Banks Association of Realtors",
    shortName: "Outer Banks Association of Realtors",
    abodeMLSName: "Outer Banks Association of Realtors"
  },
  ozark_gateway_association_of_realtors: {
    isActive: !0,
    resoID: "M00000354",
    constellation1ID: void 0,
    longName: "Ozark Gateway AOR",
    shortName: "Ozark Gateway AOR",
    abodeMLSName: "Ozark Gateway AOR"
  },
  pacific_regional_mls: {
    isActive: !0,
    resoID: "M00000648",
    constellation1ID: void 0,
    longName: "Pacific Regional MLS",
    shortName: "Pacific Regional MLS",
    abodeMLSName: "Pacific Regional MLS"
  },
  park_city_board_of_realtors: {
    isActive: !0,
    resoID: "M00000627",
    constellation1ID: void 0,
    longName: "Park City Board Services",
    shortName: "Park City Board Services",
    abodeMLSName: "Park City Board Services"
  },
  pensacola_association_of_realtors: {
    isActive: !0,
    resoID: "M00000161",
    constellation1ID: void 0,
    longName: "Pensacola Association of Realtors",
    shortName: "Pensacola Association of Realtors",
    abodeMLSName: "Pensacola Association of Realtors"
  },
  perchwell: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Perchwell (NYC)",
    shortName: "Perchwell (NYC)",
    abodeMLSName: void 0
  },
  permian_basin_board_of_realtors: {
    isActive: !0,
    resoID: "M00000737",
    constellation1ID: void 0,
    longName: "Permian Basin Association of Realtors",
    shortName: "Permian Basin Association of Realtors",
    abodeMLSName: "Permian Basin Association of Realtors"
  },
  pike_wayne_association_of_realtors: {
    isActive: !0,
    resoID: "M00000721",
    constellation1ID: void 0,
    longName: "Pike Wayne Association of Realtors",
    shortName: "Pike Wayne Association of Realtors",
    abodeMLSName: "Pike Wayne Association of Realtors"
  },
  pikes_peak_association_of_realtors: {
    isActive: !0,
    resoID: "M00000111",
    constellation1ID: void 0,
    longName: "Pikes Peak REALTOR Services Corporation",
    shortName: "Pikes Peak REALTOR Services Corporation",
    abodeMLSName: "Pikes Peak REALTOR Services Corporation"
  },
  pinehurst_southern_pines_area_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Pinehurst Southern Pines Area Association of Realtors",
    shortName: "Pinehurst Southern Pines Area Association of Realtors",
    abodeMLSName: void 0
  },
  plumas_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Plumas Association of Realtors",
    shortName: "Plumas Association of Realtors",
    abodeMLSName: void 0
  },
  pocono_mountain_mls: {
    isActive: !0,
    resoID: "M00000552",
    constellation1ID: void 0,
    longName: "Pocono Mountains Association of Realtors",
    shortName: "Pocono Mountains Association of Realtors",
    abodeMLSName: "Pocono Mountains Association of Realtors"
  },
  port_neches_port_arthur_and_nederland_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Port Neches Port Arthur and Nederland Board of REALTORS",
    shortName: "Port Neches Port Arthur and Nederland Board of REALTORS",
    abodeMLSName: void 0
  },
  prescott_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000044",
    constellation1ID: void 0,
    longName: "Presott Area Association of Realtors MLS",
    shortName: "Presott Area Association of Realtors MLS",
    abodeMLSName: "Presott Area Association of Realtors MLS"
  },
  pueblo_association: {
    isActive: !0,
    resoID: "M00000120",
    constellation1ID: void 0,
    longName: "Pueblo Board of Realtors MLS",
    shortName: "Pueblo Board of Realtors MLS",
    abodeMLSName: "Pueblo Board of Realtors MLS"
  },
  quad_city_area: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Quad City Area",
    shortName: "Quad City Area",
    abodeMLSName: void 0
  },
  range_area_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Range Area MLS",
    shortName: "Range Area MLS",
    abodeMLSName: void 0
  },
  real_comp: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Real Comp",
    shortName: "Real Comp",
    abodeMLSName: void 0
  },
  real_estate_board_of_new_york_620a: {
    isActive: !0,
    resoID: "T00000046",
    constellation1ID: void 0,
    longName: "Real Estate Board of NEW York 620A",
    shortName: "Real Estate Board of NEW York 620A",
    abodeMLSName: "Real Estate Board of NEW York 620A"
  },
  real_estate_information_network: {
    isActive: !0,
    resoID: "M00000646",
    constellation1ID: void 0,
    longName: "Real Estate Information Network",
    shortName: "Real Estate Information Network",
    abodeMLSName: "Real Estate Information Network"
  },
  real_estate_information_services: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Real Estate Information Services (REALTOR Association of Southern Kentucky)",
    shortName: "Real Estate Information Services (REALTOR Association of Southern Kentucky)",
    abodeMLSName: void 0
  },
  realtor_association_of_citrus_county: {
    isActive: !0,
    resoID: "M00000145",
    constellation1ID: void 0,
    longName: "Realtor Association of Citrus County",
    shortName: "Realtor Association of Citrus County",
    abodeMLSName: "Realtor Association of Citrus County"
  },
  realtor_association_of_franklin_and_southern_gulf_counties: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtor Association of Franklin and Southern Gulf Counties",
    shortName: "Realtor Association of Franklin and Southern Gulf Counties",
    abodeMLSName: void 0
  },
  realtor_association_of_the_greater_pee_dee_sc: {
    isActive: !0,
    resoID: "M00000703",
    constellation1ID: void 0,
    longName: "Realtor Association of Greater Pee Dee",
    shortName: "Realtor Association of Greater Pee Dee",
    abodeMLSName: "Realtor Association of Greater Pee Dee"
  },
  realtor_association_of_martin_county_fl: {
    isActive: !0,
    resoID: "M00000165",
    constellation1ID: void 0,
    longName: "Realtor Association of Martin County FL",
    shortName: "Realtor Association of Martin County FL",
    abodeMLSName: "Martin County Realtors of the Treasure coast Inc"
  },
  realtor_association_of_southern_kentucky: {
    isActive: !0,
    resoID: "M00000281",
    constellation1ID: void 0,
    longName: "REALTOR Association of Southern Kentucky",
    shortName: "REALTOR Association of Southern Kentucky",
    abodeMLSName: "REALTOR Association of Southern Kentucky"
  },
  realtor_association_of_new_mexico: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtor Association of New Mexico",
    shortName: "Realtor Association of New Mexico",
    abodeMLSName: void 0
  },
  realtor_association_of_sioux_empire: {
    isActive: !0,
    resoID: "M00000572",
    constellation1ID: void 0,
    longName: "Realtor Association of the Sioux Empire",
    shortName: "Realtor Association of the Sioux Empire",
    abodeMLSName: "Realtor Association of the Sioux Empire"
  },
  realtor_association_of_southern_minnesota: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "REALTOR Association of Southern Minnesota",
    shortName: "REALTOR Association of Southern Minnesota",
    abodeMLSName: void 0
  },
  realtors_association_greater_fort_myers_the_beach: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtors Association Greater Fort Myers & The Beach",
    shortName: "Realtors Association Greater Fort Myers & The Beach",
    abodeMLSName: void 0
  },
  realtors_association_of_acadiana: {
    isActive: !0,
    resoID: "M00000300",
    constellation1ID: void 0,
    longName: "Realtors Association of Acadiana",
    shortName: "Realtors Association of Acadiana",
    abodeMLSName: "Realtors Association of Acadiana"
  },
  realtors_association_of_indian_river_county: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtors Association of Indian River County",
    shortName: "Realtors Association of Indian River County",
    abodeMLSName: void 0
  },
  realtors_association_of_maui: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtors Association of Maui",
    shortName: "Realtors Association of Maui",
    abodeMLSName: void 0
  },
  realtors_association_of_northeast_wisconsin: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "REALTORS Association of Northeast Wisconsin",
    shortName: "REALTORS Association of Northeast Wisconsin",
    abodeMLSName: void 0
  },
  realtors_association_of_northwestern_wisconsin: {
    isActive: !0,
    resoID: "M00000658",
    constellation1ID: void 0,
    longName: "Realtors Association of Northwest Wisconsin",
    shortName: "Realtors Association of Northwest Wisconsin",
    abodeMLSName: "Realtors Association of Northwest Wisconsin"
  },
  regional_multiple_listing_service_of_minnesota: {
    isActive: !0,
    resoID: "M00000343",
    constellation1ID: void 0,
    longName: "Realtors Association of Southern MN",
    shortName: "Realtors Association of Southern MN",
    abodeMLSName: "Realtors Association of Southern MN"
  },
  rhode_island_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Rhode Island Association of Realtors (State-Wide MLS)",
    shortName: "Rhode Island Association of Realtors (State-Wide MLS)",
    abodeMLSName: void 0
  },
  rio_grande_valley_mls: {
    isActive: !0,
    resoID: "M00000598",
    constellation1ID: void 0,
    longName: "Rio Grande Valley MLS",
    shortName: "Rio Grande Valley MLS",
    abodeMLSName: "Rio Grande Valley MLS"
  },
  river_counties_association_of_realtors: {
    isActive: !0,
    resoID: "M00000577",
    constellation1ID: void 0,
    longName: "River Counties AOR",
    shortName: "River Counties AOR",
    abodeMLSName: "River Counties AOR"
  },
  roanoke_valley_association_of_realtors: {
    isActive: !0,
    resoID: "M00000644",
    constellation1ID: void 0,
    longName: "Roanoke Valley Association of REALTORS",
    shortName: "Roanoke Valley Association of REALTORS",
    abodeMLSName: "Roanoke Valley Association of REALTORS"
  },
  rockford_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000818",
    constellation1ID: void 0,
    longName: "Rockford Area Association of Realtors",
    shortName: "Rockford Area Association of Realtors",
    abodeMLSName: "Rockford Area Association of Realtors"
  },
  roswell_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Roswell Board of Realtors",
    shortName: "Roswell Board of Realtors",
    abodeMLSName: void 0
  },
  royal_gorge_association_of_realtors: {
    isActive: !0,
    resoID: "M00000110",
    constellation1ID: void 0,
    longName: "Royal Gorge AOR",
    shortName: "Royal Gorge AOR",
    abodeMLSName: "Royal Gorge AOR"
  },
  ruidosolincoln_county_association_or_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Ruidoso/Lincoln County Association or Realtors",
    shortName: "Ruidoso/Lincoln County Association or Realtors",
    abodeMLSName: void 0
  },
  saginaw_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Saginaw Board of Realtors",
    shortName: "Saginaw Board of Realtors",
    abodeMLSName: void 0
  },
  san_angelo_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "San Angelo Association of Realtors",
    shortName: "San Angelo Association of Realtors",
    abodeMLSName: void 0
  },
  san_diego_regional_mls: {
    isActive: !0,
    resoID: "M00000846",
    constellation1ID: void 0,
    longName: "San Diego Regional MLS",
    shortName: "San Diego Regional MLS",
    abodeMLSName: "San Diego Regional MLS"
  },
  san_francisco_association_of_realtors: {
    isActive: !0,
    resoID: "M00000094",
    constellation1ID: void 0,
    longName: "San Francisco Multiple Listing Service",
    shortName: "San Francisco Multiple Listing Service",
    abodeMLSName: "San Francisco Multiple Listing Service"
  },
  san_juan_county_board_of_realtors_inc: {
    isActive: !0,
    resoID: "M00000785",
    constellation1ID: void 0,
    longName: "San Juan County Board of Realtors Inc.",
    shortName: "San Juan County Board of Realtors Inc.",
    abodeMLSName: "San Juan County Board of Realtors Inc."
  },
  sandicor: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Sandicor",
    shortName: "Sandicor",
    abodeMLSName: void 0
  },
  sanibel_captiva_islands_aor: {
    isActive: !0,
    resoID: "M00000163",
    constellation1ID: void 0,
    longName: "Sanibel & Captiva Islands AOR",
    shortName: "Sanibel & Captiva Islands AOR",
    abodeMLSName: "Sanibel & Captiva Islands AOR"
  },
  santa_barbara_association_of_realtors: {
    isActive: !0,
    resoID: "M00000096",
    constellation1ID: void 0,
    longName: "Santa Barbara Multiple Listing Service",
    shortName: "Santa Barbara Multiple Listing Service",
    abodeMLSName: "Santa Barbara Multiple Listing Service"
  },
  santa_fe_association_of_realtors: {
    isActive: !0,
    resoID: "M00000461",
    constellation1ID: void 0,
    longName: "Santa Fe MLS",
    shortName: "Santa Fe MLS",
    abodeMLSName: "Santa Fe MLS"
  },
  santa_ynez_aor: {
    isActive: !0,
    resoID: "M00000820",
    constellation1ID: void 0,
    longName: "Santa Ynez AOR (North Santa Barbara County MLS)",
    shortName: "Santa Ynez AOR (North Santa Barbara County MLS)",
    abodeMLSName: "Santa Ynez AOR (North Santa Barbara County MLS)"
  },
  savannah_board_of_realtors_ga: {
    isActive: !0,
    resoID: "M00000751",
    constellation1ID: void 0,
    longName: "Savannah Multi-List",
    shortName: "Savannah Multi-List",
    abodeMLSName: "Savannah Multi-List"
  },
  sedona_verde_valley_association_of_realtors: {
    isActive: !0,
    resoID: "M00000048",
    constellation1ID: void 0,
    longName: "Sedona-Verde Association of Realtors MLS",
    shortName: "Sedona-Verde Association of Realtors MLS",
    abodeMLSName: "Sedona-Verde Association of Realtors MLS"
  },
  selkirk_aor: {
    isActive: !0,
    resoID: "M00000235",
    constellation1ID: void 0,
    longName: "Selkirk AOR",
    shortName: "Selkirk AOR",
    abodeMLSName: "Selkirk AOR"
  },
  shasta_association_of_realtors: {
    isActive: !0,
    resoID: "M00000090",
    constellation1ID: void 0,
    longName: "Shasta Association of Realtors",
    shortName: "Shasta Association of Realtors",
    abodeMLSName: "Shasta Association of Realtors"
  },
  shoals: {
    isActive: !0,
    resoID: "M00000012",
    constellation1ID: void 0,
    longName: "Shoals",
    shortName: "Shoals",
    abodeMLSName: "Strategic MLS:Cullman"
  },
  snake_river_mls: {
    isActive: !0,
    resoID: "M00000228",
    constellation1ID: void 0,
    longName: "Snake River Association of Realtors",
    shortName: "Snake River Association of Realtors",
    abodeMLSName: "Snake River Association of Realtors"
  },
  south_carolina_statewide_commercial_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "South Carolina Statewide Commercial MLS",
    shortName: "South Carolina Statewide Commercial MLS",
    abodeMLSName: void 0
  },
  south_central_association_of_realtors: {
    isActive: !0,
    resoID: "M00000637",
    constellation1ID: void 0,
    longName: "South Central AOR MLS",
    shortName: "South Central AOR MLS",
    abodeMLSName: "South Central AOR MLS"
  },
  south_central_kansas_mls: {
    isActive: !0,
    resoID: "M00000277",
    constellation1ID: void 0,
    longName: "South Central Kansas MLS",
    shortName: "South Central Kansas MLS",
    abodeMLSName: "South Central Kansas MLS"
  },
  south_central_kentucky_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "South Central Kentucky Association of Realtors",
    shortName: "South Central Kentucky Association of Realtors",
    abodeMLSName: void 0
  },
  south_central_wisconsin_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000662",
    constellation1ID: void 0,
    longName: "South Central Wisconsin MLS",
    shortName: "South Central Wisconsin MLS",
    abodeMLSName: "South Central Wisconsin MLS"
  },
  south_east_ks_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "South East KS MLS",
    shortName: "South East KS MLS",
    abodeMLSName: void 0
  },
  south_ga_mls: {
    isActive: !0,
    resoID: "M00000756",
    constellation1ID: void 0,
    longName: "South GA MLS",
    shortName: "South GA MLS",
    abodeMLSName: "South GA MLS"
  },
  south_jersey_shore_regional_mls: {
    isActive: !0,
    resoID: "M00000446",
    constellation1ID: void 0,
    longName: "South Jersey Shore Regional MLS",
    shortName: "South Jersey Shore Regional MLS",
    abodeMLSName: "South Jersey Shore Regional MLS"
  },
  south_lake_tahoe_association_of_realtors: {
    isActive: !0,
    resoID: "M00000100",
    constellation1ID: void 0,
    longName: "South Tahoe Association of REALTORS",
    shortName: "South Tahoe Association of REALTORS",
    abodeMLSName: "South Tahoe Association of REALTORS"
  },
  southeast_alabama_aor_mls: {
    isActive: !0,
    resoID: "M00000013",
    constellation1ID: void 0,
    longName: "Southeast Alabama AOR/MLS (Dothan)",
    shortName: "Southeast Alabama AOR/MLS (Dothan)",
    abodeMLSName: "Southeast Alabama AOR/MLS (Dothan)"
  },
  southeast_texas_bor: {
    isActive: !0,
    resoID: "M00000591",
    constellation1ID: void 0,
    longName: "Southeast Texas BOR",
    shortName: "Southeast Texas BOR",
    abodeMLSName: "Southeast Texas BOR"
  },
  southeastern_indiana_board_of_realtors_in: {
    isActive: !0,
    resoID: "M00000251",
    constellation1ID: void 0,
    longName: "Southeastern Indiana BOR",
    shortName: "Southeastern Indiana BOR",
    abodeMLSName: "Southeastern Indiana BOR"
  },
  southern_indiana_realtors_association: {
    isActive: !0,
    resoID: "M00000252",
    constellation1ID: void 0,
    longName: "Southern Indiana Realtor Associaion",
    shortName: "Southern Indiana Realtor Associaion",
    abodeMLSName: "Southern Indiana Realtor Associaion"
  },
  southern_missouri_regional_mls: {
    isActive: !0,
    resoID: "M00000748",
    constellation1ID: void 0,
    longName: "Southern Missouri Regional MLS",
    shortName: "Southern Missouri Regional MLS",
    abodeMLSName: "Southern Missouri Regional MLS"
  },
  southern_new_mexico_mls: {
    isActive: !0,
    resoID: "M00000457",
    constellation1ID: void 0,
    longName: "Southern New Mexico MLS",
    shortName: "Southern New Mexico MLS",
    abodeMLSName: "Southern New Mexico MLS"
  },
  southern_oregon_mls: {
    isActive: !0,
    resoID: "M00000530",
    constellation1ID: void 0,
    longName: "Southern Oregon MLS",
    shortName: "Southern Oregon MLS",
    abodeMLSName: "Southern Oregon MLS"
  },
  southwest_georgia_board_of_realtors: {
    isActive: !0,
    resoID: "M00000179",
    constellation1ID: void 0,
    longName: "Southwest Georgia Board of Realtors",
    shortName: "Southwest Georgia Board of Realtors",
    abodeMLSName: "Southwest Georgia Board of Realtors"
  },
  southwest_mls: {
    isActive: !0,
    resoID: "M00000456",
    constellation1ID: void 0,
    longName: "Southwest MLS",
    shortName: "Southwest MLS",
    abodeMLSName: "Southwest MLS"
  },
  southwest_virginia_association_of_realtors_va: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Southwest Virginia Association of Realtors, VA",
    shortName: "Southwest Virginia Association of Realtors, VA",
    abodeMLSName: void 0
  },
  southwestern_michigan_regional_information_center: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Southwestern Michigan Regional Information Center",
    shortName: "Southwestern Michigan Regional Information Center",
    abodeMLSName: void 0
  },
  spartanburg_board_of_realtors_multiple_listing_service_of_spartanburg: {
    isActive: !0,
    resoID: "M00000568",
    constellation1ID: void 0,
    longName: "Spartanburg Board of Realtors / Multiple Listing Service of Spartanburg",
    shortName: "Spartanburg Board of Realtors / Multiple Listing Service of Spartanburg",
    abodeMLSName: "MLS of Spartanburg"
  },
  spokane_association_of_realtors: {
    isActive: !0,
    resoID: "M00000653",
    constellation1ID: void 0,
    longName: "Spokane Association of Realtors",
    shortName: "Spokane Association of Realtors",
    abodeMLSName: "Spokane Association of Realtors"
  },
  st_augustine_st_johns_county_board_of_realtors: {
    isActive: !0,
    resoID: "M00000164",
    constellation1ID: void 0,
    longName: "St. Augustine & St. Johns County BOR",
    shortName: "St. Augustine & St. Johns County BOR",
    abodeMLSName: "St. Augustine & St. Johns County BOR"
  },
  staten_island_bor: {
    isActive: !0,
    resoID: "M00000487",
    constellation1ID: void 0,
    longName: "Staten Island BOR",
    shortName: "Staten Island BOR",
    abodeMLSName: "Staten Island BOR"
  },
  statewide_mls: {
    isActive: !0,
    resoID: "M00000554",
    constellation1ID: void 0,
    longName: "Statewide MLS",
    shortName: "Statewide MLS",
    abodeMLSName: "Statewide MLS"
  },
  summit_mls: {
    isActive: !0,
    resoID: "M00000113",
    constellation1ID: void 0,
    longName: "Summit County AOR",
    shortName: "Summit County AOR",
    abodeMLSName: "Summit County AOR"
  },
  sumter_association_of_realtors: {
    isActive: !0,
    resoID: "M00000569",
    constellation1ID: void 0,
    longName: "Sumter Board of Realtors",
    shortName: "Sumter Board of Realtors",
    abodeMLSName: "Sumter Board of Realtors"
  },
  sun_valley_board_of_realtors: {
    isActive: !0,
    resoID: "M00000229",
    constellation1ID: void 0,
    longName: "Sun Valley Board of Realtors",
    shortName: "Sun Valley Board of Realtors",
    abodeMLSName: "Sun Valley Board of Realtors"
  },
  sunflower_association_of_realtors: {
    isActive: !0,
    resoID: "M00000276",
    constellation1ID: void 0,
    longName: "Sunflower Association of Realtors",
    shortName: "Sunflower Association of Realtors",
    abodeMLSName: "Sunflower Association of Realtors"
  },
  sunshine_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Sunshine MLS",
    shortName: "Sunshine MLS",
    abodeMLSName: void 0
  },
  tahoe_sierra_board_of_realtors: {
    isActive: !0,
    resoID: "M00000079",
    constellation1ID: void 0,
    longName: "Tahoe - Sierra MLS",
    shortName: "Tahoe - Sierra MLS",
    abodeMLSName: "Tahoe - Sierra MLS"
  },
  tallahassee_board_of_realtors: {
    isActive: !0,
    resoID: "M00000166",
    constellation1ID: void 0,
    longName: "Tallahassee Board of Realtors MLS",
    shortName: "Tallahassee Board of Realtors MLS",
    abodeMLSName: "Tallahassee Board of Realtors MLS"
  },
  taos_county_association_of_realtors_nm: {
    isActive: !0,
    resoID: "M00000464",
    constellation1ID: void 0,
    longName: "Taos County Association of Realtors",
    shortName: "Taos County Association of Realtors",
    abodeMLSName: "Taos County Association of Realtors"
  },
  tehachapi_area_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tehachapi Area Association of Realtors",
    shortName: "Tehachapi Area Association of Realtors",
    abodeMLSName: void 0
  },
  telluride_association_of_realtors: {
    isActive: !0,
    resoID: "M00000122",
    constellation1ID: void 0,
    longName: "Telluride AOR",
    shortName: "Telluride AOR",
    abodeMLSName: "Telluride AOR"
  },
  tennessee_virginia_regional_mls: {
    isActive: !0,
    resoID: "M00000580",
    constellation1ID: void 0,
    longName: "Tennessee Virginia Regional MLS",
    shortName: "Tennessee Virginia Regional MLS",
    abodeMLSName: "Tennessee Virginia Regional MLS"
  },
  terra_haute_association_of_realtors: {
    isActive: !0,
    resoID: "M00000261",
    constellation1ID: void 0,
    longName: "Terre Haute Area Association of Realtors",
    shortName: "Terre Haute Area Association of Realtors",
    abodeMLSName: "Terre Haute Area Association of Realtors"
  },
  teton_board_of_realtors: {
    isActive: !0,
    resoID: "M00000678",
    constellation1ID: void 0,
    longName: "Teton County Board of Realtors",
    shortName: "Teton County Board of Realtors",
    abodeMLSName: "Teton County Board of Realtors"
  },
  the_heart_of_kentucky_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "The Heart Of Kentucky Association of Realtors",
    shortName: "The Heart Of Kentucky Association of Realtors",
    abodeMLSName: void 0
  },
  the_lake_superior_area_mls: {
    isActive: !0,
    resoID: "M00000337",
    constellation1ID: void 0,
    longName: "The Lake Superior Area MLS",
    shortName: "The Lake Superior Area MLS",
    abodeMLSName: "Lake Superior Area of Realtors"
  },
  tri_city_association_of_realtors_pacific_regional_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tri City Association of Realtors / Pacific Regional MLS",
    shortName: "Tri City Association of Realtors / Pacific Regional MLS",
    abodeMLSName: void 0
  },
  valley_mls: {
    isActive: !0,
    resoID: "M00000017",
    constellation1ID: void 0,
    longName: "Valley MLS",
    shortName: "Valley MLS",
    abodeMLSName: "Valley MLS"
  },
  west_alabama_mls: {
    isActive: !0,
    resoID: "M00000024",
    constellation1ID: void 0,
    longName: "West Alabama MLS",
    shortName: "West Alabama MLS",
    abodeMLSName: "West Alabama MLS"
  },
  west_central_aor: {
    isActive: !0,
    resoID: "M00000357",
    constellation1ID: void 0,
    longName: "West Central AOR",
    shortName: "West Central AOR",
    abodeMLSName: "West Central AOR"
  },
  western_arizona_real_estate_data_exchange: {
    isActive: !0,
    resoID: "M00000039",
    constellation1ID: void 0,
    longName: "Western Arizona Real Estate Data Exchange",
    shortName: "Western Arizona Real Estate Data Exchange",
    abodeMLSName: "Western Arizona Real Estate Data Exchange"
  },
  western_kentucky_regional_mls: {
    isActive: !0,
    resoID: "M00000280",
    constellation1ID: void 0,
    longName: "Western Kentucky Regional MLS (Pennyrile AOR)",
    shortName: "Western Kentucky Regional MLS (Pennyrile AOR)",
    abodeMLSName: "Western Kentucky Regional MLS (Pennyrile AOR)"
  }
}), Rl = be([...zo._keys]), hre = be([
  "M00000315",
  "M00000483",
  "M00000555",
  "M00000001",
  "M00000172",
  "M00000588",
  "M00000136",
  "M00000048",
  "M00000278",
  "M00000109",
  "M00000589",
  "M00000427",
  "M00000355",
  "M00000053",
  "M00000022",
  "M00000097",
  "M00000105",
  "M00000170",
  "M00000170",
  "M00000305",
  "M00000055",
  "M00000378",
  "M00000571",
  "M00000821",
  "M00000309",
  "M00000471",
  "M00000592",
  "M00000052",
  "M00000093",
  "M00000093",
  "M00000391",
  "M00000307",
  "M00000447",
  "M00000395",
  "M00000752",
  "M00000200",
  "M00000043",
  "M00000190",
  "M00000596",
  "M00000450",
  "M00000525",
  "M00000159",
  "M00000538",
  "M00000581",
  "M00000610",
  "M00000643",
  "M00000558",
  "M00000633",
  "M00000675",
  "M00000177",
  "M00000565",
  "M00000227",
  "M00000684",
  "M00000349",
  "M00000476",
  "M00000753",
  "M00000071",
  "M00000559",
  "M00000031",
  "M00000593",
  "M00000496",
  "M00000140",
  "M00000204",
  "M00000082",
  "M00000631",
  "M00000138",
  "M00000428",
  "M00000504",
  "M00000271",
  "M00000168",
  "M00000853",
  "M00000129",
  "M00000060",
  "M00000379",
  "M00000597",
  "M00000449",
  "M00000188",
  "M00000468",
  "M00000429",
  "M00000729",
  "M00000107",
  "M00000441",
  "M00000010",
  "M00000084",
  "M00000176",
  "M00000298",
  "M00000470",
  "M00000575",
  "M00000595",
  "M00000540",
  "M00000002",
  "M00000365",
  "M00000322",
  "M00000466",
  "M00000534",
  "M00000290",
  "M00000608",
  "M00000259",
  "M00000536",
  "M00000083",
  "M00000621",
  "M00000669",
  "M00000125",
  "M00000018",
  "M00000065",
  "M00000367",
  "M00000193",
  "M00000205",
  "M00000270",
  "M00000740",
  "M00000131",
  "M00000194",
  "M00000387",
  "M00000606",
  "M00000390",
  "M00000564",
  "M00000029",
  "M00000599",
  "M00000784",
  "M00000479",
  "M00000668",
  "M00000058",
  "M00000465",
  "M00000169",
  "M00000256",
  "M00000225",
  "M00000206",
  "M00000118",
  "M00000353",
  "M00000667",
  "M00000600",
  "M00000582",
  "M00000832",
  "M00000004",
  "M00000337",
  "M00000584",
  "M00000603",
  "M00000269",
  "M00000008",
  "M00000288",
  "M00000394",
  "M00000604",
  "M00000557",
  "M00000811",
  "M00000545",
  "M00000641",
  "M00000311",
  "M00000073",
  "M00000148",
  "M00000165",
  "M00000195",
  "M00000583",
  "M00000091",
  "M00000255",
  "M00000331",
  "M00000151",
  "T00000006",
  "M00000360",
  "M00000184",
  "M00000574",
  "M00000243",
  "M00000431",
  "M00000101",
  "M00000830",
  "M00000495",
  "M00000494",
  "M00000519",
  "M00000049",
  "M00000568",
  "M00000306",
  "M00000521",
  "M00000070",
  "M00000452",
  "M00000383",
  "M00000020",
  "M00000573",
  "M00000231",
  "M00000033",
  "M00000153",
  "M00000127",
  "M00000445",
  "M00000448",
  "M00000462",
  "M00000634",
  "T00000077",
  "M00000722",
  "M00000666",
  "M00000594",
  "M00000030",
  "M00000771",
  "M00000141",
  "M00000848",
  "M00000221",
  "M00000303",
  "M00000376",
  "M00000515",
  "M00000657",
  "M00000040",
  "M00000330",
  "M00000284",
  "M00000467",
  "M00000345",
  "M00000035",
  "M00000224",
  "M00000650",
  "M00000505",
  "M00000514",
  "M00000663",
  "M00000736",
  "M00000489",
  "T00000038",
  "M00000409",
  "M00000354",
  "M00000648",
  "M00000627",
  "M00000161",
  "M00000737",
  "M00000721",
  "M00000111",
  "M00000233",
  "M00000552",
  "M00000044",
  "M00000120",
  "T00000046",
  "M00000646",
  "M00000316",
  "M00000145",
  "M00000703",
  "M00000281",
  "M00000572",
  "M00000300",
  "M00000658",
  "M00000343",
  "M00000116",
  "M00000531",
  "M00000598",
  "M00000577",
  "M00000852",
  "M00000644",
  "M00000818",
  "M00000110",
  "M00000616",
  "M00000846",
  "M00000094",
  "M00000785",
  "M00000163",
  "M00000096",
  "M00000461",
  "M00000820",
  "M00000751",
  "M00000048",
  "M00000235",
  "M00000090",
  "M00000127",
  "M00000228",
  "M00000637",
  "M00000277",
  "M00000662",
  "M00000756",
  "M00000446",
  "M00000100",
  "M00000013",
  "M00000591",
  "M00000251",
  "M00000252",
  "M00000748",
  "M00000457",
  "M00000530",
  "M00000179",
  "M00000456",
  "M00000150",
  "M00000653",
  "M00000164",
  "M00000487",
  "M00000554",
  "M00000146",
  "M00000012",
  "M00000113",
  "M00000569",
  "M00000229",
  "M00000276",
  "M00000130",
  "M00000079",
  "M00000166",
  "M00000464",
  "M00000122",
  "M00000580",
  "M00000261",
  "M00000678",
  "M00000400",
  "M00000389",
  "M00000104",
  "M00000324",
  "M00000114",
  "M00000017",
  "M00000594",
  "M00000711",
  "M00000628",
  "M00000629",
  "M00000317",
  "M00000024",
  "M00000799",
  "M00000357",
  "M00000735",
  "M00000549",
  "M00000039",
  "M00000280",
  "M00000506",
  "M00000556",
  "M00000042",
  "M00000625",
  "M00000532",
  "M00000858",
  "M00000679",
  "M00000656",
  "M00000050"
]);
function o_(e) {
  return typeof e == "string" && zo._isKey(e);
}
function a_(e) {
  return hre.safeParse(e).success;
}
var pre = re(ce(), 1), mre = re(ce(), 1);
function gre(e) {
  return { mlsid: e, ...(0, mre.expected)(zo[e], `Invalid MLSID: ${e}`) };
}
var i_ = /* @__PURE__ */ new Map();
for (const e of zo._keys) {
  const { constellation1ID: t } = zo[e];
  t !== void 0 && i_.set(t, e);
}
function vre(e) {
  if ((0, pre.isUndefined)(e))
    return;
  const t = i_.get(e);
  if (t !== void 0)
    return gre(t);
}
re(ce(), 1);
re(ce(), 1);
var Cre = /* @__PURE__ */ new Map();
for (const e of zo._keys) {
  const { shortName: t } = zo[e];
  t !== void 0 && Cre.set(t.toLowerCase(), e);
}
re(ce(), 1);
var bre = /* @__PURE__ */ new Map();
for (const e of zo._keys) {
  const { abodeMLSName: t } = zo[e];
  t !== void 0 && bre.set(t.toLowerCase(), e);
}
re(ce(), 1);
re(ce(), 1);
function yre() {
  const e = /* @__PURE__ */ new Map();
  return zo._keys.forEach((t) => {
    const { resoID: n } = zo[t];
    n && e.set(n.toLowerCase(), t);
  }), e;
}
yre();
var N3 = "tkl:";
function Sre(e) {
  const t = zo[e];
  return t && typeof t == "object" && "resoID" in t ? t.resoID : null;
}
function s_(e) {
  if (!(e != null && e.startsWith(N3)))
    return null;
  const t = e.slice(N3.length), n = t.indexOf(":");
  if (n < 0)
    return null;
  let r = t.slice(0, n);
  const o = t.slice(n + 1);
  if (!o_(r) && !a_(r))
    return null;
  const a = Sre(r);
  return a && (r = a), { mls: r, listingID: o };
}
var l_ = (e) => typeof e == "string" && s_(e) !== null;
function Are(e) {
  if (!l_(e))
    throw new Error(`Invalid ToolkitListingID: ${e}`);
  return e;
}
var AC = re(ce(), 1);
function Mre(e) {
  if ((0, AC.isUndefined)(e.mls))
    throw new Error("Listing is missing a valid MLS");
  if ((0, AC.isUndefined)(e.listingID))
    throw new Error("Listing is missing a ListingID");
  if (e.mls.includes(":"))
    throw new Error(`Invalid MLS ID: ${e.mls}`);
  return `${N3}${e.mls}:${e.listingID}`;
}
var u_ = hh(
  l_,
  "invalid ToolkitListingID"
);
v().brand("ToolkitRecordID");
var t2 = re(ce(), 1), MC = "tkp:";
function xre(e) {
  return e.replaceAll("~1", "/").replaceAll("~0", "~");
}
function _re(e) {
  if (!e.startsWith(MC))
    return null;
  const t = e.slice(MC.length).split("/").map(xre);
  if (t[0] !== "order")
    return null;
  const n = t[1];
  if (!(0, t2.isDefined)(n))
    return null;
  switch (t[2]) {
    case "subject":
      return { orderID: n, location: { t: "subject" } };
    case "comp": {
      const r = t[3];
      return (0, t2.isDefined)(r) ? { orderID: n, location: { t: "comp", attachmentID: r } } : null;
    }
    case "dataset": {
      const r = t[3], o = t[4];
      if (!(0, t2.isDefined)(r) || !(0, t2.isDefined)(o))
        return null;
      const a = Are(o);
      return { orderID: n, location: { t: "dataset", datasetID: r, listingID: a } };
    }
    default:
      return null;
  }
}
function Ire(e) {
  return typeof e == "string" && _re(e) !== null;
}
var T3 = hh(
  Ire,
  "Invalid ToolkitRecordID"
), wre = M({
  toolkitRecordID: T3,
  toolkitListingID: u_,
  mls: v(),
  address: md,
  projectPhase: v(),
  projectName: v(),
  salePrice: Te,
  listPrice: Te,
  grossMonthlyRent: Te,
  rentControl: Y(),
  dataSources: v(),
  verificationSources: v(),
  saleType: hn,
  financingType: v(),
  financialConcessionAmount: Te,
  listingStatus: hn,
  listDate: qn,
  contractDate: qn,
  closeDate: qn,
  withdrawalDate: qn,
  expirationDate: qn,
  leaseholdOrFeeSimple: hn,
  locationImpact: hn,
  locationFactorOne: hn,
  locationFactorTwo: hn,
  site: yt,
  viewImpact: hn,
  viewFactorOne: hn,
  viewFactorTwo: hn,
  designAttachmentType: hn,
  designNumberOfStories: L(),
  designStyle: hn,
  quality: hn,
  age: L(),
  yearBuilt: L(),
  condition: hn,
  aboveGradeBedroomCount: Ht,
  aboveGradeFullBathCount: Ht,
  aboveGradeHalfBathCount: Ht,
  aboveGradeThreeQuarterBathCount: Ht,
  aboveGradeTotalRoomCount: Ht,
  grossLivingArea: yt,
  grossBuildingArea: yt,
  totalBasementArea: yt,
  finishedBasementArea: yt,
  basementFinishedRoomCount: Ht,
  basementDescription: v(),
  belowGradeExteriorAccessType: hn,
  belowGradeRecRoomCount: Ht,
  belowGradeBedroomCount: Ht,
  belowGradeFullBathCount: L(),
  belowGradeHalfBathCount: Ht,
  belowGradeThreeQuarterBathCount: Ht,
  belowGradeOtherRoomCount: Ht,
  finishedRoomsBelowGrade: Ht,
  heatingCooling: v(),
  functionalUtility: hn,
  energyEfficientItems: v(),
  attachedGarageParkingSpacesCount: Ht,
  detachedGarageParkingSpacesCount: Ht,
  builtInGarageParkingSpacesCount: Ht,
  carportParkingSpacesCount: Ht,
  drivewayParkingSpacesCount: Ht,
  porchPatioDeck: v(),
  hoaMonthlyAssessment: Te,
  commonElementsAndRecFacilities: v(),
  floorLocation: hn,
  dynamicFields: mn(
    v(),
    zt([cre, Ou(), Ri()])
  ),
  propertyType: v(),
  stucturalDesignDescription: hn,
  structureType: hn,
  storiesDescription: v(),
  elementarySchool: v(),
  mlsArea: v(),
  listingID: v(),
  marketingCommentary: v(),
  images: ne(M({ url: v() })),
  daysOnMarket: Ht,
  cumulativeDaysOnMarket: Ht,
  longitude: L(),
  latitude: L(),
  architectureStyle: v(),
  assesorsMapReferenceID: v(),
  parcelID: v(),
  censusTractID: v(),
  zoningDescription: v(),
  legalDescription: v(),
  sewerType: v(),
  annualTaxAmount: Te,
  taxYear: L(),
  ownerOccupied: Y(),
  cooling: v(),
  greenEnergyEfficient: v(),
  heating: v(),
  poolFeatures: v(),
  custom: v(),
  additionalFeature1Title: v(),
  additionalFeature1Description: v(),
  additionalFeature2Title: v(),
  additionalFeature2Description: v(),
  additionalFeature3Title: v(),
  additionalFeature3Description: v()
}).partial(), bf = ac(
  wre.transform((e) => e)
), Jc = re(ce(), 1), gh = /^([0-9]{4})-(1[0-2]|0[1-9])$/, _r = v().regex(gh).brand("IsoMonth"), c_ = ["Active", "Contract", "Expired", "Withdrawn", "SettledSale"], Lre = c_.map((e) => ({
  key: e,
  label: e,
  value: e
})), vh = be([
  "Active",
  "Contract",
  "Expired",
  "Withdrawn",
  "SettledSale"
]), d_ = be(["Active", "Contract", "Rented"]), f_ = M({
  listingStatus: vh.optional(),
  contractMonth: _r.optional(),
  closeMonth: _r.optional(),
  withdrawalMonth: _r.optional(),
  expirationMonth: _r.optional()
}), kr = L().gte(0).brand("ParkingSpaceNumber"), h_ = Ot({
  attachedGarageSpaces: kr,
  detachedGarageSpaces: kr,
  builtInGarageSpaces: kr,
  carportSpaces: kr,
  drivewaySpaces: kr
}).partial(), p_ = L().gte(1).multipleOf(0.01), F4 = be(["AT", "DT", "SD"]), m_ = Ot({
  attachmentType: F4,
  stories: p_,
  style: v()
}).partial(), g_ = Ot({
  mls: v(),
  listingID: v(),
  daysOnMarket: xe
}).partial(), v_ = Ot({
  age: xe,
  isEstimation: Y()
}).partial(), C_ = Ot({
  fullBaths: xe,
  halfBaths: xe
}).partial(), b_ = be(["wu", "wo", "in"]), y_ = Ot({
  total: yt,
  finished: yt,
  accessType: b_
}).partial(), S_ = Ot({
  recRoomCount: xe,
  bedroomCount: xe,
  fullBathCount: xe,
  halfBathCount: xe,
  otherRoomCount: xe
}).partial(), Rre = re(ce(), 1), B4 = be([
  "REO",
  "Short",
  "CrtOrd",
  "Estate",
  "Relo",
  "NonArm",
  "ArmLth",
  "Listing"
]), Ere = (0, Rre.makeLookup)({
  cases: [
    ["REO", "REO Sale"],
    ["Short", "Short Sale"],
    ["CrtOrd", "Court-Ordered Sale"],
    ["Estate", "Estate Sale"],
    ["Relo", "Relocation Sale"],
    ["NonArm", "Non-Arm's Length Sale"],
    ["ArmLth", "Arm's Length Sale"],
    ["Listing", "Listing"]
  ]
});
B4.options.map((e) => ({
  key: e,
  value: e,
  label: Ere(e)
}));
var D1 = be(["Cash", "Conventional", "FHA", "Private", "USDA", "VA"]), Dre = M({
  mls: Rl,
  mlsListingID: v()
}), A_ = M({
  id: v(),
  price: Nn,
  status: vh,
  contractDate: _r,
  saleDate: _r,
  expirationDate: _r,
  withdrawalDate: _r,
  mls: Rl,
  mlsListingID: v(),
  originalListPrice: Nn,
  daysOnMarket: L(),
  concessions: v(),
  // TODO: Type as schConcessions
  termsOfSale: B4,
  rentRate: Nn,
  leaseDate: _r,
  rentalListingstatus: d_
}).partial(), M_ = class extends Error {
}, La = class extends M_ {
}, Pt = class extends M_ {
};
function gd(e, t, n = {}) {
  function r(s) {
    return n.caseSensitive ? s.trim() : s.trim().toLowerCase();
  }
  const o = t, a = Object.fromEntries(
    Object.entries(t).map(([s, l]) => [r(l), s])
  );
  return {
    encode(s) {
      const l = o[s];
      if (l === void 0) {
        if (!n.allowOther)
          throw new La(`Unknown enum variant: ${s}`);
        return s;
      }
      return l;
    },
    decode(s) {
      const l = a[r(s)];
      if (l === void 0) {
        if (!n.allowOther)
          throw new Pt(`Unknown value for ${e}: ${s}`);
        return s;
      }
      return l;
    }
  };
}
var H4 = [
  "REOSale",
  "ShortSale",
  "CourtOrderedSale",
  "EstateSale",
  "RelocationSale",
  "NonArmsLengthSale",
  "ArmsLengthSale",
  "Listing"
], Nre = be(H4), x_ = gd("sale type", {
  REOSale: "REO",
  ShortSale: "Short",
  CourtOrderedSale: "CrtOrd",
  EstateSale: "Estate",
  RelocationSale: "Relo",
  NonArmsLengthSale: "NonArm",
  ArmsLengthSale: "ArmLth",
  Listing: "Listing"
}), Tre = (e) => e.saleType === void 0 ? "" : x_.encode(e.saleType), Pre = (e, t) => {
  const n = e.trim();
  return { saleType: n === "" ? void 0 : Nre.parse(x_.decode(n)) };
}, kre = { encode: Tre, decode: Pre }, ri = {};
pd(ri, {
  ISO_MONTH_REGEX: () => gh,
  actualAgeSyntax: () => Lh,
  addressSyntax: () => yf,
  aloftDateToIsoMonth: () => Boe,
  areaSyntax: () => G4,
  basementLine1Syntax: () => Ch,
  basementLine2Syntax: () => yh,
  bathroomSyntax: () => Sh,
  conditionSyntax: () => ooe,
  dataSourceSyntax: () => Sf,
  dateOfSaleSyntax: () => Ih,
  designSyntax: () => Ah,
  financialConcessionsSyntax: () => boe,
  garageCarportSyntax: () => Mh,
  grossLivingAreaSyntax: () => wh,
  isoMonthToAloftDate: () => Foe,
  legacyBasementLine2Syntax: () => noe,
  legacyDateOfSaleSyntax: () => hoe,
  locationSyntax: () => _oe,
  numberSyntax: () => ds,
  priceSyntax: () => Rh,
  qualitySyntax: () => woe,
  saleTypeSyntax: () => kre,
  schActualAge: () => v_,
  schAttachmentType: () => F4,
  schBasementAccessType: () => b_,
  schBasementLine1: () => y_,
  schBasementLine2: () => S_,
  schBathroomCount: () => C_,
  schCarStorage: () => h_,
  schComparableStatus: () => f_,
  schDataSource: () => g_,
  schDesignStyle: () => m_,
  schIsoMonth: () => _r,
  schParkingSpaceNumber: () => kr,
  schRentalListingStatus: () => d_,
  schStoriesNum: () => p_,
  schUadListingStatus: () => vh,
  siteSyntax: () => _h,
  splitUndelimited: () => bh,
  statusOptions: () => Lre,
  valuesSaleType: () => H4,
  valuesUadListingStatus: () => c_,
  viewSyntax: () => Toe
});
var __ = re(ce(), 1), Vre = re(ce(), 1);
function Ore(e, t) {
  const n = {};
  for (const [r, o] of Object.entries(e))
    n[r] = t(o, r);
  return n;
}
var I_ = be([
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "VI",
  "WA",
  "WV",
  "WI",
  "WY"
]), Fre = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District of Columbia",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  VI: "Virgin Islands",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
}, w_ = Ore(Fre, (e) => e.toUpperCase()), xC = Object.fromEntries(
  Object.entries(w_).map(([e, t]) => [t, e])
);
function Bre(e, t = !1) {
  if (e = e.trim().toUpperCase(), xC.hasOwnProperty(e))
    return (0, Vre.expected)(xC[e]);
  if (w_.hasOwnProperty(e))
    return e;
  if (t)
    return "";
  throw new Error(`unknown state: ${e}`);
}
function Hre({
  AddressLineText: e,
  unitNumber: t,
  CityName: n,
  StateCode: r,
  PostalCode: o
}) {
  return {
    PropertyStreetAddress: `${e}${(0, __.isDefined)(t) ? " " + t : ""}`,
    PropertyCity: n,
    PropertyState: r,
    PropertyPostalCode: o
  };
}
function Gre({
  PropertyStreetAddress: e,
  PropertyCity: t,
  PropertyState: n,
  PropertyPostalCode: r
}) {
  let o;
  try {
    o = (0, __.orUndefined)(I_.parse)(n);
  } catch {
    console.warn(`Ignoring invalid state code: ${n}`);
  }
  return {
    AddressLineText: e,
    CityName: t,
    StateCode: o,
    PostalCode: r
  };
}
var yf = {
  encode: Hre,
  decode: Gre,
  emptyAnnotations: {
    PropertyStreetAddress: void 0,
    PropertyCity: void 0,
    PropertyState: void 0,
    PropertyPostalCode: void 0
  }
}, $re = re(ce(), 1);
function Zre(e) {
  const t = e.toSqFt().unitAmount, n = e.toAcre().unitAmount;
  return n < 1 ? `${t.toFixed(0)} sf` : `${n.toFixed(2)} ac`;
}
function jre(e) {
  const t = /^([0-9.,]+)\s*(\S+)$/i.exec(e.trim());
  if (t === null)
    throw new Pt(`Unknown area format: ${e}`);
  let [, n, r] = (0, $re.checkLength)(3, t);
  switch (n = n.replaceAll(",", ""), r.toLowerCase()) {
    case "sf":
    case "sqft":
    case "ft2":
      return xt.fromNumber(parseFloat(n), "sqft");
    case "ac":
    case "acre":
    case "acres":
      return xt.fromNumber(parseFloat(n), "acre");
    default:
      throw new Pt(`Unknown unit of area: ${r}`);
  }
}
var G4 = { encode: Zre, decode: jre }, P3 = re(ce(), 1), Wre = new RegExp(/^((\d+)sf((\d+)sf)?)?(wo|wu|in)?$/);
function zre({ total: e, finished: t, accessType: n }) {
  return [e, t, n].every(P3.isUndefined) ? "" : `${e ? Math.round(e.getUnitAmount("sqft")) : 0}sf${t ? Math.round(t.getUnitAmount("sqft")) + "sf" : ""}${n || ""}`;
}
function Ure(e) {
  const t = e.trim();
  if (t === "")
    return {};
  const n = t.match(Wre);
  if (!n)
    throw new Pt(`Invalid Basement Line 1: ${e}`);
  const r = n[2], o = n[4], a = n[5];
  return {
    total: (0, P3.orUndefined)((s) => xt.fromString(s, "sqft"))(r),
    finished: (0, P3.orUndefined)((s) => xt.fromString(s, "sqft"))(o),
    accessType: a
  };
}
var Ch = {
  encode: zre,
  decode: Ure
}, Xre = re(ce(), 1), Yre = re(ce(), 1);
function* bh(e) {
  const t = /\s*([0-9.]+)\s*([a-zA-Z]+)\s*/g;
  for (; ; ) {
    if (t.lastIndex === e.length)
      return;
    const n = t.exec(e);
    if (n === null)
      throw new Pt(`Invalid format: ${e}`);
    const [, r, o] = (0, Yre.checkLength)(3, n);
    yield [r, o];
  }
}
var qre = new RegExp(/^(\d+(rr|br|o)|\d+\.\d+ba)*$/);
function Jre(e) {
  const t = [];
  if (e.recRoomCount !== void 0 && t.push(`${e.recRoomCount}rr`), e.bedroomCount !== void 0 && t.push(`${e.bedroomCount}br`), e.fullBathCount !== void 0 || e.halfBathCount !== void 0) {
    const n = e.fullBathCount ?? 0, r = e.halfBathCount ?? 0;
    t.push(`${n}.${r}ba`);
  }
  return e.otherRoomCount !== void 0 && t.push(`${e.otherRoomCount}o`), t.join("");
}
function Kre(e) {
  const t = e.trim().toLowerCase(), n = {};
  if (t === "")
    return n;
  if (!t.match(qre))
    throw new Pt(`Invalid Basement Line 2: ${e}`);
  for (const [r, o] of bh(t))
    switch (o) {
      case "rr":
        if (n.recRoomCount !== void 0)
          throw new Pt('"rr" appears multiple times in input');
        n.recRoomCount = xe.parse(r);
        break;
      case "br":
        if (n.bedroomCount !== void 0)
          throw new Pt('"br" appears multiple times in input');
        n.bedroomCount = xe.parse(r);
        break;
      case "ba":
        if (n.fullBathCount !== void 0 || n.halfBathCount !== void 0)
          throw new Pt('"ba" appears multiple times in input');
        const [a, s] = (0, Xre.checkMinLength)(2, r.split("."));
        n.fullBathCount = xe.parse(a), n.halfBathCount = s === void 0 ? xe.parse(0) : xe.parse(s);
        break;
      case "o":
        if (n.otherRoomCount !== void 0)
          throw new Pt('"o" appears multiple times in input');
        n.otherRoomCount = xe.parse(r);
        break;
      default:
        throw new Pt(`Unknown below grade room type: ${o}`);
    }
  return n;
}
var yh = {
  encode: Jre,
  decode: Kre
}, Qre = re(ce(), 1);
function eoe(e) {
  var n;
  const t = [];
  if (e.belowGradeRecRoomCount !== void 0 && t.push(`${e.belowGradeRecRoomCount.value}rr`), e.belowGradeBedroomCount !== void 0 && t.push(`${e.belowGradeBedroomCount.value}br`), e.belowGradeFullBathCount !== void 0 || e.belowGradeHalfBathCount !== void 0) {
    const r = Math.round(e.belowGradeFullBathCount ?? 0), o = ((n = e.belowGradeHalfBathCount) == null ? void 0 : n.value) ?? 0;
    t.push(`${r}.${o}ba`);
  }
  return e.belowGradeOtherRoomCount !== void 0 && t.push(`${e.belowGradeOtherRoomCount.value}o`), t.join("");
}
function toe(e) {
  const t = e.trim(), n = {
    belowGradeRecRoomCount: void 0,
    belowGradeBedroomCount: void 0,
    belowGradeFullBathCount: void 0,
    belowGradeHalfBathCount: void 0,
    belowGradeOtherRoomCount: void 0
  };
  if (t === "")
    return n;
  for (const [r, o] of bh(t))
    switch (o.toLowerCase()) {
      case "rr":
        if (n.belowGradeRecRoomCount !== void 0)
          throw new Pt('"rr" appears multiple times in input');
        n.belowGradeRecRoomCount = gt.fromNumber(parseInt(r));
        break;
      case "br":
        if (n.belowGradeBedroomCount !== void 0)
          throw new Pt('"br" appears multiple times in input');
        n.belowGradeBedroomCount = gt.fromNumber(parseInt(r));
        break;
      case "ba":
        if (n.belowGradeFullBathCount !== void 0 || n.belowGradeHalfBathCount !== void 0)
          throw new Pt('"ba" appears multiple times in input');
        const [a, s] = (0, Qre.checkMinLength)(2, r.split("."));
        n.belowGradeFullBathCount = parseInt(a), n.belowGradeHalfBathCount = s === void 0 ? gt.zero : gt.fromNumber(parseInt(s));
        break;
      case "o":
        if (n.belowGradeOtherRoomCount !== void 0)
          throw new Pt('"o" appears multiple times in input');
        n.belowGradeOtherRoomCount = gt.fromNumber(parseInt(r));
        break;
      default:
        throw new Pt(`Unknown parking space type: ${o}`);
    }
  return n;
}
var noe = {
  encode: eoe,
  decode: toe
}, _C = re(ce(), 1), Sh = {
  encode: (e) => {
    const t = e.fullBaths ?? 0, n = e.halfBaths ?? 0;
    return `${t}.${n}`;
  },
  decode: (e) => {
    const [t, n] = e.trim().split(".").map((r) => r.trim());
    try {
      return {
        fullBaths: (0, _C.orUndefined)(xe.parse)(t),
        halfBaths: (0, _C.orUndefined)(xe.parse)(n)
      };
    } catch {
      throw new Pt(`Invalid bathroom count provided: ${e}`);
    }
  }
}, roe = /* @__PURE__ */ new Set(["C1", "C2", "C3", "C4", "C5", "C6"]), ooe = {
  encode(e) {
    return e.condition ?? "";
  },
  decode(e) {
    const t = e.trim().toUpperCase();
    if (t === "")
      return { condition: void 0 };
    if (!roe.has(t))
      throw new Pt(`Invalid quality code: ${t}`);
    return { condition: t };
  }
}, aoe = re(ce(), 1), ioe = new RegExp(/^[^;]*;\s*dom\s*(\d+|unk)$/), soe = new RegExp(/^dom (\d+|unk)$/);
function loe({ mls: e, listingID: t, daysOnMarket: n }) {
  return [e, t, n].every(aoe.isUndefined) ? "" : `${e ?? ""}${t ? `#${t}` : ""}; DOM ${n ?? "Unk"}`;
}
function uoe(e) {
  var l;
  if (e === "")
    return {};
  if (!e.trim().toLowerCase().match(ioe))
    throw new Pt(`Invalid data source: ${e}`);
  const [t, n] = e.split(";"), [r, o] = (t == null ? void 0 : t.split("#")) ?? [];
  let a;
  const s = (l = n == null ? void 0 : n.trim().toLowerCase()) == null ? void 0 : l.match(soe);
  if (s && s[1] !== "unk")
    try {
      a = xe.parse(+s[1]);
    } catch (c) {
      console.warn("Could not parse DOM", c);
    }
  return {
    mls: (r == null ? void 0 : r.trim()) === "" || r == null ? void 0 : r.trim(),
    listingID: coe(o),
    daysOnMarket: a
  };
}
function coe(e) {
  const t = e != null && e.startsWith(":") ? e.slice(1) : e, n = t == null ? void 0 : t.trim();
  return n === "" ? void 0 : n;
}
var Sf = {
  encode: loe,
  decode: uoe
}, k3 = re(ce(), 1);
function doe(e) {
  const { listingStatus: t, contractDate: n, closeDate: r, withdrawalDate: o, expirationDate: a } = e;
  if (t === void 0)
    throw new La("Listing status is required");
  switch (t) {
    case "Active":
      return "Active";
    case "Expired": {
      if (a === void 0)
        throw new La("Missing expiration date for expired listing");
      return "e" + Ea.encode(a);
    }
    case "Withdrawn": {
      if (o === void 0)
        throw new La("Missing withdrawal date for withdrawn listing");
      return "w" + Ea.encode(o);
    }
    case "Contract": {
      if (n === void 0)
        throw new La("Missing contract date for contract listing");
      return "c" + Ea.encode(n);
    }
    case "SettledSale": {
      if (r === void 0)
        throw new La("Missing close date for settled listing");
      const s = "s" + Ea.encode(r), l = n === void 0 ? "Unk" : "c" + Ea.encode(n);
      return `${s};${l}`;
    }
    default:
      throw new La(`Unknown listing status: ${t}`);
  }
}
function foe(e, t) {
  const n = e.trim().toLowerCase(), r = {
    listingStatus: void 0,
    closeDate: void 0,
    contractDate: void 0,
    expirationDate: void 0,
    withdrawalDate: void 0
  };
  if (n === "")
    return r;
  if (n === "active")
    return r.listingStatus = "Active", r;
  const o = (t == null ? void 0 : t.closeDate) ?? (t == null ? void 0 : t.contractDate) ?? (t == null ? void 0 : t.expirationDate) ?? (t == null ? void 0 : t.withdrawalDate);
  switch (n.charAt(0)) {
    case "e": {
      r.listingStatus = "Expired", r.expirationDate = Ea.decode(
        n.slice(1),
        (t == null ? void 0 : t.expirationDate) ?? o
      );
      break;
    }
    case "w": {
      r.listingStatus = "Withdrawn", r.withdrawalDate = Ea.decode(
        n.slice(1),
        (t == null ? void 0 : t.withdrawalDate) ?? o
      );
      break;
    }
    case "c": {
      r.listingStatus = "Contract", r.contractDate = Ea.decode(n.slice(1), (t == null ? void 0 : t.contractDate) ?? o);
      break;
    }
    case "s": {
      const a = n.split(";").map((c) => c.trim()), [s, l] = (0, k3.checkMinLength)(1, a);
      r.listingStatus = "SettledSale", r.closeDate = Ea.decode(
        s.slice(1),
        (t == null ? void 0 : t.closeDate) ?? o
      ), r.contractDate = l === void 0 || l === "unk" ? void 0 : Ea.decode(l.slice(1), (t == null ? void 0 : t.contractDate) ?? o);
      break;
    }
    default:
      throw new Pt(`Invalid FNMA UAD date of sale string: ${n}`);
  }
  return r;
}
var Ea = {
  encode: (e) => e.format("MM/yy"),
  decode: (e, t) => {
    let n;
    if (n = /^([0-9]{2})\/([0-9]{2})$/.exec(e), n === null)
      throw new Pt(`${e}: Invalid date format, expected MM/YY`);
    const [, r, o] = (0, k3.checkLength)(3, n), a = parseInt(r), s = parseInt(o);
    let l = 1990, c = 1;
    if (t !== void 0 && (n = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(t.toIsoString()), n !== null)) {
      const [, x, , I] = (0, k3.checkLength)(4, n);
      l = parseInt(x), c = parseInt(I);
    }
    const d = 1900 + s, f = 2e3 + s, h = Math.abs(d - l) < Math.abs(f - l) ? d : f, m = a, g = c, b = h.toFixed(0).padStart(4, "0"), C = m.toFixed(0).padStart(2, "0"), y = g.toFixed(0).padStart(2, "0"), _ = `${b}-${C}-${y}`;
    return Fr.fromIsoString(_);
  }
}, hoe = {
  encode: doe,
  decode: foe
}, IC = re(ce(), 1), poe = new RegExp(/^(AT|DT|SD)?(\d|\d\.\d{1,2})?;(.+)?$/);
function moe(e) {
  var r;
  const t = ["", ""];
  let n = ((r = e.stories) == null ? void 0 : r.toFixed(2)) ?? "";
  for (; n.endsWith("0"); )
    n = n.slice(0, -1);
  return n.endsWith(".") && (n = n.slice(0, -1)), t[0] = `${e.attachmentType ?? ""}${n}`, e.style !== void 0 && (t[1] = e.style), t.join(";");
}
function goe(e) {
  if (e === "")
    return {
      attachmentType: void 0,
      stories: void 0,
      style: void 0
    };
  const t = e.match(poe);
  if (!t)
    throw new Pt(`Cannot decode design style: ${e}`);
  return {
    attachmentType: (0, IC.orUndefined)(F4.parse)(t[1]),
    stories: (0, IC.orUndefined)((n) => +n)(t[2]),
    style: t[3]
  };
}
var Ah = { encode: moe, decode: goe }, L_ = gd(
  "financing type",
  {
    Conventional: "Conv",
    FHA: "FHA",
    VA: "VA",
    Cash: "Cash",
    USDA: "USDA",
    Private: "Private"
  },
  { allowOther: !0 }
), voe = (e) => {
  var o;
  const t = e.financingType === void 0 ? "" : L_.encode(e.financingType), n = ((o = e.financialConcessionAmount) == null ? void 0 : o.toString(!0)) ?? "", r = `${t};${n}`;
  return r === ";" ? "" : r;
}, Coe = (e) => {
  let [t, n] = e.split(";").map((a) => a.trim());
  if (t === "Conv" && (t = "Conventional"), !e.includes(";"))
    return D1.safeParse(t).success ? { financingType: D1.parse(t) } : Number.isNaN(Number(t.replaceAll("$", "").replaceAll(",", ""))) ? {} : { financialConcessionAmount: jt.fromDollarLike(t) };
  const r = t === "" ? void 0 : t, o = n === "" ? void 0 : n;
  return {
    financingType: r ? D1.parse(L_.decode(r)) : void 0,
    financialConcessionAmount: o ? jt.fromDollarLike(o, "usd") : void 0
  };
}, boe = { encode: voe, decode: Coe };
function yoe(e) {
  const t = [];
  return e.attachedGarageSpaces !== void 0 && t.push(`${e.attachedGarageSpaces}ga`), e.detachedGarageSpaces !== void 0 && t.push(`${e.detachedGarageSpaces}gd`), e.builtInGarageSpaces !== void 0 && t.push(`${e.builtInGarageSpaces}gbi`), e.carportSpaces !== void 0 && t.push(`${e.carportSpaces}cp`), e.drivewaySpaces !== void 0 && t.push(`${e.drivewaySpaces}dw`), t.length < 1 ? "None" : t.join("");
}
function Soe(e) {
  const t = e.trim().toLowerCase(), n = {
    attachedGarageSpaces: void 0,
    detachedGarageSpaces: void 0,
    builtInGarageSpaces: void 0,
    carportSpaces: void 0,
    drivewaySpaces: void 0
  };
  if (t === "" || t === "none")
    return n;
  for (const [r, o] of bh(t))
    switch (o) {
      case "ga":
        if (n.attachedGarageSpaces !== void 0)
          throw new Pt('"ga" appears multiple times in input');
        n.attachedGarageSpaces = Kc(r);
        break;
      case "gd":
        if (n.detachedGarageSpaces !== void 0)
          throw new Pt('"gd" appears multiple times in input');
        n.detachedGarageSpaces = Kc(r);
        break;
      case "gbi":
        if (n.builtInGarageSpaces !== void 0)
          throw new Pt('"gbi" appears multiple times in input');
        n.builtInGarageSpaces = Kc(r);
        break;
      case "cp":
        if (n.carportSpaces !== void 0)
          throw new Pt('"cp" appears multiple times in input');
        n.carportSpaces = Kc(r);
        break;
      case "dw":
        if (n.drivewaySpaces !== void 0)
          throw new Pt('"dw" appears multiple times in input');
        n.drivewaySpaces = Kc(r);
        break;
      default:
        throw new Pt(`Unknown parking space type: ${o}`);
    }
  return n;
}
var Mh = {
  encode: yoe,
  decode: Soe
};
function Kc(e) {
  if (isNaN(+e)) {
    console.warn(`${e} is not a n`);
    return;
  }
  try {
    return kr.parse(+e);
  } catch {
    console.warn(`${e} does not match parking space schema`);
    return;
  }
}
var Aoe = re(ce(), 1), xh = gd("impact rating", {
  Neutral: "N",
  Beneficial: "B",
  Adverse: "A"
}), Af = gd(
  "location type",
  {
    Residential: "Res",
    Industrial: "Ind",
    Commercial: "Comm",
    BusyRoad: "BsyRd",
    WaterFront: "WtrFr",
    GolfCourse: "GlfCse",
    AdjacentToPark: "AdjPrk",
    AdjacentToPowerLines: "AdjPwr",
    Landfill: "Lndfl",
    PublicTransportation: "PubTrn"
  },
  { allowOther: !0 }
);
function Moe(e) {
  const t = [];
  for (t.push(
    e.locationImpact === void 0 ? "" : xh.encode(e.locationImpact)
  ), e.locationFactorOne !== void 0 && t.push(Af.encode(e.locationFactorOne)), e.locationFactorTwo !== void 0 && t.push(Af.encode(e.locationFactorTwo)); t.length > 0 && t[0] !== "" && t.length < 3; )
    t.push("");
  return t.join(";");
}
function xoe(e) {
  const [t, n, r] = (0, Aoe.checkMinLength)(1, e.trim().split(";"));
  return {
    locationImpact: t === "" ? void 0 : xh.decode(t),
    locationFactorOne: n === void 0 || n === "" ? void 0 : Af.decode(n),
    locationFactorTwo: r === void 0 || r === "" ? void 0 : Af.decode(r)
  };
}
var _oe = { encode: Moe, decode: xoe }, Ioe = /* @__PURE__ */ new Set(["Q1", "Q2", "Q3", "Q4", "Q5", "Q6"]), woe = {
  encode(e) {
    return e.quality ?? "";
  },
  decode(e) {
    const t = e.trim().toUpperCase();
    if (t === "")
      return { quality: void 0 };
    if (!Ioe.has(t))
      throw new Pt(`Invalid quality code: ${t}`);
    return { quality: t };
  }
};
function Loe(e) {
  return e.site === void 0 ? "" : G4.encode(e.site);
}
function Roe(e) {
  return { site: e.trim() === "" ? void 0 : G4.decode(e) };
}
var _h = { encode: Loe, decode: Roe }, Eoe = re(ce(), 1), Mf = gd(
  "view type",
  {
    WaterView: "Wtr",
    PastoralView: "Pstrl",
    WoodsView: "Woods",
    ParkView: "Prk",
    GolfCourseView: "Glfvw",
    CitySkylineView: "CtySky",
    MountainView: "Mtn",
    ResidentialView: "Res",
    CityStreetView: "CtyStr",
    IndustrialView: "Ind",
    PowerLines: "PwrLn",
    LimitedSight: "LtdSght"
  },
  { allowOther: !0 }
);
function Doe(e) {
  const t = [];
  for (t.push(
    e.viewImpact === void 0 ? "" : xh.encode(e.viewImpact)
  ), e.viewFactorOne !== void 0 && t.push(Mf.encode(e.viewFactorOne)), e.viewFactorTwo !== void 0 && t.push(Mf.encode(e.viewFactorTwo)); t.length > 0 && t[0] !== "" && t.length < 3; )
    t.push("");
  return t.join(";");
}
function Noe(e) {
  const [t, n, r] = (0, Eoe.checkMinLength)(1, e.trim().split(";"));
  let o;
  try {
    o = t === "" ? void 0 : xh.decode(t);
  } catch {
    console.error("Failed to parse view impact");
  }
  return {
    viewImpact: o,
    viewFactorOne: n === void 0 || n === "" ? void 0 : Mf.decode(n),
    viewFactorTwo: r === void 0 || r === "" ? void 0 : Mf.decode(r)
  };
}
var Toe = { encode: Doe, decode: Noe }, mu = re(ce(), 1), Poe = new RegExp(
  /^(c|s|w|e)(([0-9]{2}\/[0-9]{2})?)(;(c([0-9]{2}\/[0-9]{2})|unk))?$/
), koe = new RegExp(/^(1[0-2]|0[1-9])\/([0-9]{2})$/);
function Voe(e) {
  const { listingStatus: t, contractMonth: n, closeMonth: r, withdrawalMonth: o, expirationMonth: a } = e;
  if ([t, n, r, o, a].every(
    (s) => s === void 0
  ))
    return "";
  if (t === void 0)
    throw new La("Listing status is required");
  switch (t) {
    case "Active":
      return "Active";
    case "Expired":
      return "e" + n2(a);
    case "Withdrawn":
      return "w" + n2(o);
    case "Contract":
      return "c" + n2(n);
    case "SettledSale": {
      const s = "s" + n2(r), l = n === void 0 ? "Unk" : "c" + R_(n);
      return `${s};${l}`;
    }
    default:
      throw new La(`Unknown listing status: ${t}`);
  }
}
function n2(e) {
  return (0, mu.isUndefined)(e) ? "" : R_(e);
}
function Ooe(e) {
  const t = e.trim().toLowerCase(), n = {
    listingStatus: void 0,
    closeMonth: void 0,
    contractMonth: void 0,
    expirationMonth: void 0,
    withdrawalMonth: void 0
  };
  if (t === "")
    return n;
  if (t === "active")
    return n.listingStatus = "Active", n;
  const r = t.match(Poe);
  if (!r)
    throw new Pt(`Invalid FNMA UAD date of sale string: ${t}`);
  switch (r[1]) {
    case "e": {
      n.listingStatus = "Expired", n.expirationMonth = (0, mu.orUndefined)(Qc)(r[3]);
      break;
    }
    case "w": {
      n.listingStatus = "Withdrawn", n.withdrawalMonth = (0, mu.orUndefined)(Qc)(r[3]);
      break;
    }
    case "c": {
      n.listingStatus = "Contract", n.contractMonth = (0, mu.orUndefined)(Qc)(r[3]);
      break;
    }
    case "s": {
      n.listingStatus = "SettledSale", n.closeMonth = (0, mu.orUndefined)(Qc)(r[3]), r[5] && (n.contractMonth = (0, mu.orUndefined)(Qc)(r[6]));
      break;
    }
    default:
      throw new Pt(`Invalid FNMA UAD date of sale string: ${t}`);
  }
  return n;
}
function R_(e) {
  const t = e.match(gh);
  if (!t)
    throw Error(`Invalid ISO month provided: ${e}`);
  return `${t[2]}/${t[1].slice(2)}`;
}
function Qc(e) {
  if (e === "unk")
    return;
  const t = e.match(koe);
  if (!t) {
    console.error(`Invalid UAD month provided: ${e}`);
    return;
  }
  const n = t[1], r = t[2], o = +r >= 30 ? `19${r}` : `20${r}`;
  return _r.parse(`${o}-${n}`);
}
function Foe(e) {
  const t = e.match(gh);
  if (!t)
    throw Error(`Invalid ISO month provided: ${e}`);
  return Fr.fromIsoString(`${t[1]}-${t[2]}-01`);
}
function Boe(e) {
  return e.format("yyyy-MM");
}
var Ih = {
  encode: Voe,
  decode: Ooe
};
function Hoe(e) {
  return e.toSqFt().toSqFtValueStringRounded();
}
function Goe(e) {
  if (e === "")
    return xt.zero;
  try {
    return xt.fromNumber(xe.parse(e), "sqft");
  } catch {
    throw new Pt(`Invalid GLA: ${e}`);
  }
}
var wh = { encode: Hoe, decode: Goe }, $oe = re(ce(), 1), Zoe = new RegExp(/^(~?)(\d*)$/);
function joe({ age: e, isEstimation: t }) {
  return `${t ? "~" : ""}${(0, $oe.isDefined)(e) ? e : ""}`;
}
function Woe(e) {
  if (e === "")
    return {};
  const t = e.match(Zoe);
  if (!t)
    throw new Pt(`Invalid actual age: ${e}`);
  const n = t[1], r = t[2], o = n === "~";
  return {
    age: r === "" ? void 0 : xe.parse(+r),
    isEstimation: o
  };
}
var Lh = { encode: joe, decode: Woe };
function zoe(e) {
  return (e == null ? void 0 : e.toNumericPrice().toFixed(0)) ?? "";
}
function Uoe(e) {
  if (e !== "")
    try {
      return jt.fromDollarLike(e);
    } catch {
      throw new Pt(`Invalid price: ${e}`);
    }
}
var Rh = { encode: zoe, decode: Uoe }, Xoe = re(ce(), 1);
function Yoe(e) {
  const t = e == null ? void 0 : e.toString();
  return (0, Xoe.isUndefined)(t) ? "" : t;
}
function qoe(e) {
  const t = e.trim();
  if (t === "")
    return;
  const n = +t;
  if (isNaN(n))
    throw new Pt(`Invalid number: ${e}`);
  return n;
}
var ds = { encode: Yoe, decode: qoe }, ho = {
  StructuralDesignDescription: {
    values: [
      "Craftsman",
      "Mid Century",
      "Tudor",
      "Victorian",
      "Contemporary",
      "Traditional",
      "Bungalow",
      "Cape Code",
      "Modern"
    ],
    allowOther: !0
  },
  ValueMarketabilityImpactType: {
    // only UAD
    values: ["Neutral", "Beneficial", "Adverse"],
    allowOther: !1
  },
  BelowGradeExteriorAccessType: {
    values: ["WalkOut", "WalkUp", "InteriorOnly"],
    allowOther: !1
  },
  StructuralDesignType: {
    // This one is a shot in the dark
    // /VALUATION_RESPONSE/PROPERTY/PROJECT[@_DesignType='Other' and @_DesignTypeOtherDescription='AttachedAndDetached']
    values: ["Attached", "Detached"],
    allowOther: !0
  },
  ListingStatusType: {
    values: [
      "Active",
      "Expired",
      "Withdrawn",
      "Contract",
      "SettledSale",
      "Rented",
      "Backup",
      "ComingSoon",
      "Off-Market",
      "Deleted",
      "Cancelled",
      "Other",
      "Unknown",
      "Pending"
    ],
    allowOther: !1
  },
  OverallConditionRatingCode: {
    values: ["C1", "C2", "C3", "C4", "C5", "C6"],
    allowOther: !1
  },
  OverallQualityRatingCode: {
    values: ["Q1", "Q2", "Q3", "Q4", "Q5", "Q6"],
    allowOther: !1
  },
  ViewType: {
    // TODO this also has a PDF view
    values: [
      "WaterView",
      "PastoralView",
      "WoodsView",
      "ParkView",
      "GolfCourseView",
      "CitySkylineView",
      "MountainView",
      "ResidentialView",
      "CityStreetView",
      "IndustrialView",
      "PowerLines",
      "LimitedSight"
    ],
    allowOther: !0
  },
  LocationType: {
    // This also requires PDF Display values
    values: [
      "Residential",
      "Industrial",
      "Commercial",
      "BusyRoad",
      "WaterFront",
      "GolfCourse",
      "AdjacentToPark",
      "AdjacentToPowerLines",
      "Landfill",
      "PublicTransportation"
    ],
    allowOther: !0
  },
  LeaseholdOrFeeSimple: { values: ["Leasehold", "FeeSimple"], allowOther: !1 },
  DesignAttachmentType: { values: ["Detached", "Attached", "SemiDetached"], allowOther: !1 }
}, Joe = re(mh(), 1), Koe = (0, Joe.AloftEnum)()({
  Active: "Active",
  Expired: "Expired",
  Withdrawn: "Withdrawn",
  Contract: "Contract",
  SettledSale: "SettledSale"
}), Qoe = {
  values: Koe._keys,
  allowOther: !1
}, E_ = {
  address: {
    label: "Address",
    type: "address",
    valueProps: {
      formatValue: (e) => {
        var t;
        return ((t = e.address) == null ? void 0 : t.AddressLineText) ?? "";
      }
    }
  },
  projectPhase: {
    label: "Project Phase",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "projectPhase"
      }
    }
  },
  projectName: {
    label: "Project Name",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "projectName"
      }
    }
  },
  salePrice: {
    label: "Sale Price",
    type: "price",
    valueProps: {
      annotator: { t: "AloftPrice", optional: !0, valueKey: "salePrice" },
      formatValue: (e) => {
        var t;
        return ((t = e.salePrice) == null ? void 0 : t.toString(!0)) ?? "";
      }
    }
  },
  listPrice: {
    label: "List Price",
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: !0,
        valueKey: "listPrice"
      }
    }
  },
  grossMonthlyRent: {
    label: "Gross Monthly Rent",
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: !0,
        valueKey: "grossMonthlyRent"
      }
    }
  },
  rentControl: {
    label: "Rent Control",
    type: "boolean",
    valueProps: {
      annotator: {
        t: "boolean",
        optional: !0,
        valueKey: "rentControl"
      }
    }
  },
  dataSources: {
    label: "Data Source(s)",
    isHiddenForSubject: !0,
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "dataSources"
      }
    }
  },
  verificationSources: {
    label: "Verification Source(s)",
    isHiddenForSubject: !0,
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "verificationSources"
      }
    }
  },
  saleType: {
    label: "Terms of Sale",
    isHiddenForSubject: !0,
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "saleType",
        enum: { values: H4, allowOther: !1 }
      }
    },
    adjustProps: {
      manualTerm: "saleTypeManual"
    }
  },
  financingType: {
    label: "Financing Type",
    isHiddenForSubject: !0,
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "financingType",
        enum: { values: D1.options, allowOther: !0 }
      }
    }
  },
  financialConcessionAmount: {
    label: "Concession Amount",
    isHiddenForSubject: !0,
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: !0,
        valueKey: "financialConcessionAmount"
      }
    }
  },
  listingStatus: {
    label: "Listing Status",
    isHiddenForSubject: !0,
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "listingStatus",
        enum: Qoe
      }
    }
  },
  listDate: {
    label: "List Date",
    isHiddenForSubject: !0,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: !0,
        valueKey: "listDate"
      }
    }
  },
  contractDate: {
    label: "Contract Date",
    isHiddenForSubject: !0,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: !0,
        valueKey: "contractDate"
      }
    }
  },
  closeDate: {
    label: "Close Date",
    isHiddenForSubject: !0,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: !0,
        valueKey: "closeDate"
      }
    }
  },
  withdrawalDate: {
    label: "Withdrawal Date",
    isHiddenForSubject: !0,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: !0,
        valueKey: "withdrawalDate"
      }
    }
  },
  expirationDate: {
    label: "Expiration Date",
    isHiddenForSubject: !0,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: !0,
        valueKey: "expirationDate"
      }
    }
  },
  leaseholdOrFeeSimple: {
    label: "Leasehold/Fee Simple",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "leaseholdOrFeeSimple",
        enum: ho.LeaseholdOrFeeSimple
      }
    },
    adjustProps: {
      manualTerm: "leaseholdFeeSimpleManual"
    }
  },
  locationImpact: {
    label: "Location Impact",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "locationImpact",
        enum: ho.ValueMarketabilityImpactType
      }
    }
  },
  locationFactorOne: {
    label: "Location Factor 1",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "locationFactorOne",
        enum: ho.LocationType
      }
    }
  },
  locationFactorTwo: {
    label: "Location Factor 2 (Opt.)",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "locationFactorTwo",
        enum: ho.LocationType
      }
    }
  },
  site: {
    label: "Lot Size",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: !0,
        valueKey: "site"
      }
    },
    adjustProps: {
      manualTerm: "siteManual",
      managedTerms: ["site"]
    }
  },
  viewImpact: {
    label: "View Impact",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "viewImpact",
        enum: ho.ValueMarketabilityImpactType
      }
    }
  },
  viewFactorOne: {
    label: "View Factor 1",
    type: "string",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "viewFactorOne",
        enum: ho.ViewType
      }
    }
  },
  viewFactorTwo: {
    label: "View Factor 2 (Opt.)",
    type: "string",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "viewFactorTwo",
        enum: ho.ViewType
      }
    }
  },
  designAttachmentType: {
    label: "Attachment Type",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "designAttachmentType",
        enum: ho.DesignAttachmentType
      }
    }
  },
  designNumberOfStories: {
    label: "# of Stories",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "designNumberOfStories"
      }
    }
  },
  designStyle: {
    label: "Design (Style)",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "designStyle"
      }
    }
  },
  quality: {
    label: "Quality",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "quality",
        enum: ho.OverallQualityRatingCode
      }
    },
    adjustProps: {
      manualTerm: "qualityManual",
      managedTerms: ["quality"]
    }
  },
  age: {
    label: "Actual Age",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "age"
      }
    },
    adjustProps: {
      manualTerm: "ageManual"
    }
  },
  yearBuilt: {
    label: "Year Built",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "yearBuilt"
      }
    }
  },
  condition: {
    label: "Condition",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "condition",
        enum: ho.OverallConditionRatingCode
      }
    },
    adjustProps: {
      manualTerm: "conditionManual",
      managedTerms: ["condition"]
    }
  },
  aboveGradeBedroomCount: {
    label: "Above Grade Bedroom Count",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "aboveGradeBedroomCount"
      }
    }
  },
  totalBathCount: {
    label: "Total Bathroom Count",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "totalBathCount"
      }
    }
  },
  aboveGradeFullBathCount: {
    label: "Above Grade Bathrooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "aboveGradeFullBathCount"
      }
    }
  },
  aboveGradeHalfBathCount: {
    label: "Above Grade 1/2 Baths",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "aboveGradeHalfBathCount"
      }
    }
  },
  aboveGradeThreeQuarterBathCount: {
    label: "Above Grade 3/4 Baths",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "aboveGradeThreeQuarterBathCount"
      }
    }
  },
  aboveGradeTotalRoomCount: {
    label: "Above Grade Room Count",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "aboveGradeTotalRoomCount"
      }
    }
  },
  grossLivingArea: {
    label: "Gross Living Area",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: !0,
        valueKey: "grossLivingArea"
      }
    },
    adjustProps: {
      manualTerm: "grossLivingAreaManual",
      managedTerms: ["grossLivingArea"]
    }
  },
  grossBuildingArea: {
    label: "Gross Building Area",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: !0,
        valueKey: "grossBuildingArea"
      }
    }
  },
  hasBasement: {
    label: "Has Basement",
    type: "boolean",
    valueProps: {
      annotator: {
        t: "boolean",
        optional: !0,
        valueKey: "hasBasement"
      }
    }
  },
  totalBasementArea: {
    label: "Total Basement Sqft",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: !0,
        valueKey: "totalBasementArea"
      }
    },
    adjustProps: {
      manualTerm: "totalBasementAreaManual",
      managedTerms: ["totalBasementArea"]
    }
  },
  finishedBasementArea: {
    label: "Finished Basement Sqft",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: !0,
        valueKey: "finishedBasementArea"
      }
    }
  },
  basementFinishedRoomCount: {
    label: "Basement Finished Room Count",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "basementFinishedRoomCount"
      }
    }
  },
  basementDescription: {
    label: "Basement Description",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "basementDescription"
      }
    }
  },
  belowGradeExteriorAccessType: {
    label: "Basement Access",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "belowGradeExteriorAccessType",
        enum: ho.BelowGradeExteriorAccessType
      }
    }
  },
  belowGradeRecRoomCount: {
    label: "Below Grade Rec Rooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "belowGradeRecRoomCount"
      }
    }
  },
  belowGradeBedroomCount: {
    label: "Below Grade Bedrooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "belowGradeBedroomCount"
      }
    }
  },
  belowGradeFullBathCount: {
    label: "Below Grade Bathrooms",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "belowGradeFullBathCount"
      }
    }
  },
  belowGradeHalfBathCount: {
    label: "Below Grade 1/2 Baths",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "belowGradeHalfBathCount"
      }
    }
  },
  belowGradeThreeQuarterBathCount: {
    label: "Below Grade 3/4 Baths",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "belowGradeThreeQuarterBathCount"
      }
    }
  },
  belowGradeOtherRoomCount: {
    label: "Below Grade Other Rooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "belowGradeOtherRoomCount"
      }
    }
  },
  finishedRoomsBelowGrade: {
    label: "Below Grade Finished Rooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "finishedRoomsBelowGrade"
      }
    }
  },
  heatingCooling: {
    label: "Heating/Cooling",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "heatingCooling"
      }
    },
    adjustProps: {
      manualTerm: "heatingCoolingManual"
    }
  },
  functionalUtility: {
    label: "Functionality Utility",
    type: "enum",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "functionalUtility"
      }
    },
    adjustProps: {
      manualTerm: "functionalUtilityManual",
      managedTerms: ["functionalUtility"]
    }
  },
  energyEfficientItems: {
    label: "Energy Efficient Items",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "energyEfficientItems"
      }
    },
    adjustProps: {
      manualTerm: "energyEfficientItemsManual",
      managedTerms: ["energyEfficientItems"]
    }
  },
  attachedGarageParkingSpacesCount: {
    label: "Attached Garage Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "attachedGarageParkingSpacesCount"
      }
    }
  },
  detachedGarageParkingSpacesCount: {
    label: "Detached Garage Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "detachedGarageParkingSpacesCount"
      }
    }
  },
  builtInGarageParkingSpacesCount: {
    label: "Built-in Garage Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "builtInGarageParkingSpacesCount"
      }
    }
  },
  carportParkingSpacesCount: {
    label: "Carport Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "carportParkingSpacesCount"
      }
    }
  },
  drivewayParkingSpacesCount: {
    label: "Driveway Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "drivewayParkingSpacesCount"
      }
    }
  },
  porchPatioDeck: {
    label: "Porch/Patio/Deck",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "porchPatioDeck"
      }
    },
    adjustProps: {
      manualTerm: "porchPatioDeckManual"
    }
  },
  hoaMonthlyAssessment: {
    label: "HOA Monthly Assessment",
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: !0,
        valueKey: "hoaMonthlyAssessment"
      }
    }
  },
  commonElementsAndRecFacilities: {
    label: "Common Elements and Rec Facilities",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "commonElementsAndRecFacilities"
      }
    }
  },
  floorLocation: {
    label: "Floor Location",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "floorLocation",
        enum: { values: [], allowOther: !1 }
      }
    }
  },
  propertyType: {
    label: "Property Type",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "propertyType"
      }
    }
  },
  propertySubtype: {
    label: "Property Subtype",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "propertySubtype"
      }
    }
  },
  stucturalDesignDescription: {
    label: "Structural Design",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "stucturalDesignDescription",
        enum: ho.StructuralDesignDescription
      }
    }
  },
  structureType: {
    label: "Structure Type",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "structureType",
        enum: ho.StructuralDesignType
      }
    }
  },
  storiesDescription: {
    label: "Stories Description",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "storiesDescription"
      }
    }
  },
  elementarySchool: {
    label: "Elementary School",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "elementarySchool"
      }
    }
  },
  mlsArea: {
    label: "MLS Area",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "mlsArea"
      }
    }
  },
  listingID: {
    label: "Listing ID",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "listingID"
      }
    }
  },
  marketingCommentary: {
    label: "Marketing Commentary",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "marketingCommentary"
      }
    }
  },
  daysOnMarket: {
    label: "Days on Market",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "daysOnMarket"
      }
    }
  },
  cumulativeDaysOnMarket: {
    label: "Cumulative Days on Market",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "cumulativeDaysOnMarket"
      }
    }
  },
  longitude: {
    label: "Longitude",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "longitude"
      }
    }
  },
  latitude: {
    label: "Latitude",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "latitude"
      }
    }
  },
  architectureStyle: {
    label: "Architectural Style",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "architectureStyle"
      }
    }
  },
  assesorsMapReferenceID: {
    label: "Assessors Map Reference ID",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "assesorsMapReferenceID"
      }
    }
  },
  parcelID: {
    label: "Parcel ID",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "parcelID"
      }
    }
  },
  censusTractID: {
    label: "Census Tract ID",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "censusTractID"
      }
    }
  },
  zoningDescription: {
    label: "Zoning Description",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "zoningDescription"
      }
    }
  },
  legalDescription: {
    label: "Legal Description",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "legalDescription"
      }
    }
  },
  sewerType: {
    label: "Sewer Type",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "sewerType"
      }
    }
  },
  annualTaxAmount: {
    label: "Annual Tax Amount",
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: !0,
        valueKey: "annualTaxAmount"
      }
    }
  },
  taxYear: {
    label: "Tax Year",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "taxYear"
      }
    }
  },
  ownerOccupied: {
    label: "Owner Occupied",
    type: "boolean",
    valueProps: {
      annotator: {
        t: "boolean",
        optional: !0,
        valueKey: "ownerOccupied"
      }
    }
  },
  hasAttachment: {
    label: "Has Attachment",
    type: "boolean",
    valueProps: {
      annotator: {
        t: "boolean",
        optional: !0,
        valueKey: "hasAttachment"
      }
    }
  },
  mls: {
    label: "MLS",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "mls"
      }
    }
  },
  additionalFeature1Title: {
    label: "Additional Feature 1 Title",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "additionalFeature1Title"
      }
    }
  },
  additionalFeature1Description: {
    label: (e) => e.additionalFeature1Title ?? "Additional Feature 1",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "additionalFeature1Description"
      }
    },
    adjustProps: {
      manualTerm: "additionalFeature1Manual",
      managedTerms: ["additionalFeature1"]
    }
  },
  additionalFeature2Title: {
    label: "Additional Feature 2 Title",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "additionalFeature2Title"
      }
    }
  },
  additionalFeature2Description: {
    label: (e) => e.additionalFeature2Title ?? "Additional Feature 2",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "additionalFeature2Description"
      }
    },
    adjustProps: {
      manualTerm: "additionalFeature2Manual",
      managedTerms: ["additionalFeature2"]
    }
  },
  additionalFeature3Title: {
    label: "Additional Feature 3 Title",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "additionalFeature3Title"
      }
    }
  },
  additionalFeature3Description: {
    label: (e) => e.additionalFeature3Title ?? "Additional Feature 3",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "additionalFeature3Description"
      }
    },
    adjustProps: {
      manualTerm: "additionalFeature3Manual",
      managedTerms: ["additionalFeature3"]
    }
  },
  salesPricePerGrossLivingArea: {
    label: "Sale Price/GLA",
    type: "string",
    valueProps: {
      formatValue: (e) => {
        const { salePrice: t } = e, n = e.grossLivingArea;
        return t === void 0 || n === void 0 ? "" : t.div(n.toSqFt().unitAmount).toString();
      }
    }
  },
  dateOfSale: {
    label: "Date of Sale",
    type: "string",
    isHiddenForSubject: !0,
    valueProps: {
      formatValue: ri.legacyDateOfSaleSyntax.encode
    },
    adjustProps: {
      manualTerm: "dateOfSaleManual",
      managedTerms: ["dateOfSale", "listToSale"],
      isRequired: !0
    }
  },
  location: {
    label: "Location",
    type: "string",
    valueProps: {
      formatValue: ri.locationSyntax.encode
    },
    adjustProps: {
      manualTerm: "locationManual",
      managedTerms: ["location"]
    }
  },
  view: {
    label: "View",
    type: "string",
    valueProps: {
      formatValue: ri.viewSyntax.encode
    },
    adjustProps: {
      manualTerm: "viewManual",
      managedTerms: ["view"]
    }
  },
  design: {
    label: "Design (Style)",
    type: "string",
    valueProps: {
      formatValue: (e) => {
        const t = e.designAttachmentType === "Attached" ? "AT" : e.designAttachmentType === "Detached" ? "DT" : e.designAttachmentType === "SemiDetached" ? "SD" : void 0;
        return ri.designSyntax.encode({
          attachmentType: t,
          stories: e.designNumberOfStories,
          style: e.designStyle
        });
      }
    },
    adjustProps: {
      manualTerm: "designManual",
      managedTerms: ["design", "designAttachmentType", "designNumberOfStories"]
    }
  },
  aboveGradeRoomCount: {
    label: "Above Grade Rooms",
    type: "string",
    valueProps: {
      formatValue: ({
        aboveGradeTotalRoomCount: e,
        aboveGradeBedroomCount: t,
        aboveGradeFullBathCount: n,
        aboveGradeHalfBathCount: r
      }) => {
        const o = (e == null ? void 0 : e.value) ?? 0, a = (t == null ? void 0 : t.value) ?? 0, s = (n == null ? void 0 : n.value) ?? 0, l = (r == null ? void 0 : r.value) ?? 0;
        return `${o}r${a}bd${s}.${l}ba`;
      }
    },
    adjustProps: {
      manualTerm: "aboveGradeRoomCountManual",
      managedTerms: [
        "aboveGradeBedroomCount",
        "aboveGradeFullBathCount",
        "aboveGradeHalfBathCount"
      ]
    }
  },
  belowGradeRoomCount: {
    label: "Below Grade Rooms",
    type: "string",
    valueProps: {
      formatValue: ri.legacyBasementLine2Syntax.encode
    },
    adjustProps: {
      manualTerm: "belowGradeRoomCountManual"
    }
  },
  garage: {
    label: "Garage/Carport",
    type: "string",
    valueProps: {
      formatValue: (e) => {
        var t, n, r, o, a;
        return ri.garageCarportSyntax.encode({
          attachedGarageSpaces: (0, Jc.orUndefined)(kr.parse)(
            (t = e.attachedGarageParkingSpacesCount) == null ? void 0 : t.toNumber()
          ),
          detachedGarageSpaces: (0, Jc.orUndefined)(kr.parse)(
            (n = e.detachedGarageParkingSpacesCount) == null ? void 0 : n.toNumber()
          ),
          builtInGarageSpaces: (0, Jc.orUndefined)(kr.parse)(
            (r = e.builtInGarageParkingSpacesCount) == null ? void 0 : r.toNumber()
          ),
          carportSpaces: (0, Jc.orUndefined)(kr.parse)(
            (o = e.carportParkingSpacesCount) == null ? void 0 : o.toNumber()
          ),
          drivewaySpaces: (0, Jc.orUndefined)(kr.parse)(
            (a = e.drivewayParkingSpacesCount) == null ? void 0 : a.toNumber()
          )
        });
      }
    },
    adjustProps: {
      manualTerm: "garageManual",
      managedTerms: [
        "garageParkingSpacesCount",
        "carportParkingSpacesCount",
        "drivewayParkingSpacesCount"
      ]
    }
  },
  financialConcessions: {
    label: "Financial Concessions",
    type: "string",
    valueProps: {
      formatValue: ({ financingType: e, financialConcessionAmount: t }) => ri.financialConcessionsSyntax.encode({
        financingType: D1.parse(e),
        financialConcessionAmount: t
      })
    },
    adjustProps: {
      manualTerm: "financialConcessionsManual"
    }
  },
  cooling: {
    label: "Cooling",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "cooling"
      }
    }
  },
  greenEnergyEfficient: {
    label: "Energy Efficiency",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "greenEnergyEfficient"
      }
    }
  },
  heating: {
    label: "Heating",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "heating"
      }
    }
  },
  poolFeatures: {
    label: "Pool",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "poolFeatures"
      }
    }
  },
  custom: {
    label: "Custom",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "custom"
      }
    }
  }
}, D_ = re(ce(), 1);
function Ui(e) {
  const { valueProps: t } = E_[e], n = t.formatValue ? t.formatValue : (r) => eae((0, D_.expected)(t.annotator), r) ?? "";
  return (r) => {
    try {
      return n(r);
    } catch (o) {
      if (o instanceof La)
        return "";
      throw o;
    }
  };
}
var eae = (e, t) => {
  const n = t[e.valueKey];
  switch (e.t) {
    case "string":
      return n;
    case "number":
      return n == null ? void 0 : n.toString();
    case "boolean":
      return (0, D_.orUndefined)(String)(n);
    case "ToolkitPropertyEnum":
      return n;
    case "AloftArea":
      return n == null ? void 0 : n.toString();
    case "AloftCount":
      return n == null ? void 0 : n.toString();
    case "AloftDate":
      return n == null ? void 0 : n.format();
    case "AloftPrice":
      return n == null ? void 0 : n.toString();
    case "AloftTime":
      return n == null ? void 0 : n.toIsoString();
    default:
      throw new Error(
        `Unsupported annotator type: ${e.t}`
      );
  }
}, tae = re(ce(), 1), nae = re(mh(), 1), rae = class extends Error {
};
function oae(e, t) {
  if (!e)
    throw new rae(t ?? `Assertion failed (got ${e})`);
}
var p1 = zt([
  L(),
  yt,
  Ht,
  qn,
  Te,
  An
]);
re(ce(), 1);
function aae(e) {
  return !!(e === null || e === void 0 || typeof e == "number" || xt.isAloftArea(e) || gt.isAloftCount(e) || Fr.isAloftDate(e) || jt.isAloftPrice(e) || fs.isAloftTime(e));
}
var iae = re(ce(), 1);
function sae(e, t) {
  return e === null ? null : typeof t == "number" ? e : t instanceof xt ? xt.fromNumber(e, "sqft").toUnit(t.unit) : t instanceof gt ? gt.fromNumber(e) : t instanceof Fr ? Fr.fromNumericDate(e) : t instanceof jt ? jt.fromNumericPrice(e, t.currency) : t instanceof fs ? fs.fromUnix(e) : (0, iae.unreachable)(t);
}
var lae = re(P4(), 1), uae = re(ce(), 1);
function cae(e) {
  return e === null ? null : typeof e == "number" ? e : e instanceof xt ? e.toSqFt().unitAmount : e instanceof gt ? e.value : e instanceof Fr ? e.toNumericDate() : e instanceof jt ? e.toNumericPrice() : e instanceof fs ? e.toUnix() : (0, uae.unreachable)(e);
}
var dae = new lae.Lens(
  (e) => cae(e),
  (e, t) => sae(t, e)
), fae = re(ce(), 1);
function xf(e, t = "unit") {
  switch (e.t) {
    case "linear":
      return `${e.slope.toString()} per ${t}`;
    case "monthly":
      return `${(e.percent * 100).toFixed(1)}% per month`;
    default:
      (0, fae.unreachable)(e);
  }
}
function hae(e) {
  return typeof e == "string" || aae(e);
}
var pae = (e) => {
  if (e.t === "linear") {
    const t = dae.map(e.slope, (n) => n * 365 / 12);
    return oae(t instanceof jt), xf({ t: "linear", slope: t }, "month");
  }
  return xf(e, "day");
}, rr = (e) => {
  const { customRate: t, key: n, unit: r, rateToString: o, example: a, defaultGridValue: s } = e, l = E_[n];
  return {
    customRate: t,
    propertyKeys: [n],
    getAnalysisValue(c) {
      var f;
      const d = c ? c[(f = l.valueProps.annotator) == null ? void 0 : f.valueKey] : void 0;
      return hae(d) ? d : void 0;
    },
    rateToString: o ?? ((c) => xf(c, r)),
    unit: r,
    example: a,
    defaultGridValue: s
  };
}, mae = {
  customRate: "percentPerMonth",
  propertyKeys: ["closeDate", "listingStatus"],
  getAnalysisValue(e, t, n) {
    if (!e)
      return;
    const { listingStatus: r } = e, o = n !== "comparable" ? "closeDate" : (t == null ? void 0 : t.dateOfSaleVariant) ?? "closeDate", a = e[o];
    if ((0, tae.isDefined)(r) && r === "SettledSale")
      return a;
  },
  rateToString: pae,
  example: Fr.today()
}, gae = {
  propertyKeys: [
    "detachedGarageParkingSpacesCount",
    "attachedGarageParkingSpacesCount",
    "builtInGarageParkingSpacesCount"
  ],
  customRate: "dollarPerUnit",
  getAnalysisValue: (e) => gt.addWithNulls(
    (e == null ? void 0 : e.detachedGarageParkingSpacesCount) ?? null,
    (e == null ? void 0 : e.attachedGarageParkingSpacesCount) ?? null,
    (e == null ? void 0 : e.builtInGarageParkingSpacesCount) ?? null
  ) ?? void 0,
  rateToString: (e) => xf(e, "space"),
  unit: "space",
  example: gt.zero,
  defaultGridValue: gt.zero
}, vae = {
  getAnalysisValue: () => {
  },
  rateToString: () => "n/a"
}, Cae = (0, nae.AloftEnum)()({
  salePrice: rr({ key: "salePrice", example: jt.zero }),
  dateOfSale: mae,
  listToSale: rr({
    customRate: "listToSale",
    key: "listingStatus"
  }),
  site: rr({
    customRate: "dollarPerSqft",
    key: "site",
    unit: "sf",
    example: xt.zero
  }),
  designStyle: rr({ key: "designStyle" }),
  designAttachmentType: rr({ key: "designAttachmentType" }),
  designNumberOfStories: rr({
    customRate: "dollarPerUnit",
    key: "designNumberOfStories",
    unit: "story",
    example: 0
  }),
  grossLivingArea: rr({
    customRate: "dollarPerSqft",
    key: "grossLivingArea",
    unit: "sf",
    example: xt.zero
  }),
  aboveGradeBedroomCount: rr({
    customRate: "dollarPerUnit",
    key: "aboveGradeBedroomCount",
    unit: "bedroom",
    example: gt.zero,
    defaultGridValue: gt.zero
  }),
  aboveGradeFullBathCount: rr({
    customRate: "dollarPerUnit",
    key: "aboveGradeFullBathCount",
    unit: "bath",
    example: gt.zero,
    defaultGridValue: gt.zero
  }),
  aboveGradeHalfBathCount: rr({
    customRate: "dollarPerUnit",
    key: "aboveGradeHalfBathCount",
    unit: "half bath",
    example: gt.zero,
    defaultGridValue: gt.zero
  }),
  totalBasementArea: rr({
    customRate: "dollarPerSqft",
    key: "totalBasementArea",
    unit: "sf",
    example: xt.zero
  }),
  garageParkingSpacesCount: gae,
  carportParkingSpacesCount: rr({
    customRate: "dollarPerUnit",
    key: "carportParkingSpacesCount",
    unit: "space",
    example: gt.zero,
    defaultGridValue: gt.zero
  }),
  drivewayParkingSpacesCount: rr({
    customRate: "dollarPerUnit",
    key: "drivewayParkingSpacesCount",
    unit: "space",
    example: gt.zero,
    defaultGridValue: gt.zero
  }),
  cooling: rr({ key: "cooling", unit: "cooling" }),
  greenEnergyEfficient: rr({
    key: "greenEnergyEfficient",
    unit: "energy efficiency"
  }),
  heating: rr({ key: "heating", unit: "heating" }),
  poolFeatures: rr({ key: "poolFeatures", unit: "pool" }),
  porchPatioDeck: rr({ key: "porchPatioDeck", unit: "patio/porch" }),
  additionalFeature: vae,
  location: rr({ key: "locationFactorOne" })
}), bae = be(Cae._keys), yae = zt([v(), p1]), Sae = M({
  t: ie("absolute"),
  value: Te
}), Aae = M({
  t: ie("percent"),
  value: L()
});
ga("t", [
  Sae,
  Aae
]);
var $4 = ga("t", [
  M({ t: ie("monthly"), percent: L() }),
  M({ t: ie("linear"), slope: Te })
]), V3 = M({
  // Date of sale variant only applies to comp values, not market values
  dateOfSaleVariant: be(["closeDate", "contractDate"])
}).partial(), _f = v(), ic = be([
  "dateOfSaleManual",
  "dateOfSale",
  "listToSale",
  "siteManual",
  "site",
  "locationManual",
  "location",
  "viewManual",
  "view",
  "designManual",
  "design",
  "designAttachmentType",
  "designNumberOfStories",
  "qualityManual",
  "quality",
  "conditionManual",
  "condition",
  "grossLivingAreaManual",
  "grossLivingArea",
  "aboveGradeRoomCountManual",
  "aboveGradeBedroomCount",
  "aboveGradeFullBathCount",
  "aboveGradeHalfBathCount",
  "energyEfficientItemsManual",
  "energyEfficientItems",
  "totalBasementAreaManual",
  "totalBasementArea",
  "functionalUtilityManual",
  "functionalUtility",
  "garageManual",
  "garageParkingSpacesCount",
  "carportParkingSpacesCount",
  "drivewayParkingSpacesCount",
  "additionalFeature1Manual",
  "additionalFeature1",
  "additionalFeature2Manual",
  "additionalFeature2",
  "additionalFeature3Manual",
  "additionalFeature3",
  "saleTypeManual",
  "financialConcessionsManual",
  "leaseholdFeeSimpleManual",
  "ageManual",
  "belowGradeRoomCountManual",
  "heatingCoolingManual",
  "porchPatioDeckManual",
  "finishedBasementAreaManual",
  "basementAccessManual",
  "nonStandardGrossLivingAreaManual",
  "cooling",
  "greenEnergyEfficient",
  "heating",
  "pool",
  "porchPatioDeck"
]), Mae = M({
  group: M({
    none: M({}).optional(),
    monthly: M({}).optional(),
    quarterly: M({}).optional(),
    nmonth: M({ months: ne(L()) }).optional(),
    days: M({ days: ne(L()) }).optional(),
    increments: M({ increments: ne(L()) }).optional(),
    values: M({ count: L().optional() }).optional()
  }),
  dateOfSaleGroupedWindowed: Y().optional()
}), xae = M({
  irregular: Y().optional()
}), _ae = M({
  degrees: ne(L()),
  dateOfSaleLinearWindowed: Y().optional()
});
M({
  grouped: Mae.optional(),
  paired: xae.optional(),
  polynomial: _ae.optional()
});
var Iae = ga("t", [
  M({
    t: ie("custom"),
    rate: $4,
    featureOptions: V3.optional()
  }),
  M({
    t: ie("customListToSale"),
    ratio: L(),
    featureOptions: V3.optional()
  }),
  M({
    t: ie("analysis"),
    analysis: _f
  })
]), wae = ga("t", [
  M({
    t: ie("acrossTheBoard")
  }),
  M({
    t: ie("analysis"),
    analysis: _f
  }),
  M({
    t: ie("irregularPaired"),
    analysis: _f,
    direction: be(["superior", "inferior"])
  })
]), Lae = ga("t", [
  M({ t: ie("none") }),
  M({ t: ie("monthly") }),
  M({ t: ie("quarterly") }),
  M({ t: ie("nmonth"), months: L() }),
  M({ t: ie("days"), days: L() }),
  M({ t: ie("increments"), increment: L() }),
  M({ t: ie("values"), values: ne(yae) })
]), Rae = M({
  t: ie("grouped"),
  dataset: v(),
  agg: be(["median", "mean"]),
  group: Lae,
  adjustAs: be(["absolute", "percent"]).optional(),
  dateOfSaleGroupedWindowed: Y().optional(),
  windowSizeDays: L().optional()
}), Eae = M({
  t: ie("paired"),
  dataset: v(),
  p1: bf,
  p2: bf,
  adjustments: mn(ic, Te),
  adjustAs: be(["absolute", "percent"]).optional()
}), Dae = M({
  t: ie("polynomial"),
  dataset: v(),
  degree: L(),
  dateOfSaleLinearWindowed: Y().optional(),
  windowSizeDays: L().optional()
}), Nae = ga("t", [
  Rae,
  Eae,
  Dae
]), Tae = M({
  lastChangedAt: An,
  formula: Iae,
  cachedRate: $4.optional()
}), Pae = M({
  lastChangedAt: An,
  adjustment: Te.optional(),
  calculated: Te.optional(),
  formula: wae.optional()
}), kae = M({
  terms: mn(ic, Pae.optional())
}), Vae = M({
  createdAt: An,
  lastChangedAt: An,
  lastRanAt: An.optional(),
  term: ic.optional(),
  feature: bae.optional(),
  featureOptions: V3.optional(),
  formula: Nae,
  cachedRate: $4.optional(),
  title: v().optional(),
  addToCommentary: Y().optional()
});
M({
  version: ie("1"),
  createdAt: An,
  lastChangedAt: An,
  effectiveDate: qn,
  roundToNearest: Te.optional(),
  acrossTheBoard: mn(ic, Tae),
  comps: mn(T3, kae),
  compsOrder: ne(T3),
  analysis: mn(_f, Vae)
});
Ui("designStyle"), Ui("designAttachmentType"), Ui("designNumberOfStories"), Ui("cooling"), Ui("greenEnergyEfficient"), Ui("heating"), Ui("poolFeatures"), Ui("porchPatioDeck");
be([
  "market-condition",
  "prior-sales",
  "site-extraction",
  "depreciated-cost"
]);
var Oae = be(["addComps"]), Fae = be(["paired-cost", "studies"]), Z4 = be([
  "details",
  "features",
  "market",
  "analysis",
  "cost-approach",
  "adjustments",
  "adjustments-grid",
  "commentary",
  "appraisify-commentary",
  "craftsman-cost-approach",
  "reconciliation"
]), Bae = v().refine(
  (e) => Z4.options.some((t) => {
    if (e === t || e.startsWith(`${t}#`))
      return !0;
    if (e.startsWith(`${t}?`)) {
      const n = e.split("?")[1] ?? "", [r, o] = n.split("=");
      return r && o && Oae.safeParse(r).success;
    }
    return !1;
  })
).brand("PairedCostRouteItemWithQuery");
zt([Fae, Z4]);
var N_ = ["abode_mls"], T_ = be(N_), P_ = ["abode_public_record"], j4 = be(P_), k_ = ["zillow", "xml", "custom", "none", "radar"];
be(k_);
var Hae = [...N_, ...P_, ...k_], V_ = be(Hae), Gae = 6, $ae = xt.fromNumber(500, "sqft"), Zae = xt.fromNumber(500, "sqft"), jae = xt.fromNumber(1e3, "sqft");
xt.fromNumber(0, "sqft");
xt.fromNumber(0, "sqft");
var O_ = xt.fromNumber(220, "sqft"), Wae = 2;
O_.mul(Wae);
xt.fromNumber(200, "sqft");
var zae = 2;
O_.mul(zae);
xt.fromNumber(200, "sqft");
var Uae = xt.fromNumber(500, "sqft");
xt.fromNumber(200, "sqft");
var Xae = xt.fromNumber(200, "sqft"), Yae = xt.fromNumber(64, "sqft"), qae = xt.fromNumber(200, "sqft");
T_.enum.abode_mls;
j4.enum.abode_public_record;
var xr = be([
  "singleFamilyResidence",
  "condominium",
  "duplex",
  "triplex",
  "quadruplex",
  "manufacturedHome",
  "mobileHome",
  "multiFamily",
  "townhouse",
  "apartments",
  "lotsLand"
]), Jae = M({
  PropertyStreetAddress: v(),
  PropertyCity: v(),
  PropertyState: v(),
  PropertyPostalCode: v(),
  LatitudeNumber: v(),
  LongitudeNumber: v(),
  DataSourceDescription: v(),
  DataSourceVerificationDescription: v(),
  PropertySalesAmount: v(),
  /** @deprecated - use SalesConcessions instead */
  SaleType: v(),
  SalesConcessions: v(),
  FinancingConcessions: v(),
  DateOfSale: v(),
  Location: v(),
  PropertyRights: v(),
  SiteArea: v(),
  View: v(),
  DesignStyle: v(),
  Quality: v(),
  Age: v(),
  Condition: v(),
  TotalRoomCount: v(),
  TotalBedroomCount: v(),
  TotalBathroomCount: v(),
  BelowGradeRoomCount: v(),
  GrossLivingArea: v(),
  NumberOfUnits: v(),
  BasementArea: v(),
  BasementFinish: v(),
  FunctionalUtility: v(),
  HeatingCooling: v(),
  EnergyEfficient: v(),
  CarStorage: v(),
  PorchDeck: v(),
  OtherFeature1: v(),
  OtherFeature2: v(),
  OtherFeature3: v()
}).partial(), Kae = M({
  SalesConcessions: Te,
  FinancingConcessions: Te,
  DateOfSale: Te,
  Location: Te,
  PropertyRights: Te,
  SiteArea: Te,
  View: Te,
  DesignStyle: Te,
  Quality: Te,
  Age: Te,
  Condition: Te,
  RoomAboveGradeLine1: Te,
  RoomAboveGradeLine2: Te,
  GrossLivingArea: Te,
  NumberOfUnits: Te,
  BasementArea: Te,
  BasementFinish: Te,
  FunctionalUtility: Te,
  HeatingCooling: Te,
  EnergyEfficient: Te,
  CarStorage: Te,
  PorchDeck: Te,
  OtherFeature1: Te,
  OtherFeature2: Te,
  OtherFeature3: Te
}).partial(), F_ = M({
  encoding: ie("UAD_2022"),
  annotations: Jae,
  adjustments: Kae.optional()
});
ie("UAD_2022");
ie(1);
var Qae = Ot({
  toolkitListingID: u_,
  address: md,
  latitude: L(),
  longitude: L(),
  dataSource: g_,
  designStyle: m_,
  carStorage: h_,
  status: f_,
  siteArea: yt,
  actualAge: v_,
  gla: yt,
  numberOfUnits: xe,
  bedroomCount: xe,
  bathroomCount: C_,
  basementLine1: y_,
  basementLine2: S_,
  salePrice: Te
}).partial();
Object.keys(Qae.shape);
var eie = M({
  fullBathCost: Te.optional(),
  halfBathCost: Te.optional()
}), B_ = [
  xr.Values.singleFamilyResidence,
  xr.Values.manufacturedHome,
  xr.Values.multiFamily,
  xr.Values.townhouse
], Ga = be(B_), tie = [
  Ga.Values.singleFamilyResidence,
  Ga.Values.townhouse
], nie = be(tie), rie = [
  xr.Values.singleFamilyResidence,
  xr.Values.manufacturedHome,
  xr.Values.multiFamily,
  xr.Values.condominium,
  xr.Values.townhouse,
  xr.Values.lotsLand
];
be(rie);
var oie = [
  "basement",
  "garage",
  "attic",
  "shed",
  "workshop",
  "barn",
  "pool",
  "spa",
  "fireplaces",
  "adu"
];
be([
  ...B_,
  ...oie
]);
var aie = zt([ie(4), ie(6), ie(8), ie(10)]), iie = be(["none", "heating", "both"]).default("none"), H_ = L().min(1).max(3), sie = H_.int(), G_ = L().min(1).max(5);
G_.int();
var sc = L().min(1).max(6), J1 = sc.int();
sc.multipleOf(0.1);
var W4 = sc.multipleOf(0.1), $_ = sc.multipleOf(0.1), Z_ = sc.multipleOf(0.1), j_ = sc.multipleOf(0.1), lie = zt([
  W4,
  $_,
  Z_,
  j_
]), z4 = M({
  hasFeature: Y().default(!0),
  finishedArea: ma.optional(),
  totalArea: ma.optional(),
  fullBaths: xe.optional(),
  halfBaths: xe.optional()
}), U4 = M({
  hasFeature: Y().default(!0),
  area: ma.optional(),
  spaces: xe.optional(),
  quality: J1.optional()
}), uie = be(["attached", "detached"]), O3 = U4.extend({
  type: uie.optional()
}), gu = M({
  hasFeature: Y().default(!0),
  area: ma.optional(),
  quality: sie.optional()
}), F3 = M({
  hasFeature: Y().default(!0),
  area: ma.optional()
}), W_ = F3.extend({
  quality: J1.optional()
}), cie = be(["uncovered", "covered", "screen"]), D2 = M({
  hasFeature: Y().default(!0),
  type: cie.default("uncovered").optional(),
  area: ma.optional(),
  quality: J1.optional()
}), die = be(["freestanding", "zeroClearance", "masonry"]), z_ = M({
  hasFeature: Y().default(!0),
  count: xe.optional(),
  type: die.optional()
}), U_ = M({
  hasFeature: Y().default(!0),
  area: ma.optional(),
  halfBaths: xe.optional(),
  fullBaths: xe.optional(),
  quality: W4.optional()
}), vd = M({
  corners: aie.default(Gae),
  gla: ma,
  bedrooms: xe,
  fullBaths: xe,
  halfBaths: xe,
  heatingAndCooling: iie,
  effectiveAge: xe,
  age: xe,
  uadQuality: J1,
  uadCondition: J1,
  basement: z4,
  attic: W_,
  fireplace: z_,
  // Garage's "type" field is left unchanged for backwards compatibility, but "garage" is now always attached
  garage: O3,
  detachedGarage: O3.extend({
    type: ie("detached").optional().default("detached")
  }),
  carport: U4,
  shed: gu,
  workshop: gu,
  barn: gu,
  pool: gu,
  spa: gu,
  adu: U_,
  porch: D2,
  patio: D2,
  deck: D2,
  coveredPorch: F3,
  enclosedPatio: F3,
  hasManualCost: Y().default(!1),
  manualCost: Nn,
  manualCostDisplayName: v(),
  totalCostToCureDisplayName: v().default("None"),
  otherAdjustmentsDisplayName: v().default("Other"),
  featureGridDataSources: v(),
  totalEconomicLife: xe,
  externalDepreciation: Nn,
  functionalDepreciation: Nn,
  garageEffAge: xe,
  garageEcoLife: xe,
  detachedGarageEffAge: xe,
  detachedGarageEcoLife: xe,
  carportEffAge: xe,
  carportEcoLife: xe,
  porchEffAge: xe,
  porchEcoLife: xe,
  patioEffAge: xe,
  patioEcoLife: xe,
  deckEffAge: xe,
  deckEcoLife: xe,
  workshopEffAge: xe,
  workshopEcoLife: xe,
  shedEffAge: xe,
  shedEcoLife: xe,
  barnEffAge: xe,
  barnEcoLife: xe,
  poolEffAge: xe,
  poolEcoLife: xe,
  spaEffAge: xe,
  spaEcoLife: xe,
  aduEffAge: xe,
  aduEcoLife: xe,
  manualCostEffAge: xe,
  manualCostEcoLife: xe,
  fireplaceEffAge: xe,
  fireplaceEcoLife: xe
}).partial(), fie = vd.extend({
  propertyType: ie(Ga.Values.singleFamilyResidence),
  craftsmanQuality: W4.optional()
}), hie = vd.extend({
  propertyType: ie(Ga.Values.townhouse),
  craftsmanQuality: j_.optional()
}), X_ = be(["pierAndBeam", "slab"]);
be(["Pier and Beam", "Slab"]);
var pie = vd.extend({
  propertyType: ie(Ga.Values.manufacturedHome),
  foundation: X_.optional(),
  craftsmanQuality: $_.optional()
}), mie = vd.extend({
  propertyType: ie(Ga.Values.multiFamily),
  numberOfUnits: xe.optional(),
  craftsmanQuality: Z_.optional()
}), Y_ = zt([
  fie,
  pie,
  mie,
  hie
]), gie = M({
  improvements: Y_
}), X4 = [
  "adu",
  "attic",
  "barn",
  "basement",
  "bathAboveGrade",
  "bathBelowGrade",
  "bedrooms",
  "concessions",
  "condition",
  "dateOfSale",
  "externalObsolescence",
  // TODO: Remove?
  "fireplace",
  "functionalUtility",
  // TODO: Remove?
  "gla",
  // TODO: Rename to mainDwelling so there's no 2 "GLA" options in the UI?
  "garageCarport",
  "manual",
  // TODO: Rename to manualCost
  "poolSpa",
  "porchPatioDeck",
  "quality",
  "shed",
  "site",
  "termsOfSale",
  "totalCostToCure",
  "units",
  // TODO: Rename to numberOfUnits
  "workshop",
  "other"
];
be(X4);
var q_ = M(
  Object.fromEntries(X4.map((e) => [e, Nn]))
).partial(), vie = M({
  avgAdjRentRate: Nn
});
be([
  "agricultural",
  "airport",
  "bodyOfWater",
  "busyRoadway",
  "commercialArea",
  "golfCourse",
  "greenSpace",
  "highDensityResidential",
  "highPressureGasLine",
  "historicDistrict",
  "industrialArea",
  "localDistributionLine",
  "oilOrGasWell",
  "overheadPowerLine",
  "park",
  "publicTransportationHub",
  "railLine",
  "residential",
  "school",
  "stormwaterRetention"
]);
be([
  "bay",
  "canal",
  "cityStreet",
  "commercial",
  "cove",
  "creek",
  "golfCourse",
  "gulf",
  "highDensityResidential",
  "highway",
  "industrial",
  "lake",
  "marsh",
  "mountain",
  "ocean",
  "park",
  "parkingLot",
  "pastoral",
  "pond",
  "reservoir",
  "residential",
  "river",
  "school",
  "skyline",
  "sound",
  "trafficWallBarriers",
  "valley",
  "woods"
]);
var wC = be(["Beneficial", "Neutral", "Adverse"]), J_ = M({
  area: ma,
  influence: v(),
  influenceRating: wC,
  location: v(),
  notes: v(),
  view: v(),
  viewRating: wC,
  zoning: v()
}).partial(), K_ = M({
  transaction: A_,
  propertyIdentification: tre,
  improvements: Y_,
  site: J_
}), Cie = K_.extend({
  manualAdjustments: q_
}), Q_ = K_.extend({
  opinionOfSiteValue: Nn.optional(),
  rental: vie.optional(),
  siteValueCommentary: v().optional(),
  arv: gie.optional()
}), eI = ie("constellation1").or(ie("abode")), bie = M({
  MediaURL: v(),
  blobID: v().optional()
}), Y4 = M({
  Air: v(),
  Appliances: ne(v()),
  ArchitecturalStyle: ne(v()),
  AssociationFee: L(),
  AssociationFeeFrequency: v(),
  AssociationName: v(),
  AssociationYN: Y(),
  Basement: ne(v()),
  BasementYN: Y(),
  BathroomsFull: L(),
  BathroomsHalf: L(),
  BathroomsThreeQuarter: L(),
  BathroomsTotalInteger: L(),
  BedroomsTotal: L(),
  BuyerFinancing: ne(v()),
  City: v(),
  CityRegion: v(),
  CloseDate: v(),
  ClosePrice: L(),
  ConcessionsAmount: L(),
  Cooling: ne(v()),
  CountyOrParishFIPS: v(),
  CountyOrParish: v(),
  CumulativeDaysOnMarket: L(),
  DaysOnMarket: L(),
  Directions: v(),
  DoorFeatures: ne(v()),
  DoorsWindows: v(),
  ElementarySchool: v(),
  ExpirationDate: v(),
  ExteriorFeatures: ne(v()),
  FireplaceFeatures: ne(v()),
  FireplacesTotal: L(),
  FloorDescription: v(),
  Flooring: ne(v()),
  FullStreetAddress: v(),
  Furnished: v(),
  GarageSpaces: L(),
  GarageYN: Y(),
  GreenEnergyEfficient: ne(v()),
  HasAttachedGarage: Y().nullable(),
  HasView: Y(),
  Heating: ne(v()),
  HighSchool: v(),
  Inclusions: v(),
  InteriorFeatures: ne(v()),
  Latitude: L(),
  LeaseTerm: v(),
  Levels: ne(v()),
  ListAgentFullName: v(),
  ListAgentKey: v(),
  ListAgentMlsID: v(),
  ListAgentPhone: v(),
  ListAgentPreferredPhone: v(),
  ListingContractDate: v(),
  ListingId: v(),
  ListingTerms: ne(v()),
  ListOfficeKey: v(),
  ListOfficeMlsId: v(),
  ListOfficeName: v(),
  ListOfficePhone: v(),
  ListPrice: L(),
  LivingArea: L(),
  Longitude: L(),
  LotDescription: v(),
  LotFeatures: ne(v()),
  LotSizeAcres: L(),
  LotSizeSquareFeet: L(),
  Media: ne(bie),
  MiddleOrJuniorSchool: v(),
  MLSAreaMajor: v(),
  MLSOUID: v(),
  MLSName: v(),
  // Technically not RESO field but OriginatingSystemName already taken by C1Listing
  MlsStatus: v(),
  ModificationTimestamp: v(),
  NeighborhoodName: v(),
  NewConstructionYN: Y(),
  NumberOfUnitsTotal: L(),
  OccupantType: v(),
  OnMarketDate: v(),
  OnMarketTimestamp: v(),
  OriginalListPrice: L(),
  ParcelNumber: v(),
  ParkingFeatures: ne(v()),
  ParkingTotal: L(),
  PatioAndPorchFeatures: ne(v()),
  PendingTimestamp: v(),
  PetsAllowed: ne(v()),
  PoolFeatures: ne(v()),
  PostalCode: v(),
  PoolPrivateYN: Y(),
  PropertyAttachedYN: Y(),
  PropertySubType: v(),
  PropertyType: v(),
  PublicRemarks: v(),
  PurchaseContractDate: v(),
  RentControlYN: Y(),
  Roof: ne(v()),
  RoomsTotal: L(),
  SchoolDistrict: v(),
  Sewer: ne(v()),
  SpaYN: Y(),
  SpecialListingConditions: ne(v()),
  StandardStatus: v(),
  StateOrProvince: v(),
  Stories: L(),
  StoriesTotal: L(),
  StreetDirSuffix: v(),
  StreetName: v(),
  StreetNumber: v(),
  StreetSuffix: v(),
  StructureType: ne(v()),
  SubdivisionName: v(),
  TaxAnnualAmount: L(),
  TaxLegalDescription: v(),
  ToolkitListingID: dre,
  TaxYear: L(),
  TenantPays: ne(v()),
  Topography: v(),
  UnitNumber: v(),
  UnparsedAddress: v(),
  View: ne(v()),
  WaterFrontYN: Y(),
  WaterFrontFeatures: v(),
  WaterSource: ne(v()),
  WithdrawnDate: v(),
  YearBuilt: L()
}).partial(), yie = M({
  version: ie(1),
  listing: Y4
}), tI = M({
  backupListingData: yie
}).partial(), qr = M({
  source: V_,
  justification: v().optional(),
  conflictIsResolved: Y().optional()
}), $r = (e) => {
  const t = {};
  return Object.keys(e.shape).forEach((n) => {
    t[n] = qr.optional();
  }), M(t);
}, Sie = $r(A_).partial(), Aie = $r(Ll).partial(), Mie = $r(t_).partial(), xie = M({
  address: Aie,
  coordinates: Mie,
  zoning: qr,
  zoningCompliance: qr,
  legalDescription: qr,
  hoa: qr,
  hoaFeeAmount: qr,
  hoaFeeFrequency: qr,
  parcelNumber: qr,
  newConstruction: qr,
  pud: qr
}).partial(), e1 = $r(
  gu
).partial(), _ie = $r(U_).partial(), Iie = $r(W_).partial(), wie = $r(z4).partial(), Lie = $r(z_).partial(), Rie = $r(U4).partial(), LC = $r(O3).partial(), u5 = $r(D2).partial(), Eie = $r(vd).partial(), nI = M({
  ...Eie.shape,
  adu: _ie,
  attic: Iie,
  barn: e1,
  basement: wie,
  carport: Rie,
  deck: u5,
  fireplace: Lie,
  garage: LC,
  detachedGarage: LC,
  patio: u5,
  pool: e1,
  porch: u5,
  shed: e1,
  spa: e1,
  workshop: e1,
  craftsmanQuality: qr,
  foundation: qr,
  numberOfUnits: qr,
  propertyType: qr
}).partial(), Die = $r(J_).partial(), Nie = $r(q_).partial(), Tie = M({
  improvements: nI
}).partial(), Pie = M({
  transaction: Sie,
  propertyIdentification: xie,
  improvements: nI,
  site: Die,
  manualAdjustments: Nie,
  arv: Tie
}).partial(), kie = ac(
  Pie
), Vie = $r(Y4).partial(), Oie = M({
  listing: Vie
}).partial(), Fie = M({
  backupListingData: Oie
}).partial(), Bie = M({
  editableData: kie,
  readonlyData: Fie
}).partial(), Hie = ac(Bie), rI = M({
  $type: ie("PropertyData"),
  version: ie(1),
  readonlyData: tI,
  selectedSources: Hie.optional()
}), Eh = be(["arv", "aiv"]), oI = rI.extend({
  editableData: Cie,
  compType: Eh.optional()
}), Gie = oI.extend({
  readonlyData: tI.optional()
}), qu = ac(oI), $ie = rI.extend({
  editableData: Q_
}), Ju = ac($ie);
be(["adjustments", "comparable", "depreciatedCost"]);
var Dh = be([
  // Adjustments
  "allCompsAdjustedDown",
  "allCompsAdjustedUp",
  "bracketedMarketValue",
  "limitedAdjustedSalePriceRange",
  "conditionAdjustedUpAgainstSubject",
  "allCompsAdjustedDownAiv",
  "allCompsAdjustedDownArv",
  "allCompsAdjustedUpAiv",
  "allCompsAdjustedUpArv",
  "bracketedMarketValueAiv",
  "bracketedMarketValueArv",
  "limitedAdjustedSalePriceRangeAiv",
  "limitedAdjustedSalePriceRangeArv",
  "conditionAdjustedUpAgainstSubjectAiv",
  "conditionAdjustedUpAgainstSubjectArv",
  // Comparable
  "bracketedGLA",
  "bracketedSiteSize",
  "lessThanThreeSettledSales",
  "similarComparableToSubjectPriorSale",
  "bracketedGLAAiv",
  "bracketedGLAArv",
  "bracketedSiteSizeAiv",
  "bracketedSiteSizeArv",
  "lessThanThreeSettledSalesAiv",
  "lessThanThreeSettledSalesArv",
  "propertyWithoutPhoto",
  "similarComparableToSubjectPriorSaleAiv",
  "similarComparableToSubjectPriorSaleArv",
  "outsideProximityRequirement",
  // Depreciated Cost
  "bracketedSiteToValueRatio",
  "effectiveAgeLowerThanActualAge",
  "inconsistentCompGlaAdjustment",
  "inconsistentCompSiteAdjustment",
  "largestSiteHasHighestValue",
  "limitedSiteToValueRatioRange",
  "negativeSiteValue",
  "smallestSiteHasLowestValue",
  "siteValueIsLessThanVacantLandValue"
]), Zie = be(["active", "dismissed"]);
M({
  type: Dh,
  status: Zie,
  message: v(),
  propertyID: v().optional(),
  compType: Eh.optional(),
  fixingInfo: M({
    tips: v(),
    pairedCostRouteItem: Z4.or(Bae)
  })
});
M({
  status: be(["skipped", "passed", "failed"]),
  message: v(),
  propertyID: v().optional()
});
var yr = M({}).refine((e) => Object.keys(e).length === 0, {
  message: "Object must be empty"
}), jie = M({
  // aboveGradeFinishedArea: z.nullable(z.unknown()),
  // accessibilityFeatures: z.nullable(z.unknown()),
  // additionalFeeInfo: z.nullable(z.unknown()),
  // additionalParcelsDescription: z.nullable(z.unknown()),
  appliances: ze(ne(v()).or(yr)),
  architecturalStyle: ze(v()),
  // associationAmenities: z.nullable(z.unknown()),
  associationFee: ze(v()),
  // associationFee2: z.nullable(z.unknown()),
  // associationFeeIncludes: z.nullable(z.unknown()),
  associationName: ze(v()),
  // associationName2: z.nullable(z.unknown()),
  // associationPhone: z.nullable(z.unknown()),
  // associationPhone2: z.nullable(z.unknown()),
  // associations: z.nullable(z.record(z.unknown())),
  // atAGlanceFacts: z.nullable(
  //     z.array(
  //         z
  //             .object({
  //                 factLabel: z.nullable(z.string()),
  //                 factValue: z.nullable(z.string()),
  //             })
  //             .partial()
  //     )
  // ),
  // attic: z.nullable(z.unknown()),
  // availabilityDate: z.nullable(z.unknown()),
  basement: ze(v()),
  basementYN: ze(Y()),
  // bathrooms: z.nullable(z.number()),
  // bathroomsFloat: z.nullable(z.number()),
  bathroomsFull: ze(L()),
  bathroomsHalf: ze(L()),
  // bathroomsOneQuarter: z.nullable(z.unknown()),
  // bathroomsPartial: z.nullable(z.unknown()),
  bathroomsThreeQuarter: ze(L()),
  // bedrooms: z.nullable(z.number()),
  // belowGradeFinishedArea: z.nullable(z.unknown()),
  // bodyType: z.nullable(z.unknown()),
  // builderModel: z.nullable(z.unknown()),
  // builderName: z.nullable(z.unknown()),
  // buildingArea: z.nullable(z.string()),
  // buildingAreaSource: z.nullable(z.unknown()),
  // buildingFeatures: z.nullable(z.unknown()),
  // buildingName: z.nullable(z.unknown()),
  // buyerAgencyCompensation: z.nullable(z.string()),
  // buyerAgencyCompensationType: z.nullable(z.string()),
  // canRaiseHorses: z.nullable(z.boolean()),
  carportParkingCapacity: ze(L()),
  // cityRegion: z.nullable(z.string()),
  // commonWalls: z.nullable(z.unknown()),
  // communityFeatures: z.nullable(z.unknown()),
  // compensationBasedOn: z.nullable(z.unknown()),
  // constructionMaterials: z.nullable(z.array(z.string())),
  // contingency: z.nullable(z.unknown()),
  cooling: ze(ne(v()).or(yr)),
  // coveredParkingCapacity: z.nullable(z.unknown()),
  // cropsIncludedYN: z.nullable(z.unknown()),
  cumulativeDaysOnMarket: ze(v()),
  // daysOnZillow: z.nullable(z.number()),
  // developmentStatus: z.nullable(z.unknown()),
  // doorFeatures: z.nullable(z.unknown()),
  // electric: z.nullable(z.array(z.string())),
  elementarySchool: ze(v()),
  elementarySchoolDistrict: ze(v()),
  // elevation: z.nullable(z.unknown()),
  // elevationUnits: z.nullable(z.string()),
  // entryLevel: z.nullable(z.unknown()),
  // entryLocation: z.nullable(z.unknown()),
  // exclusions: z.nullable(z.unknown()),
  exteriorFeatures: ze(ne(v()).or(yr)),
  // feesAndDues: z.nullable(z.unknown()),
  // fencing: z.nullable(z.unknown()),
  fireplaceFeatures: ze(ne(v()).or(yr)),
  fireplaces: ze(L()),
  flooring: ze(ne(v()).or(yr)),
  // foundationArea: z.nullable(z.unknown()),
  // foundationDetails: z.nullable(z.array(z.string())),
  frontageLength: ze(v()),
  // frontageType: z.nullable(z.unknown()),
  // furnished: z.nullable(z.boolean()),
  garageParkingCapacity: ze(L()),
  // gas: z.nullable(z.unknown()),
  // greenBuildingVerificationType: z.nullable(z.unknown()),
  // greenEnergyEfficient: z.nullable(z.unknown()),
  // greenEnergyGeneration: z.nullable(z.unknown()),
  // greenIndoorAirQuality: z.nullable(z.unknown()),
  // greenSustainability: z.nullable(z.unknown()),
  // greenWaterConservation: z.nullable(z.unknown()),
  // hasAdditionalParcels: z.nullable(z.boolean()),
  hasAssociation: ze(Y()),
  hasAttachedGarage: ze(Y()),
  // hasAttachedProperty: z.nullable(z.boolean()),
  hasCarport: ze(Y()),
  // hasCooling: z.nullable(z.boolean()),
  // hasElectricOnProperty: z.nullable(z.unknown()),
  hasFireplace: ze(Y()),
  hasGarage: ze(Y()),
  // hasHeating: z.nullable(z.boolean()),
  // hasHomeWarranty: z.nullable(z.boolean()),
  // hasLandLease: z.nullable(z.boolean()),
  hasOpenParking: ze(Y()),
  // hasPetsAllowed: z.nullable(z.unknown()),
  hasPrivatePool: ze(Y()),
  // hasRentControl: z.nullable(z.unknown()),
  hasSpa: ze(Y()),
  // hasView: z.nullable(z.boolean()),
  // hasWaterfrontView: z.nullable(z.unknown()),
  heating: ze(ne(v()).or(yr)),
  highSchool: ze(v()),
  highSchoolDistrict: ze(v()),
  // hoaFee: z.nullable(z.unknown()),
  // hoaFeeTotal: z.nullable(z.unknown()),
  homeType: ze(v()),
  // horseAmenities: z.nullable(z.unknown()),
  // horseYN: z.nullable(z.unknown()),
  // inclusions: z.nullable(z.array(z.string())),
  // incomeIncludes: z.nullable(z.unknown()),
  interiorFeatures: ze(ne(v()).or(yr)),
  // irrigationWaterRightsAcres: z.nullable(z.unknown()),
  // irrigationWaterRightsYN: z.nullable(z.boolean()),
  isNewConstruction: ze(Y()),
  // isSeniorCommunity: z.nullable(z.unknown()),
  // landLeaseAmount: z.nullable(z.unknown()),
  // landLeaseExpirationDate: z.nullable(z.unknown()),
  // laundryFeatures: z.nullable(z.unknown()),
  // levels: z.nullable(z.string()),
  // listAOR: z.nullable(z.unknown()),
  // listingId: z.nullable(z.unknown()),
  // listingTerms: z.nullable(z.string()),
  livingArea: ze(v()),
  // livingAreaRange: z.nullable(z.unknown()),
  // livingAreaRangeUnits: z.nullable(z.unknown()),
  // livingQuarters: z.nullable(z.record(z.unknown())),
  lotFeatures: ze(ne(v()).or(yr)),
  lotSize: ze(v()),
  lotSizeDimensions: ze(gn()),
  // mainLevelBathrooms: z.nullable(z.number()),
  // mainLevelBedrooms: z.nullable(z.number()),
  // marketingType: z.nullable(z.unknown()),
  middleOrJuniorSchool: ze(v()),
  middleOrJuniorSchoolDistrict: ze(v()),
  // municipality: z.nullable(z.unknown()),
  // numberOfUnitsInCommunity: z.nullable(z.unknown()),
  // numberOfUnitsVacant: z.nullable(z.unknown()),
  // offerReviewDate: z.nullable(z.string()),
  onMarketDate: ze(L()),
  // openParkingCapacity: z.nullable(z.unknown()),
  // otherEquipment: z.nullable(z.unknown()),
  // otherFacts: z.nullable(z.record(z.unknown())),
  // otherParking: z.nullable(z.unknown()),
  // otherStructures: z.nullable(z.unknown()),
  // ownership: z.nullable(z.unknown()),
  // ownershipType: z.nullable(z.unknown()),
  parcelNumber: ze(v()),
  parkingCapacity: ze(L()),
  parkingFeatures: ze(ne(v()).or(yr)),
  patioAndPorchFeatures: ze(ne(v()).or(yr)),
  poolFeatures: ze(ne(v()).or(yr)),
  // pricePerSquareFoot: z.nullable(z.number()),
  // propertyCondition: z.nullable(z.unknown()),
  propertySubType: ze(ne(v()).or(yr)),
  // roadSurfaceType: z.nullable(z.unknown()),
  roofType: ze(v()),
  // rooms: z.nullable(
  //     z.array(
  //         z
  //             .object({
  //                 area: z.nullable(z.unknown()),
  //                 description: z.nullable(z.unknown()),
  //                 dimensions: z.nullable(z.unknown()),
  //                 features: z.nullable(z.unknown()),
  //                 level: z.nullable(z.unknown()),
  //                 roomArea: z.nullable(z.unknown()),
  //                 roomAreaSource: z.nullable(z.unknown()),
  //                 roomAreaUnits: z.nullable(z.unknown()),
  //                 roomDescription: z.nullable(z.unknown()),
  //                 roomDimensions: z.nullable(z.unknown()),
  //                 roomFeatures: z.nullable(z.unknown()),
  //                 roomLength: z.nullable(z.unknown()),
  //                 roomLengthWidthSource: z.nullable(z.unknown()),
  //                 roomLengthWidthUnits: z.nullable(z.unknown()),
  //                 roomLevel: z.nullable(z.string()),
  //                 roomType: z.nullable(z.string()),
  //                 roomWidth: z.nullable(z.unknown()),
  //             })
  //             .partial()
  //     )
  // ),
  // securityFeatures: z.nullable(z.unknown()),
  sewer: ze(ne(v()).or(yr)),
  specialListingConditions: ze(v()),
  stories: ze(L()),
  structureType: ze(v()),
  subdivisionName: ze(v()),
  taxAnnualAmount: ze(L()),
  taxLegalDescription: ze(gn()),
  topography: ze(v()),
  // totalActualRent: z.nullable(z.number()),
  // totalBedrooms: z.nullable(z.unknown()),
  // totalRentableArea: z.nullable(z.unknown()),
  // totalUnits: z.nullable(z.unknown()),
  // unitsInCommunity: z.nullable(z.unknown()),
  // utilities: z.nullable(z.array(z.string())),
  // vegetation: z.nullable(z.array(z.string())),
  view: ze(ne(v()).or(yr)),
  // virtualTour: z.nullable(z.string()),
  waterSource: ze(ne(v()).or(yr)),
  // waterViewYN: z.nullable(z.boolean()),
  waterfrontFeatures: ze(ne(v()).or(yr)),
  // windowFeatures: z.nullable(z.array(z.string())),
  yearBuilt: ze(L())
  // zoning: z.nullable(z.unknown()),
  // zoningDescription: z.nullable(z.string()),
}).partial(), Wie = M({
  city: v().nullable(),
  community: v().nullable(),
  neighborhood: v().nullable(),
  state: v().nullable(),
  streetAddress: v().nullable(),
  subdivision: v().nullable(),
  zipcode: v().nullable()
}).partial(), zie = M({
  // agentEmail: z.string().nullable(),
  // agentLicenseNumber: z.string().nullable(),
  agentName: v().nullable(),
  agentPhoneNumber: v().nullable(),
  // attributionTitle: z.string().nullable(),
  // brokerName: z.string().nullable(),
  // brokerPhoneNumber: z.string().nullable(),
  // buyerAgentMemberStateLicense: z.string().nullable(),
  // buyerAgentName: z.string().nullable(),
  // buyerBrokerageName: z.string().nullable(),
  // coAgentLicenseNumber: z.string().nullable(),
  // coAgentName: z.string().nullable(),
  // coAgentNumber: z.string().nullable(),
  infoString10: v().nullable(),
  infoString16: v().nullable(),
  infoString3: v().nullable(),
  infoString5: v().nullable(),
  lastChecked: v().nullable(),
  lastUpdated: v().nullable(),
  // listingAgents: z
  //     .array(
  //         z
  //             .object({
  //                 associatedAgentType: z.string().nullable(),
  //                 memberFullName: z.string().nullable(),
  //                 memberStateLicense: z.string().nullable(),
  //             })
  //             .partial()
  //     )
  //     .nullable(),
  // listingAgreement: z.string().nullable(),
  // listingOffices: z
  //     .array(
  //         z
  //             .object({
  //                 associatedOfficeType: z.string().nullable(),
  //                 officeName: z.string().nullable(),
  //             })
  //             .partial()
  //     )
  //     .nullable(),
  // mlsDisclaimer: z.string().nullable(),
  mlsId: v().nullable(),
  mlsName: v().nullable()
  // providerLogo: z.string().nullable(),
  // trueStatus: z.string().nullable(),
}).partial(), Uie = M({
  infoString1: v().nullable(),
  infoString2: v().nullable(),
  infoString3: v().nullable()
}).partial(), Xie = M({
  attributeSource: Uie.nullable(),
  buyerAgent: gn().nullable(),
  date: v().nullable(),
  event: v().nullable(),
  postingIsRental: Y().nullable(),
  price: L().nullable(),
  priceChangeRate: L().nullable(),
  pricePerSquareFoot: L().nullable(),
  sellerAgent: gn().nullable(),
  showCountyLink: Y().nullable(),
  source: v().nullable(),
  time: L().nullable()
}).partial();
M({
  address: Wie.nullable(),
  annualHomeownersInsurance: L().nullable(),
  attributionInfo: zie.nullable(),
  bathrooms: L().nullable(),
  bedrooms: L().nullable(),
  brokerId: v().nullable(),
  brokerageName: v().nullable(),
  building: v().nullable(),
  buildingPermits: v().nullable(),
  city: v().nullable(),
  cityId: L().nullable(),
  comingSoonOnMarketDate: v().nullable(),
  // contact_recipients: z.array(schContactRecipient).nullable(),
  contingentListingType: v().nullable(),
  country: v().nullable(),
  county: v().nullable(),
  countyFIPS: v().nullable(),
  countyId: L().nullable(),
  currency: v().nullable(),
  datePosted: v().nullable(),
  dateSold: v().nullable(),
  description: v().nullable(),
  favoriteCount: L().nullable(),
  // homeFacts: z.unknown(),
  homeStatus: v().nullable(),
  homeType: v().nullable(),
  imgSrc: v().nullable(),
  isListedByOwner: v().nullable(),
  latitude: L().nullable(),
  // listed_by: z
  //     .object({
  //         agent_reason: z.number().nullable(),
  //         badge_type: z.string().nullable(),
  //         business_name: z.string().nullable(),
  //         display_name: z.string().nullable(),
  //         image_url: z.string().nullable(),
  //         phone: schPhone.nullable(),
  //         profile_url: z.string().nullable(),
  //         rating_average: z.number().nullable(),
  //         recent_sales: z.number().nullable(),
  //         review_count: z.number().nullable(),
  //         zpro: z.boolean().nullable(),
  //         zuid: z.string().nullable(),
  //     })
  //     .nullable(),
  // listingProvider: z.string().nullable(),
  listingSubType: M({
    is_FSBA: Y().nullable(),
    is_FSBO: Y().nullable(),
    is_bankOwned: Y().nullable(),
    is_comingSoon: Y().nullable(),
    is_forAuction: Y().nullable(),
    is_foreclosure: Y().nullable(),
    is_newHome: Y().nullable(),
    is_openHouse: Y().nullable().optional(),
    is_pending: Y().nullable()
  }).nullable(),
  livingArea: L().nullable(),
  livingAreaUnits: v().nullable(),
  livingAreaValue: L().nullable(),
  longitude: L().nullable(),
  mlsid: v().nullable(),
  monthlyHoaFee: L().nullable(),
  // mortgageRates: z
  //     .object({
  //         thirtyYearFixedRate: z.number().nullable(),
  //     })
  //     .nullable(),
  price: L().nullable(),
  priceHistory: ne(Xie).or(M({})).nullable(),
  propertyTaxRate: L().nullable(),
  propertyTypeDimension: v().nullable(),
  providerListingID: v().nullable(),
  rentZestimate: L().nullable(),
  resoFacts: jie.nullable(),
  solarPotential: v().nullable(),
  state: v().nullable(),
  stateId: L().nullable(),
  streetAddress: v().nullable(),
  timeOnZillow: v().nullable(),
  timeZone: v().nullable(),
  url: v().nullable(),
  yearBuilt: L().nullable(),
  // zestimate: z.number().nullable(),
  // zestimateHighPercent: z.string().nullable(),
  // zestimateLowPercent: z.string().nullable(),
  zipcode: v().nullable(),
  zpid: L().nullable()
}).partial();
var aI = M({
  address: v().nullable(),
  bathrooms: L().nullable(),
  bedrooms: L().nullable(),
  contingentListingType: gi().nullable(),
  country: v().nullable(),
  currency: v().nullable(),
  dateSold: L().nullable(),
  hasImage: Y().nullable(),
  imgSrc: v().nullable(),
  latitude: L().nullable(),
  longitude: L().nullable(),
  listingStatus: v().nullable(),
  listingSubType: gi().nullable(),
  livingArea: L().nullable(),
  lotAreaUnit: v().nullable(),
  lotAreaValue: L().nullable(),
  price: L().nullable(),
  propertyType: v().nullable(),
  zestimate: L().nullable(),
  zpid: v().nullable()
});
M({
  currentPage: L(),
  props: ne(aI).optional(),
  resultsPerPage: L(),
  totalPages: L(),
  totalResultCount: L()
});
var iI = be(["trial", "bundle"]), q4 = M({
  id: v(),
  type: v(),
  endedAt: An.optional()
}), Yie = M({
  hasActiveSubscription: ie(!0),
  customerID: v(),
  type: ie("active"),
  nextPaymentDue: qn,
  previousSubscriptions: ne(q4)
}), qie = M({
  hasActiveSubscription: ie(!0),
  customerID: v(),
  type: ie("trialing"),
  trialEnd: qn,
  previousSubscriptions: ne(q4),
  hasPaymentMethod: Y(),
  id: v(),
  pendingSetupIntent: v(),
  priceID: v(),
  subscriptionItemID: v()
}), Jie = M({
  hasActiveSubscription: ie(!1),
  customerID: v(),
  previousSubscriptions: ne(q4)
});
zt([
  Yie,
  qie,
  Jie
]);
M({
  clientSecret: v()
});
M({
  priceID: v(),
  promotionCode: v().optional(),
  addTrial: Y().optional(),
  mcKissockOffer: iI.optional()
});
M({
  clientSecret: v(),
  paymentIntentType: be(["setup", "payment"])
});
var sI = M({
  city: v(),
  country: v(),
  line1: v(),
  line2: v().optional(),
  postal_code: v(),
  state: v()
});
M({
  automaticTaxStatus: be(["supported", "unrecognized_location", "not_collecting", "failed"])
});
M({
  address: sI,
  price: Te
});
M({
  totalAmount: Te,
  taxAmount: Te
});
M({
  priceID: v(),
  isTrial: Y(),
  address: sI.optional(),
  promotionCode: v().optional()
});
M({
  discount: M({
    amount: Te,
    percent: L(),
    promotionCode: v(),
    couponName: v()
  }).or(Ou()),
  // null if no promo code provided
  subtotalExcludingTax: Te,
  tax: Te.or(Ou()),
  // null if no billing address provided (i.e., pricing breakdown calculated with promo code before billing address added)
  total: Te,
  totalDueToday: Te.or(Ou())
  // null if not trial
});
M({
  promotionCode: v()
});
M({
  isValid: Y()
});
M({
  priceID: v(),
  promotionCode: v().optional()
});
var Kie = M({
  "autoHelpDrawer-properties": L().default(0),
  "autoHelpDrawer-market-conditions": L().default(0),
  "autoHelpDrawer-replacement-cost": L().default(0),
  "autoHelpDrawer-depreciation-and-site": L().default(0),
  "autoHelpDrawer-summary": L().default(0),
  "autoHelpDrawer-adjustments-summary": L().default(0),
  "autoHelpDrawer-commentary-summary": L().default(0),
  "autoHelpDrawer-cost-appr-summary": L().default(0),
  "autoHelpDrawer-paired-sales-library": L().default(0),
  "autoHelpDrawer-paired-sales-search-and-adjust": L().default(0),
  "autoHelpDrawer-analysis": L().default(0),
  "autoHelpDrawer-adjustments": L().default(0),
  "autoHelpDrawer-commentary": L().default(0),
  "autoHelpDrawer-craftsman-cost-approach": L().default(0),
  replacementCostInputFocus: L().default(0),
  analysisIntroTour: L().default(0)
}), Qie = be([
  "appraiser",
  "trainee",
  "amc-professional",
  "loan-officer",
  "agent-broker",
  "trainer-educator",
  "gse-rep",
  "other"
]), ese = be([
  "total",
  "aci",
  "appraise-it-pro",
  "nexus",
  "clickforms",
  "anow",
  "homeputer",
  "other"
]), tse = M({
  id: v().optional(),
  state: I_.optional()
}).optional(), lI = v().email(), nse = M({
  type: iI,
  email: lI
}), rse = M({
  version: ie(1),
  address: md.optional(),
  firstName: v().optional(),
  lastName: v().optional(),
  phone: v().optional(),
  userDefinedRole: Qie.optional(),
  company: v().optional(),
  mlsIDs: ne(v()).optional(),
  license: tse,
  ftux: Kie.optional(),
  signatureBlobId: v().optional(),
  // ID of the signature blob in S3
  // Info used by onboarding
  bubbleUserID: v().optional(),
  isOnboardingComplete: Y().optional(),
  referredBy: v().optional(),
  preferredReportSoftware: ese.optional(),
  mcKissockData: nse.optional()
}), uI = rse, ose = be(["saas", "appraisify"]), cI = M({
  id: v(),
  isArchived: Y().optional(),
  createdAt: An,
  modifiedAt: An,
  body: uI,
  isAdmin: Y(),
  email: lI
}), dI = cI.extend({
  userType: ose
});
dI.pick({
  body: !0
});
uI.extend({
  version: ie(1).optional()
});
dI.pick({
  body: !0,
  isArchived: !0
});
M({
  blobID: k4
}), gn();
M({
  blobID: k4
}), hh();
be(["custom", "constellation1", "abode"]);
var fI = M({
  zip: v(),
  updated_date: v(),
  monthly_trends: M({
    historical_data: ne(
      M({
        year: L(),
        month: L(),
        typicalHomeValue: Te,
        numCloses: L().optional(),
        sourceMLSes: Rl.array().optional(),
        medianListPrice: Te.optional(),
        medianClosePriceOverListPrice: L().optional(),
        medianDaysOnMarket: L().optional()
      })
    ),
    one_month_projection: Te.optional()
  })
}), hI = re(ce(), 1), Nh = re(yl(), 1), ase = be([
  "ARMLS",
  "ArizonaRegional",
  "Austin",
  "Beaches",
  "BrevardMLS",
  "BridgeMLS",
  "BrightMLS",
  "CanopyMLS",
  "CentralPanhandle",
  "CentralTexas",
  "CincyMLS",
  "CLAW",
  "CRMLS",
  "DesMoines",
  "EmeraldCoast",
  "FGCMLS",
  "FMLS",
  "GardenStateMLS",
  "GeorgiaMLS",
  "GSREIN",
  "HeartlandMLS",
  "Houston",
  "IRMLS",
  "Knoxville",
  "LasVegas",
  "LexingtonKY",
  "MARIS",
  "MIBOR",
  "Metrolist",
  "MLSNow",
  "MLSOK",
  "MLSUnited",
  "MLSPIN",
  "MLSTechnology",
  "MonmouthOceanMLS",
  "MRED",
  "NABOR",
  "NEREN",
  "NorthCarolinaRegional",
  "NorthStarMLS",
  "NorthwestMLS",
  "NTREIS",
  "OneKey",
  "PalmBeachFL",
  "PortlandOR",
  "Realcomp",
  "RealMLS",
  "Realtracs",
  "REBNY",
  "REColorado",
  "RMLSA",
  "SanAntonio",
  "SEF",
  "SmartMLS",
  "StellarMLS",
  "SWMRIC",
  "TriadMLS",
  "TriangleMLS",
  "UtahRealEstate",
  "WestPenn",
  "WyomingMLS"
]), J4 = Y4.extend({
  DerivedAssociationFeeMonthly: L(),
  DerivedPendingTimestamp: v(),
  DerivedOnMarketTimestamp: v(),
  RawMlsStoriesTotal: L(),
  RawMlsBathroomsTotal: L(),
  OriginatingSystemName: ase,
  AbodePropertyId: v(),
  RentalPricePerSqft: L(),
  // Added by us
  LastSyncDate: v()
}).partial(), RC = (e) => (0, Nh.isUndefined)(e) || e === "", Th = (e) => {
  if (!(0, Nh.isUndefined)(e))
    return {
      min: e.min === "" ? void 0 : e.min,
      max: e.max === "" ? void 0 : e.max,
      variance: e.variance === "" ? void 0 : e.variance,
      percentage: e.percentage === "" ? void 0 : e.percentage,
      exact: e.exact === "" ? void 0 : e.exact
    };
}, Ph = (e) => {
  if (!(0, Nh.isUndefined)(e) && !(RC(e.min) && RC(e.max)))
    return {
      min: e.min === "" ? void 0 : e.min,
      max: e.max === "" ? void 0 : e.max
    };
}, Cd = zt([
  L().min(0, { message: "must be greater than or equal to zero" }).max(100, { message: "Must be lesser than or equal to 100" }),
  ie(""),
  Ri()
]), Or = zt([
  L().min(0, { message: "must be greater than or equal to zero" }),
  ie(""),
  Ri()
]), Xi = Ot({
  min: Or.optional(),
  max: Or.optional()
}).optional().transform(Ph), t1 = Ot({
  min: Or.optional(),
  max: Or.optional(),
  variance: Or.optional(),
  exact: Or.optional(),
  percentage: Cd.optional()
}).optional().transform(Th), If = zt([qn, ie(""), Ri()]), ise = Ot({
  min: If.optional(),
  max: If.optional()
}).optional().transform(Ph), sse = Ot({
  min: If.optional(),
  max: If.optional(),
  variance: Or.optional(),
  exact: Or.optional(),
  percentage: Cd.optional()
}).optional().transform(Th), wf = zt([
  Te.transform((e, t) => ((0, hI.isDefined)(e) && jt.isAloftPrice(e) && e.unitAmount < 0 && t.addIssue({
    code: Me.custom,
    message: "must be greater than or equal to zero",
    path: []
  }), e)),
  ie(""),
  Ri()
]), lse = Ot({
  min: wf.optional(),
  max: wf.optional()
}).optional().transform(Ph), use = Ot({
  min: wf.optional(),
  max: wf.optional(),
  variance: Or.optional(),
  exact: Or.optional(),
  percentage: Cd.optional()
}).optional().transform(Th), Lf = zt([
  yt.transform((e, t) => ((0, hI.isDefined)(e) && xt.isAloftArea(e) && e.unitAmount < 0 && t.addIssue({
    code: Me.custom,
    message: "must be greater than or equal to zero",
    path: []
  }), e)),
  ie(""),
  Ri()
]), EC = Ot({
  min: Lf.optional(),
  max: Lf.optional(),
  variance: Or.optional(),
  exact: Or.optional(),
  percentage: Cd.optional()
}).optional().transform(Ph), DC = Ot({
  min: Lf.optional(),
  max: Lf.optional(),
  variance: Or.optional(),
  exact: Or.optional(),
  percentage: Cd.optional()
}).optional().transform(Th), N1 = v().optional().transform((e) => e === "" ? void 0 : e), cse = zt([Y(), ie("")]), T1 = cse.optional().transform((e) => e === "" ? void 0 : e), dse = Or.optional().transform((e, t) => {
  if (e !== "")
    return (0, Nh.isNumber)(e) && e.toString().length !== 5 && t.addIssue({
      code: Me.custom,
      message: "must be 5 digits",
      path: []
    }), e;
}), fse = be([
  "Acreage",
  "Boat Dock",
  "Business Opportunity",
  "Commercial",
  "Commercial Land",
  "Commercial Lease",
  "Commercial Sale",
  "Condo",
  "Farm",
  "Lots and Land",
  "Manufactured Home",
  "Mixed Use",
  "Mobile Home",
  "Multifamily Property",
  "Rentals",
  "Residential",
  "Residential Income",
  "Residential Lease",
  "Timeshare"
]), hse = be(["Active", "Pending", "Sold"]), kh = M({
  propertyType: fse.optional(),
  propertySubType: N1,
  saleDate: ise,
  salePrice: lse,
  gla: EC,
  lotSize: EC,
  zipCode: dse,
  yearBuilt: Xi,
  bedrooms: Xi,
  fullBaths: Xi,
  threeQuarterBaths: Xi,
  halfBaths: Xi,
  totalBaths: Xi,
  stories: Xi,
  garageSpaces: Xi,
  hasBasement: T1,
  hasPool: T1.optional(),
  style: N1,
  view: N1,
  attached: T1,
  statuses: ne(hse).optional()
}), pse = M({
  propertySubType: N1,
  saleDate: sse,
  salePrice: use,
  gla: DC,
  lotSize: DC,
  yearBuilt: t1,
  bedrooms: t1,
  fullBaths: t1,
  stories: t1,
  garageSpaces: t1,
  hasBasement: T1,
  hasPool: T1.optional(),
  status: N1
}), Rn = be([
  "lasting_range",
  "min_max_range",
  "percentage_range",
  "value_range",
  "exact"
]), mse = M({
  saleDate: be([Rn.enum.lasting_range, Rn.enum.min_max_range]).optional(),
  salePrice: be([Rn.enum.min_max_range, Rn.enum.percentage_range]).optional(),
  gla: be([Rn.enum.min_max_range, Rn.enum.percentage_range]).optional(),
  lotSize: be([Rn.enum.min_max_range, Rn.enum.percentage_range]).optional(),
  yearBuilt: be([
    Rn.enum.exact,
    Rn.enum.min_max_range,
    Rn.enum.value_range
  ]).optional(),
  bedrooms: be([
    Rn.enum.exact,
    Rn.enum.min_max_range,
    Rn.enum.value_range
  ]).optional(),
  fullBaths: be([
    Rn.enum.exact,
    Rn.enum.min_max_range,
    Rn.enum.value_range
  ]).optional(),
  stories: be([
    Rn.enum.exact,
    Rn.enum.min_max_range,
    Rn.enum.value_range
  ]).optional(),
  garageSpaces: be([
    Rn.enum.exact,
    Rn.enum.min_max_range,
    Rn.enum.value_range
  ]).optional()
}), Va = M({
  filters: pse,
  coordinates: ne(
    M({
      longitude: L(),
      latitude: L()
    })
  ),
  radius: L().optional(),
  matchCriteria: mse.optional()
}), gse = M({
  listingsSoldCount: L().optional(),
  listingsActiveCount: L().optional(),
  listingsPendingCount: L().optional(),
  last3MonthsListingsCount: L().optional(),
  last6MonthsListingsCount: L().optional(),
  last12MonthsListingsCount: L().optional()
});
M({
  filters: kh,
  coordinates: ne(
    M({
      longitude: L(),
      latitude: L()
    })
  ),
  radius: L().optional()
});
var bd = M({
  resultsCount: L(),
  results: ne(J4),
  statistics: gse.optional(),
  source: eI,
  searchCriteria: Va.optional()
}), vse = bd.extend({
  missingListingIDs: ne(v())
}), pI = bd.extend({
  totalResultsCount: L(),
  nextToken: v().optional()
});
M({
  mlsOUID: v(),
  listingIDs: ne(v())
});
M({
  longitude: L(),
  latitude: L(),
  radiusInMeters: L(),
  filters: kh.optional(),
  nextToken: v().optional(),
  top: L().optional()
});
M({
  coordinates: ne(
    M({
      longitude: L(),
      latitude: L()
    })
  ),
  filters: kh.optional(),
  nextToken: v().optional(),
  top: L().optional()
});
var po = (e) => e.array().optional(), Cse = be(["zillow", "mls"]), bse = be(["zip", "city", "county"]), yse = be(["default", "closemonth", "rolling3month"]), Sse = M({
  meta: M({
    source: Cse,
    geoname: bse,
    geo: v(),
    periodname: yse,
    updated: fs.schema.optional()
  }),
  data: M({
    start: Fr.schema.array(),
    // inclusive
    end: Fr.schema.array(),
    // exclusive
    latestmodificationtimestamp: po(fs.schema),
    originatingsystemnames: po(Rl.array()),
    numcloses: po(L()),
    avgcloseprice: po(jt.schema.nullable()),
    p50closeprice: po(jt.schema.nullable()),
    avgclosepriceoverlistprice: po(L().nullable()),
    p50closepriceoverlistprice: po(L().nullable()),
    avgclosepricepersqft: po(jt.schema.nullable()),
    p50closepricepersqft: po(jt.schema.nullable()),
    avgdaysonmarketclosed: po(L().nullable()),
    p50daysonmarketclosed: po(L().nullable()),
    avglistprice: po(jt.schema.nullable()),
    p50listprice: po(jt.schema.nullable())
  })
}), Ase = M({
  imageURLs: v().array()
}), Mse = M({
  listings: Ase.array()
}), mI = M({
  floor_structure_class: L(),
  floor_structure_commentary: v(),
  wall_framing_and_exterior_finish_class: L(),
  wall_framing_and_exterior_finish_commentary: v(),
  roof_class: L(),
  roof_commentary: v(),
  floor_finish_class: L(),
  floor_finish_commentary: v(),
  interior_wall_and_ceiling_finish_class: L(),
  interior_wall_and_ceiling_finish_commentary: v(),
  interior_detail_class: L(),
  interior_detail_commentary: v(),
  bath_detail_class: L(),
  bath_detail_commentary: v(),
  kitchen_detail_class: L(),
  kitchen_detail_commentary: v(),
  plumbing_detail_class: L(),
  plumbing_detail_commentary: v(),
  special_features_class: L(),
  special_features_commentary: v(),
  electrical_system_class: L(),
  electrical_system_commentary: v(),
  overall_class: L(),
  overall_commentary: v(),
  uad_condition_rating: v(),
  uad_condition_commentary: v(),
  has_barn: Y(),
  has_carport: Y(),
  has_basement: Y(),
  has_deck: Y(),
  has_covered_porch: Y(),
  has_enclosed_patio: Y(),
  has_accessory_dwelling_unit: Y(),
  has_pool: Y(),
  has_shed: Y(),
  has_workshop: Y(),
  has_fireplace: Y()
}).partial(), N2 = M({
  depreciateSeparately: Y().optional(),
  enableFunctionalDepreciation: Y().optional(),
  enableExternalDepreciation: Y().optional(),
  defaultEcoLife: L().int().optional(),
  defaultEcoLifeManufactured: L().int().optional(),
  defaultEcoLifeGarage: L().int().optional(),
  defaultEcoLifeDetachedGarage: L().int().optional(),
  defaultEcoLifeCarport: L().int().optional(),
  defaultEcoLifePorch: L().int().optional(),
  defaultEcoLifePatio: L().int().optional(),
  defaultEcoLifeDeck: L().int().optional(),
  defaultEcoLifeWorkshop: L().int().optional(),
  defaultEcoLifeShed: L().int().optional(),
  defaultEcoLifeBarn: L().int().optional(),
  defaultEcoLifePool: L().int().optional(),
  defaultEcoLifeSpa: L().int().optional(),
  defaultEcoLifeADU: L().int().optional(),
  defaultEcoLifeManualCost: L().int().optional(),
  defaultEcoLifeFireplace: L().int().optional()
}), xse = M({
  depreciateSeparately: Y().optional(),
  enableFunctionalDepreciation: Y().optional(),
  enableExternalDepreciation: Y().optional(),
  defaultEcoLife: L().int().optional(),
  defaultEcoLifeManufactured: L().int().optional(),
  defaultEcoLifeGarage: L().int().optional(),
  defaultEcoLifeDetachedGarage: L().int().optional(),
  defaultEcoLifeCarport: L().int().optional(),
  defaultEcoLifePorch: L().int().optional(),
  defaultEcoLifePatio: L().int().optional(),
  defaultEcoLifeDeck: L().int().optional(),
  defaultEcoLifeWorkshop: L().int().optional(),
  defaultEcoLifeShed: L().int().optional(),
  defaultEcoLifeBarn: L().int().optional(),
  defaultEcoLifePool: L().int().optional(),
  defaultEcoLifeSpa: L().int().optional(),
  defaultEcoLifeADU: L().int().optional(),
  defaultEcoLifeManualCost: L().int().optional(),
  defaultEcoLifeFireplace: L().int().optional()
});
Object.keys(xse.shape).filter(
  (e) => e.startsWith("defaultEcoLife")
);
var gI = zt([ie(6), ie(12), ie(24)]), _se = M({
  zip: v(),
  updated_date: v(),
  monthly_trends: M({
    historical_data: ne(
      M({
        year: L(),
        month: L(),
        typicalHomeValue: Nn,
        numCloses: L().optional(),
        sourceMLSes: Rl.array().optional(),
        medianListPrice: Nn.optional(),
        medianClosePriceOverListPrice: L().optional(),
        medianDaysOnMarket: L().optional()
      })
    ),
    one_month_projection: Nn.optional()
  })
}), Ise = M({
  zip: v(),
  analysisPeriod: gI,
  trends: ne(
    M({
      data: _se,
      timestamp: gk
    })
  )
}), wse = M({
  rate: L()
}), Lse = M({
  month: _r,
  value: Nn
}), Rse = M({
  type: be(["typicalHomeValue"]),
  analysisPeriod: gI,
  trendsAsPercentages: Y().optional().default(!1),
  trends: ne(Lse)
}), Ese = be([
  "none",
  "zillow",
  "customMonthlyRate",
  "customMonthlyPrice"
]), Dse = M({
  selectedMethod: Ese,
  methodState: M({
    zillow: Ise.optional(),
    customMonthlyRate: wse,
    customMonthlyPrice: Rse
  })
}), Nse = M({
  ratio: L()
}), Tse = be(["none", "customRatio"]), Pse = M({
  selectedMethod: Tse,
  methodState: M({
    customRatio: Nse
  }).partial()
}), kse = M({
  version: ie(1),
  /** The cached Date of Sale and List to Sale form data */
  cachedForms: M({
    dateOfSale: Dse,
    listToSale: Pse
  }),
  commentary: v().optional()
}), vI = M({
  bedrooms: Ht.optional(),
  bathroomsFull: Ht,
  bathroomsHalf: Ht,
  stories: L(),
  gla: yt,
  quality: hn,
  nonStandardGLA: yt.optional(),
  multiUnitCount: xe.optional()
}), CI = vI.partial(), bI = CI.pick({
  quality: !0,
  nonStandardGLA: !0,
  multiUnitCount: !0
}), yI = Ot({
  totalSqft: yt,
  finishedSqft: yt,
  access: v(),
  quality: hn
}).partial(), SI = yI.pick({ quality: !0 }), K4 = Ot({
  label: v(),
  feature: v(),
  cost: Te
}).partial(), Vse = M({
  totalSqft: yt,
  quality: hn
}).partial(), lc = M({
  totalSqft: yt,
  quality: hn
}), Vh = M({
  totalSqft: yt,
  percentInteriorFinished: L(),
  electrical: Y(),
  subpanel: Y(),
  plumbingFixturesCount: Ht,
  quality: hn
}), Ose = lc.extend({ attachedSpaceCount: Ht, builtinSpaceCount: Ht }).partial(), Fse = lc.extend({ spaceCount: Ht }).partial(), Bse = lc.extend({ spaceCount: Ht }).partial(), Hse = lc.partial(), Gse = lc.partial(), $se = lc.extend({ linearFootage: Ht }).partial(), Zse = Ot({
  totalSqft: yt,
  quality: hn
}).partial(), jse = vI.pick({
  bathroomsFull: !0,
  bathroomsHalf: !0,
  stories: !0,
  gla: !0,
  quality: !0
}).partial(), Wse = Vh.partial(), zse = Vh.partial(), Use = Vh.partial(), Xse = Vh.extend({
  isPoleBarn: Y(),
  hasExteriorWall: Y()
}).partial(), Yse = Ot({
  sections: Ht,
  gla: yt,
  bathroomsFull: Ht,
  bathroomsHalf: Ht,
  quality: hn,
  hasAC: Y(),
  hasClimatePkg: Y(),
  foundationType: v(),
  fireplaces: Ht,
  fireplaceType: hn,
  deliveryMileage: Ht
}).partial(), AI = M({
  // FIXME: Rename this field to "siteBuiltDwelling"
  /**
   * Primary dwelling is a misnomer. This field actually corresponds to DC's
   * concept of "site-built dwelling". For manufactured properties, the
   * "primary" dwelling would be a manufactured dwelling
   */
  primaryDwelling: CI,
  basement: yI,
  attic: Vse,
  attachedOrBuiltinGarage: Ose,
  detachedGarage: Fse,
  carport: Bse,
  deck: Hse,
  coveredPatioOrGazebo: Gse,
  enclosedPatio: $se,
  pool: Zse,
  adu: jse,
  shed: Wse,
  workshop: zse,
  bonusRoom: Use,
  barn: Xse,
  manufactured: Yse
}), uc = AI.keyof(), c5 = M({
  lumpSum: Te.optional(),
  percent: L().int().gte(0).lte(100).optional(),
  effectiveAge: L().optional(),
  ecoLifeYears: L().optional()
}), qse = M({
  physicalDepreciation: mn(uc, c5),
  functionalObsolescence: c5,
  externalDepreciation: c5
}), yd = AI.extend({
  address: v(),
  effectiveDate: qn,
  zip: v(),
  // Not included in DwellingCost request
  depreciation: qse,
  manualCost: K4.optional()
}), Jse = M({
  effectiveAge: L().optional(),
  ecoLifeYears: L().optional(),
  functionalObsolescencePercent: L().int().gte(0).lte(100).optional(),
  externalDepreciationPercent: L().int().gte(0).lte(100).optional()
}), Kse = yd.extend({
  depreciation: Jse,
  primaryDwelling: bI,
  basement: SI,
  manualCost: K4.optional()
});
yd.omit({ address: !0, effectiveDate: !0, zip: !0 }).extend({
  primaryDwelling: bI,
  basement: SI,
  manualCost: K4.optional()
});
yd.omit({ depreciation: !0 });
mn(
  uc,
  M({ cost: Te }).or(Ri())
);
var Q4 = mn(
  uc,
  M({ costPerSqft: Te }).or(Ri())
), e9 = M({
  // used for making a cost data request (to DwellingCost)
  editableInput: Kse,
  // Not included in DwellingCost response. Manually entered by appraiser.
  additionalFeaturesCost: Te.optional(),
  // Only set for the subject. Site cost is derived for comps.
  siteCost: Te.optional()
}), Qse = M({
  backrefs: yd.optional()
}), MI = e9.merge(M({ structureCosts: Q4.or(Ri()) })).merge(Qse);
mn(v(), e9);
var ele = mn(v(), MI), tle = uc, T2 = M({
  physicalDepreciationMode: be(["ageLifeMethod", "percent", "lumpSum"]),
  depreciateImprovementsSeparately: Y(),
  defaultEconomicLifePerImprovement: mn(tle, L()),
  functionalObsolescenceMode: be(["percent", "lumpSum"]),
  externalObsolescenceMode: be(["percent", "lumpSum"])
});
re(ce(), 1);
var nle = [
  "adu",
  "attic",
  "barn",
  "basement",
  "carport",
  "deck",
  "fireplace",
  "garage",
  "detachedGarage",
  "manualCost",
  "patio",
  "pool",
  "porch",
  "shed",
  "spa",
  "workshop"
], rle = be(nle), ole = M({
  version: ie(1),
  features: ne(rle)
}), ale = [
  "termsOfSale",
  "concessions",
  "dateOfSale",
  "site",
  "locationView",
  "quality",
  "condition",
  "mainDwelling",
  // Either GLA or GBA for multi-family
  "bathAboveGrade",
  "bathBelowGrade",
  "basement",
  "functionalUtility",
  "externalObsolescence",
  "garageCarport",
  "porchPatioDeck",
  "attic",
  "fireplace",
  "belowGradeANSI",
  "barn",
  "bonusRoom",
  "adu",
  "manufactured",
  "pool",
  "shed",
  "workshop",
  "foundation",
  "units",
  "manual"
], ile = be([...ale]), sle = Array.from(
  /* @__PURE__ */ new Set([...ile.options, ...X4])
), Rf = be(
  sle
), P2 = M({
  enableRounding: Y().optional(),
  enableThreshold: Y().optional(),
  rounding: mn(Rf, jt.schema.optional()),
  roundingDefault: jt.schema,
  threshold: mn(Rf, jt.schema.optional()),
  thresholdDefault: jt.schema,
  saveAsDefault: Y().optional()
});
M({
  enableRounding: Y().optional(),
  enableThreshold: Y().optional(),
  rounding: mn(Rf, Nn),
  roundingDefault: Nn,
  threshold: mn(Rf, Nn),
  thresholdDefault: Nn,
  saveAsDefault: Y().optional()
});
var Lu = re(ce(), 1);
function lle({ LotSizeSquareFeet: e, LotSizeAcres: t }) {
  if (e)
    return xt.fromNumber(e, "sqft");
  if (t)
    return xt.fromNumber(t, "acre");
}
function ule(e) {
  if (e !== void 0)
    switch (e.toLowerCase().trim()) {
      case "active":
      case "activeundercontract":
      case "active under contract":
      case "comingsoon":
      case "coming soon":
        return "Active";
      case "pending":
        return "Contract";
      case "withdrawn":
      case "hold":
        return "Withdrawn";
      case "sold":
      case "closed":
        return "SettledSale";
      case "canceled":
      case "delete":
      case "expired":
        return "Expired";
      default:
        return;
    }
}
M({
  subject_address: M({
    address_full: v().nullable(),
    address_id: L().nullable(),
    slug: v().nullable(),
    block_id: v().nullable(),
    city: v().nullable(),
    fips: v().nullable(),
    geo_precision: v().nullable(),
    latitude: L().nullable(),
    longitude: L().nullable(),
    state: v().nullable(),
    unit: v().nullable(),
    address: v().nullable(),
    zipcode: v().nullable(),
    zipcode_plus4: v().nullable(),
    msa: v().nullable()
  }),
  public_records: gn(),
  hc: M({
    architectural_style: v().nullable(),
    attic: gn(),
    // TODO: figure out
    basement: M({
      finished_pct: L().nullable(),
      has: Y().nullable(),
      total_area: L().nullable()
    }).nullable(),
    bathrooms: M({
      full: L().nullable(),
      partial: L().nullable(),
      total: L().nullable(),
      total_provided: L().nullable(),
      total_projected: L().nullable()
    }).nullable(),
    bedrooms: L().nullable(),
    buildings: v().nullable(),
    building_quality: v().nullable(),
    construction_types: ne(v()).nullable(),
    cooling: ne(v()).nullable(),
    fireplace: gn().nullable(),
    // TODO: figure out
    fireplaces_total: L().nullable(),
    heating: ne(v()).nullable(),
    legal_description: v().nullable(),
    living_area: L().nullable(),
    living_area_above_grade: L().nullable(),
    living_area_below_grade: L().nullable(),
    lot_size: L().nullable(),
    neighborhood: gn().nullable(),
    // TODO: figure out
    parcel_id: v().nullable(),
    parking: M({
      description: v().nullable(),
      garage: L().nullable(),
      total: L().nullable()
    }).nullable(),
    pool: Y().nullable(),
    pool_community: gn().nullable(),
    // TODO: figure out
    property_type: v().nullable(),
    property_type_description: v().nullable(),
    roof_type: gn().nullable(),
    // TODO: figure out
    roof_material: gn().nullable(),
    // TODO: figure out
    rooms_total: L().nullable(),
    sewer: gn().nullable(),
    // TODO: figure out
    sewer_public: Y().nullable(),
    solar_panels: gn().nullable(),
    // TODO: figure out
    stories: L().nullable(),
    subdivision: gn().nullable(),
    // TODO: figure out
    units_total: gn().nullable(),
    // TODO: figure out
    walls_exterior_material: v().nullable(),
    water: gn().nullable(),
    // TODO: figure out
    year_built: L().nullable(),
    zoning: M({
      code: v().nullable(),
      description: v().nullable()
    }).nullable(),
    condition_class: L().nullable()
  }).nullable(),
  assessment: M({
    apn: v().nullable(),
    amount_annual: L().nullable(),
    value_assessed: L().nullable(),
    value_assessed_improvement: L().nullable(),
    value_assessed_land: L().nullable(),
    tax_year: L().nullable(),
    year_assessed: L().nullable()
  })
});
ne(
  M({
    "property/listing_status": M({
      api_code_description: v().nullable(),
      api_code: L(),
      result: M({
        listing_status: v().nullable(),
        listing_date: v().nullable(),
        listing_price: L().nullable(),
        listing_status_date: v().nullable(),
        has_price_considerations: Y().nullable()
      }).nullable()
    }),
    address_info: M({
      city: v().nullable(),
      county_fips: v().nullable(),
      geo_precision: v().nullable(),
      zipcode: v().nullable(),
      address_full: v().nullable(),
      slug: v().nullable(),
      block_id: v().nullable(),
      blockgroup_id: v().nullable(),
      state: v().nullable(),
      zipcode_plus4: v().nullable(),
      address: v().nullable(),
      lat: L().nullable(),
      lng: L().nullable(),
      unit: v().nullable(),
      status: gn().nullable(),
      // TODO: figure out
      msa: v().nullable(),
      metrodiv: gn().nullable()
      // TODO: figure out
    })
  })
);
var cle = re(ce(), 1), dle = re(ce(), 1), fle = (0, dle.applyIfNonEmptyString)((e) => Fr.fromIsoString(e)), hle = re(yl(), 1), NC = (e, t) => (0, hle.isUndefined)(e) || e === "" ? void 0 : fs.fromIsoString(e).toAloftDate(t);
function ple(e, t = !1) {
  if (t && (0, cle.isUndefined)(e.OriginatingSystemName))
    return;
  const n = vre(e.OriginatingSystemName);
  let r;
  return n === void 0 || n.isActive === !1 || !n.timeZone ? r = Xe.TimeZones.US_PACIFIC : r = n.timeZone, // PurchaseContractDate is the most accurate, but has very low fill rate
  fle(e.PurchaseContractDate) ?? // Pending timestamp is the next best option as it's set by the MLS
  NC(e.PendingTimestamp, r) ?? // If neither of those options is available, fallback to C1's derived pending date
  NC(e.DerivedPendingTimestamp, r);
}
re(ce(), 1);
var TC = re(ce(), 1);
function mle(e) {
  if ((0, TC.isDefined)(e.BathroomsFull) || (0, TC.isDefined)(e.BathroomsThreeQuarter))
    return (e.BathroomsFull ?? 0) + (e.BathroomsThreeQuarter ?? 0);
  const t = e.BathroomsTotalInteger;
  if (t !== void 0 && !Number.isNaN(t))
    return Math.floor(t);
}
var gle = re(ce(), 1);
function vle(e) {
  var n;
  if (e.BathroomsHalf !== void 0)
    return e.BathroomsHalf;
  const t = (n = e.BathroomsTotalInteger) == null ? void 0 : n.toString();
  if (t != null && t.includes("."))
    return Number((0, gle.expected)(t).split(".")[1]);
}
re(ce(), 1);
var Cle = re(ce(), 1);
re(yl(), 1);
re(ce(), 1);
var ble = re(ce(), 1);
(0, ble.applyIfNonEmptyString)((e) => Bre(e));
var yle = re(ce(), 1);
(0, yle.makeLookup)({
  cases: [
    [["Active", "Active Under Contract", "Coming Soon"], "Active"],
    [["Canceled", "Delete", "Expired", "Incomplete"], "Expired"],
    [["Closed", "Sold"], "SettledSale"],
    [["Hold", "Withdrawn"], "Withdrawn"],
    ["Pending", "Contract"]
  ],
  default: "Expired"
  // TODO: Should we leave this or get rid of it?
});
jt.fromNumericPrice;
(0, Cle.orUndefined)((e) => e.join(", "));
jt.fromNumericPrice;
function d5(e) {
  if (e === void 0)
    return;
  const t = new Date(e), n = t.getMonth() + 1, r = t.getFullYear();
  return _r.parse(`${r}-${n < 10 ? "0" : ""}${n}`);
}
var Sle = re(ce(), 1), Ei = re(P4(), 1);
function PC(e) {
  return Number.isNaN(e) ? void 0 : e;
}
var Oa = new Ei.Iso(
  (e) => e === void 0 ? void 0 : PC(e),
  (e) => e === void 0 ? void 0 : PC(e)
), Nr = new Ei.Iso(
  Oa.fwd,
  (e) => e === void 0 || Number.isNaN(e) ? void 0 : xe.parse(e)
), la = new Ei.Lens(
  xt.sqftLensOpt.get,
  xt.sqftLensOpt.set
).concat(Oa.toLens()), as = Oa, is = new Ei.Iso(
  (e) => e === !0 ? "Yes" : e === !1 ? "No" : void 0,
  (e) => e === "Yes" ? !0 : e === "No" ? !1 : void 0
), kC = new Ei.Iso(
  // not technically an iso but what can you do
  (e) => e === void 0 ? void 0 : e,
  (e) => e === "" ? void 0 : e
), Ale = new Ei.Lens(
  jt.dollarLensOpt.get,
  jt.dollarLensOpt.set
).concat(Oa.toLens());
function xI(e) {
  return new Ei.Iso(
    (t) => t && e.includes(t) ? t : void 0,
    (t) => t && e.includes(t) ? t : void 0
  );
}
var Mle = xI([
  "Permanent or Concrete",
  "Non-Permanent"
]), xle = xI(["Built-In", "Freestanding"]), Yi = new Ei.Lens(
  (e) => Ef({
    totalSqft: la.get(e == null ? void 0 : e.totalSqft),
    quality: as.fwd(e == null ? void 0 : e.quality)
  }),
  (e, t) => Ef({
    totalSqft: la.set(e == null ? void 0 : e.totalSqft, t == null ? void 0 : t.totalSqft),
    quality: as.fwd(t == null ? void 0 : t.quality)
  })
), r2 = new Ei.Lens(
  (e) => Ef({
    totalSqft: la.get(e == null ? void 0 : e.totalSqft),
    quality: as.fwd(e == null ? void 0 : e.dwellingCostQuality),
    percentInteriorFinished: Oa.fwd(e == null ? void 0 : e.percentInteriorFinished),
    electrical: is.fwd(e == null ? void 0 : e.electrical),
    subpanel: is.fwd(e == null ? void 0 : e.subpanel),
    plumbingFixturesCount: Oa.fwd(e == null ? void 0 : e.plumbingFixturesCount)
  }),
  (e, t) => Ef({
    totalSqft: la.set(e == null ? void 0 : e.totalSqft, t == null ? void 0 : t.totalSqft),
    percentInteriorFinished: Oa.inv(t == null ? void 0 : t.percentInteriorFinished),
    electrical: is.inv(t == null ? void 0 : t.electrical),
    subpanel: is.inv(t == null ? void 0 : t.subpanel),
    plumbingFixturesCount: Nr.inv(t == null ? void 0 : t.plumbingFixturesCount),
    dwellingCostQuality: as.inv(t == null ? void 0 : t.quality)
  })
);
function Ef(e) {
  return (0, Sle.populated)(e) ? e : void 0;
}
function _le(e) {
  var f, h, m, g, b, C, y, _, x, I, R, E;
  const t = e._getCostDataExtension(), n = e.getStructuredData("gla"), r = e.getStructuredData("bathroomCount"), o = e.getStructuredData("basementLine1"), a = e.getStructuredData("basementLine2"), s = e.getStructuredData("designStyle"), l = e.getPropertyType(), c = () => {
    var N, P, F;
    const k = {
      gla: la.get(n),
      quality: as.fwd((N = t == null ? void 0 : t.primaryDwelling) == null ? void 0 : N.quality),
      stories: Oa.fwd(s == null ? void 0 : s.stories),
      aboveGradeBathsFull: Nr.fwd(r == null ? void 0 : r.fullBaths),
      aboveGradeBathsHalf: Nr.fwd(r == null ? void 0 : r.halfBaths),
      belowGradeBathsFull: Nr.fwd(a == null ? void 0 : a.fullBathCount),
      belowGradeBathsHalf: Nr.fwd(a == null ? void 0 : a.halfBathCount),
      nonStandardGLA: la.get((P = t == null ? void 0 : t.primaryDwelling) == null ? void 0 : P.nonStandardGla),
      multiUnitCount: Nr.fwd((F = t == null ? void 0 : t.primaryDwelling) == null ? void 0 : F.multiUnitCount)
    };
    switch (l) {
      case "manufacturedHome":
        return;
      case "multiFamily":
      case "singleFamilyResidence":
      default:
        return k;
    }
  }, d = () => {
    var N, P, F, G, j, ae, ue, le, _e, ve, z, K, Ce;
    const k = {
      gla: la.get((N = t == null ? void 0 : t.manufactured) == null ? void 0 : N.gla),
      quality: as.fwd((P = t == null ? void 0 : t.manufactured) == null ? void 0 : P.dwellingCostQuality),
      sections: Oa.fwd((F = t == null ? void 0 : t.manufactured) == null ? void 0 : F.sections),
      bathroomsFull: Nr.fwd((G = t == null ? void 0 : t.manufactured) == null ? void 0 : G.bathroomsFull),
      bathroomsHalf: Nr.fwd((j = t == null ? void 0 : t.manufactured) == null ? void 0 : j.bathroomsHalf),
      hasAC: is.fwd((ae = t == null ? void 0 : t.manufactured) == null ? void 0 : ae.hasAC),
      hasClimatePkg: is.fwd((ue = t == null ? void 0 : t.manufactured) == null ? void 0 : ue.hasClimatePkg),
      foundationType: Mle.fwd((le = t == null ? void 0 : t.manufactured) == null ? void 0 : le.foundationType),
      fireplaces: Nr.fwd((ve = (_e = t == null ? void 0 : t.manufactured) == null ? void 0 : _e.fireplaces) == null ? void 0 : ve.totalCount),
      fireplaceType: xle.fwd((K = (z = t == null ? void 0 : t.manufactured) == null ? void 0 : z.fireplaces) == null ? void 0 : K.type),
      deliveryMileage: Nr.fwd((Ce = t == null ? void 0 : t.manufactured) == null ? void 0 : Ce.deliveryMileage)
    };
    switch (l) {
      case "manufacturedHome":
        return {
          ...k,
          gla: la.get(n),
          bathroomsFull: Nr.fwd(r == null ? void 0 : r.fullBaths),
          bathroomsHalf: Nr.fwd(r == null ? void 0 : r.halfBaths)
        };
      case "multiFamily":
      case "singleFamilyResidence":
      default:
        return k;
    }
  };
  return {
    // Primary Dwelling actually refers to site built dwelling here
    primaryDwelling: c(),
    basement: {
      totalSqft: la.get(o == null ? void 0 : o.total),
      quality: as.fwd((f = t == null ? void 0 : t.basement) == null ? void 0 : f.quality),
      finishedSqft: la.get(o == null ? void 0 : o.finished)
    },
    attachedOrBuiltinGarage: Yi.get(t == null ? void 0 : t.attachedOrBuiltinGarage),
    detachedGarage: Yi.get(t == null ? void 0 : t.detachedGarage),
    carport: Yi.get(t == null ? void 0 : t.carport),
    deck: Yi.get(t == null ? void 0 : t.deck),
    coveredPatioOrGazebo: Yi.get(t == null ? void 0 : t.coveredPatioOrGazebo),
    enclosedPatio: {
      ...Yi.get(t == null ? void 0 : t.enclosedPatio),
      linearFootage: Nr.fwd((h = t == null ? void 0 : t.enclosedPatio) == null ? void 0 : h.linearFootage)
    },
    pool: Yi.get(t == null ? void 0 : t.pool),
    adu: {
      gla: la.get((m = t == null ? void 0 : t.adu) == null ? void 0 : m.gla),
      quality: as.fwd((g = t == null ? void 0 : t.adu) == null ? void 0 : g.dwellingCostQuality),
      bathroomsFull: Nr.fwd((b = t == null ? void 0 : t.adu) == null ? void 0 : b.bathroomsFull),
      bathroomsHalf: Nr.fwd((C = t == null ? void 0 : t.adu) == null ? void 0 : C.bathroomsHalf),
      stories: Oa.fwd((y = t == null ? void 0 : t.adu) == null ? void 0 : y.stories)
    },
    attic: Yi.get(t == null ? void 0 : t.attic),
    shed: r2.get(t == null ? void 0 : t.shed),
    workshop: r2.get(t == null ? void 0 : t.workshop),
    bonusRoom: r2.get(t == null ? void 0 : t.bonusRoom),
    barn: {
      ...r2.get(t == null ? void 0 : t.barn),
      isPoleBarn: is.fwd((_ = t == null ? void 0 : t.barn) == null ? void 0 : _.isPoleBarn),
      hasExteriorWall: is.fwd((x = t == null ? void 0 : t.barn) == null ? void 0 : x.hasExteriorWall)
    },
    manufactured: d(),
    manualCost: {
      label: kC.fwd((I = t == null ? void 0 : t.manualCost) == null ? void 0 : I.label),
      feature: kC.fwd((R = t == null ? void 0 : t.manualCost) == null ? void 0 : R.feature),
      cost: Ale.get((E = t == null ? void 0 : t.manualCost) == null ? void 0 : E.cost)
    }
  };
}
var Sr = re(ce(), 1);
function Ile(e, t) {
  var o;
  const { encoding: n, annotations: r } = t;
  if (n !== "UAD_2022")
    throw Error(`Cannot retrieve data for encoding: ${n}`);
  try {
    switch (e) {
      case "toolkitListingID":
        if ((0, Sr.isUndefined)(r.DataSourceDescription))
          return;
        const { mls: a, listingID: s } = Sf.decode(r.DataSourceDescription);
        return [a, s].some(Sr.isUndefined) || !o_(a) || !a_(a) ? void 0 : Mre({
          mls: a,
          listingID: s
        });
      case "address":
        return yf.decode(r);
      case "latitude":
        return (0, Sr.orUndefined)(ds.decode)(
          r.LatitudeNumber
        );
      case "longitude":
        return (0, Sr.orUndefined)(ds.decode)(
          r.LongitudeNumber
        );
      case "dataSource":
        return (0, Sr.orUndefined)(Sf.decode)(
          r.DataSourceDescription
        );
      case "designStyle":
        return (0, Sr.orUndefined)(Ah.decode)(r.DesignStyle);
      case "carStorage":
        return (0, Sr.orUndefined)(Mh.decode)(
          r.CarStorage
        );
      case "status":
        return (0, Sr.orUndefined)(Ih.decode)(
          r.DateOfSale
        );
      case "siteArea":
        return (o = (0, Sr.orUndefined)(_h.decode)(r.SiteArea)) == null ? void 0 : o.site;
      case "actualAge":
        return (0, Sr.orUndefined)(Lh.decode)(r.Age);
      case "gla":
        return (0, Sr.orUndefined)(wh.decode)(
          r.GrossLivingArea
        );
      case "bedroomCount":
        return (0, Sr.orUndefined)(ds.decode)(
          r.TotalBedroomCount
        );
      case "bathroomCount":
        return (0, Sr.orUndefined)(Sh.decode)(
          r.TotalBathroomCount
        );
      case "basementLine1":
        return (0, Sr.orUndefined)(Ch.decode)(
          r.BasementArea
        );
      case "basementLine2":
        return (0, Sr.orUndefined)(yh.decode)(
          r.BasementFinish
        );
      case "salePrice":
        return (0, Sr.orUndefined)(Rh.decode)(
          r.PropertySalesAmount
        );
      default:
        throw Error(`Getter not implemented for field: ${e}`);
    }
  } catch (a) {
    if (a instanceof Pt)
      return;
    throw a;
  }
}
var oa = re(ce(), 1);
function aa(e, t, n) {
  switch (e) {
    case "actualAge":
      const r = t.getStructuredData(e), o = n.getStructuredData(e);
      return r === void 0 && o === void 0 ? void 0 : (0, oa.orUndefined)(Lh.encode)({
        age: (o == null ? void 0 : o.age) ?? (r == null ? void 0 : r.age),
        isEstimation: (o == null ? void 0 : o.isEstimation) ?? (r == null ? void 0 : r.isEstimation)
      });
    case "gla":
      const a = t.getStructuredData(e), s = n.getStructuredData(e);
      return (0, oa.orUndefined)(wh.encode)(s ?? a);
    case "bedroomCount":
      const l = t.getStructuredData(e), c = n.getStructuredData(e);
      return (0, oa.orUndefined)(ds.encode)(c ?? l);
    case "bathroomCount":
      const d = t.getStructuredData(e), f = n.getStructuredData(e);
      return d === void 0 && f === void 0 ? void 0 : (0, oa.orUndefined)(Sh.encode)({
        fullBaths: (f == null ? void 0 : f.fullBaths) ?? (d == null ? void 0 : d.fullBaths),
        halfBaths: (f == null ? void 0 : f.halfBaths) ?? (d == null ? void 0 : d.halfBaths)
      });
    case "basementLine1":
      const h = t.getStructuredData(e), m = n.getStructuredData(e);
      return h === void 0 && m === void 0 ? void 0 : (0, oa.orUndefined)(Ch.encode)({
        total: (m == null ? void 0 : m.total) ?? (h == null ? void 0 : h.total),
        finished: (m == null ? void 0 : m.finished) ?? (h == null ? void 0 : h.finished)
      });
    case "basementLine2":
      const g = t.getStructuredData(e), b = n.getStructuredData(e);
      return g === void 0 && b === void 0 ? void 0 : (0, oa.orUndefined)(yh.encode)({
        bedroomCount: (b == null ? void 0 : b.bedroomCount) ?? (g == null ? void 0 : g.bedroomCount),
        fullBathCount: (b == null ? void 0 : b.fullBathCount) ?? (g == null ? void 0 : g.fullBathCount),
        halfBathCount: (b == null ? void 0 : b.halfBathCount) ?? (g == null ? void 0 : g.halfBathCount),
        otherRoomCount: (b == null ? void 0 : b.otherRoomCount) ?? (g == null ? void 0 : g.otherRoomCount),
        recRoomCount: (b == null ? void 0 : b.recRoomCount) ?? (g == null ? void 0 : g.recRoomCount)
      });
    case "carStorage":
      const C = t.getStructuredData(e), y = n.getStructuredData(e);
      return C === void 0 && y === void 0 ? void 0 : (0, oa.orUndefined)(Mh.encode)({
        attachedGarageSpaces: (y == null ? void 0 : y.attachedGarageSpaces) ?? (C == null ? void 0 : C.attachedGarageSpaces),
        builtInGarageSpaces: (y == null ? void 0 : y.builtInGarageSpaces) ?? (C == null ? void 0 : C.builtInGarageSpaces),
        detachedGarageSpaces: (y == null ? void 0 : y.detachedGarageSpaces) ?? (C == null ? void 0 : C.detachedGarageSpaces),
        drivewaySpaces: (y == null ? void 0 : y.drivewaySpaces) ?? (C == null ? void 0 : C.drivewaySpaces),
        carportSpaces: (y == null ? void 0 : y.carportSpaces) ?? (C == null ? void 0 : C.carportSpaces)
      });
    case "designStyle":
      const _ = t.getStructuredData(e), x = n.getStructuredData(e);
      return _ === void 0 && x === void 0 ? void 0 : (0, oa.orUndefined)(Ah.encode)({
        attachmentType: (x == null ? void 0 : x.attachmentType) ?? (_ == null ? void 0 : _.attachmentType),
        style: (x == null ? void 0 : x.style) ?? (_ == null ? void 0 : _.style),
        stories: (x == null ? void 0 : x.stories) ?? (_ == null ? void 0 : _.stories)
      });
    case "salePrice":
      const I = t.getStructuredData(e), R = n.getStructuredData(e);
      return I === void 0 && R === void 0 ? void 0 : (0, oa.orUndefined)(Rh.encode)(R ?? I);
    case "siteArea":
      const E = t.getStructuredData(e), k = n.getStructuredData(e);
      return E === void 0 && k === void 0 ? void 0 : (0, oa.orUndefined)(_h.encode)({
        site: k ?? E
      });
    case "status":
      const N = t.getStructuredData(e), P = n.getStructuredData(e);
      return N === void 0 && P === void 0 ? void 0 : (0, oa.orUndefined)(Ih.encode)({
        contractMonth: (P == null ? void 0 : P.contractMonth) ?? (N == null ? void 0 : N.contractMonth),
        closeMonth: (P == null ? void 0 : P.closeMonth) ?? (N == null ? void 0 : N.closeMonth),
        expirationMonth: (P == null ? void 0 : P.expirationMonth) ?? (N == null ? void 0 : N.expirationMonth),
        withdrawalMonth: (P == null ? void 0 : P.withdrawalMonth) ?? (N == null ? void 0 : N.withdrawalMonth),
        listingStatus: (P == null ? void 0 : P.listingStatus) ?? (N == null ? void 0 : N.listingStatus)
      });
    default:
      throw new Error(`Unhandled field: ${e}`);
  }
}
var Dr = re(ce(), 1);
function wle(e, t, n) {
  const { encoding: r } = n;
  if (r !== "UAD_2022")
    throw Error(`Cannot retrieve data for encoding: ${r}`);
  let o, a;
  switch (e) {
    case "address":
      const s = t, l = (0, Dr.isUndefined)(s) ? yf.emptyAnnotations : yf.encode(s);
      return {
        ...n,
        annotations: {
          ...n.annotations,
          ...l
        }
      };
    case "latitude":
      o = "LatitudeNumber";
      const c = t;
      a = (0, Dr.orUndefined)(ds.encode)(c);
      break;
    case "longitude":
      o = "LongitudeNumber";
      const d = t;
      a = (0, Dr.orUndefined)(ds.encode)(d);
      break;
    case "dataSource":
      o = "DataSourceDescription";
      const f = t;
      a = (0, Dr.orUndefined)(Sf.encode)(f);
      break;
    case "designStyle":
      o = "DesignStyle";
      const h = t;
      a = (0, Dr.orUndefined)(Ah.encode)(h);
      break;
    case "carStorage":
      o = "CarStorage";
      const m = t;
      a = (0, Dr.orUndefined)(Mh.encode)(m);
      break;
    case "status":
      o = "DateOfSale";
      const g = t;
      a = (0, Dr.orUndefined)(Ih.encode)(g);
      break;
    case "siteArea":
      o = "SiteArea";
      const b = t;
      a = (0, Dr.orUndefined)((k) => _h.encode({ site: k }))(b);
      break;
    case "actualAge":
      o = "Age";
      const C = t;
      a = (0, Dr.orUndefined)(Lh.encode)(C);
      break;
    case "gla":
      o = "GrossLivingArea";
      const y = t;
      a = (0, Dr.orUndefined)(wh.encode)(y);
      break;
    case "bedroomCount":
      o = "TotalBedroomCount";
      const _ = t;
      a = (0, Dr.orUndefined)(ds.encode)(_);
      break;
    case "bathroomCount":
      o = "TotalBathroomCount";
      const x = t;
      a = (0, Dr.orUndefined)(Sh.encode)(x);
      break;
    case "basementLine1":
      o = "BasementArea";
      const I = t;
      a = (0, Dr.orUndefined)(Ch.encode)(I);
      break;
    case "basementLine2":
      o = "BasementFinish";
      const R = t;
      a = (0, Dr.orUndefined)(yh.encode)(R);
      break;
    case "salePrice":
      o = "PropertySalesAmount";
      const E = t;
      a = (0, Dr.orUndefined)(Rh.encode)(E);
      break;
    default:
      throw Error(`Setter not implemented for field: ${e}`);
  }
  return {
    ...n,
    annotations: {
      ...n.annotations,
      [o]: a
    }
  };
}
var Lle = re(ce(), 1);
function Rle(e) {
  var s, l, c, d, f, h;
  const { salesCompGridData: t, costDataExtension: n, runCostExtension: r, propertyType: o } = e, a = {
    ...n,
    depreciation: {
      physicalDepreciation: {
        primaryDwelling: {
          effectiveAge: (l = (s = n.depreciation) == null ? void 0 : s.physicalDepreciation) == null ? void 0 : l.effectiveAge,
          ecoLifeYears: (d = (c = n.depreciation) == null ? void 0 : c.physicalDepreciation) == null ? void 0 : d.economicLifeYears
        }
      },
      functionalObsolescence: {
        percent: (f = n.depreciation) == null ? void 0 : f.functionalObsolescencePercent
      },
      externalDepreciation: {
        percent: (h = n.depreciation) == null ? void 0 : h.externalDepreciationPercent
      }
    }
  };
  return {
    version: 2,
    salesCompGridData: t,
    costDataExtension: a,
    runCostExtension: r,
    propertyType: o
  };
}
function Ele(e) {
  let t = e;
  switch (t.version) {
    case 1:
      t = Rle(t);
    case 2:
      return t;
    default:
      (0, Lle.unreachable)(t);
  }
}
var xs = L().gte(1).lte(8).multipleOf(0.1), El = Ot({
  totalSqft: yt,
  quality: xs
}).partial(), Oh = Ot({
  totalSqft: yt,
  percentInteriorFinished: L(),
  electrical: Y(),
  subpanel: Y(),
  plumbingFixturesCount: xe,
  dwellingCostQuality: xs
}).partial(), _I = be(["Permanent or Concrete", "Non-Permanent"]), Dle = be(["Built-In", "Freestanding"]), II = Ot({
  quality: xs,
  nonStandardGla: yt,
  multiUnitCount: xe
}).partial(), wI = Ot({
  quality: xs
}).partial(), LI = M({
  totalSqft: yt,
  quality: xs
}).partial(), RI = El.partial(), EI = El.partial(), DI = El.partial(), NI = El.partial(), TI = El.partial(), PI = El.extend({ linearFootage: xe }).partial(), kI = El.partial(), VI = Ot({
  bathroomsFull: xe,
  bathroomsHalf: xe,
  stories: L().gte(0).lte(4).multipleOf(0.5),
  gla: yt,
  dwellingCostQuality: xs
}).partial(), OI = Oh.partial(), FI = Oh.partial(), BI = Oh.partial(), HI = Oh.extend({
  isPoleBarn: Y(),
  hasExteriorWall: Y()
}).partial(), t9 = Ot({
  sections: L().gte(1).lte(4).int(),
  gla: yt,
  bathroomsFull: xe,
  bathroomsHalf: xe,
  dwellingCostQuality: xs,
  hasAC: Y(),
  hasClimatePkg: Y(),
  foundationType: _I,
  fireplaces: Ot({
    totalCount: xe,
    type: Dle
  }).partial(),
  deliveryMileage: xe
}).partial(), Nle = Ot({
  physicalDepreciation: Ot({
    effectiveAge: L(),
    economicLifeYears: xe
  }).partial(),
  functionalObsolescencePercent: L().int().gte(0).lte(100),
  externalDepreciationPercent: L().int().gte(0).lte(100)
}).partial(), GI = Ot({
  label: v(),
  feature: v(),
  cost: jt.schema
}).partial(), Tle = Ot({
  primaryDwelling: II,
  basement: wI,
  attic: LI,
  attachedOrBuiltinGarage: RI,
  detachedGarage: EI,
  carport: DI,
  deck: NI,
  coveredPatioOrGazebo: TI,
  enclosedPatio: PI,
  pool: kI,
  adu: VI,
  shed: OI,
  workshop: FI,
  bonusRoom: BI,
  barn: HI,
  manufactured: t9,
  // Not included in DwellingCost request
  /**
   * @deprecated Use manualCost instead
   */
  additionalFeaturesCost: Te.optional(),
  manualCost: GI,
  depreciation: Nle,
  siteNotes: v().optional(),
  // Only set for the subject. Site cost is derived for comps.
  siteCost: Te.optional()
}).partial(), Ple = M({
  output: Q4,
  bathroomCosts: eie.optional()
}), $I = Ple.extend({
  input: gn()
}), kle = M({
  version: ie(1),
  salesCompGridData: F_,
  costDataExtension: Tle,
  runCostExtension: $I.optional(),
  propertyType: xr.optional()
}), B3 = M({
  lumpSum: Te.optional(),
  percent: L().gte(0).lte(100).optional(),
  effectiveAge: L().optional(),
  ecoLifeYears: L().optional()
}), Vle = mn(
  uc,
  B3
), Ole = Ot({
  physicalDepreciation: Vle,
  functionalObsolescence: B3,
  externalDepreciation: B3
}).partial(), Fle = Ot({
  primaryDwelling: II,
  basement: wI,
  attic: LI,
  attachedOrBuiltinGarage: RI,
  detachedGarage: EI,
  carport: DI,
  deck: NI,
  coveredPatioOrGazebo: TI,
  enclosedPatio: PI,
  pool: kI,
  adu: VI,
  shed: OI,
  workshop: FI,
  bonusRoom: BI,
  barn: HI,
  manufactured: t9,
  // Not included in DwellingCost request
  /**
   * @deprecated Use manualCost instead
   */
  additionalFeaturesCost: Te.optional(),
  manualCost: GI,
  depreciation: Ole,
  notes: v().optional(),
  // Only set for the subject. Site cost is derived for comps.
  siteCost: Te.optional()
}).partial(), Ble = M({
  version: ie(2),
  salesCompGridData: F_,
  costDataExtension: Fle,
  runCostExtension: $I.optional(),
  propertyType: xr.optional()
}), Hle = ga("version", [
  kle,
  Ble
]), En, Gle = (En = class {
  constructor(t) {
    Gs(this, "salesCompGridData");
    Gs(this, "costDataExtension");
    Gs(this, "runCostExtension");
    Gs(this, "propertyType");
    this.salesCompGridData = t.salesCompGridData, this.costDataExtension = t.costDataExtension, this.runCostExtension = t.runCostExtension, this.propertyType = t.propertyType;
  }
  equals(t) {
    return t instanceof En ? h1.isEqual(this.salesCompGridData, t.salesCompGridData) && h1.isEqual(this.costDataExtension, t.costDataExtension) && h1.isEqual(this.runCostExtension, t.runCostExtension) && h1.isEqual(this.propertyType, t.propertyType) : !1;
  }
  // NOTE: toJSON() and schema.parse() should be inverses of each other! (modulo upgrades)
  toJSON() {
    return {
      version: En.LATEST_VERSION,
      salesCompGridData: this.salesCompGridData,
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    };
  }
  static empty() {
    return new En({
      salesCompGridData: { encoding: "UAD_2022", annotations: {} },
      costDataExtension: {},
      runCostExtension: void 0,
      propertyType: void 0
    });
  }
  static fromSalesCompGridData(t, n) {
    return new En({
      salesCompGridData: t,
      costDataExtension: {},
      runCostExtension: void 0,
      propertyType: n
    });
  }
  static fromPublicRecord(t, n) {
    let r = new En({
      propertyType: n,
      salesCompGridData: {
        encoding: "UAD_2022",
        annotations: {
          PropertyCity: t.PropertyAddressCity ?? void 0,
          PropertyState: t.PropertyAddressState ?? void 0,
          PropertyPostalCode: t.PropertyAddressZIP ?? void 0,
          PropertyStreetAddress: t.PropertyAddressFull ?? void 0,
          View: t.ViewDescription ?? void 0,
          DesignStyle: t.StructureStyle ?? void 0
        }
      },
      costDataExtension: {
        attachedOrBuiltinGarage: {
          totalSqft: t.ParkingGarageArea ?? void 0
        },
        carport: {
          totalSqft: t.ParkingCarportArea ?? void 0
        },
        deck: {
          totalSqft: t.DeckArea ?? void 0
        },
        coveredPatioOrGazebo: {
          totalSqft: t.PatioArea ?? void 0
        },
        attic: {
          totalSqft: t.RoomsAtticArea ?? void 0
        },
        adu: {
          gla: t.GuestHouseArea ?? void 0
        },
        shed: {
          totalSqft: t.ShedArea ?? void 0
        },
        pool: {
          totalSqft: t.PoolArea ?? void 0
        }
      },
      runCostExtension: void 0
    });
    const o = t.RoomsBasementArea ?? t.RoomsBasementAreaFinished ?? void 0, a = t.StoriesCount, s = t.YearBuilt, l = t.ParkingSpaceCount;
    return r = r.updateStructuredData("siteArea", t.AreaLotSF ?? void 0).updateStructuredData("gla", t.AreaBuilding ?? void 0).updateStructuredData("bedroomCount", du(t.BedroomsCount)).updateStructuredData("bathroomCount", {
      fullBaths: du(t.BathCount),
      halfBaths: du(t.BathPartialCount)
    }).updateStructuredData("basementLine1", {
      total: o,
      finished: t.RoomsBasementAreaFinished ?? void 0
    }), l !== null && (r = r.updateStructuredData("carStorage", {
      attachedGarageSpaces: t.ParkingGarage ? f5(t.ParkingSpaceCount) : void 0,
      carportSpaces: t.ParkingCarport ? f5(t.ParkingSpaceCount) : void 0
    })), a !== null && (r = r.updateStructuredData("designStyle", {
      stories: a
    })), s !== null && (r = r.updateStructuredData("actualAge", {
      age: xe.parse((/* @__PURE__ */ new Date()).getFullYear() - s)
    })), r;
  }
  static fromMLSData(t, n) {
    var C, y, _, x, I;
    const { listingID: r, mls: o } = s_((0, Lu.expected)(t.ToolkitListingID)), a = new En({
      propertyType: n,
      salesCompGridData: {
        encoding: "UAD_2022",
        annotations: {
          PropertyCity: t.City ?? void 0,
          PropertyState: t.StateOrProvince ?? void 0,
          PropertyPostalCode: t.PostalCode ?? void 0,
          PropertyStreetAddress: t.UnparsedAddress ?? void 0,
          View: ((C = t.View) == null ? void 0 : C.join(" ")) ?? void 0,
          PorchDeck: ((y = t.PatioAndPorchFeatures) == null ? void 0 : y.join(" ")) ?? void 0,
          LatitudeNumber: (_ = t.Latitude) == null ? void 0 : _.toString(),
          LongitudeNumber: (x = t.Longitude) == null ? void 0 : x.toString()
        }
      },
      costDataExtension: {},
      runCostExtension: void 0
    }), s = du(vle(t)), l = du(mle(t)), c = (0, Lu.isDefined)(l) || (0, Lu.isDefined)(s), d = ple(t), f = d == null ? void 0 : d.getMonth(), h = d == null ? void 0 : d.getYear(), m = f !== void 0 && h !== void 0 ? _r.parse(`${h}-${f < 10 ? "0" : ""}${f}`) : void 0, g = ule(t.StandardStatus);
    let b = a.updateStructuredData("dataSource", { mls: o, listingID: r }).updateStructuredData("designStyle", {
      stories: t.StoriesTotal,
      style: (I = t.ArchitecturalStyle) == null ? void 0 : I.join(" ")
    }).updateStructuredData(
      "salePrice",
      t.ClosePrice ? jt.fromNumericPrice(t.ClosePrice) : jt.fromNumericPrice(t.ListPrice)
    ).updateStructuredData("siteArea", lle(t)).updateStructuredData(
      "gla",
      t.LivingArea ? xt.fromNumber(t.LivingArea, "sqft") : void 0
    ).updateStructuredData("bedroomCount", du(t.BedroomsTotal)).updateStructuredData("actualAge", {
      age: t.YearBuilt ? xe.parse((/* @__PURE__ */ new Date()).getFullYear() - t.YearBuilt) : void 0
    });
    return c && (b = b.updateStructuredData("bathroomCount", {
      fullBaths: l,
      halfBaths: s
    })), t.GarageSpaces && (b = b.updateStructuredData("carStorage", {
      attachedGarageSpaces: f5(t.GarageSpaces)
    })), g && (b = b.updateStructuredData("status", {
      listingStatus: g,
      contractMonth: m,
      closeMonth: d5(t.CloseDate),
      expirationMonth: d5(t.ExpirationDate),
      withdrawalMonth: d5(t.WithdrawnDate)
    })), b;
  }
  /**
   * Pulls the property data from that and overlays it on top of the current
   * tkv2 property. Does not support merging runCostExtension today.
   * Remember: That overrides this where both values are available!
   */
  mergeWith(t) {
    return new En({
      salesCompGridData: {
        encoding: t.salesCompGridData.encoding ?? this.salesCompGridData.encoding,
        annotations: {
          // These are simply strings so spreading is valid here
          ...this.salesCompGridData.annotations,
          ...t.salesCompGridData.annotations,
          Age: aa("actualAge", this, t),
          GrossLivingArea: aa("gla", this, t),
          TotalBedroomCount: aa("bedroomCount", this, t),
          TotalBathroomCount: aa("bathroomCount", this, t),
          BasementArea: aa("basementLine1", this, t),
          BasementFinish: aa("basementLine2", this, t),
          CarStorage: aa("carStorage", this, t),
          DesignStyle: aa("designStyle", this, t),
          PropertySalesAmount: aa("salePrice", this, t),
          SiteArea: aa("siteArea", this, t),
          DateOfSale: aa("status", this, t)
        }
      },
      costDataExtension: {
        primaryDwelling: {
          ...this.costDataExtension.primaryDwelling,
          ...t.costDataExtension.primaryDwelling
        },
        adu: {
          ...this.costDataExtension.adu,
          ...t.costDataExtension.adu
        },
        basement: {
          ...this.costDataExtension.basement,
          ...t.costDataExtension.basement
        },
        attic: {
          ...this.costDataExtension.attic,
          ...t.costDataExtension.attic
        },
        attachedOrBuiltinGarage: {
          ...this.costDataExtension.attachedOrBuiltinGarage,
          ...t.costDataExtension.attachedOrBuiltinGarage
        },
        detachedGarage: {
          ...this.costDataExtension.detachedGarage,
          ...t.costDataExtension.detachedGarage
        },
        carport: {
          ...this.costDataExtension.carport,
          ...t.costDataExtension.carport
        },
        deck: {
          ...this.costDataExtension.deck,
          ...t.costDataExtension.deck
        },
        coveredPatioOrGazebo: {
          ...this.costDataExtension.coveredPatioOrGazebo,
          ...t.costDataExtension.coveredPatioOrGazebo
        },
        enclosedPatio: {
          ...this.costDataExtension.enclosedPatio,
          ...t.costDataExtension.enclosedPatio
        },
        pool: {
          ...this.costDataExtension.pool,
          ...t.costDataExtension.pool
        },
        shed: {
          ...this.costDataExtension.shed,
          ...t.costDataExtension.shed
        },
        workshop: {
          ...this.costDataExtension.workshop,
          ...t.costDataExtension.workshop
        },
        bonusRoom: {
          ...this.costDataExtension.bonusRoom,
          ...t.costDataExtension.bonusRoom
        },
        barn: {
          ...this.costDataExtension.barn,
          ...t.costDataExtension.barn
        },
        manufactured: {
          ...this.costDataExtension.manufactured,
          ...t.costDataExtension.manufactured
        },
        depreciation: {
          ...this.costDataExtension.depreciation,
          ...t.costDataExtension.depreciation
        },
        manualCost: {
          ...this.costDataExtension.manualCost,
          ...t.costDataExtension.manualCost
        },
        siteCost: t.costDataExtension.siteCost ?? this.costDataExtension.siteCost,
        notes: t.costDataExtension.notes ?? this.costDataExtension.notes
      },
      runCostExtension: t.runCostExtension ?? this.runCostExtension,
      propertyType: t.propertyType ?? this.propertyType
    });
  }
  /**
   * Returns an updated version of the current Tkv2Property by copying
   * everything from the given property that is allowed to be updated directly
   * via the API.
   */
  updateAPIWritable(t) {
    return new En({
      salesCompGridData: t.salesCompGridData,
      costDataExtension: t.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: t.propertyType
    });
  }
  getGridField(t) {
    const { encoding: n } = this.salesCompGridData;
    if (n !== "UAD_2022")
      throw Error(`Cannot get UAD field for property with encoding: ${n}`);
    return this.salesCompGridData.annotations[t];
  }
  /**
   * Returns a new Tkv2Property with one field updated. Original property is
   * unchanged.
   */
  updateGridField(t, n) {
    const { encoding: r } = this.salesCompGridData;
    if (r !== "UAD_2022")
      throw Error(`Cannot set UAD field for property with encoding: ${r}`);
    return new En({
      salesCompGridData: {
        ...this.salesCompGridData,
        annotations: {
          ...this.salesCompGridData.annotations,
          [t]: n
        }
      },
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  getAdjustment(t) {
    var r;
    const { encoding: n } = this.salesCompGridData;
    if (n !== "UAD_2022")
      throw Error(`Cannot get UAD adjustment for property with encoding: ${n}`);
    return (r = this.salesCompGridData.adjustments) == null ? void 0 : r[t];
  }
  /**
   * Returns a new Tkv2Property with one adjustment updated. Original property is
   * unchanged.
   */
  updateAdjustment(t, n) {
    const { encoding: r } = this.salesCompGridData;
    if (r !== "UAD_2022")
      throw Error(`Cannot set UAD adjustment for property with encoding: ${r}`);
    return new En({
      salesCompGridData: {
        ...this.salesCompGridData,
        adjustments: {
          ...this.salesCompGridData.adjustments,
          [t]: n
        }
      },
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  getStructuredData(t) {
    return Ile(t, this.salesCompGridData);
  }
  /**
   * Returns a new Tkv2Property with updated structured data. Original
   * property is unchanged
   */
  updateStructuredData(t, n) {
    const r = wle(t, n, this.salesCompGridData);
    return new En({
      salesCompGridData: r,
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  /** get SalesCompGridData */
  getSalesCompGridData() {
    return this.salesCompGridData;
  }
  /** Update SalesCompGridData */
  updateSalesCompGridData(t) {
    return new En({
      salesCompGridData: t,
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  getEditableCostData() {
    var n, r, o, a, s, l, c, d, f, h, m, g, b, C, y, _, x, I, R, E, k, N, P, F, G, j, ae, ue, le, _e, ve, z, K;
    const t = this.costDataExtension;
    return {
      primaryDwelling: {
        quality: qs((n = t.primaryDwelling) == null ? void 0 : n.quality),
        nonStandardGLA: (r = t.primaryDwelling) == null ? void 0 : r.nonStandardGla,
        multiUnitCount: (o = t.primaryDwelling) == null ? void 0 : o.multiUnitCount
      },
      basement: {
        quality: qs((a = t.basement) == null ? void 0 : a.quality)
      },
      attic: {
        quality: qs((s = t.attic) == null ? void 0 : s.quality),
        totalSqft: (l = t.attic) == null ? void 0 : l.totalSqft
      },
      attachedOrBuiltinGarage: Zs(t.attachedOrBuiltinGarage),
      detachedGarage: Zs(t.detachedGarage),
      carport: Zs(t.carport),
      deck: Zs(t.deck),
      coveredPatioOrGazebo: Zs(t.coveredPatioOrGazebo),
      enclosedPatio: {
        ...Zs(t.enclosedPatio),
        linearFootage: gt.fromNumber((c = t.enclosedPatio) == null ? void 0 : c.linearFootage)
      },
      pool: Zs(t.pool),
      adu: {
        bathroomsFull: gt.fromNumber((d = t.adu) == null ? void 0 : d.bathroomsFull),
        bathroomsHalf: gt.fromNumber((f = t.adu) == null ? void 0 : f.bathroomsHalf),
        stories: (h = t.adu) == null ? void 0 : h.stories,
        gla: (m = t.adu) == null ? void 0 : m.gla,
        quality: qs((g = t.adu) == null ? void 0 : g.dwellingCostQuality)
      },
      shed: o2(t.shed),
      workshop: o2(t.workshop),
      bonusRoom: o2(t.bonusRoom),
      barn: {
        ...o2(t.barn),
        isPoleBarn: (b = t.barn) == null ? void 0 : b.isPoleBarn,
        hasExteriorWall: (C = t.barn) == null ? void 0 : C.hasExteriorWall
      },
      manufactured: {
        sections: gt.fromNumber((y = t.manufactured) == null ? void 0 : y.sections),
        gla: (_ = t.manufactured) == null ? void 0 : _.gla,
        bathroomsFull: gt.fromNumber((x = t.manufactured) == null ? void 0 : x.bathroomsFull),
        bathroomsHalf: gt.fromNumber((I = t.manufactured) == null ? void 0 : I.bathroomsHalf),
        quality: qs((R = t.manufactured) == null ? void 0 : R.dwellingCostQuality),
        hasAC: (E = t.manufactured) == null ? void 0 : E.hasAC,
        hasClimatePkg: (k = t.manufactured) == null ? void 0 : k.hasClimatePkg,
        foundationType: (N = t.manufactured) == null ? void 0 : N.foundationType,
        fireplaces: gt.fromNumber((F = (P = t.manufactured) == null ? void 0 : P.fireplaces) == null ? void 0 : F.totalCount),
        fireplaceType: (j = (G = t.manufactured) == null ? void 0 : G.fireplaces) == null ? void 0 : j.type,
        deliveryMileage: gt.fromNumber((ae = t.manufactured) == null ? void 0 : ae.deliveryMileage)
      },
      depreciation: {
        physicalDepreciation: ((ue = t.depreciation) == null ? void 0 : ue.physicalDepreciation) ?? {},
        functionalObsolescence: ((le = t.depreciation) == null ? void 0 : le.functionalObsolescence) ?? {},
        externalDepreciation: ((_e = t.depreciation) == null ? void 0 : _e.externalDepreciation) ?? {}
      },
      manualCost: {
        label: (ve = t.manualCost) == null ? void 0 : ve.label,
        feature: (z = t.manualCost) == null ? void 0 : z.feature,
        cost: (K = t.manualCost) == null ? void 0 : K.cost
      }
    };
  }
  updateEditableCostData(t) {
    var r, o, a, s, l, c, d, f, h, m, g, b, C, y, _, x, I, R, E, k, N, P, F, G, j, ae, ue, le, _e;
    const n = {
      ...this.costDataExtension,
      primaryDwelling: {
        quality: Js(t.primaryDwelling.quality),
        nonStandardGla: t.primaryDwelling.nonStandardGLA,
        multiUnitCount: t.primaryDwelling.multiUnitCount
      },
      basement: {
        quality: Js(t.basement.quality)
      },
      attic: {
        quality: Js(t.attic.quality),
        totalSqft: t.attic.totalSqft
      },
      attachedOrBuiltinGarage: js(t.attachedOrBuiltinGarage),
      detachedGarage: js(t.detachedGarage),
      carport: js(t.carport),
      deck: js(t.deck),
      coveredPatioOrGazebo: js(t.coveredPatioOrGazebo),
      enclosedPatio: {
        ...js(t.enclosedPatio),
        linearFootage: xe.optional().parse((r = t.enclosedPatio.linearFootage) == null ? void 0 : r.toNumber())
      },
      pool: js(t.pool),
      adu: {
        bathroomsFull: xe.optional().parse((a = (o = t.adu) == null ? void 0 : o.bathroomsFull) == null ? void 0 : a.toNumber()),
        bathroomsHalf: xe.optional().parse((l = (s = t.adu) == null ? void 0 : s.bathroomsHalf) == null ? void 0 : l.toNumber()),
        stories: (c = t.adu) == null ? void 0 : c.stories,
        gla: (d = t.adu) == null ? void 0 : d.gla,
        dwellingCostQuality: Js((f = t.adu) == null ? void 0 : f.quality)
      },
      shed: a2(t.shed),
      workshop: a2(t.workshop),
      bonusRoom: a2(t.bonusRoom),
      barn: {
        ...a2(t.barn),
        isPoleBarn: (h = t.barn) == null ? void 0 : h.isPoleBarn,
        hasExteriorWall: (m = t.barn) == null ? void 0 : m.hasExteriorWall
      },
      manufactured: {
        sections: (b = (g = t.manufactured) == null ? void 0 : g.sections) == null ? void 0 : b.toNumber(),
        gla: (C = t.manufactured) == null ? void 0 : C.gla,
        bathroomsFull: xe.optional().parse((_ = (y = t.manufactured) == null ? void 0 : y.bathroomsFull) == null ? void 0 : _.toNumber()),
        bathroomsHalf: xe.optional().parse((I = (x = t.manufactured) == null ? void 0 : x.bathroomsHalf) == null ? void 0 : I.toNumber()),
        dwellingCostQuality: Js((R = t.manufactured) == null ? void 0 : R.quality),
        hasAC: (E = t.manufactured) == null ? void 0 : E.hasAC,
        hasClimatePkg: (k = t.manufactured) == null ? void 0 : k.hasClimatePkg,
        foundationType: _I.optional().parse((N = t.manufactured) == null ? void 0 : N.foundationType),
        fireplaces: t9.shape.fireplaces.parse({
          totalCount: xe.optional().parse((F = (P = t.manufactured) == null ? void 0 : P.fireplaces) == null ? void 0 : F.toNumber()),
          type: (G = t.manufactured) == null ? void 0 : G.fireplaceType
        }),
        deliveryMileage: xe.optional().parse((ae = (j = t.manufactured) == null ? void 0 : j.deliveryMileage) == null ? void 0 : ae.toNumber())
      },
      depreciation: {
        physicalDepreciation: (ue = t.depreciation) == null ? void 0 : ue.physicalDepreciation,
        functionalObsolescence: (le = t.depreciation) == null ? void 0 : le.functionalObsolescence,
        externalDepreciation: (_e = t.depreciation) == null ? void 0 : _e.externalDepreciation
      }
    };
    return new En({
      salesCompGridData: this.salesCompGridData,
      costDataExtension: n,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  getCostPerSqft(t) {
    var n, r;
    return (r = (n = this._getRunCostExtension()) == null ? void 0 : n.output[t]) == null ? void 0 : r.costPerSqft;
  }
  getDwellingCostQuality(t) {
    var n;
    return (n = this.getEditableCostData()[t]) == null ? void 0 : n.quality;
  }
  /** INTERNAL */
  _getRunCostExtension() {
    return this.runCostExtension;
  }
  /** INTERNAL */
  _updateRunCostExtension(t) {
    return new En({
      salesCompGridData: this.salesCompGridData,
      costDataExtension: this.costDataExtension,
      runCostExtension: t,
      propertyType: this.propertyType
    });
  }
  /** INTERNAL */
  _getCostDataExtension() {
    return this.costDataExtension;
  }
  getPropertyType() {
    return this.propertyType;
  }
  getReplacementCostFields() {
    return _le(this);
  }
  getCostDataInput(t) {
    var c, d, f;
    const n = this.getEditableCostData(), r = this.getStructuredData("bedroomCount"), o = this.getStructuredData("bathroomCount"), a = this.getStructuredData("basementLine2"), s = this.getStructuredData("carStorage"), l = this.getPropertyType();
    return {
      ...n,
      address: this.getGridField("PropertyStreetAddress") ?? "",
      effectiveDate: t,
      zip: this.getGridField("PropertyPostalCode") ?? "",
      primaryDwelling: l === "manufacturedHome" ? {} : {
        ...n.primaryDwelling,
        bedrooms: gt.fromNumber(r),
        bathroomsFull: gt.addWithNulls(
          gt.fromNumber(o == null ? void 0 : o.fullBaths),
          gt.fromNumber(a == null ? void 0 : a.fullBathCount)
        ) ?? void 0,
        bathroomsHalf: gt.addWithNulls(
          gt.fromNumber(o == null ? void 0 : o.halfBaths),
          gt.fromNumber(a == null ? void 0 : a.halfBathCount)
        ) ?? void 0,
        stories: (c = this.getStructuredData("designStyle")) == null ? void 0 : c.stories,
        gla: this.getStructuredData("gla")
      },
      manufactured: l === "manufacturedHome" ? {
        ...n.manufactured,
        bathroomsFull: gt.addWithNulls(
          gt.fromNumber(o == null ? void 0 : o.fullBaths),
          gt.fromNumber(a == null ? void 0 : a.fullBathCount)
        ) ?? void 0,
        bathroomsHalf: gt.addWithNulls(
          gt.fromNumber(o == null ? void 0 : o.halfBaths),
          gt.fromNumber(a == null ? void 0 : a.halfBathCount)
        ) ?? void 0
      } : n.manufactured,
      basement: {
        ...n.basement,
        totalSqft: (d = this.getStructuredData("basementLine1")) == null ? void 0 : d.total,
        finishedSqft: (f = this.getStructuredData("basementLine1")) == null ? void 0 : f.finished
      },
      attachedOrBuiltinGarage: {
        ...n.attachedOrBuiltinGarage,
        attachedSpaceCount: i2(s == null ? void 0 : s.attachedGarageSpaces),
        builtinSpaceCount: i2(s == null ? void 0 : s.builtInGarageSpaces)
      },
      detachedGarage: {
        ...n.detachedGarage,
        spaceCount: i2(s == null ? void 0 : s.detachedGarageSpaces)
      },
      carport: {
        ...n.carport,
        spaceCount: i2(s == null ? void 0 : s.carportSpaces)
      }
    };
  }
  getBathroomCosts() {
    var t;
    return (t = this.runCostExtension) == null ? void 0 : t.bathroomCosts;
  }
  getBathroomCounts() {
    const t = this.getStructuredData("bathroomCount"), n = this.getStructuredData("basementLine2");
    return {
      aboveGrade: {
        fullBaths: (t == null ? void 0 : t.fullBaths) ?? xe.parse(0),
        halfBaths: (t == null ? void 0 : t.halfBaths) ?? xe.parse(0)
      },
      belowGrade: {
        fullBaths: (n == null ? void 0 : n.fullBathCount) ?? xe.parse(0),
        halfBaths: (n == null ? void 0 : n.halfBathCount) ?? xe.parse(0)
      }
    };
  }
  getGarageStallCount() {
    const t = this.getStructuredData("carStorage");
    return (0, Lu.isUndefined)(t) ? 0 : (t.attachedGarageSpaces ?? 0) + (t.builtInGarageSpaces ?? 0) + (t.detachedGarageSpaces ?? 0) + (t.carportSpaces ?? 0);
  }
}, Gs(En, "LATEST_VERSION", 2), Gs(En, "schema", ac(
  zt([Hle, hh((t) => t instanceof En)]).transform(
    (t) => t instanceof En ? t : new En(Ele(t))
  )
)), En), vs = Gle.schema;
function Zs(e) {
  return e === void 0 ? {} : {
    quality: qs(e.quality),
    totalSqft: e.totalSqft
  };
}
function js(e) {
  return {
    quality: Js(e.quality),
    totalSqft: e.totalSqft
  };
}
function o2(e) {
  return {
    totalSqft: e == null ? void 0 : e.totalSqft,
    percentInteriorFinished: e == null ? void 0 : e.percentInteriorFinished,
    electrical: e == null ? void 0 : e.electrical,
    subpanel: e == null ? void 0 : e.subpanel,
    plumbingFixturesCount: gt.fromNumber(e == null ? void 0 : e.plumbingFixturesCount),
    quality: qs(e == null ? void 0 : e.dwellingCostQuality)
  };
}
function a2(e) {
  var t;
  return {
    totalSqft: e.totalSqft,
    percentInteriorFinished: e.percentInteriorFinished,
    electrical: e.electrical,
    subpanel: e.subpanel,
    plumbingFixturesCount: xe.optional().parse((t = e.plumbingFixturesCount) == null ? void 0 : t.toNumber()),
    dwellingCostQuality: Js(e.quality)
  };
}
function qs(e) {
  if (e !== void 0)
    return `${e}`;
}
function Js(e) {
  if (e === void 0)
    return;
  const t = e.match(/^([.0-9]+)$/);
  if (t === null)
    throw new Pt(`cannot parse quality: ${e}`);
  return xs.parse(parseFloat((0, Lu.expected)(t[1])));
}
function i2(e) {
  if (!(0, Lu.isUndefined)(e))
    return gt.fromNumber(Math.floor(e));
}
function du(e) {
  if (e == null)
    return;
  const t = xe.safeParse(e);
  if (t.success)
    return t.data;
  console.warn(`Expected integer but received: ${e}`);
}
function f5(e) {
  try {
    return kr.parse(e);
  } catch {
    return;
  }
}
var VC = zt([
  M({
    status: ie("found"),
    output: bd
  }),
  M({
    status: ie("not_found"),
    output: M({
      searchCriteria: Va.optional()
    }).optional()
  }),
  M({
    status: ie("error"),
    message: v(),
    output: M({
      searchCriteria: Va.optional()
    }).optional()
  })
]), $le = zt([
  M({
    status: ie("found"),
    output: M({
      results: ne(aI),
      resultsCount: L(),
      searchCriteria: Va.optional()
    })
  }),
  M({
    status: ie("not_found"),
    output: M({
      searchCriteria: Va.optional()
    }).optional()
  }),
  M({
    status: ie("error"),
    message: v(),
    output: M({
      searchCriteria: Va
    }).optional()
  })
]), Zle = zt([
  M({
    version: ie(2),
    source: ie("constellation1"),
    input: gi(),
    body: VC
  }),
  M({
    version: ie(2),
    source: ie("z"),
    input: gi(),
    body: $le
  }),
  M({
    version: ie(2),
    source: ie("abode"),
    input: gi(),
    body: VC
  })
]), jle = Zle;
be(["constellation1", "z", "abode"]);
var Wle = zt([
  M({
    status: ie("found"),
    output: bd
  }),
  M({
    status: ie("not_found"),
    output: M({
      searchCriteria: Va.optional()
    }).optional()
  }),
  M({
    status: ie("error"),
    message: v(),
    output: M({
      searchCriteria: Va.optional()
    }).optional()
  })
]), zle = zt([
  M({
    version: ie(1),
    source: ie("abode"),
    input: gi(),
    body: Wle
  }),
  M({
    version: ie(1),
    source: Ou(),
    input: gi(),
    body: Ou()
  })
]), Ule = zle, Xle = zt([
  M({
    status: ie("found"),
    output: bd
  }),
  M({
    status: ie("not_found")
  }),
  M({
    status: ie("error"),
    message: v()
  })
]), Yle = M({
  version: ie(1),
  source: eI,
  input: gi(),
  body: Xle
}), k2 = M({
  copyPrimaryDwellingQualityToOthers: Y(),
  uadQualityMapping: M({
    q1: L(),
    q2: L(),
    q3: L(),
    q4: L(),
    q5: L(),
    q6: L()
  }),
  garageCarportAreaPerStall: xt.schema
}), qle = M({
  featureOneName: v().optional(),
  featureTwoName: v().optional(),
  featureThreeName: v().optional()
}), Jle = M({
  dismissedAlerts: ne(Dh)
}), Kle = M({
  version: ie(1),
  pageTimeMs: mn(v(), L())
}), Qle = M(
  Object.fromEntries(Dh.options.map((e) => [e, v()]))
).partial(), eue = ["Zip Code", "City", "County"], tue = be(
  eue
), nue = ["Shortage", "In Balance", "Over Supply"], rue = be(nue), oue = [
  "Less than 30 days",
  "30 - 60 days",
  "60 - 90 days",
  "90 - 120 days",
  "120 - 150 days",
  "150 - 180 days",
  "More than 180 days"
], aue = be(oue), iue = M({
  commentary: v().optional(),
  filter: M({
    type: tue.default("Zip Code"),
    value: v().optional()
  }),
  estimatedDemandSupply: rue.default("Shortage"),
  estimatedExposureTime: aue.default("Less than 30 days")
  // data: z.object({}), // TODO: shape?
}), sue = M({
  commentary: v()
}).partial(), lue = M({
  commentary: v()
}).partial(), uue = M({
  glaCommentary: v(),
  bathCommentary: v(),
  basementCommentary: v(),
  qualityCommentary: v(),
  conditionCommentary: v(),
  garageCarportCommentary: v(),
  porchPatioDeckCommentary: v(),
  aduCommentary: v(),
  poolCommentary: v(),
  shedCommentary: v()
}).partial(), cue = M({
  totalCostToCureCommentary: v(),
  reconciliationCommentary: v(),
  highestAndBestUseCommentary: v(),
  certificationCommentary: v(),
  revisionCommentary: v(),
  alternativeComparablesCommentary: ne(v()),
  roiCommentary: v(),
  feasibilityCommentary: v()
}).partial(), ZI = M({
  alerts: Qle.optional(),
  depreciatedCost: uue,
  marketConditionsV2: iue,
  priorSales: sue,
  reconciliation: cue,
  siteExtraction: lue,
  /** @deprecated */
  isMarketConditionsCommentaryOmit: Y(),
  /** @deprecated */
  marketConditions: v(),
  /** @deprecated */
  isSiteCommentaryOmit: Y(),
  /** @deprecated */
  siteAdjustments: v(),
  /** @deprecated */
  isImprovementsCommentaryOmit: Y(),
  /** @deprecated */
  improvementsAdjustments: v(),
  /** @deprecated */
  isGlaCommentaryOmit: Y(),
  /** @deprecated */
  glaAdjustment: v(),
  /** @deprecated */
  isQualityCommentaryOmit: Y(),
  /** @deprecated */
  qualityAdjustment: v(),
  /** @deprecated */
  isConditionCommentaryOmit: Y(),
  /** @deprecated */
  conditionAdjustment: v(),
  /** @deprecated */
  isAtticCommentaryOmit: Y(),
  /** @deprecated */
  atticAdjustment: v(),
  /** @deprecated */
  isBasementCommentaryOmit: Y(),
  /** @deprecated */
  basementAdjustment: v(),
  /** @deprecated */
  isBelowGradeCommentaryOmit: Y(),
  /** @deprecated */
  belowGradeAdjustment: v(),
  /** @deprecated */
  isParkingCommentaryOmit: Y(),
  /** @deprecated */
  parkingAdjustment: v(),
  /** @deprecated */
  isPatioDeckCommentaryOmit: Y(),
  /** @deprecated */
  patioDeckAdjustment: v(),
  /** @deprecated */
  isPoolCommentaryOmit: Y(),
  /** @deprecated */
  poolAdjustment: v(),
  /** @deprecated */
  isGuestHouseCommentaryOmit: Y(),
  /** @deprecated */
  guestHouseAdjustment: v(),
  /** @deprecated */
  isShedCommentaryOmit: Y(),
  /** @deprecated */
  shedAdjustment: v(),
  /** @deprecated */
  isWorkshopCommentaryOmit: Y(),
  /** @deprecated */
  workshopAdjustment: v(),
  /** @deprecated */
  isBonusRoomCommentaryOmit: Y(),
  /** @deprecated */
  bonusRoomAdjustment: v(),
  /** @deprecated */
  isBarnCommentaryOmit: Y(),
  /** @deprecated */
  barnAdjustment: v(),
  /** @deprecated */
  isManufacturedDwellingCommentaryOmit: Y(),
  /** @deprecated */
  manufacturedDwellingAdjustment: v(),
  /** @deprecated */
  isManualCostCommentaryOmit: Y(),
  /** @deprecated */
  manualCostAdjustment: v(),
  /** @deprecated */
  isCostApproachCommentaryOmit: Y(),
  /** @deprecated */
  costApproach: v()
}).partial();
ZI.pick({
  marketConditionsV2: !0,
  priorSales: !0,
  siteExtraction: !0,
  depreciatedCost: !0,
  reconciliation: !0,
  alerts: !0
});
var due = M({
  sequence: ne(v())
}), fue = M({
  propertyID: v(),
  imageURLs: v().array(),
  result: mI
}), n9 = be([
  "zip",
  "state",
  "county",
  "city",
  "mls_source"
]), hue = M({
  month: v(),
  geo_type: n9,
  geo_id: v(),
  total_comparable_sales: L().nullable(),
  total_active_properties: L().nullable().optional(),
  absorption_rate: L().nullable(),
  months_supply: L().nullable(),
  median_days_on_market: L().nullable(),
  median_sale_price: Te.nullable(),
  median_list_price: Te.nullable().optional()
}), jI = M({
  geoType: n9,
  geoId: v(),
  monthlyData: ne(hue)
}), WI = M({
  t: ie("percent"),
  value: L()
}), H3 = M({
  source: ie("customPrice"),
  adjustmentAmount: Te
}), pue = M({
  source: ie("customRate"),
  adjustmentAmount: Te,
  adjustmentSource: WI
}), mue = M({
  source: ie("customListToSale"),
  adjustmentAmount: Te,
  adjustmentPercent: WI
}), gue = ga("source", [
  H3,
  mue,
  pue
]), vue = Ot({
  termsOfSale: H3,
  concessions: H3,
  dateOfSale: gue
}).partial(), Cue = M({
  zip: v(),
  analysisPeriodMonths: zt([ie(6), ie(12), ie(24)]),
  trends: ne(
    M({
      data: fI,
      timestamp: An
    })
  )
}), bue = M({
  zip: v(),
  analysisPeriodMonths: zt([ie(6), ie(12), ie(24)]),
  trends: ne(
    M({
      data: fI,
      timestamp: An
    })
  )
}), yue = M({
  year: L(),
  month: L(),
  typicalHomeValue: Te
}), Sue = M({
  analysisPeriodMonths: zt([ie(6), ie(12), ie(24)]),
  trends: ne(yue)
}), Aue = M({
  series: Sse,
  using: be(["p50closeprice", "p50closepricepersqft"])
  // subset of series.data keys
}), Mue = M({
  zillow: Cue,
  mlsData: bue,
  marketTrends: Aue,
  customRate: M({
    rate: L()
  }),
  customAvgPricePerMonth: Sue
}).partial(), xue = M({
  customRatio: M({
    ratio: L()
  })
}).partial(), _ue = M({
  dateOfSaleAdjustment: M({
    selectedMethod: be([
      "zillow",
      "mlsData",
      "marketTrends",
      "customRate",
      "customAvgPricePerMonth"
    ]),
    methods: Mue
  }).partial(),
  listToSaleAdjustment: M({
    selectedMethod: be(["customRatio"]),
    methods: xue
  }).partial().optional(),
  marketAggregateData: ne(jI).optional()
}), Iue = M({
  version: ie(1),
  // compID mapping to adjustment info
  comps: mn(vue).optional(),
  cachedState: _ue
}), wue = ne(J4), Lue = mn(v(), wue), Rue = M({
  version: ie(1),
  priorSales: Lue
}), Eue = be(["as-is", "subject-to"]), Due = M({
  includeTotalCostToCure: Y().default(!0),
  totalCostToCure: Nn.optional(),
  opinionOfMarketValue: Nn.optional(),
  includeOpinionOfAfterRepairValue: Y().default(!1),
  opinionOfAfterRepairValue: Nn.optional(),
  totalRenovationBudget: Nn.optional(),
  includeTotalRenovationBudget: Y().default(!1),
  allowSubjectToValue: Y().default(!0),
  valueTypes: ne(Eue).default([])
}), Nue = M({
  sequence: ne(v())
}), Tue = M({
  id: v()
  // The S3 blob ID of the report PDF
}), Pue = M({
  signatureId: v(),
  // The S3 blob ID of the signature image
  stateSealId: v().optional()
  // The S3 blob ID of the state seal image, if applicable
}), kue = M({
  id: v()
}), Jn = {
  // Keep this alphabetized
  additionalFeatures: qle,
  alerts: Jle,
  analytics: Kle,
  commentary: ZI,
  comp: vs,
  compData: qu,
  compRecommendation: jle,
  compSequence: due,
  depreciationSettings: T2,
  depreciationSettingsV2: N2,
  imageAnalysis: fue,
  marketAdjustments: kse,
  marketConditions: Iue,
  orderFeatures: ole,
  pairedCostSettings: P2,
  priorSales: Rue,
  reconciliation: Due,
  rentalCompSequence: Nue,
  rentalCompRecommendation: Ule,
  replacementCostSettings: k2,
  report: Tue,
  signature: Pue,
  subject: vs,
  subjectData: Ju,
  vacantLandSales: Yle,
  xml: kue
}, Vue = (e) => e in Jn, Oue = M({
  id: v(),
  orderID: v(),
  type: v(),
  body: gn()
}).transform((e, t) => {
  if (!Vue(e.type))
    return t.addIssue({
      code: Me.invalid_enum_value,
      message: "Invalid attachment type",
      fatal: !0,
      received: e.type,
      options: Object.keys(Jn)
    }), gf;
  const n = Jn[e.type].safeParse(e.body);
  return n.success ? {
    id: e.id,
    orderID: e.orderID,
    type: e.type,
    body: n.data
  } : (t.addIssue({
    code: Me.invalid_union,
    message: `Invalid attachment body for ${e.type}`,
    fatal: !0,
    unionErrors: [n.error]
  }), gf);
}), OC = {}, Cn = (e) => {
  const t = OC[e] ?? Oue.refine((n) => n.type === e, {
    message: `Attachment is not of type ${e}`
  });
  return OC[e] = t, t;
};
M({
  content: mI
});
M({ orderID: In, propertyID: v() }), M({
  content: Cn("imageAnalysis")
});
var Fue = {};
pd(Fue, {
  ADDITIONAL_FEATURES: () => oce,
  ALERTS_API: () => ice,
  ANALYTICS: () => zue,
  COMMENTARY: () => lce,
  COMPS: () => Kue,
  COMP_DATA: () => Que,
  COMP_IMAGES: () => pce,
  COMP_PROPERTY_DATA: () => ece,
  COMP_RECOMMENDATION: () => dce,
  COMP_SEQUENCE: () => Uue,
  MARKET_ADJUSTMENTS: () => tce,
  MARKET_CONDITIONS: () => nce,
  ORDER_FEATURES_API: () => ace,
  PRIOR_SALES: () => sce,
  RECONCILIATION: () => uce,
  RENTAL_COMP_RECOMMENDATION: () => hce,
  RENTAL_COMP_SEQUENCE: () => Xue,
  REPORT: () => vce,
  REPORT_SIGNATURE: () => gce,
  SUBJECT: () => Yue,
  SUBJECT_DATA: () => que,
  SUBJECT_PROPERTY_DATA: () => Jue,
  VACANT_LAND_SALES: () => mce,
  XML: () => rce
});
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
var h5 = M({
  label: v(),
  value: v()
}), zI = M({
  address: md,
  age: xe,
  gla: ma,
  numberOfUnits: xe,
  fullBaths: xe,
  halfBaths: xe,
  basement: z4,
  garageSpaces: kr,
  carportSpaces: kr,
  status: ri.schUadListingStatus,
  foundation: X_,
  price: Nn,
  saleDate: _r,
  contractDate: _r,
  daysOnMarket: L(),
  latitude: L(),
  longitude: L(),
  mls: Rl,
  mlsListingID: v(),
  siteArea: ma,
  location: v(),
  view: v(),
  termsOfSale: B4,
  concessions: v(),
  quality: L(),
  condition: L(),
  propertyType: Ga,
  porchPatioDeck: v(),
  additionalFeature1: h5,
  additionalFeature2: h5,
  additionalFeature3: h5
}).partial(), qe = { orderID: In };
re(ce(), 1);
var Bue = M({
  sequence: ne(v()),
  comps: mn(vs)
}), Hue = M({
  comps: ne(vs)
}), Gue = M({
  sequence: ne(v()),
  comps: mn(vs)
}), $ue = M({
  id: v()
}), Zue = M({
  id: v()
}), FC = M({
  sequence: ne(v()),
  comps: mn(qu)
}), jue = M({
  comps: ne(qu)
}), Wue = be([
  "additionalFeatures",
  "alerts",
  "analytics",
  "commentary",
  "compRecommendation",
  "compSequence",
  "depreciationSettings",
  "depreciationSettingsV2",
  "marketAdjustments",
  "marketConditions",
  "orderFeatures",
  "pairedCostSettings",
  "priorSales",
  "reconciliation",
  "rentalCompRecommendation",
  "replacementCostSettings",
  "report",
  "signature",
  "subject",
  "subjectData",
  "vacantLandSales"
]);
Wue.options;
var zue = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Cn("analytics")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Jn.analytics
    },
    RESPONSE: Cn("analytics")
  }
}, Uue = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Cn("compSequence")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Jn.compSequence
    },
    RESPONSE: Cn("compSequence")
  }
}, Xue = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Cn("rentalCompSequence")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Jn.rentalCompSequence
    },
    RESPONSE: Cn("rentalCompSequence")
  }
}, Yue = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Cn("subject")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: vs
    },
    RESPONSE: Cn("subject")
  }
}, que = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Ju
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Q_
    },
    RESPONSE: Ju
  }
}, Jue = {
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Ju
    },
    RESPONSE: Ju
  }
}, Kue = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Bue
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Hue
    },
    RESPONSE: Gue
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M({
        ...qe,
        compID: v()
      }),
      BODY: vs
    },
    RESPONSE: vs
  }
}, Que = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: FC
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: jue
    },
    RESPONSE: FC
  }
}, ece = {
  PUT: {
    REQUEST: {
      PATH_PARAMS: M({
        ...qe,
        compID: v()
      }),
      BODY: qu
    },
    RESPONSE: qu
  }
}, tce = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Cn("marketAdjustments")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Jn.marketAdjustments
    },
    RESPONSE: Cn("marketAdjustments")
  }
}, nce = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Cn("marketConditions")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Jn.marketConditions
    },
    RESPONSE: Cn("marketConditions")
  }
}, rce = {
  POST: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: $ue
    },
    RESPONSE: Zue
  }
}, oce = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Cn("additionalFeatures")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Jn.additionalFeatures
    },
    RESPONSE: Cn("additionalFeatures")
  }
}, ace = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Cn("orderFeatures")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Jn.orderFeatures
    },
    RESPONSE: Cn("orderFeatures")
  }
}, ice = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Cn("alerts")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Jn.alerts
    },
    RESPONSE: Cn("alerts")
  }
}, sce = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Cn("priorSales")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Jn.priorSales
    },
    RESPONSE: Cn("priorSales")
  }
}, lce = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Cn("commentary")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Jn.commentary
    },
    RESPONSE: Cn("commentary")
  }
}, uce = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: Cn("reconciliation")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: Jn.reconciliation
    },
    RESPONSE: Cn("reconciliation")
  }
}, cce = M({
  body: Jn.compRecommendation
}), dce = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: M({
      body: Jn.compRecommendation
    })
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      QUERY_PARAMS: M({ source: be(["constellation1", "z", "abode"]) }),
      BODY: Va
    },
    RESPONSE: cce
  }
}, fce = M({
  body: Jn.rentalCompRecommendation
}), hce = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: M({
      body: Jn.rentalCompRecommendation
    })
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      QUERY_PARAMS: M({ source: be(["abode"]) }),
      BODY: Va
    },
    RESPONSE: fce
  }
}, pce = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M({ id: v() })
    },
    RESPONSE: M({ id: v(), images: ne(v()) })
  }
}, mce = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: M({ body: Jn.vacantLandSales })
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: M({ body: Jn.vacantLandSales })
  }
}, gce = {
  POST: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: M({
        signatureBlobId: v(),
        stateSealBlobId: v().optional(),
        storeSignatureBlobId: Y().optional().default(!1)
      })
    }
  }
}, vce = {
  GET: {
    REQUEST: {
      PATH_PARAMS: M(qe)
    },
    RESPONSE: M({
      body: Cn("report")
    })
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: M(qe),
      BODY: M({
        reportBlobId: v()
      })
    }
  }
}, Cce = {};
pd(Cce, {
  COORDINATES_FOR_ADDRESSES: () => bce
});
var bce = {
  GET: {
    REQUEST: {
      QUERY_PARAMS: M({
        addresses: ne(v())
      })
    },
    RESPONSE: ne(
      M({ address: v(), lat: L().optional(), lng: L().optional() })
    )
  }
}, yce = v(), Sce = M({
  listings: ne(J4),
  source: T_
});
Ll.extend({
  lookbackCutoff: yce.optional()
});
var Ace = v(), Mce = mn(Ace, L()), xce = mn(v(), L()), r9 = M({
  variable: ne(L())
}), _ce = M({
  fixed: ne(L())
}), Ii = qx(r9, _ce), Ice = M({
  sixCorners: Ii
}), wce = M({
  twoOrThreeUnits: Ii,
  fourToNineUnits: Ii
}), Lce = Ii, Rce = M({
  fullBaths: ne(L()),
  halfBaths: ne(L())
}), Ece = M({
  totalArea: M({
    variable: ne(L())
  }),
  finishedArea: M({
    variable: ne(L())
  })
}), Dce = M({
  detached: Ii,
  attached: Ii
}), Nce = r9, Tce = M({
  fixed: ne(L()),
  variable240To480: ne(L()),
  variableOver480: ne(L())
}), Pce = M({
  fixed: ne(L()),
  variableOver70: ne(L())
}), kce = Ii, Vce = Ii, Oce = Ii, Fce = r9, Bce = M({
  uncovered: M({
    variable: ne(L())
  }),
  covered: M({
    variable: ne(L())
  }),
  screen: M({
    variable: ne(L())
  })
}), Hce = M({
  uncovered: M({
    variable: ne(L())
  }),
  covered: M({
    variable: ne(L())
  }),
  screen: M({
    variable: ne(L())
  })
}), Gce = M({
  uncovered: M({
    variable: ne(L())
  }),
  covered: M({
    variable: ne(L())
  }),
  screen: M({
    variable: ne(L())
  })
}), $ce = M({
  freestanding: L(),
  zeroClearance: L(),
  masonry: L()
}), Zce = M({
  fullBaths: ne(L()),
  halfBaths: ne(L())
}), jce = M({
  slab: M({
    variable: L()
  })
}), Wce = M({
  singleFamily: Ice,
  multiFamily: wce,
  manufactured: Lce,
  bathrooms: Rce,
  basement: Ece,
  attic: Fce,
  garage: Dce,
  carport: Nce,
  heating: L(),
  heatingAndCooling: L(),
  pool: Tce,
  spa: Pce,
  shed: kce,
  workshop: Vce,
  barn: Oce,
  porch: Bce,
  patio: Hce,
  deck: Gce,
  fireplace: $ce,
  manufacturedBaths: Zce,
  foundation: jce
}), UI = be(["2024.1", "2025.1", "2026.1"]);
M({
  version: UI,
  zipMultiplier: Mce,
  costData: Wce,
  historicalIndex: xce
});
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
var zce = ie("1.0");
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
xt.fromNumber(400, "sqft");
xt.fromNumber(400, "sqft");
xt.fromNumber(100, "sqft");
xt.fromNumber(64, "sqft");
var Uce = ie("1.0");
G_.multipleOf(0.1);
H_.multipleOf(0.1);
var Xce = M({
  fullAddress: v(),
  unitNumber: v().optional(),
  legalDescription: v().optional(),
  parcelNumber: v().optional(),
  propertyType: xr.optional(),
  propertyInterest: v().optional(),
  yearBuilt: L().optional(),
  bedroomCount: L().optional(),
  fullBathCount: L().optional(),
  halfBathCount: L().optional(),
  gla: L().optional(),
  lotSize: L().optional(),
  opinionOfSiteValue: L().optional(),
  valueOfImprovements: L().optional(),
  costNew: L().optional(),
  depreciation: L().optional(),
  indicatedCostValue: L().optional(),
  arvGla: L().optional(),
  arvValueOfImprovements: L().optional(),
  arvCostNew: L().optional(),
  arvDepreciation: L().optional(),
  arvIndicatedCostValue: L().optional(),
  arvCraftsmanQuality: L().optional(),
  uadQuality: v().optional(),
  condition: v().optional(),
  arvUadQuality: v().optional(),
  arvCondition: v().optional(),
  craftsmanQuality: L().optional(),
  // Stringified JSONs
  costNewBreakdown: v().optional(),
  depreciationBreakdown: v().optional(),
  additionalFeaturesBreakdown: v().optional(),
  arvCostNewBreakdown: v().optional(),
  arvDepreciationBreakdown: v().optional(),
  arvAdditionalFeaturesBreakdown: v().optional(),
  neighborhoodName: v().optional(),
  zoning: v().optional(),
  zoningCompliance: r_.optional(),
  siteInfluence: v().optional(),
  view: v().optional(),
  newConstruction: Y().optional(),
  pud: Y().optional(),
  mandatoryFees: v().optional(),
  mandatoryFeesFrequency: n_.optional()
}), Yce = M({
  fullAddress: v(),
  unitNumber: v().optional(),
  propertyType: xr.optional(),
  yearBuilt: L().optional(),
  bedroomCount: L().optional(),
  fullBathCount: L().optional(),
  halfBathCount: L().optional(),
  gla: L().optional(),
  lotSize: L().optional(),
  compType: Eh.optional(),
  displayOrder: L().optional(),
  saleDate: v().optional(),
  salesPrice: L().optional(),
  contractDate: v().optional(),
  listingPrice: L().optional(),
  listingStatus: vh.optional(),
  dateOfSaleAdjustment: L().optional(),
  siteExtractionAdjustment: L().optional(),
  depreciatedCostAdjustment: L().optional(),
  totalNetAdjustment: L().optional(),
  adjustedSalesPrice: L().optional(),
  extractedSiteValue: L().optional(),
  valueOfImprovements: L().optional(),
  costNew: L().optional(),
  depreciation: L().optional(),
  indicatedCostValue: L().optional(),
  // Stringified JSONs
  adjustmentsBreakdown: v().optional(),
  costNewBreakdown: v().optional(),
  depreciationBreakdown: v().optional(),
  additionalFeaturesBreakdown: v().optional(),
  proximity: L().optional(),
  uadQuality: v().optional(),
  condition: v().optional(),
  craftsmanQuality: lie.optional(),
  siteInfluence: v().optional(),
  view: v().optional()
}), qce = M({
  borrower: v().optional(),
  productType: v().optional(),
  valuationType: v().optional(),
  inspectorType: v().optional(),
  effectiveDate: v().optional(),
  intendedUse: v().optional(),
  intendedUsers: v().optional(),
  opinionOfMarketValue: L().optional(),
  opinionOfAfterRepairValue: L().optional(),
  totalCostToCure: L().optional(),
  totalRenovationBudget: L().optional(),
  estimatedReturnOnInvestment: L().optional(),
  dismissedAlerts: ne(Dh).optional(),
  subjectProperty: Xce,
  comparableProperties: ne(Yce)
}), XI = be([
  "c5_condition",
  "c6_condition",
  "leasehold_property_interest",
  "leased_fee_property_interest",
  "zoning_compliance_illegal",
  "zoning_compliance_non_conforming",
  "value_subject_to"
]), Jce = zt([ie(1), ie(2)]), YI = M({
  hasInspection: Y().optional(),
  reportId: v().nullable().optional()
}), qI = be(["rov", "revision"]), BC = M({
  originalOrderId: v(),
  comparables: ne(
    M({
      address: v(),
      dataSource: v(),
      dateOfSale: v(),
      justification: v()
    })
  ).optional().nullable(),
  requesterName: v(),
  requesterEmail: v(),
  requesterPhone: v(),
  requestDescription: v(),
  revisionType: qI,
  requestedAt: An,
  revisionRequestId: v(),
  inspectionId: v()
}), JI = M({
  costToCure: Y().optional(),
  arv: Y().optional(),
  allowSubjectToValue: Y().optional(),
  avm: Y().optional()
}), o9 = M({
  /** @deprecated */
  address: O4.optional(),
  effectiveDate: qn,
  orderNumber: v().optional(),
  /** @deprecated */
  propertyType: Ga,
  isCraftsman: Y().optional(),
  version: Jce.default(1),
  craftsmanAdjustmentVersion: zce.default("1.0"),
  craftsmanCalculatorVersion: Uce.default("1.0"),
  craftsmanDatasetVersion: UI.default("2024.1"),
  costMultiplier: L().optional(),
  licenseState: v().optional(),
  licenseNumber: v().optional(),
  licenseExpiration: qn.optional(),
  licenseType: v().optional(),
  inspectionData: YI.optional(),
  revisionData: BC.optional(),
  previousRevisionsData: ne(BC).optional(),
  revisionRequestId: v().optional(),
  inspectionId: v().optional(),
  options: JI.optional(),
  appraisifyName: v().optional(),
  appraisifyAddress: v().optional(),
  isMock: Y().optional(),
  appraisalReportDisclaimer: v().optional(),
  previousDesktopOrderID: v().optional()
}), Kce = be(["listingID", "publicRecord", "none"]), Qce = o9.extend({
  // Autofill fields: publicRecord/none requires nothing besides this autofillType
  autofillType: Kce.optional(),
  // MLS autofill fields
  mls: Rl.optional(),
  listingID: v().optional(),
  supplementWithPublicRecord: Y().optional(),
  address: O4,
  appraisalType: v().optional(),
  clientName: v().optional(),
  dueDate: qn.optional(),
  inspectionDate: qn.optional(),
  appraiserInstructions: v().optional(),
  intendedUsers: v().optional(),
  intendedUse: v().optional(),
  inspectorType: v().optional(),
  borrowerName: v().optional(),
  inspectifyOrder: Y().optional(),
  mock: Y().optional()
}), Cs = M({
  id: In,
  /** @deprecated */
  subjectAddress: md.optional(),
  ownerID: oc.optional(),
  createdAt: An.optional(),
  modifiedAt: An.optional(),
  isArchived: Y().optional(),
  isDeleted: Y().optional(),
  isMock: Y().optional(),
  isTraining: Y().optional(),
  isCompleted: Y().optional(),
  requiresPrefill: Y().optional(),
  isInspectifyOrder: Y().optional(),
  input: o9,
  appraisalType: v().optional(),
  clientName: v().optional(),
  appraiserFee: Te.optional(),
  dueDate: qn.optional(),
  inspectionDate: qn.optional(),
  appraiserInstructions: v().optional(),
  intendedUsers: v().optional(),
  intendedUse: v().optional(),
  inspectorType: v().optional(),
  borrowerName: v().optional(),
  signedAt: An.optional(),
  appraisifyFee: Te.optional(),
  isRevision: Y().optional(),
  originalOrderId: v().nullable().optional(),
  startedAt: An.optional(),
  estimatedMinutesSpentLastUpdatedAt: An.optional(),
  estimatedMinutesSpent: L().optional(),
  isEscalated: Y().optional(),
  escalationType: XI.optional(),
  propertyType: Ga.optional()
}), e1e = Cs.extend({
  warnings: ne(v()).optional()
});
ne(v());
var t1e = M({
  results: ne(Cs),
  pagination: e_
}), n1e = M({
  input: Qce,
  subject: zI.optional()
}), r1e = M({
  originalOrderId: v(),
  comparables: ne(
    M({
      address: v(),
      dataSource: v(),
      dateOfSale: v(),
      justification: v()
    })
  ).optional().nullable(),
  requesterName: v(),
  requesterEmail: v(),
  requesterPhone: v(),
  requestDescription: v(),
  revisionType: qI,
  requestedAt: v(),
  revisionRequestId: v()
});
M({
  revisionData: r1e,
  appraiserFee: v().nullable(),
  appraisifyFee: v().nullable(),
  dueDate: v(),
  inspectionId: v()
});
M({
  address: O4,
  effectiveDate: v(),
  orderNumber: v(),
  propertyType: nie,
  appraisalType: v(),
  clientName: v().nullable(),
  appraiserFee: v().nullable(),
  appraisifyFee: v().nullable(),
  dueDate: v(),
  inspectionDate: v().nullable(),
  appraiserInstructions: v().nullable(),
  intendedUsers: v().nullable(),
  intendedUse: v().nullable(),
  appraisalReportDisclaimer: v().nullable(),
  inspectorType: v(),
  borrowerName: v().nullable(),
  licenseState: v(),
  licenseNumber: v(),
  licenseExpiration: v(),
  licenseType: v(),
  inspectionData: YI,
  inspectionId: v().optional(),
  options: JI.optional(),
  appraisifyAddress: v().optional(),
  appraisifyName: v().optional(),
  mock: Y().optional(),
  previousDesktopOrderID: v().nullable()
});
var o1e = M({
  dueDate: v()
}), a1e = M({
  input: o9,
  isArchived: Y().optional(),
  isDeleted: Y().optional(),
  isTraining: Y().optional(),
  requiresPrefill: Y().optional(),
  intendedUsers: v().optional(),
  intendedUse: v().optional(),
  startedAt: v().optional()
}), i1e = be(["1571BradfordTrace", "2665Dearborn", "6106Lakeshore"]);
M({
  trainingAddress: i1e
});
M({
  archived: Y().default(!1)
});
M({
  orderID: In
});
M({
  limit: L().optional(),
  next: v().optional()
});
M({
  orderID: In
}), M({ orderID: In });
M({
  orderID: In
});
var s1e = M({
  appraisalData: qce
});
M({
  orderID: In
}), v();
var l1e = M({
  escalationType: XI,
  escalationReason: v()
});
M({ orderID: In }), v();
M({ orderID: In });
M({ orderID: In });
M({ orderID: In });
var Fh = { saveAsDefault: v().optional() };
M(qe), M(qe), M(Fh);
M(qe), M(qe), M(Fh);
M(qe), M(qe), M(Fh);
M(qe), M(qe), M(Fh);
var KI = M({
  ParcelNumberRaw: v().nullable(),
  PropertyAddressFull: v().nullable(),
  PropertyAddressCity: v().nullable(),
  PropertyAddressState: v().nullable(),
  PropertyAddressZIP: v().nullable(),
  SitusCounty: v().nullable(),
  NeighborhoodCode: v().nullable(),
  MinorCivilDivisionName: v().nullable(),
  LegalDescription: v().nullable(),
  PropertyUseGroup: v().nullable(),
  YearBuilt: L().nullable(),
  EffectiveYearBuilt: L().nullable(),
  PartyOwner1NameFull: v().nullable(),
  AssessorLastSaleAmount: Te.nullable(),
  AssessorPriorSaleDate: qn.nullable(),
  AreaBuilding: yt.nullable(),
  AreaGross: yt.nullable(),
  AreaLotSF: yt.nullable(),
  RoomsAtticFlag: Y().nullable(),
  RoomsAtticArea: yt.nullable(),
  RoomsBasementArea: yt.nullable(),
  RoomsBasementAreaFinished: yt.nullable(),
  ParkingSpaceCount: L().nullable(),
  DrivewayArea: yt.nullable(),
  PorchArea: yt.nullable(),
  PatioArea: yt.nullable(),
  DeckArea: yt.nullable(),
  PoolArea: yt.nullable(),
  BuildingsCount: L().nullable(),
  PartyOwner2NameFull: v().nullable(),
  PartyOwner3NameFull: v().nullable(),
  PartyOwner4NameFull: v().nullable(),
  ContactOwnerMailAddressFull: v().nullable(),
  ContactOwnerMailAddressCity: v().nullable(),
  ContactOwnerMailAddressState: v().nullable(),
  ContactOwnerMailAddressZIP: v().nullable(),
  CompanyFlag: Y().nullable(),
  TaxYearAssessed: L().nullable(),
  TaxAssessedValueImprovements: Te.nullable(),
  TaxAssessedValueLand: Te.nullable(),
  TaxAssessedValueTotal: Te.nullable(),
  TaxMarketValueYear: L().nullable(),
  TaxMarketValueImprovements: Te.nullable(),
  TaxMarketValueLand: Te.nullable(),
  TaxMarketValueTotal: Te.nullable(),
  TaxFiscalYear: L().nullable(),
  TaxRateArea: v().nullable(),
  TaxBilledAmount: Te.nullable(),
  AssessorLastSaleDate: qn.nullable(),
  LastOwnershipTransferDocumentNumber: v().nullable(),
  AssessorPriorSaleAmount: Te.nullable(),
  RoomsCount: L().nullable(),
  BathCount: L().nullable(),
  BathPartialCount: L().nullable(),
  BedroomsCount: L().nullable(),
  StoriesCount: L().nullable(),
  UnitsCount: L().nullable(),
  StructureStyle: v().nullable(),
  Exterior1Code: v().nullable(),
  RoofMaterial: v().nullable(),
  ViewDescription: v().nullable(),
  ParkingGarage: v().nullable(),
  ParkingGarageArea: yt.nullable(),
  ParkingCarport: Y().nullable(),
  ParkingCarportArea: yt.nullable(),
  HVACCoolingDetail: v().nullable(),
  HVACHeatingDetail: v().nullable(),
  HVACHeatingFuel: v().nullable(),
  UtilitiesSewageUsage: v().nullable(),
  UtilitiesWaterSource: v().nullable(),
  Construction: v().nullable(),
  Foundation: v().nullable(),
  PlumbingFixturesCount: L().nullable(),
  FlooringMaterialPrimary: v().nullable(),
  GuestHouseArea: yt.nullable(),
  ShedArea: yt.nullable(),
  Zoning: v().nullable()
});
M(qe), M({
  listing: KI,
  source: j4
});
M(qe), M({
  addresses: v()
}), ne(
  M({
    listing: KI,
    source: j4,
    address: Ll
  })
);
var u1e = M({
  t: ie("custom"),
  name: v()
}), QI = ic.or(
  u1e
), c1e = zt([ic, ie("custom")]), Bh = vne([L(), L()]);
ne(Bh);
var ew = M({
  coords: Bh,
  propertyType: v(),
  propertySubType: v(),
  marketingCommentary: v(),
  address: v(),
  zipCode: v(),
  view: v(),
  designStyle: v(),
  heatingCooling: v(),
  hasBasement: Y(),
  hasAttachment: Y(),
  bedrooms: L(),
  bathrooms: L(),
  halfBathrooms: L(),
  threeQuarterBathrooms: L(),
  totalBathrooms: L(),
  stories: L(),
  attachedGarageParkingSpacesCount: L(),
  glaSqFt: L(),
  basementSqFt: L(),
  siteSizeSqFt: L(),
  yearBuilt: L(),
  contractDate: L(),
  saleDate: L(),
  salePrice: L(),
  partitionKey: v()
}).partial(), d1e = ga("t", [
  M({ t: ie("any"), value: gC().optional() }),
  M({ t: ie("equal"), value: gC().optional() }),
  M({ t: ie("less"), value: p1 }),
  M({ t: ie("greater"), value: p1 }),
  M({ t: ie("withinUnit"), value: p1 }),
  M({ t: ie("withinPercent"), value: p1 })
]), f1e = mn(ew.keyof(), d1e), HC = M({
  t: be(["any", "includeKeyword", "omitKeyword", "address", "equal"]),
  key: ew.keyof().optional(),
  value: zt([v(), L()]).optional()
}), h1e = M({
  p1: HC,
  p2: HC
}), p1e = M({
  version: ie(1),
  matchCriteria: f1e,
  differenceCriteria: h1e
}), m1e = M({
  t: ie("radius"),
  coord: Bh,
  radiusInMeters: L()
}), g1e = M({
  t: ie("polygon"),
  coords: ne(Bh)
}), v1e = ga("t", [m1e, g1e]), tw = M({
  filters: kh,
  pairCriteria: p1e,
  geoSearch: v1e
}), nw = zt([Te, L()]), C1e = M({
  p1: bf,
  p2: bf,
  adjustments: mn(c1e, Te),
  additionalFeature1Title: v().optional(),
  additionalFeature2Title: v().optional(),
  additionalFeature3Title: v().optional()
}), rw = ne(C1e), b1e = M({
  search: tw,
  notes: v(),
  reconciledValue: nw,
  selectedPairs: rw
}), y1e = M({
  version: ie(1),
  id: _i,
  createdBy: oc,
  createdAt: An,
  modifiedAt: An,
  analysisFeature: QI,
  // TODO: Check if this is the correct set
  propertyType: xr,
  mlsID: v(),
  body: b1e
  // Add isArchived?
});
y1e.omit({
  id: !0,
  createdAt: !0,
  modifiedAt: !0
});
var S1e = M({
  analysisFeature: QI,
  propertyType: xr,
  mlsID: v()
}), ow = M({
  search: tw,
  notes: v(),
  reconciledValue: nw,
  selectedPairs: rw
});
M({});
var A1e = M({
  body: ow.optional(),
  addToExport: Y().optional(),
  isDeleted: Y().optional()
}), Df = M({
  id: _i,
  ownerID: oc,
  createdAt: An,
  modifiedAt: An,
  input: S1e,
  body: ow,
  // TODO: Make this optional when we support in-progress paired Sales
  isExported: Y()
});
Df.pick({
  input: !0,
  body: !0
});
M({
  results: ne(Df).optional(),
  _pagination: e_.optional()
});
M({
  limit: L().optional(),
  next: v().optional(),
  orderID: In.optional()
});
M({
  orderID: In.optional()
});
M({
  studyID: _i
}), M({
  orderID: In.optional()
}), M({
  studyID: _i
}), M({
  orderID: In.optional()
});
var a9 = gn(), aw = gn(), iw = gn(), sw = be(["pairedCost", "pairedSales"]), M1e = gn(), lw = M({
  orderID: In,
  studyID: _i,
  isActive: Y(),
  body: M1e
});
lw.pick({
  orderID: !0,
  studyID: !0
});
lw.pick({
  orderID: !0
});
var p5 = M({
  id: _i,
  ownerID: oc,
  createdAt: An,
  modifiedAt: An,
  type: sw,
  input: a9,
  scratch: aw.optional(),
  output: iw.optional()
}), x1e = M({
  input: a9.optional(),
  type: sw
}), _1e = M({
  id: _i,
  ownerID: oc,
  input: a9.optional(),
  scratch: aw.optional(),
  output: iw.optional()
});
M({
  orderID: In,
  studyID: _i
}), zt([p5, M({ message: v() })]), M({
  orderID: In
}), zt([p5, M({ message: v() })]), M({
  orderID: In,
  studyID: _i
}), zt([p5, M({ message: v() })]);
var I1e = be(["subject"]), w1e = M({
  id: v(),
  studyID: v(),
  type: I1e
}), L1e = M({
  type: ie("subject"),
  body: gn()
});
qx(
  w1e,
  L1e
);
M({
  address: Ll.optional(),
  mlsListingInfo: Dre.optional(),
  effectiveYear: L(),
  xmlProperty: zI.optional(),
  propertyType: Ga.optional(),
  compType: Eh.optional(),
  orderID: v()
});
M({
  status: ie("success"),
  result: qu
});
M({
  ...qe,
  propertyId: v()
}), M({
  sources: ne(V_).optional(),
  includeBackupListingData: Y().optional().default(!0)
}), Ju.or(Gie).optional();
var uw = M({
  reportPDF: os,
  loePDF: os.optional(),
  purchaseContractPDF: os.optional(),
  orderDetailsPDF: os.optional()
});
uw.keyof();
var cw = M({
  id: v(),
  orderID: In,
  status: be(["in-progress", "error", "success"]),
  results: ne(v()).nullable(),
  files: uw,
  createdAt: Cne.date()
}), R1e = M({ status: ie("idle") }), E1e = cw.or(R1e);
M({ orderID: In }), M({ orderID: In }), M({
  files: M({
    reportPDF: os,
    loePDF: os.optional(),
    purchaseContractPDF: os.optional(),
    orderDetailsPDF: os.optional()
  })
});
M({
  limit: L().optional(),
  offset: L().optional(),
  email: v().optional(),
  name: v().optional()
}), M({
  results: ne(cI),
  resultsCount: L(),
  totalResultsCount: L()
});
M({
  orderID: In
}), M({
  geoType: n9,
  geoId: v()
});
re(ce(), 1);
$ae.toJSON();
re(ce(), 1);
Zae.toJSON();
jae.toJSON();
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
xe.parse(20);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
xe.optional();
Uae.toJSON();
re(ce(), 1);
Xae.toJSON();
re(ce(), 1);
Yae.toJSON();
re(ce(), 1);
re(ce(), 1);
qae.toJSON();
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
Fr.today();
re(ce(), 1);
re(ce(), 1);
M({ orderID: v() });
M({ orderID: v(), propertyAttachmentID: v() }), M({ orderID: v(), propertyAttachmentID: v() }), M({}), M({ orderID: v(), propertyAttachmentID: v() });
be([
  ...uc.exclude(["primaryDwelling"]).options,
  ...be(["mainDwelling", "belowGradeANSI", "manual"]).options
]);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
jt.fromDollarLike(1e3), jt.fromDollarLike(1e3);
re(ce(), 1);
re(Gne(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
re(ce(), 1);
(0, V4.AloftEnum)()({
  shouldAllowTrialWithoutPayment(e) {
    return e.isEnabled("TRIAL_WITHOUT_PAYMENT");
  },
  shouldShowOffshoreQCBeta(e) {
    return e.isEnabled("OFFSHORE_QC_BETA");
  },
  shouldShowRecommendedCompsFiltering(e) {
    return e.isEnabled("RECOMMENDED_COMPS_FILTERING");
  },
  shouldShowFeatureGrid(e) {
    return e.isEnabled("SHOW_SALES_COMPARISON_GRID");
  },
  shouldShowAdjustmentsGrid(e) {
    return e.isEnabled("SHOW_ADJUSTMENTS_GRID");
  },
  shouldShowOrderDetails(e) {
    return e.isEnabled("SHOW_ORDER_DETAILS");
  },
  shouldShowCommentaryBeta(e) {
    return e.isEnabled("SHOW_COMMENTARY_BETA");
  },
  shouldShowSiteValueAdjuster(e) {
    return e.isEnabled("SHOW_SITE_VALUE_ADJUSTER");
  },
  shouldShowCreateInspectifyOrderModal(e) {
    return e.isEnabled("CREATE_INSPECTIFY_ORDER_MODAL");
  },
  shouldShowNewCostApproachPage(e) {
    return e.isEnabled("SHOW_NEW_COST_APPROACH_PAGE");
  }
});
var D1e = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F"
], N1e = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
], T1e = (e = 8) => `${new Array(2).fill(0).map(() => N1e[Math.floor(Math.random() * 26)]).join("")}-${new Array(e).fill(0).map(() => D1e[Math.floor(Math.random() * 16)]).join("")}`;
re(ce(), 1);
var P1e = re(ce(), 1);
(0, P1e.makeLookup)({
  cases: [
    ["reportPDF", "Report PDF"],
    ["orderDetailsPDF", "Order Details PDF"],
    ["loePDF", "Letter of Engagement PDF"],
    ["purchaseContractPDF", "Purchase Contract PDF"]
  ]
});
re(ce(), 1);
re(ce(), 1);
xt.fromNumber(220, "sqft");
V4.AloftEnum;
V4.AloftEnumKeys;
gr.applyIfNonEmptyString;
gr.checkLength;
gr.checkMinLength;
gr.clamp;
gr.enumerate;
gr.expected;
gr.hasDefinedValues;
Ms.isBoolean;
var $t = gr.isDefined;
Ms.isFunction;
gr.isNonEmptyString;
Ms.isNull;
Ms.isNumber;
Ms.isObject;
var k1e = Ms.isString;
Ms.isSymbol;
var vo = Ms.isUndefined;
gr.linJitter;
gr.makeLookup;
gr.noop;
gr.orUndefined;
gr.populated;
gr.toPunctuatedPhoneFormat;
gr.toTitleCase;
var V1e = gr.unreachable;
const O1e = (e, t) => {
  const n = He(null);
  return ft(() => {
    const r = (o) => {
      n != null && n.current && o.target && !n.current.contains(o.target) && (t == null || t(), n.current.blur());
    };
    return document.addEventListener("mouseup", r), () => {
      document.removeEventListener("mouseup", r);
    };
  }, [n.current]), te(
    (r) => {
      typeof e == "function" ? e(r) : e !== null && (e.current = r), n.current = r;
    },
    [n, e]
  );
}, F1e = (e) => {
  if (vo(e.paddingX) && vo(e.paddingY) && vo(e.paddingX) && vo(e.paddingY))
    return e;
  const t = { ...e };
  return $t(t.paddingX) && (t.paddingLeft = t.paddingLeft ?? t.paddingX, t.paddingRight = t.paddingRight ?? t.paddingX), $t(t.paddingY) && (t.paddingTop = t.paddingTop ?? t.paddingY, t.paddingBottom = t.paddingBottom ?? t.paddingY), $t(t.marginX) && (t.marginLeft = t.marginLeft ?? t.marginX, t.marginRight = t.marginRight ?? t.marginX), $t(t.marginY) && (t.marginTop = t.marginTop ?? t.marginY, t.marginBottom = t.marginBottom ?? t.marginY), t;
}, B1e = 4, dw = (e) => `${e * B1e}px`, H1e = {
  borderRadius: !0,
  borderTopRadius: !0,
  borderBottomRadius: !0,
  borderLeftRadius: !0,
  borderRightRadius: !0,
  borderTopLeftRadius: !0,
  borderTopRightRadius: !0,
  borderBottomLeftRadius: !0,
  borderBottomRightRadius: !0,
  borderWidth: !0,
  borderTopWidth: !0,
  borderBottomWidth: !0,
  borderLeftWidth: !0,
  borderRightWidth: !0,
  bottom: !0,
  columnGap: !0,
  gap: !0,
  height: !0,
  left: !0,
  margin: !0,
  marginTop: !0,
  marginBottom: !0,
  marginLeft: !0,
  marginRight: !0,
  maxWidth: !0,
  maxHeight: !0,
  minHeight: !0,
  minWidth: !0,
  padding: !0,
  paddingY: !0,
  paddingX: !0,
  paddingTop: !0,
  paddingBottom: !0,
  paddingLeft: !0,
  paddingRight: !0,
  right: !0,
  rowGap: !0,
  top: !0,
  width: !0
}, G1e = (e) => Object.entries(e).reduce((t, [n, r]) => (H1e.hasOwnProperty(n) && typeof r == "number" ? t[n] = dw(r) : t[n] = r, t), {}), Xs = (e) => Fo[e], $1e = (e) => {
  const [t, n, r] = $t(e.border) ? e.border.split(" ") : [], o = parseInt(t, 10), a = Number.isNaN(parseInt(t, 10)) || o.toString() !== t ? t : dw(o), s = Xs(r || "none"), l = $t(r) ? s : void 0;
  if (vo(e.border) && vo(e.borderColor) && vo(e.borderTopColor) && vo(e.borderBottomColor) && vo(e.borderLeftColor) && vo(e.borderRightColor))
    return e;
  const c = [a, n, l].filter(
    (E) => $t(E)
  ), d = c.length > 0 ? c.join(" ") : void 0, f = Xs(e.borderColor || "none"), h = Xs(e.borderTopColor || "none"), m = Xs(e.borderBottomColor || "none"), g = Xs(e.borderLeftColor || "none"), b = Xs(e.borderRightColor || "none"), C = e.borderColor ? f : void 0, y = e.borderTopColor ? h : void 0, _ = e.borderBottomColor ? m : void 0, x = e.borderLeftColor ? g : void 0, I = e.borderRightColor ? b : void 0, R = { ...e };
  return $t(d) && (R.border = d), $t(C) && (R.borderColor = C), $t(y) && (R.borderTopColor = y), $t(_) && (R.borderBottomColor = _), $t(x) && (R.borderLeftColor = x), $t(I) && (R.borderRightColor = I), R;
}, GC = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"], Z1e = (e) => `${GC[Math.floor(Math.round(255 * e) / 16)]}${GC[Math.round(Math.round(255 * e) % 16)]}`, j1e = (e) => {
  const t = Xs(e.backgroundColor || "none");
  if (vo(e.backgroundColor))
    return e;
  const n = $t(e.backgroundOpacity) ? `${t}${Z1e(e.backgroundOpacity)}` : t;
  return { ...e, backgroundColor: n };
}, W1e = (e) => {
  const t = F1e(e), n = G1e(t), r = $1e(n), o = j1e(r), a = Object.fromEntries(
    Object.entries(e).filter(([l]) => l.match(/^data-/))
  );
  return { adjustedProps: Object.fromEntries(
    Object.entries(o).filter(([l]) => !l.match(/^data-/))
  ), dataProps: a };
};
function z1e(e) {
  return e.colSpan !== void 0 || e.rowSpan !== void 0;
}
const $C = nt(
  (e, t) => /* @__PURE__ */ A.jsx("div", { ...e, ref: t })
), U1e = nt(
  (e, t) => /* @__PURE__ */ A.jsx("li", { ...e, ref: t })
), X1e = nt(
  (e, t) => /* @__PURE__ */ A.jsx("ul", { ...e, ref: t })
), Y1e = nt(
  (e, t) => /* @__PURE__ */ A.jsx("td", { ...e, ref: t })
), q1e = nt(
  (e, t) => /* @__PURE__ */ A.jsx("th", { ...e, ref: t })
), J1e = nt(
  (e, t) => /* @__PURE__ */ A.jsx("tr", { ...e, ref: t })
), K1e = nt(
  (e, t) => /* @__PURE__ */ A.jsx("tbody", { ...e, ref: t })
), Q1e = nt(
  (e, t) => /* @__PURE__ */ A.jsx("thead", { ...e, ref: t })
), ede = nt(
  (e, t) => /* @__PURE__ */ A.jsx("table", { ...e, ref: t })
), tde = (e) => {
  switch (e) {
    case "div":
      return $C;
    case "li":
      return U1e;
    case "ul":
      return X1e;
    case "td":
      return Y1e;
    case "th":
      return q1e;
    case "tr":
      return J1e;
    case "tbody":
      return K1e;
    case "thead":
      return Q1e;
    case "table":
      return ede;
    default:
      return $C;
  }
}, Di = nt(
  ({
    id: e,
    __testId: t,
    children: n,
    className: r,
    onClick: o,
    onPress: a,
    onBlur: s,
    onFocus: l,
    onMouseDown: c,
    onMouseEnter: d,
    onMouseLeave: f,
    onClickOutside: h,
    onDragEnter: m,
    onDragLeave: g,
    onDragOver: b,
    onDrop: C,
    onKeyDown: y,
    onKeyUp: _,
    tabIndex: x,
    role: I,
    __dangerDoNotUseSx: R,
    ...E
  }, k) => {
    const { adjustedProps: N, dataProps: P } = W1e(E), F = O1e(k, h), G = tde(I), j = z1e(E) && $t(I) && ["td", "th"].includes(I) ? { colSpan: E.colSpan, rowSpan: E.rowSpan } : {};
    return (
      // @ts-expect-error all of these things have children, hush
      /* @__PURE__ */ A.jsx(
        G,
        {
          id: e,
          className: r,
          tabIndex: x,
          ref: F,
          role: a && !I ? "button" : void 0,
          onBlur: (ae) => {
            s && !ae.currentTarget.contains(ae.relatedTarget) && s(ae);
          },
          onFocus: l,
          onMouseDown: c,
          onMouseEnter: d,
          onMouseLeave: f,
          onDragEnter: m,
          onDragLeave: g,
          onDragOver: b,
          onDrop: C,
          onKeyDown: y,
          style: {
            ...N,
            ...R
          },
          "data-testid": t ?? e,
          onClick: o ?? a,
          onKeyUp: a && ((ae) => {
            (ae.key === " " || ae.code === "Space" || ae.key === "Enter" || ae.code === "Enter") && a(ae);
          }),
          ...j,
          ...P,
          children: n
        }
      )
    );
  }
), Sl = nt((e, t) => /* @__PURE__ */ A.jsx(Di, { ref: t, ...e, display: "flex" })), [nde, Hh] = Wte({
  name: "form-size-context",
  strict: !0,
  errorMessage: "missing form size context. see SUI withFormWrapper."
}), cc = (e, t) => {
  const {
    id: n,
    infoText: r,
    helperText: o,
    errorText: a,
    internalFormWrapperErrorText: s,
    isDisabled: l,
    isReadonly: c,
    isRequired: d,
    isInvalid: f,
    label: h,
    size: m = "md",
    fullWidth: g = !0
  } = e;
  return /* @__PURE__ */ A.jsx(
    ZA,
    {
      isDisabled: l,
      isReadOnly: c,
      isRequired: d,
      isInvalid: f || !!s,
      size: m,
      width: g ? "100%" : "initial",
      children: /* @__PURE__ */ A.jsxs(nde, { value: m, children: [
        h && /* @__PURE__ */ A.jsx(OM, { htmlFor: n, size: m, children: /* @__PURE__ */ A.jsxs("div", { style: { display: "inline-flex", alignItems: "center", gap: "0.5rem" }, children: [
          h,
          r && /* @__PURE__ */ A.jsx(fh, { label: r, placement: "auto", hasArrow: !0, children: /* @__PURE__ */ A.jsx(Sl, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ A.jsx(Go, { icon: "information" }) }) })
        ] }) }),
        t,
        o && /* @__PURE__ */ A.jsx(jA, { children: o }),
        (f && a || !!s) && /* @__PURE__ */ A.jsx(VM, { color: "textError", children: a ?? s })
      ] })
    }
  );
}, rde = (e, t) => {
  if (e)
    return "boxed";
  if (t)
    return "__dangerDoNotUseCheckmarks";
}, ode = ({
  __dangerDoNotUseSx: e,
  __testId: t,
  id: n,
  checked: r,
  label: o,
  multiselect: a,
  onChange: s,
  size: l = "lg",
  value: c,
  forceCheckboxes: d,
  __dangerDoNotUseCheckmarks: f,
  tooltip: h,
  textVariant: m = "h4"
}) => {
  const g = (y) => {
    s && s(c, y.target.checked);
  }, b = a || d ? qg : Rx, C = /* @__PURE__ */ A.jsx(
    b,
    {
      id: n,
      "data-testid": t,
      isChecked: r,
      onChange: g,
      size: l,
      sx: e,
      value: a ? void 0 : c,
      variant: rde(d, f),
      children: /* @__PURE__ */ A.jsx(Wo, { variant: m, children: o })
    }
  );
  return h ? /* @__PURE__ */ A.jsx(R4, { label: h.content, ...h.props, children: C }) : C;
}, ade = (e, t) => {
  const n = e.reduce((r, { value: o }) => (r[o] = !1, r), {});
  return t == null || t.forEach((r) => {
    n[r] = !0;
  }), n;
}, fw = ({
  __testId: e,
  items: t,
  multiselect: n,
  name: r,
  onChange: o,
  size: a,
  value: s,
  isDisabled: l,
  forceCheckboxes: c,
  forceHorizontal: d,
  title: f,
  columnGap: h = "0.5rem",
  gap: m,
  __dangerDoNotUseCheckmarks: g,
  textVariant: b
}) => {
  const C = (R) => {
    o && !n && o(R);
  }, y = (R, E) => {
    if (o && n) {
      const k = [...s || []], N = k.includes(R);
      !N && E ? k.push(R) : N && !E && k.splice(k.indexOf(R), 1), o(k);
    } else
      o && c && C(R);
  }, _ = n ? ade(t, s) : {}, x = t.map(
    ({ value: R, id: E, label: k, __testId: N, tooltip: P }) => /* @__PURE__ */ A.jsx(
      ode,
      {
        __testId: N,
        id: E,
        label: k,
        multiselect: n,
        onChange: y,
        size: a,
        value: R,
        checked: c ? s === R : _[R],
        forceCheckboxes: c,
        tooltip: P,
        __dangerDoNotUseCheckmarks: g,
        textVariant: b
      },
      R
    )
  );
  if (n)
    return /* @__PURE__ */ A.jsx(UA, { isDisabled: l, children: /* @__PURE__ */ A.jsx("div", { "data-testid": e, style: { display: "flex", flexDirection: "column", gap: m, columnGap: h }, children: x }) });
  const I = d || c && t.length < 3 ? "row" : "column";
  return /* @__PURE__ */ A.jsx(
    wx,
    {
      isDisabled: l,
      "data-testid": e,
      value: s,
      onChange: C,
      name: r,
      title: f,
      children: /* @__PURE__ */ A.jsx("div", { style: { display: "flex", gap: m, columnGap: h, flexDirection: I }, children: x })
    }
  );
}, ide = ({
  __testId: e,
  items: t,
  onChange: n,
  size: r,
  value: o,
  forceHorizontal: a,
  title: s,
  columnGap: l,
  gap: c,
  textVariant: d,
  ...f
}) => /* @__PURE__ */ A.jsx(
  fw,
  {
    __testId: e,
    items: t,
    onChange: n,
    size: r,
    value: o,
    multiselect: !0,
    forceHorizontal: a,
    title: s,
    columnGap: l,
    gap: c,
    textVariant: d,
    ...f
  }
), Nme = nt(
  (e, t) => cc(e, /* @__PURE__ */ A.jsx(ide, { ...e }))
), Tme = ({ tooltipContent: e, color: t = "textLight" }) => /* @__PURE__ */ A.jsx(fh, { label: e, children: /* @__PURE__ */ A.jsx(Sl, { cursor: "help", alignItems: "center", children: /* @__PURE__ */ A.jsx(Go, { icon: "information", color: t }) }) }), sde = ({
  __testId: e,
  items: t,
  onChange: n,
  name: r,
  size: o = "lg",
  value: a,
  forceCheckboxes: s,
  forceHorizontal: l,
  title: c,
  columnGap: d,
  gap: f,
  __dangerDoNotUseCheckmarks: h,
  textVariant: m
}) => /* @__PURE__ */ A.jsx(
  fw,
  {
    __testId: e,
    value: a,
    items: t,
    name: r,
    onChange: n,
    size: o,
    multiselect: !1,
    forceCheckboxes: s,
    forceHorizontal: l,
    title: c,
    columnGap: d,
    gap: f,
    __dangerDoNotUseCheckmarks: h,
    textVariant: m
  }
), Pme = nt(
  (e, t) => cc(e, /* @__PURE__ */ A.jsx(sde, { ...e }))
), lde = nt(
  ({
    href: e,
    children: t,
    isExternal: n = !1,
    variant: r = "default",
    __dangerDoNotUseSx: o,
    as: a,
    color: s
  }, l) => {
    const c = { color: s, textDecoration: "underline" };
    return n ? /* @__PURE__ */ A.jsx(
      d3,
      {
        ref: l,
        href: e,
        isExternal: n,
        variant: r,
        sx: o,
        as: a,
        color: s,
        _hover: c,
        _active: c,
        _focus: c,
        children: t
      }
    ) : /* @__PURE__ */ A.jsx(
      d3,
      {
        color: s,
        ref: l,
        as: a,
        to: e,
        variant: r,
        sx: o,
        _hover: c,
        _active: c,
        _focus: c,
        children: t
      }
    );
  }
);
lde.displayName = "Link";
const kme = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "body1",
  "body2",
  "placeholder",
  "subtitle1",
  "subtitle2",
  "subtitle3",
  "link",
  "buttonSmall",
  "buttonRegular",
  "chip",
  "tableColumnTitle",
  "tableH1",
  "tableH2",
  "tableH3",
  "tableTag",
  "displayLarge",
  "displayMedium",
  "displaySmall",
  "label"
], ude = (e, t, n) => {
  const r = He(!1);
  ft(() => {
    var o;
    return e && !r.current && typeof t != "function" && ((o = (t || n).current) == null || o.focus(), r.current = !0), () => {
      r.current = !1;
    };
  }, [e, t]);
}, cde = [
  "price",
  "percent",
  "number",
  "aloftPrice",
  "aloftArea"
], dde = (e) => cde.includes(e), fde = (e, t) => {
  ft(() => {
    if (dde(e) && typeof t == "object" && typeof t != "function") {
      const n = t == null ? void 0 : t.current, r = (o) => {
        document.activeElement === n && o.preventDefault();
      };
      return n == null || n.addEventListener("wheel", r), () => {
        n == null || n.removeEventListener("wheel", r);
      };
    }
  }, [t, e]);
}, hde = nt((e, t) => /* @__PURE__ */ A.jsx(
  $h,
  {
    ...e,
    ref: t,
    type: "date",
    value: Fr.isAloftDate(e.value) ? e.value.toIsoString() : void 0,
    onChange: (n) => {
      try {
        e.onChange(Fr.fromIsoString(n));
      } catch {
        e.onClear();
      }
    },
    onClear: e.onClear,
    formatValue: (n) => vo(n) ? "" : e.formatValue ? e.formatValue(Fr.fromIsoString(n)) : n,
    setInternalFormWrapperErrorText: () => null
  }
)), pde = nt((e, t) => {
  const n = (o) => {
    $t(o) ? e.onChange(jt.fromNumericPrice(o)) : e.onClear();
  }, r = (o) => $t(o) ? e.formatValue ? e.formatValue(jt.fromNumericPrice(o)) : `${o}` : "";
  return /* @__PURE__ */ A.jsx(
    $h,
    {
      ...e,
      ref: t,
      type: "price",
      onClear: e.onClear,
      onChange: n,
      value: jt.isAloftPrice(e.value) ? e.value.toNumericPrice() : void 0,
      formatValue: r,
      setInternalFormWrapperErrorText: () => null
    }
  );
}), mde = (e, t) => {
  if ($t(e) && $t(t))
    return xt.fromNumber(ph.round(e.unitAmount, t), e.unit);
}, i9 = (e) => e.target.value, wi = (e) => e !== void 0, s9 = nt(({ leftAddon: e, rightAddon: t, input: n, leftAddonProps: r = {}, rightAddonProps: o = {} }, a) => {
  const s = Hh();
  return /* @__PURE__ */ A.jsxs(c4, { size: s, children: [
    wi(e) && /* @__PURE__ */ A.jsx(
      f4,
      {
        ...r,
        backgroundColor: "transparent",
        borderColor: "transparent",
        height: r.height || "2.75rem",
        children: e
      }
    ),
    n,
    wi(t) && /* @__PURE__ */ A.jsx(
      h4,
      {
        ...o,
        backgroundColor: "transparent",
        borderColor: "transparent",
        children: t
      }
    )
  ] });
});
s9.displayName = "InputWithAddons";
const gde = ({
  commonProps: e,
  ...t
}) => {
  var c;
  const { prefix: n, suffix: r } = t, o = ((c = t.value) == null ? void 0 : c.unit) ?? t.unit, a = {};
  (o || r) && (a.rightAddon = r ?? o, a.rightAddonProps = {
    height: "100%",
    marginY: "auto"
  }), n && (a.leftAddon = n, a.leftAddonProps = {
    height: "100%",
    marginY: "auto"
  });
  const s = t.formatValue ?? ((d) => d == null ? void 0 : d.unitAmount), l = (d) => {
    var h;
    const f = i9(d);
    if (f === "")
      t.onClear();
    else {
      const m = xt.fromString(f, ((h = t.value) == null ? void 0 : h.unit) ?? "sqft");
      t.onChange(m);
    }
  };
  return /* @__PURE__ */ A.jsx(
    s9,
    {
      ...a,
      input: /* @__PURE__ */ A.jsx(
        no,
        {
          ...e,
          paddingInlineStart: "8px",
          type: "number",
          precision: t.precision,
          onChange: l,
          onBlur: () => {
            var f;
            const d = mde(t.value, t.precision);
            (f = t.onBlur) == null || f.call(t, d);
          },
          value: $t(t.value) && t.value !== "" ? s(t.value) : ""
        }
      )
    }
  );
}, dc = (e) => e ?? "", _s = (e, t) => (n) => {
  const r = i9(n);
  r === "" ? t() : e(r);
}, vde = ({
  commonProps: e,
  ...t
}) => {
  const n = t.formatValue ?? dc;
  return /* @__PURE__ */ A.jsx(
    no,
    {
      ...e,
      type: "date",
      value: n(t.value),
      onChange: _s(t.onChange, t.onClear)
    }
  );
}, Cde = ({
  commonProps: e,
  ...t
}) => {
  const n = t.formatValue ?? dc;
  return /* @__PURE__ */ A.jsx(
    no,
    {
      ...e,
      type: "email",
      value: n(t.value),
      onChange: _s(t.onChange, t.onClear)
    }
  );
}, ZC = {
  fields: ["address_components"],
  componentRestrictions: { country: ["us"] }
};
function hw(e, t) {
  const n = He(document.createElement("div")), r = He(null), o = He(null), a = He(null), s = te(() => {
    var d;
    const l = a.current, c = l == null ? void 0 : l.getPlace();
    if (c) {
      t(c, (d = o.current) == null ? void 0 : d.value);
      return;
    }
    e && (async () => {
      var f;
      try {
        const { AutocompleteService: h, PlacesService: m } = await e.importLibrary("places"), g = ((f = o.current) == null ? void 0 : f.value) ?? "";
        new h().getPlacePredictions(
          { input: g },
          (C, y) => {
            y === google.maps.places.PlacesServiceStatus.OK && (C != null && C.length) && new m(
              r.current
            ).getDetails(
              { placeId: C[0].place_id, ...ZC },
              (x) => {
                x && t(x, g);
              }
            );
          }
        );
      } catch (h) {
        console.error("Google Maps fallback failed", h);
      }
    })();
  }, [t, e]);
  return ft(() => {
    if (!e || !o.current)
      return;
    let l = null;
    return (async () => {
      try {
        const { Autocomplete: c } = await e.importLibrary("places");
        l = new c(o.current, ZC), a.current = l, l.addListener("place_changed", s);
        const { Map: d } = await e.importLibrary("maps");
        r.current = new d(n.current, {
          center: { lat: -33.866, lng: 151.196 },
          zoom: 15
        });
      } catch (c) {
        console.error("Google Maps initialization failed", c);
      }
    })(), () => {
      l && google.maps.event.clearInstanceListeners(l);
    };
  }, [s, e]), o;
}
const Oo = (e, t) => {
  var n;
  return (n = e.address_components.find((r) => r.types.includes(t))) == null ? void 0 : n.short_name;
}, bde = (e, t) => {
  var c;
  if (!e)
    return;
  const n = Oo(e, "street_number") || ((c = t == null ? void 0 : t.match(/\d+/)) == null ? void 0 : c[0]);
  if (!n)
    return;
  const r = Oo(e, "route");
  if (!r)
    return;
  const o = Oo(e, "subpremise"), a = Oo(e, "locality");
  if (!a)
    return;
  const s = Oo(e, "administrative_area_level_1");
  if (!s)
    return;
  const l = Oo(e, "postal_code");
  if (l)
    return {
      AddressLineText: `${n} ${r}`,
      unitNumber: o,
      CityName: a,
      StateCode: s,
      PostalCode: l
    };
}, Dl = nt(({ input: e, icon: t, placeIconRight: n }, r) => {
  const o = Hh(), a = /* @__PURE__ */ A.jsx(Go, { icon: t, size: o === "xs" ? "md" : "lg", color: "textTertiary" });
  return /* @__PURE__ */ A.jsxs(c4, { size: o, children: [
    !n && /* @__PURE__ */ A.jsx(p4, { height: "full", children: a }),
    e,
    n && /* @__PURE__ */ A.jsx(m4, { height: "full", children: a })
  ] });
});
Dl.displayName = "IconInput";
const yde = ({
  commonProps: e,
  ...t
}) => {
  const n = (o, a) => {
    const s = bde(o, a);
    s && t.onPlaceChanged && t.onPlaceChanged(s);
  }, r = hw(t.mapsLoader, n);
  return /* @__PURE__ */ A.jsx(
    Dl,
    {
      icon: "map-pin",
      input: /* @__PURE__ */ A.jsx(
        no,
        {
          ...e,
          ref: r,
          type: "text",
          value: t.value ?? "",
          onChange: _s(t.onChange, t.onClear),
          placeholder: "Enter an address"
        }
      )
    }
  );
}, Sde = (e, t) => {
  var c;
  if (!e)
    return;
  const n = Oo(e, "street_number") || ((c = t == null ? void 0 : t.match(/\d+/)) == null ? void 0 : c[0]);
  if (!n)
    return;
  const r = Oo(e, "route");
  if (!r)
    return;
  const o = Oo(e, "subpremise"), a = Oo(e, "locality");
  if (!a)
    return;
  const s = Oo(e, "administrative_area_level_1");
  if (!s)
    return;
  const l = Oo(e, "postal_code");
  if (l)
    return `${n} ${r}${o ? `, ${o}` : ""}, ${a}, ${s}, ${l}`;
}, Ade = ({
  commonProps: e,
  ...t
}) => {
  const [n, r] = je(
    t.value ? rre(t.value) : ""
  ), [o, a] = je(!0), s = (h) => {
    r(h.target.value);
  }, l = () => {
    var h;
    (h = t.onBlur) == null || h.call(t), o || t.setInternalFormWrapperErrorText("Address format isn't valid");
  }, c = (h, m) => {
    const g = Sde(h, m);
    g && r(g);
  }, d = hw(t.mapsLoader, c), f = t.formatValue ?? ((h) => h);
  return ft(() => {
    if (n)
      try {
        t.onChange(ore(n)), t.setInternalFormWrapperErrorText(void 0), a(!0);
      } catch {
        a(!1);
      }
    else
      t.onClear();
  }, [n]), /* @__PURE__ */ A.jsx(
    Dl,
    {
      icon: "map-pin",
      input: /* @__PURE__ */ A.jsx(
        no,
        {
          ...e,
          ref: d,
          type: "text",
          value: f(n),
          onChange: s,
          onBlur: l
        }
      )
    }
  );
}, Mde = ({
  commonProps: e,
  ...t
}) => {
  const n = t.formatValue ?? dc;
  return /* @__PURE__ */ A.jsx(
    no,
    {
      ...e,
      type: "month",
      value: n(t.value),
      onChange: _s(t.onChange, t.onClear)
    }
  );
}, xde = nt(({ commonProps: e, ...t }, n) => {
  const r = t.formatValue ?? dc;
  return /* @__PURE__ */ A.jsx(
    Ox,
    {
      ...e,
      ref: n,
      onChange: _s(t.onChange, t.onClear),
      value: r(t.value),
      inputMode: "text"
    }
  );
}), pw = (e, t, n) => {
  $t(e) && $t(t) && e !== "" && n(ph.round(e, t));
}, l9 = (e) => Number.isNaN(e) || !$t(e) ? "" : e, u9 = (e, t) => (n) => {
  const r = i9(n);
  r === "" ? t() : e(+r);
}, _de = ({
  commonProps: e,
  ...t
}) => {
  const n = u9(t.onChange, t.onClear), r = t.formatValue ?? l9, { prefix: o, suffix: a } = t, s = {};
  return a && (s.rightAddon = a, s.rightAddonProps = {
    height: "100%",
    marginY: "auto"
  }), o && (s.leftAddon = o, s.leftAddonProps = {
    height: "100%",
    marginY: "auto"
  }), /* @__PURE__ */ A.jsx(
    s9,
    {
      ...s,
      input: /* @__PURE__ */ A.jsx(
        no,
        {
          ...e,
          value: r(t.value),
          onChange: n,
          onBlur: () => {
            var l;
            pw(t.value, t.precision, t.onChange), (l = t.onBlur) == null || l.call(t);
          },
          type: "number"
        }
      )
    }
  );
}, Ide = ({
  commonProps: e,
  ...t
}) => {
  const n = u9(t.onChange, t.onClear), r = t.formatValue ?? l9;
  return /* @__PURE__ */ A.jsx(
    Dl,
    {
      icon: "percent",
      placeIconRight: !0,
      input: /* @__PURE__ */ A.jsx(
        no,
        {
          type: "number",
          ...e,
          onChange: n,
          onBlur: () => {
            var o;
            pw(t.value, t.precision, t.onChange), (o = t.onBlur) == null || o.call(t);
          },
          value: r(t.value)
        }
      )
    }
  );
};
function jC(e) {
  const { anchorOffset: t = 0, focusOffset: n = 0 } = e.ownerDocument.getSelection() || {}, r = Math.min(t, n), o = Math.max(t, n);
  return [r, o];
}
function wde(e, [t, n]) {
  var r, o;
  const a = e.ownerDocument, s = a.createRange();
  s.setStart(e.firstChild || e, Math.min(t, ((r = e.textContent) === null || r === void 0 ? void 0 : r.length) || 0)), s.setEnd(e.lastChild || e, Math.min(n, ((o = e.textContent) === null || o === void 0 ? void 0 : o.length) || 0));
  const l = a.getSelection();
  l && (l.removeAllRanges(), l.addRange(s));
}
class Lde {
  constructor(t) {
    this.element = t, this.maxLength = 1 / 0;
  }
  get value() {
    return this.element.innerText.replace(/\n\n$/, `
`);
  }
  set value(t) {
    this.element.innerHTML = t.replace(/\n$/, `

`);
  }
  get selectionStart() {
    return jC(this.element)[0];
  }
  get selectionEnd() {
    return jC(this.element)[1];
  }
  setSelectionRange(t, n) {
    wde(this.element, [t || 0, n || 0]);
  }
  select() {
    this.setSelectionRange(0, this.value.length);
  }
}
function Rde(e) {
  const t = new Lde(e);
  return new Proxy(e, {
    get(n, r) {
      if (r in t)
        return t[r];
      const o = n[r];
      return typeof o == "function" ? o.bind(n) : o;
    },
    set(n, r, o, a) {
      return Reflect.set(r in t ? t : n, r, o, a);
    }
  });
}
const Ede = (e) => e.isContentEditable ? Rde(e) : e.querySelector("input,textarea") || e, c9 = {
  mask: /^.*$/,
  preprocessors: [],
  postprocessors: [],
  plugins: [],
  overwriteMode: "shift"
};
class Dde {
  constructor() {
    this.now = null, this.past = [], this.future = [];
  }
  undo() {
    const t = this.past.pop();
    t && this.now && (this.future.push(this.now), this.updateElement(t, "historyUndo"));
  }
  redo() {
    const t = this.future.pop();
    t && this.now && (this.past.push(this.now), this.updateElement(t, "historyRedo"));
  }
  updateHistory(t) {
    if (!this.now) {
      this.now = t;
      return;
    }
    const n = this.now.value !== t.value, r = this.now.selection.some((o, a) => o !== t.selection[a]);
    !n && !r || (n && (this.past.push(this.now), this.future = []), this.now = t);
  }
  updateElement(t, n) {
    this.now = t, this.updateElementState(t, { inputType: n, data: null });
  }
}
function Nde(e, ...t) {
  return t.every(({ value: n }) => n === e.value);
}
function Tde(e, ...t) {
  return t.every(({ value: n, selection: r }) => n === e.value && r[0] === e.selection[0] && r[1] === e.selection[1]);
}
function Pde({ value: e, selection: t }, n, r) {
  const [o, a] = t, s = typeof r == "function" ? r({ value: e, selection: t }) : r;
  return {
    value: e,
    selection: s === "replace" ? [o, o + n.length] : [o, a]
  };
}
function Gh(e) {
  return typeof e == "string";
}
function WC(e, t, n, r) {
  let o = "";
  for (let a = t.length; a < e.length; a++) {
    const s = e[a], l = (r == null ? void 0 : r.value[a]) === s;
    if (!Gh(s) || s === n && !l)
      return o;
    o += s;
  }
  return o;
}
function mw(e, t) {
  return Array.isArray(t) ? e.length === t.length && Array.from(e).every((n, r) => {
    const o = t[r];
    return Gh(o) ? n === o : n.match(o);
  }) : t.test(e);
}
function kde(e, t, n) {
  let r = null, o = null;
  const a = Array.from(e.value).reduce((l, c, d) => {
    const f = WC(t, l, c, n), h = l + f, m = t[h.length];
    return Gh(m) ? h + m : c.match(m) ? (r === null && d >= e.selection[0] && (r = h.length), o === null && d >= e.selection[1] && (o = h.length), h + c) : h;
  }, ""), s = WC(t, a, "", n);
  return {
    value: mw(a + s, t) ? a + s : a,
    selection: [r ?? a.length, o ?? a.length]
  };
}
function Vde({ value: e, selection: t }, n) {
  const [r, o] = t;
  let a = r, s = o;
  return { value: Array.from(e).reduce((c, d, f) => {
    const h = c + d;
    return r === f && (a = c.length), o === f && (s = c.length), h.match(n) ? h : c;
  }, ""), selection: [a, s] };
}
function s2(e, t, n = null) {
  if (mw(e.value, t))
    return e;
  const { value: r, selection: o } = Array.isArray(t) ? kde(e, t, n) : Vde(e, t);
  return {
    selection: o,
    value: Array.isArray(t) ? r.slice(0, t.length) : r
  };
}
function zC(e, t) {
  if (!Array.isArray(t))
    return e;
  const [n, r] = e.selection, o = [], a = Array.from(e.value).reduce((s, l, c) => {
    const d = t[c];
    return c === n && o.push(s.length), c === r && o.push(s.length), Gh(d) && d === l ? s : s + l;
  }, "");
  return o.length < 2 && o.push(...new Array(2 - o.length).fill(a.length)), {
    value: a,
    selection: [o[0], o[1]]
  };
}
class G3 {
  constructor(t, n) {
    this.initialElementState = t, this.maskOptions = n, this.value = "", this.selection = [0, 0];
    const { value: r, selection: o } = s2(this.initialElementState, this.getMaskExpression(this.initialElementState));
    this.value = r, this.selection = o;
  }
  addCharacters([t, n], r) {
    const { value: o } = this, a = this.getMaskExpression({
      value: o.slice(0, t) + r + o.slice(n),
      selection: [t + r.length, t + r.length]
    }), s = { value: o, selection: [t, n] }, l = zC(s, a), [c, d] = Pde(l, r, this.maskOptions.overwriteMode).selection, f = l.value.slice(0, c) + r, h = f.length, m = s2({
      value: f + l.value.slice(d),
      selection: [h, h]
    }, a, s);
    if (// eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
    o.slice(0, c) === s2({
      value: f,
      selection: [h, h]
    }, a, s).value || Tde(this, m))
      throw new Error("Invalid mask value");
    this.value = m.value, this.selection = m.selection;
  }
  deleteCharacters([t, n]) {
    if (t === n || !n)
      return;
    const { value: r } = this, o = this.getMaskExpression({
      value: r.slice(0, t) + r.slice(n),
      selection: [t, t]
    }), a = { value: r, selection: [t, n] }, s = zC(a, o), [l, c] = s.selection, d = s.value.slice(0, l) + s.value.slice(c), f = s2({ value: d, selection: [l, l] }, o, a);
    this.value = f.value, this.selection = f.selection;
  }
  getMaskExpression(t) {
    const { mask: n } = this.maskOptions;
    return typeof n == "function" ? n(t) : n;
  }
}
class Ode {
  constructor(t) {
    this.element = t, this.listeners = [];
  }
  listen(t, n, r) {
    const o = n;
    this.element.addEventListener(t, o, r), this.listeners.push(() => this.element.removeEventListener(t, o));
  }
  destroy() {
    this.listeners.forEach((t) => t());
  }
}
const ca = {
  CTRL: 1,
  ALT: 2,
  SHIFT: 4,
  META: 8
}, P1 = {
  Y: 89,
  Z: 90
};
function k1(e, t, n) {
  return e.ctrlKey === !!(t & ca.CTRL) && e.altKey === !!(t & ca.ALT) && e.shiftKey === !!(t & ca.SHIFT) && e.metaKey === !!(t & ca.META) && /**
   * We intentionally use legacy {@link KeyboardEvent#keyCode `keyCode`} property. It is more
   * "keyboard-layout"-independent than {@link KeyboardEvent#key `key`} or {@link KeyboardEvent#code `code`} properties.
   * @see {@link https://github.com/taiga-family/maskito/issues/315 `KeyboardEvent#code` issue}
   */
  e.keyCode === n;
}
function Fde(e) {
  return k1(e, ca.CTRL, P1.Y) || // Windows
  k1(e, ca.CTRL | ca.SHIFT, P1.Z) || // Windows & Android
  k1(e, ca.META | ca.SHIFT, P1.Z);
}
function Bde(e) {
  return k1(e, ca.CTRL, P1.Z) || // Windows & Android
  k1(e, ca.META, P1.Z);
}
function Ku(e, t) {
  var n;
  const r = e.value;
  if (typeof t == "string")
    e.value = t;
  else {
    const [o, a] = t.selection;
    e.value = t.value, e.matches(":focus") && ((n = e.setSelectionRange) === null || n === void 0 || n.call(e, o, a));
  }
  e.value !== r && e.dispatchEvent(new Event(
    "input",
    /**
     * React handles this event only on bubbling phase
     *
     * here is the list of events that are processed in the capture stage, others are processed in the bubbling stage
     * https://github.com/facebook/react/blob/cb2439624f43c510007f65aea5c50a8bb97917e4/packages/react-dom-bindings/src/events/DOMPluginEventSystem.js#L222
     */
    { bubbles: !0 }
  ));
}
function Hde({ value: e, selection: t }, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  const a = n ? e.slice(r).indexOf(`
`) + 1 || e.length : e.slice(0, o).lastIndexOf(`
`) + 1;
  return [n ? r : a, n ? a : o];
}
function Gde({ value: e, selection: t }, n) {
  const [r, o] = t;
  return r !== o ? [r, o] : (n ? [r, o + 1] : [r - 1, o]).map((s) => Math.min(Math.max(s, 0), e.length));
}
const $de = /\s+$/g, Zde = /^\s+/g, UC = /\s/;
function jde({ value: e, selection: t }, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  if (n) {
    const c = e.slice(r), [d] = c.match(Zde) || [
      ""
    ], f = c.trimStart().search(UC);
    return [
      r,
      f !== -1 ? r + d.length + f : e.length
    ];
  }
  const a = e.slice(0, o), [s] = a.match($de) || [""], l = a.trimEnd().split("").reverse().findIndex((c) => c.match(UC));
  return [
    l !== -1 ? o - s.length - l : 0,
    o
  ];
}
function Nf(e = []) {
  return (t, ...n) => e.reduce((r, o) => Object.assign(Object.assign({}, r), o(r, ...n)), t);
}
function Sd(e, t) {
  const n = Object.assign(Object.assign({}, c9), t), r = Nf(n.preprocessors), o = Nf(n.postprocessors), a = typeof e == "string" ? { value: e, selection: [0, 0] } : e, { elementState: s } = r({ elementState: a, data: "" }, "validation"), l = new G3(s, n), { value: c, selection: d } = o(l, a);
  return typeof e == "string" ? c : { value: c, selection: d };
}
function Wde(e) {
  return (t, n) => {
    const r = t.selectionStart || 0, o = t.selectionEnd || 0;
    Ku(t, {
      value: Sd(t.value, e || n),
      selection: [r, o]
    });
  };
}
class zde extends Dde {
  constructor(t, n) {
    super(), this.element = t, this.maskitoOptions = n, this.isTextArea = this.element.nodeName === "TEXTAREA", this.eventListener = new Ode(this.element), this.options = Object.assign(Object.assign({}, c9), this.maskitoOptions), this.preprocessor = Nf(this.options.preprocessors), this.postprocessor = Nf(this.options.postprocessors), this.teardowns = this.options.plugins.map((r) => r(this.element, this.options)), this.updateHistory(this.elementState), this.eventListener.listen("keydown", (r) => {
      if (Fde(r))
        return r.preventDefault(), this.redo();
      if (Bde(r))
        return r.preventDefault(), this.undo();
    }), this.eventListener.listen("beforeinput", (r) => {
      var o;
      const a = r.inputType.includes("Forward");
      switch (this.updateHistory(this.elementState), r.inputType) {
        case "historyUndo":
          return r.preventDefault(), this.undo();
        case "historyRedo":
          return r.preventDefault(), this.redo();
        case "deleteByCut":
        case "deleteContentBackward":
        case "deleteContentForward":
          return this.handleDelete({
            event: r,
            isForward: a,
            selection: Gde(this.elementState, a)
          });
        case "deleteWordForward":
        case "deleteWordBackward":
          return this.handleDelete({
            event: r,
            isForward: a,
            selection: jde(this.elementState, a),
            force: !0
          });
        case "deleteSoftLineBackward":
        case "deleteSoftLineForward":
        case "deleteHardLineBackward":
        case "deleteHardLineForward":
          return this.handleDelete({
            event: r,
            isForward: a,
            selection: Hde(this.elementState, a),
            force: !0
          });
        case "insertCompositionText":
          return;
        case "insertReplacementText":
          return;
        case "insertLineBreak":
        case "insertParagraph":
          return this.handleEnter(r);
        case "insertFromPaste":
        case "insertText":
        case "insertFromDrop":
        default:
          return this.handleInsert(r, r.data || // `event.data` for `contentEditable` is always `null` for paste/drop events
          ((o = r.dataTransfer) === null || o === void 0 ? void 0 : o.getData("text/plain")) || "");
      }
    }), this.eventListener.listen("input", ({ inputType: r }) => {
      r !== "insertCompositionText" && (this.ensureValueFitsMask(), this.updateHistory(this.elementState));
    }), this.eventListener.listen("compositionend", () => {
      this.ensureValueFitsMask(), this.updateHistory(this.elementState);
    });
  }
  get elementState() {
    const { value: t, selectionStart: n, selectionEnd: r } = this.element;
    return {
      value: t,
      selection: [n || 0, r || 0]
    };
  }
  get maxLength() {
    const { maxLength: t } = this.element;
    return t === -1 ? 1 / 0 : t;
  }
  destroy() {
    this.eventListener.destroy(), this.teardowns.forEach((t) => t == null ? void 0 : t());
  }
  updateElementState({ value: t, selection: n }, r = {
    inputType: "insertText",
    data: null
  }) {
    const o = this.elementState.value;
    this.updateValue(t), this.updateSelectionRange(n), o !== t && this.dispatchInputEvent(r);
  }
  updateSelectionRange([t, n]) {
    var r;
    const { element: o } = this;
    o.matches(":focus") && (o.selectionStart !== t || o.selectionEnd !== n) && ((r = o.setSelectionRange) === null || r === void 0 || r.call(o, t, n));
  }
  updateValue(t) {
    this.element.value = t;
  }
  ensureValueFitsMask() {
    this.updateElementState(Sd(this.elementState, this.options));
  }
  dispatchInputEvent(t = {
    inputType: "insertText",
    data: null
  }) {
    globalThis.InputEvent && this.element.dispatchEvent(new InputEvent("input", Object.assign(Object.assign({}, t), { bubbles: !0, cancelable: !1 })));
  }
  handleDelete({ event: t, selection: n, isForward: r, force: o = !1 }) {
    const a = {
      value: this.elementState.value,
      selection: n
    }, [s, l] = a.selection, { elementState: c } = this.preprocessor({
      elementState: a,
      data: ""
    }, r ? "deleteForward" : "deleteBackward"), d = new G3(c, this.options), [f, h] = c.selection;
    d.deleteCharacters([f, h]);
    const m = this.postprocessor(d, a);
    if (!(a.value.slice(0, s) + a.value.slice(l) === m.value && !o && !this.element.isContentEditable)) {
      if (t.preventDefault(), Nde(a, c, d, m))
        return this.updateSelectionRange(r ? [h, h] : [f, f]);
      this.updateElementState(m, {
        inputType: t.inputType,
        data: null
      }), this.updateHistory(m);
    }
  }
  handleInsert(t, n) {
    const r = this.elementState, { elementState: o, data: a = n } = this.preprocessor({
      data: n,
      elementState: r
    }, "insert"), s = new G3(o, this.options);
    try {
      s.addCharacters(o.selection, a);
    } catch {
      return t.preventDefault();
    }
    const [l, c] = o.selection, d = r.value.slice(0, l) + n + r.value.slice(c), f = this.postprocessor(s, r);
    if (f.value.length > this.maxLength)
      return t.preventDefault();
    (d !== f.value || this.element.isContentEditable) && (t.preventDefault(), this.updateElementState(f, {
      data: n,
      inputType: t.inputType
    }), this.updateHistory(f));
  }
  handleEnter(t) {
    (this.isTextArea || this.element.isContentEditable) && this.handleInsert(t, `
`);
  }
}
function Qu(e, t, n) {
  const r = Math.min(Number(n), Math.max(Number(t), Number(e)));
  return e instanceof Date ? new Date(r) : r;
}
const Ude = [".", ",", "б", "ю"], Xde = [":", "."], Yde = " ", qde = "​", gw = "–", vw = "—", Tf = "-", $3 = "−", Cw = "ー", bw = /[\\^$.*+?()[\]{}|]/g, Jde = new RegExp(bw.source);
function Hr(e) {
  return e && Jde.test(e) ? e.replaceAll(bw, "\\$&") : e;
}
function Ca(e, { prefix: t, postfix: n }) {
  var r, o;
  const a = new RegExp(`^${Hr(t)}`), s = new RegExp(`${Hr(n)}$`), [l = ""] = (r = e.match(a)) !== null && r !== void 0 ? r : [], [c = ""] = (o = e.match(s)) !== null && o !== void 0 ? o : [], d = e.replace(a, "").replace(s, "");
  return { extractedPrefix: l, extractedPostfix: c, cleanValue: d };
}
function Kde(e, t) {
  let n = "";
  for (let r = 0; r < e.length; r++) {
    if (e[r] !== t[r])
      return n;
    n += e[r];
  }
  return n;
}
function Ad(e) {
  return e;
}
function XC(e) {
  return e.replaceAll(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248));
}
function Qde() {
  return ({ elementState: e, data: t }) => {
    const { value: n, selection: r } = e;
    return {
      elementState: {
        selection: r,
        value: XC(n)
      },
      data: XC(t)
    };
  };
}
function e0e(e) {
  const t = new RegExp(`${Hr(e)}$`);
  return e ? ({ value: n, selection: r }, o) => {
    if (!n && !o.value.endsWith(e))
      return { value: n, selection: r };
    if (!n.endsWith(e) && !o.value.endsWith(e))
      return { selection: r, value: n + e };
    const a = o.value.replace(t, ""), s = o.selection[1] >= a.length, l = Kde(a, n);
    return {
      selection: r,
      value: Array.from(e).reverse().reduce((c, d, f) => {
        const h = c.length - 1 - f, m = l[h] === d && s;
        return c[h] !== d || m ? c.slice(0, h + 1) + d + c.slice(h + 1) : c;
      }, n)
    };
  } : Ad;
}
function t0e(e) {
  return e ? ({ value: t, selection: n }, r) => {
    if (t.startsWith(e) || // already valid
    !t && !r.value.startsWith(e))
      return { value: t, selection: n };
    const [o, a] = n, s = Array.from(e).reduce((c, d, f) => c[f] === d ? c : c.slice(0, f) + d + c.slice(f), t), l = s.length - t.length;
    return {
      selection: [o + l, a + l],
      value: s
    };
  } : Ad;
}
function K1(e, t, n) {
  return (r, o) => {
    const a = () => t(r, o);
    return r.addEventListener(e, a, n), () => r.removeEventListener(e, a, n);
  };
}
function yw(e) {
  return (t) => {
    const n = t.ownerDocument;
    let r = 0;
    const o = () => r++, a = () => {
      r = Math.max(--r, 0);
    }, s = () => {
      if (!t.matches(":focus"))
        return;
      if (r)
        return n.addEventListener("mouseup", s, {
          once: !0,
          passive: !0
        });
      const l = t.selectionStart || 0, c = t.selectionEnd || 0, [d, f] = e(t.value, [l, c]);
      (d > l || f < c) && t.setSelectionRange(Qu(l, d, f), Qu(c, d, f));
    };
    return n.addEventListener("selectionchange", s, { passive: !0 }), t.addEventListener("mousedown", o, { passive: !0 }), n.addEventListener("mouseup", a, { passive: !0 }), () => {
      n.removeEventListener("selectionchange", s), n.removeEventListener("mousedown", o), n.removeEventListener("mouseup", a);
    };
  };
}
function n0e(e, t = !1) {
  let n = "", r = "validation";
  const o = (l) => {
    for (let c = l.length - 1; c >= n.length; c--)
      if (l[c] !== e[c])
        return l.slice(0, c + 1);
    return l.slice(0, n.length);
  }, a = [yw((l) => [0, o(l).length])];
  let s = !1;
  if (t) {
    const l = K1("focus", (d) => {
      s = !0, Ku(d, d.value + e.slice(d.value.length));
    }, { capture: !0 }), c = K1("blur", (d) => {
      s = !1, Ku(d, o(d.value));
    }, { capture: !0 });
    a.push(l, c);
  }
  return {
    plugins: a,
    removePlaceholder: o,
    preprocessors: [
      ({ elementState: l, data: c }, d) => {
        r = d;
        const { value: f, selection: h } = l;
        return {
          elementState: {
            selection: h,
            value: o(f)
          },
          data: c
        };
      }
    ],
    postprocessors: [
      ({ value: l, selection: c }, d) => {
        n = l;
        const f = l !== d.value && (s || !t) ? l + e.slice(l.length) : l;
        if (f === d.value && r === "deleteBackward") {
          const [h] = d.selection;
          return {
            value: f,
            selection: [h, h]
          };
        }
        return { value: f, selection: c };
      }
    ]
  };
}
new RegExp(`[${Xde.map(Hr).join("")}]$`);
function r0e({ prefix: e, postfix: t }) {
  return ({ elementState: n, data: r }) => {
    const { cleanValue: o } = Ca(r, {
      prefix: e,
      postfix: t
    });
    return {
      elementState: n,
      data: o
    };
  };
}
function Sw({ decimalSeparator: e, isNegativeAllowed: t, precision: n, thousandSeparator: r, prefix: o, postfix: a, decimalPseudoSeparators: s = [], pseudoMinuses: l = [], minusSign: c }) {
  const d = YC(o), f = "\\d", h = t ? `[${c}${l.map((C) => `\\${C}`).join("")}]?` : "", m = r ? `[${f}${Hr(r).replaceAll(/\s/g, "\\s")}]*` : `[${f}]*`, g = n > 0 ? `([${Hr(e)}${s.map(Hr).join("")}]${f}{0,${Number.isFinite(n) ? n : ""}})?` : "", b = YC(a);
  return new RegExp(`^${d}${h}${m}${g}${b}$`);
}
function YC(e) {
  return e ? `${e.split("").map((t) => `${Hr(t)}?`).join("")}` : "";
}
function d9(e, t = ".") {
  const n = !!e.match(new RegExp(`^\\D*[${$3}\\${Tf}${gw}${vw}${Cw}]`)), r = Hr(t), o = e.replaceAll(new RegExp(`${r}(?!\\d)`, "g"), "").replaceAll(new RegExp(`[^\\d${r}]`, "g"), "").replace(t, ".");
  return o ? Number((n ? Tf : "") + o) : NaN;
}
function o0e(e) {
  const t = String(e), [n, r] = t.split("e-");
  let o = t;
  if (r) {
    const [, a] = n.split("."), s = Number(r) + ((a == null ? void 0 : a.length) || 0);
    o = e.toFixed(s);
  }
  return o;
}
function Aw(e, { decimalSeparator: t, thousandSeparator: n }) {
  const [r = "", o = ""] = e.split(t), [, a = "", s = ""] = r.match(new RegExp(`([^\\d${Hr(n)}]+)?(.*)`)) || [];
  return { minus: a, integerPart: s, decimalPart: o };
}
function a0e({ decimalSeparator: e, thousandSeparator: t, decimalPseudoSeparators: n = Ude }) {
  return n.filter((r) => r !== t && r !== e);
}
function i0e({ decimalSeparator: e, precision: t, decimalZeroPadding: n, prefix: r, postfix: o }) {
  return t <= 0 || !n ? Ad : ({ value: a, selection: s }) => {
    const { cleanValue: l, extractedPrefix: c, extractedPostfix: d } = Ca(a, {
      prefix: r,
      postfix: o
    });
    if (Number.isNaN(d9(l, e)))
      return { value: a, selection: s };
    const [f, h = ""] = l.split(e);
    return {
      value: c + f + e + h.padEnd(t, "0") + d,
      selection: s
    };
  };
}
function s0e({ prefix: e, postfix: t, decimalSeparator: n, thousandSeparator: r }) {
  return ({ value: o, selection: a }) => {
    const [s] = a, { cleanValue: l, extractedPrefix: c, extractedPostfix: d } = Ca(o, {
      prefix: e,
      postfix: t
    }), { minus: f, integerPart: h, decimalPart: m } = Aw(l, {
      decimalSeparator: n,
      thousandSeparator: r
    }), g = !h && !m && l.includes(n);
    return !h && !Number(m) && s === (f + c).length || g ? {
      selection: a,
      value: c + f + d
    } : { value: o, selection: a };
  };
}
function l0e({ decimalSeparator: e, decimalPseudoSeparators: t, pseudoMinuses: n, prefix: r, postfix: o, minusSign: a }) {
  let s = !0;
  const l = Sw({
    decimalSeparator: e,
    decimalPseudoSeparators: t,
    pseudoMinuses: n,
    prefix: "",
    postfix: "",
    thousandSeparator: "",
    precision: 1 / 0,
    isNegativeAllowed: !0,
    minusSign: a
  });
  return ({ elementState: c, data: d }) => {
    if (!s)
      return { elementState: c, data: d };
    s = !1;
    const { value: f, selection: h } = c, [m, g] = h, { extractedPrefix: b, cleanValue: C, extractedPostfix: y } = Ca(f, {
      prefix: r,
      postfix: o
    }), _ = Sd({
      selection: [
        Math.max(m - b.length, 0),
        Qu(g - b.length, 0, C.length)
      ],
      value: C
    }, {
      mask: l
    }), [x, I] = _.selection;
    return {
      elementState: {
        selection: [
          x + b.length,
          I + b.length
        ],
        value: b + _.value + y
      },
      data: d
    };
  };
}
function u0e({ decimalSeparator: e, thousandSeparator: t, prefix: n, postfix: r }) {
  const o = (s) => {
    const l = Hr(t);
    return s.replace(
      // all leading zeroes followed by another zero
      new RegExp(`^(\\D+)?[0${l}]+(?=0)`),
      "$1"
    ).replace(
      // zero followed by not-zero digit
      new RegExp(`^(\\D+)?[0${l}]+(?=[1-9])`),
      "$1"
    );
  }, a = (s, l) => {
    const c = s.slice(0, l), d = s.slice(l).startsWith("0");
    return c.length - o(c).length + (d ? 1 : 0);
  };
  return ({ value: s, selection: l }) => {
    const [c, d] = l, { cleanValue: f, extractedPrefix: h, extractedPostfix: m } = Ca(s, {
      prefix: n,
      postfix: r
    }), g = f.includes(e), [b, C = ""] = f.split(e), y = o(b);
    if (b === y)
      return { value: s, selection: l };
    const _ = c - a(s, c), x = d - a(s, d);
    return {
      value: h + y + (g ? e : "") + C + m,
      selection: [Math.max(_, 0), Math.max(x, 0)]
    };
  };
}
function c0e({ min: e, max: t, decimalSeparator: n, minusSign: r }) {
  return ({ value: o, selection: a }) => {
    const s = d9(o, n), l = (
      /**
       * We cannot limit lower bound if user enters positive number.
       * The same for upper bound and negative number.
       * ___
       * @example (min = 5)
       * Empty input => Without this condition user cannot type 42 (the first digit will be rejected)
       * ___
       * @example (max = -10)
       * Value is -10 => Without this condition user cannot delete 0 to enter another digit
       */
      s > 0 ? Math.min(s, t) : Math.max(s, e)
    );
    if (s && l !== s) {
      const c = `${l}`.replace(".", n).replace(Tf, r);
      return {
        value: c,
        selection: [c.length, c.length]
      };
    }
    return {
      value: o,
      selection: a
    };
  };
}
function d0e({ decimalSeparator: e, thousandSeparator: t, decimalZeroPadding: n }) {
  return ({ elementState: r, data: o }, a) => {
    const { value: s, selection: l } = r, [c, d] = l, f = s.slice(c, d), h = n ? [e, t] : [t], m = n && c > s.indexOf(e) && !!f.match(/^0+$/gi);
    return a !== "deleteBackward" && a !== "deleteForward" || !h.includes(f) && !m ? {
      elementState: r,
      data: o
    } : {
      elementState: {
        value: s,
        selection: a === "deleteForward" ? [d, d] : [c, c]
      },
      data: o
    };
  };
}
function f0e({ decimalSeparator: e, precision: t, prefix: n, postfix: r }) {
  const o = new RegExp(`^\\D*${Hr(e)}`);
  return ({ elementState: a, data: s }) => {
    const { value: l, selection: c } = a, { cleanValue: d, extractedPrefix: f } = Ca(l, {
      prefix: n,
      postfix: r
    }), [h, m] = c, g = Qu(h - f.length, 0, d.length), b = Qu(m - f.length, 0, d.length);
    if (t <= 0 || d.slice(0, g).includes(e) || d.slice(b).includes(e) || !s.match(o))
      return { elementState: a, data: s };
    const C = d.slice(0, g).match(/\d+/);
    return {
      elementState: a,
      data: C ? s : `0${s}`
    };
  };
}
function qC({ validCharacter: e, pseudoCharacters: t, prefix: n, postfix: r }) {
  const o = new RegExp(`[${t.join("")}]`, "gi");
  return ({ elementState: a, data: s }) => {
    const { value: l, selection: c } = a, { cleanValue: d, extractedPostfix: f, extractedPrefix: h } = Ca(l, {
      prefix: n,
      postfix: r
    });
    return {
      elementState: {
        selection: c,
        value: h + d.replace(o, e) + f
      },
      data: s.replace(o, e)
    };
  };
}
function h0e({ decimalSeparator: e, prefix: t, postfix: n }) {
  return ({ elementState: r, data: o }) => {
    const { value: a, selection: s } = r, [l, c] = s, { cleanValue: d } = Ca(a, { prefix: t, postfix: n });
    return {
      elementState: r,
      data: !d.includes(e) || a.slice(l, c + 1).includes(e) ? o : o.replaceAll(new RegExp(Hr(e), "gi"), "")
    };
  };
}
function p0e({ thousandSeparator: e, decimalSeparator: t, prefix: n, postfix: r }) {
  if (!e)
    return Ad;
  const o = (...a) => a.every((s) => /\s/.test(s));
  return ({ value: a, selection: s }) => {
    const { cleanValue: l, extractedPostfix: c, extractedPrefix: d } = Ca(a, {
      prefix: n,
      postfix: r
    }), { minus: f, integerPart: h, decimalPart: m } = Aw(l, {
      decimalSeparator: t,
      thousandSeparator: e
    }), [g, b] = s;
    let [C, y] = s;
    const _ = Array.from(h).reduceRight((x, I, R) => {
      const k = !(!R && I === e) && x.length && (x.length + 1) % 4 === 0;
      return k && (I === e || o(I, e)) ? e + x : I === e && !k ? (R && R <= g && C--, R && R <= b && y--, x) : k ? (R <= g && C++, R <= b && y++, I + e + x) : I + x;
    }, "");
    return {
      value: d + f + _ + (l.includes(t) ? t : "") + m + c,
      selection: [C, y]
    };
  };
}
function m0e({ precision: e, decimalSeparator: t, prefix: n, postfix: r }) {
  if (e > 0)
    return Ad;
  const o = new RegExp(`${Hr(t)}.*$`, "g");
  return ({ elementState: a, data: s }) => {
    const { value: l, selection: c } = a, { cleanValue: d, extractedPrefix: f, extractedPostfix: h } = Ca(l, {
      prefix: n,
      postfix: r
    }), [m, g] = c, b = f + d.replace(o, "") + h;
    return {
      elementState: {
        selection: [
          Math.min(m, b.length),
          Math.min(g, b.length)
        ],
        value: b
      },
      data: s.replace(o, "")
    };
  };
}
const JC = [0, 0];
function g0e({ decimalSeparator: e, thousandSeparator: t, prefix: n, postfix: r }) {
  const o = u0e({
    decimalSeparator: e,
    thousandSeparator: t,
    prefix: n,
    postfix: r
  });
  return K1("blur", (a) => {
    const s = o({
      value: a.value,
      selection: JC
    }, { value: "", selection: JC }).value;
    Ku(a, s);
  }, { capture: !0 });
}
function v0e({ min: e, max: t, decimalSeparator: n }) {
  return K1("blur", (r, o) => {
    const a = d9(r.value, n), s = Qu(a, e, t);
    !Number.isNaN(a) && a !== s && Ku(r, Sd(o0e(s), o));
  }, { capture: !0 });
}
function C0e({ decimalSeparator: e, prefix: t, postfix: n }) {
  return K1("blur", (r) => {
    const { cleanValue: o, extractedPostfix: a, extractedPrefix: s } = Ca(r.value, { prefix: t, postfix: n }), l = s + o.replace(new RegExp(`^(\\D+)?${Hr(e)}`), `$10${e}`) + a;
    Ku(r, l);
  }, { capture: !0 });
}
function b0e({ max: e = Number.MAX_SAFE_INTEGER, min: t = Number.MIN_SAFE_INTEGER, precision: n = 0, thousandSeparator: r = Yde, decimalSeparator: o = ".", decimalPseudoSeparators: a, decimalZeroPadding: s = !1, prefix: l = "", postfix: c = "", minusSign: d = $3 } = {}) {
  const f = [
    Tf,
    gw,
    vw,
    Cw,
    $3
  ].filter((g) => g !== r && g !== o && g !== d), h = a0e({
    decimalSeparator: o,
    thousandSeparator: r,
    decimalPseudoSeparators: a
  }), m = l.endsWith(o) && n > 0 ? `${l}${qde}` : l;
  return Object.assign(Object.assign({}, c9), { mask: Sw({
    decimalSeparator: o,
    precision: n,
    thousandSeparator: r,
    prefix: m,
    postfix: c,
    isNegativeAllowed: t < 0,
    minusSign: d
  }), preprocessors: [
    Qde(),
    l0e({
      decimalSeparator: o,
      decimalPseudoSeparators: h,
      pseudoMinuses: f,
      prefix: m,
      postfix: c,
      minusSign: d
    }),
    r0e({ prefix: m, postfix: c }),
    qC({
      validCharacter: d,
      pseudoCharacters: f,
      prefix: m,
      postfix: c
    }),
    qC({
      validCharacter: o,
      pseudoCharacters: h,
      prefix: m,
      postfix: c
    }),
    f0e({
      decimalSeparator: o,
      precision: n,
      prefix: m,
      postfix: c
    }),
    d0e({
      decimalSeparator: o,
      decimalZeroPadding: s,
      thousandSeparator: r
    }),
    m0e({
      precision: n,
      decimalSeparator: o,
      prefix: m,
      postfix: c
    }),
    h0e({
      decimalSeparator: o,
      prefix: m,
      postfix: c
    })
  ], postprocessors: [
    c0e({ decimalSeparator: o, min: t, max: e, minusSign: d }),
    t0e(m),
    e0e(c),
    p0e({
      decimalSeparator: o,
      thousandSeparator: r,
      prefix: m,
      postfix: c
    }),
    i0e({
      decimalSeparator: o,
      decimalZeroPadding: s,
      precision: n,
      prefix: m,
      postfix: c
    }),
    s0e({ prefix: m, postfix: c, decimalSeparator: o, thousandSeparator: r })
  ], plugins: [
    g0e({
      decimalSeparator: o,
      thousandSeparator: r,
      prefix: m,
      postfix: c
    }),
    C0e({
      decimalSeparator: o,
      prefix: m,
      postfix: c
    }),
    v0e({ min: t, max: e, decimalSeparator: o })
  ], overwriteMode: s ? ({ value: g, selection: [b] }) => b <= g.indexOf(o) ? "shift" : "replace" : "shift" });
}
const KC = typeof window < "u" ? nc : ft;
function y0e(e) {
  return e && typeof e == "object" && "then" in e;
}
const Mw = ({
  options: e = null,
  elementPredicate: t = Ede
} = {}) => {
  const [n, r] = je(null), [o, a] = je(null), s = te((c) => {
    r(c);
  }, []), l = He(t);
  return l.current = t, KC(() => {
    if (!n)
      return;
    const c = t, d = c(n);
    y0e(d) ? d.then((f) => {
      l.current === c && a(f);
    }) : a(d);
  }, [n, t, l]), KC(() => {
    if (!o || !e)
      return;
    const c = new zde(o, e);
    return () => {
      c.destroy();
    };
  }, [e, o]), s;
}, S0e = (e) => e === "", xw = (e) => e === void 0, Z3 = (e) => xw(e) || typeof e == "string" && S0e(e), _w = "(___) ___-____", { removePlaceholder: A0e, ...M0e } = n0e(_w), x0e = {
  ...M0e,
  mask: ["(", /\d/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]
}, _0e = ({
  commonProps: e,
  ...t
}) => {
  const n = Mw({ options: x0e }), r = t.formatValue ?? dc, o = () => {
    t.onChange(A0e(r(t.value)));
  }, a = Z3(e.placeholder) ? _w : e.placeholder;
  return /* @__PURE__ */ A.jsx(
    Dl,
    {
      icon: "phone",
      input: /* @__PURE__ */ A.jsx(
        no,
        {
          type: "tel",
          onInput: _s(t.onChange, t.onClear),
          value: r(t.value),
          ...e,
          placeholder: a,
          ref: n,
          onBlur: o
        }
      )
    }
  );
}, I0e = ({
  commonProps: e,
  ...t
}) => {
  const n = u9(t.onChange, t.onClear), o = (t.formatValue ? t.formatValue : l9)(t.value), a = /* @__PURE__ */ A.jsx(
    no,
    {
      ...e,
      value: o,
      onChange: n,
      type: "number",
      step: "any",
      autoComplete: "off"
    }
  );
  return t.noIcon ? a : /* @__PURE__ */ A.jsx(Dl, { icon: "money-dollar-circle", input: a });
}, w0e = ({
  ref: e,
  ...t
}) => {
  const {
    min: n,
    max: r,
    resetValue: o,
    valueWhenEmpty: a,
    id: s,
    onClear: l,
    autoFocus: c,
    __dangerDoNotUseSx: d,
    ...f
  } = t, h = () => {
    if (!$t(n) && !$t(r))
      return;
    const C = parseFloat(t.value);
    let y;
    return $t(n) && C < n && (y = o ?? n), $t(r) && C > r && (y = o ?? r), y;
  }, m = () => {
    var y, _;
    const C = h();
    $t(C) ? (t.onChange(C), (y = t.onBlur) == null || y.call(t)) : (_ = t.onBlur) == null || _.call(t);
  }, g = f.onKeyDown ? (C) => {
    const y = h() ?? t.value;
    f.onKeyDown(C, y);
  } : void 0, b = {
    ...f,
    value: $t(t.value) ? t.value : "",
    onBlur: m,
    onChange: (C, y) => {
      const _ = Number.isNaN(y) ? a : y;
      t.onChange(_);
    },
    onKeyDown: g
  };
  return /* @__PURE__ */ A.jsxs(bx, { ...b, clampValueOnBlur: !1, children: [
    /* @__PURE__ */ A.jsx(Sx, { ref: e }),
    $t(b.step) && /* @__PURE__ */ A.jsxs(yx, { children: [
      /* @__PURE__ */ A.jsx(xx, {}),
      /* @__PURE__ */ A.jsx(Mx, {})
    ] })
  ] });
}, L0e = ({
  commonProps: e,
  ...t
}) => {
  const n = t.formatValue ?? dc, r = _s(t.onChange, t.onClear);
  return /* @__PURE__ */ A.jsx(
    Dl,
    {
      icon: "search",
      input: /* @__PURE__ */ A.jsx(
        no,
        {
          ...e,
          type: "text",
          onChange: r,
          value: n(t.value)
        }
      )
    }
  );
}, R0e = ({
  commonProps: e,
  ...t
}) => /* @__PURE__ */ A.jsx(
  no,
  {
    ...e,
    type: "text",
    value: t.formatValue ? t.formatValue(t.value) : t.value ?? "",
    onChange: _s(t.onChange, t.onClear)
  }
), Xr = (e) => e, $h = nt(
  (e, t) => {
    const n = Hh(), r = He(null), o = {
      id: e.id,
      sx: e.__dangerDoNotUseSx,
      ref: t ?? r,
      "data-testid": e.__testId ?? e.id,
      placeholder: e.placeholderText,
      onKeyDown: e.onKeyDown,
      onFocus: e.onFocus,
      onMouseDown: e.onMouseDown,
      onBlur: () => {
        var a;
        return (a = e.onBlur) == null ? void 0 : a.call(e);
      },
      border: e.border,
      borderRadius: e.borderRadius,
      boxShadow: e.boxShadow,
      size: n
    };
    switch (ude(e.autoFocus, t, r), fde(e.type, o.ref), e.type) {
      case "text": {
        const a = Xr(e.value);
        return /* @__PURE__ */ A.jsx(R0e, { ...e, commonProps: o, value: a });
      }
      case "search": {
        const a = Xr(e.value);
        return /* @__PURE__ */ A.jsx(L0e, { ...e, commonProps: o, value: a });
      }
      case "multiline": {
        const a = Xr(e.value), { ref: s, ...l } = o;
        return /* @__PURE__ */ A.jsx(
          xde,
          {
            ...e,
            commonProps: l,
            value: a,
            ref: t
          }
        );
      }
      case "location": {
        const a = Xr(e.value);
        return /* @__PURE__ */ A.jsx(Ade, { ...e, commonProps: o, value: a });
      }
      case "locationAddressAutocomplete": {
        const a = Xr(e.value);
        return /* @__PURE__ */ A.jsx(yde, { ...e, commonProps: o, value: a });
      }
      case "number": {
        const a = Xr(e.value);
        return /* @__PURE__ */ A.jsx(_de, { ...e, commonProps: o, value: a });
      }
      case "percent": {
        const a = Xr(e.value);
        return /* @__PURE__ */ A.jsx(Ide, { ...e, commonProps: o, value: a });
      }
      case "range":
        return /* @__PURE__ */ A.jsx(w0e, { ...e });
      case "aloftArea": {
        const a = Xr(e.value);
        return /* @__PURE__ */ A.jsx(gde, { ...e, commonProps: o, value: a });
      }
      case "price": {
        const a = Xr(e.value);
        return /* @__PURE__ */ A.jsx(I0e, { ...e, commonProps: o, value: a });
      }
      case "aloftPrice": {
        const a = Xr(e.value);
        return /* @__PURE__ */ A.jsx(pde, { ...e, ref: t, value: a });
      }
      case "email": {
        const a = Xr(e.value);
        return /* @__PURE__ */ A.jsx(Cde, { ...e, commonProps: o, value: a });
      }
      case "date": {
        const a = Xr(e.value);
        return /* @__PURE__ */ A.jsx(vde, { ...e, commonProps: o, value: a });
      }
      case "month": {
        const a = Xr(e.value);
        return /* @__PURE__ */ A.jsx(Mde, { ...e, commonProps: o, value: a });
      }
      case "aloftDate":
        return /* @__PURE__ */ A.jsx(hde, { ...e, ref: t });
      case "phone": {
        const a = Xr(e.value);
        return /* @__PURE__ */ A.jsx(_0e, { ...e, commonProps: o, value: a });
      }
      default:
        return Wx(e);
    }
  }
);
$h.displayName = "BaseInput";
const Vme = nt((e, t) => {
  const [n, r] = je(), {
    id: o,
    isDisabled: a,
    isReadonly: s,
    isInvalid: l,
    isRequired: c,
    helperText: d,
    errorText: f,
    label: h,
    ariaLabel: m,
    size: g = "md",
    variant: b,
    clearable: C,
    ...y
  } = e;
  return cc(
    {
      id: o,
      isDisabled: a,
      isReadonly: s,
      isRequired: c,
      isInvalid: l,
      helperText: d,
      errorText: f,
      internalFormWrapperErrorText: n,
      label: h,
      ariaLabel: m,
      size: g,
      variant: b,
      clearable: C
    },
    /* @__PURE__ */ A.jsx(
      $h,
      {
        id: e.id,
        ref: t,
        ...y,
        setInternalFormWrapperErrorText: r
      }
    )
  );
}), E0e = (e, t) => {
  const n = Hh(), {
    onChange: r,
    onFocus: o,
    onBlur: a,
    __dangerDoNotUseSx: s,
    placeholder: l,
    options: c,
    value: d,
    border: f = !0,
    radius: h = !0
  } = e;
  return /* @__PURE__ */ A.jsx(
    Dx,
    {
      border: f ? void 0 : "hidden",
      borderRadius: h ? void 0 : "none",
      ref: t,
      onChange: (m) => {
        const { value: g } = m.currentTarget;
        r(g === "" ? void 0 : g, m);
      },
      onFocus: o,
      onBlur: a,
      sx: s,
      size: n,
      placeholder: l,
      value: d,
      children: c.map(({ label: m, value: g }) => /* @__PURE__ */ A.jsx("option", { value: g, children: m }, g))
    }
  );
}, D0e = nt(E0e), N0e = (e, t) => {
  const { variant: n = "native" } = e;
  switch (n) {
    case "native":
      return cc(e, /* @__PURE__ */ A.jsx(D0e, { ...e, ref: t }));
    default:
      return null;
  }
}, Ome = nt(N0e), Fme = (e) => e.map((t) => ({ value: t, label: ph.startCase(t) })), Bme = nt((e, t) => /* @__PURE__ */ A.jsx(Di, { ref: t, ...e, display: "grid" })), T0e = nt((e, t) => /* @__PURE__ */ A.jsx(Di, { ref: t, ...e, display: "block" })), P0e = ({ width: e, height: t }) => /* @__PURE__ */ A.jsxs("svg", { width: e, height: t, viewBox: "0 0 200 200", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ A.jsx("path", { d: "M72.3229 169.049L86.4221 165.965L62.4673 162.46L72.3229 169.049Z", fill: "#3C70A7" }),
  /* @__PURE__ */ A.jsx(
    "path",
    {
      d: "M43.6861 69.4804L64.0226 88.1552L77.2991 140.806L98.9435 98.7906L87.301 76.5295L43.6861 69.4804Z",
      fill: "#3C70A7"
    }
  ),
  /* @__PURE__ */ A.jsx("path", { d: "M41.653 65.4667L83.0325 71.8327L37.0788 47.4518L41.653 65.4667Z", fill: "#1F364E" }),
  /* @__PURE__ */ A.jsx("path", { d: "M117.659 54.2922L152.739 80.3563L126.191 26.4058L117.659 54.2922Z", fill: "#1F364E" }),
  /* @__PURE__ */ A.jsx(
    "path",
    {
      d: "M132.239 134.244L151.254 84.5434L116.486 58.3245L112.456 81.6043L78.2202 147.134L41.9506 155.788L111.571 165.116L154.879 148.766L168.363 150.105L167.04 147.462L157.788 143.938L149.417 136.447L132.239 134.244Z",
      fill: "#73A9EF"
    }
  )
] });
const Hme = ({ light: e, message: t, __testId: n }) => /* @__PURE__ */ A.jsxs("div", { className: "loading-indicator", "data-testid": n, children: [
  /* @__PURE__ */ A.jsx(P0e, { width: 100, height: 100 }),
  wi(t) ? /* @__PURE__ */ A.jsx(Wo, { color: e ? "textOffset" : void 0, children: t }) : null
] }), k0e = ({ children: e }) => /* @__PURE__ */ A.jsx(Wo, { variant: "h3", __dangerDoNotUseSx: { fontWeight: "normal" }, children: e }), V0e = ({ canDismiss: e, status: t, description: n, title: r }) => {
  const [o, a] = je(!0), s = () => {
    e && a(!1);
  };
  return o ? /* @__PURE__ */ A.jsxs(
    Gg,
    {
      status: t,
      position: "sticky",
      top: 0,
      width: "100vw",
      zIndex: 999999,
      className: "sui-banner",
      children: [
        /* @__PURE__ */ A.jsx($g, {}),
        /* @__PURE__ */ A.jsxs(Sl, { gap: "8px", children: [
          !!r && /* @__PURE__ */ A.jsx(Wo, { variant: "h3", children: r }),
          typeof n == "string" ? /* @__PURE__ */ A.jsx(k0e, { children: n }) : n
        ] }),
        e && /* @__PURE__ */ A.jsx(oh, { onClick: s, position: "absolute", right: "4" })
      ]
    }
  ) : null;
}, Gme = () => {
  const [e, t] = je(navigator.onLine);
  return ft(() => {
    const n = () => t(!0), r = () => t(!1);
    return window.addEventListener("offline", r), window.addEventListener("online", n), () => {
      window.removeEventListener("online", n), window.removeEventListener("offline", r);
    };
  }, []), e ? null : /* @__PURE__ */ A.jsx(
    V0e,
    {
      status: "error",
      title: "You are Offline",
      description: "You are not connected to the internet. We cannot guarantee your changes will be saved! Please restore your internet connection before proceeding.",
      canDismiss: !1
    }
  );
}, O0e = ({
  content: e,
  title: t
}) => /* @__PURE__ */ A.jsx(Y2, { borderWidth: "1px", borderBottomColor: "strokeDefault", children: /* @__PURE__ */ A.jsx(NA, { children: /* @__PURE__ */ A.jsxs(Y2, { height: "1.5rem", width: "100%", justifyContent: "space-between", alignItems: "center", children: [
  e && e,
  t && /* @__PURE__ */ A.jsx(Wo, { variant: "h5", children: t }),
  /* @__PURE__ */ A.jsx(TA, {})
] }) }) }), $me = ({
  panels: e,
  panelState: t
}) => {
  const { index: n, onChange: r } = t || {}, [o, a] = je(
    () => Object.keys(e).map((c) => +c)
  ), s = n ?? o, l = r ?? a;
  return /* @__PURE__ */ A.jsx(
    DA,
    {
      variant: "default",
      width: "full",
      index: s,
      onChange: l,
      allowToggle: !0,
      children: e.map(({ id: c, body: d, ...f }) => /* @__PURE__ */ A.jsxs(PA, { children: [
        /* @__PURE__ */ A.jsx(O0e, { ...f }),
        /* @__PURE__ */ A.jsx(VA, { paddingBottom: 4, children: d })
      ] }, c))
    }
  );
}, Zme = (e) => {
  const {
    children: t,
    variant: n,
    header: r,
    headerProps: o,
    drawerContentProps: a,
    footer: s,
    footerProps: l,
    bodyProps: c,
    ...d
  } = e;
  return /* @__PURE__ */ A.jsxs(lee, { ...d, children: [
    n === "overlay" && /* @__PURE__ */ A.jsx(w4, {}),
    /* @__PURE__ */ A.jsxs(Cx, { ...a, children: [
      wi(r) && /* @__PURE__ */ A.jsx(I4, { ...o, children: r }),
      /* @__PURE__ */ A.jsx(x4, { ...c, children: t }),
      wi(s) && /* @__PURE__ */ A.jsx(_4, { ...l, children: s })
    ] })
  ] });
}, Iw = nt((e, t) => {
  const {
    __testId: n,
    onChange: r,
    value: o,
    isDisabled: a,
    isReadonly: s,
    isInvalid: l,
    isRequired: c,
    size: d,
    __dangerDoNotUseSx: f
  } = e, h = (m) => {
    r(!!m.target.checked);
  };
  return /* @__PURE__ */ A.jsx(
    kx,
    {
      "data-testid": n,
      ref: t,
      isChecked: o,
      onChange: h,
      isDisabled: a,
      isReadOnly: s,
      isInvalid: l,
      isRequired: c,
      size: d,
      sx: f
    }
  );
});
Iw.displayName = "Switch";
const jme = nt((e, t) => {
  const { __testId: n, label: r, ...o } = e;
  return cc(
    o,
    /* @__PURE__ */ A.jsxs(Sl, { alignItems: "center", gap: ".5rem", children: [
      /* @__PURE__ */ A.jsx(Iw, { __testId: n, ref: t, ...o }),
      /* @__PURE__ */ A.jsx(Wo, { variant: "h4", children: r })
    ] })
  );
}), F0e = ({
  size: e,
  isOpen: t,
  onClose: n,
  variant: r,
  title: o,
  children: a,
  primaryAction: s,
  secondaryAction: l,
  closeOnEsc: c = !0,
  showCloseButton: d = !0,
  overflow: f,
  modalBodyProps: h = {},
  titleBadge: m,
  fullHeight: g = !1,
  leftFooterContent: b
}) => {
  const C = s || l || b;
  return /* @__PURE__ */ A.jsxs(
    M4,
    {
      isOpen: t,
      onClose: n,
      scrollBehavior: "inside",
      size: e || "lg",
      isCentered: !0,
      closeOnEsc: c,
      closeOnOverlayClick: c,
      children: [
        /* @__PURE__ */ A.jsx(w4, {}),
        /* @__PURE__ */ A.jsxs(
          px,
          {
            onKeyDown: (y) => {
              y.stopPropagation();
            },
            height: g ? "100%" : "auto",
            children: [
              /* @__PURE__ */ A.jsxs(I4, { borderBottom: "1px solid border", children: [
                /* @__PURE__ */ A.jsxs(Sl, { alignItems: "center", justifyContent: "flex-start", flexGrow: 1, gap: 2, children: [
                  o,
                  m && /* @__PURE__ */ A.jsx(Zx, { ...m, size: "md" })
                ] }),
                d && /* @__PURE__ */ A.jsx(mx, { onClick: n })
              ] }),
              /* @__PURE__ */ A.jsx(x4, { overflow: f, ...h, children: a }),
              /* @__PURE__ */ A.jsx(_4, { borderTop: "1px solid border", children: C && /* @__PURE__ */ A.jsxs(Sl, { justifyContent: "space-between", flex: 1, children: [
                /* @__PURE__ */ A.jsx(v3, { gap: 2, children: b }),
                /* @__PURE__ */ A.jsxs(v3, { gap: 2, children: [
                  l && /* @__PURE__ */ A.jsx(A3, { variant: "secondary", ...l }),
                  s && /* @__PURE__ */ A.jsx(
                    fh,
                    {
                      isDisabled: xw(s.tooltipText),
                      label: s.tooltipText,
                      children: /* @__PURE__ */ A.jsx(
                        A3,
                        {
                          variant: r === "danger" ? "danger" : "primary",
                          ...s
                        }
                      )
                    }
                  )
                ] })
              ] }) })
            ]
          }
        )
      ]
    }
  );
}, Wme = (e) => {
  const [t, n] = je(!1);
  return {
    Modal: F0e,
    isModalOpen: t,
    openModal: () => {
      var a;
      n(!0), (a = e == null ? void 0 : e.onOpen) == null || a.call(e);
    },
    closeModal: () => {
      var a;
      n(!1), (a = e == null ? void 0 : e.onClose) == null || a.call(e);
    }
  };
};
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function zme() {
  return {
    accessor: (e, t) => typeof e == "function" ? {
      ...t,
      accessorFn: e
    } : {
      ...t,
      accessorKey: e
    },
    display: (e) => e,
    group: (e) => e
  };
}
function ss(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function So(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: ss(n, r[e])
    }));
  };
}
function Zh(e) {
  return e instanceof Function;
}
function B0e(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function H0e(e, t) {
  const n = [], r = (o) => {
    o.forEach((a) => {
      n.push(a);
      const s = t(a);
      s != null && s.length && r(s);
    });
  };
  return r(e), n;
}
function ct(e, t, n) {
  let r = [], o;
  return (a) => {
    let s;
    n.key && n.debug && (s = Date.now());
    const l = e(a);
    if (!(l.length !== r.length || l.some((f, h) => r[h] !== f)))
      return o;
    r = l;
    let d;
    if (n.key && n.debug && (d = Date.now()), o = t(...l), n == null || n.onChange == null || n.onChange(o), n.key && n.debug && n != null && n.debug()) {
      const f = Math.round((Date.now() - s) * 100) / 100, h = Math.round((Date.now() - d) * 100) / 100, m = h / 16, g = (b, C) => {
        for (b = String(b); b.length < C; )
          b = " " + b;
        return b;
      };
      console.info(`%c⏱ ${g(h, 5)} /${g(f, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * m, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return o;
  };
}
function dt(e, t, n, r) {
  return {
    debug: () => {
      var o;
      return (o = e == null ? void 0 : e.debugAll) != null ? o : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function G0e(e, t, n, r) {
  const o = () => {
    var s;
    return (s = a.getValue()) != null ? s : e.options.renderFallbackValue;
  }, a = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: o,
    getContext: ct(() => [e, n, t, a], (s, l, c, d) => ({
      table: s,
      column: l,
      row: c,
      cell: d,
      getValue: d.getValue,
      renderValue: d.renderValue
    }), dt(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((s) => {
    s.createCell == null || s.createCell(a, n, t, e);
  }, {}), a;
}
function $0e(e, t, n, r) {
  var o, a;
  const l = {
    ...e._getDefaultColumnDef(),
    ...t
  }, c = l.accessorKey;
  let d = (o = (a = l.id) != null ? a : c ? typeof String.prototype.replaceAll == "function" ? c.replaceAll(".", "_") : c.replace(/\./g, "_") : void 0) != null ? o : typeof l.header == "string" ? l.header : void 0, f;
  if (l.accessorFn ? f = l.accessorFn : c && (c.includes(".") ? f = (m) => {
    let g = m;
    for (const C of c.split(".")) {
      var b;
      g = (b = g) == null ? void 0 : b[C], process.env.NODE_ENV !== "production" && g === void 0 && console.warn(`"${C}" in deeply nested key "${c}" returned undefined.`);
    }
    return g;
  } : f = (m) => m[l.accessorKey]), !d)
    throw process.env.NODE_ENV !== "production" ? new Error(l.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let h = {
    id: `${String(d)}`,
    accessorFn: f,
    parent: r,
    depth: n,
    columnDef: l,
    columns: [],
    getFlatColumns: ct(() => [!0], () => {
      var m;
      return [h, ...(m = h.columns) == null ? void 0 : m.flatMap((g) => g.getFlatColumns())];
    }, dt(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: ct(() => [e._getOrderColumnsFn()], (m) => {
      var g;
      if ((g = h.columns) != null && g.length) {
        let b = h.columns.flatMap((C) => C.getLeafColumns());
        return m(b);
      }
      return [h];
    }, dt(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const m of e._features)
    m.createColumn == null || m.createColumn(h, e);
  return h;
}
const Ar = "debugHeaders";
function QC(e, t, n) {
  var r;
  let a = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const s = [], l = (c) => {
        c.subHeaders && c.subHeaders.length && c.subHeaders.map(l), s.push(c);
      };
      return l(a), s;
    },
    getContext: () => ({
      table: e,
      header: a,
      column: t
    })
  };
  return e._features.forEach((s) => {
    s.createHeader == null || s.createHeader(a, e);
  }), a;
}
const Z0e = {
  createTable: (e) => {
    e.getHeaderGroups = ct(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => {
      var a, s;
      const l = (a = r == null ? void 0 : r.map((h) => n.find((m) => m.id === h)).filter(Boolean)) != null ? a : [], c = (s = o == null ? void 0 : o.map((h) => n.find((m) => m.id === h)).filter(Boolean)) != null ? s : [], d = n.filter((h) => !(r != null && r.includes(h.id)) && !(o != null && o.includes(h.id)));
      return l2(t, [...l, ...d, ...c], e);
    }, dt(e.options, Ar, "getHeaderGroups")), e.getCenterHeaderGroups = ct(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => (n = n.filter((a) => !(r != null && r.includes(a.id)) && !(o != null && o.includes(a.id))), l2(t, n, e, "center")), dt(e.options, Ar, "getCenterHeaderGroups")), e.getLeftHeaderGroups = ct(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var o;
      const a = (o = r == null ? void 0 : r.map((s) => n.find((l) => l.id === s)).filter(Boolean)) != null ? o : [];
      return l2(t, a, e, "left");
    }, dt(e.options, Ar, "getLeftHeaderGroups")), e.getRightHeaderGroups = ct(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var o;
      const a = (o = r == null ? void 0 : r.map((s) => n.find((l) => l.id === s)).filter(Boolean)) != null ? o : [];
      return l2(t, a, e, "right");
    }, dt(e.options, Ar, "getRightHeaderGroups")), e.getFooterGroups = ct(() => [e.getHeaderGroups()], (t) => [...t].reverse(), dt(e.options, Ar, "getFooterGroups")), e.getLeftFooterGroups = ct(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), dt(e.options, Ar, "getLeftFooterGroups")), e.getCenterFooterGroups = ct(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), dt(e.options, Ar, "getCenterFooterGroups")), e.getRightFooterGroups = ct(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), dt(e.options, Ar, "getRightFooterGroups")), e.getFlatHeaders = ct(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), dt(e.options, Ar, "getFlatHeaders")), e.getLeftFlatHeaders = ct(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), dt(e.options, Ar, "getLeftFlatHeaders")), e.getCenterFlatHeaders = ct(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), dt(e.options, Ar, "getCenterFlatHeaders")), e.getRightFlatHeaders = ct(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), dt(e.options, Ar, "getRightFlatHeaders")), e.getCenterLeafHeaders = ct(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), dt(e.options, Ar, "getCenterLeafHeaders")), e.getLeftLeafHeaders = ct(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), dt(e.options, Ar, "getLeftLeafHeaders")), e.getRightLeafHeaders = ct(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), dt(e.options, Ar, "getRightLeafHeaders")), e.getLeafHeaders = ct(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var o, a, s, l, c, d;
      return [...(o = (a = t[0]) == null ? void 0 : a.headers) != null ? o : [], ...(s = (l = n[0]) == null ? void 0 : l.headers) != null ? s : [], ...(c = (d = r[0]) == null ? void 0 : d.headers) != null ? c : []].map((f) => f.getLeafHeaders()).flat();
    }, dt(e.options, Ar, "getLeafHeaders"));
  }
};
function l2(e, t, n, r) {
  var o, a;
  let s = 0;
  const l = function(m, g) {
    g === void 0 && (g = 1), s = Math.max(s, g), m.filter((b) => b.getIsVisible()).forEach((b) => {
      var C;
      (C = b.columns) != null && C.length && l(b.columns, g + 1);
    }, 0);
  };
  l(e);
  let c = [];
  const d = (m, g) => {
    const b = {
      depth: g,
      id: [r, `${g}`].filter(Boolean).join("_"),
      headers: []
    }, C = [];
    m.forEach((y) => {
      const _ = [...C].reverse()[0], x = y.column.depth === b.depth;
      let I, R = !1;
      if (x && y.column.parent ? I = y.column.parent : (I = y.column, R = !0), _ && (_ == null ? void 0 : _.column) === I)
        _.subHeaders.push(y);
      else {
        const E = QC(n, I, {
          id: [r, g, I.id, y == null ? void 0 : y.id].filter(Boolean).join("_"),
          isPlaceholder: R,
          placeholderId: R ? `${C.filter((k) => k.column === I).length}` : void 0,
          depth: g,
          index: C.length
        });
        E.subHeaders.push(y), C.push(E);
      }
      b.headers.push(y), y.headerGroup = b;
    }), c.push(b), g > 0 && d(C, g - 1);
  }, f = t.map((m, g) => QC(n, m, {
    depth: s,
    index: g
  }));
  d(f, s - 1), c.reverse();
  const h = (m) => m.filter((b) => b.column.getIsVisible()).map((b) => {
    let C = 0, y = 0, _ = [0];
    b.subHeaders && b.subHeaders.length ? (_ = [], h(b.subHeaders).forEach((I) => {
      let {
        colSpan: R,
        rowSpan: E
      } = I;
      C += R, _.push(E);
    })) : C = 1;
    const x = Math.min(..._);
    return y = y + x, b.colSpan = C, b.rowSpan = y, {
      colSpan: C,
      rowSpan: y
    };
  });
  return h((o = (a = c[0]) == null ? void 0 : a.headers) != null ? o : []), c;
}
const j0e = (e, t, n, r, o, a, s) => {
  let l = {
    id: t,
    index: r,
    original: n,
    depth: o,
    parentId: s,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (c) => {
      if (l._valuesCache.hasOwnProperty(c))
        return l._valuesCache[c];
      const d = e.getColumn(c);
      if (d != null && d.accessorFn)
        return l._valuesCache[c] = d.accessorFn(l.original, r), l._valuesCache[c];
    },
    getUniqueValues: (c) => {
      if (l._uniqueValuesCache.hasOwnProperty(c))
        return l._uniqueValuesCache[c];
      const d = e.getColumn(c);
      if (d != null && d.accessorFn)
        return d.columnDef.getUniqueValues ? (l._uniqueValuesCache[c] = d.columnDef.getUniqueValues(l.original, r), l._uniqueValuesCache[c]) : (l._uniqueValuesCache[c] = [l.getValue(c)], l._uniqueValuesCache[c]);
    },
    renderValue: (c) => {
      var d;
      return (d = l.getValue(c)) != null ? d : e.options.renderFallbackValue;
    },
    subRows: a ?? [],
    getLeafRows: () => H0e(l.subRows, (c) => c.subRows),
    getParentRow: () => l.parentId ? e.getRow(l.parentId, !0) : void 0,
    getParentRows: () => {
      let c = [], d = l;
      for (; ; ) {
        const f = d.getParentRow();
        if (!f)
          break;
        c.push(f), d = f;
      }
      return c.reverse();
    },
    getAllCells: ct(() => [e.getAllLeafColumns()], (c) => c.map((d) => G0e(e, l, d, d.id)), dt(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: ct(() => [l.getAllCells()], (c) => c.reduce((d, f) => (d[f.column.id] = f, d), {}), dt(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let c = 0; c < e._features.length; c++) {
    const d = e._features[c];
    d == null || d.createRow == null || d.createRow(l, e);
  }
  return l;
}, W0e = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, ww = (e, t, n) => {
  var r, o;
  const a = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
  return !!(!((o = e.getValue(t)) == null || (o = o.toString()) == null || (o = o.toLowerCase()) == null) && o.includes(a));
};
ww.autoRemove = (e) => ha(e);
const Lw = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
Lw.autoRemove = (e) => ha(e);
const Rw = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
Rw.autoRemove = (e) => ha(e);
const Ew = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
Ew.autoRemove = (e) => ha(e);
const Dw = (e, t, n) => !n.some((r) => {
  var o;
  return !((o = e.getValue(t)) != null && o.includes(r));
});
Dw.autoRemove = (e) => ha(e) || !(e != null && e.length);
const Nw = (e, t, n) => n.some((r) => {
  var o;
  return (o = e.getValue(t)) == null ? void 0 : o.includes(r);
});
Nw.autoRemove = (e) => ha(e) || !(e != null && e.length);
const Tw = (e, t, n) => e.getValue(t) === n;
Tw.autoRemove = (e) => ha(e);
const Pw = (e, t, n) => e.getValue(t) == n;
Pw.autoRemove = (e) => ha(e);
const f9 = (e, t, n) => {
  let [r, o] = n;
  const a = e.getValue(t);
  return a >= r && a <= o;
};
f9.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, o = typeof n != "number" ? parseFloat(n) : n, a = t === null || Number.isNaN(r) ? -1 / 0 : r, s = n === null || Number.isNaN(o) ? 1 / 0 : o;
  if (a > s) {
    const l = a;
    a = s, s = l;
  }
  return [a, s];
};
f9.autoRemove = (e) => ha(e) || ha(e[0]) && ha(e[1]);
const oi = {
  includesString: ww,
  includesStringSensitive: Lw,
  equalsString: Rw,
  arrIncludes: Ew,
  arrIncludesAll: Dw,
  arrIncludesSome: Nw,
  equals: Tw,
  weakEquals: Pw,
  inNumberRange: f9
};
function ha(e) {
  return e == null || e === "";
}
const z0e = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: So("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      return typeof r == "string" ? oi.includesString : typeof r == "number" ? oi.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? oi.equals : Array.isArray(r) ? oi.arrIncludes : oi.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return Zh(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : oi[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, o;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const o = e.getFilterFn(), a = r == null ? void 0 : r.find((f) => f.id === e.id), s = ss(n, a ? a.value : void 0);
        if (eb(o, s, e)) {
          var l;
          return (l = r == null ? void 0 : r.filter((f) => f.id !== e.id)) != null ? l : [];
        }
        const c = {
          id: e.id,
          value: s
        };
        if (a) {
          var d;
          return (d = r == null ? void 0 : r.map((f) => f.id === e.id ? c : f)) != null ? d : [];
        }
        return r != null && r.length ? [...r, c] : [c];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (o) => {
        var a;
        return (a = ss(t, o)) == null ? void 0 : a.filter((s) => {
          const l = n.find((c) => c.id === s.id);
          if (l) {
            const c = l.getFilterFn();
            if (eb(c, s.value, l))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function eb(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const U0e = (e, t, n) => n.reduce((r, o) => {
  const a = o.getValue(e);
  return r + (typeof a == "number" ? a : 0);
}, 0), X0e = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const a = o.getValue(e);
    a != null && (r > a || r === void 0 && a >= a) && (r = a);
  }), r;
}, Y0e = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const a = o.getValue(e);
    a != null && (r < a || r === void 0 && a >= a) && (r = a);
  }), r;
}, q0e = (e, t, n) => {
  let r, o;
  return n.forEach((a) => {
    const s = a.getValue(e);
    s != null && (r === void 0 ? s >= s && (r = o = s) : (r > s && (r = s), o < s && (o = s)));
  }), [r, o];
}, J0e = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((o) => {
    let a = o.getValue(e);
    a != null && (a = +a) >= a && (++n, r += a);
  }), n)
    return r / n;
}, K0e = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((a) => a.getValue(e));
  if (!B0e(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), o = n.sort((a, s) => a - s);
  return n.length % 2 !== 0 ? o[r] : (o[r - 1] + o[r]) / 2;
}, Q0e = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), e2e = (e, t) => new Set(t.map((n) => n.getValue(e))).size, t2e = (e, t) => t.length, m5 = {
  sum: U0e,
  min: X0e,
  max: Y0e,
  extent: q0e,
  mean: J0e,
  median: K0e,
  unique: Q0e,
  uniqueCount: e2e,
  count: t2e
}, n2e = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: So("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      if (typeof r == "number")
        return m5.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return m5.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Zh(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : m5[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var o;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((o = n.subRows) != null && o.length);
    };
  }
};
function r2e(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((a) => !t.includes(a.id));
  return n === "remove" ? r : [...t.map((a) => e.find((s) => s.id === a)).filter(Boolean), ...r];
}
const o2e = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: So("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = ct((n) => [V1(t, n)], (n) => n.findIndex((r) => r.id === e.id), dt(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = V1(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const o = V1(t, n);
      return ((r = o[o.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = ct(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (o) => {
      let a = [];
      if (!(t != null && t.length))
        a = o;
      else {
        const s = [...t], l = [...o];
        for (; l.length && s.length; ) {
          const c = s.shift(), d = l.findIndex((f) => f.id === c);
          d > -1 && a.push(l.splice(d, 1)[0]);
        }
        a = [...a, ...l];
      }
      return r2e(a, n, r);
    }, dt(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, g5 = () => ({
  left: [],
  right: []
}), a2e = {
  getInitialState: (e) => ({
    columnPinning: g5(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: So("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((o) => o.id).filter(Boolean);
      t.setColumnPinning((o) => {
        var a, s;
        if (n === "right") {
          var l, c;
          return {
            left: ((l = o == null ? void 0 : o.left) != null ? l : []).filter((h) => !(r != null && r.includes(h))),
            right: [...((c = o == null ? void 0 : o.right) != null ? c : []).filter((h) => !(r != null && r.includes(h))), ...r]
          };
        }
        if (n === "left") {
          var d, f;
          return {
            left: [...((d = o == null ? void 0 : o.left) != null ? d : []).filter((h) => !(r != null && r.includes(h))), ...r],
            right: ((f = o == null ? void 0 : o.right) != null ? f : []).filter((h) => !(r != null && r.includes(h)))
          };
        }
        return {
          left: ((a = o == null ? void 0 : o.left) != null ? a : []).filter((h) => !(r != null && r.includes(h))),
          right: ((s = o == null ? void 0 : o.right) != null ? s : []).filter((h) => !(r != null && r.includes(h)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var o, a, s;
      return ((o = r.columnDef.enablePinning) != null ? o : !0) && ((a = (s = t.options.enableColumnPinning) != null ? s : t.options.enablePinning) != null ? a : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((l) => l.id), {
        left: r,
        right: o
      } = t.getState().columnPinning, a = n.some((l) => r == null ? void 0 : r.includes(l)), s = n.some((l) => o == null ? void 0 : o.includes(l));
      return a ? "left" : s ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      return o ? (n = (r = t.getState().columnPinning) == null || (r = r[o]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = ct(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, o) => {
      const a = [...r ?? [], ...o ?? []];
      return n.filter((s) => !a.includes(s.column.id));
    }, dt(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = ct(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((a) => n.find((s) => s.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "left"
    })), dt(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = ct(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((a) => n.find((s) => s.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "right"
    })), dt(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? g5() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : g5());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var o, a;
        return !!((o = r.left) != null && o.length || (a = r.right) != null && a.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = ct(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), dt(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = ct(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), dt(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = ct(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const o = [...n ?? [], ...r ?? []];
      return t.filter((a) => !o.includes(a.id));
    }, dt(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function i2e(e) {
  return e || (typeof document < "u" ? document : null);
}
const u2 = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, v5 = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), s2e = {
  getDefaultColumnDef: () => u2,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: v5(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: So("columnSizing", e),
    onColumnSizingInfoChange: So("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, o;
      const a = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : u2.minSize, (r = a ?? e.columnDef.size) != null ? r : u2.size), (o = e.columnDef.maxSize) != null ? o : u2.maxSize);
    }, e.getStart = ct((n) => [n, V1(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((o, a) => o + a.getSize(), 0), dt(t.options, "debugColumns", "getStart")), e.getAfter = ct((n) => [n, V1(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((o, a) => o + a.getSize(), 0), dt(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...o
        } = n;
        return o;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (o) => {
        if (o.subHeaders.length)
          o.subHeaders.forEach(r);
        else {
          var a;
          n += (a = o.column.getSize()) != null ? a : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), o = r == null ? void 0 : r.getCanResize();
      return (a) => {
        if (!r || !o || (a.persist == null || a.persist(), C5(a) && a.touches && a.touches.length > 1))
          return;
        const s = e.getSize(), l = e ? e.getLeafHeaders().map((_) => [_.column.id, _.column.getSize()]) : [[r.id, r.getSize()]], c = C5(a) ? Math.round(a.touches[0].clientX) : a.clientX, d = {}, f = (_, x) => {
          typeof x == "number" && (t.setColumnSizingInfo((I) => {
            var R, E;
            const k = t.options.columnResizeDirection === "rtl" ? -1 : 1, N = (x - ((R = I == null ? void 0 : I.startOffset) != null ? R : 0)) * k, P = Math.max(N / ((E = I == null ? void 0 : I.startSize) != null ? E : 0), -0.999999);
            return I.columnSizingStart.forEach((F) => {
              let [G, j] = F;
              d[G] = Math.round(Math.max(j + j * P, 0) * 100) / 100;
            }), {
              ...I,
              deltaOffset: N,
              deltaPercentage: P
            };
          }), (t.options.columnResizeMode === "onChange" || _ === "end") && t.setColumnSizing((I) => ({
            ...I,
            ...d
          })));
        }, h = (_) => f("move", _), m = (_) => {
          f("end", _), t.setColumnSizingInfo((x) => ({
            ...x,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, g = i2e(n), b = {
          moveHandler: (_) => h(_.clientX),
          upHandler: (_) => {
            g == null || g.removeEventListener("mousemove", b.moveHandler), g == null || g.removeEventListener("mouseup", b.upHandler), m(_.clientX);
          }
        }, C = {
          moveHandler: (_) => (_.cancelable && (_.preventDefault(), _.stopPropagation()), h(_.touches[0].clientX), !1),
          upHandler: (_) => {
            var x;
            g == null || g.removeEventListener("touchmove", C.moveHandler), g == null || g.removeEventListener("touchend", C.upHandler), _.cancelable && (_.preventDefault(), _.stopPropagation()), m((x = _.touches[0]) == null ? void 0 : x.clientX);
          }
        }, y = l2e() ? {
          passive: !1
        } : !1;
        C5(a) ? (g == null || g.addEventListener("touchmove", C.moveHandler, y), g == null || g.addEventListener("touchend", C.upHandler, y)) : (g == null || g.addEventListener("mousemove", b.moveHandler, y), g == null || g.addEventListener("mouseup", b.upHandler, y)), t.setColumnSizingInfo((_) => ({
          ..._,
          startOffset: c,
          startSize: s,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: l,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? v5() : (n = e.initialState.columnSizingInfo) != null ? n : v5());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    };
  }
};
let c2 = null;
function l2e() {
  if (typeof c2 == "boolean")
    return c2;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return c2 = e, c2;
}
function C5(e) {
  return e.type === "touchstart";
}
const u2e = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: So("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const o = e.columns;
      return (n = o.length ? o.some((a) => a.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = ct(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), dt(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = ct(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, o) => [...n, ...r, ...o], dt(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => ct(() => [r(), r().filter((o) => o.getIsVisible()).map((o) => o.id).join("_")], (o) => o.filter((a) => a.getIsVisible == null ? void 0 : a.getIsVisible()), dt(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((o, a) => ({
        ...o,
        [a.id]: n || !(a.getCanHide != null && a.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function V1(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const c2e = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, d2e = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: So("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, o, a;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && ((a = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? a : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => oi.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return Zh(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : oi[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, f2e = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: So("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n)
          return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var o, a;
      e.setExpanded(r ? {} : (o = (a = e.initialState) == null ? void 0 : a.expanded) != null ? o : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((o) => !o.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((a) => {
        const s = a.split(".");
        r = Math.max(r, s.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var o;
        const a = r === !0 ? !0 : !!(r != null && r[e.id]);
        let s = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((l) => {
          s[l] = !0;
        }) : s = r, n = (o = n) != null ? o : !a, !a && n)
          return {
            ...s,
            [e.id]: !0
          };
        if (a && !n) {
          const {
            [e.id]: l,
            ...c
          } = s;
          return c;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var n, r, o;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((o = e.subRows) != null && o.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, j3 = 0, W3 = 10, b5 = () => ({
  pageIndex: j3,
  pageSize: W3
}), h2e = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...b5(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: So("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n)
          return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const o = (a) => ss(r, a);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(o);
    }, e.resetPagination = (r) => {
      var o;
      e.setPagination(r ? b5() : (o = e.initialState.pagination) != null ? o : b5());
    }, e.setPageIndex = (r) => {
      e.setPagination((o) => {
        let a = ss(r, o.pageIndex);
        const s = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return a = Math.max(0, Math.min(a, s)), {
          ...o,
          pageIndex: a
        };
      });
    }, e.resetPageIndex = (r) => {
      var o, a;
      e.setPageIndex(r ? j3 : (o = (a = e.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageIndex) != null ? o : j3);
    }, e.resetPageSize = (r) => {
      var o, a;
      e.setPageSize(r ? W3 : (o = (a = e.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageSize) != null ? o : W3);
    }, e.setPageSize = (r) => {
      e.setPagination((o) => {
        const a = Math.max(1, ss(r, o.pageSize)), s = o.pageSize * o.pageIndex, l = Math.floor(s / a);
        return {
          ...o,
          pageIndex: l,
          pageSize: a
        };
      });
    }, e.setPageCount = (r) => e.setPagination((o) => {
      var a;
      let s = ss(r, (a = e.options.pageCount) != null ? a : -1);
      return typeof s == "number" && (s = Math.max(-1, s)), {
        ...o,
        pageCount: s
      };
    }), e.getPageOptions = ct(() => [e.getPageCount()], (r) => {
      let o = [];
      return r && r > 0 && (o = [...new Array(r)].fill(null).map((a, s) => s)), o;
    }, dt(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, o = e.getPageCount();
      return o === -1 ? !0 : o === 0 ? !1 : r < o - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, y5 = () => ({
  top: [],
  bottom: []
}), p2e = {
  getInitialState: (e) => ({
    rowPinning: y5(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: So("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, o) => {
      const a = r ? e.getLeafRows().map((c) => {
        let {
          id: d
        } = c;
        return d;
      }) : [], s = o ? e.getParentRows().map((c) => {
        let {
          id: d
        } = c;
        return d;
      }) : [], l = /* @__PURE__ */ new Set([...s, e.id, ...a]);
      t.setRowPinning((c) => {
        var d, f;
        if (n === "bottom") {
          var h, m;
          return {
            top: ((h = c == null ? void 0 : c.top) != null ? h : []).filter((C) => !(l != null && l.has(C))),
            bottom: [...((m = c == null ? void 0 : c.bottom) != null ? m : []).filter((C) => !(l != null && l.has(C))), ...Array.from(l)]
          };
        }
        if (n === "top") {
          var g, b;
          return {
            top: [...((g = c == null ? void 0 : c.top) != null ? g : []).filter((C) => !(l != null && l.has(C))), ...Array.from(l)],
            bottom: ((b = c == null ? void 0 : c.bottom) != null ? b : []).filter((C) => !(l != null && l.has(C)))
          };
        }
        return {
          top: ((d = c == null ? void 0 : c.top) != null ? d : []).filter((C) => !(l != null && l.has(C))),
          bottom: ((f = c == null ? void 0 : c.bottom) != null ? f : []).filter((C) => !(l != null && l.has(C)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: o
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? o) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: o
      } = t.getState().rowPinning, a = n.some((l) => r == null ? void 0 : r.includes(l)), s = n.some((l) => o == null ? void 0 : o.includes(l));
      return a ? "top" : s ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      if (!o)
        return -1;
      const a = (n = o === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((s) => {
        let {
          id: l
        } = s;
        return l;
      });
      return (r = a == null ? void 0 : a.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? y5() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : y5());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var o, a;
        return !!((o = r.top) != null && o.length || (a = r.bottom) != null && a.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var o;
      return ((o = e.options.keepPinnedRows) == null || o ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((s) => {
          const l = e.getRow(s, !0);
          return l.getIsAllParentsExpanded() ? l : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((s) => t.find((l) => l.id === s))
      )).filter(Boolean).map((s) => ({
        ...s,
        position: r
      }));
    }, e.getTopRows = ct(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), dt(e.options, "debugRows", "getTopRows")), e.getBottomRows = ct(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), dt(e.options, "debugRows", "getBottomRows")), e.getCenterRows = ct(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const o = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((a) => !o.has(a.id));
    }, dt(e.options, "debugRows", "getCenterRows"));
  }
}, m2e = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: So("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, o = e.getPreGroupedRowModel().flatRows;
        return t ? o.forEach((a) => {
          a.getCanSelect() && (r[a.id] = !0);
        }) : o.forEach((a) => {
          delete r[a.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), o = {
        ...n
      };
      return e.getRowModel().rows.forEach((a) => {
        z3(o, a.id, r, !0, e);
      }), o;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = ct(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? S5(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, dt(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = ct(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? S5(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, dt(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = ct(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? S5(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, dt(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((o) => o.getCanSelect() && !n[o.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((o) => o.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((o) => !n[o.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const o = e.getIsSelected();
      t.setRowSelection((a) => {
        var s;
        if (n = typeof n < "u" ? n : !o, e.getCanSelect() && o === n)
          return a;
        const l = {
          ...a
        };
        return z3(l, e.id, n, (s = r == null ? void 0 : r.selectChildren) != null ? s : !0, t), l;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return h9(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return U3(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return U3(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var o;
        n && e.toggleSelected((o = r.target) == null ? void 0 : o.checked);
      };
    };
  }
}, z3 = (e, t, n, r, o) => {
  var a;
  const s = o.getRow(t, !0);
  n ? (s.getCanMultiSelect() || Object.keys(e).forEach((l) => delete e[l]), s.getCanSelect() && (e[t] = !0)) : delete e[t], r && (a = s.subRows) != null && a.length && s.getCanSelectSubRows() && s.subRows.forEach((l) => z3(e, l.id, n, r, o));
};
function S5(e, t) {
  const n = e.getState().rowSelection, r = [], o = {}, a = function(s, l) {
    return s.map((c) => {
      var d;
      const f = h9(c, n);
      if (f && (r.push(c), o[c.id] = c), (d = c.subRows) != null && d.length && (c = {
        ...c,
        subRows: a(c.subRows)
      }), f)
        return c;
    }).filter(Boolean);
  };
  return {
    rows: a(t.rows),
    flatRows: r,
    rowsById: o
  };
}
function h9(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function U3(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length))
    return !1;
  let o = !0, a = !1;
  return e.subRows.forEach((s) => {
    if (!(a && !o) && (s.getCanSelect() && (h9(s, t) ? a = !0 : o = !1), s.subRows && s.subRows.length)) {
      const l = U3(s, t);
      l === "all" ? a = !0 : (l === "some" && (a = !0), o = !1);
    }
  }), o ? "all" : a ? "some" : !1;
}
const X3 = /([0-9]+)/gm, g2e = (e, t, n) => kw(bs(e.getValue(n)).toLowerCase(), bs(t.getValue(n)).toLowerCase()), v2e = (e, t, n) => kw(bs(e.getValue(n)), bs(t.getValue(n))), C2e = (e, t, n) => p9(bs(e.getValue(n)).toLowerCase(), bs(t.getValue(n)).toLowerCase()), b2e = (e, t, n) => p9(bs(e.getValue(n)), bs(t.getValue(n))), y2e = (e, t, n) => {
  const r = e.getValue(n), o = t.getValue(n);
  return r > o ? 1 : r < o ? -1 : 0;
}, S2e = (e, t, n) => p9(e.getValue(n), t.getValue(n));
function p9(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function bs(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function kw(e, t) {
  const n = e.split(X3).filter(Boolean), r = t.split(X3).filter(Boolean);
  for (; n.length && r.length; ) {
    const o = n.shift(), a = r.shift(), s = parseInt(o, 10), l = parseInt(a, 10), c = [s, l].sort();
    if (isNaN(c[0])) {
      if (o > a)
        return 1;
      if (a > o)
        return -1;
      continue;
    }
    if (isNaN(c[1]))
      return isNaN(s) ? -1 : 1;
    if (s > l)
      return 1;
    if (l > s)
      return -1;
  }
  return n.length - r.length;
}
const n1 = {
  alphanumeric: g2e,
  alphanumericCaseSensitive: v2e,
  text: C2e,
  textCaseSensitive: b2e,
  datetime: y2e,
  basic: S2e
}, A2e = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: So("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const o of n) {
        const a = o == null ? void 0 : o.getValue(e.id);
        if (Object.prototype.toString.call(a) === "[object Date]")
          return n1.datetime;
        if (typeof a == "string" && (r = !0, a.split(X3).length > 1))
          return n1.alphanumeric;
      }
      return r ? n1.text : n1.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Zh(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : n1[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const o = e.getNextSortingOrder(), a = typeof n < "u" && n !== null;
      t.setSorting((s) => {
        const l = s == null ? void 0 : s.find((g) => g.id === e.id), c = s == null ? void 0 : s.findIndex((g) => g.id === e.id);
        let d = [], f, h = a ? n : o === "desc";
        if (s != null && s.length && e.getCanMultiSort() && r ? l ? f = "toggle" : f = "add" : s != null && s.length && c !== s.length - 1 ? f = "replace" : l ? f = "toggle" : f = "replace", f === "toggle" && (a || o || (f = "remove")), f === "add") {
          var m;
          d = [...s, {
            id: e.id,
            desc: h
          }], d.splice(0, d.length - ((m = t.options.maxMultiSortColCount) != null ? m : Number.MAX_SAFE_INTEGER));
        } else
          f === "toggle" ? d = s.map((g) => g.id === e.id ? {
            ...g,
            desc: h
          } : g) : f === "remove" ? d = s.filter((g) => g.id !== e.id) : d = [{
            id: e.id,
            desc: h
          }];
        return d;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, o;
      const a = e.getFirstSortDir(), s = e.getIsSorted();
      return s ? s !== a && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (o = t.options.enableMultiRemove) != null) || o) ? !1 : s === "desc" ? "asc" : "desc" : a;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((o) => o.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, M2e = [
  Z0e,
  u2e,
  o2e,
  a2e,
  W0e,
  z0e,
  c2e,
  //depends on ColumnFaceting
  d2e,
  //depends on ColumnFiltering
  A2e,
  n2e,
  //depends on RowSorting
  f2e,
  h2e,
  p2e,
  m2e,
  s2e
];
function x2e(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...M2e, ...(t = e._features) != null ? t : []];
  let o = {
    _features: r
  };
  const a = o._features.reduce((m, g) => Object.assign(m, g.getDefaultOptions == null ? void 0 : g.getDefaultOptions(o)), {}), s = (m) => o.options.mergeOptions ? o.options.mergeOptions(a, m) : {
    ...a,
    ...m
  };
  let c = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  o._features.forEach((m) => {
    var g;
    c = (g = m.getInitialState == null ? void 0 : m.getInitialState(c)) != null ? g : c;
  });
  const d = [];
  let f = !1;
  const h = {
    _features: r,
    options: {
      ...a,
      ...e
    },
    initialState: c,
    _queue: (m) => {
      d.push(m), f || (f = !0, Promise.resolve().then(() => {
        for (; d.length; )
          d.shift()();
        f = !1;
      }).catch((g) => setTimeout(() => {
        throw g;
      })));
    },
    reset: () => {
      o.setState(o.initialState);
    },
    setOptions: (m) => {
      const g = ss(m, o.options);
      o.options = s(g);
    },
    getState: () => o.options.state,
    setState: (m) => {
      o.options.onStateChange == null || o.options.onStateChange(m);
    },
    _getRowId: (m, g, b) => {
      var C;
      return (C = o.options.getRowId == null ? void 0 : o.options.getRowId(m, g, b)) != null ? C : `${b ? [b.id, g].join(".") : g}`;
    },
    getCoreRowModel: () => (o._getCoreRowModel || (o._getCoreRowModel = o.options.getCoreRowModel(o)), o._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => o.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (m, g) => {
      let b = (g ? o.getPrePaginationRowModel() : o.getRowModel()).rowsById[m];
      if (!b && (b = o.getCoreRowModel().rowsById[m], !b))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${m}`) : new Error();
      return b;
    },
    _getDefaultColumnDef: ct(() => [o.options.defaultColumn], (m) => {
      var g;
      return m = (g = m) != null ? g : {}, {
        header: (b) => {
          const C = b.header.column.columnDef;
          return C.accessorKey ? C.accessorKey : C.accessorFn ? C.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (b) => {
          var C, y;
          return (C = (y = b.renderValue()) == null || y.toString == null ? void 0 : y.toString()) != null ? C : null;
        },
        ...o._features.reduce((b, C) => Object.assign(b, C.getDefaultColumnDef == null ? void 0 : C.getDefaultColumnDef()), {}),
        ...m
      };
    }, dt(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => o.options.columns,
    getAllColumns: ct(() => [o._getColumnDefs()], (m) => {
      const g = function(b, C, y) {
        return y === void 0 && (y = 0), b.map((_) => {
          const x = $0e(o, _, y, C), I = _;
          return x.columns = I.columns ? g(I.columns, x, y + 1) : [], x;
        });
      };
      return g(m);
    }, dt(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: ct(() => [o.getAllColumns()], (m) => m.flatMap((g) => g.getFlatColumns()), dt(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: ct(() => [o.getAllFlatColumns()], (m) => m.reduce((g, b) => (g[b.id] = b, g), {}), dt(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: ct(() => [o.getAllColumns(), o._getOrderColumnsFn()], (m, g) => {
      let b = m.flatMap((C) => C.getLeafColumns());
      return g(b);
    }, dt(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (m) => {
      const g = o._getAllFlatColumnsById()[m];
      return process.env.NODE_ENV !== "production" && !g && console.error(`[Table] Column with id '${m}' does not exist.`), g;
    }
  };
  Object.assign(o, h);
  for (let m = 0; m < o._features.length; m++) {
    const g = o._features[m];
    g == null || g.createTable == null || g.createTable(o);
  }
  return o;
}
function _2e() {
  return (e) => ct(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(o, a, s) {
      a === void 0 && (a = 0);
      const l = [];
      for (let d = 0; d < o.length; d++) {
        const f = j0e(e, e._getRowId(o[d], d, s), o[d], d, a, void 0, s == null ? void 0 : s.id);
        if (n.flatRows.push(f), n.rowsById[f.id] = f, l.push(f), e.options.getSubRows) {
          var c;
          f.originalSubRows = e.options.getSubRows(o[d], d), (c = f.originalSubRows) != null && c.length && (f.subRows = r(f.originalSubRows, a + 1, f));
        }
      }
      return l;
    };
    return n.rows = r(t), n;
  }, dt(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function I2e(e) {
  const t = [], n = (r) => {
    var o;
    t.push(r), (o = r.subRows) != null && o.length && r.getIsExpanded() && r.subRows.forEach(n);
  };
  return e.rows.forEach(n), {
    rows: t,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function w2e(e) {
  return (t) => ct(() => [t.getState().pagination, t.getPrePaginationRowModel(), t.options.paginateExpandedRows ? void 0 : t.getState().expanded], (n, r) => {
    if (!r.rows.length)
      return r;
    const {
      pageSize: o,
      pageIndex: a
    } = n;
    let {
      rows: s,
      flatRows: l,
      rowsById: c
    } = r;
    const d = o * a, f = d + o;
    s = s.slice(d, f);
    let h;
    t.options.paginateExpandedRows ? h = {
      rows: s,
      flatRows: l,
      rowsById: c
    } : h = I2e({
      rows: s,
      flatRows: l,
      rowsById: c
    }), h.flatRows = [];
    const m = (g) => {
      h.flatRows.push(g), g.subRows.length && g.subRows.forEach(m);
    };
    return h.rows.forEach(m), h;
  }, dt(t.options, "debugTable", "getPaginationRowModel"));
}
function L2e() {
  return (e) => ct(() => [e.getState().sorting, e.getPreSortedRowModel()], (t, n) => {
    if (!n.rows.length || !(t != null && t.length))
      return n;
    const r = e.getState().sorting, o = [], a = r.filter((c) => {
      var d;
      return (d = e.getColumn(c.id)) == null ? void 0 : d.getCanSort();
    }), s = {};
    a.forEach((c) => {
      const d = e.getColumn(c.id);
      d && (s[c.id] = {
        sortUndefined: d.columnDef.sortUndefined,
        invertSorting: d.columnDef.invertSorting,
        sortingFn: d.getSortingFn()
      });
    });
    const l = (c) => {
      const d = c.map((f) => ({
        ...f
      }));
      return d.sort((f, h) => {
        for (let g = 0; g < a.length; g += 1) {
          var m;
          const b = a[g], C = s[b.id], y = C.sortUndefined, _ = (m = b == null ? void 0 : b.desc) != null ? m : !1;
          let x = 0;
          if (y) {
            const I = f.getValue(b.id), R = h.getValue(b.id), E = I === void 0, k = R === void 0;
            if (E || k) {
              if (y === "first")
                return E ? -1 : 1;
              if (y === "last")
                return E ? 1 : -1;
              x = E && k ? 0 : E ? y : -y;
            }
          }
          if (x === 0 && (x = C.sortingFn(f, h, b.id)), x !== 0)
            return _ && (x *= -1), C.invertSorting && (x *= -1), x;
        }
        return f.index - h.index;
      }), d.forEach((f) => {
        var h;
        o.push(f), (h = f.subRows) != null && h.length && (f.subRows = l(f.subRows));
      }), d;
    };
    return {
      rows: l(n.rows),
      flatRows: o,
      rowsById: n.rowsById
    };
  }, dt(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function tb(e, t) {
  return e ? R2e(e) ? /* @__PURE__ */ De.createElement(e, t) : e : null;
}
function R2e(e) {
  return E2e(e) || typeof e == "function" || D2e(e);
}
function E2e(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function D2e(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function N2e(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = De.useState(() => ({
    current: x2e(t)
  })), [r, o] = De.useState(() => n.current.initialState);
  return n.current.setOptions((a) => ({
    ...a,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (s) => {
      o(s), e.onStateChange == null || e.onStateChange(s);
    }
  })), n.current;
}
const T2e = (e) => {
  if (!e.getCanSort())
    return null;
  const t = e.getIsSorted();
  return t === !1 ? /* @__PURE__ */ A.jsx(Go, { icon: "arrow-up-down", size: "md" }) : t === "desc" ? /* @__PURE__ */ A.jsx(Go, { icon: "arrow-down", size: "md" }) : /* @__PURE__ */ A.jsx(Go, { icon: "arrow-up", size: "md" });
}, Ume = ({
  columns: e,
  data: t,
  onClick: n,
  onHover: r,
  initialState: o,
  determineRowColor: a,
  size: s,
  whiteSpace: l
}) => {
  const c = Pr.useMemo(() => t, [t]), d = Pr.useMemo(() => e, [e]), {
    getPageCount: f,
    getHeaderGroups: h,
    previousPage: m,
    nextPage: g,
    getCanPreviousPage: b,
    getCanNextPage: C,
    getState: y,
    getRowModel: _
  } = N2e({
    columns: d,
    data: c,
    getCoreRowModel: _2e(),
    getPaginationRowModel: w2e(),
    getSortedRowModel: L2e(),
    enableSorting: !0,
    initialState: {
      pagination: {
        pageIndex: (o == null ? void 0 : o.pageIndex) ?? 0,
        pageSize: (o == null ? void 0 : o.pageSize) ?? 50
      },
      sorting: o != null && o.sortBy ? o.sortBy : []
    }
  }), x = y(), I = f(), R = x.pagination.pageIndex + 1, E = I > 1, k = h(), N = C(), P = b(), F = wi(r), G = wi(n);
  return /* @__PURE__ */ A.jsxs(
    Si,
    {
      sx: {
        table: {
          "td.sm": { width: "1%", paddingLeft: "6px", paddingRight: "6px" },
          "td.md": { width: "2%" },
          "td.lg": { width: "5%" },
          "th.sm": { width: "1%", paddingLeft: "6px", paddingRight: "6px" },
          "th.md": { width: "2%" },
          "th.lg": { width: "5%" }
        }
      },
      children: [
        /* @__PURE__ */ A.jsxs(Vx, { size: s, whiteSpace: l, role: "table", children: [
          /* @__PURE__ */ A.jsx(Nee, { children: k.map((j) => /* @__PURE__ */ A.jsx(Kv, { role: "row", children: j.headers.map((ae) => {
            const ue = ae.column.getCanSort(), { isPlaceholder: le } = ae, _e = ue ? {
              onClick: ae.column.getToggleSortingHandler(),
              cursor: "pointer",
              userSelect: "none"
            } : {};
            return /* @__PURE__ */ A.jsx(Dee, { role: "columnheader", children: le ? null : /* @__PURE__ */ A.jsxs(Si, { ..._e, display: "flex", alignItems: "center", children: [
              tb(ae.column.columnDef.header, ae.getContext()),
              ue && /* @__PURE__ */ A.jsx(Ne.span, { pl: "4", children: T2e(ae.column) })
            ] }) }, ae.id);
          }) }, j.id)) }),
          /* @__PURE__ */ A.jsx(Ree, { role: "rowgroup", children: _().rows.map((j) => {
            const ae = G ? {
              sx: {
                ":hover td": {
                  cursor: "pointer"
                }
              },
              onClick: () => n(j.original)
            } : {};
            return /* @__PURE__ */ A.jsx(
              Kv,
              {
                role: "row",
                onMouseOver: F ? () => r(j.original) : void 0,
                backgroundColor: a ? a(j.original) : "transparent",
                ...ae,
                children: j.getVisibleCells().map((ue) => /* @__PURE__ */ A.jsx(Eee, { children: tb(ue.column.columnDef.cell, ue.getContext()) }, ue.id))
              },
              j.id
            );
          }) })
        ] }),
        E && /* @__PURE__ */ A.jsxs(Y2, { justifyContent: "center", alignItems: "center", gap: 6, paddingTop: 4, children: [
          /* @__PURE__ */ A.jsx(
            ef,
            {
              onClick: m,
              disabled: !P,
              ariaLabel: "Back",
              icon: "arrow-left"
            }
          ),
          /* @__PURE__ */ A.jsx(Wo, { children: `${R} of ${I}` }),
          /* @__PURE__ */ A.jsx(
            ef,
            {
              onClick: g,
              disabled: !N,
              ariaLabel: "Next",
              icon: "arrow-right"
            }
          )
        ] })
      ]
    }
  );
}, {
  createElement: ec,
  createContext: P2e,
  forwardRef: Vw,
  useCallback: Ki,
  useContext: Ow,
  useEffect: vi,
  useImperativeHandle: Fw,
  useLayoutEffect: k2e,
  useMemo: V2e,
  useRef: go,
  useState: O1
} = De, nb = De["useId".toString()], Pf = k2e, O2e = typeof nb == "function" ? nb : () => null;
let F2e = 0;
function m9(e = null) {
  const t = O2e(), n = go(e || t || null);
  return n.current === null && (n.current = "" + F2e++), n.current;
}
const jh = P2e(null);
jh.displayName = "PanelGroupContext";
function Bw({
  children: e = null,
  className: t = "",
  collapsedSize: n = 0,
  collapsible: r = !1,
  defaultSize: o = null,
  forwardedRef: a,
  id: s = null,
  maxSize: l = 100,
  minSize: c = 10,
  onCollapse: d = null,
  onResize: f = null,
  order: h = null,
  style: m = {},
  tagName: g = "div"
}) {
  const b = Ow(jh);
  if (b === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const C = m9(s), {
    collapsePanel: y,
    expandPanel: _,
    getPanelStyle: x,
    registerPanel: I,
    resizePanel: R,
    unregisterPanel: E
  } = b, k = go({
    onCollapse: d,
    onResize: f
  });
  if (vi(() => {
    k.current.onCollapse = d, k.current.onResize = f;
  }), c < 0 || c > 100)
    throw Error(`Panel minSize must be between 0 and 100, but was ${c}`);
  if (l < 0 || l > 100)
    throw Error(`Panel maxSize must be between 0 and 100, but was ${l}`);
  if (o !== null) {
    if (o < 0 || o > 100)
      throw Error(`Panel defaultSize must be between 0 and 100, but was ${o}`);
    c > o && !r && (console.error(`Panel minSize ${c} cannot be greater than defaultSize ${o}`), o = c);
  }
  const N = x(C, o), P = go({
    size: rb(N)
  }), F = go({
    callbacksRef: k,
    collapsedSize: n,
    collapsible: r,
    defaultSize: o,
    id: C,
    idWasAutoGenerated: s == null,
    maxSize: l,
    minSize: c,
    order: h
  });
  return Pf(() => {
    P.current.size = rb(N), F.current.callbacksRef = k, F.current.collapsedSize = n, F.current.collapsible = r, F.current.defaultSize = o, F.current.id = C, F.current.idWasAutoGenerated = s == null, F.current.maxSize = l, F.current.minSize = c, F.current.order = h;
  }), Pf(() => (I(C, F), () => {
    E(C);
  }), [h, C, I, E]), Fw(a, () => ({
    collapse: () => y(C),
    expand: () => _(C),
    getCollapsed() {
      return P.current.size === 0;
    },
    getSize() {
      return P.current.size;
    },
    resize: (G) => R(C, G)
  }), [y, _, C, R]), ec(g, {
    children: e,
    className: t,
    "data-panel": "",
    "data-panel-collapsible": r || void 0,
    "data-panel-id": C,
    "data-panel-size": parseFloat("" + N.flexGrow).toFixed(1),
    id: `data-panel-id-${C}`,
    style: {
      ...N,
      ...m
    }
  });
}
const Y3 = Vw((e, t) => ec(Bw, {
  ...e,
  forwardedRef: t
}));
Bw.displayName = "Panel";
Y3.displayName = "forwardRef(Panel)";
function rb(e) {
  const {
    flexGrow: t
  } = e;
  return typeof t == "string" ? parseFloat(t) : t;
}
const Al = 10;
function m1(e, t, n, r, o, a, s, l) {
  const {
    sizes: c
  } = l || {}, d = c || a;
  if (o === 0)
    return d;
  const f = Vo(t), h = d.concat();
  let m = 0;
  {
    const C = o < 0 ? r : n, y = f.findIndex((R) => R.current.id === C), _ = f[y], x = d[y], I = ob(_, Math.abs(o), x, e);
    if (x === I)
      return d;
    I === 0 && x > 0 && s.set(C, x), o = o < 0 ? x - I : I - x;
  }
  let g = o < 0 ? n : r, b = f.findIndex((C) => C.current.id === g);
  for (; ; ) {
    const C = f[b], y = d[b], _ = Math.abs(o) - Math.abs(m), x = ob(C, 0 - _, y, e);
    if (y !== x && (x === 0 && y > 0 && s.set(C.current.id, y), m += y - x, h[b] = x, m.toPrecision(Al).localeCompare(Math.abs(o).toPrecision(Al), void 0, {
      numeric: !0
    }) >= 0))
      break;
    if (o < 0) {
      if (--b < 0)
        break;
    } else if (++b >= f.length)
      break;
  }
  return m === 0 ? d : (g = o < 0 ? r : n, b = f.findIndex((C) => C.current.id === g), h[b] = d[b] + m, h);
}
function fu(e, t, n) {
  t.forEach((r, o) => {
    const a = e[o];
    if (!a)
      return;
    const {
      callbacksRef: s,
      collapsedSize: l,
      collapsible: c,
      id: d
    } = a.current, f = n[d];
    if (f !== r) {
      n[d] = r;
      const {
        onCollapse: h,
        onResize: m
      } = s.current;
      m && m(r, f), c && h && ((f == null || f === l) && r !== l ? h(!1) : f !== l && r === l && h(!0));
    }
  });
}
function A5(e, t) {
  if (t.length < 2)
    return [null, null];
  const n = t.findIndex((s) => s.current.id === e);
  if (n < 0)
    return [null, null];
  const r = n === t.length - 1, o = r ? t[n - 1].current.id : e, a = r ? e : t[n + 1].current.id;
  return [o, a];
}
function Hw(e, t, n) {
  if (e.size === 1)
    return "100";
  const o = Vo(e).findIndex((s) => s.current.id === t), a = n[o];
  return a == null ? "0" : a.toPrecision(Al);
}
function B2e(e) {
  const t = document.querySelector(`[data-panel-id="${e}"]`);
  return t || null;
}
function g9(e) {
  const t = document.querySelector(`[data-panel-group-id="${e}"]`);
  return t || null;
}
function Wh(e) {
  const t = document.querySelector(`[data-panel-resize-handle-id="${e}"]`);
  return t || null;
}
function H2e(e) {
  return Gw().findIndex((r) => r.getAttribute("data-panel-resize-handle-id") === e) ?? null;
}
function Gw() {
  return Array.from(document.querySelectorAll("[data-panel-resize-handle-id]"));
}
function $w(e) {
  return Array.from(document.querySelectorAll(`[data-panel-resize-handle-id][data-panel-group-id="${e}"]`));
}
function v9(e, t, n) {
  var c, d, f, h;
  const r = Wh(t), o = $w(e), a = r ? o.indexOf(r) : -1, s = ((d = (c = n[a]) == null ? void 0 : c.current) == null ? void 0 : d.id) ?? null, l = ((h = (f = n[a + 1]) == null ? void 0 : f.current) == null ? void 0 : h.id) ?? null;
  return [s, l];
}
function Vo(e) {
  return Array.from(e.values()).sort((t, n) => {
    const r = t.current.order, o = n.current.order;
    return r == null && o == null ? 0 : r == null ? -1 : o == null ? 1 : r - o;
  });
}
function ob(e, t, n, r) {
  var f;
  const o = n + t, {
    collapsedSize: a,
    collapsible: s,
    maxSize: l,
    minSize: c
  } = e.current;
  if (s) {
    if (n > a) {
      if (o <= c / 2 + a)
        return a;
    } else if (!((f = r == null ? void 0 : r.type) == null ? void 0 : f.startsWith("key")) && o < c)
      return a;
  }
  return Math.min(l, Math.max(c, o));
}
function Zw(e, t = "Assertion failed!") {
  if (!e)
    throw console.error(t), Error(t);
}
function G2e({
  committedValuesRef: e,
  groupId: t,
  panels: n,
  setSizes: r,
  sizes: o,
  panelSizeBeforeCollapse: a
}) {
  vi(() => {
    const {
      direction: s,
      panels: l
    } = e.current, c = g9(t), {
      height: d,
      width: f
    } = c.getBoundingClientRect(), m = $w(t).map((g) => {
      const b = g.getAttribute("data-panel-resize-handle-id"), C = Vo(l), [y, _] = v9(t, b, C);
      if (y == null || _ == null)
        return () => {
        };
      let x = 0, I = 100, R = 0, E = 0;
      C.forEach((j) => {
        j.current.id === y ? (I = j.current.maxSize, x = j.current.minSize) : (R += j.current.minSize, E += j.current.maxSize);
      });
      const k = Math.min(I, 100 - R), N = Math.max(x, (C.length - 1) * 100 - E), P = Hw(l, y, o);
      g.setAttribute("aria-valuemax", "" + Math.round(k)), g.setAttribute("aria-valuemin", "" + Math.round(N)), g.setAttribute("aria-valuenow", "" + Math.round(parseInt(P)));
      const F = (j) => {
        if (!j.defaultPrevented)
          switch (j.key) {
            case "Enter": {
              j.preventDefault();
              const ae = C.findIndex((ue) => ue.current.id === y);
              if (ae >= 0) {
                const ue = C[ae], le = o[ae];
                if (le != null) {
                  let _e = 0;
                  le.toPrecision(Al) <= ue.current.minSize.toPrecision(Al) ? _e = s === "horizontal" ? f : d : _e = -(s === "horizontal" ? f : d);
                  const ve = m1(j, l, y, _, _e, o, a.current, null);
                  o !== ve && r(ve);
                }
              }
              break;
            }
          }
      };
      g.addEventListener("keydown", F);
      const G = B2e(y);
      return G != null && g.setAttribute("aria-controls", G.id), () => {
        g.removeAttribute("aria-valuemax"), g.removeAttribute("aria-valuemin"), g.removeAttribute("aria-valuenow"), g.removeEventListener("keydown", F), G != null && g.removeAttribute("aria-controls");
      };
    });
    return () => {
      m.forEach((g) => g());
    };
  }, [e, t, n, a, r, o]);
}
function $2e({
  disabled: e,
  handleId: t,
  resizeHandler: n
}) {
  vi(() => {
    if (e || n == null)
      return;
    const r = Wh(t);
    if (r == null)
      return;
    const o = (a) => {
      if (!a.defaultPrevented)
        switch (a.key) {
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "ArrowUp":
          case "End":
          case "Home": {
            a.preventDefault(), n(a);
            break;
          }
          case "F6": {
            a.preventDefault();
            const s = Gw(), l = H2e(t);
            Zw(l !== null);
            const c = a.shiftKey ? l > 0 ? l - 1 : s.length - 1 : l + 1 < s.length ? l + 1 : 0;
            s[c].focus();
            break;
          }
        }
    };
    return r.addEventListener("keydown", o), () => {
      r.removeEventListener("keydown", o);
    };
  }, [e, t, n]);
}
function Z2e(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function jw(e, t, n, r = 0, o = null) {
  const a = n === "horizontal";
  let s = 0;
  if (q3(e))
    s = a ? e.clientX : e.clientY;
  else if (J3(e)) {
    const f = e.touches[0];
    s = a ? f.screenX : f.screenY;
  } else
    return 0;
  const l = Wh(t), c = o || l.getBoundingClientRect(), d = a ? c.left : c.top;
  return s - d - r;
}
function j2e(e, t, n, r, o, a, s) {
  const {
    dragOffset: l = 0,
    dragHandleRect: c,
    sizes: d
  } = s || {}, f = d || a;
  if (W2e(e)) {
    const h = o === "horizontal", g = g9(t).getBoundingClientRect(), b = h ? g.width : g.height, C = e.shiftKey ? 10 : 100, y = b / C;
    let _ = 0;
    switch (e.key) {
      case "ArrowDown":
        _ = h ? 0 : y;
        break;
      case "ArrowLeft":
        _ = h ? -y : 0;
        break;
      case "ArrowRight":
        _ = h ? y : 0;
        break;
      case "ArrowUp":
        _ = h ? 0 : -y;
        break;
      case "End":
        _ = b;
        break;
      case "Home":
        _ = -b;
        break;
    }
    const [x, I] = v9(t, n, r), R = _ < 0 ? x : I, E = r.findIndex((N) => N.current.id === R), k = r[E];
    if (k.current.collapsible) {
      const N = f[E];
      (N === 0 || N.toPrecision(Al) === k.current.minSize.toPrecision(Al)) && (_ = _ < 0 ? -k.current.minSize * b : k.current.minSize * b);
    }
    return _;
  } else
    return jw(e, n, o, l, c);
}
function W2e(e) {
  return e.type === "keydown";
}
function q3(e) {
  return e.type.startsWith("mouse");
}
function J3(e) {
  return e.type.startsWith("touch");
}
let K3 = null, nl = null;
function Ww(e) {
  switch (e) {
    case "horizontal":
      return "ew-resize";
    case "horizontal-max":
      return "w-resize";
    case "horizontal-min":
      return "e-resize";
    case "vertical":
      return "ns-resize";
    case "vertical-max":
      return "n-resize";
    case "vertical-min":
      return "s-resize";
  }
}
function z2e() {
  nl !== null && (document.head.removeChild(nl), K3 = null, nl = null);
}
function M5(e) {
  if (K3 === e)
    return;
  K3 = e;
  const t = Ww(e);
  nl === null && (nl = document.createElement("style"), document.head.appendChild(nl)), nl.innerHTML = `*{cursor: ${t}!important;}`;
}
function U2e(e, t = 10) {
  let n = null;
  return (...o) => {
    n !== null && clearTimeout(n), n = setTimeout(() => {
      e(...o);
    }, t);
  };
}
function zw(e) {
  return e.map((t) => {
    const {
      minSize: n,
      order: r
    } = t.current;
    return r ? `${r}:${n}` : `${n}`;
  }).sort((t, n) => t.localeCompare(n)).join(",");
}
function Uw(e, t) {
  try {
    const n = t.getItem(`PanelGroup:sizes:${e}`);
    if (n) {
      const r = JSON.parse(n);
      if (typeof r == "object" && r != null)
        return r;
    }
  } catch {
  }
  return null;
}
function X2e(e, t, n) {
  const r = Uw(e, n);
  if (r) {
    const o = zw(t);
    return r[o] ?? null;
  }
  return null;
}
function Y2e(e, t, n, r) {
  const o = zw(t), a = Uw(e, r) || {};
  a[o] = n;
  try {
    r.setItem(`PanelGroup:sizes:${e}`, JSON.stringify(a));
  } catch (s) {
    console.error(s);
  }
}
const x5 = {};
function ab(e) {
  try {
    if (typeof localStorage < "u")
      e.getItem = (t) => localStorage.getItem(t), e.setItem = (t, n) => {
        localStorage.setItem(t, n);
      };
    else
      throw new Error("localStorage not supported in this environment");
  } catch (t) {
    console.error(t), e.getItem = () => null, e.setItem = () => {
    };
  }
}
const g1 = {
  getItem: (e) => (ab(g1), g1.getItem(e)),
  setItem: (e, t) => {
    ab(g1), g1.setItem(e, t);
  }
};
function Xw({
  autoSaveId: e,
  children: t = null,
  className: n = "",
  direction: r,
  disablePointerEventsDuringResize: o = !1,
  forwardedRef: a,
  id: s = null,
  onLayout: l,
  storage: c = g1,
  style: d = {},
  tagName: f = "div"
}) {
  const h = m9(s), [m, g] = O1(null), [b, C] = O1(/* @__PURE__ */ new Map()), y = go(null);
  go({
    didLogDefaultSizeWarning: !1,
    didLogIdAndOrderWarning: !1,
    prevPanelIds: []
  });
  const _ = go({
    onLayout: l
  });
  vi(() => {
    _.current.onLayout = l;
  });
  const x = go({}), [I, R] = O1([]), E = go(/* @__PURE__ */ new Map()), k = go(0), N = go({
    direction: r,
    panels: b,
    sizes: I
  });
  Fw(a, () => ({
    getLayout: () => {
      const {
        sizes: z
      } = N.current;
      return z;
    },
    setLayout: (z) => {
      const K = z.reduce((ge, X) => ge + X, 0);
      Zw(K === 100, "Panel sizes must add up to 100%");
      const {
        panels: Ce
      } = N.current, q = x.current, J = Vo(Ce);
      R(z), fu(J, z, q);
    }
  }), []), Pf(() => {
    N.current.direction = r, N.current.panels = b, N.current.sizes = I;
  }), G2e({
    committedValuesRef: N,
    groupId: h,
    panels: b,
    setSizes: R,
    sizes: I,
    panelSizeBeforeCollapse: E
  }), vi(() => {
    const {
      onLayout: z
    } = _.current, {
      panels: K,
      sizes: Ce
    } = N.current;
    if (Ce.length > 0) {
      z && z(Ce);
      const q = x.current, J = Vo(K);
      fu(J, Ce, q);
    }
  }, [I]), Pf(() => {
    if (N.current.sizes.length === b.size)
      return;
    let K = null;
    if (e) {
      const Ce = Vo(b);
      K = X2e(e, Ce, c);
    }
    if (K != null)
      R(K);
    else {
      const Ce = Vo(b);
      let q = 0, J = 0, ge = 0;
      if (Ce.forEach((X) => {
        ge += X.current.minSize, X.current.defaultSize === null ? q++ : J += X.current.defaultSize;
      }), J > 100)
        throw new Error("Default panel sizes cannot exceed 100%");
      if (Ce.length > 1 && q === 0 && J !== 100)
        throw new Error("Invalid default sizes specified for panels");
      if (ge > 100)
        throw new Error("Minimum panel sizes cannot exceed 100%");
      R(Ce.map((X) => X.current.defaultSize === null ? (100 - J) / q : X.current.defaultSize));
    }
  }, [e, b, c]), vi(() => {
    if (e) {
      if (I.length === 0 || I.length !== b.size)
        return;
      const z = Vo(b);
      x5[e] || (x5[e] = U2e(Y2e, 100)), x5[e](e, z, I, c);
    }
  }, [e, b, I, c]);
  const P = Ki((z, K) => {
    const {
      panels: Ce
    } = N.current;
    return Ce.size === 0 ? {
      flexBasis: 0,
      flexGrow: K ?? void 0,
      flexShrink: 1,
      // Without this, Panel sizes may be unintentionally overridden by their content.
      overflow: "hidden"
    } : {
      flexBasis: 0,
      flexGrow: Hw(Ce, z, I),
      flexShrink: 1,
      // Without this, Panel sizes may be unintentionally overridden by their content.
      overflow: "hidden",
      // Disable pointer events inside of a panel during resize.
      // This avoid edge cases like nested iframes.
      pointerEvents: o && m !== null ? "none" : void 0
    };
  }, [m, o, I]), F = Ki((z, K) => {
    C((Ce) => {
      if (Ce.has(z))
        return Ce;
      const q = new Map(Ce);
      return q.set(z, K), q;
    });
  }, []), G = Ki((z) => (Ce) => {
    Ce.preventDefault();
    const {
      direction: q,
      panels: J,
      sizes: ge
    } = N.current, X = Vo(J), [pe, fe] = v9(h, z, X);
    if (pe == null || fe == null)
      return;
    let de = j2e(Ce, h, z, X, q, ge, y.current);
    if (de === 0)
      return;
    const Ie = g9(h).getBoundingClientRect(), Pe = q === "horizontal";
    document.dir === "rtl" && Pe && (de = -de);
    const Se = Pe ? Ie.width : Ie.height, Fe = de / Se * 100, oe = m1(Ce, J, pe, fe, Fe, ge, E.current, y.current), pt = !Z2e(ge, oe);
    if ((q3(Ce) || J3(Ce)) && k.current != Fe && M5(pt ? Pe ? "horizontal" : "vertical" : Pe ? de < 0 ? "horizontal-min" : "horizontal-max" : de < 0 ? "vertical-min" : "vertical-max"), pt) {
      const Ee = x.current;
      R(oe), fu(X, oe, Ee);
    }
    k.current = Fe;
  }, [h]), j = Ki((z) => {
    C((K) => {
      if (!K.has(z))
        return K;
      const Ce = new Map(K);
      return Ce.delete(z), Ce;
    });
  }, []), ae = Ki((z) => {
    const {
      panels: K,
      sizes: Ce
    } = N.current, q = K.get(z);
    if (q == null)
      return;
    const {
      collapsedSize: J,
      collapsible: ge
    } = q.current;
    if (!ge)
      return;
    const X = Vo(K), pe = X.indexOf(q);
    if (pe < 0)
      return;
    const fe = Ce[pe];
    if (fe === J)
      return;
    E.current.set(z, fe);
    const [de, we] = A5(z, X);
    if (de == null || we == null)
      return;
    const Pe = pe === X.length - 1 ? fe : J - fe, Se = m1(null, K, de, we, Pe, Ce, E.current, null);
    if (Ce !== Se) {
      const Fe = x.current;
      R(Se), fu(X, Se, Fe);
    }
  }, []), ue = Ki((z) => {
    const {
      panels: K,
      sizes: Ce
    } = N.current, q = K.get(z);
    if (q == null)
      return;
    const {
      collapsedSize: J,
      minSize: ge
    } = q.current, X = E.current.get(z) || ge;
    if (!X)
      return;
    const pe = Vo(K), fe = pe.indexOf(q);
    if (fe < 0 || Ce[fe] !== J)
      return;
    const [we, Ie] = A5(z, pe);
    if (we == null || Ie == null)
      return;
    const Se = fe === pe.length - 1 ? J - X : X, Fe = m1(null, K, we, Ie, Se, Ce, E.current, null);
    if (Ce !== Fe) {
      const oe = x.current;
      R(Fe), fu(pe, Fe, oe);
    }
  }, []), le = Ki((z, K) => {
    const {
      panels: Ce,
      sizes: q
    } = N.current, J = Ce.get(z);
    if (J == null)
      return;
    const {
      collapsedSize: ge,
      collapsible: X,
      maxSize: pe,
      minSize: fe
    } = J.current, de = Vo(Ce), we = de.indexOf(J);
    if (we < 0)
      return;
    const Ie = q[we];
    if (Ie === K)
      return;
    X && K === ge || (K = Math.min(pe, Math.max(fe, K)));
    const [Pe, Se] = A5(z, de);
    if (Pe == null || Se == null)
      return;
    const oe = we === de.length - 1 ? Ie - K : K - Ie, pt = m1(null, Ce, Pe, Se, oe, q, E.current, null);
    if (q !== pt) {
      const Ee = x.current;
      R(pt), fu(de, pt, Ee);
    }
  }, []), _e = V2e(() => ({
    activeHandleId: m,
    collapsePanel: ae,
    direction: r,
    expandPanel: ue,
    getPanelStyle: P,
    groupId: h,
    registerPanel: F,
    registerResizeHandle: G,
    resizePanel: le,
    startDragging: (z, K) => {
      if (g(z), q3(K) || J3(K)) {
        const Ce = Wh(z);
        y.current = {
          dragHandleRect: Ce.getBoundingClientRect(),
          dragOffset: jw(K, z, r),
          sizes: N.current.sizes
        };
      }
    },
    stopDragging: () => {
      z2e(), g(null), y.current = null;
    },
    unregisterPanel: j
  }), [m, ae, r, ue, P, h, F, G, le, j]), ve = {
    display: "flex",
    flexDirection: r === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return ec(jh.Provider, {
    children: ec(f, {
      children: t,
      className: n,
      "data-panel-group": "",
      "data-panel-group-direction": r,
      "data-panel-group-id": h,
      style: {
        ...ve,
        ...d
      }
    }),
    value: _e
  });
}
const Yw = Vw((e, t) => ec(Xw, {
  ...e,
  forwardedRef: t
}));
Xw.displayName = "PanelGroup";
Yw.displayName = "forwardRef(PanelGroup)";
function qw({
  children: e = null,
  className: t = "",
  disabled: n = !1,
  id: r = null,
  onDragging: o,
  style: a = {},
  tagName: s = "div"
}) {
  const l = go(null), c = go({
    onDragging: o
  });
  vi(() => {
    c.current.onDragging = o;
  });
  const d = Ow(jh);
  if (d === null)
    throw Error("PanelResizeHandle components must be rendered within a PanelGroup container");
  const {
    activeHandleId: f,
    direction: h,
    groupId: m,
    registerResizeHandle: g,
    startDragging: b,
    stopDragging: C
  } = d, y = m9(r), _ = f === y, [x, I] = O1(!1), [R, E] = O1(null), k = Ki(() => {
    l.current.blur(), C();
    const {
      onDragging: F
    } = c.current;
    F && F(!1);
  }, [C]);
  vi(() => {
    if (n)
      E(null);
    else {
      const P = g(y);
      E(() => P);
    }
  }, [n, y, g]), vi(() => {
    if (n || R == null || !_)
      return;
    const P = (ae) => {
      R(ae);
    }, F = (ae) => {
      R(ae);
    }, j = l.current.ownerDocument;
    return j.body.addEventListener("contextmenu", k), j.body.addEventListener("mousemove", P), j.body.addEventListener("touchmove", P), j.body.addEventListener("mouseleave", F), window.addEventListener("mouseup", k), window.addEventListener("touchend", k), () => {
      j.body.removeEventListener("contextmenu", k), j.body.removeEventListener("mousemove", P), j.body.removeEventListener("touchmove", P), j.body.removeEventListener("mouseleave", F), window.removeEventListener("mouseup", k), window.removeEventListener("touchend", k);
    };
  }, [h, n, _, R, k]), $2e({
    disabled: n,
    handleId: y,
    resizeHandler: R
  });
  const N = {
    cursor: Ww(h),
    touchAction: "none",
    userSelect: "none"
  };
  return ec(s, {
    children: e,
    className: t,
    "data-resize-handle-active": _ ? "pointer" : x ? "keyboard" : void 0,
    "data-panel-group-direction": h,
    "data-panel-group-id": m,
    "data-panel-resize-handle-enabled": !n,
    "data-panel-resize-handle-id": y,
    onBlur: () => I(!1),
    onFocus: () => I(!0),
    onMouseDown: (P) => {
      b(y, P.nativeEvent);
      const {
        onDragging: F
      } = c.current;
      F && F(!0);
    },
    onMouseUp: k,
    onTouchCancel: k,
    onTouchEnd: k,
    onTouchStart: (P) => {
      b(y, P.nativeEvent);
      const {
        onDragging: F
      } = c.current;
      F && F(!0);
    },
    ref: l,
    role: "separator",
    style: {
      ...N,
      ...a
    },
    tabIndex: 0
  });
}
qw.displayName = "PanelResizeHandle";
const Xme = ({ direction: e, config: t = {}, panelA: n, panelB: r }) => {
  var o;
  return /* @__PURE__ */ A.jsxs(Yw, { direction: e, ...t.panelGroupProps, ref: t.panelGroupRef, children: [
    /* @__PURE__ */ A.jsx(Y3, { ...t.panelAProps, ref: t.panelARef, children: n }),
    t.isResizable && /* @__PURE__ */ A.jsx(
      qw,
      {
        style: {
          ...e === "vertical" ? { maxHeight: "10px" } : { maxWidth: "10px" }
        },
        children: /* @__PURE__ */ A.jsx(
          Si,
          {
            height: e === "vertical" ? "10px" : "full",
            width: e === "vertical" ? "full" : "10px",
            backgroundColor: "hoverTransparentLight",
            _hover: { backgroundColor: "hoverTransparentLight" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            role: "group",
            children: /* @__PURE__ */ A.jsx(
              Si,
              {
                ...e === "vertical" ? {
                  width: "20",
                  height: 1
                } : { height: "20", width: 1 },
                borderRadius: "lg",
                backgroundColor: "strokeDefault",
                _groupHover: { backgroundColor: "hoverTransparentLight" }
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ A.jsx(
      Y3,
      {
        ...t.panelBProps,
        ref: t.panelBRef,
        ...(o = t.panelBProps) != null && o.isCollapsed ? { defaultSize: 0 } : {},
        children: r
      }
    )
  ] });
}, Yme = ({
  wrapperProps: e = {},
  children: t,
  footer: n,
  header: r,
  bodyProps: o,
  footerProps: a,
  headerProps: s
}) => /* @__PURE__ */ A.jsxs(uY, { ...e, children: [
  wi(r) && /* @__PURE__ */ A.jsx(fY, { ...s, children: r }),
  /* @__PURE__ */ A.jsx(cY, { ...o, children: t }),
  wi(n) && /* @__PURE__ */ A.jsx(dY, { ...a, children: n })
] }), qme = (e) => /* @__PURE__ */ A.jsx(JM, { ...e }), Jme = (e) => /* @__PURE__ */ A.jsx(KM, { ...e }), Kme = (e) => /* @__PURE__ */ A.jsx(tx, { ...e }), Qme = (e) => /* @__PURE__ */ A.jsx(nx, { ...e }), q2e = ({
  tab: e,
  onClick: t,
  isSelected: n,
  variant: r
}) => {
  let o = "textTertiary";
  n && (o = r === "primary" ? "textOffset" : "textPrimary");
  const a = (s) => {
    (s.key === "Enter" || s.key === " ") && (s.preventDefault(), t());
  };
  return /* @__PURE__ */ A.jsx(
    "div",
    {
      "data-tab-value": e.value,
      onClick: t,
      onKeyDown: a,
      role: "tab",
      tabIndex: 0,
      "aria-selected": n,
      className: to("tab", n && "selected"),
      children: k1e(e.label) ? /* @__PURE__ */ A.jsx(Wo, { variant: "h3", color: o, __dangerDoNotUseSx: { whiteSpace: "nowrap" }, children: e.label }) : e.label
    }
  );
};
const e5e = ({
  tabs: e,
  activeTab: t,
  setActiveTab: n,
  variant: r = "primary"
}) => /* @__PURE__ */ A.jsx("div", { className: `tabs wrapper ${r}`, "data-active-tab": t, children: e.map((o) => /* @__PURE__ */ A.jsx(
  q2e,
  {
    variant: r,
    isSelected: o.value === t,
    tab: o,
    onClick: () => n(o.value)
  },
  `${o.label}-${o.value}`
)) }), t5e = (e) => `${e}px`;
function n5e({ items: e, value: t, onChange: n, ...r }) {
  const { getRootProps: o, getRadioProps: a } = _x({
    defaultValue: void 0,
    value: t,
    onChange: n
  });
  return cc(
    { ...r, fullWidth: !1 },
    /* @__PURE__ */ A.jsx(Si, { display: "flex", gap: "8px", ...o(), children: e.map(({ label: s, value: l }) => {
      const c = a({ value: l });
      return /* @__PURE__ */ A.jsx(J2e, { ...c, children: s }, l);
    }) })
  );
}
const J2e = (e) => {
  const { getInputProps: t, getRadioProps: n } = Lx(e), { isChecked: r, children: o } = e, a = t(), s = n();
  return /* @__PURE__ */ A.jsxs(Si, { as: "label", flexShrink: "0", children: [
    /* @__PURE__ */ A.jsx("input", { ...a }),
    /* @__PURE__ */ A.jsx(
      Si,
      {
        ...s,
        cursor: "pointer",
        borderWidth: "1px",
        borderRadius: "20px",
        border: "1px solid",
        borderColor: "strokeDefault",
        paddingX: "16px",
        paddingY: "6px",
        width: "fit-content",
        backgroundColor: "surface1",
        children: /* @__PURE__ */ A.jsx(
          Wo,
          {
            variant: "chip",
            color: r ? "buttonDefault" : void 0,
            children: o
          }
        )
      }
    )
  ] });
}, K2e = (e) => e.type === "number" || e.type === "date" || e.type === "month" || e.type === "count", Q2e = (e) => e.type === "number" || e.type === "count", Md = (e, t, n) => n ? ["simple-field-filler"] : e === "grid" ? ["simple-field-sizer", "simple-field-size-grid"] : ["simple-field-sizer", `simple-field-size-${t}`], xd = (e, t = "100%") => e ? {} : { width: t };
const ib = ({
  addon: e,
  variant: t = "outline"
}) => {
  const n = to("simple-addon", t), r = { flex: "0 0 auto" };
  return /* @__PURE__ */ A.jsx("div", { style: r, className: n, children: e });
};
function efe(e) {
  const t = e;
  return t.leftAddon !== void 0 || t.rightAddon !== void 0;
}
const tfe = (e) => {
  const {
    width: t = "100%",
    leftAddon: n,
    rightAddon: r,
    children: o,
    variant: a = "outline",
    size: s = "md",
    isWrapped: l
  } = e, c = xd(l, t), d = Md(a, s, l);
  return /* @__PURE__ */ A.jsxs("div", { style: c, className: to("simple-addon-wrapper", ...d), children: [
    n && /* @__PURE__ */ A.jsx(ib, { addon: n, ...e }),
    o,
    r && /* @__PURE__ */ A.jsx(ib, { addon: r, ...e })
  ] });
};
function nfe(e) {
  const t = e;
  return (t.errorMessage !== void 0 || t.label !== void 0) && t.variant !== "grid";
}
const rfe = ({
  label: e,
  labelTypographyVariant: t = "label",
  id: n,
  children: r,
  errorMessage: o,
  required: a
}) => /* @__PURE__ */ A.jsxs("div", { className: "simple-field-wrapper", children: [
  /* @__PURE__ */ A.jsxs("div", { className: "simple-field-input-with-label", children: [
    e && /* @__PURE__ */ A.jsxs("label", { htmlFor: n, className: "simple-field-label", children: [
      /* @__PURE__ */ A.jsx(Wo, { variant: t, children: e }),
      a && /* @__PURE__ */ A.jsx("span", { className: "simple-field-required", children: "*" })
    ] }),
    r
  ] }),
  o && /* @__PURE__ */ A.jsx("div", { className: "simple-field-error-message", children: /* @__PURE__ */ A.jsx(Wo, { variant: "body2", color: "alertError", children: o }) })
] }), sb = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), Jw = ",", ofe = ".", afe = 10, ife = 0, sfe = ({
  prefix: e = "",
  postfix: t = "",
  useSeparator: n = !1,
  type: r = "number",
  precision: o,
  min: a,
  max: s
}) => {
  const { plugins: l, ...c } = b0e({
    postfix: t,
    prefix: e,
    thousandSeparator: n ? Jw : "",
    decimalSeparator: ofe,
    precision: $t(o) ? o : r === "number" ? afe : ife,
    min: $t(a) ? +a : void 0,
    max: $t(s) ? +s : void 0
  });
  return {
    ...c,
    plugins: [
      ...l,
      // Forbids caret to be placed in pre or postfix
      yw((d) => [e.length - 1, d.length - t.length]),
      Wde()
    ]
  };
}, lfe = ({ postfix: e, prefix: t, useSeparator: n }) => {
  const r = [];
  return Z3(t) || r.push((o) => o.replace(new RegExp(`^${sb(t)}`), "")), Z3(e) || r.push((o) => o.replace(new RegExp(`${sb(e)}$`), "")), n && r.push(
    (o) => o.replace(new RegExp(`(?!^)${Jw}(?!$)`, "g"), "")
  ), r;
}, ufe = ({
  children: e,
  postfix: t,
  prefix: n,
  useSeparator: r,
  type: o,
  precision: a,
  width: s,
  variant: l = "outline",
  size: c = "md",
  min: d,
  max: f,
  isWrapped: h,
  placeholder: m,
  onChange: g,
  value: b
}) => {
  const C = Et(
    () => sfe({
      postfix: t,
      prefix: n,
      useSeparator: r,
      type: o,
      precision: a,
      min: d,
      max: f
    }),
    [t, n, r, o, a, d, f]
  ), y = Mw({ options: C }), _ = Sd($t(b) ? b : "", C), x = te(
    (k) => {
      const N = (P) => lfe({ postfix: t, prefix: n, useSeparator: r }).reduce((F, G) => G(F), P);
      if (g) {
        const P = N(k.currentTarget.value);
        g({
          // Emit unmasked val
          ...k,
          target: { ...k.target, value: P },
          currentTarget: { ...k.currentTarget, value: P }
        });
      }
    },
    [g, t, n, r]
  ), I = m || `${n || ""} ${t || ""}`, R = xd(h, s), E = Md(l, c, h);
  return /* @__PURE__ */ A.jsx("div", { ref: y, style: R, className: to("simple-field-mask", ...E), children: Fa(
    e,
    {
      onInput: x,
      // this is the html input element inside of simple input, so onInput is a valid prop
      placeholder: I,
      value: _
    },
    null
  ) });
}, cfe = [
  {
    isSizerWrapper: !1,
    predicate: (e) => nfe(e),
    decorator: (e, t) => (n) => /* @__PURE__ */ A.jsx(rfe, { ...t, isWrapped: e, children: n })
  },
  {
    isSizerWrapper: !0,
    predicate: (e) => efe(e),
    decorator: (e, t) => (n) => /* @__PURE__ */ A.jsx(tfe, { ...t, isWrapped: e, children: n })
  },
  {
    isSizerWrapper: !0,
    predicate: (e) => Q2e(e),
    decorator: (e, t) => (n) => /* @__PURE__ */ A.jsx(ufe, { ...t, isWrapped: e, children: n })
  }
], _d = (e) => {
  const t = [];
  let n = !1;
  for (const { predicate: o, decorator: a, isSizerWrapper: s } of cfe)
    o(e) && (t.push(a(n, e)), s && (n = !0));
  return { decorate: (o) => t.reduceRight((a, s) => s(a), o), isWrapped: n };
}, Id = (e) => He(e ?? T1e()).current;
const dfe = {
  text: "text",
  number: "text",
  count: "text",
  date: "date",
  month: "month"
}, ffe = (e) => dfe[e || "text"], r5e = nt((e, t) => {
  const {
    id: n,
    name: r,
    type: o,
    value: a,
    onChange: s,
    onBlur: l,
    invalid: c,
    width: d = "100%",
    variant: f = "outline",
    size: h = "md",
    placeholder: m,
    disabled: g,
    errorMessage: b,
    textAlign: C
  } = e, y = Id(n), { decorate: _, isWrapped: x } = _d({ ...e, id: y }), { min: I, max: R } = K2e(e) ? e : { min: void 0, max: void 0 }, E = { ...xd(x, d), ...C ? { textAlign: C } : {} }, k = [
    "simple-field",
    "simple-input",
    f,
    c || $t(b) ? "invalid" : "",
    ...Md(f, h, x)
  ];
  return _(
    /* @__PURE__ */ A.jsx(
      "input",
      {
        className: to(...k),
        ref: t,
        id: y,
        name: r,
        type: ffe(o),
        value: a,
        onChange: s,
        onBlur: l,
        style: E,
        min: I,
        max: R,
        placeholder: m,
        autoComplete: "off",
        disabled: g
      }
    )
  );
});
const o5e = nt(
  (e, t) => {
    const {
      children: n,
      id: r,
      name: o,
      value: a,
      invalid: s,
      onChange: l,
      onBlur: c,
      variant: d = "outline",
      size: f = "md",
      width: h = "100%",
      disabled: m
    } = e, g = Id(r), { decorate: b, isWrapped: C } = _d({ ...e, id: g });
    return b(
      /* @__PURE__ */ A.jsx(
        "select",
        {
          className: to(
            "simple-field",
            "simple-select",
            d,
            s && "invalid",
            ...Md(d, f, C)
          ),
          style: xd(C, h),
          ref: t,
          id: g,
          name: o,
          value: a,
          onChange: l,
          onBlur: c,
          disabled: m,
          children: n
        }
      )
    );
  }
);
const a5e = nt((e, t) => {
  const {
    id: n,
    name: r,
    value: o,
    onChange: a,
    onBlur: s,
    invalid: l,
    width: c = "100%",
    variant: d = "outline",
    size: f = "md",
    resize: h = "both",
    disabled: m
  } = e, g = Id(n), { decorate: b, isWrapped: C } = _d({ ...e, id: g });
  return b(
    /* @__PURE__ */ A.jsx(
      "textarea",
      {
        className: to(
          "simple-field",
          "simple-textarea",
          d,
          l && "invalid",
          "simple-field-sizer",
          ...Md(d, f, C)
        ),
        style: { resize: h, ...xd(C, c) },
        ref: t,
        id: g,
        name: r,
        value: o,
        onChange: a,
        onBlur: s,
        disabled: m
      }
    )
  );
});
function lb(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function et(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lb(Object(n), !0).forEach(function(r) {
      wu(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lb(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function hfe(e) {
  if (Array.isArray(e))
    return e;
}
function pfe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, a, s, l = [], c = !0, d = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        c = !1;
      } else
        for (; !(c = (r = a.call(n)).done) && (l.push(r.value), l.length !== t); c = !0)
          ;
    } catch (f) {
      d = !0, o = f;
    } finally {
      try {
        if (!c && n.return != null && (s = n.return(), Object(s) !== s))
          return;
      } finally {
        if (d)
          throw o;
      }
    }
    return l;
  }
}
function Q3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Kw(e, t) {
  if (e) {
    if (typeof e == "string")
      return Q3(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Q3(e, t) : void 0;
  }
}
function mfe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ci(e, t) {
  return hfe(e) || pfe(e, t) || Kw(e, t) || mfe();
}
function Ni(e, t) {
  if (e == null)
    return {};
  var n, r, o = YA(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
var gfe = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function vfe(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, r = e.defaultMenuIsOpen, o = r === void 0 ? !1 : r, a = e.defaultValue, s = a === void 0 ? null : a, l = e.inputValue, c = e.menuIsOpen, d = e.onChange, f = e.onInputChange, h = e.onMenuClose, m = e.onMenuOpen, g = e.value, b = Ni(e, gfe), C = je(l !== void 0 ? l : n), y = Ci(C, 2), _ = y[0], x = y[1], I = je(c !== void 0 ? c : o), R = Ci(I, 2), E = R[0], k = R[1], N = je(g !== void 0 ? g : s), P = Ci(N, 2), F = P[0], G = P[1], j = te(function(K, Ce) {
    typeof d == "function" && d(K, Ce), G(K);
  }, [d]), ae = te(function(K, Ce) {
    var q;
    typeof f == "function" && (q = f(K, Ce)), x(q !== void 0 ? q : K);
  }, [f]), ue = te(function() {
    typeof m == "function" && m(), k(!0);
  }, [m]), le = te(function() {
    typeof h == "function" && h(), k(!1);
  }, [h]), _e = l !== void 0 ? l : _, ve = c !== void 0 ? c : E, z = g !== void 0 ? g : F;
  return et(et({}, b), {}, {
    inputValue: _e,
    menuIsOpen: ve,
    onChange: j,
    onInputChange: ae,
    onMenuClose: le,
    onMenuOpen: ue,
    value: z
  });
}
function Cfe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ub(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, cM(r.key), r);
  }
}
function bfe(e, t, n) {
  return t && ub(e.prototype, t), n && ub(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function yfe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && q2(e, t);
}
function kf(e) {
  return kf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, kf(e);
}
function Qw() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Qw = function() {
    return !!e;
  })();
}
function Sfe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Afe(e, t) {
  if (t && (fl(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Sfe(e);
}
function Mfe(e) {
  var t = Qw();
  return function() {
    var n, r = kf(e);
    if (t) {
      var o = kf(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else
      n = r.apply(this, arguments);
    return Afe(this, n);
  };
}
function xfe(e) {
  if (Array.isArray(e))
    return Q3(e);
}
function _fe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Ife() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function C9(e) {
  return xfe(e) || _fe(e) || Kw(e) || Ife();
}
function wfe(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
const Lfe = Math.min, Rfe = Math.max, Vf = Math.round, d2 = Math.floor, Of = (e) => ({
  x: e,
  y: e
});
function Efe(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function zh() {
  return typeof window < "u";
}
function eL(e) {
  return nL(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function pa(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function tL(e) {
  var t;
  return (t = (nL(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function nL(e) {
  return zh() ? e instanceof Node || e instanceof pa(e).Node : !1;
}
function eg(e) {
  return zh() ? e instanceof Element || e instanceof pa(e).Element : !1;
}
function b9(e) {
  return zh() ? e instanceof HTMLElement || e instanceof pa(e).HTMLElement : !1;
}
function cb(e) {
  return !zh() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof pa(e).ShadowRoot;
}
function rL(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = y9(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function Dfe() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Nfe(e) {
  return ["html", "body", "#document"].includes(eL(e));
}
function y9(e) {
  return pa(e).getComputedStyle(e);
}
function Tfe(e) {
  if (eL(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    cb(e) && e.host || // Fallback.
    tL(e)
  );
  return cb(t) ? t.host : t;
}
function oL(e) {
  const t = Tfe(e);
  return Nfe(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : b9(t) && rL(t) ? t : oL(t);
}
function Ff(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = oL(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = pa(o);
  if (a) {
    const l = tg(s);
    return t.concat(s, s.visualViewport || [], rL(o) ? o : [], l && n ? Ff(l) : []);
  }
  return t.concat(o, Ff(o, [], n));
}
function tg(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Pfe(e) {
  const t = y9(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = b9(e), a = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, l = Vf(n) !== a || Vf(r) !== s;
  return l && (n = a, r = s), {
    width: n,
    height: r,
    $: l
  };
}
function S9(e) {
  return eg(e) ? e : e.contextElement;
}
function _5(e) {
  const t = S9(e);
  if (!b9(t))
    return Of(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = Pfe(t);
  let s = (a ? Vf(n.width) : n.width) / r, l = (a ? Vf(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: s,
    y: l
  };
}
const kfe = /* @__PURE__ */ Of(0);
function Vfe(e) {
  const t = pa(e);
  return !Dfe() || !t.visualViewport ? kfe : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Ofe(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== pa(e) ? !1 : t;
}
function db(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = S9(e);
  let s = Of(1);
  t && (r ? eg(r) && (s = _5(r)) : s = _5(e));
  const l = Ofe(a, n, r) ? Vfe(a) : Of(0);
  let c = (o.left + l.x) / s.x, d = (o.top + l.y) / s.y, f = o.width / s.x, h = o.height / s.y;
  if (a) {
    const m = pa(a), g = r && eg(r) ? pa(r) : r;
    let b = m, C = tg(b);
    for (; C && r && g !== b; ) {
      const y = _5(C), _ = C.getBoundingClientRect(), x = y9(C), I = _.left + (C.clientLeft + parseFloat(x.paddingLeft)) * y.x, R = _.top + (C.clientTop + parseFloat(x.paddingTop)) * y.y;
      c *= y.x, d *= y.y, f *= y.x, h *= y.y, c += I, d += R, b = pa(C), C = tg(b);
    }
  }
  return Efe({
    width: f,
    height: h,
    x: c,
    y: d
  });
}
function aL(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Ffe(e, t) {
  let n = null, r;
  const o = tL(e);
  function a() {
    var l;
    clearTimeout(r), (l = n) == null || l.disconnect(), n = null;
  }
  function s(l, c) {
    l === void 0 && (l = !1), c === void 0 && (c = 1), a();
    const d = e.getBoundingClientRect(), {
      left: f,
      top: h,
      width: m,
      height: g
    } = d;
    if (l || t(), !m || !g)
      return;
    const b = d2(h), C = d2(o.clientWidth - (f + m)), y = d2(o.clientHeight - (h + g)), _ = d2(f), I = {
      rootMargin: -b + "px " + -C + "px " + -y + "px " + -_ + "px",
      threshold: Rfe(0, Lfe(1, c)) || 1
    };
    let R = !0;
    function E(k) {
      const N = k[0].intersectionRatio;
      if (N !== c) {
        if (!R)
          return s();
        N ? s(!1, N) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      N === 1 && !aL(d, e.getBoundingClientRect()) && s(), R = !1;
    }
    try {
      n = new IntersectionObserver(E, {
        ...I,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(E, I);
    }
    n.observe(e);
  }
  return s(!0), a;
}
function Bfe(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, d = S9(e), f = o || a ? [...d ? Ff(d) : [], ...Ff(t)] : [];
  f.forEach((_) => {
    o && _.addEventListener("scroll", n, {
      passive: !0
    }), a && _.addEventListener("resize", n);
  });
  const h = d && l ? Ffe(d, n) : null;
  let m = -1, g = null;
  s && (g = new ResizeObserver((_) => {
    let [x] = _;
    x && x.target === d && g && (g.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var I;
      (I = g) == null || I.observe(t);
    })), n();
  }), d && !c && g.observe(d), g.observe(t));
  let b, C = c ? db(e) : null;
  c && y();
  function y() {
    const _ = db(e);
    C && !aL(C, _) && n(), C = _, b = requestAnimationFrame(y);
  }
  return n(), () => {
    var _;
    f.forEach((x) => {
      o && x.removeEventListener("scroll", n), a && x.removeEventListener("resize", n);
    }), h == null || h(), (_ = g) == null || _.disconnect(), g = null, c && cancelAnimationFrame(b);
  };
}
var ng = nc, Hfe = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], Bf = function() {
};
function Gfe(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function $fe(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)
    r[o - 2] = arguments[o];
  var a = [].concat(r);
  if (t && e)
    for (var s in t)
      t.hasOwnProperty(s) && t[s] && a.push("".concat(Gfe(e, s)));
  return a.filter(function(l) {
    return l;
  }).map(function(l) {
    return String(l).trim();
  }).join(" ");
}
var fb = function(t) {
  return Jfe(t) ? t.filter(Boolean) : fl(t) === "object" && t !== null ? [t] : [];
}, iL = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = Ni(t, Hfe);
  return et({}, n);
}, Bn = function(t, n, r) {
  var o = t.cx, a = t.getStyles, s = t.getClassNames, l = t.className;
  return {
    css: a(n, t),
    className: o(r ?? {}, s(n, t), l)
  };
};
function Uh(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function Zfe(e) {
  return Uh(e) ? window.innerHeight : e.clientHeight;
}
function sL(e) {
  return Uh(e) ? window.pageYOffset : e.scrollTop;
}
function Hf(e, t) {
  if (Uh(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function jfe(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", r = /(auto|scroll)/;
  if (t.position === "fixed")
    return document.documentElement;
  for (var o = e; o = o.parentElement; )
    if (t = getComputedStyle(o), !(n && t.position === "static") && r.test(t.overflow + t.overflowY + t.overflowX))
      return o;
  return document.documentElement;
}
function Wfe(e, t, n, r) {
  return n * ((e = e / r - 1) * e * e + 1) + t;
}
function f2(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Bf, o = sL(e), a = t - o, s = 10, l = 0;
  function c() {
    l += s;
    var d = Wfe(l, o, a, n);
    Hf(e, d), l < n ? window.requestAnimationFrame(c) : r(e);
  }
  c();
}
function hb(e, t) {
  var n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), o = t.offsetHeight / 3;
  r.bottom + o > n.bottom ? Hf(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + o, e.scrollHeight)) : r.top - o < n.top && Hf(e, Math.max(t.offsetTop - o, 0));
}
function zfe(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function pb() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function Ufe() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var lL = !1, Xfe = {
  get passive() {
    return lL = !0;
  }
}, h2 = typeof window < "u" ? window : {};
h2.addEventListener && h2.removeEventListener && (h2.addEventListener("p", Bf, Xfe), h2.removeEventListener("p", Bf, !1));
var Yfe = lL;
function qfe(e) {
  return e != null;
}
function Jfe(e) {
  return Array.isArray(e);
}
function p2(e, t, n) {
  return e ? t : n;
}
var Kfe = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  var a = Object.entries(t).filter(function(s) {
    var l = Ci(s, 1), c = l[0];
    return !r.includes(c);
  });
  return a.reduce(function(s, l) {
    var c = Ci(l, 2), d = c[0], f = c[1];
    return s[d] = f, s;
  }, {});
}, Qfe = ["children", "innerProps"], ehe = ["children", "innerProps"];
function the(e) {
  var t = e.maxHeight, n = e.menuEl, r = e.minHeight, o = e.placement, a = e.shouldScroll, s = e.isFixedPosition, l = e.controlHeight, c = jfe(n), d = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent)
    return d;
  var f = c.getBoundingClientRect(), h = f.height, m = n.getBoundingClientRect(), g = m.bottom, b = m.height, C = m.top, y = n.offsetParent.getBoundingClientRect(), _ = y.top, x = s ? window.innerHeight : Zfe(c), I = sL(c), R = parseInt(getComputedStyle(n).marginBottom, 10), E = parseInt(getComputedStyle(n).marginTop, 10), k = _ - E, N = x - C, P = k + I, F = h - I - C, G = g - x + I + R, j = I + C - E, ae = 160;
  switch (o) {
    case "auto":
    case "bottom":
      if (N >= b)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (F >= b && !s)
        return a && f2(c, G, ae), {
          placement: "bottom",
          maxHeight: t
        };
      if (!s && F >= r || s && N >= r) {
        a && f2(c, G, ae);
        var ue = s ? N - R : F - R;
        return {
          placement: "bottom",
          maxHeight: ue
        };
      }
      if (o === "auto" || s) {
        var le = t, _e = s ? k : P;
        return _e >= r && (le = Math.min(_e - R - l, t)), {
          placement: "top",
          maxHeight: le
        };
      }
      if (o === "bottom")
        return a && Hf(c, G), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (k >= b)
        return {
          placement: "top",
          maxHeight: t
        };
      if (P >= b && !s)
        return a && f2(c, j, ae), {
          placement: "top",
          maxHeight: t
        };
      if (!s && P >= r || s && k >= r) {
        var ve = t;
        return (!s && P >= r || s && k >= r) && (ve = s ? k - E : P - E), a && f2(c, j, ae), {
          placement: "top",
          maxHeight: ve
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(o, '".'));
  }
  return d;
}
function nhe(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var uL = function(t) {
  return t === "auto" ? "bottom" : t;
}, rhe = function(t, n) {
  var r, o = t.placement, a = t.theme, s = a.borderRadius, l = a.spacing, c = a.colors;
  return et((r = {
    label: "menu"
  }, wu(r, nhe(o), "100%"), wu(r, "position", "absolute"), wu(r, "width", "100%"), wu(r, "zIndex", 1), r), n ? {} : {
    backgroundColor: c.neutral0,
    borderRadius: s,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: l.menuGutter,
    marginTop: l.menuGutter
  });
}, cL = /* @__PURE__ */ Uo(null), ohe = function(t) {
  var n = t.children, r = t.minMenuHeight, o = t.maxMenuHeight, a = t.menuPlacement, s = t.menuPosition, l = t.menuShouldScrollIntoView, c = t.theme, d = Zn(cL) || {}, f = d.setPortalPlacement, h = He(null), m = je(o), g = Ci(m, 2), b = g[0], C = g[1], y = je(null), _ = Ci(y, 2), x = _[0], I = _[1], R = c.spacing.controlHeight;
  return ng(function() {
    var E = h.current;
    if (E) {
      var k = s === "fixed", N = l && !k, P = the({
        maxHeight: o,
        menuEl: E,
        minHeight: r,
        placement: a,
        shouldScroll: N,
        isFixedPosition: k,
        controlHeight: R
      });
      C(P.maxHeight), I(P.placement), f == null || f(P.placement);
    }
  }, [o, a, s, l, r, f, R]), n({
    ref: h,
    placerProps: et(et({}, t), {}, {
      placement: x || uL(a),
      maxHeight: b
    })
  });
}, ahe = function(t) {
  var n = t.children, r = t.innerRef, o = t.innerProps;
  return Ke("div", Je({}, Bn(t, "menu", {
    menu: !0
  }), {
    ref: r
  }, o), n);
}, ihe = ahe, she = function(t, n) {
  var r = t.maxHeight, o = t.theme.spacing.baseUnit;
  return et({
    maxHeight: r,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: o,
    paddingTop: o
  });
}, lhe = function(t) {
  var n = t.children, r = t.innerProps, o = t.innerRef, a = t.isMulti;
  return Ke("div", Je({}, Bn(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": a
  }), {
    ref: o
  }, r), n);
}, dL = function(t, n) {
  var r = t.theme, o = r.spacing.baseUnit, a = r.colors;
  return et({
    textAlign: "center"
  }, n ? {} : {
    color: a.neutral40,
    padding: "".concat(o * 2, "px ").concat(o * 3, "px")
  });
}, uhe = dL, che = dL, dhe = function(t) {
  var n = t.children, r = n === void 0 ? "No options" : n, o = t.innerProps, a = Ni(t, Qfe);
  return Ke("div", Je({}, Bn(et(et({}, a), {}, {
    children: r,
    innerProps: o
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), o), r);
}, fhe = function(t) {
  var n = t.children, r = n === void 0 ? "Loading..." : n, o = t.innerProps, a = Ni(t, ehe);
  return Ke("div", Je({}, Bn(et(et({}, a), {}, {
    children: r,
    innerProps: o
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), o), r);
}, hhe = function(t) {
  var n = t.rect, r = t.offset, o = t.position;
  return {
    left: n.left,
    position: o,
    top: r,
    width: n.width,
    zIndex: 1
  };
}, phe = function(t) {
  var n = t.appendTo, r = t.children, o = t.controlElement, a = t.innerProps, s = t.menuPlacement, l = t.menuPosition, c = He(null), d = He(null), f = je(uL(s)), h = Ci(f, 2), m = h[0], g = h[1], b = Et(function() {
    return {
      setPortalPlacement: g
    };
  }, []), C = je(null), y = Ci(C, 2), _ = y[0], x = y[1], I = te(function() {
    if (o) {
      var N = zfe(o), P = l === "fixed" ? 0 : window.pageYOffset, F = N[m] + P;
      (F !== (_ == null ? void 0 : _.offset) || N.left !== (_ == null ? void 0 : _.rect.left) || N.width !== (_ == null ? void 0 : _.rect.width)) && x({
        offset: F,
        rect: N
      });
    }
  }, [o, l, m, _ == null ? void 0 : _.offset, _ == null ? void 0 : _.rect.left, _ == null ? void 0 : _.rect.width]);
  ng(function() {
    I();
  }, [I]);
  var R = te(function() {
    typeof d.current == "function" && (d.current(), d.current = null), o && c.current && (d.current = Bfe(o, c.current, I, {
      elementResize: "ResizeObserver" in window
    }));
  }, [o, I]);
  ng(function() {
    R();
  }, [R]);
  var E = te(function(N) {
    c.current = N, R();
  }, [R]);
  if (!n && l !== "fixed" || !_)
    return null;
  var k = Ke("div", Je({
    ref: E
  }, Bn(et(et({}, t), {}, {
    offset: _.offset,
    position: l,
    rect: _.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), a), r);
  return Ke(cL.Provider, {
    value: b
  }, n ? /* @__PURE__ */ og(k, n) : k);
}, mhe = function(t) {
  var n = t.isDisabled, r = t.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, ghe = function(t) {
  var n = t.children, r = t.innerProps, o = t.isDisabled, a = t.isRtl;
  return Ke("div", Je({}, Bn(t, "container", {
    "--is-disabled": o,
    "--is-rtl": a
  }), r), n);
}, vhe = function(t, n) {
  var r = t.theme.spacing, o = t.isMulti, a = t.hasValue, s = t.selectProps.controlShouldRenderValue;
  return et({
    alignItems: "center",
    display: o && a && s ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(r.baseUnit / 2, "px ").concat(r.baseUnit * 2, "px")
  });
}, Che = function(t) {
  var n = t.children, r = t.innerProps, o = t.isMulti, a = t.hasValue;
  return Ke("div", Je({}, Bn(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": o,
    "value-container--has-value": a
  }), r), n);
}, bhe = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, yhe = function(t) {
  var n = t.children, r = t.innerProps;
  return Ke("div", Je({}, Bn(t, "indicatorsContainer", {
    indicators: !0
  }), r), n);
}, mb, She = ["size"], Ahe = ["innerProps", "isRtl", "size"];
function Mhe() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var xhe = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Mhe
}, fL = function(t) {
  var n = t.size, r = Ni(t, She);
  return Ke("svg", Je({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: xhe
  }, r));
}, A9 = function(t) {
  return Ke(fL, Je({
    size: 20
  }, t), Ke("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, hL = function(t) {
  return Ke(fL, Je({
    size: 20
  }, t), Ke("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, pL = function(t, n) {
  var r = t.isFocused, o = t.theme, a = o.spacing.baseUnit, s = o.colors;
  return et({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: r ? s.neutral60 : s.neutral20,
    padding: a * 2,
    ":hover": {
      color: r ? s.neutral80 : s.neutral40
    }
  });
}, _he = pL, Ihe = function(t) {
  var n = t.children, r = t.innerProps;
  return Ke("div", Je({}, Bn(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), r), n || Ke(hL, null));
}, whe = pL, Lhe = function(t) {
  var n = t.children, r = t.innerProps;
  return Ke("div", Je({}, Bn(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), r), n || Ke(A9, null));
}, Rhe = function(t, n) {
  var r = t.isDisabled, o = t.theme, a = o.spacing.baseUnit, s = o.colors;
  return et({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: r ? s.neutral10 : s.neutral20,
    marginBottom: a * 2,
    marginTop: a * 2
  });
}, Ehe = function(t) {
  var n = t.innerProps;
  return Ke("span", Je({}, n, Bn(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, Dhe = Q1(mb || (mb = wfe([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), Nhe = function(t, n) {
  var r = t.isFocused, o = t.size, a = t.theme, s = a.colors, l = a.spacing.baseUnit;
  return et({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: o,
    lineHeight: 1,
    marginRight: o,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: r ? s.neutral60 : s.neutral20,
    padding: l * 2
  });
}, I5 = function(t) {
  var n = t.delay, r = t.offset;
  return Ke("span", {
    css: /* @__PURE__ */ uy({
      animation: "".concat(Dhe, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, The = function(t) {
  var n = t.innerProps, r = t.isRtl, o = t.size, a = o === void 0 ? 4 : o, s = Ni(t, Ahe);
  return Ke("div", Je({}, Bn(et(et({}, s), {}, {
    innerProps: n,
    isRtl: r,
    size: a
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), Ke(I5, {
    delay: 0,
    offset: r
  }), Ke(I5, {
    delay: 160,
    offset: !0
  }), Ke(I5, {
    delay: 320,
    offset: !r
  }));
}, Phe = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, a = t.theme, s = a.colors, l = a.borderRadius, c = a.spacing;
  return et({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: c.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: r ? s.neutral5 : s.neutral0,
    borderColor: r ? s.neutral10 : o ? s.primary : s.neutral20,
    borderRadius: l,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: o ? "0 0 0 1px ".concat(s.primary) : void 0,
    "&:hover": {
      borderColor: o ? s.primary : s.neutral30
    }
  });
}, khe = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, a = t.innerRef, s = t.innerProps, l = t.menuIsOpen;
  return Ke("div", Je({
    ref: a
  }, Bn(t, "control", {
    control: !0,
    "control--is-disabled": r,
    "control--is-focused": o,
    "control--menu-is-open": l
  }), s, {
    "aria-disabled": r || void 0
  }), n);
}, Vhe = khe, Ohe = ["data"], Fhe = function(t, n) {
  var r = t.theme.spacing;
  return n ? {} : {
    paddingBottom: r.baseUnit * 2,
    paddingTop: r.baseUnit * 2
  };
}, Bhe = function(t) {
  var n = t.children, r = t.cx, o = t.getStyles, a = t.getClassNames, s = t.Heading, l = t.headingProps, c = t.innerProps, d = t.label, f = t.theme, h = t.selectProps;
  return Ke("div", Je({}, Bn(t, "group", {
    group: !0
  }), c), Ke(s, Je({}, l, {
    selectProps: h,
    theme: f,
    getStyles: o,
    getClassNames: a,
    cx: r
  }), d), Ke("div", null, n));
}, Hhe = function(t, n) {
  var r = t.theme, o = r.colors, a = r.spacing;
  return et({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: o.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: a.baseUnit * 3,
    paddingRight: a.baseUnit * 3,
    textTransform: "uppercase"
  });
}, Ghe = function(t) {
  var n = iL(t);
  n.data;
  var r = Ni(n, Ohe);
  return Ke("div", Je({}, Bn(t, "groupHeading", {
    "group-heading": !0
  }), r));
}, $he = Bhe, Zhe = ["innerRef", "isDisabled", "isHidden", "inputClassName"], jhe = function(t, n) {
  var r = t.isDisabled, o = t.value, a = t.theme, s = a.spacing, l = a.colors;
  return et(et({
    visibility: r ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: o ? "translateZ(0)" : ""
  }, Whe), n ? {} : {
    margin: s.baseUnit / 2,
    paddingBottom: s.baseUnit / 2,
    paddingTop: s.baseUnit / 2,
    color: l.neutral80
  });
}, mL = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, Whe = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": et({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, mL)
}, zhe = function(t) {
  return et({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, mL);
}, Uhe = function(t) {
  var n = t.cx, r = t.value, o = iL(t), a = o.innerRef, s = o.isDisabled, l = o.isHidden, c = o.inputClassName, d = Ni(o, Zhe);
  return Ke("div", Je({}, Bn(t, "input", {
    "input-container": !0
  }), {
    "data-value": r || ""
  }), Ke("input", Je({
    className: n({
      input: !0
    }, c),
    ref: a,
    style: zhe(l),
    disabled: s
  }, d)));
}, Xhe = Uhe, Yhe = function(t, n) {
  var r = t.theme, o = r.spacing, a = r.borderRadius, s = r.colors;
  return et({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: s.neutral10,
    borderRadius: a / 2,
    margin: o.baseUnit / 2
  });
}, qhe = function(t, n) {
  var r = t.theme, o = r.borderRadius, a = r.colors, s = t.cropWithEllipsis;
  return et({
    overflow: "hidden",
    textOverflow: s || s === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: o / 2,
    color: a.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, Jhe = function(t, n) {
  var r = t.theme, o = r.spacing, a = r.borderRadius, s = r.colors, l = t.isFocused;
  return et({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: a / 2,
    backgroundColor: l ? s.dangerLight : void 0,
    paddingLeft: o.baseUnit,
    paddingRight: o.baseUnit,
    ":hover": {
      backgroundColor: s.dangerLight,
      color: s.danger
    }
  });
}, gL = function(t) {
  var n = t.children, r = t.innerProps;
  return Ke("div", r, n);
}, Khe = gL, Qhe = gL;
function epe(e) {
  var t = e.children, n = e.innerProps;
  return Ke("div", Je({
    role: "button"
  }, n), t || Ke(A9, {
    size: 14
  }));
}
var tpe = function(t) {
  var n = t.children, r = t.components, o = t.data, a = t.innerProps, s = t.isDisabled, l = t.removeProps, c = t.selectProps, d = r.Container, f = r.Label, h = r.Remove;
  return Ke(d, {
    data: o,
    innerProps: et(et({}, Bn(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": s
    })), a),
    selectProps: c
  }, Ke(f, {
    data: o,
    innerProps: et({}, Bn(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: c
  }, n), Ke(h, {
    data: o,
    innerProps: et(et({}, Bn(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, l),
    selectProps: c
  }));
}, npe = tpe, rpe = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, a = t.isSelected, s = t.theme, l = s.spacing, c = s.colors;
  return et({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: a ? c.primary : o ? c.primary25 : "transparent",
    color: r ? c.neutral20 : a ? c.neutral0 : "inherit",
    padding: "".concat(l.baseUnit * 2, "px ").concat(l.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: r ? void 0 : a ? c.primary : c.primary50
    }
  });
}, ope = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, a = t.isSelected, s = t.innerRef, l = t.innerProps;
  return Ke("div", Je({}, Bn(t, "option", {
    option: !0,
    "option--is-disabled": r,
    "option--is-focused": o,
    "option--is-selected": a
  }), {
    ref: s,
    "aria-disabled": r
  }, l), n);
}, ape = ope, ipe = function(t, n) {
  var r = t.theme, o = r.spacing, a = r.colors;
  return et({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: a.neutral50,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, spe = function(t) {
  var n = t.children, r = t.innerProps;
  return Ke("div", Je({}, Bn(t, "placeholder", {
    placeholder: !0
  }), r), n);
}, lpe = spe, upe = function(t, n) {
  var r = t.isDisabled, o = t.theme, a = o.spacing, s = o.colors;
  return et({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: r ? s.neutral40 : s.neutral80,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2
  });
}, cpe = function(t) {
  var n = t.children, r = t.isDisabled, o = t.innerProps;
  return Ke("div", Je({}, Bn(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": r
  }), o), n);
}, dpe = cpe, fpe = {
  ClearIndicator: Lhe,
  Control: Vhe,
  DropdownIndicator: Ihe,
  DownChevron: hL,
  CrossIcon: A9,
  Group: $he,
  GroupHeading: Ghe,
  IndicatorsContainer: yhe,
  IndicatorSeparator: Ehe,
  Input: Xhe,
  LoadingIndicator: The,
  Menu: ihe,
  MenuList: lhe,
  MenuPortal: phe,
  LoadingMessage: fhe,
  NoOptionsMessage: dhe,
  MultiValue: npe,
  MultiValueContainer: Khe,
  MultiValueLabel: Qhe,
  MultiValueRemove: epe,
  Option: ape,
  Placeholder: lpe,
  SelectContainer: ghe,
  SingleValue: dpe,
  ValueContainer: Che
}, hpe = function(t) {
  return et(et({}, fpe), t.components);
}, gb = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function ppe(e, t) {
  return !!(e === t || gb(e) && gb(t));
}
function mpe(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!ppe(e[n], t[n]))
      return !1;
  return !0;
}
function gpe(e, t) {
  t === void 0 && (t = mpe);
  var n = null;
  function r() {
    for (var o = [], a = 0; a < arguments.length; a++)
      o[a] = arguments[a];
    if (n && n.lastThis === this && t(o, n.lastArgs))
      return n.lastResult;
    var s = e.apply(this, o);
    return n = {
      lastResult: s,
      lastArgs: o,
      lastThis: this
    }, s;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
function vpe() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Cpe = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: vpe
}, bpe = function(t) {
  return Ke("span", Je({
    css: Cpe
  }, t));
}, vb = bpe, ype = {
  guidance: function(t) {
    var n = t.isSearchable, r = t.isMulti, o = t.tabSelectsValue, a = t.context, s = t.isInitialFocus;
    switch (a) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(o ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return s ? "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, r = t.label, o = r === void 0 ? "" : r, a = t.labels, s = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(o, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(a.length > 1 ? "s" : "", " ").concat(a.join(","), ", selected.");
      case "select-option":
        return s ? "option ".concat(o, " is disabled. Select another option.") : "option ".concat(o, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, r = t.focused, o = t.options, a = t.label, s = a === void 0 ? "" : a, l = t.selectValue, c = t.isDisabled, d = t.isSelected, f = t.isAppleDevice, h = function(C, y) {
      return C && C.length ? "".concat(C.indexOf(y) + 1, " of ").concat(C.length) : "";
    };
    if (n === "value" && l)
      return "value ".concat(s, " focused, ").concat(h(l, r), ".");
    if (n === "menu" && f) {
      var m = c ? " disabled" : "", g = "".concat(d ? " selected" : "").concat(m);
      return "".concat(s).concat(g, ", ").concat(h(o, r), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, r = t.resultsMessage;
    return "".concat(r).concat(n ? " for search term " + n : "", ".");
  }
}, Spe = function(t) {
  var n = t.ariaSelection, r = t.focusedOption, o = t.focusedValue, a = t.focusableOptions, s = t.isFocused, l = t.selectValue, c = t.selectProps, d = t.id, f = t.isAppleDevice, h = c.ariaLiveMessages, m = c.getOptionLabel, g = c.inputValue, b = c.isMulti, C = c.isOptionDisabled, y = c.isSearchable, _ = c.menuIsOpen, x = c.options, I = c.screenReaderStatus, R = c.tabSelectsValue, E = c.isLoading, k = c["aria-label"], N = c["aria-live"], P = Et(function() {
    return et(et({}, ype), h || {});
  }, [h]), F = Et(function() {
    var _e = "";
    if (n && P.onChange) {
      var ve = n.option, z = n.options, K = n.removedValue, Ce = n.removedValues, q = n.value, J = function(Ie) {
        return Array.isArray(Ie) ? null : Ie;
      }, ge = K || ve || J(q), X = ge ? m(ge) : "", pe = z || Ce || void 0, fe = pe ? pe.map(m) : [], de = et({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: ge && C(ge, l),
        label: X,
        labels: fe
      }, n);
      _e = P.onChange(de);
    }
    return _e;
  }, [n, P, C, l, m]), G = Et(function() {
    var _e = "", ve = r || o, z = !!(r && l && l.includes(r));
    if (ve && P.onFocus) {
      var K = {
        focused: ve,
        label: m(ve),
        isDisabled: C(ve, l),
        isSelected: z,
        options: a,
        context: ve === r ? "menu" : "value",
        selectValue: l,
        isAppleDevice: f
      };
      _e = P.onFocus(K);
    }
    return _e;
  }, [r, o, m, C, P, a, l, f]), j = Et(function() {
    var _e = "";
    if (_ && x.length && !E && P.onFilter) {
      var ve = I({
        count: a.length
      });
      _e = P.onFilter({
        inputValue: g,
        resultsMessage: ve
      });
    }
    return _e;
  }, [a, g, _, P, x, I, E]), ae = (n == null ? void 0 : n.action) === "initial-input-focus", ue = Et(function() {
    var _e = "";
    if (P.guidance) {
      var ve = o ? "value" : _ ? "menu" : "input";
      _e = P.guidance({
        "aria-label": k,
        context: ve,
        isDisabled: r && C(r, l),
        isMulti: b,
        isSearchable: y,
        tabSelectsValue: R,
        isInitialFocus: ae
      });
    }
    return _e;
  }, [k, r, o, b, C, y, _, P, l, R, ae]), le = Ke(F1, null, Ke("span", {
    id: "aria-selection"
  }, F), Ke("span", {
    id: "aria-focused"
  }, G), Ke("span", {
    id: "aria-results"
  }, j), Ke("span", {
    id: "aria-guidance"
  }, ue));
  return Ke(F1, null, Ke(vb, {
    id: d
  }, ae && le), Ke(vb, {
    "aria-live": N,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, s && !ae && le));
}, Ape = Spe, rg = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], Mpe = new RegExp("[" + rg.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), vL = {};
for (var w5 = 0; w5 < rg.length; w5++)
  for (var L5 = rg[w5], R5 = 0; R5 < L5.letters.length; R5++)
    vL[L5.letters[R5]] = L5.base;
var CL = function(t) {
  return t.replace(Mpe, function(n) {
    return vL[n];
  });
}, xpe = gpe(CL), Cb = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, _pe = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, Ipe = function(t) {
  return function(n, r) {
    if (n.data.__isNew__)
      return !0;
    var o = et({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: _pe,
      trim: !0,
      matchFrom: "any"
    }, t), a = o.ignoreCase, s = o.ignoreAccents, l = o.stringify, c = o.trim, d = o.matchFrom, f = c ? Cb(r) : r, h = c ? Cb(l(n)) : l(n);
    return a && (f = f.toLowerCase(), h = h.toLowerCase()), s && (f = xpe(f), h = CL(h)), d === "start" ? h.substr(0, f.length) === f : h.indexOf(f) > -1;
  };
}, wpe = ["innerRef"];
function Lpe(e) {
  var t = e.innerRef, n = Ni(e, wpe), r = Kfe(n, "onExited", "in", "enter", "exit", "appear");
  return Ke("input", Je({
    ref: t
  }, r, {
    css: /* @__PURE__ */ uy({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var Rpe = function(t) {
  t.cancelable && t.preventDefault(), t.stopPropagation();
};
function Epe(e) {
  var t = e.isEnabled, n = e.onBottomArrive, r = e.onBottomLeave, o = e.onTopArrive, a = e.onTopLeave, s = He(!1), l = He(!1), c = He(0), d = He(null), f = te(function(y, _) {
    if (d.current !== null) {
      var x = d.current, I = x.scrollTop, R = x.scrollHeight, E = x.clientHeight, k = d.current, N = _ > 0, P = R - E - I, F = !1;
      P > _ && s.current && (r && r(y), s.current = !1), N && l.current && (a && a(y), l.current = !1), N && _ > P ? (n && !s.current && n(y), k.scrollTop = R, F = !0, s.current = !0) : !N && -_ > I && (o && !l.current && o(y), k.scrollTop = 0, F = !0, l.current = !0), F && Rpe(y);
    }
  }, [n, r, o, a]), h = te(function(y) {
    f(y, y.deltaY);
  }, [f]), m = te(function(y) {
    c.current = y.changedTouches[0].clientY;
  }, []), g = te(function(y) {
    var _ = c.current - y.changedTouches[0].clientY;
    f(y, _);
  }, [f]), b = te(function(y) {
    if (y) {
      var _ = Yfe ? {
        passive: !1
      } : !1;
      y.addEventListener("wheel", h, _), y.addEventListener("touchstart", m, _), y.addEventListener("touchmove", g, _);
    }
  }, [g, m, h]), C = te(function(y) {
    y && (y.removeEventListener("wheel", h, !1), y.removeEventListener("touchstart", m, !1), y.removeEventListener("touchmove", g, !1));
  }, [g, m, h]);
  return ft(function() {
    if (t) {
      var y = d.current;
      return b(y), function() {
        C(y);
      };
    }
  }, [t, b, C]), function(y) {
    d.current = y;
  };
}
var bb = ["boxSizing", "height", "overflow", "paddingRight", "position"], yb = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function Sb(e) {
  e.preventDefault();
}
function Ab(e) {
  e.stopPropagation();
}
function Mb() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function xb() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var _b = !!(typeof window < "u" && window.document && window.document.createElement), r1 = 0, hu = {
  capture: !1,
  passive: !1
};
function Dpe(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, r = n === void 0 ? !0 : n, o = He({}), a = He(null), s = te(function(c) {
    if (_b) {
      var d = document.body, f = d && d.style;
      if (r && bb.forEach(function(b) {
        var C = f && f[b];
        o.current[b] = C;
      }), r && r1 < 1) {
        var h = parseInt(o.current.paddingRight, 10) || 0, m = document.body ? document.body.clientWidth : 0, g = window.innerWidth - m + h || 0;
        Object.keys(yb).forEach(function(b) {
          var C = yb[b];
          f && (f[b] = C);
        }), f && (f.paddingRight = "".concat(g, "px"));
      }
      d && xb() && (d.addEventListener("touchmove", Sb, hu), c && (c.addEventListener("touchstart", Mb, hu), c.addEventListener("touchmove", Ab, hu))), r1 += 1;
    }
  }, [r]), l = te(function(c) {
    if (_b) {
      var d = document.body, f = d && d.style;
      r1 = Math.max(r1 - 1, 0), r && r1 < 1 && bb.forEach(function(h) {
        var m = o.current[h];
        f && (f[h] = m);
      }), d && xb() && (d.removeEventListener("touchmove", Sb, hu), c && (c.removeEventListener("touchstart", Mb, hu), c.removeEventListener("touchmove", Ab, hu)));
    }
  }, [r]);
  return ft(function() {
    if (t) {
      var c = a.current;
      return s(c), function() {
        l(c);
      };
    }
  }, [t, s, l]), function(c) {
    a.current = c;
  };
}
function Npe() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Tpe = function(t) {
  var n = t.target;
  return n.ownerDocument.activeElement && n.ownerDocument.activeElement.blur();
}, Ppe = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Npe
};
function kpe(e) {
  var t = e.children, n = e.lockEnabled, r = e.captureEnabled, o = r === void 0 ? !0 : r, a = e.onBottomArrive, s = e.onBottomLeave, l = e.onTopArrive, c = e.onTopLeave, d = Epe({
    isEnabled: o,
    onBottomArrive: a,
    onBottomLeave: s,
    onTopArrive: l,
    onTopLeave: c
  }), f = Dpe({
    isEnabled: n
  }), h = function(g) {
    d(g), f(g);
  };
  return Ke(F1, null, n && Ke("div", {
    onClick: Tpe,
    css: Ppe
  }), t(h));
}
function Vpe() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Ope = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: Vpe
}, Fpe = function(t) {
  var n = t.name, r = t.onFocus;
  return Ke("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: r,
    css: Ope,
    value: "",
    onChange: function() {
    }
  });
}, Bpe = Fpe;
function M9(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function Hpe() {
  return M9(/^iPhone/i);
}
function bL() {
  return M9(/^Mac/i);
}
function Gpe() {
  return M9(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  bL() && navigator.maxTouchPoints > 1;
}
function $pe() {
  return Hpe() || Gpe();
}
function Zpe() {
  return bL() || $pe();
}
var jpe = function(t) {
  return t.label;
}, Wpe = function(t) {
  return t.label;
}, zpe = function(t) {
  return t.value;
}, Upe = function(t) {
  return !!t.isDisabled;
}, Xpe = {
  clearIndicator: whe,
  container: mhe,
  control: Phe,
  dropdownIndicator: _he,
  group: Fhe,
  groupHeading: Hhe,
  indicatorsContainer: bhe,
  indicatorSeparator: Rhe,
  input: jhe,
  loadingIndicator: Nhe,
  loadingMessage: che,
  menu: rhe,
  menuList: she,
  menuPortal: hhe,
  multiValue: Yhe,
  multiValueLabel: qhe,
  multiValueRemove: Jhe,
  noOptionsMessage: uhe,
  option: rpe,
  placeholder: ipe,
  singleValue: upe,
  valueContainer: vhe
}, Ype = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, qpe = 4, yL = 4, Jpe = 38, Kpe = yL * 2, Qpe = {
  baseUnit: yL,
  controlHeight: Jpe,
  menuGutter: Kpe
}, E5 = {
  borderRadius: qpe,
  colors: Ype,
  spacing: Qpe
}, eme = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: pb(),
  captureMenuScroll: !pb(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: Ipe(),
  formatGroupLabel: jpe,
  getOptionLabel: Wpe,
  getOptionValue: zpe,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: Upe,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !Ufe(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function Ib(e, t, n, r) {
  var o = ML(e, t, n), a = xL(e, t, n), s = AL(e, t), l = Gf(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: o,
    isSelected: a,
    label: s,
    value: l,
    index: r
  };
}
function V2(e, t) {
  return e.options.map(function(n, r) {
    if ("options" in n) {
      var o = n.options.map(function(s, l) {
        return Ib(e, s, t, l);
      }).filter(function(s) {
        return Lb(e, s);
      });
      return o.length > 0 ? {
        type: "group",
        data: n,
        options: o,
        index: r
      } : void 0;
    }
    var a = Ib(e, n, t, r);
    return Lb(e, a) ? a : void 0;
  }).filter(qfe);
}
function SL(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, C9(n.options.map(function(r) {
      return r.data;
    }))) : t.push(n.data), t;
  }, []);
}
function wb(e, t) {
  return e.reduce(function(n, r) {
    return r.type === "group" ? n.push.apply(n, C9(r.options.map(function(o) {
      return {
        data: o.data,
        id: "".concat(t, "-").concat(r.index, "-").concat(o.index)
      };
    }))) : n.push({
      data: r.data,
      id: "".concat(t, "-").concat(r.index)
    }), n;
  }, []);
}
function tme(e, t) {
  return SL(V2(e, t));
}
function Lb(e, t) {
  var n = e.inputValue, r = n === void 0 ? "" : n, o = t.data, a = t.isSelected, s = t.label, l = t.value;
  return (!IL(e) || !a) && _L(e, {
    label: s,
    value: l,
    data: o
  }, r);
}
function nme(e, t) {
  var n = e.focusedValue, r = e.selectValue, o = r.indexOf(n);
  if (o > -1) {
    var a = t.indexOf(n);
    if (a > -1)
      return n;
    if (o < t.length)
      return t[o];
  }
  return null;
}
function rme(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var D5 = function(t, n) {
  var r, o = (r = t.find(function(a) {
    return a.data === n;
  })) === null || r === void 0 ? void 0 : r.id;
  return o || null;
}, AL = function(t, n) {
  return t.getOptionLabel(n);
}, Gf = function(t, n) {
  return t.getOptionValue(n);
};
function ML(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function xL(e, t, n) {
  if (n.indexOf(t) > -1)
    return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var r = Gf(e, t);
  return n.some(function(o) {
    return Gf(e, o) === r;
  });
}
function _L(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var IL = function(t) {
  var n = t.hideSelectedOptions, r = t.isMulti;
  return n === void 0 ? r : n;
}, ome = 1, wL = /* @__PURE__ */ function(e) {
  yfe(n, e);
  var t = Mfe(n);
  function n(r) {
    var o;
    if (Cfe(this, n), o = t.call(this, r), o.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, o.blockOptionHover = !1, o.isComposing = !1, o.commonProps = void 0, o.initialTouchX = 0, o.initialTouchY = 0, o.openAfterFocus = !1, o.scrollToFocusedOptionOnUpdate = !1, o.userIsDragging = void 0, o.isAppleDevice = Zpe(), o.controlRef = null, o.getControlRef = function(c) {
      o.controlRef = c;
    }, o.focusedOptionRef = null, o.getFocusedOptionRef = function(c) {
      o.focusedOptionRef = c;
    }, o.menuListRef = null, o.getMenuListRef = function(c) {
      o.menuListRef = c;
    }, o.inputRef = null, o.getInputRef = function(c) {
      o.inputRef = c;
    }, o.focus = o.focusInput, o.blur = o.blurInput, o.onChange = function(c, d) {
      var f = o.props, h = f.onChange, m = f.name;
      d.name = m, o.ariaOnChange(c, d), h(c, d);
    }, o.setValue = function(c, d, f) {
      var h = o.props, m = h.closeMenuOnSelect, g = h.isMulti, b = h.inputValue;
      o.onInputChange("", {
        action: "set-value",
        prevInputValue: b
      }), m && (o.setState({
        inputIsHiddenAfterUpdate: !g
      }), o.onMenuClose()), o.setState({
        clearFocusValueOnUpdate: !0
      }), o.onChange(c, {
        action: d,
        option: f
      });
    }, o.selectOption = function(c) {
      var d = o.props, f = d.blurInputOnSelect, h = d.isMulti, m = d.name, g = o.state.selectValue, b = h && o.isOptionSelected(c, g), C = o.isOptionDisabled(c, g);
      if (b) {
        var y = o.getOptionValue(c);
        o.setValue(g.filter(function(_) {
          return o.getOptionValue(_) !== y;
        }), "deselect-option", c);
      } else if (!C)
        h ? o.setValue([].concat(C9(g), [c]), "select-option", c) : o.setValue(c, "select-option");
      else {
        o.ariaOnChange(c, {
          action: "select-option",
          option: c,
          name: m
        });
        return;
      }
      f && o.blurInput();
    }, o.removeValue = function(c) {
      var d = o.props.isMulti, f = o.state.selectValue, h = o.getOptionValue(c), m = f.filter(function(b) {
        return o.getOptionValue(b) !== h;
      }), g = p2(d, m, m[0] || null);
      o.onChange(g, {
        action: "remove-value",
        removedValue: c
      }), o.focusInput();
    }, o.clearValue = function() {
      var c = o.state.selectValue;
      o.onChange(p2(o.props.isMulti, [], null), {
        action: "clear",
        removedValues: c
      });
    }, o.popValue = function() {
      var c = o.props.isMulti, d = o.state.selectValue, f = d[d.length - 1], h = d.slice(0, d.length - 1), m = p2(c, h, h[0] || null);
      o.onChange(m, {
        action: "pop-value",
        removedValue: f
      });
    }, o.getFocusedOptionId = function(c) {
      return D5(o.state.focusableOptionsWithIds, c);
    }, o.getFocusableOptionsWithIds = function() {
      return wb(V2(o.props, o.state.selectValue), o.getElementId("option"));
    }, o.getValue = function() {
      return o.state.selectValue;
    }, o.cx = function() {
      for (var c = arguments.length, d = new Array(c), f = 0; f < c; f++)
        d[f] = arguments[f];
      return $fe.apply(void 0, [o.props.classNamePrefix].concat(d));
    }, o.getOptionLabel = function(c) {
      return AL(o.props, c);
    }, o.getOptionValue = function(c) {
      return Gf(o.props, c);
    }, o.getStyles = function(c, d) {
      var f = o.props.unstyled, h = Xpe[c](d, f);
      h.boxSizing = "border-box";
      var m = o.props.styles[c];
      return m ? m(h, d) : h;
    }, o.getClassNames = function(c, d) {
      var f, h;
      return (f = (h = o.props.classNames)[c]) === null || f === void 0 ? void 0 : f.call(h, d);
    }, o.getElementId = function(c) {
      return "".concat(o.state.instancePrefix, "-").concat(c);
    }, o.getComponents = function() {
      return hpe(o.props);
    }, o.buildCategorizedOptions = function() {
      return V2(o.props, o.state.selectValue);
    }, o.getCategorizedOptions = function() {
      return o.props.menuIsOpen ? o.buildCategorizedOptions() : [];
    }, o.buildFocusableOptions = function() {
      return SL(o.buildCategorizedOptions());
    }, o.getFocusableOptions = function() {
      return o.props.menuIsOpen ? o.buildFocusableOptions() : [];
    }, o.ariaOnChange = function(c, d) {
      o.setState({
        ariaSelection: et({
          value: c
        }, d)
      });
    }, o.onMenuMouseDown = function(c) {
      c.button === 0 && (c.stopPropagation(), c.preventDefault(), o.focusInput());
    }, o.onMenuMouseMove = function(c) {
      o.blockOptionHover = !1;
    }, o.onControlMouseDown = function(c) {
      if (!c.defaultPrevented) {
        var d = o.props.openMenuOnClick;
        o.state.isFocused ? o.props.menuIsOpen ? c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && o.onMenuClose() : d && o.openMenu("first") : (d && (o.openAfterFocus = !0), o.focusInput()), c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && c.preventDefault();
      }
    }, o.onDropdownIndicatorMouseDown = function(c) {
      if (!(c && c.type === "mousedown" && c.button !== 0) && !o.props.isDisabled) {
        var d = o.props, f = d.isMulti, h = d.menuIsOpen;
        o.focusInput(), h ? (o.setState({
          inputIsHiddenAfterUpdate: !f
        }), o.onMenuClose()) : o.openMenu("first"), c.preventDefault();
      }
    }, o.onClearIndicatorMouseDown = function(c) {
      c && c.type === "mousedown" && c.button !== 0 || (o.clearValue(), c.preventDefault(), o.openAfterFocus = !1, c.type === "touchend" ? o.focusInput() : setTimeout(function() {
        return o.focusInput();
      }));
    }, o.onScroll = function(c) {
      typeof o.props.closeMenuOnScroll == "boolean" ? c.target instanceof HTMLElement && Uh(c.target) && o.props.onMenuClose() : typeof o.props.closeMenuOnScroll == "function" && o.props.closeMenuOnScroll(c) && o.props.onMenuClose();
    }, o.onCompositionStart = function() {
      o.isComposing = !0;
    }, o.onCompositionEnd = function() {
      o.isComposing = !1;
    }, o.onTouchStart = function(c) {
      var d = c.touches, f = d && d.item(0);
      f && (o.initialTouchX = f.clientX, o.initialTouchY = f.clientY, o.userIsDragging = !1);
    }, o.onTouchMove = function(c) {
      var d = c.touches, f = d && d.item(0);
      if (f) {
        var h = Math.abs(f.clientX - o.initialTouchX), m = Math.abs(f.clientY - o.initialTouchY), g = 5;
        o.userIsDragging = h > g || m > g;
      }
    }, o.onTouchEnd = function(c) {
      o.userIsDragging || (o.controlRef && !o.controlRef.contains(c.target) && o.menuListRef && !o.menuListRef.contains(c.target) && o.blurInput(), o.initialTouchX = 0, o.initialTouchY = 0);
    }, o.onControlTouchEnd = function(c) {
      o.userIsDragging || o.onControlMouseDown(c);
    }, o.onClearIndicatorTouchEnd = function(c) {
      o.userIsDragging || o.onClearIndicatorMouseDown(c);
    }, o.onDropdownIndicatorTouchEnd = function(c) {
      o.userIsDragging || o.onDropdownIndicatorMouseDown(c);
    }, o.handleInputChange = function(c) {
      var d = o.props.inputValue, f = c.currentTarget.value;
      o.setState({
        inputIsHiddenAfterUpdate: !1
      }), o.onInputChange(f, {
        action: "input-change",
        prevInputValue: d
      }), o.props.menuIsOpen || o.onMenuOpen();
    }, o.onInputFocus = function(c) {
      o.props.onFocus && o.props.onFocus(c), o.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (o.openAfterFocus || o.props.openMenuOnFocus) && o.openMenu("first"), o.openAfterFocus = !1;
    }, o.onInputBlur = function(c) {
      var d = o.props.inputValue;
      if (o.menuListRef && o.menuListRef.contains(document.activeElement)) {
        o.inputRef.focus();
        return;
      }
      o.props.onBlur && o.props.onBlur(c), o.onInputChange("", {
        action: "input-blur",
        prevInputValue: d
      }), o.onMenuClose(), o.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, o.onOptionHover = function(c) {
      if (!(o.blockOptionHover || o.state.focusedOption === c)) {
        var d = o.getFocusableOptions(), f = d.indexOf(c);
        o.setState({
          focusedOption: c,
          focusedOptionId: f > -1 ? o.getFocusedOptionId(c) : null
        });
      }
    }, o.shouldHideSelectedOptions = function() {
      return IL(o.props);
    }, o.onValueInputFocus = function(c) {
      c.preventDefault(), c.stopPropagation(), o.focus();
    }, o.onKeyDown = function(c) {
      var d = o.props, f = d.isMulti, h = d.backspaceRemovesValue, m = d.escapeClearsValue, g = d.inputValue, b = d.isClearable, C = d.isDisabled, y = d.menuIsOpen, _ = d.onKeyDown, x = d.tabSelectsValue, I = d.openMenuOnFocus, R = o.state, E = R.focusedOption, k = R.focusedValue, N = R.selectValue;
      if (!C && !(typeof _ == "function" && (_(c), c.defaultPrevented))) {
        switch (o.blockOptionHover = !0, c.key) {
          case "ArrowLeft":
            if (!f || g)
              return;
            o.focusValue("previous");
            break;
          case "ArrowRight":
            if (!f || g)
              return;
            o.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (g)
              return;
            if (k)
              o.removeValue(k);
            else {
              if (!h)
                return;
              f ? o.popValue() : b && o.clearValue();
            }
            break;
          case "Tab":
            if (o.isComposing || c.shiftKey || !y || !x || !E || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            I && o.isOptionSelected(E, N))
              return;
            o.selectOption(E);
            break;
          case "Enter":
            if (c.keyCode === 229)
              break;
            if (y) {
              if (!E || o.isComposing)
                return;
              o.selectOption(E);
              break;
            }
            return;
          case "Escape":
            y ? (o.setState({
              inputIsHiddenAfterUpdate: !1
            }), o.onInputChange("", {
              action: "menu-close",
              prevInputValue: g
            }), o.onMenuClose()) : b && m && o.clearValue();
            break;
          case " ":
            if (g)
              return;
            if (!y) {
              o.openMenu("first");
              break;
            }
            if (!E)
              return;
            o.selectOption(E);
            break;
          case "ArrowUp":
            y ? o.focusOption("up") : o.openMenu("last");
            break;
          case "ArrowDown":
            y ? o.focusOption("down") : o.openMenu("first");
            break;
          case "PageUp":
            if (!y)
              return;
            o.focusOption("pageup");
            break;
          case "PageDown":
            if (!y)
              return;
            o.focusOption("pagedown");
            break;
          case "Home":
            if (!y)
              return;
            o.focusOption("first");
            break;
          case "End":
            if (!y)
              return;
            o.focusOption("last");
            break;
          default:
            return;
        }
        c.preventDefault();
      }
    }, o.state.instancePrefix = "react-select-" + (o.props.instanceId || ++ome), o.state.selectValue = fb(r.value), r.menuIsOpen && o.state.selectValue.length) {
      var a = o.getFocusableOptionsWithIds(), s = o.buildFocusableOptions(), l = s.indexOf(o.state.selectValue[0]);
      o.state.focusableOptionsWithIds = a, o.state.focusedOption = s[l], o.state.focusedOptionId = D5(a, s[l]);
    }
    return o;
  }
  return bfe(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && hb(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(o) {
      var a = this.props, s = a.isDisabled, l = a.menuIsOpen, c = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (c && !s && o.isDisabled || // ensure focus is on the Input when the menu opens
      c && l && !o.menuIsOpen) && this.focusInput(), c && s && !o.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !c && !s && o.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (hb(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(o, a) {
      this.props.onInputChange(o, a);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(o) {
      var a = this, s = this.state, l = s.selectValue, c = s.isFocused, d = this.buildFocusableOptions(), f = o === "first" ? 0 : d.length - 1;
      if (!this.props.isMulti) {
        var h = d.indexOf(l[0]);
        h > -1 && (f = h);
      }
      this.scrollToFocusedOptionOnUpdate = !(c && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: d[f],
        focusedOptionId: this.getFocusedOptionId(d[f])
      }, function() {
        return a.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(o) {
      var a = this.state, s = a.selectValue, l = a.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var c = s.indexOf(l);
        l || (c = -1);
        var d = s.length - 1, f = -1;
        if (s.length) {
          switch (o) {
            case "previous":
              c === 0 ? f = 0 : c === -1 ? f = d : f = c - 1;
              break;
            case "next":
              c > -1 && c < d && (f = c + 1);
              break;
          }
          this.setState({
            inputIsHidden: f !== -1,
            focusedValue: s[f]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", a = this.props.pageSize, s = this.state.focusedOption, l = this.getFocusableOptions();
      if (l.length) {
        var c = 0, d = l.indexOf(s);
        s || (d = -1), o === "up" ? c = d > 0 ? d - 1 : l.length - 1 : o === "down" ? c = (d + 1) % l.length : o === "pageup" ? (c = d - a, c < 0 && (c = 0)) : o === "pagedown" ? (c = d + a, c > l.length - 1 && (c = l.length - 1)) : o === "last" && (c = l.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: l[c],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(l[c])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(E5) : et(et({}, E5), this.props.theme) : E5;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var o = this.clearValue, a = this.cx, s = this.getStyles, l = this.getClassNames, c = this.getValue, d = this.selectOption, f = this.setValue, h = this.props, m = h.isMulti, g = h.isRtl, b = h.options, C = this.hasValue();
      return {
        clearValue: o,
        cx: a,
        getStyles: s,
        getClassNames: l,
        getValue: c,
        hasValue: C,
        isMulti: m,
        isRtl: g,
        options: b,
        selectOption: d,
        selectProps: h,
        setValue: f,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var o = this.state.selectValue;
      return o.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var o = this.props, a = o.isClearable, s = o.isMulti;
      return a === void 0 ? s : a;
    }
  }, {
    key: "isOptionDisabled",
    value: function(o, a) {
      return ML(this.props, o, a);
    }
  }, {
    key: "isOptionSelected",
    value: function(o, a) {
      return xL(this.props, o, a);
    }
  }, {
    key: "filterOption",
    value: function(o, a) {
      return _L(this.props, o, a);
    }
  }, {
    key: "formatOptionLabel",
    value: function(o, a) {
      if (typeof this.props.formatOptionLabel == "function") {
        var s = this.props.inputValue, l = this.state.selectValue;
        return this.props.formatOptionLabel(o, {
          context: a,
          inputValue: s,
          selectValue: l
        });
      } else
        return this.getOptionLabel(o);
    }
  }, {
    key: "formatGroupLabel",
    value: function(o) {
      return this.props.formatGroupLabel(o);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var o = this.props, a = o.isDisabled, s = o.isSearchable, l = o.inputId, c = o.inputValue, d = o.tabIndex, f = o.form, h = o.menuIsOpen, m = o.required, g = this.getComponents(), b = g.Input, C = this.state, y = C.inputIsHidden, _ = C.ariaSelection, x = this.commonProps, I = l || this.getElementId("input"), R = et(et(et({
          "aria-autocomplete": "list",
          "aria-expanded": h,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": m,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, h && {
          "aria-controls": this.getElementId("listbox")
        }), !s && {
          "aria-readonly": !0
        }), this.hasValue() ? (_ == null ? void 0 : _.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return s ? /* @__PURE__ */ De.createElement(b, Je({}, x, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: I,
          innerRef: this.getInputRef,
          isDisabled: a,
          isHidden: y,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: d,
          form: f,
          type: "text",
          value: c
        }, R)) : /* @__PURE__ */ De.createElement(Lpe, Je({
          id: I,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: Bf,
          onFocus: this.onInputFocus,
          disabled: a,
          tabIndex: d,
          inputMode: "none",
          form: f,
          value: ""
        }, R));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var o = this, a = this.getComponents(), s = a.MultiValue, l = a.MultiValueContainer, c = a.MultiValueLabel, d = a.MultiValueRemove, f = a.SingleValue, h = a.Placeholder, m = this.commonProps, g = this.props, b = g.controlShouldRenderValue, C = g.isDisabled, y = g.isMulti, _ = g.inputValue, x = g.placeholder, I = this.state, R = I.selectValue, E = I.focusedValue, k = I.isFocused;
      if (!this.hasValue() || !b)
        return _ ? null : /* @__PURE__ */ De.createElement(h, Je({}, m, {
          key: "placeholder",
          isDisabled: C,
          isFocused: k,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), x);
      if (y)
        return R.map(function(P, F) {
          var G = P === E, j = "".concat(o.getOptionLabel(P), "-").concat(o.getOptionValue(P));
          return /* @__PURE__ */ De.createElement(s, Je({}, m, {
            components: {
              Container: l,
              Label: c,
              Remove: d
            },
            isFocused: G,
            isDisabled: C,
            key: j,
            index: F,
            removeProps: {
              onClick: function() {
                return o.removeValue(P);
              },
              onTouchEnd: function() {
                return o.removeValue(P);
              },
              onMouseDown: function(ue) {
                ue.preventDefault();
              }
            },
            data: P
          }), o.formatOptionLabel(P, "value"));
        });
      if (_)
        return null;
      var N = R[0];
      return /* @__PURE__ */ De.createElement(f, Je({}, m, {
        data: N,
        isDisabled: C
      }), this.formatOptionLabel(N, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var o = this.getComponents(), a = o.ClearIndicator, s = this.commonProps, l = this.props, c = l.isDisabled, d = l.isLoading, f = this.state.isFocused;
      if (!this.isClearable() || !a || c || !this.hasValue() || d)
        return null;
      var h = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ De.createElement(a, Je({}, s, {
        innerProps: h,
        isFocused: f
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var o = this.getComponents(), a = o.LoadingIndicator, s = this.commonProps, l = this.props, c = l.isDisabled, d = l.isLoading, f = this.state.isFocused;
      if (!a || !d)
        return null;
      var h = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ De.createElement(a, Je({}, s, {
        innerProps: h,
        isDisabled: c,
        isFocused: f
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var o = this.getComponents(), a = o.DropdownIndicator, s = o.IndicatorSeparator;
      if (!a || !s)
        return null;
      var l = this.commonProps, c = this.props.isDisabled, d = this.state.isFocused;
      return /* @__PURE__ */ De.createElement(s, Je({}, l, {
        isDisabled: c,
        isFocused: d
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var o = this.getComponents(), a = o.DropdownIndicator;
      if (!a)
        return null;
      var s = this.commonProps, l = this.props.isDisabled, c = this.state.isFocused, d = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ De.createElement(a, Je({}, s, {
        innerProps: d,
        isDisabled: l,
        isFocused: c
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var o = this, a = this.getComponents(), s = a.Group, l = a.GroupHeading, c = a.Menu, d = a.MenuList, f = a.MenuPortal, h = a.LoadingMessage, m = a.NoOptionsMessage, g = a.Option, b = this.commonProps, C = this.state.focusedOption, y = this.props, _ = y.captureMenuScroll, x = y.inputValue, I = y.isLoading, R = y.loadingMessage, E = y.minMenuHeight, k = y.maxMenuHeight, N = y.menuIsOpen, P = y.menuPlacement, F = y.menuPosition, G = y.menuPortalTarget, j = y.menuShouldBlockScroll, ae = y.menuShouldScrollIntoView, ue = y.noOptionsMessage, le = y.onMenuScrollToTop, _e = y.onMenuScrollToBottom;
      if (!N)
        return null;
      var ve = function(X, pe) {
        var fe = X.type, de = X.data, we = X.isDisabled, Ie = X.isSelected, Pe = X.label, Se = X.value, Fe = C === de, oe = we ? void 0 : function() {
          return o.onOptionHover(de);
        }, pt = we ? void 0 : function() {
          return o.selectOption(de);
        }, Ee = "".concat(o.getElementId("option"), "-").concat(pe), wt = {
          id: Ee,
          onClick: pt,
          onMouseMove: oe,
          onMouseOver: oe,
          tabIndex: -1,
          role: "option",
          "aria-selected": o.isAppleDevice ? void 0 : Ie
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ De.createElement(g, Je({}, b, {
          innerProps: wt,
          data: de,
          isDisabled: we,
          isSelected: Ie,
          key: Ee,
          label: Pe,
          type: fe,
          value: Se,
          isFocused: Fe,
          innerRef: Fe ? o.getFocusedOptionRef : void 0
        }), o.formatOptionLabel(X.data, "menu"));
      }, z;
      if (this.hasOptions())
        z = this.getCategorizedOptions().map(function(ge) {
          if (ge.type === "group") {
            var X = ge.data, pe = ge.options, fe = ge.index, de = "".concat(o.getElementId("group"), "-").concat(fe), we = "".concat(de, "-heading");
            return /* @__PURE__ */ De.createElement(s, Je({}, b, {
              key: de,
              data: X,
              options: pe,
              Heading: l,
              headingProps: {
                id: we,
                data: ge.data
              },
              label: o.formatGroupLabel(ge.data)
            }), ge.options.map(function(Ie) {
              return ve(Ie, "".concat(fe, "-").concat(Ie.index));
            }));
          } else if (ge.type === "option")
            return ve(ge, "".concat(ge.index));
        });
      else if (I) {
        var K = R({
          inputValue: x
        });
        if (K === null)
          return null;
        z = /* @__PURE__ */ De.createElement(h, b, K);
      } else {
        var Ce = ue({
          inputValue: x
        });
        if (Ce === null)
          return null;
        z = /* @__PURE__ */ De.createElement(m, b, Ce);
      }
      var q = {
        minMenuHeight: E,
        maxMenuHeight: k,
        menuPlacement: P,
        menuPosition: F,
        menuShouldScrollIntoView: ae
      }, J = /* @__PURE__ */ De.createElement(ohe, Je({}, b, q), function(ge) {
        var X = ge.ref, pe = ge.placerProps, fe = pe.placement, de = pe.maxHeight;
        return /* @__PURE__ */ De.createElement(c, Je({}, b, q, {
          innerRef: X,
          innerProps: {
            onMouseDown: o.onMenuMouseDown,
            onMouseMove: o.onMenuMouseMove
          },
          isLoading: I,
          placement: fe
        }), /* @__PURE__ */ De.createElement(kpe, {
          captureEnabled: _,
          onTopArrive: le,
          onBottomArrive: _e,
          lockEnabled: j
        }, function(we) {
          return /* @__PURE__ */ De.createElement(d, Je({}, b, {
            innerRef: function(Pe) {
              o.getMenuListRef(Pe), we(Pe);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": b.isMulti,
              id: o.getElementId("listbox")
            },
            isLoading: I,
            maxHeight: de,
            focusedOption: C
          }), z);
        }));
      });
      return G || F === "fixed" ? /* @__PURE__ */ De.createElement(f, Je({}, b, {
        appendTo: G,
        controlElement: this.controlRef,
        menuPlacement: P,
        menuPosition: F
      }), J) : J;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var o = this, a = this.props, s = a.delimiter, l = a.isDisabled, c = a.isMulti, d = a.name, f = a.required, h = this.state.selectValue;
      if (f && !this.hasValue() && !l)
        return /* @__PURE__ */ De.createElement(Bpe, {
          name: d,
          onFocus: this.onValueInputFocus
        });
      if (!(!d || l))
        if (c)
          if (s) {
            var m = h.map(function(C) {
              return o.getOptionValue(C);
            }).join(s);
            return /* @__PURE__ */ De.createElement("input", {
              name: d,
              type: "hidden",
              value: m
            });
          } else {
            var g = h.length > 0 ? h.map(function(C, y) {
              return /* @__PURE__ */ De.createElement("input", {
                key: "i-".concat(y),
                name: d,
                type: "hidden",
                value: o.getOptionValue(C)
              });
            }) : /* @__PURE__ */ De.createElement("input", {
              name: d,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ De.createElement("div", null, g);
          }
        else {
          var b = h[0] ? this.getOptionValue(h[0]) : "";
          return /* @__PURE__ */ De.createElement("input", {
            name: d,
            type: "hidden",
            value: b
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var o = this.commonProps, a = this.state, s = a.ariaSelection, l = a.focusedOption, c = a.focusedValue, d = a.isFocused, f = a.selectValue, h = this.getFocusableOptions();
      return /* @__PURE__ */ De.createElement(Ape, Je({}, o, {
        id: this.getElementId("live-region"),
        ariaSelection: s,
        focusedOption: l,
        focusedValue: c,
        isFocused: d,
        selectValue: f,
        focusableOptions: h,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var o = this.getComponents(), a = o.Control, s = o.IndicatorsContainer, l = o.SelectContainer, c = o.ValueContainer, d = this.props, f = d.className, h = d.id, m = d.isDisabled, g = d.menuIsOpen, b = this.state.isFocused, C = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ De.createElement(l, Je({}, C, {
        className: f,
        innerProps: {
          id: h,
          onKeyDown: this.onKeyDown
        },
        isDisabled: m,
        isFocused: b
      }), this.renderLiveRegion(), /* @__PURE__ */ De.createElement(a, Je({}, C, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: m,
        isFocused: b,
        menuIsOpen: g
      }), /* @__PURE__ */ De.createElement(c, Je({}, C, {
        isDisabled: m
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ De.createElement(s, Je({}, C, {
        isDisabled: m
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(o, a) {
      var s = a.prevProps, l = a.clearFocusValueOnUpdate, c = a.inputIsHiddenAfterUpdate, d = a.ariaSelection, f = a.isFocused, h = a.prevWasFocused, m = a.instancePrefix, g = o.options, b = o.value, C = o.menuIsOpen, y = o.inputValue, _ = o.isMulti, x = fb(b), I = {};
      if (s && (b !== s.value || g !== s.options || C !== s.menuIsOpen || y !== s.inputValue)) {
        var R = C ? tme(o, x) : [], E = C ? wb(V2(o, x), "".concat(m, "-option")) : [], k = l ? nme(a, x) : null, N = rme(a, R), P = D5(E, N);
        I = {
          selectValue: x,
          focusedOption: N,
          focusedOptionId: P,
          focusableOptionsWithIds: E,
          focusedValue: k,
          clearFocusValueOnUpdate: !1
        };
      }
      var F = c != null && o !== s ? {
        inputIsHidden: c,
        inputIsHiddenAfterUpdate: void 0
      } : {}, G = d, j = f && h;
      return f && !j && (G = {
        value: p2(_, x, x[0] || null),
        options: x,
        action: "initial-input-focus"
      }, j = !h), (d == null ? void 0 : d.action) === "initial-input-focus" && (G = null), et(et(et({}, I), F), {}, {
        prevProps: o,
        ariaSelection: G,
        prevWasFocused: j
      });
    }
  }]), n;
}(dk);
wL.defaultProps = eme;
var ame = /* @__PURE__ */ nt(function(e, t) {
  var n = vfe(e);
  return /* @__PURE__ */ De.createElement(wL, Je({
    ref: t
  }, n));
}), ime = ame;
const LL = ({
  children: e,
  onMouseDown: t
}) => /* @__PURE__ */ A.jsx(
  Sl,
  {
    paddingX: "5px",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    onMouseDown: t,
    children: e
  }
), sme = ({
  innerProps: e
}) => /* @__PURE__ */ A.jsx(LL, { ...e, children: /* @__PURE__ */ A.jsx(Go, { icon: "close" }) }), lme = () => /* @__PURE__ */ A.jsx(LL, { children: /* @__PURE__ */ A.jsx(Go, { icon: "arrow-down-s" }) }), Rb = (e, { isFocused: t }) => ({
  "&:hover": {
    borderColor: e ? Fo.alertError : t ? Fo.selected2 : Fo.hover2
  },
  boxShadow: t ? e ? `inset 0 0 0 1px ${Fo.alertError}` : `inset 0 0 0 1px ${Fo.selected2}` : "none"
}), ume = (e, t, n, r) => e === "grid" ? {
  borderRadius: "0px",
  border: "1px solid transparent",
  minHeight: "25px",
  height: "100%",
  // consume all space if grid row is more than one line
  // body-2
  fontSize: "0.75rem",
  fontWeight: "400",
  backgroundColor: n ? Fo.alertWarningLight : "transparent",
  outline: "none !important",
  ...Rb(n, r)
} : {
  minHeight: {
    xs: "1.5rem",
    sm: "2rem",
    md: "2.75rem",
    lg: "3rem"
  }[t],
  height: "100%",
  borderColor: n ? Fo.alertError : Fo.strokeDefault,
  ...Rb(n, r)
}, cme = (e, t, n, r) => ({ minHeight: o, ...a }, s) => ({
  ...a,
  ...ume(e, t, n, s),
  ...r,
  alignItems: "center"
}), dme = (e, t) => e === "grid" ? { fontSize: "12px" } : { fontSize: {
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px"
}[t] }, fme = (e, t) => ({ margin: n, ...r }, o) => ({ ...r, ...dme(e, t) }), hme = (e, t, n, r) => ({ ...o }) => ({
  ...o,
  ...r
}), pme = (e, t) => e === "grid" ? { fontSize: "12px" } : { fontSize: {
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px"
}[t] }, mme = (e, t) => ({ margin: n, ...r }, o) => ({ ...r, ...pme(e, t) }), gme = (e, t) => {
  if (e === "grid")
    return { padding: ".125rem", gap: ".125rem" };
  switch (t) {
    case "xs":
      return { padding: ".125rem", gap: ".125rem", minHeight: "1.5rem" };
    case "sm":
      return { padding: ".25rem", gap: ".25rem" };
    case "md":
      return { padding: ".5rem", gap: ".375rem" };
    case "lg":
      return { padding: ".625Rem", gap: ".5rem" };
    default:
      V1e(t);
  }
}, vme = (e, t) => (n, r) => ({
  ...n,
  ...gme(e, t),
  lineHeight: "normal"
}), Cme = (e) => {
  const t = Et(
    () => e.reduce((n, r) => (n[r.value] = r, n), {}),
    [e]
  );
  return te(
    (n) => vo(n) ? null : t[n],
    []
  );
};
const i5e = nt((e, t) => {
  const {
    id: n,
    name: r,
    value: o,
    invalid: a,
    onChange: s,
    variant: l = "outline",
    size: c = "md",
    width: d = "100%",
    disabled: f,
    options: h,
    filterOption: m,
    placeholder: g,
    defaultMenuIsOpen: b,
    isClearable: C = !0
  } = e, y = Cme(h), _ = Id(n), { decorate: x } = _d({ ...e, id: _ }), I = (R) => {
    s == null || s((R == null ? void 0 : R.value) ?? "");
  };
  return x(
    /* @__PURE__ */ A.jsx(
      ime,
      {
        id: _,
        ref: t,
        name: r,
        defaultMenuIsOpen: b ?? !1,
        options: h,
        filterOption: m,
        value: y(o),
        onChange: I,
        isDisabled: f,
        placeholder: g,
        isClearable: C,
        menuShouldScrollIntoView: !1,
        components: { ClearIndicator: sme, DropdownIndicator: lme },
        styles: {
          control: cme(l, c, a, { width: d }),
          input: fme(l, c),
          menu: hme(l, c, a, { width: d }),
          multiValue: mme(l, c),
          valueContainer: vme(l, c)
        }
      }
    )
  );
});
const s5e = nt((e, t) => {
  const {
    id: n,
    name: r,
    value: o,
    onChange: a,
    onBlur: s,
    width: l = "100%",
    disabled: c,
    min: d,
    max: f,
    step: h = 1
  } = e, m = Id(n), { decorate: g } = _d({ ...e, id: m });
  return g(
    /* @__PURE__ */ A.jsxs("div", { className: "simple-range-wrapper", style: { width: l }, children: [
      /* @__PURE__ */ A.jsx("div", { className: "simple-range-selected-fill", children: /* @__PURE__ */ A.jsx(
        "input",
        {
          type: "range",
          min: d,
          max: f,
          value: o,
          step: h,
          onChange: () => null,
          disabled: c,
          tabIndex: -1
        }
      ) }),
      /* @__PURE__ */ A.jsx("div", { className: "simple-range-input", children: /* @__PURE__ */ A.jsx(
        "input",
        {
          id: m,
          ref: t,
          type: "range",
          name: r,
          min: d,
          max: f,
          value: o,
          step: h,
          onChange: a,
          onBlur: s,
          disabled: c
        }
      ) })
    ] })
  );
}), l5e = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ A.jsx(T0e, { className: to("sound-ui-table-container", t), ...n, children: e }), u5e = ({
  children: e,
  stickyFirstColumn: t,
  variant: n,
  className: r,
  ...o
}) => {
  const a = ["sound-ui-table", r];
  return t && a.push("sticky-first-column"), n === "grid" ? a.push("grid") : a.push("default"), /* @__PURE__ */ A.jsx(Di, { role: "table", className: to(a), ...o, children: e });
}, c5e = ({ children: e, ...t }) => /* @__PURE__ */ A.jsx(Di, { role: "tbody", ...t, children: e }), d5e = ({ children: e, ...t }) => /* @__PURE__ */ A.jsx(Di, { role: "thead", ...t, children: e }), f5e = ({ children: e, ...t }) => /* @__PURE__ */ A.jsx(Di, { role: "tr", ...t, children: e }), h5e = nt(
  ({ children: e, ...t }, n) => /* @__PURE__ */ A.jsx(Di, { role: "th", ref: n, ...t, children: e })
), p5e = nt(
  ({ children: e, ...t }, n) => /* @__PURE__ */ A.jsx(Di, { role: "td", ref: n, ...t, children: e })
), m5e = ({
  items: e,
  value: t,
  size: n,
  variant: r,
  disabled: o = !1,
  onChange: a
}) => /* @__PURE__ */ A.jsx("div", { className: "mode-switcher", children: e.map((s) => /* @__PURE__ */ A.jsx(
  A3,
  {
    text: s.label,
    onClick: () => a(s.id),
    disabled: t === s.id || o,
    size: n,
    variant: r,
    icon: s.icon
  },
  s.id
)) });
export {
  $me as Accordion,
  Eme as Avatar,
  Zx as Badge,
  V0e as Banner,
  k0e as BannerDescription,
  T0e as Block,
  A3 as Button,
  Yme as Card,
  jte as Checkbox,
  Nme as CheckboxGroup,
  Zte as CopyButton,
  Zme as Drawer,
  Sl as Flex,
  Bme as Grid,
  Go as Icon,
  ef as IconButton,
  Tme as InfoIcon,
  Vme as Input,
  lde as Link,
  Hme as LoadingIndicator,
  P0e as Logo,
  qme as Menu,
  Jme as MenuButton,
  Kme as MenuItem,
  Qme as MenuList,
  F0e as Modal,
  m5e as ModeSwitcher,
  Gme as OfflineBanner,
  n5e as RadioCardGroup,
  Pme as RadioGroup,
  Ume as ReactTableUI,
  Ome as Select,
  r5e as SimpleInput,
  s5e as SimpleRange,
  o5e as SimpleSelect,
  i5e as SimpleSingleCombo,
  a5e as SimpleTextArea,
  jx as SmallLoader,
  Rme as SoundUIProvider,
  Xme as SplitLayout,
  jme as Switch,
  u5e as Table,
  l5e as TableContainer,
  e5e as Tabs,
  c5e as Tbody,
  p5e as Td,
  h5e as Th,
  d5e as Thead,
  fh as Tooltip,
  f5e as Tr,
  Wo as Typography,
  Yee as appraisifyColors,
  Lme as appraisifyPDFTheme,
  Dme as buttonSizeToIconSize,
  Fo as colors,
  zme as createColumnHelper,
  Fte as getFillRule,
  T2e as getSortIcon,
  Q2e as hasMask,
  K2e as hasMinMax,
  Bte as icons,
  z1e as isCellProps,
  dde as isNumberLikeInputType,
  t5e as makePxlStr,
  Vte as theme,
  Fme as toOpts,
  kme as typographyVariants,
  Hh as useFormSizeContext,
  Wme as useModal,
  Xs as useThemeColor,
  cc as withFormWrapper
};
//# sourceMappingURL=main.mjs.map
